// Local UI copy only. Keys are stable English source messages. User content is never passed here.
// English is the per-message fallback. Additional languages can be added without a service or API key.
export const messages = {
 'Language & region': ['Idioma y región', 'Wika at rehiyon'],
 'Country of operation': ['País donde opera', 'Bansa ng operasyon'],
 'Choose a country': ['Elige un país', 'Pumili ng bansa'],
 'Search countries…': ['Buscar países…', 'Maghanap ng bansa…'],
 'No matching country.': ['No se encontró el país.', 'Walang katugmang bansa.'],
 'Language': ['Idioma', 'Wika'],
 'School language': ['Idioma de la escuela', 'Wika ng paaralan'],
 'Language updated': ['Idioma actualizado', 'Na-update ang wika'],
 'Could not save your language. Please try again.': ['No se pudo guardar el idioma. Inténtalo de nuevo.', 'Hindi na-save ang wika. Pakisubukan muli.'],
 'Choose your language': ['Elige tu idioma', 'Piliin ang iyong wika'],
 'Country and language are independent of currency.': ['El país y el idioma son independientes de la moneda.', 'Hiwalay ang bansa at wika sa pera.'],
 'Your names, messages and custom content stay unchanged.': ['Tus nombres, mensajes y contenido personalizado no cambian.', 'Hindi babaguhin ang mga pangalan, mensahe at sarili mong nilalaman.'],
 'Formatting preview': ['Vista previa del formato', 'Halimbawa ng format'],
 'Save preferences': ['Guardar preferencias', 'I-save ang mga pagpipilian'],
 'Preferences saved': ['Preferencias guardadas', 'Na-save ang mga pagpipilian'],
 'Could not load preferences.': ['No se pudieron cargar las preferencias.', 'Hindi ma-load ang mga pagpipilian.'],
 'Could not save preferences.': ['No se pudieron guardar las preferencias.', 'Hindi ma-save ang mga pagpipilian.'],
 'Currency': ['Moneda', 'Pera'],
 'Current billing currency': ['Moneda actual de facturación', 'Kasalukuyang pera sa pagsingil'],
 'Preferred currency (not active yet)': ['Moneda preferida (aún no está activa)', 'Gustong pera (hindi pa aktibo)'],
 'Saving a currency preference does not switch billing. Prices, invoices and payments stay in the current currency until the full currency review is ready.': ['Guardar una moneda preferida no cambia la facturación. Los precios, facturas y pagos mantienen la moneda actual hasta que esté lista la revisión completa.', 'Hindi mababago ang pagsingil kapag nag-save ng gustong pera. Mananatili ang kasalukuyang pera sa mga presyo, invoice at bayad hanggang handa na ang kumpletong pagsusuri.'],
 'Past payments keep their original currency. Lesson prices are never automatically converted.': ['Los pagos anteriores conservan su moneda original. Los precios de las clases nunca se convierten automáticamente.', 'Mananatili ang orihinal na pera ng mga dating bayad. Hindi awtomatikong iko-convert ang presyo ng mga aralin.'],
 'Your SplashPad subscription stays in USD.': ['Tu suscripción a SplashPad sigue en USD.', 'Mananatili sa USD ang iyong subscription sa SplashPad.'],
 'Some detailed screens are still in English while translations are being completed.': ['Algunas pantallas detalladas siguen en inglés mientras se completan las traducciones.', 'Nasa Ingles pa ang ilang detalyadong pahina habang kinukumpleto ang mga salin.'],
 'Dashboard': ['Inicio', 'Dashboard'],
 'Families & Lessons': ['Familias y clases', 'Mga pamilya at aralin'],
 'Applications': ['Solicitudes', 'Mga aplikasyon'],
 'Students': ['Alumnos', 'Mga mag-aaral'],
 'Schedule': ['Horario', 'Iskedyul'],
 'Route': ['Ruta', 'Ruta'],
 'Waivers': ['Exenciones', 'Mga waiver'],
 'Follow-ups & Progress': ['Seguimiento y progreso', 'Follow-up at pag-unlad'],
 'Broadcast': ['Mensaje colectivo', 'Anunsyo'],
 'Classes & Pricing': ['Clases y precios', 'Mga klase at presyo'],
 'Classes & Packages': ['Clases y paquetes', 'Mga klase at pakete'],
 'Discount Codes': ['Códigos de descuento', 'Mga discount code'],
 'Locations': ['Ubicaciones', 'Mga lokasyon'],
 'Grow': ['Crecer', 'Palaguin'],
 'Landing Page': ['Página pública', 'Pampublikong pahina'],
 'Marketing': ['Marketing', 'Marketing'],
 'Money': ['Finanzas', 'Pananalapi'],
 'Payments': ['Pagos', 'Mga bayad'],
 'Invoices': ['Facturas', 'Mga invoice'],
 'Bookkeeping': ['Contabilidad', 'Talaan ng pananalapi'],
 'Team Management': ['Gestión del equipo', 'Pamamahala ng team'],
 'Settings': ['Configuración', 'Mga setting'],
 'Subscription': ['Suscripción', 'Subscription'],
 'My public page': ['Mi página pública', 'Aking pampublikong pahina'],
 'Sign out': ['Cerrar sesión', 'Mag-sign out'],
 'My lessons': ['Mis clases', 'Aking mga aralin'],
 'My coach portal': ['Portal de mi instructor', 'Portal ng aking coach'],
 'Enrollments': ['Inscripciones', 'Mga pagpapatala'],
 'Progress': ['Progreso', 'Pag-unlad'],
 'My students': ['Mis alumnos', 'Aking mga mag-aaral'],
 'Policies': ['Políticas', 'Mga patakaran'],
 'Profile': ['Perfil', 'Profile'],
 'Home': ['Inicio', 'Home'],
 'Coach': ['Instructor', 'Coach'],
 'Pay': ['Pagar', 'Magbayad'],
 'Kids': ['Niños', 'Mga bata'],
 'Parent portal': ['Portal de familias', 'Portal ng magulang'],
 'Find an instructor': ['Buscar instructor', 'Maghanap ng coach'],
 'Browse the SplashPad coach map.': ['Explora el mapa de instructores de SplashPad.', 'Tingnan ang mapa ng mga coach sa SplashPad.'],
 'Business profile': ['Perfil del negocio', 'Profile ng negosyo'],
 'Public page & portal': ['Página pública y portal', 'Pampublikong pahina at portal'],
 'Scheduling & booking': ['Horarios y reservas', 'Iskedyul at booking'],
 'Policies & waivers': ['Políticas y exenciones', 'Mga patakaran at waiver'],
 'Notifications': ['Notificaciones', 'Mga abiso'],
 'Account & security': ['Cuenta y seguridad', 'Account at seguridad'],
 'Tools & team': ['Herramientas y equipo', 'Mga tool at team'],
 'Save': ['Guardar', 'I-save'],
 'Save changes': ['Guardar cambios', 'I-save ang mga pagbabago'],
 'Cancel': ['Cancelar', 'Kanselahin'],
 'Close': ['Cerrar', 'Isara'],
 'Back': ['Atrás', 'Bumalik'],
 'Continue': ['Continuar', 'Magpatuloy'],
 'Try again': ['Reintentar', 'Subukan muli'],
 'Loading…': ['Cargando…', 'Naglo-load…'],
 'Saving…': ['Guardando…', 'Sine-save…'],
 'Saved': ['Guardado', 'Na-save'],
 'Not saved': ['Sin guardar', 'Hindi na-save'],
 'Unsaved': ['Cambios sin guardar', 'Hindi pa na-save'],
 'Edit': ['Editar', 'Baguhin'],
 'Delete': ['Eliminar', 'Tanggalin'],
 'View': ['Ver', 'Tingnan'],
 'Search': ['Buscar', 'Maghanap'],
 'Next': ['Siguiente', 'Susunod'],
 'Previous': ['Anterior', 'Nakaraan'],
 'Email': ['Correo electrónico', 'Email'],
 'Phone': ['Teléfono', 'Telepono'],
 'Name': ['Nombre', 'Pangalan'],
 'Status': ['Estado', 'Katayuan'],
 'Date': ['Fecha', 'Petsa'],
 'Amount': ['Importe', 'Halaga'],
 'Total': ['Total', 'Kabuuan'],
 'Paid': ['Pagado', 'Bayad na'],
 'Pending': ['Pendiente', 'Nakabinbin'],
 'Cancelled': ['Cancelado', 'Kinansela'],
 'Active': ['Activo', 'Aktibo'],
 'Completed': ['Completado', 'Tapos na'],
 'Upcoming': ['Próximas', 'Paparating'],
 'Past': ['Anteriores', 'Nakaraan'],
 'Details': ['Detalles', 'Mga detalye'],
 'View details': ['Ver detalles', 'Tingnan ang mga detalye'],
 'Book lessons': ['Reservar clases', 'Mag-book ng mga aralin'],
 'Book a lesson': ['Reservar una clase', 'Mag-book ng aralin'],
 'Book now': ['Reservar ahora', 'Mag-book ngayon'],
 'Register': ['Registrarse', 'Magparehistro'],
 'Sign in': ['Iniciar sesión', 'Mag-sign in'],
 'Contact coach': ['Contactar al instructor', 'Kontakin ang coach'],
 'Contact Coach': ['Contactar al instructor', 'Kontakin ang coach'],
 'About': ['Acerca de', 'Tungkol'],
 'Programs': ['Programas', 'Mga programa'],
 'Contact': ['Contacto', 'Kontak'],
 'Book a Class': ['Reservar una clase', 'Mag-book ng klase'],
 'View classes': ['Ver clases', 'Tingnan ang mga klase'],
 'Choose a class': ['Elige una clase', 'Pumili ng klase'],
 'Choose a package': ['Elige un paquete', 'Pumili ng pakete'],
 'Pay now': ['Pagar ahora', 'Magbayad ngayon'],
 'Payment history': ['Historial de pagos', 'Kasaysayan ng mga bayad'],
 'Payment details': ['Detalles del pago', 'Mga detalye ng bayad'],
 'View receipt': ['Ver recibo', 'Tingnan ang resibo'],
 'No payments yet': ['Aún no hay pagos', 'Wala pang bayad'],
 'No invoices yet': ['Aún no hay facturas', 'Wala pang invoice'],
 'Your business. Your way.': ['Tu negocio. A tu manera.', 'Negosyo mo. Paraan mo.'],
 'Tell us how you teach. We’ll put together a starting setup you can review and change.': ['Cuéntanos cómo enseñas. Prepararemos una configuración inicial que podrás revisar y cambiar.', 'Sabihin kung paano ka nagtuturo. Gagawa kami ng panimulang setup na maaari mong suriin at baguhin.'],
 'Where are you based, and what language should SplashPad use?': ['¿Dónde trabajas y qué idioma debe usar SplashPad?', 'Saan ka nagtuturo, at anong wika ang gagamitin ng SplashPad?'],
 'Choose your country and language. You can change them later in Settings.': ['Elige tu país e idioma. Puedes cambiarlos luego en Configuración.', 'Piliin ang iyong bansa at wika. Maaari mong baguhin ang mga ito sa Mga setting.'],
 'Which currency would you like to use?': ['¿Qué moneda te gustaría usar?', 'Anong pera ang gusto mong gamitin?'],
 'We’ll save your preference. Billing stays in the current currency until a safe price review is available.': ['Guardaremos tu preferencia. La facturación mantiene la moneda actual hasta que haya una revisión segura de precios.', 'Ise-save namin ang iyong pagpipilian. Mananatili ang kasalukuyang pera sa pagsingil hanggang may ligtas na pagsusuri ng presyo.'],
 'Where are you starting from?': ['¿Desde dónde empiezas?', 'Saan ka magsisimula?'],
 'Tap an answer to continue. You can go Back to change it.': ['Toca una respuesta para continuar. Puedes volver atrás para cambiarla.', 'Pindutin ang sagot para magpatuloy. Maaari kang bumalik para baguhin ito.'],
 'What do you call your swim business?': ['¿Cómo se llama tu escuela de natación?', 'Ano ang pangalan ng iyong negosyo sa paglangoy?'],
 'Use the name your families know. You can change it later.': ['Usa el nombre que conocen tus familias. Puedes cambiarlo después.', 'Gamitin ang pangalang kilala ng mga pamilya. Maaari mo itong baguhin sa susunod.'],
 'Which timezone do you teach in?': ['¿En qué zona horaria enseñas?', 'Sa anong time zone ka nagtuturo?'],
 'Your lesson times will use this timezone, even if a family lives somewhere else.': ['Las clases usarán esta zona horaria, aunque una familia viva en otro lugar.', 'Gagamitin ng iyong mga aralin ang time zone na ito, kahit nasa ibang lugar ang pamilya.'],
 'What do you teach?': ['¿Qué enseñas?', 'Ano ang itinuturo mo?'],
 'Choose everything you offer. A mix is absolutely fine.': ['Elige todo lo que ofreces. Puedes combinar opciones.', 'Piliin ang lahat ng iyong inaalok. Puwedeng pagsamahin ang mga ito.'],
 'Where do your lessons happen?': ['¿Dónde das tus clases?', 'Saan ginaganap ang iyong mga aralin?'],
 'At your regular pools, at families’ pools, or a bit of both?': ['¿En tus piscinas habituales, en las de las familias o en ambas?', 'Sa regular mong pool, sa pool ng mga pamilya, o pareho?'],
 'How many regular locations do you teach at?': ['¿En cuántas ubicaciones habituales enseñas?', 'Sa ilang regular na lokasyon ka nagtuturo?'],
 'Does this look like your business?': ['¿Esto refleja tu negocio?', 'Ganito ba ang iyong negosyo?'],
 'These are starting drafts, not live offers. Review them before we create anything.': ['Son borradores iniciales, no ofertas publicadas. Revísalos antes de crearlos.', 'Mga panimulang draft lamang ito, hindi aktibong alok. Suriin muna bago kami gumawa ng anuman.'],
 'Keep SplashPad close by.': ['Ten SplashPad a mano.', 'Gawing madaling buksan ang SplashPad.'],
 'Add it to your phone or computer like an app—same account, no app store needed.': ['Añádelo a tu teléfono u ordenador como una app: la misma cuenta, sin tienda de aplicaciones.', 'Idagdag ito sa telepono o computer bilang app—parehong account, hindi kailangan ng app store.'],
 'Have you tried Splash yet?': ['¿Ya probaste Splash?', 'Nasubukan mo na ba ang Splash?'],
 'Your swim-business assistant for account questions, lesson setup, and ideas to grow.': ['Tu asistente para preguntas de cuenta, configuración de clases e ideas para crecer.', 'Ang katulong mo para sa tanong sa account, setup ng aralin, at paglago ng negosyo.'],
 'You have a starting point.': ['Ya tienes un punto de partida.', 'May panimula ka na.'],
 'Your drafts are saved. You decide what goes live and when.': ['Tus borradores están guardados. Tú decides qué publicar y cuándo.', 'Na-save na ang iyong mga draft. Ikaw ang magpapasya kung ano at kailan ia-activate.'],
 'Your existing setup is safe and under your control.': ['Tu configuración actual está a salvo y bajo tu control.', 'Ligtas ang iyong kasalukuyang setup at ikaw ang may kontrol.'],
 'I’m Splash.': ['Soy Splash.', 'Ako si Splash.'],
 'Let’s build a setup around the way you teach.': ['Creemos una configuración adaptada a tu forma de enseñar.', 'Gumawa tayo ng setup na akma sa paraan mo ng pagtuturo.'],
 'One step at a time': ['Un paso a la vez', 'Isang hakbang bawat pagkakataon'],
 'Clear questions. No software jargon.': ['Preguntas claras. Sin tecnicismos.', 'Malinaw na tanong. Walang teknikal na salita.'],
 'Nothing goes live': ['Nada se publica', 'Walang ia-activate'],
 'Review every draft before you publish.': ['Revisa cada borrador antes de publicarlo.', 'Suriin ang bawat draft bago i-publish.'],
 'Pick up later': ['Continúa después', 'Ituloy sa susunod'],
 'Progress saves as you go.': ['Tu progreso se guarda mientras avanzas.', 'Nase-save ang iyong progreso habang nagpapatuloy.'],
 'I’m starting my business': ['Estoy iniciando mi negocio', 'Sinisimulan ko ang aking negosyo'],
 'Let’s build a simple starting setup': ['Creemos una configuración inicial sencilla', 'Gumawa tayo ng simpleng panimulang setup'],
 'I’m already teaching': ['Ya estoy enseñando', 'Nagtuturo na ako'],
 'Make SplashPad fit the way you work': ['Adapta SplashPad a tu forma de trabajar', 'Iangkop ang SplashPad sa paraan mo ng pagtatrabaho'],
 'I’m still figuring it out': ['Aún lo estoy pensando', 'Pinag-iisipan ko pa'],
 'That’s okay. You can start with drafts': ['No pasa nada. Puedes empezar con borradores', 'Ayos lang. Maaari kang magsimula sa mga draft'],
 'Business name': ['Nombre del negocio', 'Pangalan ng negosyo'],
 'Schedule timezone': ['Zona horaria del horario', 'Time zone ng iskedyul'],
 'Private lessons': ['Clases particulares', 'Pribadong aralin'],
 'Semi-private lessons': ['Clases semiprivadas', 'Semi-private na aralin'],
 'Group lessons': ['Clases en grupo', 'Pangkatang aralin'],
 'Swim team': ['Equipo de natación', 'Koponan sa paglangoy'],
 'Swim camps': ['Campamentos de natación', 'Mga swim camp'],
 'One swimmer at a time': ['Un nadador a la vez', 'Isang manlalangoy bawat pagkakataon'],
 'Two or a few swimmers together': ['Dos o pocos nadadores juntos', 'Dalawa o ilang manlalangoy nang sabay'],
 'A group learning together': ['Un grupo que aprende junto', 'Isang grupong sabay na natututo'],
 'Regular team practices or coaching': ['Entrenamientos regulares del equipo', 'Regular na pagsasanay ng koponan'],
 'A program over a set number of days': ['Un programa durante varios días', 'Programa sa takdang bilang ng araw'],
 'One lesson at a time': ['Una clase a la vez', 'Isang aralin bawat pagkakataon'],
 'Families pay for each individual lesson': ['Las familias pagan cada clase por separado', 'Nagbabayad ang pamilya para sa bawat aralin'],
 'A bundle of lessons': ['Un paquete de clases', 'Pakete ng mga aralin'],
 'For example, 4 lessons paid for together': ['Por ejemplo, 4 clases pagadas juntas', 'Halimbawa, 4 na araling sabay na babayaran'],
 'A monthly membership': ['Una membresía mensual', 'Buwanang membership'],
 'Families are billed each month': ['Se factura a las familias cada mes', 'Sinisingil ang mga pamilya bawat buwan'],
 'At my regular locations': ['En mis ubicaciones habituales', 'Sa regular kong mga lokasyon'],
 'One pool or several venues': ['Una piscina o varios lugares', 'Isang pool o ilang lugar'],
 'I travel to families’ pools': ['Voy a las piscinas de las familias', 'Pumupunta ako sa pool ng mga pamilya'],
 'Lessons at their homes or chosen pools': ['Clases en sus casas o piscinas elegidas', 'Aralin sa kanilang bahay o piniling pool'],
 'Both': ['Ambas', 'Pareho'],
 'Regular locations and traveling lessons': ['Ubicaciones habituales y clases a domicilio', 'Regular na lokasyon at pagpunta sa mga pamilya'],
 'Regular locations': ['Ubicaciones habituales', 'Mga regular na lokasyon'],
 'Location name': ['Nombre de la ubicación', 'Pangalan ng lokasyon'],
 'Address': ['Dirección', 'Tirahan'],
 '(optional for now)': ['(opcional por ahora)', '(opsyonal muna)'],
 'Usual session length': ['Duración habitual de la sesión', 'Karaniwang haba ng sesyon'],
 'minutes': ['minutos', 'minuto'],
 'lessons': ['clases', 'aralin'],
 'days': ['días', 'araw'],
 'swimmers': ['nadadores', 'manlalangoy'],
 'Swimmers together': ['Nadadores juntos', 'Sabay-sabay na manlalangoy'],
 'Teaching days per camp': ['Días de enseñanza por campamento', 'Araw ng pagtuturo bawat camp'],
 'Lessons per bundle': ['Clases por paquete', 'Aralin bawat pakete'],
 'Total price in US dollars': ['Precio total en dólares estadounidenses', 'Kabuuang presyo sa US dollars'],
 'I’ll decide the price later': ['Decidiré el precio después', 'Pagpapasyahan ko ang presyo sa susunod'],
 'The same time each week': ['A la misma hora cada semana', 'Parehong oras bawat linggo'],
 'A regular lesson or practice time': ['Un horario habitual de clase o práctica', 'Regular na oras ng aralin o pagsasanay'],
 'I arrange times with families': ['Acuerdo los horarios con las familias', 'Inaayos ko ang oras kasama ang mga pamilya'],
 'I add their lessons to the schedule': ['Añado sus clases al horario', 'Idinadagdag ko ang kanilang aralin sa iskedyul'],
 'Families choose available times': ['Las familias eligen horarios disponibles', 'Pamilya ang pipili ng bakanteng oras'],
 'They pick from openings I provide': ['Eligen entre los horarios que ofrezco', 'Pumipili sila sa mga oras na iniaalok ko'],
 'I’ll decide this later': ['Lo decidiré después', 'Pagpapasyahan ko ito sa susunod'],
 'Keep this part as a draft': ['Mantener esta parte como borrador', 'Panatilihin muna itong draft'],
 'Save & exit': ['Guardar y salir', 'I-save at lumabas'],
 'Your business setup guide': ['Guía de configuración de tu negocio', 'Gabay sa setup ng iyong negosyo'],
 'Continue anyway': ['Continuar de todos modos', 'Magpatuloy pa rin'],
 'Let’s get started': ['Empecemos', 'Magsimula tayo'],
 'Keep my existing setup': ['Mantener mi configuración actual', 'Panatilihin ang kasalukuyang setup'],
 'Go to my dashboard': ['Ir a mi panel', 'Pumunta sa aking dashboard'],
 'Saving your drafts…': ['Guardando tus borradores…', 'Sine-save ang iyong mga draft…'],
 'No live bookings or charges are created by this guide.': ['Esta guía no crea reservas ni cobros activos.', 'Walang aktibong booking o singil na gagawin ng gabay na ito.'],
 'About you': ['Sobre ti', 'Tungkol sa iyo'],
 'Your lessons': ['Tus clases', 'Iyong mga aralin'],
 'Your locations': ['Tus ubicaciones', 'Iyong mga lokasyon'],
 'Prices & times': ['Precios y horarios', 'Mga presyo at oras'],
 'Review drafts': ['Revisar borradores', 'Suriin ang mga draft'],
 'Get comfortable': ['Familiarízate', 'Maging pamilyar'],
 'Welcome back': ['Bienvenido de nuevo', 'Maligayang pagbabalik'],
 'Share your registration link with families to start enrolling.': ['Comparte tu enlace de inscripción con las familias para empezar.', 'Ibahagi ang iyong registration link sa mga pamilya para makapagsimula.'],
 'Recent registrations': ['Inscripciones recientes', 'Mga bagong pagpapatala'],
 'See all': ['Ver todos', 'Tingnan lahat'],
 'Direct link': ['Enlace directo', 'Direktang link'],
 'Website button': ['Botón para tu web', 'Button sa website'],
 'Embed iframe': ['Insertar iframe', 'I-embed ang iframe'],
 'Copy': ['Copiar', 'Kopyahin'],
 'Copy snippet': ['Copiar código', 'Kopyahin ang code'],
 'Registered families': ['Familias registradas', 'Mga nakarehistrong pamilya'],
 'Active students': ['Alumnos activos', 'Mga aktibong mag-aaral'],
 'Upcoming lessons': ['Próximas clases', 'Paparating na mga aralin'],
 'Total collected': ['Total cobrado', 'Kabuuang nakolekta'],
 'Total Collected': ['Total cobrado', 'Kabuuang nakolekta'],
 'My Lessons': ['Mis clases', 'Aking mga aralin'],
 'My Students': ['Mis alumnos', 'Aking mga mag-aaral'],
 'My Payments': ['Mis pagos', 'Aking mga bayad'],
 'My Profile': ['Mi perfil', 'Aking profile'],
 'My Schedule': ['Mi horario', 'Aking iskedyul'],
 'No upcoming lessons': ['No hay próximas clases', 'Walang paparating na aralin'],
 'No upcoming lessons yet': ['Aún no hay próximas clases', 'Wala pang paparating na aralin'],
 'Book more lessons': ['Reservar más clases', 'Mag-book ng karagdagang aralin'],
 'View schedule': ['Ver horario', 'Tingnan ang iskedyul'],
 'Add student': ['Añadir alumno', 'Magdagdag ng mag-aaral'],
 'Add a student': ['Añadir un alumno', 'Magdagdag ng mag-aaral'],
 'First name': ['Nombre', 'Pangalan'],
 'Last name': ['Apellido', 'Apelyido'],
 'Date of birth': ['Fecha de nacimiento', 'Petsa ng kapanganakan'],
 'Payment method': ['Método de pago', 'Paraan ng pagbabayad'],
 'New invoice': ['Nueva factura', 'Bagong invoice'],
 'Outstanding': ['Pendiente', 'Hindi pa nababayaran'],
 'All': ['Todos', 'Lahat'],
 'Today': ['Hoy', 'Ngayon'],
 'Actions': ['Acciones', 'Mga aksyon'],
 'Notes': ['Notas', 'Mga tala'],
 'Optional': ['Opcional', 'Opsyonal'],
 'More actions': ['Más acciones', 'Iba pang aksyon'],
};
// R40: explicit system copy; user-entered content is not translated.
Object.assign(messages, {
 "Could not open Stripe. Try Settings → Payments.": [
  "No se pudo abrir Stripe. Ve a Configuración → Pagos.",
  "Hindi mabuksan ang Stripe. Pumunta sa Mga setting → Mga bayad."
 ],
 "Stripe is holding your payouts": [
  "Stripe está reteniendo tus pagos",
  "Pinipigil ng Stripe ang iyong mga payout"
 ],
 "Opening Stripe…": [
  "Abriendo Stripe…",
  "Binubuksan ang Stripe…"
 ],
 "Fix in Stripe": [
  "Resolver en Stripe",
  "Ayusin sa Stripe"
 ],
 "Your trial is running — set up payment": [
  "Tu prueba está activa: configura el pago",
  "Aktibo ang trial mo — i-set up ang bayad"
 ],
 "Set up payment": [
  "Configurar pago",
  "I-set up ang bayad"
 ],
 "Copy registration link": [
  "Copiar enlace de inscripción",
  "Kopyahin ang registration link"
 ],
 "Copied!": [
  "¡Copiado!",
  "Nakopya na!"
 ],
 "Open registration page": [
  "Abrir página de inscripción",
  "Buksan ang pahina ng pagpapatala"
 ],
 "Embed on your website": [
  "Insertar en tu web",
  "I-embed sa iyong website"
 ],
 "Drop a button on your website or embed the whole flow. Parents register, sign waivers, and pay through this link.": [
  "Añade un botón o el formulario completo a tu web. Las familias se inscriben, firman y pagan mediante este enlace.",
  "Maglagay ng button o buong form sa iyong website. Dito magpaparehistro, pipirma ng waiver, at magbabayad ang mga magulang."
 ],
 "Open link": [
  "Abrir enlace",
  "Buksan ang link"
 ],
 "Paste this into Wix / Squarespace / WordPress / your custom site.": [
  "Pégalo en Wix, Squarespace, WordPress o tu propia web.",
  "I-paste ito sa Wix, Squarespace, WordPress o sariling website."
 ],
 "Snippet copied!": [
  "¡Código copiado!",
  "Nakopya na ang code!"
 ],
 "Embeds the registration flow inline on your site.": [
  "Inserta el registro directamente en tu web.",
  "I-embed ang pagpapatala mismo sa iyong website."
 ],
 "Starter limit reached —": [
  "Límite de Starter alcanzado —",
  "Naabot ang limitasyon ng Starter —"
 ],
 "upgrade to Pro": [
  "cambiar a Pro",
  "lumipat sa Pro"
 ],
 "for unlimited students": [
  "para alumnos ilimitados",
  "para sa walang limitasyong mag-aaral"
 ],
 "seat": [
  "plaza",
  "puwesto"
 ],
 "left on Starter ·": [
  "disponibles en Starter ·",
  "ang natitira sa Starter ·"
 ],
 "go Pro": [
  "pasar a Pro",
  "lumipat sa Pro"
 ],
 "Starter plan includes up to": [
  "El plan Starter incluye hasta",
  "Kasama sa Starter plan ang hanggang"
 ],
 "active students": [
  "alumnos activos",
  "aktibong mag-aaral"
 ],
 "No registrations yet. Share your link to get started!": [
  "Aún no hay inscripciones. ¡Comparte tu enlace para empezar!",
  "Wala pang pagpapatala. Ibahagi ang link mo para makapagsimula!"
 ],
 "Get a beautiful landing page that sells lessons for you": [
  "Consigue una página atractiva que venda tus clases",
  "Magkaroon ng magandang pahinang makatutulong magbenta ng mga aralin"
 ],
 "Upgrade to Pro": [
  "Cambiar a Pro",
  "Lumipat sa Pro"
 ],
 "Settings sections": [
  "Secciones de configuración",
  "Mga seksyon ng setting"
 ],
 "On this page": [
  "En esta página",
  "Sa pahinang ito"
 ],
 "Failed": [
  "Error",
  "Nabigo"
 ],
 "Logo updated — your app icon will follow": [
  "Logo actualizado; el icono de tu app se actualizará también",
  "Na-update ang logo — susunod ang icon ng app"
 ],
 "Profile updated": [
  "Perfil actualizado",
  "Na-update ang profile"
 ],
 "Payment instructions saved": [
  "Instrucciones de pago guardadas",
  "Na-save ang mga tagubilin sa pagbabayad"
 ],
 "That doesn't look like a valid email address.": [
  "Introduce un correo electrónico válido.",
  "Maglagay ng wastong email address."
 ],
 "Enter your current password to confirm.": [
  "Introduce tu contraseña actual para confirmar.",
  "Ilagay ang kasalukuyang password para kumpirmahin."
 ],
 "That's already your email — nothing to change.": [
  "Ese ya es tu correo; no hay cambios.",
  "Iyan na ang iyong email — walang babaguhin."
 ],
 "Members-only portal updated": [
  "Portal privado actualizado",
  "Na-update ang pribadong portal"
 ],
 "Social links updated": [
  "Enlaces sociales actualizados",
  "Na-update ang mga social link"
 ],
 "Waiver saved": [
  "Exención guardada",
  "Na-save ang waiver"
 ],
 "Season-pause note saved": [
  "Nota de pausa guardada",
  "Na-save ang tala sa pahinga ng season"
 ],
 "Update what parents see on your registration page.": [
  "Actualiza lo que ven las familias en tu página de registro.",
  "I-update ang nakikita ng mga magulang sa iyong registration page."
 ],
 "Profile photo": [
  "Foto de perfil",
  "Larawan sa profile"
 ],
 "Logo": [
  "Logo",
  "Logo"
 ],
 "Your logo is also the icon of your installed SplashPad app and the parent portal.": [
  "Tu logo también es el icono de tu app SplashPad instalada y del portal de familias.",
  "Ang logo mo rin ang icon ng naka-install mong SplashPad app at portal ng magulang."
 ],
 "New logo:": [
  "Nuevo logo:",
  "Bagong logo:"
 ],
 "Square images (at least 512×512) look best on a home screen.": [
  "Las imágenes cuadradas (mínimo 512×512) se ven mejor en la pantalla de inicio.",
  "Mas maganda sa home screen ang parisukat na larawan (hindi bababa sa 512×512)."
 ],
 "Display / business name": [
  "Nombre público / del negocio",
  "Pangalan sa publiko / ng negosyo"
 ],
 "Bio": [
  "Biografía",
  "Tungkol sa iyo"
 ],
 "Brand color": [
  "Color de marca",
  "Kulay ng brand"
 ],
 "Used on your public page, your parents' portal,": [
  "Se usa en tu página pública, el portal de familias,",
  "Ginagamit sa pampublikong pahina, portal ng magulang,"
 ],
 "and this dashboard": [
  "y este panel",
  "at dashboard na ito"
 ],
 "— buttons, highlights and active tabs all switch to this color the moment you save. Your logo above becomes the icon in the sidebar, browser tab and installed app.": [
  "— los botones y pestañas activas cambian al guardar. Tu logo será el icono del menú, navegador y app instalada.",
  "— magbabago ang kulay ng mga button at aktibong tab kapag nag-save. Ang logo mo ang magiging icon ng sidebar, browser tab at naka-install na app."
 ],
 "Your timezone": [
  "Tu zona horaria",
  "Iyong time zone"
 ],
 "— Pick your timezone —": [
  "— Elige tu zona horaria —",
  "— Piliin ang iyong time zone —"
 ],
 "Use browser tz (": [
  "Usar zona del navegador (",
  "Gamitin ang time zone ng browser ("
 ],
 "Controls the times shown on your Schedule and the default timezone for new class slots. Existing slots keep their own timezone — you can update them on each package.": [
  "Controla el horario mostrado y la zona predeterminada para clases nuevas. Las clases existentes conservan su zona; puedes cambiarla en cada paquete.",
  "Ito ang time zone ng iskedyul at mga bagong klase. Mananatili ang time zone ng kasalukuyang mga klase — maaari itong baguhin sa bawat pakete."
 ],
 "Save profile": [
  "Guardar perfil",
  "I-save ang profile"
 ],
 "Business address": [
  "Dirección del negocio",
  "Address ng negosyo"
 ],
 "Where your pin lands on the public SplashPad coach map.": [
  "Dónde aparece tu marcador en el mapa público de instructores.",
  "Lokasyon ng iyong pin sa pampublikong mapa ng mga coach."
 ],
 "Updating this moves your map pin (auto-refreshes within a few seconds). Only your city is ever shown publicly. Leave blank to hide yourself from the map entirely.": [
  "Actualizar mueve tu marcador en unos segundos. Solo se muestra la ciudad. Déjalo vacío para ocultarte del mapa.",
  "Kapag binago, lilipat ang iyong pin sa loob ng ilang segundo. Lungsod lang ang ipinapakita sa publiko. Iwanang blangko para hindi lumabas sa mapa."
 ],
 "Save business address": [
  "Guardar dirección",
  "I-save ang address"
 ],
 "Social media links": [
  "Enlaces de redes sociales",
  "Mga link ng social media"
 ],
 "Only the platforms you fill in appear as icon buttons on your public page and in your parents' portal. Leave a field blank to hide that icon.": [
  "Solo aparecen las redes que completes en tu página y portal. Deja un campo vacío para ocultar su icono.",
  "Ang mga platform na nilagyan mo lang ang lalabas sa iyong pahina at portal. Iwanang blangko para itago ang icon."
 ],
 "Preview": [
  "Vista previa",
  "Preview"
 ],
 "No social icons yet — add at least one link above to preview.": [
  "Aún no hay iconos; añade un enlace para verlos.",
  "Wala pang social icon — magdagdag ng link sa itaas para makita ang preview."
 ],
 "Save social links": [
  "Guardar enlaces",
  "I-save ang mga link"
 ],
 "Page status": [
  "Estado de la página",
  "Katayuan ng pahina"
 ],
 "Pause registrations temporarily without deleting your page.": [
  "Pausa las inscripciones sin borrar tu página.",
  "Pansamantalang ihinto ang pagpapatala nang hindi binubura ang pahina."
 ],
 "Live": [
  "Publicada",
  "Aktibo"
 ],
 "Paused": [
  "En pausa",
  "Naka-pause"
 ],
 "What's shown on your public page": [
  "Contenido de tu página pública",
  "Ipinapakita sa iyong pampublikong pahina"
 ],
 "Season-pause note": [
  "Nota de pausa de temporada",
  "Tala sa pahinga ng season"
 ],
 "When you put your account on": [
  "Cuando pones tu cuenta en",
  "Kapag inilagay ang iyong account sa"
 ],
 "Seasonal Hold": [
  "Pausa de temporada",
  "Pahinga ng season"
 ],
 ", parents who visit your public page see this note instead of the registration form. Tell them when registration reopens or how to reach you.": [
  ", las familias ven esta nota en lugar del registro. Indica cuándo reabres o cómo contactarte.",
  ", makikita ng mga magulang ang talang ito sa halip na registration form. Sabihin kung kailan muling magbubukas o paano ka makokontak."
 ],
 "/ 500 characters": [
  "/ 500 caracteres",
  "/ 500 character"
 ],
 "Save season note": [
  "Guardar nota",
  "I-save ang tala"
 ],
 "Members-only coach portal": [
  "Portal privado del instructor",
  "Pribadong portal ng coach"
 ],
 "What approved parents see on their": [
  "Lo que ven las familias aprobadas en su",
  "Ang nakikita ng mga aprubadong magulang sa kanilang"
 ],
 "page. Hidden from the public.": [
  "página. Oculto al público.",
  "pahina. Hindi nakikita ng publiko."
 ],
 "Welcome message": [
  "Mensaje de bienvenida",
  "Mensahe ng pagbati"
 ],
 "Welcome to my coaching family! Here's how to book lessons, what to bring, and a few tips before your first class...": [
  "¡Bienvenidos! Aquí encontrarán cómo reservar, qué traer y consejos para su primera clase…",
  "Maligayang pagdating! Narito kung paano mag-book, ano ang dadalhin at mga payo bago ang unang klase…"
 ],
 "YouTube welcome video URL": [
  "URL del video de bienvenida en YouTube",
  "URL ng welcome video sa YouTube"
 ],
 "(optional)": [
  "(opcional)",
  "(opsyonal)"
 ],
 "Paste any YouTube link (watch, shorts, embed, or youtu.be). It'll auto-embed.": [
  "Pega cualquier enlace de YouTube; el video se insertará automáticamente.",
  "Mag-paste ng YouTube link. Awtomatikong lalabas ang video."
 ],
 "Resources / attachments": [
  "Recursos / archivos adjuntos",
  "Mga sanggunian / attachment"
 ],
 "Add links to PDFs, schedules, handbooks, or shared docs. Each row: a label and a URL.": [
  "Añade enlaces a PDF, horarios, manuales o documentos. Cada fila lleva un nombre y una URL.",
  "Magdagdag ng link sa PDF, iskedyul, handbook o dokumento. Bawat hilera ay may label at URL."
 ],
 "Label (e.g. Family handbook)": [
  "Nombre (p. ej., manual para familias)",
  "Label (hal. Handbook ng pamilya)"
 ],
 "Remove": [
  "Quitar",
  "Alisin"
 ],
 "+ Add resource": [
  "+ Añadir recurso",
  "+ Magdagdag ng sanggunian"
 ],
 "Save members-only portal": [
  "Guardar portal privado",
  "I-save ang pribadong portal"
 ],
 "How families apply": [
  "Cómo solicitan plaza las familias",
  "Paano nag-aaplay ang mga pamilya"
 ],
 "Each": [
  "Cada",
  "Bawat"
 ],
 "class time": [
  "horario de clase",
  "oras ng klase"
 ],
 "also has its own signup setting (instant vs. request).": [
  "también tiene su propio modo de inscripción (instantáneo o solicitud).",
  "ay may sariling paraan ng pagpapatala (agad o may kahilingan)."
 ],
 "Manage class time signup →": [
  "Gestionar inscripciones por horario →",
  "Pamahalaan ang pagpapatala sa oras ng klase →"
 ],
 "Card payments in the portal": [
  "Pagos con tarjeta en el portal",
  "Mga bayad gamit ang card sa portal"
 ],
 "Pay another way (Venmo, Zelle, cash)": [
  "Otra forma de pago (Venmo, Zelle, efectivo)",
  "Ibang paraan ng pagbabayad (Venmo, Zelle, cash)"
 ],
 "Let families skip the card form and pay you directly. Their registration fee, package, or lesson stays": [
  "Permite pagar directamente sin tarjeta. La cuota, el paquete o la clase queda",
  "Payagang direktang magbayad nang walang card. Ang registration fee, pakete o aralin ay mananatiling"
 ],
 "pending": [
  "pendiente",
  "nakabinbin"
 ],
 "until you tap \"Mark as paid\", so nothing is confirmed before the money arrives. Never offered on classes.": [
  "hasta que marques «Pagado». No se confirma nada hasta recibir el dinero. No se ofrece para clases.",
  "hanggang markahan mong bayad na. Walang makukumpirma hangga't hindi natatanggap ang pera. Hindi ito iniaalok sa mga klase."
 ],
 "Payment instructions shown to parents": [
  "Instrucciones de pago para familias",
  "Mga tagubilin sa pagbabayad para sa magulang"
 ],
 "Parents see this the moment they pick \"Pay another way\" — include your handle, phone, or where to hand you cash. Offline payments skip Stripe, so there's no automatic receipt — you confirm each one manually.": [
  "Se muestran al elegir «Otra forma de pago». Incluye tu usuario, teléfono o dónde entregar el efectivo. No hay recibo automático: confirma cada pago manualmente.",
  "Makikita ito kapag pinili ang ibang paraan ng pagbabayad. Ilagay ang account, telepono o kung saan iaabot ang cash. Walang awtomatikong resibo — mano-manong kumpirmahin ang bawat bayad."
 ],
 "Save instructions": [
  "Guardar instrucciones",
  "I-save ang mga tagubilin"
 ],
 "Who picks lesson times, the booking-page note, lesson reminder emails, your available hours and closed dates now live on the": [
  "Las opciones de horarios, notas de reserva, recordatorios, disponibilidad y fechas cerradas están en",
  "Ang mga setting ng oras, tala sa booking, paalala, bakanteng oras at saradong petsa ay nasa"
 ],
 "page — tap": [
  "página; pulsa",
  "pahina — pindutin ang"
 ],
 "there.": [
  "allí.",
  "doon."
 ],
 "Open Schedule settings": [
  "Abrir ajustes de horario",
  "Buksan ang mga setting ng iskedyul"
 ],
 "Sync to Apple / Google / Outlook Calendar": [
  "Sincronizar con Apple / Google / Outlook Calendar",
  "I-sync sa Apple / Google / Outlook Calendar"
 ],
 "One tap adds a private SplashPad calendar to your phone or computer. Booked lessons and class times stay up to date automatically.": [
  "Añade un calendario privado de SplashPad a tu dispositivo. Las clases y reservas se actualizan automáticamente.",
  "Idagdag ang pribadong SplashPad calendar sa iyong device. Awtomatikong naa-update ang mga booking at klase."
 ],
 "Set up calendar sync": [
  "Configurar sincronización",
  "I-set up ang calendar sync"
 ],
 "Waiver template": [
  "Plantilla de exención",
  "Template ng waiver"
 ],
 "Edit the liability waiver.": [
  "Edita la exención de responsabilidad.",
  "Baguhin ang liability waiver."
 ],
 "Past signed waivers are locked": [
  "Las exenciones firmadas están bloqueadas",
  "Naka-lock ang mga pinirmahang waiver"
 ],
 "with the original text.": [
  "con el texto original.",
  "gamit ang orihinal na teksto."
 ],
 "The default below is a standard swim-lesson waiver that names": [
  "La plantilla es una exención de natación que menciona a",
  "Ang default ay karaniwang waiver para sa aralin sa paglangoy na binabanggit ang"
 ],
 "your": [
  "tu",
  "iyong"
 ],
 "business and releases you and your staff. It's a solid starting point, not legal advice — we recommend having your own attorney look it over.": [
  "negocio y exime a ti y a tu personal. Es un punto de partida, no asesoría legal; recomendamos la revisión de un abogado.",
  "negosyo at nagpapalaya sa iyo at staff sa pananagutan. Panimula lang ito, hindi legal na payo — ipasuri ito sa iyong abogado."
 ],
 "Save waiver": [
  "Guardar exención",
  "I-save ang waiver"
 ],
 "Cancellation policy": [
  "Política de cancelación",
  "Patakaran sa pagkansela"
 ],
 "Your cancellation wording": [
  "Tu texto de cancelación",
  "Ang teksto mo sa pagkansela"
 ],
 "and": [
  "y",
  "at"
 ],
 "the rules for what parents can cancel or reschedule themselves now live with your packages — so you set them once, right where they apply.": [
  "las reglas de cancelación y cambio de horario están en tus paquetes para configurarlas donde se aplican.",
  "ang mga patakaran sa pagkansela o pagbabago ng iskedyul ay nasa mga pakete — doon mo itatakda kung saan naaangkop."
 ],
 "Open Packages & Classes settings": [
  "Abrir ajustes de paquetes y clases",
  "Buksan ang mga setting ng pakete at klase"
 ],
 "Emails you receive": [
  "Correos que recibes",
  "Mga email na natatanggap mo"
 ],
 "Automated emails to parents": [
  "Correos automáticos a familias",
  "Mga awtomatikong email sa mga magulang"
 ],
 "Lesson reminder emails (to you 24h before, or to parents the morning of) are under": [
  "Los recordatorios de clase (24 h antes para ti o esa mañana para familias) están en",
  "Ang mga paalala (24 oras bago para sa iyo o sa umaga para sa magulang) ay nasa"
 ],
 "Schedule → Settings →": [
  "Horario → Configuración →",
  "Iskedyul → Mga setting →"
 ],
 "Login email": [
  "Correo de acceso",
  "Email sa pag-login"
 ],
 "The address that receives all SplashPad notifications, parent messages, and Stripe receipts. We'll send a confirmation to both your old and new address when you change it.": [
  "Aquí llegan notificaciones, mensajes y recibos. Al cambiarlo, enviaremos confirmación a ambas direcciones.",
  "Dito ipinapadala ang abiso, mensahe at resibo. Magpapadala ng kumpirmasyon sa luma at bagong email kapag binago."
 ],
 "Current email": [
  "Correo actual",
  "Kasalukuyang email"
 ],
 "New email": [
  "Nuevo correo",
  "Bagong email"
 ],
 "Current password": [
  "Contraseña actual",
  "Kasalukuyang password"
 ],
 "Required to confirm": [
  "Obligatoria para confirmar",
  "Kailangan para kumpirmahin"
 ],
 "We require your password as a security check so a stolen session alone can't hijack your account by re-pointing the email.": [
  "Pedimos tu contraseña para evitar que alguien con una sesión robada cambie tu correo y tome tu cuenta.",
  "Kailangan ang password para hindi mabago ang email at maagaw ang account gamit lang ang ninakaw na session."
 ],
 "Updating…": [
  "Actualizando…",
  "Ina-update…"
 ],
 "Update email address": [
  "Actualizar correo",
  "I-update ang email"
 ],
 "Startup guide": [
  "Guía de inicio",
  "Gabay sa pagsisimula"
 ],
 "Usually needed only once. For day-to-day changes, use Classes & Pricing. You can revisit the guide, but it won’t reset or overwrite your existing setup.": [
  "Normalmente solo se necesita una vez. Para cambios diarios usa Clases y precios. Volver a la guía no borra ni sobrescribe tu configuración.",
  "Karaniwang isang beses lang kailangan. Gamitin ang Mga klase at presyo para sa araw-araw na pagbabago. Hindi buburahin o papalitan ng gabay ang kasalukuyang setup."
 ],
 "Revisit guide": [
  "Volver a la guía",
  "Balikan ang gabay"
 ],
 "Import existing families": [
  "Importar familias existentes",
  "I-import ang kasalukuyang mga pamilya"
 ],
 "Bulk-import an existing roster from a CSV (parent name, email, phone, students, swim level). Great for transferring families from another system or onboarding a returning group all at once.": [
  "Importa familias desde un CSV con nombres, correo, teléfono, alumnos y nivel. Ideal para migrar desde otro sistema o reincorporar un grupo.",
  "I-import mula sa CSV ang pangalan, email, telepono, mga mag-aaral at antas sa paglangoy. Para sa paglipat mula sa ibang sistema o pagbabalik ng grupo."
 ],
 "Open importer": [
  "Abrir importador",
  "Buksan ang importer"
 ],
 "Staff & workforce": [
  "Personal y equipo",
  "Staff at team"
 ],
 "Turn on or off the time clock, shifts scheduling, and pay-rate features for your team.": [
  "Activa o desactiva el registro horario, los turnos y las tarifas de tu equipo.",
  "I-on o i-off ang time clock, iskedyul ng shift at pay rate para sa iyong team."
 ],
 "Master:": [
  "General:",
  "Pangkalahatan:"
 ],
 "Time clock:": [
  "Registro horario:",
  "Time clock:"
 ],
 "Shifts:": [
  "Turnos:",
  "Mga shift:"
 ],
 "Pay rates:": [
  "Tarifas:",
  "Mga pay rate:"
 ],
 "Manage": [
  "Gestionar",
  "Pamahalaan"
 ],
 "Coach dashboard": [
  "Panel del instructor",
  "Dashboard ng coach"
 ],
 "of": [
  "de",
  "ng"
 ],
 "Setup progress": [
  "Progreso de configuración",
  "Progreso ng setup"
 ],
 "Your typed answers stay here until you choose to reload the saved version.": [
  "Tus respuestas permanecen aquí hasta que recargues la versión guardada.",
  "Mananatili rito ang mga sagot mo hanggang i-reload mo ang na-save na bersyon."
 ],
 "Reload saved guide": [
  "Recargar guía guardada",
  "I-reload ang na-save na gabay"
 ],
 "Retry saving": [
  "Reintentar guardar",
  "Subukang i-save muli"
 ],
 "Back to dashboard": [
  "Volver al panel",
  "Bumalik sa dashboard"
 ],
 "1. Check your coach's available times": [
  "1. Consulta los horarios disponibles",
  "1. Tingnan ang mga bakanteng oras ng coach"
 ],
 "Live availability from your coach — buy a package below to lock in your spot.": [
  "Disponibilidad actual de tu instructor; compra un paquete abajo para reservar tu plaza.",
  "Kasalukuyang bakanteng oras ng coach — bumili ng pakete sa ibaba para makakuha ng puwesto."
 ],
 "You pick your class day & time": [
  "Elige el día y la hora",
  "Piliin ang araw at oras"
 ],
 "Choose a package below — every available day and time is listed right there, and you lock yours in as you check out.": [
  "Elige un paquete abajo y confirma el horario al pagar.",
  "Pumili ng pakete sa ibaba at kumpirmahin ang oras sa pagbabayad."
 ],
 "From your coach:": [
  "De tu instructor:",
  "Mula sa coach:"
 ],
 "Scheduling handled directly with your coach": [
  "Acuerda el horario con tu instructor",
  "Direktang ayusin ang oras sa coach"
 ],
 "Choose your package": [
  "Elige tu paquete",
  "Piliin ang pakete"
 ],
 "Pick a package to lock in your spot. You can always add more later.": [
  "Elige un paquete para reservar. Puedes añadir más después.",
  "Pumili ng pakete para makakuha ng puwesto. Puwedeng magdagdag sa susunod."
 ],
 "Your coach hasn't made any packages available yet.": [
  "Tu instructor aún no ofrece paquetes.",
  "Wala pang iniaalok na pakete ang coach."
 ],
 "Message your coach": [
  "Escribe a tu instructor",
  "Mag-message sa coach"
 ],
 "to get started.": [
  "para empezar.",
  "para magsimula."
 ],
 "Approved": [
  "Aprobado",
  "Aprubado"
 ],
 "✨ Custom": [
  "Personalizado",
  "Pasadya"
 ],
 "Camp": [
  "Campamento",
  "Camp"
 ],
 "Custom": [
  "Personalizado",
  "Pasadya"
 ],
 "session": [
  "sesión",
  "sesyon"
 ],
 "min each": [
  "min cada una",
  "minuto bawat isa"
 ],
 "/week": [
  "/semana",
  "/linggo"
 ],
 "· Choose from": [
  "· Elige entre",
  "· Pumili mula sa"
 ],
 "time slots": [
  "horarios",
  "mga oras"
 ],
 "Call": [
  "Llamar",
  "Tumawag"
 ],
 "Reach out to your coach to discuss": [
  "Contacta a tu instructor para hablar de",
  "Kontakin ang coach tungkol sa"
 ],
 "Pick a class time & pay": [
  "Elegir horario y pagar",
  "Pumili ng oras at magbayad"
 ],
 "Buy now": [
  "Comprar ahora",
  "Bumili ngayon"
 ],
 "Online pay not available — message your coach": [
  "Pago online no disponible; contacta a tu instructor",
  "Hindi available ang online na bayad — kontakin ang coach"
 ],
 "Pick at least one child for this package.": [
  "Elige al menos un niño para este paquete.",
  "Pumili ng kahit isang bata para sa pakete."
 ],
 "Pick a class time before paying.": [
  "Elige un horario antes de pagar.",
  "Pumili muna ng oras bago magbayad."
 ],
 "Your coach hasn't finished setting up payments yet. Try again in a few minutes or message them directly.": [
  "Tu instructor aún está configurando pagos. Inténtalo más tarde o contáctalo.",
  "Hindi pa tapos ang setup ng bayad ng coach. Subukan muli o kontakin siya."
 ],
 "Buy": [
  "Comprar",
  "Bumili"
 ],
 "Total today": [
  "Total de hoy",
  "Kabuuan ngayon"
 ],
 "lesson": [
  "clase",
  "aralin"
 ],
 "Who is this for?": [
  "¿Para quién es?",
  "Para kanino ito?"
 ],
 "Preparing…": [
  "Preparando…",
  "Inihahanda…"
 ],
 "Continue to payment": [
  "Continuar al pago",
  "Magpatuloy sa pagbabayad"
 ],
 "Questions for your coach?": [
  "¿Preguntas para tu instructor?",
  "May tanong sa coach?"
 ],
 "Send a quick message — it goes straight to": [
  "Envía un mensaje a",
  "Magpadala ng mensahe kay"
 ],
 "'s inbox. They can reply directly to you.": [
  ". Podrá responderte directamente.",
  ". Maaari siyang direktang sumagot."
 ],
 "Send a message": [
  "Enviar un mensaje",
  "Magpadala ng mensahe"
 ],
 "Type a message before sending.": [
  "Escribe un mensaje antes de enviarlo.",
  "Magsulat muna ng mensahe."
 ],
 "Message": [
  "Mensaje",
  "Mensahe"
 ],
 "Subject": [
  "Asunto",
  "Paksa"
 ],
 "e.g. Question about lessons": [
  "P. ej., pregunta sobre clases",
  "Hal. Tanong tungkol sa aralin"
 ],
 "Your message": [
  "Tu mensaje",
  "Iyong mensahe"
 ],
 "Hi! I had a question about…": [
  "Hola, tengo una pregunta sobre…",
  "Kumusta! May tanong ako tungkol sa…"
 ],
 "/5000 — replies go straight to your email.": [
  "/5000; las respuestas llegarán a tu correo.",
  "/5000 — sa email mo darating ang sagot."
 ],
 "Sending…": [
  "Enviando…",
  "Ipinapadala…"
 ],
 "Send message": [
  "Enviar mensaje",
  "Ipadala ang mensahe"
 ],
 "Review copied — paste it on Google when prompted!": [
  "Reseña copiada; pégala en Google.",
  "Nakopya ang review — i-paste sa Google!"
 ],
 "Loved your experience?": [
  "¿Te encantó la experiencia?",
  "Nagustuhan mo ang karanasan?"
 ],
 "Help other families find": [
  "Ayuda a otras familias a encontrar a",
  "Tulungan ang ibang pamilya na mahanap si"
 ],
 "by leaving a Google review. Draft it here, then post on Google.": [
  "con una reseña en Google. Escríbela aquí y publícala allí.",
  "sa pamamagitan ng review sa Google. Isulat dito at i-post doon."
 ],
 "e.g. My daughter went from afraid of water to swimming laps in 6 lessons. Highly recommend!": [
  "P. ej., mi hija aprendió a nadar en seis clases. ¡Lo recomiendo!",
  "Hal. Natutong lumangoy ang anak ko sa anim na aralin. Inirerekomenda ko!"
 ],
 "Copy + post on Google": [
  "Copiar y publicar en Google",
  "Kopyahin at i-post sa Google"
 ],
 "Review on Google": [
  "Reseña en Google",
  "Mag-review sa Google"
 ],
 "Preview only — approved parents join the waitlist here.": [
  "Solo vista previa; las familias aprobadas se unen aquí a la lista.",
  "Preview lang — dito sumasali sa waitlist ang aprubadong magulang."
 ],
 "Removed from the waitlist.": [
  "Eliminado de la lista de espera.",
  "Inalis sa waitlist."
 ],
 "Could not load the parent portal preview.": [
  "No se pudo cargar la vista previa.",
  "Hindi ma-load ang preview."
 ],
 "You don't have access to a coach portal yet. Apply to one first.": [
  "Aún no tienes acceso a un portal. Envía una solicitud primero.",
  "Wala ka pang access sa portal. Mag-apply muna."
 ],
 "Coach not found.": [
  "Instructor no encontrado.",
  "Hindi nahanap ang coach."
 ],
 "Loading your coach portal…": [
  "Cargando tu portal…",
  "Nilo-load ang portal mo…"
 ],
 "Preview only — parents would be taken to the enrollment page.": [
  "Solo vista previa; se abriría la página de inscripción.",
  "Preview lang — bubuksan ang pahina ng pagpapatala."
 ],
 "Members-only portal": [
  "Portal privado",
  "Pribadong portal"
 ],
 "Website": [
  "Sitio web",
  "Website"
 ],
 "Public page": [
  "Página pública",
  "Pampublikong pahina"
 ],
 "A note from your coach": [
  "Una nota de tu instructor",
  "Tala mula sa coach"
 ],
 "Welcome to the family! Your coach hasn't added a personal message yet.": [
  "¡Bienvenidos! Tu instructor aún no añadió un mensaje personal.",
  "Maligayang pagdating! Wala pang personal na mensahe ang coach."
 ],
 "Resources": [
  "Recursos",
  "Mga sanggunian"
 ],
 "Welcome video": [
  "Video de bienvenida",
  "Welcome video"
 ],
 "Find Classes": [
  "Buscar clases",
  "Maghanap ng klase"
 ],
 "Coach unavailable": [
  "Instructor no disponible",
  "Hindi available ang coach"
 ],
 "Closed": [
  "Cerrado",
  "Sarado"
 ],
 "class": [
  "clase",
  "klase"
 ],
 "private": [
  "particular",
  "pribado"
 ],
 "Click any highlighted day to see classes and bookable lesson times. Classes marked": [
  "Pulsa un día resaltado para ver clases y horarios. Las clases marcadas",
  "Pindutin ang naka-highlight na araw para makita ang klase at oras. Ang may markang"
 ],
 "open": [
  "abiertas",
  "bukas"
 ],
 "let you enroll instantly. Classes marked": [
  "permiten inscribirte al instante. Las marcadas",
  "ay maaaring salihan agad. Ang may markang"
 ],
 "request": [
  "solicitud",
  "kahilingan"
 ],
 "need your coach's approval first.": [
  "requieren aprobación del instructor.",
  "ay kailangan ng pag-apruba ng coach."
 ],
 "Your coach hasn't published any Classes or Packages yet.": [
  "Tu instructor aún no publicó clases ni paquetes.",
  "Wala pang nai-publish na klase o pakete ang coach."
 ],
 "Class · Recurring": [
  "Clase · Recurrente",
  "Klase · Paulit-ulit"
 ],
 "Package · Per-lesson": [
  "Paquete · Por clase",
  "Pakete · Bawat aralin"
 ],
 "Package · One-time": [
  "Paquete · Pago único",
  "Pakete · Isahang bayad"
 ],
 "Classes & bookable lesson times for this day.": [
  "Clases y horarios disponibles para este día.",
  "Mga klase at bakanteng oras sa araw na ito."
 ],
 "Nothing scheduled.": [
  "No hay nada programado.",
  "Walang naka-iskedyul."
 ],
 "Open enrollment": [
  "Inscripción abierta",
  "Bukas na pagpapatala"
 ],
 "Request to enroll": [
  "Solicitar inscripción",
  "Humiling ng pagpapatala"
 ],
 "Full": [
  "Completo",
  "Puno na"
 ],
 "Your coach needs to confirm this time — request it and they'll follow up.": [
  "Solicita este horario; tu instructor debe confirmarlo.",
  "Humiling ng oras na ito — kailangang kumpirmahin ng coach."
 ],
 "on waitlist": [
  "en lista de espera",
  "nasa waitlist"
 ],
 "Leave": [
  "Salir",
  "Umalis"
 ],
 "Join waitlist": [
  "Unirme a la lista",
  "Sumali sa waitlist"
 ],
 "Preview only — approved parents sign up here.": [
  "Solo vista previa; las familias aprobadas se inscriben aquí.",
  "Preview lang — dito nagpaparehistro ang aprubadong magulang."
 ],
 "Sign up": [
  "Inscribirse",
  "Magparehistro"
 ],
 "Request": [
  "Solicitar",
  "Humiling"
 ],
 "Private 1:1 lesson times": [
  "Horarios de clases particulares",
  "Mga oras ng pribadong aralin"
 ],
 "Preview only — approved parents book here.": [
  "Solo vista previa; las familias aprobadas reservan aquí.",
  "Preview lang — dito nagbu-book ang aprubadong magulang."
 ],
 "Tap a time to book a private 1:1 lesson.": [
  "Pulsa un horario para reservar una clase particular.",
  "Pindutin ang oras para mag-book ng pribadong aralin."
 ],
 "Almost there — complete payment to confirm your spot.": [
  "Completa el pago para confirmar tu plaza.",
  "Magbayad para makumpirma ang puwesto."
 ],
 "You're enrolled! Your coach will invoice you — you can pay any time from your Payments tab.": [
  "¡Inscrito! Tu instructor enviará una factura; paga desde Pagos.",
  "Nakatala ka na! Magpapadala ng invoice ang coach — bayaran sa Mga bayad."
 ],
 "Enrolled! Pay the invoice from your Payments tab to finalize.": [
  "¡Inscrito! Paga la factura en Pagos para finalizar.",
  "Nakatala ka na! Bayaran ang invoice sa Mga bayad para matapos."
 ],
 "Pick which student(s) to enroll. You'll pay the invoice via Stripe on the next screen.": [
  "Elige alumnos; pagarás por Stripe en la siguiente pantalla.",
  "Piliin ang mag-aaral — magbabayad gamit ang Stripe sa susunod na screen."
 ],
 "This time overlaps a lesson already on your coach's calendar. Pick your student(s) and send a request — your coach will confirm the time with you before anything is booked.": [
  "Coincide con otra clase. Elige alumnos y envía la solicitud; el instructor confirmará antes de reservar.",
  "Kasabay nito ang ibang aralin. Pumili ng mag-aaral at humiling — kukumpirmahin ng coach bago mag-book."
 ],
 "Pick which student(s) you'd like to enroll. Your coach will review and confirm.": [
  "Elige alumnos para inscribir. Tu instructor revisará y confirmará.",
  "Piliin ang mag-aaral na ipapatala. Susuriin at kukumpirmahin ng coach."
 ],
 "Your coach will be": [
  "Tu instructor será",
  "Ang coach mo ay si"
 ],
 "No students on your profile yet. Add one from your Profile page first.": [
  "Aún no tienes alumnos. Añade uno desde tu perfil.",
  "Wala pang mag-aaral. Magdagdag muna sa Profile."
 ],
 "Notes for your coach (optional)": [
  "Notas para tu instructor (opcional)",
  "Tala para sa coach (opsyonal)"
 ],
 "Submitting…": [
  "Enviando…",
  "Isinusumite…"
 ],
 "Enroll": [
  "Inscribir",
  "Magpatala"
 ],
 "Send request": [
  "Enviar solicitud",
  "Ipadala ang kahilingan"
 ],
 "Text": [
  "Mensaje de texto",
  "Text"
 ],
 "Your family's swim HQ": [
  "El centro de natación de tu familia",
  "Sentro ng paglangoy ng pamilya"
 ],
 "Add to my calendar": [
  "Añadir a mi calendario",
  "Idagdag sa calendar ko"
 ],
 "Payment due — you chose to pay another way": [
  "Pago pendiente: elegiste otra forma de pago",
  "May dapat bayaran — pinili mong magbayad sa ibang paraan"
 ],
 "These stay pending until your coach confirms the money arrived.": [
  "Pendiente hasta que el instructor confirme que llegó el dinero.",
  "Nakabinbin hanggang kumpirmahin ng coach na dumating ang pera."
 ],
 "directly": [
  "directamente",
  "nang direkta"
 ],
 "Next lesson": [
  "Próxima clase",
  "Susunod na aralin"
 ],
 "Address & details": [
  "Dirección y detalles",
  "Address at mga detalye"
 ],
 "Full schedule": [
  "Horario completo",
  "Buong iskedyul"
 ],
 "Pending applications": [
  "Solicitudes pendientes",
  "Mga nakabinbing aplikasyon"
 ],
 "Applied": [
  "Solicitud enviada",
  "Nakapag-apply"
 ],
 "Pending review": [
  "En revisión",
  "Sinusuri pa"
 ],
 "Your coach is reviewing your application. You'll get an email as soon as a decision is made — usually within 24-48 hours.": [
  "Tu instructor revisa la solicitud. Recibirás la decisión por correo, normalmente en 24–48 horas.",
  "Sinusuri ng coach ang aplikasyon. Darating ang desisyon sa email, karaniwang sa loob ng 24–48 oras."
 ],
 "Need to update your info? Reach out at": [
  "¿Necesitas cambiar datos? Contacta a",
  "Kailangang baguhin ang impormasyon? Kontakin ang"
 ],
 "Ready to book": [
  "Listo para reservar",
  "Handa nang mag-book"
 ],
 "Payment required": [
  "Pago requerido",
  "Kailangang magbayad"
 ],
 "You're not signed up yet.": [
  "Aún no estás inscrito.",
  "Hindi ka pa nakatala."
 ],
 "Your coach has approved you — tap below to pick a package and complete payment. Your spot isn't held until the payment goes through.": [
  "Tu instructor te aprobó. Elige un paquete y paga. La plaza no se reserva hasta completar el pago.",
  "Aprubado ka na. Pumili ng pakete at magbayad. Hindi nakareserba ang puwesto hangga't hindi bayad."
 ],
 "Complete payment": [
  "Completar pago",
  "Kumpletuhin ang bayad"
 ],
 "Past applications": [
  "Solicitudes anteriores",
  "Mga dating aplikasyon"
 ],
 "Not accepted": [
  "No aceptado",
  "Hindi tinanggap"
 ],
 "wasn't able to take on your family at this time.": [
  "no pudo aceptar a tu familia esta vez.",
  "ay hindi matanggap ang pamilya mo sa ngayon."
 ],
 "Coach note:": [
  "Nota del instructor:",
  "Tala ng coach:"
 ],
 "Awaiting payment": [
  "Esperando pago",
  "Hinihintay ang bayad"
 ],
 "Awaiting invoice": [
  "Esperando factura",
  "Hinihintay ang invoice"
 ],
 "Complete": [
  "Completo",
  "Kumpleto"
 ],
 "sessions": [
  "sesiones",
  "mga sesyon"
 ],
 "Students:": [
  "Alumnos:",
  "Mga mag-aaral:"
 ],
 "Ongoing subscription": [
  "Suscripción en curso",
  "Aktibong subscription"
 ],
 "Sessions remaining:": [
  "Sesiones restantes:",
  "Natitirang sesyon:"
 ],
 "Your coach schedules lesson times with you directly": [
  "Tu instructor acuerda los horarios contigo",
  "Direktang inaayos ng coach sa iyo ang oras"
 ],
 "All lessons used — great job!": [
  "¡Usaste todas las clases! ¡Buen trabajo!",
  "Nagamit na lahat ng aralin — mahusay!"
 ],
 "Your coach can renew this pack so the progress keeps going. Reach out to them, or they may renew it for you.": [
  "Tu instructor puede renovar el paquete. Contáctalo o espera a que lo renueve por ti.",
  "Maaaring i-renew ng coach ang pakete. Kontakin siya o maaari niya itong i-renew para sa iyo."
 ],
 "Enrolled": [
  "Inscrito",
  "Nakatala"
 ],
 "Waiver": [
  "Exención",
  "Waiver"
 ],
 "No applications yet": [
  "Aún no hay solicitudes",
  "Wala pang aplikasyon"
 ],
 "Visit your coach's page to apply for lessons.": [
  "Visita la página de tu instructor para solicitar clases.",
  "Bisitahin ang pahina ng coach para mag-apply."
 ],
 "Card on file": [
  "Tarjeta guardada",
  "Naka-save na card"
 ],
 "exp": [
  "vence",
  "paso"
 ],
 "charges this card for future lessons and packages.": [
  "carga a esta tarjeta futuras clases y paquetes.",
  "ay sisingil sa card na ito para sa susunod na aralin at pakete."
 ],
 "No card on file yet": [
  "Aún no hay tarjeta guardada",
  "Wala pang naka-save na card"
 ],
 "We'll save your card automatically the first time you pay.": [
  "Guardaremos tu tarjeta al pagar por primera vez.",
  "Ise-save namin ang card sa unang pagbabayad."
 ],
 "You can also add one now so": [
  "Puedes añadir una ahora para que",
  "Puwede ring magdagdag ngayon para si"
 ],
 "can charge you for packages without waiting.": [
  "pueda cobrar paquetes sin esperar.",
  "ay makasingil ng pakete nang hindi naghihintay."
 ],
 "Manage cards": [
  "Gestionar tarjetas",
  "Pamahalaan ang mga card"
 ],
 "We couldn't open this invitation": [
  "No pudimos abrir esta invitación",
  "Hindi mabuksan ang imbitasyon"
 ],
 "Payment isn't available right now (missing Stripe key). Please reach out to your coach.": [
  "Pago no disponible: falta la clave de Stripe. Contacta al instructor.",
  "Hindi available ang bayad: walang Stripe key. Kontakin ang coach."
 ],
 "Your payment went through": [
  "Tu pago se completó",
  "Pumasok na ang bayad mo"
 ],
 "Your card was charged for \"": [
  "Se cobró a tu tarjeta por «",
  "Nasingil ang card para sa \""
 ],
 "\" and you'll get a Stripe receipt by email. We hit a snag finishing the enrollment on our side —": [
  "» y recibirás un recibo de Stripe por correo. Hubo un problema al finalizar la inscripción:",
  "\" at darating ang resibo ng Stripe sa email. Nagkaproblema sa pagtatapos ng pagpapatala —"
 ],
 "please don't pay again": [
  "no vuelvas a pagar",
  "huwag magbayad muli"
 ],
 ". Your coach will see the payment and your spot will be confirmed automatically; if it isn't within a few hours, just reply to your coach.": [
  ". Tu instructor verá el pago y tu plaza se confirmará automáticamente. Si tarda varias horas, contáctalo.",
  ". Makikita ng coach ang bayad at awtomatikong makukumpirma ang puwesto. Kung lumipas ang ilang oras, kontakin siya."
 ],
 "Go to your dashboard": [
  "Ir al panel",
  "Pumunta sa dashboard"
 ],
 "Complete your enrollment | SplashPad": [
  "Completa tu inscripción | SplashPad",
  "Kumpletuhin ang pagpapatala | SplashPad"
 ],
 "Finish your swim lesson enrollment and payment securely through SplashPad.": [
  "Completa tu inscripción y pago de forma segura con SplashPad.",
  "Ligtas na kumpletuhin ang pagpapatala at bayad sa SplashPad."
 ],
 "Enrollment invitation": [
  "Invitación de inscripción",
  "Imbitasyon sa pagpapatala"
 ],
 "Auto-bills on day": [
  "Cobro automático el día",
  "Awtomatikong sinisingil sa araw na"
 ],
 "of each month. Cancel anytime.": [
  "de cada mes. Cancela cuando quieras.",
  "ng bawat buwan. Kanselahin anumang oras."
 ],
 "Your card will be saved on file.": [
  "Tu tarjeta quedará guardada.",
  "Ise-save ang card mo."
 ],
 "By": [
  "Al",
  "Sa"
 ],
 "starting this subscription": [
  "iniciar esta suscripción",
  "pagsisimula ng subscription"
 ],
 "paying": [
  "pagar",
  "pagbabayad"
 ],
 ", you authorize": [
  ", autorizas a",
  ", pinapahintulutan mo si"
 ],
 "to save this card and charge it for future lessons or packages. Manage saved cards anytime under": [
  "a guardar esta tarjeta y cobrar futuras clases o paquetes. Gestiona tus tarjetas en",
  "na i-save ang card at singilin para sa susunod na aralin o pakete. Pamahalaan ang mga card sa"
 ],
 "Payment methods": [
  "Métodos de pago",
  "Mga paraan ng pagbabayad"
 ],
 "in your dashboard.": [
  "de tu panel.",
  "sa dashboard mo."
 ],
 "Confirming…": [
  "Confirmando…",
  "Kinukumpirma…"
 ],
 "Start subscription —": [
  "Iniciar suscripción —",
  "Simulan ang subscription —"
 ],
 "/month": [
  "/mes",
  "/buwan"
 ],
 "Secured by Stripe. Your card details never touch SplashPad.": [
  "Protegido por Stripe. SplashPad no recibe los datos de tu tarjeta.",
  "Ligtas sa Stripe. Hindi natatanggap ng SplashPad ang mga detalye ng card."
 ],
 "You're enrolled! 🎉": [
  "¡Ya estás inscrito!",
  "Nakatala ka na!"
 ],
 "No new charge was made.": [
  "No se realizó ningún cobro nuevo.",
  "Walang bagong singil."
 ],
 "Your bookings": [
  "Tus reservas",
  "Iyong mga booking"
 ],
 "Your packages, classes, and upcoming swim lessons in one place.": [
  "Tus paquetes y clases en un solo lugar.",
  "Mga pakete at klase sa iisang lugar."
 ],
 "Payment needed": [
  "Pago necesario",
  "Kailangang magbayad"
 ],
 "has approved your family — pick a class and complete payment to lock it in.": [
  "ha aprobado a tu familia; elige una clase y paga para confirmarla.",
  "ay inaprubahan ang pamilya mo — pumili ng klase at magbayad."
 ],
 "Pick a class & pay": [
  "Elegir clase y pagar",
  "Pumili ng klase at magbayad"
 ],
 "Once you complete payment above, your enrolled classes will show here.": [
  "Tus clases aparecerán aquí cuando completes el pago.",
  "Lalabas dito ang mga klase kapag nakumpleto ang bayad."
 ],
 "No active enrollments yet.": [
  "Aún no hay inscripciones activas.",
  "Wala pang aktibong pagpapatala."
 ],
 "with": [
  "con",
  "kasama si"
 ],
 "Coached by": [
  "Con el instructor",
  "Sa pagtuturo ni"
 ],
 "sessions ·": [
  "sesiones ·",
  "mga sesyon ·"
 ],
 "To pause or cancel this subscription, please contact your coach directly. Any changes are handled by the instructor on your behalf.": [
  "Para pausar o cancelar esta suscripción, contacta a tu instructor. Él gestiona los cambios por ti.",
  "Para ihinto o kanselahin ang subscription, kontakin ang coach. Siya ang gagawa ng mga pagbabago."
 ],
 "No lessons scheduled yet. Your coach will add them as they book each session.": [
  "Aún no hay clases programadas. Tu instructor las añadirá al reservarlas.",
  "Wala pang naka-iskedyul na aralin. Idadagdag ng coach kapag nai-book."
 ],
 "Recent": [
  "Recientes",
  "Kamakailan"
 ],
 "View on dashboard": [
  "Ver en el panel",
  "Tingnan sa dashboard"
 ],
 "Time TBD — check with your coach": [
  "Hora por confirmar; consulta al instructor",
  "Wala pang takdang oras — itanong sa coach"
 ],
 "TBD": [
  "Por confirmar",
  "Itatakda pa"
 ],
 "— pick location —": [
  "— elegir ubicación —",
  "— pumili ng lokasyon —"
 ],
 "Class time updated.": [
  "Horario actualizado.",
  "Na-update ang oras ng klase."
 ],
 "— pick class time —": [
  "— elegir horario —",
  "— pumili ng oras —"
 ],
 "Couldn't load your students.": [
  "No se pudieron cargar tus alumnos.",
  "Hindi ma-load ang mga mag-aaral."
 ],
 "First and last name are required.": [
  "Nombre y apellido obligatorios.",
  "Kailangan ang pangalan at apelyido."
 ],
 "Pick your child's date of birth.": [
  "Elige la fecha de nacimiento de tu hijo.",
  "Piliin ang kaarawan ng bata."
 ],
 "Saved.": [
  "Guardado.",
  "Na-save."
 ],
 "yr": [
  "años",
  "taon"
 ],
 "Medical note": [
  "Nota médica",
  "Medikal na tala"
 ],
 "Awaiting class assignment": [
  "Esperando asignación de clase",
  "Hinihintay ang pagtatalaga ng klase"
 ],
 "Keep your kids' profiles in one place so applying to a new class is one tap.": [
  "Guarda los perfiles de tus hijos para solicitar clases fácilmente.",
  "Itabi ang profile ng mga bata para madaling mag-apply."
 ],
 "Add child": [
  "Añadir hijo",
  "Magdagdag ng bata"
 ],
 "Loading your students…": [
  "Cargando alumnos…",
  "Nilo-load ang mga mag-aaral…"
 ],
 "No students yet": [
  "Aún no hay alumnos",
  "Wala pang mag-aaral"
 ],
 "Add each child you'd like to enroll. You only have to do this once — every future class application will let you pick them from a list.": [
  "Añade a cada hijo una vez. En futuras solicitudes podrás elegirlos de una lista.",
  "Idagdag ang bawat bata nang isang beses. Sa susunod na aplikasyon, piliin na lang sila sa listahan."
 ],
 "Add your first child": [
  "Añadir tu primer hijo",
  "Idagdag ang unang bata"
 ],
 "Add a child": [
  "Añadir un hijo",
  "Magdagdag ng bata"
 ],
 "Edit child": [
  "Editar hijo",
  "Baguhin ang detalye ng bata"
 ],
 "Your coach uses this to know who's in the water and how to keep them safe.": [
  "Estos datos permiten al instructor saber quién nada y cómo cuidarlo.",
  "Ginagamit ng coach para kilalanin ang lumalangoy at mapanatiling ligtas."
 ],
 "Gender": [
  "Género",
  "Kasarian"
 ],
 "Prefer not to say": [
  "Prefiero no decirlo",
  "Mas gustong hindi sabihin"
 ],
 "Swim level": [
  "Nivel de natación",
  "Antas sa paglangoy"
 ],
 "Medical notes / allergies": [
  "Notas médicas / alergias",
  "Mga medikal na tala / allergy"
 ],
 "Anything your coach should know (allergies, asthma, prior injuries)…": [
  "Lo que deba saber el instructor (alergias, asma, lesiones)…",
  "Dapat malaman ng coach (allergy, hika, pinsala)…"
 ],
 "Emergency medication authorization": [
  "Autorización para medicación de emergencia",
  "Pahintulot sa gamot sa emergency"
 ],
 "I authorize the coach to administer emergency medication (e.g., EpiPen, inhaler) on my child's behalf if needed.": [
  "Autorizo al instructor a administrar medicación de emergencia (EpiPen, inhalador) a mi hijo si es necesario.",
  "Pinapahintulutan ko ang coach na magbigay ng gamot sa emergency (EpiPen, inhaler) sa aking anak kung kailangan."
 ],
 "Saving": [
  "Guardando",
  "Sine-save"
 ],
 "from your account?": [
  "de tu cuenta?",
  "mula sa iyong account?"
 ],
 "This removes the student profile entirely.": [
  "Esto elimina el perfil del alumno por completo.",
  "Tuluyang aalisin ang profile ng mag-aaral."
 ],
 "They'll be gone from": [
  "Se eliminará de",
  "Mawawala siya sa"
 ],
 "your account roster": [
  "la lista de tu cuenta",
  "talaan ng iyong account"
 ],
 "— not just from a single class — so they won't appear when applying to a new class either.": [
  "— no solo de una clase; tampoco aparecerá en solicitudes futuras.",
  "— hindi lang sa isang klase — hindi na rin siya lalabas sa susunod na aplikasyon."
 ],
 "This is NOT how you drop them from a class they're in.": [
  "Esto NO es para darlo de baja de una clase.",
  "HINDI ito ang paraan para alisin siya sa klase."
 ],
 "To stop attending a class, open": [
  "Para dejar una clase, abre",
  "Para huminto sa klase, buksan ang"
 ],
 "and cancel that enrollment instead — billing prorates automatically.": [
  "y cancela esa inscripción; la facturación se prorratea automáticamente.",
  "at kanselahin ang pagpapatala — awtomatikong iaakma ang singil."
 ],
 "Past attendance and historical enrollments stay intact for your coach's records. If they're still in any active class right now, we'll block this removal and ask you to cancel that enrollment first.": [
  "La asistencia e inscripciones anteriores se conservan. Si sigue en una clase activa, deberás cancelar esa inscripción antes de eliminar el perfil.",
  "Mananatili ang lumang attendance at pagpapatala sa talaan ng coach. Kung may aktibong klase, kailangan munang kanselahin ang pagpapatala bago alisin ang profile."
 ],
 "Keep them on my account": [
  "Mantener en mi cuenta",
  "Panatilihin sa aking account"
 ],
 "Removing": [
  "Eliminando",
  "Inaalis"
 ],
 "Remove from account": [
  "Eliminar de la cuenta",
  "Alisin sa account"
 ],
 "Primary": [
  "Principal",
  "Pangunahin"
 ],
 "We couldn't open this invoice": [
  "No pudimos abrir esta factura",
  "Hindi mabuksan ang invoice"
 ],
 "Pay your invoice | SplashPad": [
  "Paga tu factura | SplashPad",
  "Bayaran ang invoice | SplashPad"
 ],
 "Securely pay your swim lesson invoice online through SplashPad.": [
  "Paga tu factura de natación de forma segura con SplashPad.",
  "Ligtas na bayaran ang invoice sa paglangoy sa SplashPad."
 ],
 "Default card updated.": [
  "Tarjeta predeterminada actualizada.",
  "Na-update ang default card."
 ],
 "Card removed.": [
  "Tarjeta eliminada.",
  "Inalis ang card."
 ],
 "Got it — send your payment using the coach’s instructions. They’ll confirm once it arrives.": [
  "Sigue las instrucciones de pago del instructor. Confirmará cuando lo reciba.",
  "Sundin ang tagubilin ng coach sa pagbabayad. Kukumpirmahin niya kapag natanggap."
 ],
 "Manage your saved cards, pay invoices, and review your payment history.": [
  "Gestiona tarjetas, paga facturas y consulta tus pagos.",
  "Pamahalaan ang card, magbayad ng invoice at tingnan ang kasaysayan ng bayad."
 ],
 "Save a card on file so your coach can charge it for new packages and lessons without bothering you each time. Cards are stored by Stripe — SplashPad never sees the full number.": [
  "Guarda una tarjeta para que tu instructor pueda cobrar nuevas clases. Stripe guarda las tarjetas; SplashPad nunca ve el número completo.",
  "Mag-save ng card para masingil ng coach ang bagong pakete at aralin. Nasa Stripe ang card — hindi nakikita ng SplashPad ang buong numero."
 ],
 "Once you're enrolled with a coach, you'll be able to save a card on file here. Your card will save automatically the first time you pay.": [
  "Cuando estés inscrito podrás guardar una tarjeta aquí. Se guardará automáticamente con tu primer pago.",
  "Kapag nakatala ka na, maaari kang mag-save ng card dito. Awtomatiko itong mase-save sa unang bayad."
 ],
 "Outstanding invoices": [
  "Facturas pendientes",
  "Mga hindi pa bayad na invoice"
 ],
 "All caught up — no invoices waiting for payment.": [
  "Todo al día; no hay facturas pendientes.",
  "Kumpleto na — walang kailangang bayarang invoice."
 ],
 "Old card removed.": [
  "Tarjeta anterior eliminada.",
  "Inalis ang lumang card."
 ],
 "Remove card ending in": [
  "¿Eliminar tarjeta terminada en",
  "Alisin ang card na nagtatapos sa"
 ],
 "won't be able to charge this card anymore. Any recurring subscription tied to it will continue until you cancel the subscription itself.": [
  "no podrá cobrar a esta tarjeta. Las suscripciones vinculadas continúan hasta cancelarlas.",
  "ay hindi na makakasingil sa card na ito. Magpapatuloy ang subscription hanggang kanselahin ito."
 ],
 "This is currently your default card — another saved card will become the default automatically.": [
  "Es tu tarjeta predeterminada; otra guardada pasará a ser la principal.",
  "Ito ang default card — magiging default ang isa pang naka-save na card."
 ],
 "Keep card": [
  "Mantener tarjeta",
  "Panatilihin ang card"
 ],
 "Removing…": [
  "Eliminando…",
  "Inaalis…"
 ],
 "Remove card": [
  "Eliminar tarjeta",
  "Alisin ang card"
 ],
 "Pay another way": [
  "Otra forma de pago",
  "Ibang paraan ng pagbabayad"
 ],
 "directly (Venmo, Zelle, cash…) instead of using a card:": [
  "directamente (Venmo, Zelle, efectivo) en lugar de tarjeta:",
  "nang direkta (Venmo, Zelle, cash) sa halip na card:"
 ],
 "Your coach will share payment details with you directly.": [
  "Tu instructor compartirá los datos de pago directamente.",
  "Direktang ibibigay ng coach ang detalye sa pagbabayad."
 ],
 "Your spot stays pending": [
  "Tu plaza queda pendiente",
  "Mananatiling nakabinbin ang puwesto"
 ],
 "until the coach confirms your payment was received.": [
  "hasta que el instructor confirme el pago.",
  "hanggang kumpirmahin ng coach ang bayad."
 ],
 "Never mind": [
  "Volver",
  "Huwag na"
 ],
 "Confirm — I'll pay directly": [
  "Confirmar: pagaré directamente",
  "Kumpirmahin — direktang magbabayad"
 ],
 "Coach not connected to Stripe": [
  "Instructor no conectado a Stripe",
  "Hindi nakakonekta sa Stripe ang coach"
 ],
 "Add card": [
  "Añadir tarjeta",
  "Magdagdag ng card"
 ],
 "No cards saved yet.": [
  "Aún no hay tarjetas guardadas.",
  "Wala pang naka-save na card."
 ],
 "Your card will save automatically the first time you pay": [
  "Tu tarjeta se guardará con tu primer pago a",
  "Mase-save ang card sa unang bayad kay"
 ],
 ". Or": [
  ". O",
  ". O"
 ],
 "add one now": [
  "añade una ahora",
  "magdagdag ngayon"
 ],
 "wait for the coach to finish setting up payments": [
  "espera a que el instructor configure los pagos",
  "hintaying matapos ang setup ng bayad ng coach"
 ],
 "Default": [
  "Predeterminada",
  "Default"
 ],
 "Expires": [
  "Vence",
  "Mapapaso"
 ],
 "Make default": [
  "Usar como predeterminada",
  "Gawing default"
 ],
 "Your card details are stored by Stripe. SplashPad never sees the full number.": [
  "Stripe guarda tu tarjeta. SplashPad nunca ve el número completo.",
  "Nasa Stripe ang detalye ng card. Hindi nakikita ng SplashPad ang buong numero."
 ],
 "To swap cards, add the new one first — you always need at least one card on file while enrolled.": [
  "Para cambiar tarjetas, añade la nueva primero. Debes mantener al menos una mientras estés inscrito.",
  "Idagdag muna ang bagong card bago palitan ang luma. Kailangan ng kahit isang card habang nakatala."
 ],
 "Need help?": [
  "¿Necesitas ayuda?",
  "Kailangan ng tulong?"
 ],
 "Reach out to": [
  "Contacta a",
  "Kontakin si"
 ],
 "at": [
  "en",
  "sa"
 ],
 "directly.": [
  "directamente.",
  "nang direkta."
 ],
 "Overdue": [
  "Vencida",
  "Lampas sa takdang petsa"
 ],
 "Paying another way": [
  "Pagando de otra forma",
  "Magbabayad sa ibang paraan"
 ],
 "From": [
  "De",
  "Mula kay"
 ],
 "· Sent": [
  "· Enviada",
  "· Ipinadala"
 ],
 "· Due": [
  "· Vence",
  "· Takdang petsa"
 ],
 "· Paid": [
  "· Pagada",
  "· Bayad na"
 ],
 "Payment due — send it directly to": [
  "Pago pendiente: envíalo directamente a",
  "May kailangang bayaran — direktang ipadala kay"
 ],
 "Waiting for your coach to confirm the payment arrived.": [
  "Esperando que tu instructor confirme la recepción.",
  "Hinihintay ang kumpirmasyon ng coach na natanggap ang bayad."
 ],
 "Reference material": [
  "Material de referencia",
  "Mga sanggunian"
 ],
 "My coach policies": [
  "Políticas de mis instructores",
  "Mga patakaran ng coach"
 ],
 "These are the policies you signed with each of your SplashPad coaches. If you ever need to check cancellation rules, sick-day guidance, or weather policy, they live here.": [
  "Aquí están las políticas que firmaste con cada instructor, incluidas cancelaciones, enfermedades y clima.",
  "Narito ang mga patakarang pinirmahan mo sa bawat coach, kabilang ang pagkansela, pagkakasakit at panahon."
 ],
 "No signed policies yet": [
  "Aún no hay políticas firmadas",
  "Wala pang pinirmahang patakaran"
 ],
 "As soon as you sign your first waiver with a SplashPad coach, that coach's cancellation and sick/injury policies will appear here.": [
  "Al firmar tu primera exención aparecerán aquí las políticas de cancelación, enfermedad y lesión del instructor.",
  "Pagkapirma ng unang waiver, lalabas dito ang patakaran sa pagkansela, sakit at pinsala ng coach."
 ],
 "Go to my enrollments": [
  "Ir a mis inscripciones",
  "Pumunta sa aking mga pagpapatala"
 ],
 "Signed by:": [
  "Firmado por:",
  "Pinirmahan ni:"
 ],
 "Download signed waiver": [
  "Descargar exención firmada",
  "I-download ang pinirmahang waiver"
 ],
 "Weather policy": [
  "Política por clima",
  "Patakaran sa panahon"
 ],
 "Sick / medical policy": [
  "Política de enfermedad / salud",
  "Patakaran sa sakit / kalusugan"
 ],
 "This coach hasn't written custom policies. Contact them directly for cancellation rules.": [
  "Este instructor no ha escrito políticas propias. Contáctalo para consultar las cancelaciones.",
  "Wala pang sariling patakaran ang coach. Kontakin siya tungkol sa pagkansela."
 ],
 "Profile updated.": [
  "Perfil actualizado.",
  "Na-update ang profile."
 ],
 "Enter a valid email.": [
  "Introduce un correo válido.",
  "Maglagay ng wastong email."
 ],
 "That's already your email on file.": [
  "Ese ya es tu correo guardado.",
  "Iyan na ang iyong naka-save na email."
 ],
 "Email updated. Check your new inbox for confirmation.": [
  "Correo actualizado. Revisa tu nueva bandeja para confirmar.",
  "Na-update ang email. Tingnan ang bagong inbox para sa kumpirmasyon."
 ],
 "Current password didn't match. Try again.": [
  "Contraseña actual incorrecta. Inténtalo otra vez.",
  "Mali ang kasalukuyang password. Subukan muli."
 ],
 "That email already belongs to another SplashPad account.": [
  "Ese correo ya pertenece a otra cuenta de SplashPad.",
  "Ginagamit na ng ibang SplashPad account ang email na iyan."
 ],
 "Email on file": [
  "Correo guardado",
  "Naka-save na email"
 ],
 "This is where SplashPad sends class confirmations, invoices, and updates from your coach.": [
  "Aquí llegan confirmaciones, facturas y novedades de tu instructor.",
  "Dito ipinapadala ang kumpirmasyon, invoice at balita mula sa coach."
 ],
 "Change email": [
  "Cambiar correo",
  "Baguhin ang email"
 ],
 "Add, remove, or update your saved cards": [
  "Añade, elimina o actualiza tarjetas",
  "Magdagdag, mag-alis o mag-update ng card"
 ],
 "Manage the cards your coach can charge for lessons and packages.": [
  "Gestiona las tarjetas que puede cobrar tu instructor.",
  "Pamahalaan ang mga card na maaaring singilin ng coach."
 ],
 "Contact details": [
  "Datos de contacto",
  "Mga detalye sa pagkontak"
 ],
 "Emergency contact name": [
  "Nombre del contacto de emergencia",
  "Pangalan ng emergency contact"
 ],
 "Emergency contact phone": [
  "Teléfono de emergencia",
  "Telepono ng emergency contact"
 ],
 "Change your email": [
  "Cambiar tu correo",
  "Baguhin ang iyong email"
 ],
 "Your login + every SplashPad notification will be sent to your new email starting immediately. You'll get a confirmation at both your old and new addresses.": [
  "El acceso y las notificaciones usarán tu nuevo correo inmediatamente. Recibirás confirmación en ambas direcciones.",
  "Agad gagamitin ang bagong email sa pag-login at abiso. Darating ang kumpirmasyon sa luma at bagong email."
 ],
 "Current": [
  "Actual",
  "Kasalukuyan"
 ],
 "We require your password to keep your account safe.": [
  "Pedimos tu contraseña para proteger tu cuenta.",
  "Kailangan ang password para protektahan ang account."
 ],
 "You'll need to use the new email to log in next time. Old links in old emails will still work.": [
  "Usa el nuevo correo en tu próximo acceso. Los enlaces en correos anteriores seguirán funcionando.",
  "Gamitin ang bagong email sa susunod na pag-login. Gagana pa rin ang mga link sa lumang email."
 ],
 "Update email": [
  "Actualizar correo",
  "I-update ang email"
 ],
 "Swimmer progress": [
  "Progreso del nadador",
  "Pag-unlad ng manlalangoy"
 ],
 "Updates reviewed and published by your coach. Private drafts are never shown here.": [
  "Actualizaciones revisadas y publicadas por tu instructor. No se muestran borradores privados.",
  "Mga update na sinuri at inilathala ng coach. Hindi ipinapakita ang pribadong draft."
 ],
 "Retry": [
  "Reintentar",
  "Subukan muli"
 ],
 "Your swimmer’s story is still being written": [
  "La historia de tu nadador sigue escribiéndose",
  "Isinusulat pa ang kuwento ng iyong manlalangoy"
 ],
 "When your coach publishes an update, you’ll find skills, observations, and the next goal here.": [
  "Cuando tu instructor publique una actualización, verás habilidades, observaciones y el próximo objetivo.",
  "Kapag nag-publish ang coach, makikita rito ang kasanayan, obserbasyon at susunod na layunin."
 ],
 "View my lessons": [
  "Ver mis clases",
  "Tingnan ang aking mga aralin"
 ],
 "Coach reviewed": [
  "Revisado por el instructor",
  "Sinuri ng coach"
 ],
 "Observed": [
  "Observado",
  "Naobserbahan"
 ],
 "Practicing": [
  "Practicando",
  "Nagsasanay"
 ],
 "Next goal": [
  "Próximo objetivo",
  "Susunod na layunin"
 ],
 "Open print view": [
  "Abrir vista de impresión",
  "Buksan ang print view"
 ],
 "Published": [
  "Publicado",
  "Nailathala"
 ],
 ". Observations are not a guarantee of water safety or readiness to swim without supervision.": [
  ". Las observaciones no garantizan seguridad ni preparación para nadar sin supervisión.",
  ". Hindi garantiya ang obserbasyon ng kaligtasan o kahandaang lumangoy nang walang bantay."
 ],
 "Time TBD": [
  "Hora por confirmar",
  "Wala pang takdang oras"
 ],
 "Add to Google": [
  "Añadir a Google",
  "Idagdag sa Google"
 ],
 "Reason:": [
  "Motivo:",
  "Dahilan:"
 ],
 "Calendar file downloaded. Open it to add to Apple/Google/Outlook Calendar.": [
  "Calendario descargado. Ábrelo para añadirlo a Apple, Google u Outlook.",
  "Na-download ang calendar. Buksan para idagdag sa Apple, Google o Outlook."
 ],
 "Could not download calendar file.": [
  "No se pudo descargar el calendario.",
  "Hindi ma-download ang calendar."
 ],
 "Lesson cancelled. Your coach has been notified.": [
  "Clase cancelada. Se notificó al instructor.",
  "Nakansela ang aralin. Naabisuhan ang coach."
 ],
 "Lesson cancelled. (Coach notification email may be delayed.)": [
  "Clase cancelada. El correo al instructor puede tardar.",
  "Nakansela ang aralin. Maaaring maantala ang email sa coach."
 ],
 "Everything in one place": [
  "Todo en un solo lugar",
  "Lahat sa iisang lugar"
 ],
 "My schedule": [
  "Mi horario",
  "Aking iskedyul"
 ],
 "All lesson times are shown in your coach's time zone — the zone the classes are scheduled in.": [
  "Los horarios se muestran en la zona horaria del instructor, donde se programan las clases.",
  "Nasa time zone ng coach ang lahat ng oras — kung saan naka-iskedyul ang klase."
 ],
 "Times in each coach's time zone": [
  "Horarios en la zona de cada instructor",
  "Oras sa time zone ng bawat coach"
 ],
 "One-time file. Use “Add to my calendar” for a calendar that updates itself.": [
  "Archivo de una sola vez. Usa «Añadir a mi calendario» para actualizaciones automáticas.",
  "Isang download lang. Gamitin ang Idagdag sa calendar ko para awtomatikong ma-update."
 ],
 "Download once (.ics)": [
  "Descargar una vez (.ics)",
  "I-download minsan (.ics)"
 ],
 "View policies": [
  "Ver políticas",
  "Tingnan ang mga patakaran"
 ],
 "Loading your schedule…": [
  "Cargando horario…",
  "Nilo-load ang iskedyul…"
 ],
 "No lessons scheduled yet": [
  "Aún no hay clases programadas",
  "Wala pang naka-iskedyul na aralin"
 ],
 "Once your coach schedules a lesson, it'll show up here.": [
  "Las clases aparecerán aquí cuando tu instructor las programe.",
  "Lalabas dito ang aralin kapag na-iskedyul ng coach."
 ],
 "View my enrollments": [
  "Ver mis inscripciones",
  "Tingnan ang aking pagpapatala"
 ],
 "Agenda": [
  "Agenda",
  "Agenda"
 ],
 "Month": [
  "Mes",
  "Buwan"
 ],
 "No upcoming lessons in the next 90 days.": [
  "No hay clases en los próximos 90 días.",
  "Walang aralin sa susunod na 90 araw."
 ],
 "Days with lessons are highlighted in blue.": [
  "Los días con clases están resaltados en azul.",
  "Naka-highlight sa asul ang araw na may aralin."
 ],
 "Pick a day": [
  "Elige un día",
  "Pumili ng araw"
 ],
 "No lessons on this day.": [
  "No hay clases este día.",
  "Walang aralin sa araw na ito."
 ],
 "Cancel this lesson?": [
  "¿Cancelar esta clase?",
  "Kanselahin ang araling ito?"
 ],
 "Please check your policies": [
  "Revisa tus políticas",
  "Suriin ang mga patakaran"
 ],
 "View full policies": [
  "Ver políticas completas",
  "Tingnan ang buong patakaran"
 ],
 "Reason": [
  "Motivo",
  "Dahilan"
 ],
 "Please explain": [
  "Explica el motivo",
  "Ipaliwanag ang dahilan"
 ],
 "Anything else the coach should know? (optional)": [
  "¿Algo más que deba saber el instructor? (opcional)",
  "May iba pang dapat malaman ang coach? (opsyonal)"
 ],
 "Tell your coach why you're cancelling…": [
  "Explica por qué cancelas…",
  "Sabihin kung bakit ka magkakansela…"
 ],
 "e.g. she still has a low-grade fever": [
  "P. ej., aún tiene fiebre baja",
  "Hal. may kaunting lagnat pa siya"
 ],
 "Your coach will receive an email with your reason. Refunds (if any) are handled separately by your coach.": [
  "Tu instructor recibirá el motivo por correo. Los reembolsos se gestionan por separado con él.",
  "Darating sa email ng coach ang dahilan. Hiwalay na inaasikaso niya ang refund kung mayroon."
 ],
 "Keep the lesson": [
  "Mantener la clase",
  "Panatilihin ang aralin"
 ],
 "Cancel this lesson": [
  "Cancelar esta clase",
  "Kanselahin ang aralin"
 ],
 "Page unavailable": [
  "Página no disponible",
  "Hindi available ang pahina"
 ],
 "Back home": [
  "Volver al inicio",
  "Bumalik sa home"
 ],
 "❄️ Off-season": [
  "Fuera de temporada",
  "Labas ng season"
 ],
 "⏸ Temporarily unavailable": [
  "Temporalmente no disponible",
  "Pansamantalang hindi available"
 ],
 "⏸ Taking a short break": [
  "Tomando un descanso",
  "Sandaling nagpapahinga"
 ],
 "New bookings are paused for the moment. Please check back soon or contact the coach directly.": [
  "Las reservas están pausadas. Vuelve pronto o contacta al instructor.",
  "Naka-pause ang booking. Bumalik muli o direktang kontakin ang coach."
 ],
 "Returning parent? Log in": [
  "¿Ya eres cliente? Inicia sesión",
  "Bumabalik na magulang? Mag-login"
 ],
 "Find another coach": [
  "Buscar otro instructor",
  "Maghanap ng ibang coach"
 ],
 "Powered by SplashPad · Superhero Swim University": [
  "Desarrollado por SplashPad · Superhero Swim University",
  "Pinapagana ng SplashPad · Superhero Swim University"
 ],
 "Preview only — parents see this Class Finder inside their private portal after their application is approved. It never shows on your public page.": [
  "Solo vista previa. Este buscador aparece en el portal privado tras aprobar la solicitud, nunca en la página pública.",
  "Preview lang. Nasa pribadong portal ang class finder matapos maaprubahan, hindi sa pampublikong pahina."
 ],
 "Preview mode": [
  "Modo de vista previa",
  "Preview mode"
 ],
 "— this is exactly how parents will see your website. Apply and Book buttons are disabled here.": [
  "— así verán las familias tu web. Los botones de solicitud y reserva están desactivados.",
  "— ganito makikita ng magulang ang website. Hindi aktibo ang apply at book na mga button."
 ],
 "— this is exactly how parents will see your page. Apply and Book buttons are disabled here.": [
  "— así verán las familias tu página. Los botones de solicitud y reserva están desactivados.",
  "— ganito makikita ng magulang ang pahina. Hindi aktibo ang apply at book na mga button."
 ],
 "Log in to your parent account": [
  "Acceder a tu cuenta de familia",
  "Mag-login sa account ng magulang"
 ],
 "Log in": [
  "Iniciar sesión",
  "Mag-login"
 ],
 "SplashPad Verified Coach": [
  "Instructor verificado por SplashPad",
  "Beripikadong coach ng SplashPad"
 ],
 "+ yrs experience": [
  "+ años de experiencia",
  "+ taong karanasan"
 ],
 "Lesson packages": [
  "Paquetes de clases",
  "Mga pakete ng aralin"
 ],
 "Pick a package and we’ll guide you through the rest.": [
  "Elige un paquete y te guiaremos en lo demás.",
  "Pumili ng pakete at gagabayan ka namin sa iba pa."
 ],
 "No packages are currently available.": [
  "No hay paquetes disponibles actualmente.",
  "Walang available na pakete sa ngayon."
 ],
 "Most Popular": [
  "Más popular",
  "Pinakapopular"
 ],
 "Subscription · auto-renews": [
  "Suscripción · renovación automática",
  "Subscription · awtomatikong renewal"
 ],
 "Flexible schedule — coach sets times with you": [
  "Horario flexible; acuerda con tu instructor",
  "Flexible na iskedyul — inaayos ng coach kasama mo"
 ],
 "Available class times": [
  "Horarios disponibles",
  "Mga available na oras ng klase"
 ],
 "Class schedule": [
  "Horario de clases",
  "Iskedyul ng klase"
 ],
 "Ongoing": [
  "En curso",
  "Nagpapatuloy"
 ],
 "You'll pick your class time next.": [
  "Elegirás el horario a continuación.",
  "Susunod mong pipiliin ang oras ng klase."
 ],
 "Coach will invoice": [
  "El instructor facturará",
  "Magpapadala ng invoice ang coach"
 ],
 "Pay securely": [
  "Pagar de forma segura",
  "Ligtas na magbayad"
 ],
 "Application under review": [
  "Solicitud en revisión",
  "Sinusuri ang aplikasyon"
 ],
 "Apply Now": [
  "Solicitar ahora",
  "Mag-apply ngayon"
 ],
 "How it works": [
  "Cómo funciona",
  "Paano ito gumagana"
 ],
 "What parents say": [
  "Opiniones de las familias",
  "Sinasabi ng mga magulang"
 ],
 "Parent of": [
  "Familiar de",
  "Magulang ni"
 ],
 "Frequently asked questions": [
  "Preguntas frecuentes",
  "Mga karaniwang tanong"
 ],
 "Powered by SplashPad · SSA MEDIA LLC": [
  "Desarrollado por SplashPad · SSA MEDIA LLC",
  "Pinapagana ng SplashPad · SSA MEDIA LLC"
 ],
 "Privacy": [
  "Privacidad",
  "Privacy"
 ],
 "Terms": [
  "Condiciones",
  "Mga tuntunin"
 ],
 "✦ Apply for pricing": [
  "Solicita para conocer precios",
  "Mag-apply para sa presyo"
 ],
 "Prefer to chat?": [
  "¿Prefieres conversar?",
  "Mas gustong makipag-usap?"
 ],
 "In the water": [
  "En el agua",
  "Sa tubig"
 ],
 "A glimpse into our lessons.": [
  "Un vistazo a nuestras clases.",
  "Sulyap sa aming mga aralin."
 ],
 "Watch us in action": [
  "Míranos en acción",
  "Panoorin kami"
 ],
 "What parents are saying": [
  "Lo que dicen las familias",
  "Sinasabi ng mga magulang"
 ],
 "Ready to dive in?": [
  "¿Listos para nadar?",
  "Handa nang lumangoy?"
 ],
 "Sign up in under a minute — instant approval, no waiting for review.": [
  "Inscríbete en menos de un minuto: aprobación inmediata, sin espera.",
  "Magparehistro nang wala pang isang minuto — aprubado agad, walang paghihintay."
 ],
 "Apply now — your coach will review your application and get back to you within 24-48 hours.": [
  "Solicita ahora; el instructor responderá en 24–48 horas.",
  "Mag-apply ngayon — sasagot ang coach sa loob ng 24–48 oras."
 ],
 "See us on Google": [
  "Encuéntranos en Google",
  "Hanapin kami sa Google"
 ],
 "Verified business": [
  "Negocio verificado",
  "Beripikadong negosyo"
 ],
 "5-star rated": [
  "Valorado con 5 estrellas",
  "May 5-star na rating"
 ],
 "Read what parents are saying on Google — independent reviews from real families.": [
  "Lee opiniones independientes de familias reales en Google.",
  "Basahin ang malayang review ng mga tunay na pamilya sa Google."
 ],
 "Read reviews on Google": [
  "Leer reseñas en Google",
  "Basahin ang review sa Google"
 ],
 "Email and password required": [
  "Correo y contraseña obligatorios",
  "Kailangan ang email at password"
 ],
 "Password must be at least 10 characters": [
  "La contraseña debe tener al menos 10 caracteres",
  "Dapat may hindi bababa sa 10 character ang password"
 ],
 "Password must include at least one letter and one number.": [
  "Incluye al menos una letra y un número.",
  "Magsama ng kahit isang letra at isang numero."
 ],
 "Please review and accept the Terms of Service and Privacy Policy to continue.": [
  "Revisa y acepta los Términos y la Política de privacidad.",
  "Suriin at tanggapin ang Mga tuntunin at Privacy Policy."
 ],
 "Please enter your first name.": [
  "Introduce tu nombre.",
  "Ilagay ang pangalan mo."
 ],
 "Please enter your last name.": [
  "Introduce tu apellido.",
  "Ilagay ang apelyido mo."
 ],
 "Please enter your phone number — the coach uses this to reach you.": [
  "Introduce tu teléfono para que el instructor te contacte.",
  "Ilagay ang telepono para makontak ka ng coach."
 ],
 "Please enter a valid mobile phone number (at least 10 digits).": [
  "Introduce un móvil válido (al menos 10 dígitos).",
  "Ilagay ang wastong mobile number (hindi bababa sa 10 digit)."
 ],
 "Please enter your street address.": [
  "Introduce tu dirección.",
  "Ilagay ang iyong address."
 ],
 "Please enter your city.": [
  "Introduce tu ciudad.",
  "Ilagay ang iyong lungsod."
 ],
 "Please enter your state (2-letter code, e.g. CA).": [
  "Introduce el código de estado de dos letras (p. ej., CA).",
  "Ilagay ang 2-letrang code ng estado (hal. CA)."
 ],
 "Please enter your ZIP code.": [
  "Introduce tu código postal.",
  "Ilagay ang ZIP code."
 ],
 "Please pick at least one child from your account or add a new one.": [
  "Elige al menos un hijo de tu cuenta o añade uno.",
  "Pumili ng kahit isang bata sa account o magdagdag."
 ],
 "Each student needs a name and date of birth": [
  "Cada alumno necesita nombre y fecha de nacimiento",
  "Kailangan ng pangalan at petsa ng kapanganakan ang bawat mag-aaral"
 ],
 "Please confirm you are the parent/legal guardian of the listed children.": [
  "Confirma que eres el padre o tutor legal de los niños.",
  "Kumpirmahing ikaw ang magulang o legal guardian ng mga bata."
 ],
 "Please pick the location you’d like to attend.": [
  "Elige la ubicación a la que asistirás.",
  "Piliin ang lokasyong pupuntahan."
 ],
 "Please pick whether you’d like fixed-location or mobile lessons.": [
  "Elige clases en ubicación fija o a domicilio.",
  "Piliin kung fixed-location o mobile ang aralin."
 ],
 "Pick a package": [
  "Elige un paquete",
  "Pumili ng pakete"
 ],
 "Pick a class time to continue.": [
  "Elige un horario para continuar.",
  "Pumili ng oras ng klase para magpatuloy."
 ],
 "That class just filled up. Pick another time.": [
  "Esa clase se llenó. Elige otro horario.",
  "Napuno na ang klase. Pumili ng ibang oras."
 ],
 "Pick a date and time for the lesson to continue.": [
  "Elige fecha y hora para continuar.",
  "Pumili ng petsa at oras para magpatuloy."
 ],
 "That date/time is invalid — try picking it from the calendar again.": [
  "Fecha u hora inválida; elígela otra vez en el calendario.",
  "Hindi wastong petsa o oras — pumili muli sa calendar."
 ],
 "Lesson time is in the past. Pick a future date and time.": [
  "Ese horario ya pasó. Elige una fecha futura.",
  "Lumipas na ang oras. Pumili ng darating na petsa."
 ],
 "Please agree to the Liability Waiver and Cancellation Policy to continue": [
  "Acepta la exención y la política de cancelación para continuar.",
  "Tanggapin ang waiver at patakaran sa pagkansela para magpatuloy."
 ],
 "Type your full name to sign": [
  "Escribe tu nombre completo para firmar",
  "Isulat ang buong pangalan para pumirma"
 ],
 "Please complete payment before continuing.": [
  "Completa el pago antes de continuar.",
  "Kumpletuhin ang bayad bago magpatuloy."
 ],
 "Please save your card to continue.": [
  "Guarda tu tarjeta para continuar.",
  "I-save ang card para magpatuloy."
 ],
 "Please fill in your email and password before submitting.": [
  "Completa tu correo y contraseña antes de enviar.",
  "Ilagay ang email at password bago isumite."
 ],
 "Sorry, that class just filled up while you were finishing. Please pick another time.": [
  "La clase se llenó mientras terminabas. Elige otro horario.",
  "Napuno ang klase habang tinatapos mo. Pumili ng ibang oras."
 ],
 "Looks like your sign-in expired. Please fill in your email and password to finish your application.": [
  "Tu sesión caducó. Introduce correo y contraseña para terminar.",
  "Nag-expire ang pag-login. Ilagay ang email at password para matapos."
 ],
 "You already have a SplashPad account — log in to apply with this coach.": [
  "Ya tienes una cuenta SplashPad; inicia sesión para solicitar.",
  "May SplashPad account ka na — mag-login para mag-apply."
 ],
 "Log in to an existing SplashPad account": [
  "Acceder a una cuenta existente",
  "Mag-login sa kasalukuyang account"
 ],
 "Already a SplashPad parent?": [
  "¿Ya eres familia SplashPad?",
  "May SplashPad account ka na?"
 ],
 "No need to re-apply — log in and you're good to go.": [
  "No necesitas volver a solicitar; inicia sesión.",
  "Hindi kailangang mag-apply muli — mag-login lang."
 ],
 "Log in to your existing account": [
  "Acceder a tu cuenta existente",
  "Mag-login sa account mo"
 ],
 "Signed in as": [
  "Sesión iniciada como",
  "Naka-login bilang"
 ],
 ". Your application will be tied to this account.": [
  ". La solicitud se vinculará a esta cuenta.",
  ". Maiuugnay sa account na ito ang aplikasyon."
 ],
 "Not you? Log in with a different account": [
  "¿No eres tú? Accede con otra cuenta",
  "Hindi ikaw? Mag-login sa ibang account"
 ],
 "You're already approved with": [
  "Ya estás aprobado con",
  "Aprubado ka na kay"
 ],
 "No need to reapply — head straight to the booking page to pick a class": [
  "No necesitas solicitar otra vez; ve a reservas para elegir una clase",
  "Hindi kailangang mag-apply muli — pumunta sa booking para pumili ng klase"
 ],
 "and complete payment": [
  "y completar el pago",
  "at kumpletuhin ang bayad"
 ],
 "Go to Booking": [
  "Ir a reservas",
  "Pumunta sa booking"
 ],
 "My Enrollments": [
  "Mis inscripciones",
  "Aking mga pagpapatala"
 ],
 "Need to add another swimmer to your account? Head to": [
  "¿Otro nadador en tu cuenta? Ve a",
  "Magdaragdag ng manlalangoy? Pumunta sa"
 ],
 "your profile": [
  "tu perfil",
  "iyong profile"
 ],
 "instead.": [
  "en su lugar.",
  "sa halip."
 ],
 "Your application is under review": [
  "Tu solicitud está en revisión",
  "Sinusuri ang aplikasyon mo"
 ],
 "has your application and will get back to you shortly. We'll email you the moment a decision is made — you don't need to reapply.": [
  "tiene tu solicitud y responderá pronto. Te avisaremos por correo; no necesitas solicitar de nuevo.",
  "ay may aplikasyon mo at sasagot agad. Mag-eemail kami kapag may desisyon; huwag mag-apply muli."
 ],
 "Back to my dashboard": [
  "Volver a mi panel",
  "Bumalik sa aking dashboard"
 ],
 "Create your account": [
  "Crea tu cuenta",
  "Gumawa ng account"
 ],
 "We use this to save your info, send confirmations, and store your waiver.": [
  "Guardaremos tus datos y exención y enviaremos confirmaciones.",
  "Ise-save ang impormasyon at waiver mo at magpapadala ng kumpirmasyon."
 ],
 "Already have a SplashPad account from another coach?": [
  "¿Ya tienes cuenta de SplashPad con otro instructor?",
  "May SplashPad account ka na mula sa ibang coach?"
 ],
 "and you can apply with just a couple of taps — one login works for every coach on SplashPad.": [
  "y solicita fácilmente: una cuenta sirve para todos los instructores.",
  "at madaling mag-apply — iisang account para sa lahat ng coach sa SplashPad."
 ],
 "Password": [
  "Contraseña",
  "Password"
 ],
 "If you already have an account, enter your existing password.": [
  "Si ya tienes cuenta, usa tu contraseña actual.",
  "Kung may account ka na, gamitin ang kasalukuyang password."
 ],
 "I have read and agree to SplashPad's": [
  "He leído y acepto de SplashPad la",
  "Nabasa at tinatanggap ko ang SplashPad"
 ],
 "Privacy Policy": [
  "Política de privacidad",
  "Privacy Policy"
 ],
 "Terms of Service": [
  "Términos de servicio",
  "Mga tuntunin ng serbisyo"
 ],
 "Guardian information": [
  "Datos del tutor",
  "Impormasyon ng guardian"
 ],
 "Tell us about yourself and where you live so the coach can decide if they can take on your family.": [
  "Cuéntanos sobre ti y dónde vives para que el instructor evalúe si puede recibir a tu familia.",
  "Sabihin ang tungkol sa iyo at tirahan para masuri ng coach kung matatanggap ang pamilya mo."
 ],
 "Tell us a little about yourself so the coach can reach you.": [
  "Cuéntanos sobre ti para que el instructor pueda contactarte.",
  "Sabihin ang tungkol sa iyo para makontak ka ng coach."
 ],
 "Optional — you can reply": [
  "Opcional; puedes responder",
  "Opsyonal — maaari kang sumagot ng"
 ],
 "to any text to opt out at any time. See": [
  "a cualquier mensaje para dejar de recibirlos. Consulta",
  "para huminto sa mga text anumang oras. Tingnan ang"
 ],
 "SMS Terms": [
  "Términos de SMS",
  "Mga tuntunin ng SMS"
 ],
 "Home address": [
  "Dirección de casa",
  "Address ng tahanan"
 ],
 "·required": [
  "· obligatorio",
  "· kailangan"
 ],
 "Your coach uses this to confirm they can travel to your area or that the location works for you.": [
  "El instructor confirma si puede viajar a tu zona o si la ubicación te conviene.",
  "Ginagamit ng coach para tiyaking mapupuntahan ang lugar mo o angkop ang lokasyon sa iyo."
 ],
 "Street address": [
  "Dirección",
  "Address"
 ],
 "City": [
  "Ciudad",
  "Lungsod"
 ],
 "State": [
  "Estado",
  "Estado"
 ],
 "ZIP": [
  "Código postal",
  "ZIP code"
 ],
 "How did you hear about": [
  "¿Cómo conociste a",
  "Paano mo nakilala si"
 ],
 "Friend, Google, Instagram…": [
  "Amigo, Google, Instagram…",
  "Kaibigan, Google, Instagram…"
 ],
 "Pick which of your kids will be attending, or add a new one.": [
  "Elige qué hijos asistirán o añade uno nuevo.",
  "Piliin ang mga batang dadalo o magdagdag ng bago."
 ],
 "Add the children who will be attending lessons.": [
  "Añade los niños que asistirán a clases.",
  "Idagdag ang mga batang dadalo sa aralin."
 ],
 "Your children": [
  "Tus hijos",
  "Iyong mga anak"
 ],
 "Tap to include them in this application. You can still edit medical or swim-level details below.": [
  "Pulsa para incluirlos. Puedes editar datos médicos y nivel abajo.",
  "Pindutin para isama. Maaari mong baguhin ang medikal na tala at antas sa ibaba."
 ],
 "On your account": [
  "En tu cuenta",
  "Nasa iyong account"
 ],
 "Student": [
  "Alumno",
  "Mag-aaral"
 ],
 "From your account": [
  "De tu cuenta",
  "Mula sa account mo"
 ],
 "Don't include this child": [
  "No incluir a este niño",
  "Huwag isama ang batang ito"
 ],
 "Remove this student": [
  "Eliminar este alumno",
  "Alisin ang mag-aaral na ito"
 ],
 "Gender (optional)": [
  "Género (opcional)",
  "Kasarian (opsyonal)"
 ],
 "Choose…": [
  "Elige…",
  "Pumili…"
 ],
 "Male": [
  "Masculino",
  "Lalaki"
 ],
 "Female": [
  "Femenino",
  "Babae"
 ],
 "Other": [
  "Otro",
  "Iba pa"
 ],
 "Non-swimmer": [
  "No sabe nadar",
  "Hindi marunong lumangoy"
 ],
 "Can float / kick": [
  "Puede flotar / patear",
  "Marunong lumutang / sumipa"
 ],
 "Knows basic strokes": [
  "Conoce estilos básicos",
  "Alam ang mga pangunahing stroke"
 ],
 "Competitive swimmer": [
  "Nadador competitivo",
  "Lumalahok sa kompetisyon"
 ],
 "Medical/special needs (optional)": [
  "Necesidades médicas / especiales (opcional)",
  "Medikal / espesyal na pangangailangan (opsyonal)"
 ],
 "I authorize the coach to seek emergency medical treatment for my child if needed.": [
  "Autorizo al instructor a buscar atención médica de emergencia para mi hijo si es necesario.",
  "Pinapahintulutan ko ang coach na humingi ng emergency na medikal na pangangalaga para sa aking anak kung kailangan."
 ],
 "Tick a child above to include them, or add a brand-new student below.": [
  "Selecciona un niño arriba o añade uno nuevo abajo.",
  "Pumili ng bata sa itaas o magdagdag ng bago sa ibaba."
 ],
 "No students yet. Add one to continue.": [
  "Aún no hay alumnos. Añade uno para continuar.",
  "Wala pang mag-aaral. Magdagdag para magpatuloy."
 ],
 "Add a new student": [
  "Añadir nuevo alumno",
  "Magdagdag ng bagong mag-aaral"
 ],
 "Add another student": [
  "Añadir otro alumno",
  "Magdagdag ng isa pang mag-aaral"
 ],
 "Parent / guardian consent.": [
  "Consentimiento del padre / tutor.",
  "Pahintulot ng magulang / guardian."
 ],
 "I am the parent or legal guardian of the child(ren) listed above and consent to SplashPad processing their information for swim lesson delivery (waivers, scheduling, attendance, and communications with my coach).": [
  "Soy padre o tutor legal de los menores indicados y autorizo a SplashPad a tratar sus datos para las clases de natación (exenciones, horarios, asistencia y comunicaciones con mi instructor).",
  "Ako ang magulang o legal guardian ng mga batang nakalista at pumapayag akong iproseso ng SplashPad ang kanilang impormasyon para sa aralin sa paglangoy (waiver, iskedyul, attendance at komunikasyon sa coach)."
 ],
 "Where would you like lessons?": [
  "¿Dónde quieres las clases?",
  "Saan mo gusto ang mga aralin?"
 ],
 "Your coach offers both fixed-pool lessons and mobile (they come to you). Pick the option that works best.": [
  "Tu instructor ofrece piscina fija o a domicilio. Elige lo que te convenga.",
  "Nag-aalok ang coach ng fixed-pool at mobile na aralin. Piliin ang angkop sa iyo."
 ],
 "Your coach teaches at multiple locations. Pick the one you'd like to attend.": [
  "Tu instructor enseña en varias ubicaciones. Elige una.",
  "Nagtuturo ang coach sa iba't ibang lokasyon. Pumili ng pupuntahan."
 ],
 "Pick a location": [
  "Elige una ubicación",
  "Pumili ng lokasyon"
 ],
 "You can change this from your parent dashboard later if your schedule shifts.": [
  "Puedes cambiarlo después desde tu panel si cambia tu horario.",
  "Maaari itong baguhin sa dashboard kung magbago ang iskedyul."
 ],
 "Pick the package that’s right for your child.": [
  "Elige el paquete adecuado para tu hijo.",
  "Piliin ang paketeng angkop sa bata."
 ],
 "Popular": [
  "Popular",
  "Popular"
 ],
 "Flexible schedule — your coach sets lesson times with you": [
  "Horario flexible; tu instructor lo acuerda contigo",
  "Flexible na iskedyul — inaayos ng coach kasama mo"
 ],
 "Pick a preferred slot": [
  "Elige un horario preferido",
  "Piliin ang gustong oras"
 ],
 "Choose a time that works for your first lesson. Your remaining lessons will be scheduled with your coach.": [
  "Elige la primera clase. Las demás se programarán con tu instructor.",
  "Piliin ang oras ng unang aralin. Kasama ang coach sa pag-iskedyul ng natitira."
 ],
 "Preferred date & time": [
  "Fecha y hora preferidas",
  "Gustong petsa at oras"
 ],
 "If your coach hasn’t set availability yet, they’ll reach out to confirm.": [
  "Si aún no hay disponibilidad, tu instructor te contactará para confirmar.",
  "Kung wala pang takdang bakanteng oras, kokontakin ka ng coach para kumpirmahin."
 ],
 "Pick your class time": [
  "Elige tu horario de clase",
  "Piliin ang oras ng klase"
 ],
 "runs at set times. Pick the one that works for your family — your coach can move you later if your schedule changes.": [
  "tiene horarios fijos. Elige uno; tu instructor puede cambiarte después si es necesario.",
  "ay may takdang oras. Pumili ng angkop — maaaring ilipat ng coach kung magbago ang iskedyul."
 ],
 "Open": [
  "Abierto",
  "Bukas"
 ],
 "Pick a class time to continue. You can change it later from your dashboard.": [
  "Elige un horario para continuar. Puedes cambiarlo desde tu panel después.",
  "Pumili ng oras para magpatuloy. Maaari itong baguhin sa dashboard sa susunod."
 ],
 "Pick your lesson date & time": [
  "Elige fecha y hora de tu clase",
  "Piliin ang petsa at oras ng aralin"
 ],
 "is a single private lesson. Pick the date and time that works for you — your coach will see this on their schedule the moment you check out.": [
  "es una clase particular. Elige fecha y hora; aparecerá en el horario del instructor al pagar.",
  "ay pribadong aralin. Piliin ang petsa at oras — makikita ito ng coach sa iskedyul kapag nag-checkout."
 ],
 "Lesson date & time": [
  "Fecha y hora de la clase",
  "Petsa at oras ng aralin"
 ],
 "Times are in your coach's local time zone": [
  "Horarios en la zona horaria del instructor",
  "Mga oras sa time zone ng coach"
 ],
 ". Need a different time after you check out? Message your coach — they can reschedule in one click.": [
  ". Si necesitas cambiarlo después, escribe al instructor.",
  ". Kung kailangan ng ibang oras pagkatapos mag-checkout, mag-message sa coach."
 ],
 "Waiver & cancellation policy": [
  "Exención y política de cancelación",
  "Waiver at patakaran sa pagkansela"
 ],
 "Agree to your coach's waiver and cancellation policy, then type your name to sign.": [
  "Acepta los documentos del instructor y escribe tu nombre para firmar.",
  "Tanggapin ang waiver at patakaran ng coach at isulat ang pangalan para pumirma."
 ],
 "This is the standard participation waiver you'd sign at any swim school — it's between you and": [
  "Es la exención habitual de una escuela de natación, entre tú y",
  "Ito ang karaniwang waiver sa paaralan ng paglangoy — sa pagitan mo at ni"
 ],
 ", and you'll get a PDF copy for your records. Tap either document to read it in full.": [
  ". Recibirás una copia PDF. Pulsa cada documento para leerlo completo.",
  ". Makakatanggap ka ng PDF. Pindutin ang dokumento para basahin nang buo."
 ],
 "Your signature covers both documents": [
  "Tu firma cubre ambos documentos",
  "Sakop ng pirma ang dalawang dokumento"
 ],
 "Type your full legal name to sign": [
  "Escribe tu nombre legal completo",
  "Isulat ang buong legal na pangalan"
 ],
 "One last step": [
  "Un último paso",
  "Isang huling hakbang"
 ],
 "requires a fee with new applications. Your card is saved securely now — nothing is charged until you're approved.": [
  "requiere una cuota de solicitud. Guardaremos tu tarjeta; no se cobrará hasta aprobarte.",
  "ay may bayad sa aplikasyon. Ligtas na ise-save ang card — walang singil hanggang maaprubahan."
 ],
 "Got it — you’ll pay the fee directly. Your coach will confirm once it arrives.": [
  "Pagarás directamente. Tu instructor confirmará cuando llegue.",
  "Direkta kang magbabayad. Kukumpirmahin ng coach kapag natanggap."
 ],
 "Card saved": [
  "Tarjeta guardada",
  "Na-save ang card"
 ],
 "You'll only be charged when your application is approved. Tap Submit application to finish.": [
  "Solo se cobrará al aprobar la solicitud. Pulsa Enviar solicitud para terminar.",
  "Sisingilin lang kapag aprubado ang aplikasyon. Pindutin ang Isumite ang aplikasyon para matapos."
 ],
 "Payment": [
  "Pago",
  "Bayad"
 ],
 "Review & payment": [
  "Revisión y pago",
  "Pagsusuri at bayad"
 ],
 "Your card is charged securely by Stripe. We never see your card number.": [
  "Stripe cobra de forma segura. Nunca vemos tu número de tarjeta.",
  "Ligtas na sinisingil ng Stripe ang card. Hindi namin nakikita ang numero nito."
 ],
 "Please review your selection. Payment instructions will appear after you confirm.": [
  "Revisa tu selección. Verás instrucciones de pago tras confirmar.",
  "Suriin ang napili. Lalabas ang tagubilin sa bayad matapos kumpirmahin."
 ],
 "Got it — you’ll pay your coach directly. Your spot stays pending until they confirm.": [
  "Pagarás directamente al instructor. Tu plaza queda pendiente hasta que confirme.",
  "Direkta kang magbabayad sa coach. Nakabinbin ang puwesto hanggang kumpirmahin niya."
 ],
 "Payment received": [
  "Pago recibido",
  "Natanggap ang bayad"
 ],
 "Your card is on file. Tap Continue to finish enrollment.": [
  "Tu tarjeta está guardada. Pulsa Continuar para terminar.",
  "Naka-save ang card. Pindutin ang Magpatuloy para matapos."
 ],
 "· billed every": [
  "· facturado cada",
  "· sinisingil bawat"
 ],
 "will contact you within 24 hours with payment details.": [
  "te contactará en 24 horas con los datos de pago.",
  "ay kokontak sa iyo sa loob ng 24 oras para sa detalye ng bayad."
 ],
 "You’ll complete payment with the coach’s preferred provider after confirmation.": [
  "Pagarás con el proveedor del instructor tras confirmar.",
  "Magbabayad ka sa gustong provider ng coach matapos kumpirmahin."
 ],
 "Submitting your application…": [
  "Enviando solicitud…",
  "Isinusumite ang aplikasyon…"
 ],
 "Go back & fix": [
  "Volver y corregir",
  "Bumalik at ayusin"
 ],
 "Try submitting again": [
  "Reintentar envío",
  "Subukang isumite muli"
 ],
 "You're all set — pick a class next! 🏊": [
  "¡Listo! Elige una clase",
  "Handa na! Pumili ng klase"
 ],
 "Application submitted! 🏊": [
  "¡Solicitud enviada!",
  "Naisumite ang aplikasyon!"
 ],
 "Thanks for signing up with": [
  "Gracias por inscribirte con",
  "Salamat sa pagparehistro kay"
 ],
 ". You're approved instantly — no waiting. Pick a package to book your first class.": [
  ". Aprobación inmediata; elige un paquete para reservar tu primera clase.",
  ". Aprubado ka agad — pumili ng pakete para sa unang klase."
 ],
 "Thanks for applying with": [
  "Gracias por solicitar con",
  "Salamat sa pag-apply kay"
 ],
 ". We've sent your information to your coach for review.": [
  ". Enviamos tus datos al instructor para revisión.",
  ". Ipinadala ang impormasyon mo sa coach para suriin."
 ],
 "What happens next": [
  "Qué sucede después",
  "Ano ang susunod"
 ],
 "Head back to your coach's page and pick the class or package you want.": [
  "Vuelve a la página del instructor y elige una clase o paquete.",
  "Bumalik sa pahina ng coach at pumili ng klase o pakete."
 ],
 "Complete payment (secured by Stripe) — you're enrolled the moment it clears.": [
  "Completa el pago por Stripe; quedarás inscrito al confirmarse.",
  "Kumpletuhin ang bayad sa Stripe — nakatala ka na kapag pumasok ito."
 ],
 "You'll get a confirmation email with lesson details.": [
  "Recibirás un correo con los detalles de la clase.",
  "Makakatanggap ka ng email na may detalye ng aralin."
 ],
 "Your coach reviews your application (usually within 24-48 hours)": [
  "El instructor revisa tu solicitud, normalmente en 24–48 horas",
  "Susuriin ng coach ang aplikasyon, karaniwang sa loob ng 24–48 oras"
 ],
 "They may call or text you to schedule an assessment": [
  "Puede llamarte o escribirte para programar una evaluación",
  "Maaaring tumawag o mag-text para sa pagtatasa"
 ],
 "Once approved, you'll get an email and can purchase lesson packages from your account": [
  "Al aprobarte recibirás un correo y podrás comprar paquetes desde tu cuenta",
  "Kapag aprubado, may email ka at maaari nang bumili ng pakete sa account"
 ],
 "We've also sent you a confirmation email at": [
  "También enviamos confirmación a",
  "Nagpadala rin kami ng kumpirmasyon sa"
 ],
 "Don't forget your registration fee": [
  "No olvides la cuota de inscripción",
  "Huwag kalimutan ang registration fee"
 ],
 "You chose to pay": [
  "Elegiste pagar a",
  "Pinili mong bayaran si"
 ],
 "directly. It stays pending until they confirm the payment arrived.": [
  "directamente. Queda pendiente hasta confirmar que llegó.",
  "nang direkta. Nakabinbin hanggang kumpirmahin na dumating."
 ],
 "Pick a class": [
  "Elige una clase",
  "Pumili ng klase"
 ],
 "Go to my account": [
  "Ir a mi cuenta",
  "Pumunta sa account ko"
 ],
 "Back to coach's page": [
  "Volver a la página del instructor",
  "Bumalik sa pahina ng coach"
 ],
 "You're registered!": [
  "¡Estás registrado!",
  "Nakarehistro ka na!"
 ],
 "Welcome to": [
  "Bienvenido a",
  "Maligayang pagdating sa"
 ],
 "Your coach will schedule with you": [
  "Tu instructor acordará el horario contigo",
  "Iaayos ng coach ang iskedyul kasama mo"
 ],
 "This package doesn't have fixed lesson times —": [
  "Este paquete no tiene horarios fijos:",
  "Walang takdang oras ang paketeng ito —"
 ],
 "will reach out to set your lesson days and times, if they haven't already. You can track your remaining lessons any time from your parent dashboard.": [
  "te contactará para acordarlos, si aún no lo hizo. Consulta tus clases restantes desde tu panel.",
  "ay kokontak para ayusin ang araw at oras kung hindi pa nagagawa. Makikita ang natitirang aralin sa dashboard."
 ],
 "One more step — send your payment": [
  "Un paso más: envía tu pago",
  "Isa pang hakbang — ipadala ang bayad"
 ],
 "directly. Your spot stays": [
  "directamente. Tu plaza queda",
  "nang direkta. Ang puwesto ay mananatiling"
 ],
 "until they confirm your payment arrived — you'll get a confirmation the moment they do.": [
  "hasta que confirme tu pago; recibirás confirmación al hacerlo.",
  "hanggang kumpirmahin ang bayad — makakatanggap ka agad ng kumpirmasyon."
 ],
 "You're all set — invoice on the way": [
  "Listo: la factura está en camino",
  "Handa na — darating ang invoice"
 ],
 "Your spot is reserved.": [
  "Tu plaza está reservada.",
  "Nakareserba ang puwesto mo."
 ],
 "will send you an invoice — you can pay any time from your Payments tab.": [
  "te enviará una factura; puedes pagar desde Pagos.",
  "ay magpapadala ng invoice — bayaran sa Mga bayad."
 ],
 "Pay now (optional)": [
  "Pagar ahora (opcional)",
  "Magbayad ngayon (opsyonal)"
 ],
 "Complete your payment": [
  "Completa tu pago",
  "Kumpletuhin ang bayad"
 ],
 "Pay using the coach's preferred provider.": [
  "Paga con el proveedor del instructor.",
  "Magbayad gamit ang gustong provider ng coach."
 ],
 "Complete Payment": [
  "Completar pago",
  "Kumpletuhin ang bayad"
 ],
 "Thanks! The coach will confirm shortly.": [
  "¡Gracias! El instructor confirmará pronto.",
  "Salamat! Kukumpirmahin agad ng coach."
 ],
 "Could not record. Please try again.": [
  "No se pudo registrar. Inténtalo otra vez.",
  "Hindi maitala. Subukan muli."
 ],
 "I've completed payment": [
  "Ya completé el pago",
  "Nakumpleto ko na ang bayad"
 ],
 "Confirm registration": [
  "Confirmar inscripción",
  "Kumpirmahin ang pagpapatala"
 ],
 "Submit application": [
  "Enviar solicitud",
  "Isumite ang aplikasyon"
 ],
 "Password must be at least 8 characters.": [
  "La contraseña debe tener al menos 8 caracteres.",
  "Dapat may hindi bababa sa 8 character ang password."
 ],
 "Please accept the Terms & Privacy Policy.": [
  "Acepta los Términos y la Política de privacidad.",
  "Tanggapin ang Mga tuntunin at Privacy Policy."
 ],
 "Enter your first and last name.": [
  "Introduce nombre y apellido.",
  "Ilagay ang pangalan at apelyido."
 ],
 "Enter a valid mobile phone number (10+ digits).": [
  "Introduce un móvil válido (10 dígitos o más).",
  "Ilagay ang wastong mobile number (10 o higit pang digit)."
 ],
 "Type your full name to sign the waiver.": [
  "Escribe tu nombre completo para firmar la exención.",
  "Isulat ang buong pangalan para pumirma sa waiver."
 ],
 "Please agree to the Liability Waiver and Cancellation Policy.": [
  "Acepta la exención y la política de cancelación.",
  "Tanggapin ang waiver at patakaran sa pagkansela."
 ],
 "Preview mode — payment is disabled here.": [
  "Vista previa: el pago está desactivado.",
  "Preview — hindi aktibo ang pagbabayad."
 ],
 "Your cart is empty": [
  "Tu carrito está vacío",
  "Walang laman ang cart"
 ],
 "Head back to the class finder to pick your classes.": [
  "Vuelve al buscador para elegir clases.",
  "Bumalik sa class finder para pumili ng klase."
 ],
 "Find classes": [
  "Buscar clases",
  "Maghanap ng klase"
 ],
 "You're all set! 🎉": [
  "¡Todo listo!",
  "Handa na ang lahat!"
 ],
 "One checkout,": [
  "Un solo pago,",
  "Isang checkout,"
 ],
 "enrollment": [
  "inscripción",
  "pagpapatala"
 ],
 "/mo from": [
  "/mes desde",
  "/buwan mula"
 ],
 "· first month prorated": [
  "· primer mes prorrateado",
  "· inayos ayon sa araw ang unang buwan"
 ],
 "Go to my parent dashboard": [
  "Ir a mi panel de familia",
  "Pumunta sa dashboard ng magulang"
 ],
 "— payment is disabled.": [
  "— el pago está desactivado.",
  "— hindi aktibo ang pagbabayad."
 ],
 "· Checkout": [
  "· Pago",
  "· Checkout"
 ],
 "Back to classes": [
  "Volver a clases",
  "Bumalik sa mga klase"
 ],
 "Create your parent account": [
  "Crea tu cuenta de familia",
  "Gumawa ng account ng magulang"
 ],
 "You'll use this to manage lessons, payments, and schedules.": [
  "Gestiona aquí clases, pagos y horarios.",
  "Pamahalaan dito ang aralin, bayad at iskedyul."
 ],
 "At least 8 characters": [
  "Al menos 8 caracteres",
  "Hindi bababa sa 8 character"
 ],
 "I agree to SplashPad's": [
  "Acepto de SplashPad los",
  "Tinatanggap ko ang SplashPad"
 ],
 "Already have an account?": [
  "¿Ya tienes cuenta?",
  "May account ka na?"
 ],
 "— your cart is saved.": [
  "— tu carrito está guardado.",
  "— naka-save ang cart mo."
 ],
 "Parent / guardian info": [
  "Datos del padre / tutor",
  "Impormasyon ng magulang / guardian"
 ],
 "Mobile phone": [
  "Teléfono móvil",
  "Mobile phone"
 ],
 "Your swimmers": [
  "Tus nadadores",
  "Iyong mga manlalangoy"
 ],
 "Complete the details for each swimmer in your cart.": [
  "Completa los datos de cada nadador en el carrito.",
  "Kumpletuhin ang detalye ng bawat manlalangoy sa cart."
 ],
 "Birthdate": [
  "Fecha de nacimiento",
  "Petsa ng kapanganakan"
 ],
 "Medical notes": [
  "Notas médicas",
  "Mga medikal na tala"
 ],
 "Allergies, conditions…": [
  "Alergias, condiciones…",
  "Mga allergy, kondisyon…"
 ],
 "I confirm I am the parent/legal guardian of the child(ren) listed and consent to SplashPad processing their information for swim lesson delivery.": [
  "Confirmo ser padre o tutor legal de los menores y consiento el tratamiento de sus datos por SplashPad para las clases de natación.",
  "Kinukumpirma kong ako ang magulang o legal guardian ng mga bata at pumapayag na iproseso ng SplashPad ang impormasyon nila para sa aralin sa paglangoy."
 ],
 "Liability waiver & policies": [
  "Exención y políticas",
  "Waiver at mga patakaran"
 ],
 "Tap a document to read it, agree, then type your name to sign.": [
  "Lee cada documento, acepta y escribe tu nombre para firmar.",
  "Basahin ang dokumento, tanggapin at isulat ang pangalan para pumirma."
 ],
 "Your full legal name": [
  "Tu nombre legal completo",
  "Buong legal na pangalan"
 ],
 "Creating your account & setting up one checkout…": [
  "Creando tu cuenta y preparando el pago…",
  "Ginagawa ang account at inihahanda ang checkout…"
 ],
 "Checkout hit a snag": [
  "Hubo un problema con el pago",
  "Nagkaproblema sa checkout"
 ],
 "Order summary": [
  "Resumen del pedido",
  "Buod ng order"
 ],
 "/mo": [
  "/mes",
  "/buwan"
 ],
 "Due today": [
  "A pagar hoy",
  "Babayaran ngayon"
 ],
 "Includes prorated first month": [
  "Incluye primer mes prorrateado",
  "Kasama ang inayos na bayad sa unang buwan"
 ],
 "Then monthly": [
  "Luego mensualmente",
  "Pagkatapos ay buwanan"
 ],
 "One-time classes": [
  "Clases de pago único",
  "Mga klaseng isahang bayad"
 ],
 "Memberships": [
  "Membresías",
  "Mga membership"
 ],
 "First month prorated — exact total shown at payment.": [
  "Primer mes prorrateado; total exacto al pagar.",
  "Inayos ang unang buwan — eksaktong kabuuan sa pagbabayad."
 ],
 "Secured by Stripe · one card entry for everything": [
  "Protegido por Stripe · una tarjeta para todo",
  "Ligtas sa Stripe · isang card para sa lahat"
 ],
 "One checkout — everything in your cart": [
  "Un pago para todo tu carrito",
  "Isang checkout para sa buong cart"
 ],
 "One-time charge today.": [
  "Cobro único hoy.",
  "Isahang bayad ngayon."
 ],
 "By paying, you authorize": [
  "Al pagar autorizas a",
  "Sa pagbabayad, pinapahintulutan mo si"
 ],
 "to save this card and charge it for the items in your cart — including prorated first-month and recurring monthly membership charges — and future lessons or packages. Manage saved cards anytime from your parent portal.": [
  "a guardar esta tarjeta y cobrar los artículos del carrito, incluidos el primer mes prorrateado, cuotas mensuales recurrentes y futuras clases o paquetes. Gestiona las tarjetas desde tu portal.",
  "na i-save ang card at singilin ang nasa cart — kabilang ang inayos na unang buwan, paulit-ulit na buwanang bayad, at susunod na aralin o pakete. Pamahalaan ang card sa portal."
 ],
 "Enrolling your swimmers…": [
  "Inscribiendo nadadores…",
  "Ipinapatala ang mga manlalangoy…"
 ],
 "Processing…": [
  "Procesando…",
  "Pinoproseso…"
 ],
 "Save card & enroll": [
  "Guardar tarjeta e inscribir",
  "I-save ang card at magpatala"
 ],
 "Secured by Stripe. SplashPad takes a small platform fee — your coach receives the rest on their next payout.": [
  "Protegido por Stripe. SplashPad cobra una pequeña comisión; el instructor recibe el resto en su próximo pago.",
  "Ligtas sa Stripe. May maliit na platform fee ang SplashPad — natatanggap ng coach ang natitira sa susunod na payout."
 ],
 "Hi, I’m Splash.": [
  "Hola, soy Splash.",
  "Kumusta, ako si Splash."
 ],
 "Tell me how you teach and I’ll build a starting setup you can review—nothing goes live.": [
  "Cuéntame cómo enseñas y prepararé una configuración para revisar; nada se publica.",
  "Sabihin kung paano ka nagtuturo at gagawa ako ng setup na susuriin mo — walang ia-activate."
 ],
 "Choose a number from": [
  "Elige un número de",
  "Pumili ng numero mula"
 ],
 "to": [
  "a",
  "hanggang"
 ],
 "For example, 200": [
  "Por ejemplo, 200",
  "Halimbawa, 200"
 ],
 "We’ll label this as needing a price—not as a free offering. It stays a draft.": [
  "Quedará marcado como pendiente de precio, no gratuito. Sigue siendo borrador.",
  "Mamarkahang kailangan ng presyo, hindi libre. Mananatiling draft."
 ],
 "You entered $0. This draft will be a free offering if you later activate it.": [
  "Introdujiste $0. Será gratuito si lo activas después.",
  "Naglagay ka ng $0. Magiging libre ito kung ia-activate mo sa susunod."
 ],
 "Choose your timezone": [
  "Elige tu zona horaria",
  "Piliin ang time zone"
 ],
 "Search a city or timezone…": [
  "Buscar ciudad o zona horaria…",
  "Maghanap ng lungsod o time zone…"
 ],
 "No matching timezone.": [
  "No hay coincidencias.",
  "Walang katugmang time zone."
 ],
 "Your existing schedule timezone is protected. Change it separately in Settings if needed.": [
  "Tu zona horaria actual está protegida. Cámbiala en Configuración si lo necesitas.",
  "Protektado ang kasalukuyang time zone. Baguhin ito sa Mga setting kung kailangan."
 ],
 "Use this device’s timezone:": [
  "Usar la zona horaria del dispositivo:",
  "Gamitin ang time zone ng device:"
 ],
 "You already have a setup. Matching offerings are kept as-is—nothing is reset, overwritten, or duplicated.": [
  "Ya tienes una configuración. Las ofertas coincidentes se mantienen sin cambios, reinicios ni duplicados.",
  "May setup ka na. Pananatilihin ang magkatugmang alok — walang ire-reset, papalitan o dodoblehin."
 ],
 "Manage offerings": [
  "Gestionar ofertas",
  "Pamahalaan ang mga alok"
 ],
 "For example, Blue Water Swim": [
  "Por ejemplo, Blue Water Swim",
  "Halimbawa, Blue Water Swim"
 ],
 "Your own name is fine too.": [
  "También puedes usar tu propio nombre.",
  "Maaari ring gamitin ang sarili mong pangalan."
 ],
 "Your saved business profile won’t be overwritten by this guide.": [
  "La guía no sobrescribirá tu perfil guardado.",
  "Hindi papalitan ng gabay ang na-save mong profile."
 ],
 "No public page will be published by this step.": [
  "Este paso no publicará ninguna página.",
  "Walang pahinang ipa-publish sa hakbang na ito."
 ],
 "Changing this plan never deletes an existing saved location.": [
  "Cambiar este plan no elimina ubicaciones guardadas.",
  "Hindi mabubura ang na-save na lokasyon kapag binago ang planong ito."
 ],
 "Use a saved location?": [
  "¿Usar una ubicación guardada?",
  "Gumamit ng na-save na lokasyon?"
 ],
 "Add a different location": [
  "Añadir otra ubicación",
  "Magdagdag ng ibang lokasyon"
 ],
 "For example, Community Pool": [
  "Por ejemplo, piscina comunitaria",
  "Halimbawa, Community Pool"
 ],
 "Street and city": [
  "Calle y ciudad",
  "Kalye at lungsod"
 ],
 "We’ll reuse this location without changing it. Edit its details later in Locations.": [
  "Reutilizaremos esta ubicación sin cambiarla. Edítala después en Ubicaciones.",
  "Gagamitin ang lokasyon nang hindi binabago. Baguhin sa Mga lokasyon sa susunod."
 ],
 "Monthly memberships use recurring classes. Review your payment choice before publishing—we won’t change it for you.": [
  "Las membresías mensuales usan clases recurrentes. Revisa tu elección antes de publicar; no la cambiaremos por ti.",
  "Gumagamit ang buwanang membership ng paulit-ulit na klase. Suriin ang piniling bayad bago i-publish — hindi namin ito babaguhin para sa iyo."
 ],
 "Camp starts": [
  "Inicio del campamento",
  "Simula ng camp"
 ],
 "First teaching date": [
  "Primera fecha de clase",
  "Unang petsa ng pagtuturo"
 ],
 "Camp ends": [
  "Fin del campamento",
  "Tapos ng camp"
 ],
 "Last date (optional)": [
  "Última fecha (opcional)",
  "Huling petsa (opsyonal)"
 ],
 "Teaching days": [
  "Días de clase",
  "Mga araw ng pagtuturo"
 ],
 "Teaching weekdays": [
  "Días de enseñanza",
  "Mga araw ng pagtuturo"
 ],
 "Start time": [
  "Hora de inicio",
  "Oras ng pagsisimula"
 ],
 "In": [
  "En",
  "Sa"
 ],
 "Leave the dates and times for later": [
  "Dejar fechas y horarios para después",
  "Itakda na lang ang petsa at oras sa susunod"
 ],
 "Preparing your draft review": [
  "Preparando revisión de borradores",
  "Inihahanda ang pagsusuri ng draft"
 ],
 "Refresh review": [
  "Actualizar revisión",
  "I-refresh ang pagsusuri"
 ],
 "new draft": [
  "borradores nuevos",
  "bagong draft"
 ],
 "existing kept": [
  "existentes conservados",
  "kasalukuyang pinanatili"
 ],
 "Timezone:": [
  "Zona horaria:",
  "Time zone:"
 ],
 "Lessons at families’ pools": [
  "Clases en piscinas de familias",
  "Mga aralin sa pool ng pamilya"
 ],
 "Existing · unchanged": [
  "Existente · sin cambios",
  "Kasalukuyan · hindi binago"
 ],
 "Draft · not live": [
  "Borrador · no publicado",
  "Draft · hindi aktibo"
 ],
 "/ month": [
  "/ mes",
  "/ buwan"
 ],
 "swimmer": [
  "nadador",
  "manlalangoy"
 ],
 "View current offering": [
  "Ver oferta actual",
  "Tingnan ang kasalukuyang alok"
 ],
 "Change these answers": [
  "Cambiar estas respuestas",
  "Baguhin ang mga sagot na ito"
 ],
 "Open Splash": [
  "Abrir Splash",
  "Buksan ang Splash"
 ],
 "Opening Splash doesn’t send a question or use a chat allowance. You can also continue and try it later.": [
  "Abrir Splash no envía una pregunta ni consume tu cuota. Puedes continuar y probarlo después.",
  "Hindi nagpapadala ng tanong o gumagamit ng chat allowance ang pagbukas ng Splash. Maaari kang magpatuloy at subukan sa susunod."
 ],
 "drafts saved ·": [
  "borradores guardados ·",
  "mga draft na na-save ·"
 ],
 "No family was enrolled, notified, or charged. New offerings stay inactive and private.": [
  "Ninguna familia fue inscrita, notificada ni cobrada. Las ofertas nuevas siguen inactivas y privadas.",
  "Walang pamilyang ipinatala, inabisuhan o siningil. Mananatiling hindi aktibo at pribado ang bagong alok."
 ],
 "Ask Splash for help with your next step": [
  "Pide ayuda a Splash para el próximo paso",
  "Humingi ng tulong kay Splash para sa susunod na hakbang"
 ],
 "Page views (last 30 days)": [
  "Visitas (últimos 30 días)",
  "Mga pagbisita (nakaraang 30 araw)"
 ],
 "all-time": [
  "histórico",
  "sa lahat ng panahon"
 ],
 "last view": [
  "última visita",
  "huling pagbisita"
 ],
 "Revenue this month": [
  "Ingresos de este mes",
  "Kita ngayong buwan"
 ],
 "Paid through Stripe this calendar month": [
  "Pagado mediante Stripe este mes natural",
  "Nabayaran sa Stripe ngayong buwan"
 ],
 "— no card revenue yet": [
  "— aún sin ingresos de tarjeta",
  "— wala pang kita mula sa card"
 ],
 "Outstanding payments": [
  "Pagos pendientes",
  "Mga hindi pa nababayaran"
 ],
 "family hasn’t paid yet": [
  "familia aún no ha pagado",
  "pamilya ang hindi pa nagbabayad"
 ],
 "families haven’t paid yet": [
  "familias aún no han pagado",
  "pamilya ang hindi pa nagbabayad"
 ],
 "click to see who": [
  "pulsa para ver quién",
  "pindutin para makita kung sino"
 ],
 "All caught up — no unpaid invoices": [
  "Todo al día; sin facturas pendientes",
  "Kumpleto na — walang hindi bayad na invoice"
 ],
 "1 family waiting for your approval": [
  "1 familia espera tu aprobación",
  "1 pamilya ang naghihintay ng pag-apruba"
 ],
 "Inbox clear — no one waiting": [
  "Bandeja vacía; nadie espera",
  "Walang naghihintay"
 ],
 "Revenue history": [
  "Historial de ingresos",
  "Kasaysayan ng kita"
 ],
 "Successful card charges only. Refunds subtracted. Year-by-year side by side so you can see momentum.": [
  "Solo cobros de tarjeta completados, menos reembolsos. Compara los años para ver tu evolución.",
  "Mga matagumpay na bayad sa card lang, bawas ang refund. Ihambing ang mga taon para makita ang pag-unlad."
 ],
 "Lifetime": [
  "Total histórico",
  "Kabuuan sa lahat ng panahon"
 ],
 "Avg / mo": [
  "Promedio / mes",
  "Karaniwan / buwan"
 ],
 "Best month": [
  "Mejor mes",
  "Pinakamagandang buwan"
 ],
 "All locations": [
  "Todas las ubicaciones",
  "Lahat ng lokasyon"
 ],
 "No card revenue yet — the chart will populate the moment your first parent pays. Keep going!": [
  "Aún no hay ingresos de tarjeta. La gráfica se mostrará con el primer pago.",
  "Wala pang kita mula sa card. Lalabas ang tsart sa unang bayad."
 ],
 "vs": [
  "frente a",
  "kumpara sa"
 ],
 "last year": [
  "año anterior",
  "nakaraang taon"
 ],
 "Your registration link is not ready yet": [
  "Tu enlace de registro aún no está listo",
  "Hindi pa handa ang registration link"
 ],
 "Registration link copied": [
  "Enlace copiado",
  "Nakopya ang registration link"
 ],
 "Could not copy — long-press the link on your Marketing page instead": [
  "No se pudo copiar; mantén pulsado el enlace en Marketing",
  "Hindi makopya — pindutin nang matagal ang link sa Marketing"
 ],
 "Quick actions": [
  "Acciones rápidas",
  "Mabilisang aksyon"
 ],
 "No shortcuts yet — tap to pick the pages you use most.": [
  "Sin accesos directos; elige tus páginas más usadas.",
  "Wala pang shortcut — piliin ang mga pahinang madalas gamitin."
 ],
 "Your page link is not ready yet": [
  "Tu enlace de página aún no está listo",
  "Hindi pa handa ang link ng pahina"
 ],
 "Quick actions updated": [
  "Acciones rápidas actualizadas",
  "Na-update ang mabilisang aksyon"
 ],
 "Customize quick actions": [
  "Personalizar acciones rápidas",
  "I-customize ang mabilisang aksyon"
 ],
 "Pin the pages you use most. Up to": [
  "Fija tus páginas más usadas. Hasta",
  "I-pin ang madalas gamitin na pahina. Hanggang"
 ],
 ". Use the arrows to change the order.": [
  ". Usa las flechas para cambiar el orden.",
  ". Gamitin ang mga arrow para baguhin ang pagkakasunod."
 ],
 "Pinned ·": [
  "Fijados ·",
  "Naka-pin ·"
 ],
 "Nothing pinned. Tick a few below.": [
  "Nada fijado. Selecciona opciones abajo.",
  "Walang naka-pin. Pumili sa ibaba."
 ],
 "Available": [
  "Disponibles",
  "Available"
 ],
 "Reset to defaults": [
  "Restablecer valores iniciales",
  "Ibalik sa default"
 ],
 "Signup link copied — paste it anywhere families will see it!": [
  "Enlace copiado; compártelo con las familias.",
  "Nakopya ang link — ibahagi sa mga pamilya!"
 ],
 "Could not copy — long-press the link on your dashboard instead.": [
  "No se pudo copiar; mantén pulsado el enlace en tu panel.",
  "Hindi makopya — pindutin nang matagal ang link sa dashboard."
 ],
 "Hide the setup checklist": [
  "Ocultar lista de configuración",
  "Itago ang checklist ng setup"
 ],
 "Setup checklist": [
  "Lista de configuración",
  "Checklist ng setup"
 ],
 "A few quick steps to get paid and fill your lanes. Knock them out in any order.": [
  "Pasos para recibir pagos y llenar tus clases. Hazlos en cualquier orden.",
  "Mga hakbang para makabayad at mapuno ang klase. Gawin sa anumang pagkakasunod."
 ],
 "done ·": [
  "completados ·",
  "tapos ·"
 ],
 "Hide": [
  "Ocultar",
  "Itago"
 ],
 "Show": [
  "Mostrar",
  "Ipakita"
 ],
 "PRO · FREE": [
  "PRO · GRATIS",
  "PRO · LIBRE"
 ],
 "Nice — see you in the group!": [
  "¡Nos vemos en el grupo!",
  "Magkita tayo sa grupo!"
 ],
 "Couldn't mark that done. Try again.": [
  "No se pudo marcar como hecho. Inténtalo otra vez.",
  "Hindi mamarkahang tapos. Subukan muli."
 ],
 "Mark done": [
  "Marcar como hecho",
  "Markahang tapos"
 ],
 "Make it yours": [
  "Hazlo tuyo",
  "Gawing sarili mo"
 ],
 "Add": [
  "Añade",
  "Magdagdag ng"
 ],
 "and this whole dashboard re-themes to match": [
  "y el panel se adaptará a",
  "at ang dashboard ay babagay sa"
 ],
 "your swim school": [
  "tu escuela de natación",
  "iyong paaralan ng paglangoy"
 ],
 "— logo up top, your color on every button and highlight.": [
  "— tu logo arriba y tu color en botones y destacados.",
  "— logo sa itaas at kulay mo sa mga button at highlight."
 ],
 "Add logo & color": [
  "Añadir logo y color",
  "Magdagdag ng logo at kulay"
 ],
 "Dismiss": [
  "Descartar",
  "Isara"
 ],
 "Hide for today": [
  "Ocultar por hoy",
  "Itago muna ngayon"
 ],
 "Families who wait too long usually book somewhere else. A quick yes or no keeps them with you.": [
  "Las familias que esperan demasiado suelen reservar en otro lugar. Responde pronto para retenerlas.",
  "Kapag matagal ang hintay, sa iba nagbu-book ang pamilya. Mabilis na sagot ang tutulong para manatili sila."
 ],
 "Parents hear back the moment you decide — approve or decline in one tap.": [
  "Las familias reciben tu decisión al instante: aprueba o rechaza con un toque.",
  "Agad malalaman ng magulang ang desisyon — aprubahan o tanggihan sa isang pindot."
 ],
 "oldest waiting": [
  "mayor espera",
  "pinakamatagal na paghihintay"
 ],
 "Pay invoice": [
  "Pagar factura",
  "Bayaran ang invoice"
 ],
 "Your card details stay on Stripe's servers — SplashPad never sees the full number.": [
  "Los datos de tu tarjeta permanecen en Stripe; SplashPad nunca ve el número completo.",
  "Nasa Stripe ang detalye ng card — hindi nakikita ng SplashPad ang buong numero."
 ]
});
Object.assign(messages, {
 "Packages sold": [
  "Paquetes vendidos",
  "Mga nabentang pakete"
 ],
 "Pending waivers": [
  "Exenciones pendientes",
  "Mga nakabinbing waiver"
 ],
 "View students": [
  "Ver alumnos",
  "Tingnan ang mga mag-aaral"
 ],
 "Classes & packages": [
  "Clases y paquetes",
  "Mga klase at pakete"
 ],
 "Open waivers": [
  "Abrir exenciones",
  "Buksan ang mga waiver"
 ],
 "Next 7 days · open schedule": [
  "Próximos 7 días · abrir horario",
  "Susunod na 7 araw · buksan ang iskedyul"
 ],
 "Location": [
  "Ubicación",
  "Lokasyon"
 ],
 "Tell us about location {number}.": [
  "Cuéntanos sobre la ubicación {number}.",
  "Sabihin ang tungkol sa lokasyon {number}."
 ],
 "What do you teach at {location}?": [
  "¿Qué enseñas en {location}?",
  "Ano ang itinuturo mo sa {location}?"
 ],
 "How do families pay for {format}?": [
  "¿Cómo pagan las familias por {format}?",
  "Paano nagbabayad ang pamilya para sa {format}?"
 ],
 "How long is each session of {format}?": [
  "¿Cuánto dura cada sesión de {format}?",
  "Gaano katagal ang bawat sesyon ng {format}?"
 ],
 "How many swimmers join each session?": [
  "¿Cuántos nadadores participan en cada sesión?",
  "Ilang manlalangoy ang kasama sa bawat sesyon?"
 ],
 "How do you schedule {format}?": [
  "¿Cómo programas {format}?",
  "Paano mo iniiskedyul ang {format}?"
 ],
 "How many {format} are in a bundle?": [
  "¿Cuántas sesiones de {format} hay en un paquete?",
  "Ilang sesyon ng {format} ang nasa isang pakete?"
 ],
 "Do you know the regular times for {format}?": [
  "¿Conoces los horarios habituales de {format}?",
  "Alam mo na ba ang regular na oras ng {format}?"
 ],
 "What do you charge for all {count} lessons?": [
  "¿Cuánto cobras por las {count} clases?",
  "Magkano ang singil sa lahat ng {count} aralin?"
 ],
 "What is the monthly price for {format}?": [
  "¿Cuál es el precio mensual de {format}?",
  "Magkano ang buwanang presyo ng {format}?"
 ],
 "What do you charge for one session of {format}?": [
  "¿Cuánto cobras por una sesión de {format}?",
  "Magkano ang singil sa isang sesyon ng {format}?"
 ],
 "Create {count} drafts": [
  "Crear {count} borradores",
  "Gumawa ng {count} draft"
 ],
 "Which platform are you leaving?": [
  "¿Qué plataforma dejas?",
  "Anong platform ang iiwan mo?"
 ],
 "We’ll help you move your families, one simple step at a time.": [
  "Te ayudaremos a trasladar tus familias paso a paso.",
  "Tutulungan ka naming ilipat ang mga pamilya, isang hakbang bawat pagkakataon."
 ],
 "Bring your families with you.": [
  "Trae a tus familias contigo.",
  "Isama ang mga pamilya mo."
 ],
 "Review policies. Import quietly. Invite when you’re ready.": [
  "Revisa políticas. Importa sin notificaciones. Invita cuando estés listo.",
  "Suriin ang patakaran. Mag-import nang tahimik. Mag-imbita kapag handa na."
 ],
 "Count the pools or venues you use regularly. Traveling to families’ pools is separate.": [
  "Cuenta las piscinas o lugares habituales. Las clases a domicilio van aparte.",
  "Bilangin ang regular na pool o lugar. Hiwalay ang pagpunta sa pool ng pamilya."
 ],
 "A simple name is enough to start. The address can wait if you don’t have it handy.": [
  "Basta un nombre para empezar. Puedes añadir la dirección después.",
  "Sapat muna ang pangalan. Maaaring idagdag ang address sa susunod."
 ],
 "Choose the lesson types offered at this location—not necessarily everything you teach.": [
  "Elige los tipos de clase de esta ubicación, no todo lo que enseñas.",
  "Piliin ang mga uri ng aralin sa lokasyong ito, hindi lahat ng itinuturo mo."
 ],
 "What do you teach at families’ pools?": [
  "¿Qué enseñas en las piscinas de las familias?",
  "Ano ang itinuturo mo sa pool ng pamilya?"
 ],
 "This can be different from what you offer at your regular locations.": [
  "Puede ser distinto de tus ubicaciones habituales.",
  "Maaaring iba ito sa alok sa regular mong lokasyon."
 ],
 "Choose all that apply. Teaching every week does not have to mean monthly billing.": [
  "Elige todas las opciones aplicables. Enseñar cada semana no exige facturación mensual.",
  "Piliin ang lahat ng angkop. Hindi kailangang buwanan ang singil kahit lingguhan ang pagtuturo."
 ],
 "How many teaching days are in a typical camp?": [
  "¿Cuántos días de clase tiene un campamento típico?",
  "Ilang araw ng pagtuturo sa karaniwang camp?"
 ],
 "We’ll start with one camp offering. You’ll review its dates before it goes live.": [
  "Empezaremos con un campamento. Revisarás sus fechas antes de publicarlo.",
  "Magsisimula sa isang camp. Susuriin mo ang petsa bago ia-activate."
 ],
 "For example, a family might buy 4 lessons at once. You can add other bundle sizes later.": [
  "Por ejemplo, cuatro clases juntas. Puedes añadir otros paquetes después.",
  "Halimbawa, apat na aralin nang sabay. Maaari kang magdagdag ng ibang laki ng pakete sa susunod."
 ],
 "Enter the usual length in minutes.": [
  "Introduce la duración habitual en minutos.",
  "Ilagay ang karaniwang haba sa minuto."
 ],
 "This is the maximum number of swimmers together at the same time.": [
  "Es el máximo de nadadores juntos a la vez.",
  "Ito ang pinakamataas na bilang ng sabay-sabay na manlalangoy."
 ],
 "What do families pay for the whole camp?": [
  "¿Cuánto pagan por todo el campamento?",
  "Magkano ang bayad para sa buong camp?"
 ],
 "Enter the total bundle price, not the price of one lesson.": [
  "Introduce el precio del paquete completo, no de una clase.",
  "Ilagay ang kabuuang presyo ng pakete, hindi ng isang aralin."
 ],
 "Not decided yet? Leave this blank. We’ll keep it as a draft that needs a price.": [
  "¿Aún no lo decides? Déjalo vacío; seguirá como borrador pendiente de precio.",
  "Hindi pa napagpapasyahan? Iwanang blangko. Mananatiling draft na kailangan ng presyo."
 ],
 "This is separate from how families pay.": [
  "Es independiente de cómo pagan las familias.",
  "Hiwalay ito sa paraan ng pagbabayad."
 ],
 "Do you know the dates for your next camp?": [
  "¿Conoces las fechas del próximo campamento?",
  "Alam mo na ang petsa ng susunod na camp?"
 ],
 "Only add times you actually teach. You can leave this for later—we won’t invent a schedule.": [
  "Añade solo horarios reales. Puedes hacerlo después; no inventaremos horarios.",
  "Ilagay lang ang tunay na oras ng pagtuturo. Maaari sa susunod — hindi kami gagawa ng sariling iskedyul."
 ],
 "Welcome your families when ready.": [
  "Da la bienvenida cuando estés listo.",
  "Batiin ang mga pamilya kapag handa na."
 ],
 "Preview your email. Nothing sends until you approve it.": [
  "Revisa el correo. Nada se envía sin tu aprobación.",
  "I-preview ang email. Walang ipapadala hanggat hindi aprubado."
 ],
 "Choose your previous platform, or choose “Not moving software”.": [
  "Elige tu plataforma anterior o «No cambio de software».",
  "Piliin ang dating platform o “Hindi lumilipat ng software”."
 ],
 "Enter a business name to continue.": [
  "Introduce un nombre de negocio para continuar.",
  "Ilagay ang pangalan ng negosyo para magpatuloy."
 ],
 "Choose your schedule timezone.": [
  "Elige la zona horaria de tus clases.",
  "Piliin ang time zone ng iskedyul."
 ],
 "Choose at least one lesson type.": [
  "Elige al menos un tipo de clase.",
  "Pumili ng kahit isang uri ng aralin."
 ],
 "Give this location a name.": [
  "Pon un nombre a esta ubicación.",
  "Lagyan ng pangalan ang lokasyon."
 ],
 "Choose what you teach at this location.": [
  "Elige qué enseñas aquí.",
  "Piliin ang itinuturo mo sa lokasyong ito."
 ],
 "Choose what you teach at families’ pools.": [
  "Elige qué enseñas a domicilio.",
  "Piliin ang itinuturo sa pool ng pamilya."
 ],
 "Choose at least one way families pay.": [
  "Elige al menos una forma de pago.",
  "Pumili ng kahit isang paraan ng bayad."
 ],
 "Enter at least one lesson or day.": [
  "Introduce al menos una clase o día.",
  "Maglagay ng kahit isang aralin o araw."
 ],
 "Choose a duration from 5 to 720 minutes.": [
  "Elige entre 5 y 720 minutos.",
  "Pumili ng haba mula 5 hanggang 720 minuto."
 ],
 "Choose a group size from 1 to 100.": [
  "Elige entre 1 y 100 nadadores.",
  "Pumili ng bilang mula 1 hanggang 100."
 ],
 "The end date must be on or after the start date.": [
  "La fecha final no puede ser anterior al inicio.",
  "Hindi maaaring mas maaga ang huling petsa kaysa simula."
 ],
 "Choose a start date, weekday, and time—or use “Add this later”.": [
  "Elige fecha, día y hora, o añádelo después.",
  "Pumili ng petsa, araw at oras — o idagdag sa susunod."
 ],
 "Add both camp dates, or leave both for later.": [
  "Añade ambas fechas del campamento o deja ambas para después.",
  "Ilagay ang parehong petsa ng camp o iwanan pareho para sa susunod."
 ],
 "Add a price": [
  "Añadir un precio",
  "Magdagdag ng presyo"
 ],
 "Price to add later": [
  "Precio por añadir",
  "Presyo na itatakda pa"
 ],
 "Add your real teaching dates and times": [
  "Añadir fechas y horarios reales",
  "Idagdag ang tunay na petsa at oras"
 ],
 "Choose camp start and end dates": [
  "Elegir fechas de inicio y fin del campamento",
  "Piliin ang simula at huling petsa ng camp"
 ],
 "Review scheduling: monthly memberships use recurring class times": [
  "Revisar horarios: las membresías mensuales usan clases recurrentes",
  "Suriin ang iskedyul: may paulit-ulit na klase ang buwanang membership"
 ],
 "Set up available booking times in Schedule": [
  "Configurar horarios disponibles en Horario",
  "Itakda ang bakanteng oras sa Iskedyul"
 ],
 "Enable traveling lessons in Locations": [
  "Activar clases a domicilio en Ubicaciones",
  "I-enable ang pagpunta sa pamilya sa Mga lokasyon"
 ],
 "Families pay each month. SplashPad uses a class for recurring billing.": [
  "Las familias pagan cada mes. SplashPad usa una clase para cobros recurrentes.",
  "Buwanang nagbabayad ang pamilya. Gumagamit ang SplashPad ng klase para sa paulit-ulit na singil."
 ],
 "Families buy a set number of lessons. A weekly teaching time does not turn this into a subscription.": [
  "Las familias compran un número de clases. Un horario semanal no lo convierte en suscripción.",
  "Bumibili ang pamilya ng takdang bilang ng aralin. Hindi ito nagiging subscription kahit lingguhan ang klase."
 ],
 "Families pay for one lesson at a time.": [
  "Las familias pagan una clase a la vez.",
  "Nagbabayad ang pamilya ng isang aralin bawat pagkakataon."
 ],
 "Families pay once for this camp. Real camp dates must be added before it goes live.": [
  "Las familias pagan una vez por el campamento. Añade fechas reales antes de publicarlo.",
  "Isang beses magbabayad para sa camp. Ilagay ang tunay na petsa bago ia-activate."
 ],
 "Already exists: edit it in Classes & Pricing, not through this guide": [
  "Ya existe: edítalo en Clases y precios, no en esta guía",
  "Mayroon na: baguhin sa Mga klase at presyo, hindi sa gabay na ito"
 ],
 "Every new offering will be inactive. No family is enrolled, billed, or notified.": [
  "Cada oferta nueva estará inactiva. No se inscribe, cobra ni notifica a familias.",
  "Hindi aktibo ang bawat bagong alok. Walang pamilyang ipapatala, sisingilin o aabisuhan."
 ],
 "Your existing offerings, locations, business settings, and payment setup will stay unchanged. Most coaches only need this guide once.": [
  "Tus ofertas, ubicaciones, ajustes y pagos actuales no cambian. Normalmente solo necesitas esta guía una vez.",
  "Hindi mababago ang kasalukuyang alok, lokasyon, setting at bayad. Karaniwang isang beses lang kailangan ang gabay."
 ],
 "Your schedule timezone and business details will be saved. Your public page will remain unpublished.": [
  "Se guardarán tu zona horaria y datos. Tu página pública no se publicará.",
  "Ise-save ang time zone at detalye ng negosyo. Hindi ipa-publish ang pampublikong pahina."
 ],
 "Matching existing offerings are kept as-is, including their saved prices and availability. They are not overwritten or duplicated.": [
  "Las ofertas coincidentes mantienen precios y disponibilidad. No se sobrescriben ni duplican.",
  "Mananatili ang katugmang alok, presyo at bakanteng oras. Walang papalitan o dodoblehin."
 ],
 "Mon": [
  "Lun",
  "Lun"
 ],
 "Tue": [
  "Mar",
  "Mar"
 ],
 "Wed": [
  "Mié",
  "Miy"
 ],
 "Thu": [
  "Jue",
  "Huw"
 ],
 "Fri": [
  "Vie",
  "Biy"
 ],
 "Sat": [
  "Sáb",
  "Sab"
 ],
 "Sun": [
  "Dom",
  "Lin"
 ],
 "Move your families with a CSV": [
  "Traslada familias con un CSV",
  "Ilipat ang pamilya gamit ang CSV"
 ],
 "Keep families and swimmers together": [
  "Mantén familias y nadadores juntos",
  "Panatilihing magkasama ang pamilya at manlalangoy"
 ],
 "Another platform": [
  "Otra plataforma",
  "Ibang platform"
 ],
 "Use a template or match columns": [
  "Usa plantilla o relaciona columnas",
  "Gumamit ng template o itugma ang column"
 ],
 "Not moving software": [
  "No cambio de software",
  "Hindi lumilipat ng software"
 ],
 "Continue without importing": [
  "Continuar sin importar",
  "Magpatuloy nang hindi nag-iimport"
 ],
 "Yes, I’ve tried Splash": [
  "Sí, ya probé Splash",
  "Oo, nasubukan ko na ang Splash"
 ],
 "You can open it again any time": [
  "Puedes abrirlo cuando quieras",
  "Maaari itong buksan anumang oras"
 ],
 "Not yet": [
  "Todavía no",
  "Hindi pa"
 ],
 "You can try it whenever you’re ready": [
  "Pruébalo cuando estés listo",
  "Subukan kapag handa ka na"
 ],
 "Review your drafts": [
  "Revisar borradores",
  "Suriin ang mga draft"
 ],
 "Add prices and dates, then publish when ready.": [
  "Añade precios y fechas; publica cuando estés listo.",
  "Maglagay ng presyo at petsa, saka i-publish kapag handa na."
 ],
 "Check your locations": [
  "Revisar ubicaciones",
  "Suriin ang mga lokasyon"
 ],
 "Review pools and traveling-lesson settings.": [
  "Revisa piscinas y clases a domicilio.",
  "Suriin ang pool at setting ng pagpunta sa pamilya."
 ],
 "Business & payment details": [
  "Datos del negocio y pagos",
  "Detalye ng negosyo at bayad"
 ],
 "Settings, payouts, and your public page.": [
  "Configuración, cobros y página pública.",
  "Mga setting, payout at pampublikong pahina."
 ],
 "Could not load dashboard.": [
  "No se pudo cargar el panel.",
  "Hindi ma-load ang dashboard."
 ]
});
Object.assign(messages, {
 "Apply Now": [
  "Solicitar ahora",
  "Mag-apply ngayon"
 ],
 "Step {current} of {total}": [
  "Paso {current} de {total}",
  "Hakbang {current} ng {total}"
 ],
 "Your lessons": [
  "Tus clases",
  "Iyong mga aralin"
 ],
 "left to book": [
  "por reservar",
  "puwede pang i-book"
 ],
 "Next:": [
  "Próxima:",
  "Susunod:"
 ],
 "Nothing booked yet": [
  "Aún no hay reservas",
  "Wala pang naka-book"
 ],
 " — pick a time below.": [
  " — elige un horario abajo.",
  " — pumili ng oras sa ibaba."
 ],
 "Book another lesson": [
  "Reservar otra clase",
  "Mag-book ng isa pang aralin"
 ],
 "Book a lesson": [
  "Reservar una clase",
  "Mag-book ng aralin"
 ],
 "schedules your lessons —": [
  "programa tus clases —",
  "ang nag-iiskedyul ng aralin —"
 ],
 "text or call": [
  "escribe o llama",
  "mag-text o tumawag"
 ],
 "reach out": [
  "contacta",
  "makipag-ugnayan"
 ],
 "to book.": [
  "para reservar.",
  "para mag-book."
 ],
 "Change": [
  "Cambiar",
  "Baguhin"
 ],
 "Cancel or move this lesson": [
  "Cancelar o cambiar esta clase",
  "Kanselahin o ilipat ang aralin"
 ],
 "Contact your coach to change": [
  "Contacta al instructor para cambiar",
  "Kontakin ang coach para baguhin"
 ],
 "Show fewer": [
  "Mostrar menos",
  "Ipakita ang mas kaunti"
 ],
 "Show all {count} upcoming": [
  "Ver las {count} próximas",
  "Ipakita ang lahat ng {count} paparating"
 ],
 "Policy:": [
  "Política:",
  "Patakaran:"
 ],
 "Couldn't load your lessons.": [
  "No se pudieron cargar tus clases.",
  "Hindi ma-load ang mga aralin."
 ],
 "{count} make-up lessons": [
  "{count} clases de recuperación",
  "{count} pambawi na aralin"
 ],
 "{used} used · {booked} booked": [
  "{used} usadas · {booked} reservadas",
  "{used} nagamit · {booked} naka-book"
 ],
 "({count} forfeited)": [
  "({count} perdidas)",
  "({count} hindi na magagamit)"
 ],
 "{count} total": [
  "{count} en total",
  "{count} kabuuan"
 ],
 "make-up": [
  "recuperación",
  "pambawi"
 ],
 "Review + approve new families": [
  "Revisar y aprobar familias nuevas",
  "Suriin at aprubahan ang bagong pamilya"
 ],
 "Bill anyone for anything": [
  "Factura a cualquier persona",
  "Maningil gamit ang invoice"
 ],
 "Email all your families": [
  "Enviar correo a todas las familias",
  "Mag-email sa lahat ng pamilya"
 ],
 "Today's and upcoming lessons": [
  "Clases de hoy y próximas",
  "Mga aralin ngayon at sa susunod"
 ],
 "Your roster": [
  "Tu lista de alumnos",
  "Talaan ng mga mag-aaral"
 ],
 "Signed + pending waivers": [
  "Exenciones firmadas y pendientes",
  "Mga pinirmahan at nakabinbing waiver"
 ],
 "Classes, packages & programs": [
  "Clases, paquetes y programas",
  "Mga klase, pakete at programa"
 ],
 "Promo codes": [
  "Códigos promocionales",
  "Mga promo code"
 ],
 "Card payments from parents": [
  "Pagos con tarjeta de familias",
  "Mga bayad sa card ng magulang"
 ],
 "All invoices": [
  "Todas las facturas",
  "Lahat ng invoice"
 ],
 "Edit your public page": [
  "Editar página pública",
  "Baguhin ang pampublikong pahina"
 ],
 "Share links, QR codes, embeds": [
  "Compartir enlaces y códigos QR",
  "Ibahagi ang link, QR code at embed"
 ],
 "Bulk-import families from CSV": [
  "Importar familias desde CSV",
  "I-import ang mga pamilya mula sa CSV"
 ],
 "Staff, shifts, time clock": [
  "Personal, turnos y registro horario",
  "Staff, shift at time clock"
 ],
 "Pools & venues": [
  "Piscinas y lugares",
  "Mga pool at lugar"
 ],
 "Account & preferences": [
  "Cuenta y preferencias",
  "Account at mga kagustuhan"
 ],
 "Open your public page": [
  "Abrir página pública",
  "Buksan ang pampublikong pahina"
 ],
 "Copy your registration link": [
  "Copiar enlace de inscripción",
  "Kopyahin ang registration link"
 ],
 "View my page": [
  "Ver mi página",
  "Tingnan ang pahina ko"
 ],
 "Copy link": [
  "Copiar enlace",
  "Kopyahin ang link"
 ],
 "New invoice": [
  "Nueva factura",
  "Bagong invoice"
 ],
 "Students": [
  "Alumnos",
  "Mga mag-aaral"
 ],
 "Guardian": [
  "Tutor",
  "Guardian"
 ],
 "Account": [
  "Cuenta",
  "Account"
 ],
 "Review": [
  "Revisar",
  "Suriin"
 ],
 "Contact": [
  "Contacto",
  "Kontak"
 ]
});
Object.assign(messages, {
 "Report currency": [
  "Moneda del informe",
  "Currency ng ulat"
 ],
 "Currencies are reported separately. No conversion is applied.": [
  "Cada moneda se informa por separado. No se aplica conversión.",
  "Hiwalay ang ulat sa bawat currency. Walang conversion."
 ],
 "Could not load revenue history.": [
  "No se pudo cargar el historial de ingresos.",
  "Hindi ma-load ang kasaysayan ng kita."
 ],
 "Page views · 30d": [
  "Visitas · 30 días",
  "Pagbisita · 30 araw"
 ],
 "Revenue · month": [
  "Ingresos · mes",
  "Kita · buwan"
 ],
 "Outstanding": [
  "Pendiente",
  "Hindi pa bayad"
 ],
 "{count} families waiting for your approval": [
  "{count} familias esperan tu aprobación",
  "{count} pamilya ang naghihintay ng pag-apruba"
 ]
});
// R42 static translations; generated at development time, no runtime API.
Object.assign(messages, {
 "Seasonal Hold ($9.99/mo)": [
  "Pausa de temporada ($9.99/mes)",
  "Seasonal Hold ($9.99/mo)"
 ],
 "for exactly that.": [
  "precisamente por eso.",
  "para mismo doon."
 ],
 "Pause — $9.99/mo": [
  "Pausar — $9.99/mes",
  "I-pause — $9.99/mo"
 ],
 "Keep all your students & waivers": [
  "Conserva todos tus estudiantes y exenciones de responsabilidad",
  "Panatilihin ang lahat ng iyong estudyante at waiver"
 ],
 "Public page stays live with a \"taking a break\" note": [
  "La página pública sigue activa con una nota de \"tomando un descanso\"",
  "Mananatiling live ang pampublikong page na may notang \"nagpapahinga muna\""
 ],
 "Resume anytime — no card re-entry": [
  "Reanuda en cualquier momento — sin volver a ingresar la tarjeta",
  "Ipagpatuloy anumang oras — hindi na kailangang ilagay muli ang card"
 ],
 "Save $20+/mo vs. your current plan": [
  "Ahorra más de $20/mes frente a tu plan actual",
  "Makatipid ng $20+/mo kumpara sa kasalukuyan mong plan"
 ],
 "Cancel — $0": [
  "Cancelar — $0",
  "Kanselahin — $0"
 ],
 "Public page goes offline at period end": [
  "La página pública se desconecta al final del período",
  "Mag-o-offline ang pampublikong page sa katapusan ng period"
 ],
 "Families can't book or apply": [
  "Las familias no pueden reservar ni inscribirse",
  "Hindi makakapag-book o makakapag-apply ang mga pamilya"
 ],
 "You'll need to re-enter your card to come back": [
  "Tendrás que volver a ingresar tu tarjeta para regresar",
  "Kakailanganin mong ilagay muli ang card mo para makabalik"
 ],
 "Data retained for 90 days": [
  "Datos conservados durante 90 días",
  "Pananatilihin ang data sa loob ng 90 araw"
 ],
 "Switching to hold…": [
  "Cambiando a pausa…",
  "Lililipat sa hold…"
 ],
 "Pause for $9.99 instead — best choice": [
  "Pausa por $9.99 en su lugar — la mejor opción",
  "Mag-pause na lang sa halagang $9.99 — pinakamainam na opsyon"
 ],
 "Never mind, keep my membership": [
  "No importa, mantener mi membresía",
  "Huwag na lang, panatilihin ang membership ko"
 ],
 "I really want to cancel": [
  "De verdad quiero cancelar",
  "Gusto ko talagang magkansela"
 ],
 "Cancel your Seasonal Hold?": [
  "¿Cancelar tu pausa de temporada?",
  "Kanselahin ang iyong Seasonal Hold?"
 ],
 "One quick question before you go": [
  "Una pregunta rápida antes de irte",
  "Isang mabilis na tanong bago ka umalis"
 ],
 "We'll cancel at the end of your current billing period. What's the main reason?": [
  "Cancelaremos al final de tu período de facturación actual. ¿Cuál es la razón principal?",
  "Ikakansela namin sa katapusan ng kasalukuyan mong billing period. Ano ang pangunahing dahilan?"
 ],
 "Main reason (optional)": [
  "Razón principal (opcional)",
  "Pangunahing dahilan (opsyonal)"
 ],
 "Anything else? (optional)": [
  "¿Algo más? (opcional)",
  "May iba pa? (opsyonal)"
 ],
 "Tell us what would have kept you — even one sentence helps.": [
  "Cuéntanos qué te habría hecho quedarte; incluso una sola frase ayuda.",
  "Sabihin mo sa amin kung ano sana ang nakapagpanatili sa iyo — kahit isang pangungusap lang ay makakatulong."
 ],
 "← Back": [
  "← Atrás",
  "← Bumalik"
 ],
 "Keep my membership": [
  "Mantener mi membresía",
  "Panatilihin ang membership ko"
 ],
 "Cancelling…": [
  "Cancelando…",
  "Kinakansela…"
 ],
 "Confirm cancellation": [
  "Confirmar cancelación",
  "Kumpirmahin ang pagkansela"
 ],
 "Report period type": [
  "Tipo de período del informe",
  "Uri ng period ng ulat"
 ],
 "Previous month": [
  "Mes anterior",
  "Nakaraang buwan"
 ],
 "Next month": [
  "Mes siguiente",
  "Susunod na buwan"
 ],
 "Year": [
  "Año",
  "Taon"
 ],
 "Previous year": [
  "Año anterior",
  "Nakaraang taon"
 ],
 "· YTD": [
  "· Acumulado del año",
  "· YTD"
 ],
 "Next year": [
  "Año siguiente",
  "Susunod na taon"
 ],
 "Start date": [
  "Fecha de inicio",
  "Petsa ng simula"
 ],
 "End date": [
  "Fecha de finalización",
  "Petsa ng pagtatapos"
 ],
 "on next invoice": [
  "en la próxima factura",
  "en la susunod na invoice"
 ],
 "Cancels on": [
  "Se cancela el",
  "Kakanselahin sa"
 ],
 "— you'll keep access until then.": [
  "— conservarás el acceso hasta entonces.",
  "— mananatili ang access mo hanggang noon."
 ],
 "Next payment:": [
  "Próximo pago:",
  "Susunod na bayad:"
 ],
 "· exp": [
  "· vence",
  "· exp"
 ],
 "Update card": [
  "Actualizar tarjeta",
  "I-update ang card"
 ],
 "No card details found — add one so your membership never lapses.": [
  "No se encontraron datos de la tarjeta — agrega una para que tu membresía nunca caduque.",
  "Walang nahanap na detalye ng card — magdagdag ng isa para hindi mapaso ang membership mo."
 ],
 "Resuming…": [
  "Reanudando…",
  "Ipinagpapatuloy…"
 ],
 "Resume full membership": [
  "Reanudar membresía completa",
  "Ipagpatuloy ang buong membership"
 ],
 "Don't cancel — keep my subscription": [
  "No cancelar — mantener mi suscripción",
  "Huwag kanselahin — panatilihin ang subscription ko"
 ],
 "💡 Pause and Cancel become live once you subscribe to a plan below.": [
  "💡 Pausar y Cancelar se activan una vez que te suscribas a un plan abajo.",
  "💡 Magiging available ang Pause at Cancel kapag nag-subscribe ka sa isa sa mga plan sa ibaba."
 ],
 "💡 Just need a break for the off-season?": [
  "💡 ¿Solo necesitas un descanso durante la temporada baja?",
  "💡 Kailangan mo lang ba ng pahinga para sa off-season?"
 ],
 "Most coaches choose Pause ($9.99/mo)": [
  "La mayoría de los instructores eligen Pausar ($9.99/mo)",
  "Karamihan sa mga coach ay pinipili ang Pause ($9.99/mo)"
 ],
 "— keeps your data, students, and public page intact so you can pick right back up.": [
  "— mantiene tus datos, alumnos y página pública intactos para que puedas retomarlo de inmediato.",
  "— pinananatiling buo ang iyong data, mga estudyante, at pampublikong page para makabalik ka agad."
 ],
 "Choose your plan": [
  "Elige tu plan",
  "Piliin ang plan mo"
 ],
 "All payments processed securely by Stripe — your card never touches SplashPad servers.": [
  "Todos los pagos se procesan de forma segura con Stripe — tu tarjeta nunca pasa por los servidores de SplashPad.",
  "Lahat ng bayad ay ligtas na pinoproseso ng Stripe — hindi kailanman dumadaan ang card mo sa mga server ng SplashPad."
 ],
 "⭐ Most popular": [
  "⭐ Más popular",
  "⭐ Pinakasikat"
 ],
 "Free for community members": [
  "Gratis para miembros de la comunidad",
  "Libre para sa mga miyembro ng komunidad"
 ],
 "Billing is processed securely by Stripe inside SplashPad. Tap the floating": [
  "La facturación se procesa de forma segura con Stripe dentro de SplashPad. Toca el botón flotante de",
  "Ang billing ay ligtas na pinoproseso ng Stripe sa loob ng SplashPad. I-tap ang lumulutang na"
 ],
 "Help": [
  "Ayuda",
  "Tulong"
 ],
 "button or email": [
  "o envía un correo a",
  "button o mag-email sa"
 ],
 "support@splashpad.pro": [
  "support@splashpad.pro",
  "support@splashpad.pro"
 ],
 "if you run into trouble.": [
  "si tienes algún problema.",
  "kung magkaroon ka ng problema."
 ],
 "Pause membership ($9.99/mo)": [
  "Pausar membresía ($9.99/mo)",
  "I-pause ang membership ($9.99/mo)"
 ],
 "Pause to Seasonal Hold?": [
  "¿Pausar a Seasonal Hold?",
  "I-pause sa Seasonal Hold?"
 ],
 "We'll switch you to the": [
  "Te cambiaremos al plan",
  "Ililipat ka namin sa"
 ],
 "Seasonal Hold plan at $9.99/month": [
  "Seasonal Hold por $9.99/mes",
  "Seasonal Hold plan na $9.99/buwan"
 ],
 "— your data, students, and waivers stay safe and your public page shows a friendly \"taking a break\" note.": [
  "— tus datos, alumnos y exenciones se mantienen seguros y tu página pública mostrará una nota amistosa de \"tomando un descanso\".",
  "— mananatiling ligtas ang iyong data, mga estudyante, at waiver at magpapakita ang pampublikong page mo ng magiliw na mensaheng \"nagpapahinga muna\"."
 ],
 "Tap": [
  "Toca",
  "I-tap ang"
 ],
 "any time to go back to your old plan — no need to re-enter your card.": [
  "en cualquier momento para volver a tu plan anterior — no hace falta volver a ingresar tu tarjeta.",
  "anumang oras para bumalik sa dati mong plan — hindi na kailangang ilagay muli ang card mo."
 ],
 "Pausing…": [
  "Pausando…",
  "Pina-pause…"
 ],
 "Yes, switch to $9.99 hold": [
  "Sí, cambiar a la pausa de $9.99",
  "Oo, lumipat sa $9.99 hold"
 ],
 "Cancel membership": [
  "Cancelar membresía",
  "Kanselahin ang membership"
 ],
 "Before you go — would Pause work instead?": [
  "Antes de irte — ¿te serviría Pausar en su lugar?",
  "Bago ka umalis — baka mas bagay ang Pause?"
 ],
 "Most coaches who cancel just want a break for the off-season. We built": [
  "La mayoría de los instructores que cancelan solo quieren un descanso durante la temporada baja. Creamos",
  "Karamihan sa mga coach na nagkakansela ay gusto lang ng pahinga para sa off-season. Gumawa kami ng"
 ],
 "No students listed": [
  "No hay estudiantes en la lista",
  "Walang nakalistang estudyante"
 ],
 "· age": [
  "· edad",
  "· edad"
 ],
 "How they found you:": [
  "Cómo te encontraron:",
  "Paano ka nila nahanap:"
 ],
 "— card saved, charges when you approve": [
  "— tarjeta guardada, se cobra cuando lo apruebes",
  "— naka-save ang card, sisingilin kapag inaprubahan mo"
 ],
 "paid": [
  "pagado",
  "bayad"
 ],
 "— family is paying you directly (Venmo, Zelle, or cash).": [
  "— la familia te está pagando directamente (Venmo, Zelle o efectivo).",
  "— direkta kang binabayaran ng pamilya (Venmo, Zelle, o cash)."
 ],
 "Mark fee received": [
  "Marcar tarifa como recibida",
  "Markahan ang bayad bilang natanggap"
 ],
 "received (paid offline)": [
  "recibido (pagado fuera de línea)",
  "natanggap (binayaran offline)"
 ],
 "failed.": [
  "falló.",
  "nabigo."
 ],
 "Retry charge": [
  "Reintentar cobro",
  "Subukang singilin muli"
 ],
 "Note sent to parent:": [
  "Nota enviada al padre/madre:",
  "Tala na ipinadala sa magulang:"
 ],
 "on this parent's booking page": [
  "en la página de reserva de este padre/madre",
  "sa booking page ng magulang na ito"
 ],
 "Decline": [
  "Rechazar",
  "Tanggihan"
 ],
 "You'll pick which packages they see in the next step.": [
  "Elegirás qué paquetes verán en el siguiente paso.",
  "Pipiliin mo kung aling mga package ang makikita nila sa susunod na hakbang."
 ],
 "You need an active subscription before you can pause it. Pick a plan and subscribe first.": [
  "Necesitas una suscripción activa antes de poder pausarla. Primero elige un plan y suscríbete.",
  "Kailangan mo ng aktibong subscription bago mo ito ma-pause. Pumili muna ng plan at mag-subscribe."
 ],
 "Membership paused — you’re now on Seasonal Hold at $9.99/mo. Resume any time.": [
  "Membresía en pausa — ahora estás en Pausa de temporada por $9.99/mes. Reanúdala cuando quieras.",
  "Naka-pause ang membership — nasa Seasonal Hold ka na ngayon sa halagang $9.99/mo. I-resume anumang oras."
 ],
 "Welcome back! Your full membership is active again.": [
  "¡Qué gusto verte de nuevo! Tu membresía completa está activa otra vez.",
  "Welcome back! Aktibo na ulit ang buong membership mo."
 ],
 "You don't have an active subscription to cancel.": [
  "No tienes una suscripción activa para cancelar.",
  "Wala kang aktibong subscription na puwedeng kanselahin."
 ],
 "Plans are still loading — try again in a second.": [
  "Los planes aún se están cargando — inténtalo de nuevo en un segundo.",
  "Naglo-load pa ang mga plan — subukan ulit pagkalipas ng isang segundo."
 ],
 "Your Subscription": [
  "Tu suscripción",
  "Iyong Subscription"
 ],
 "Manage your SplashPad membership in one place. Payments are processed by Stripe directly inside SplashPad — no redirects, instant confirmation.": [
  "Administra tu membresía de SplashPad en un solo lugar. Los pagos son procesados por Stripe directamente dentro de SplashPad, sin redirecciones y con confirmación instantánea.",
  "Pamahalaan ang iyong SplashPad membership sa iisang lugar. Ang mga bayad ay pinoproseso ng Stripe direkta sa loob ng SplashPad — walang redirects, agad ang kumpirmasyon."
 ],
 "Your subscription needs a fresh start": [
  "Tu suscripción necesita un nuevo comienzo",
  "Kailangan ng bagong simula ang subscription mo"
 ],
 "We're showing you as": [
  "Te mostramos como",
  "Ipinapakita ka namin bilang"
 ],
 "in our records, but Stripe reports your subscription is": [
  "en nuestros registros, pero Stripe informa que tu suscripción está",
  "sa aming records, pero sinasabi ng Stripe na ang subscription mo ay"
 ],
 ". This usually happens after a failed payment or a cancellation that didn't fully sync.": [
  ". Esto suele pasar después de un pago fallido o una cancelación que no se sincronizó completamente.",
  ". Karaniwan itong nangyayari pagkatapos ng nabigong bayad o pagkanselang hindi ganap na nag-sync."
 ],
 "Try \"Re-sync with Stripe\" first": [
  "Prueba primero \"Volver a sincronizar con Stripe\"",
  "Subukan muna ang \"Re-sync with Stripe\""
 ],
 "— it'll match our records to whatever Stripe currently shows (active Starter/Pro/etc.). If that doesn't help, \"Clear stale subscription\" lets you start fresh.": [
  "— hará coincidir nuestros registros con lo que Stripe muestra actualmente (Starter/Pro/etc. activo). Si eso no ayuda, \"Borrar suscripción desactualizada\" te permite empezar de nuevo.",
  "— itutugma nito ang aming records sa kung ano ang kasalukuyang ipinapakita ng Stripe (active Starter/Pro/etc.). Kung hindi iyon makatulong, ang \"Clear stale subscription\" ay magbibigay-daan para magsimula ka ulit."
 ],
 "Re-sync with Stripe": [
  "Volver a sincronizar con Stripe",
  "Re-sync with Stripe"
 ],
 "Clear stale subscription & start fresh": [
  "Borrar suscripción desactualizada y empezar de nuevo",
  "Clear stale subscription at magsimulang muli"
 ],
 "Current plan:": [
  "Plan actual:",
  "Kasalukuyang plan:"
 ],
 "Community member — Starter free · Pro": [
  "Miembro de la comunidad — Starter gratis · Pro",
  "Community member — Starter libre · Pro"
 ],
 "% off ($": [
  "% de descuento ($",
  "% diskuwento ($"
 ],
 "/mo)": [
  "/mes)",
  "/mo)"
 ],
 "% off": [
  "% de descuento",
  "% diskuwento"
 ],
 "forever": [
  "para siempre",
  "habambuhay"
 ],
 "You've hit your": [
  "Has alcanzado tu límite de",
  "Naabot mo na ang iyong"
 ],
 "-student Starter limit (": [
  " estudiantes del plan Starter (",
  "-estudyanteng limit ng Starter ("
 ],
 "active students)": [
  "estudiantes activos)",
  "mga aktibong estudyante)"
 ],
 "Families can still apply and their applications are saved right here — but approving or enrolling them is paused until you upgrade. Pro removes the limit entirely.": [
  "Las familias aún pueden postularse y sus solicitudes se guardan aquí mismo, pero aprobarlas o inscribirlas se pausa hasta que actualices tu plan. Pro elimina el límite por completo.",
  "Makakapag-apply pa rin ang mga pamilya at mase-save rito ang kanilang mga application, pero naka-pause ang pag-apruba o pag-enroll sa kanila hanggang mag-upgrade ka. Inaalis ng Pro ang limit nang buo."
 ],
 "Failed to load applications": [
  "No se pudieron cargar las solicitudes",
  "Hindi na-load ang mga application"
 ],
 "Approved — parent has been emailed with their booking page link": [
  "Aprobada — se le ha enviado un correo al padre/madre con el enlace a su página de reserva",
  "Naaprubahan — na-email na ang magulang ng link sa kanilang booking page"
 ],
 "Declined — parent has been emailed": [
  "Rechazada — se le ha enviado un correo al padre/madre",
  "Tinanggihan — na-email na ang magulang"
 ],
 "Updated — the parent's booking page now reflects your changes.": [
  "Actualizada — la página de reserva del padre/madre ahora refleja tus cambios.",
  "Na-update — makikita na ngayon sa booking page ng magulang ang iyong mga pagbabago."
 ],
 "No families waiting on a decision.": [
  "No hay familias esperando una decisión.",
  "Walang pamilyang naghihintay ng desisyon."
 ],
 "Declined": [
  "Rechazada",
  "Tinanggihan"
 ],
 "No pending applications.": [
  "No hay solicitudes pendientes.",
  "Walang nakabinbing application."
 ],
 "No approved applications yet.": [
  "Aún no hay solicitudes aprobadas.",
  "Wala pang naaprubahang application."
 ],
 "No declined applications.": [
  "No hay solicitudes rechazadas.",
  "Walang tinanggihang application."
 ],
 "Approve": [
  "Aprobar",
  "Aprubahan"
 ],
 "Pick which packages this family can purchase. You can change this anytime.": [
  "Elige qué paquetes puede comprar esta familia. Puedes cambiar esto en cualquier momento.",
  "Piliin kung aling mga package ang puwedeng bilhin ng pamilyang ito. Maaari mo itong baguhin anumang oras."
 ],
 "Their saved card will be charged the": [
  "Se hará el cargo a su tarjeta guardada",
  "Ang kanilang naka-save na card ay sisingilin ng"
 ],
 "the moment you approve.": [
  "en el momento en que apruebes.",
  "sa mismong oras na aprubahan mo."
 ],
 "This family is paying the $": [
  "Esta familia está pagando los $",
  "Binabayaran ng pamilyang ito ang $"
 ],
 "directly (Venmo, Zelle, or cash) — nothing is charged on approval. Tap \"Mark fee received\" on their card once it arrives.": [
  "directamente (Venmo, Zelle o efectivo) — no se cobra nada al aprobar. Toca \"Marcar tarifa como recibida\" en su tarjeta una vez que llegue.",
  "nang direkta (Venmo, Zelle, o cash) — walang sisingilin sa pag-apruba. I-tap ang \"Mark fee received\" sa kanilang card kapag natanggap na ito."
 ],
 "Approving…": [
  "Aprobando…",
  "Inaaprubahan…"
 ],
 "Approve & email parent": [
  "Aprobar y enviar correo al padre/madre",
  "Aprubahan at i-email ang magulang"
 ],
 "Update packages for": [
  "Actualizar paquetes para",
  "I-update ang mga package para kay/sa"
 ],
 "These are the only packages they'll see on their booking page.": [
  "Estos son los únicos paquetes que verán en su página de reserva.",
  "Ito lang ang mga package na makikita nila sa kanilang booking page."
 ],
 "Decline application": [
  "Rechazar solicitud",
  "Tanggihan ang application"
 ],
 "Optionally add a personal note. The parent will get an email notifying them of your decision.": [
  "Opcionalmente, agrega una nota personal. El padre/madre recibirá un correo notificándole tu decisión.",
  "Opsyonal na magdagdag ng personal na note. Makakatanggap ang magulang ng email na nagpapaalam ng iyong desisyon."
 ],
 "Note to parent (optional)": [
  "Nota para el padre/madre (opcional)",
  "Note para sa magulang (opsyonal)"
 ],
 "e.g., Sorry, you're outside my service area but I can recommend a colleague nearby.": [
  "p. ej., Lo sentimos, estás fuera de mi área de servicio, pero puedo recomendarte un colega cercano.",
  "hal., Paumanhin, nasa labas ka ng aking service area pero maaari akong magrekomenda ng kasamahang malapit sa iyo."
 ],
 "Decline & email parent": [
  "Rechazar y enviar correo al padre/madre",
  "Tanggihan at i-email ang magulang"
 ],
 "You haven't created any packages yet. The parent will land on an empty booking page — head to Packages & Pricing to add some.": [
  "Aún no has creado ningún paquete. El padre/madre llegará a una página de reserva vacía — ve a Paquetes y precios para agregar algunos.",
  "Wala ka pang nagagawang anumang package. Mapupunta ang magulang sa isang walang lamang booking page — pumunta sa Packages & Pricing para magdagdag."
 ],
 "Show all my packages": [
  "Mostrar todos mis paquetes",
  "Ipakita ang lahat ng aking package"
 ],
 "(recommended for new clients)": [
  "(recomendado para clientes nuevos)",
  "(inirerekomenda para sa mga bagong kliyente)"
 ],
 "Only show these packages": [
  "Mostrar solo estos paquetes",
  "Ang mga package na ito lang ang ipakita"
 ],
 "Payment declined": [
  "Pago rechazado",
  "Tinanggihang bayad"
 ],
 "We told them:": [
  "Les dijimos:",
  "Sinabi namin sa kanila:"
 ],
 "Nothing was charged. This clears on its own once their payment goes through.": [
  "No se cobró nada. Esto se resuelve solo una vez que su pago se procese.",
  "Walang siningil. Kusang mawawala ito kapag pumasok na ang bayad nila."
 ],
 "vs prior:": [
  "vs. período anterior:",
  "kumpara sa nakaraang panahon:"
 ],
 "% vs prior period": [
  "% vs. período anterior",
  "% kumpara sa nakaraang panahon"
 ],
 "payment": [
  "pago",
  "bayad"
 ],
 "refunds": [
  "reembolsos",
  "mga refund"
 ],
 "net": [
  "neto",
  "net"
 ],
 "Connect Stripe to pull exact card fees and payouts.": [
  "Conecta Stripe para obtener las comisiones exactas de tarjeta y los pagos.",
  "Ikonekta ang Stripe para makuha ang eksaktong card fees at payouts."
 ],
 "Already up to date — synced a few minutes ago.": [
  "Ya está actualizado — se sincronizó hace unos minutos.",
  "Up to date na — na-sync ilang minuto ang nakalipas."
 ],
 "Your income, fees and client value in one place — month or full year, ready for your CPA.": [
  "Tus ingresos, comisiones y valor del cliente en un solo lugar — por mes o por el año completo, listo para tu CPA.",
  "Ang iyong income, fees at client value sa isang lugar — buwanan o buong taon, handa para sa iyong CPA."
 ],
 "Gross receipts": [
  "Ingresos brutos",
  "Gross receipts"
 ],
 "Refunds": [
  "Reembolsos",
  "Mga refund"
 ],
 "Card fees (Stripe)": [
  "Comisiones de tarjeta (Stripe)",
  "Card fees (Stripe)"
 ],
 "estimated · sync for exact": [
  "estimado · sincroniza para ver el valor exacto",
  "tantya · i-sync para sa eksakto"
 ],
 "SplashPad fees": [
  "Comisiones de SplashPad",
  "SplashPad fees"
 ],
 "Net income": [
  "Ingresos netos",
  "Net income"
 ],
 "By category": [
  "Por categoría",
  "Ayon sa kategorya"
 ],
 "By location": [
  "Por ubicación",
  "Ayon sa lokasyon"
 ],
 "By coach": [
  "Por instructor",
  "Ayon sa coach"
 ],
 "Top classes & packages": [
  "Clases y paquetes principales",
  "Mga nangungunang klase at package"
 ],
 "Stripe payouts": [
  "Pagos de Stripe",
  "Stripe payouts"
 ],
 "Sync": [
  "Sincronizar",
  "I-sync"
 ],
 "Connect Stripe (Your Subscription → Payments) to see deposits to your bank here and pull exact card fees.": [
  "Conecta Stripe (Tu Suscripción → Pagos) para ver aquí los depósitos a tu banco y obtener las comisiones exactas de tarjeta.",
  "Ikonekta ang Stripe (Your Subscription → Payments) para makita rito ang mga deposit sa iyong bangko at makuha ang eksaktong card fees."
 ],
 "No payouts in this period yet.": [
  "Aún no hay pagos en este período.",
  "Wala pang payouts sa panahong ito."
 ],
 "Press Sync to pull them from Stripe.": [
  "Presiona Sincronizar para obtenerlos de Stripe.",
  "Pindutin ang I-sync para makuha ang mga ito mula sa Stripe."
 ],
 "Deposited to your bank:": [
  "Depositado en tu banco:",
  "Na-deposito sa iyong bangko:"
 ],
 "across": [
  "en",
  "sa kabuuan ng"
 ],
 "payout": [
  "pago",
  "payout"
 ],
 "By payment method": [
  "Por método de pago",
  "Ayon sa payment method"
 ],
 "Bookkeeping CSV downloaded": [
  "CSV de contabilidad descargado",
  "Na-download ang bookkeeping CSV"
 ],
 "Search family, email, description, package…": [
  "Buscar familia, correo electrónico, descripción, paquete…",
  "Maghanap ng pamilya, email, description, package…"
 ],
 "Search transactions": [
  "Buscar transacciones",
  "Maghanap ng mga transaksyon"
 ],
 "CSV for": [
  "CSV para",
  "CSV para sa"
 ],
 "Line type": [
  "Tipo de línea",
  "Line type"
 ],
 "Category": [
  "Categoría",
  "Kategorya"
 ],
 "All categories": [
  "Todas las categorías",
  "Lahat ng kategorya"
 ],
 "All coaches": [
  "Todos los instructores",
  "Lahat ng coach"
 ],
 "No transactions match. Try a different period or clear the filters.": [
  "No hay transacciones que coincidan. Prueba con otro período o borra los filtros.",
  "Walang tugmang transaksyon. Subukan ang ibang yugto o i-clear ang mga filter."
 ],
 "Family": [
  "Familia",
  "Pamilya"
 ],
 "Description": [
  "Descripción",
  "Paglalarawan"
 ],
 "Category · Location · Coach": [
  "Categoría · Ubicación · Instructor",
  "Kategorya · Lokasyon · Coach"
 ],
 "Gross": [
  "Bruto",
  "Kabuuan"
 ],
 "Fees": [
  "Comisiones",
  "Bayarin"
 ],
 "Net": [
  "Neto",
  "Neto"
 ],
 "Estimated until synced from Stripe": [
  "Estimado hasta sincronizar con Stripe",
  "Tinataya hanggang ma-sync mula sa Stripe"
 ],
 "est.": [
  "est.",
  "tant."
 ],
 "line": [
  "línea",
  "linya"
 ],
 "fees": [
  "comisiones",
  "bayarin"
 ],
 "(est.)": [
  "(est.)",
  "(tant.)"
 ],
 "· gross": [
  "· bruto",
  "· gross"
 ],
 "Client LTV CSV downloaded": [
  "CSV de LTV de clientes descargado",
  "Na-download ang CSV ng client LTV"
 ],
 "Families (all time)": [
  "Familias (histórico)",
  "Mga pamilya (all time)"
 ],
 "Average lifetime value": [
  "Valor promedio de por vida",
  "Average lifetime value"
 ],
 "Top family": [
  "Familia principal",
  "Nangungunang pamilya"
 ],
 "Average tenure": [
  "Antigüedad promedio",
  "Average tenure"
 ],
 "Search family, email, swimmer…": [
  "Buscar familia, correo electrónico, nadador…",
  "Maghanap ng pamilya, email, manlalangoy…"
 ],
 "Search families": [
  "Buscar familias",
  "Maghanap ng mga pamilya"
 ],
 "Active only": [
  "Solo activas",
  "Active lang"
 ],
 "CSV": [
  "CSV",
  "CSV"
 ],
 "No families yet — lifetime value appears after the first payment.": [
  "Aún no hay familias — el valor de por vida aparece después del primer pago.",
  "Wala pang mga pamilya — lalabas ang lifetime value pagkatapos ng unang bayad."
 ],
 "· since": [
  "· desde",
  "· mula"
 ],
 "mo ·": [
  "mes ·",
  "buw. ·"
 ],
 "This period": [
  "Este período",
  "Sa panahong ito"
 ],
 "Enter the email address to send to.": [
  "Ingresa la dirección de correo electrónico a la que se enviará.",
  "Ilagay ang email address na padadalhan."
 ],
 "Pick at least one file to attach.": [
  "Elige al menos un archivo para adjuntar.",
  "Pumili ng kahit isang file na ia-attach."
 ],
 "Cash basis by payment date; refunds on the date issued. Income only — expenses beyond card and platform fees aren’t tracked here yet.": [
  "Base de efectivo según la fecha de pago; los reembolsos en la fecha de emisión. Solo ingresos — aquí todavía no se registran los gastos más allá de las comisiones de tarjeta y de la plataforma.",
  "Cash basis ayon sa petsa ng bayad; ang mga refund ay sa petsa kung kailan ibinigay. Kita lang — ang mga gastos lampas sa card at platform fees ay hindi pa sinusubaybayan dito."
 ],
 "Card fees on": [
  "Comisiones de tarjeta en",
  "Card fees sa"
 ],
 "are estimated (2.9% + 30¢).": [
  "son estimadas (2.9% + 30¢).",
  "ay tinataya (2.9% + 30¢)."
 ],
 "Syncing…": [
  "Sincronizando…",
  "Sini-sync…"
 ],
 "Sync with Stripe": [
  "Sincronizar con Stripe",
  "I-sync sa Stripe"
 ],
 "for exact figures before sending to your CPA.": [
  "para obtener cifras exactas antes de enviarlo a tu CPA.",
  "para sa eksaktong mga numero bago ipadala sa iyong CPA."
 ],
 "Download": [
  "Descargar",
  "I-download"
 ],
 "Send to every approved parent on your roster (": [
  "Enviar a todos los padres aprobados de tu lista (",
  "Ipadala sa bawat aprubadong magulang sa iyong roster ("
 ],
 "Specific families": [
  "Familias específicas",
  "Mga partikular na pamilya"
 ],
 "Pick": [
  "Elegir",
  "Pumili"
 ],
 "or fewer to bypass the": [
  "o menos para evitar el",
  "o mas kaunti para lampasan ang"
 ],
 "h cooldown": [
  "h de espera",
  "h na cooldown"
 ],
 "Search by parent name, email, or child": [
  "Buscar por nombre del padre, correo electrónico o niño",
  "Maghanap ayon sa pangalan ng magulang, email, o bata"
 ],
 "Select matches": [
  "Seleccionar coincidencias",
  "Piliin ang mga tugma"
 ],
 "Select all": [
  "Seleccionar todo",
  "Piliin lahat"
 ],
 "Clear (": [
  "Borrar (",
  "I-clear ("
 ],
 "You don't have any approved families yet.": [
  "Aún no tienes familias aprobadas.",
  "Wala ka pang mga aprubadong pamilya."
 ],
 "No matches for that search.": [
  "No hay coincidencias para esa búsqueda.",
  "Walang tugma para sa paghahanap na iyan."
 ],
 "This message will go to": [
  "Este mensaje se enviará a",
  "Ipapadala ang mensaheng ito sa"
 ],
 "parent": [
  "padre",
  "magulang"
 ],
 "parents": [
  "padres",
  "mga magulang"
 ],
 "Capped at": [
  "Límite de",
  "Naka-cap sa"
 ],
 "Next full broadcast in": [
  "Próxima difusión completa en",
  "Susunod na full broadcast sa loob ng"
 ],
 "e.g. Pool closed Friday — make-ups scheduled for Sunday": [
  "p. ej. Piscina cerrada el viernes; clases de recuperación programadas para el domingo",
  "hal. Sarado ang pool sa Biyernes — ang make-up classes ay naka-iskedyul sa Linggo"
 ],
 "Basic formatting only (bold, italic, lists, links). Parents will see your email signed by you with a one-click reply.": [
  "Solo formato básico (negrita, cursiva, listas, enlaces). Los padres verán tu correo firmado por ti con respuesta en un clic.",
  "Basic formatting lang (bold, italic, lists, links). Makikita ng mga magulang ang iyong email na pirmado mo na may one-click reply."
 ],
 "Limit: one full broadcast every": [
  "Límite: una difusión completa cada",
  "Limit: isang full broadcast bawat"
 ],
 "hours. Targeted sends to": [
  "horas. Los envíos dirigidos a",
  "oras. Ang targeted sends sa"
 ],
 "or fewer families don't count.": [
  "o menos familias no cuentan.",
  "o mas kaunting pamilya ay hindi binibilang."
 ],
 "Choose who gets this": [
  "Elige quién recibe esto",
  "Piliin kung sino ang makakatanggap nito"
 ],
 "Pick at least one family": [
  "Elige al menos una familia",
  "Pumili ng kahit isang pamilya"
 ],
 "No recipients yet": [
  "Aún no hay destinatarios",
  "Wala pang mga tatanggap"
 ],
 "Send this": [
  "Enviar esto",
  "Ipadala ito"
 ],
 "message": [
  "mensaje",
  "mensahe"
 ],
 "broadcast": [
  "difusión",
  "broadcast"
 ],
 "We'll email": [
  "Enviaremos un correo a",
  "Mag-e-email kami sa"
 ],
 "you selected": [
  "seleccionaste",
  "pinili mo"
 ],
 "on your roster": [
  "de tu lista",
  "sa iyong roster"
 ],
 "with the subject": [
  "con el asunto",
  "na may subject na"
 ],
 "Replies will come back to your account email so you can continue the conversation.": [
  "Las respuestas volverán al correo electrónico de tu cuenta para que puedas continuar la conversación.",
  "Ang mga reply ay babalik sa email ng iyong account para maipagpatuloy mo ang usapan."
 ],
 "Yes, send now": [
  "Sí, enviar ahora",
  "Oo, ipadala ngayon"
 ],
 "Recent broadcasts": [
  "Difusiones recientes",
  "Mga kamakailang broadcast"
 ],
 "You haven't sent any broadcasts yet. When you do, you'll see them listed here.": [
  "Aún no has enviado ninguna difusión. Cuando lo hagas, las verás aquí.",
  "Hindi ka pa nagpapadala ng anumang broadcast. Kapag nakapagpadala ka na, makikita mo ang mga iyon dito."
 ],
 "Income statement (PDF)": [
  "Estado de resultados (PDF)",
  "Pahayag ng kita (PDF)"
 ],
 "Transactions + totals (CSV)": [
  "Transacciones + totales (CSV)",
  "Mga transaksyon + kabuuan (CSV)"
 ],
 "QuickBooks import (CSV)": [
  "Importación a QuickBooks (CSV)",
  "Import sa QuickBooks (CSV)"
 ],
 "Import into QuickBooks yourself:": [
  "Impórtalo tú mismo a QuickBooks:",
  "Ikaw mismo ang mag-import sa QuickBooks:"
 ],
 "in QuickBooks Online go to Transactions → Bank transactions → Upload from file and pick this CSV. It uses QuickBooks’ 4-column format (Date, Description, Credit, Debit) with income, fees and refunds as separate lines, so your bookkeeper can categorize each one.": [
  "en QuickBooks Online ve a Transacciones → Transacciones bancarias → Cargar desde archivo y selecciona este CSV. Usa el formato de 4 columnas de QuickBooks (Fecha, Descripción, Crédito, Débito) con ingresos, comisiones y reembolsos en líneas separadas, para que tu tenedor de libros pueda categorizar cada uno.",
  "sa QuickBooks Online, pumunta sa Transactions → Bank transactions → Upload from file at piliin ang CSV na ito. Ginagamit nito ang 4-column format ng QuickBooks (Date, Description, Credit, Debit) na may magkakahiwalay na linya para sa kita, bayarin, at refund, para maikategorya ng iyong bookkeeper ang bawat isa."
 ],
 "Email to your CPA": [
  "Enviar por correo a tu CPA",
  "I-email sa iyong CPA"
 ],
 "Send the": [
  "Enviar el",
  "Ipadala ang"
 ],
 "bookkeeping to any address. We’ll remember it for next time.": [
  "contabilidad a cualquier dirección. La recordaremos para la próxima vez.",
  "bookkeeping sa anumang address. Tatandaan namin ito sa susunod."
 ],
 "Send to": [
  "Enviar a",
  "Ipadala sa"
 ],
 "cpa@example.com": [
  "cpa@example.com",
  "cpa@example.com"
 ],
 "Attach": [
  "Adjuntar",
  "I-attach"
 ],
 "Note (optional)": [
  "Nota (opcional)",
  "Tala (opsyonal)"
 ],
 "Hi Dana — here are the books for the quarter. Card fees are actual from Stripe.": [
  "Hola, Dana — aquí están los libros del trimestre. Las comisiones de tarjeta son las reales de Stripe.",
  "Hi Dana — narito ang books para sa quarter. Ang card fees ay aktuwal mula sa Stripe."
 ],
 "Remember this address": [
  "Recordar esta dirección",
  "Tandaan ang address na ito"
 ],
 "Send": [
  "Enviar",
  "Ipadala"
 ],
 "bookkeeping": [
  "contabilidad",
  "bookkeeping"
 ],
 "Sent to": [
  "Enviado a",
  "Naipadala sa"
 ],
 "Last sent": [
  "Último envío",
  "Huling ipinadala"
 ],
 "Bold": [
  "Negrita",
  "Bold"
 ],
 "Italic": [
  "Cursiva",
  "Italic"
 ],
 "Bulleted list": [
  "Lista con viñetas",
  "Bulleted list"
 ],
 "Numbered list": [
  "Lista numerada",
  "Numbered list"
 ],
 "Insert link": [
  "Insertar enlace",
  "Maglagay ng link"
 ],
 "Links must start with http:// or https://": [
  "Los enlaces deben comenzar con http:// o https://",
  "Dapat magsimula ang mga link sa http:// o https://"
 ],
 "Broadcast to your families": [
  "Difunde a tus familias",
  "I-broadcast sa iyong mga pamilya"
 ],
 "Send one email to every approved parent on your roster. Great for schedule updates, weather changes, end-of-season notes, and seasonal promos.": [
  "Envía un solo correo a todos los padres aprobados de tu lista. Ideal para actualizaciones de horario, cambios por el clima, notas de fin de temporada y promociones de temporada.",
  "Magpadala ng isang email sa bawat approved na magulang sa iyong roster. Mainam ito para sa mga update sa schedule, pagbabago dahil sa panahon, mga tala sa pagtatapos ng season, at mga seasonal promo."
 ],
 "Loading reviewed draft…": [
  "Cargando borrador revisado…",
  "Nilo-load ang na-review na draft…"
 ],
 "Draft handoff — nothing has been sent by opening this page": [
  "Transferencia del borrador — no se ha enviado nada por abrir esta página",
  "Draft handoff — walang naipadala sa pagbukas ng page na ito"
 ],
 "Review the subject, message and specific recipients again. Sending still requires your explicit confirmation below.": [
  "Vuelve a revisar el asunto, el mensaje y los destinatarios específicos. El envío aún requiere tu confirmación explícita abajo.",
  "Suriin muli ang subject, mensahe, at mga partikular na tatanggap. Ang pagpapadala ay nangangailangan pa rin ng iyong tahasang kumpirmasyon sa ibaba."
 ],
 "Source:": [
  "Origen:",
  "Source:"
 ],
 "· Previously used in a send; review history before sending again.": [
  "· Ya se usó antes en un envío; revisa el historial antes de volver a enviarlo.",
  "· Dati na itong ginamit sa pagpapadala; suriin ang history bago ipadala muli."
 ],
 "Use regular composer instead": [
  "Usar el redactor normal en su lugar",
  "Gamitin na lang ang regular composer"
 ],
 "Who should get this email?": [
  "¿Quiénes deberían recibir este correo?",
  "Sino ang dapat makatanggap ng email na ito?"
 ],
 "No approved families yet": [
  "Aún no hay familias aprobadas",
  "Wala pang approved na pamilya"
 ],
 "All approved families": [
  "Todas las familias aprobadas",
  "Lahat ng approved na pamilya"
 ],
 "delivered": [
  "entregado",
  "naihatid"
 ],
 "PRO": [
  "PRO",
  "PRO"
 ],
 "Discount codes": [
  "Códigos de descuento",
  "Mga discount code"
 ],
 "Create codes for sales, sibling discounts, or first-month-free promos. Parents enter them on the pay-invoice page when settling up.": [
  "Crea códigos para promociones, descuentos para hermanos o primer mes gratis. Los padres los ingresan en la página de pago de factura al liquidar el saldo.",
  "Gumawa ng mga code para sa sale, discount para sa magkakapatid, o promos na libreng unang buwan. Ini-enter ito ng mga magulang sa page ng pagbabayad ng invoice kapag nagbabayad na."
 ],
 "No codes yet": [
  "Aún no hay códigos",
  "Wala pang mga code"
 ],
 "Click": [
  "Haz clic",
  "I-click"
 ],
 "New code": [
  "Nuevo código",
  "Bagong code"
 ],
 "to set up your first one. Common examples:": [
  "para configurar el primero. Ejemplos comunes:",
  "para i-set up ang una mo. Mga karaniwang halimbawa:"
 ],
 "SIBLING10": [
  "SIBLING10",
  "SIBLING10"
 ],
 "(10% off),": [
  "(10% de descuento),",
  "(10% off),"
 ],
 "SUMMER25": [
  "SUMMER25",
  "SUMMER25"
 ],
 "($25 off), or": [
  "($25 de descuento), o",
  "($25 off), o"
 ],
 "FRIENDSFREE": [
  "FRIENDSFREE",
  "FRIENDSFREE"
 ],
 "(100% off).": [
  "(100% de descuento).",
  "(100% off)."
 ],
 "Remove this discount code?": [
  "¿Quitar este código de descuento?",
  "Alisin ang discount code na ito?"
 ],
 "Deactivate": [
  "Desactivar",
  "I-deactivate"
 ],
 "Copy failed.": [
  "Error al copiar.",
  "Hindi nakopya."
 ],
 "Copy code": [
  "Copiar código",
  "Kopyahin ang code"
 ],
 "Registration fee": [
  "Cuota de inscripción",
  "Registration fee"
 ],
 "Inactive": [
  "Inactivo",
  "Inactive"
 ],
 "Expired": [
  "Vencido",
  "Expired"
 ],
 "redeemed": [
  "canjeado",
  "na-redeem"
 ],
 "saved": [
  "ahorrado",
  "natipid"
 ],
 "No expiration": [
  "Sin vencimiento",
  "Walang expiration"
 ],
 "Applies to:": [
  "Se aplica a:",
  "Nalalapat sa:"
 ],
 "Redemptions": [
  "Canjes",
  "Mga redemption"
 ],
 "Pick a code (e.g., SIBLING10).": [
  "Elige un código (p. ej., SIBLING10).",
  "Pumili ng code (hal., SIBLING10)."
 ],
 "Set a positive discount value.": [
  "Establece un valor de descuento positivo.",
  "Magtakda ng positibong halaga ng discount."
 ],
 "Percent discount cannot exceed 100.": [
  "El descuento porcentual no puede superar el 100.",
  "Hindi maaaring lumampas sa 100 ang percent discount."
 ],
 "Pick at least one Class or Package for the code to apply to.": [
  "Elige al menos una Clase o Paquete para que se aplique el código.",
  "Pumili ng kahit isang Klase o Package na paglalapatan ng code."
 ],
 "Code updated.": [
  "Código actualizado.",
  "Na-update ang code."
 ],
 "Code created.": [
  "Código creado.",
  "Nagawa ang code."
 ],
 "New discount code": [
  "Nuevo código de descuento",
  "Bagong discount code"
 ],
 "Lesson-price codes are entered on the pay-invoice page; registration-fee codes are entered on your registration form's fee step.": [
  "Los códigos para el precio de las clases se ingresan en la página de pago de factura; los códigos para la cuota de inscripción se ingresan en el paso de cuotas de tu formulario de inscripción.",
  "Ang mga code para sa presyo ng lesson ay ini-enter sa page ng pagbabayad ng invoice; ang mga code para sa registration fee ay ini-enter sa step ng bayarin sa iyong registration form."
 ],
 "This code discounts": [
  "Este código descuenta",
  "Ang code na ito ay nagbibigay ng discount sa"
 ],
 "Lesson prices (Classes & Packages)": [
  "Precios de las lecciones (Clases y Paquetes)",
  "Mga presyo ng lesson (Mga Klase at Package)"
 ],
 "Registration fee (at sign-up)": [
  "Cuota de inscripción (al registrarse)",
  "Bayad sa pagpaparehistro (sa pag-sign up)"
 ],
 "Parents enter it on the registration form. A 100% code waives the fee completely — they skip the card step and still sign the waiver.": [
  "Los padres lo ingresan en el formulario de inscripción. Un código del 100% exime la cuota por completo; omiten el paso de la tarjeta y aun así firman la exención de responsabilidad.",
  "Ine-enter ito ng mga magulang sa registration form. Ang 100% na code ay ganap na nag-aalis ng bayad — nilalaktawan nila ang card step at pinipirmahan pa rin ang waiver."
 ],
 "Code": [
  "Código",
  "Code"
 ],
 "Letters, digits, dashes, or underscores. 2-40 chars.": [
  "Letras, dígitos, guiones o guiones bajos. 2-40 caracteres.",
  "Mga letra, digit, dash, o underscore. 2-40 character."
 ],
 "Description (optional)": [
  "Descripción (opcional)",
  "Deskripsyon (opsyonal)"
 ],
 "Sibling discount — second child enrolled": [
  "Descuento para hermanos: segundo hijo inscrito",
  "Sibling discount — pangalawang batang naka-enroll"
 ],
 "Type": [
  "Tipo",
  "Uri"
 ],
 "Percent off": [
  "Porcentaje de descuento",
  "Porsiyento na bawas"
 ],
 "Dollar amount": [
  "Monto en dólares",
  "Halagang dolyar"
 ],
 "Percentage": [
  "Porcentaje",
  "Porsiyento"
 ],
 "Applies to": [
  "Se aplica a",
  "Nalalapat sa"
 ],
 "All Classes & Packages": [
  "Todas las Clases y Paquetes",
  "Lahat ng Klase at Package"
 ],
 "Only specific ones": [
  "Solo algunos específicos",
  "Mga partikular lang"
 ],
 "Pick Classes/Packages": [
  "Seleccionar Clases/Paquetes",
  "Pumili ng Mga Klase/Package"
 ],
 "You don't have any Classes or Packages yet.": [
  "Todavía no tienes Clases ni Paquetes.",
  "Wala ka pang Mga Klase o Package."
 ],
 "Expires (optional)": [
  "Vence (opcional)",
  "Mag-e-expire (opsyonal)"
 ],
 "Leave blank if the code never expires.": [
  "Déjalo en blanco si el código nunca vence.",
  "Iwanang blangko kung hindi nag-e-expire ang code."
 ],
 "Deactivate to stop accepting new redemptions without losing history.": [
  "Desactívalo para dejar de aceptar nuevos canjes sin perder el historial.",
  "I-deactivate para huminto sa pagtanggap ng mga bagong redemption nang hindi nawawala ang history."
 ],
 "Create code": [
  "Crear código",
  "Gumawa ng code"
 ],
 "Redemptions for": [
  "Canjes de",
  "Mga redemption para sa"
 ],
 "redemption": [
  "canje",
  "redemption"
 ],
 "totalling": [
  "por un total de",
  "na may kabuuang"
 ],
 "in discounts.": [
  "en descuentos.",
  "na mga discount."
 ],
 "No redemptions yet.": [
  "Aún no hay canjes.",
  "Wala pang redemption."
 ],
 "When": [
  "Cuándo",
  "Kailan"
 ],
 "Before": [
  "Antes",
  "Bago"
 ],
 "After": [
  "Después",
  "Pagkatapos"
 ],
 "Follow-ups & progress": [
  "Seguimiento y progreso",
  "Mga follow-up at progreso"
 ],
 "Keep families moving forward. You review every message, schedule change, and progress update.": [
  "Mantén a las familias avanzando. Revisas cada mensaje, cambio de horario y actualización de progreso.",
  "Panatilihing umaabante ang mga pamilya. Nire-review mo ang bawat mensahe, pagbabago ng schedule, at update sa progreso."
 ],
 "Search this view": [
  "Buscar en esta vista",
  "Maghanap sa view na ito"
 ],
 "Search families or reports": [
  "Buscar familias o informes",
  "Maghanap ng mga pamilya o report"
 ],
 "Refresh": [
  "Actualizar",
  "I-refresh"
 ],
 "New report": [
  "Nuevo informe",
  "Bagong report"
 ],
 "No matching results": [
  "No hay resultados coincidentes",
  "Walang katugmang resulta"
 ],
 "Download template": [
  "Descargar plantilla",
  "I-download ang template"
 ],
 "Choose a CSV file to begin.": [
  "Elige un archivo CSV para comenzar.",
  "Pumili ng CSV file para magsimula."
 ],
 "Choose file": [
  "Elegir archivo",
  "Pumili ng file"
 ],
 "Preview (": [
  "Vista previa (",
  "Preview ("
 ],
 "families)": [
  "familias)",
  "pamilya)"
 ],
 "Parent": [
  "Padre/madre",
  "Magulang"
 ],
 "no email": [
  "sin correo electrónico",
  "walang email"
 ],
 "Importing…": [
  "Importando…",
  "Ini-import…"
 ],
 "Import": [
  "Importar",
  "I-import"
 ],
 "families": [
  "familias",
  "mga pamilya"
 ],
 "Families you've invited who haven't claimed their account yet. Resend the email to remind them, or cancel if they decided not to join.": [
  "Familias que has invitado y que aún no han activado su cuenta. Reenvía el correo para recordárselo o cancélalo si decidieron no unirse.",
  "Mga pamilyang inimbitahan mo na hindi pa naa-activate ang kanilang account. I-resend ang email para paalalahanan sila, o kanselahin kung nagpasya silang huwag sumali."
 ],
 "No invitations sent yet. Use": [
  "Aún no se han enviado invitaciones. Usa",
  "Wala pang naipapadalang imbitasyon. Gamitin ang"
 ],
 "or": [
  "o",
  "o"
 ],
 "with an email to send your first invite.": [
  "con un correo electrónico para enviar tu primera invitación.",
  "na may email para ipadala ang una mong imbitasyon."
 ],
 "Resent": [
  "Reenviado",
  "Na-resend"
 ],
 "Claimed": [
  "Activada",
  "Na-claim"
 ],
 "Sending": [
  "Enviando",
  "Ipinapadala"
 ],
 "Resend": [
  "Reenviar",
  "I-resend"
 ],
 "Import results": [
  "Resultados de la importación",
  "Mga resulta ng import"
 ],
 "Created": [
  "Creadas",
  "Nagawa"
 ],
 "Auto-linked": [
  "Vinculadas automáticamente",
  "Awtomatikong na-link"
 ],
 "Invites sent": [
  "Invitaciones enviadas",
  "Naipadalang mga imbitasyon"
 ],
 "Errors": [
  "Errores",
  "Mga error"
 ],
 "Some rows had errors": [
  "Algunas filas tuvieron errores",
  "May mga row na may error"
 ],
 "Row": [
  "Fila",
  "Row"
 ],
 "Open Students →": [
  "Abrir Estudiantes →",
  "Buksan ang Students →"
 ],
 "to enroll the new families in classes.": [
  "para inscribir a las nuevas familias en clases.",
  "para i-enroll ang mga bagong pamilya sa mga klase."
 ],
 "Invoice cancelled. The student was dropped and the parent was notified.": [
  "Factura cancelada. Se dio de baja al estudiante y se notificó al padre/madre.",
  "Nakansela ang invoice. Na-drop ang estudyante at naabisuhan ang magulang."
 ],
 "Enter a valid recipient email.": [
  "Ingresa un correo electrónico válido del destinatario.",
  "Maglagay ng wastong email ng tatanggap."
 ],
 "Subject is required.": [
  "El asunto es obligatorio.",
  "Kinakailangan ang subject."
 ],
 "Write a short message for the invoice email.": [
  "Escribe un mensaje breve para el correo de la factura.",
  "Sumulat ng maikling mensahe para sa invoice email."
 ],
 "Enter an amount greater than $0.": [
  "Ingresa un importe mayor que $0.",
  "Maglagay ng halagang mas mataas sa $0."
 ],
 "Amount is too large — please confirm under $100,000.": [
  "El importe es demasiado alto — confirma que sea menor de $100,000.",
  "Masyadong malaki ang halaga — pakikumpirma na mas mababa sa $100,000."
 ],
 "Invoice sent — Stripe Pay-now link generated automatically.": [
  "Factura enviada — enlace de pago inmediato de Stripe generado automáticamente.",
  "Naipadala ang invoice — awtomatikong nabuo ang Stripe Pay-now link."
 ],
 "Invoice sent with your custom payment link.": [
  "Factura enviada con tu enlace de pago personalizado.",
  "Naipadala ang invoice gamit ang iyong custom payment link."
 ],
 "No follow-ups in this view": [
  "No hay seguimientos en esta vista",
  "Walang mga follow-up sa view na ito"
 ],
 "Tell families what their swimmers are learning": [
  "Diles a las familias lo que están aprendiendo sus nadadores",
  "Sabihin sa mga pamilya kung ano ang natututuhan ng kanilang mga swimmer"
 ],
 "No message drafts yet": [
  "Aún no hay borradores de mensajes",
  "Wala pang mga draft ng mensahe"
 ],
 "Families with eligible finite packages appear when two or fewer lessons remain, or when they have lessons left but none booked. New bookings and renewals update the signals.": [
  "Las familias con paquetes finitos elegibles aparecen cuando quedan dos o menos clases, o cuando todavía tienen clases pero ninguna reservada. Las nuevas reservas y renovaciones actualizan los indicadores.",
  "Lalabas ang mga pamilyang may kwalipikadong finite package kapag dalawa o mas kaunti na lang ang natitirang lesson, o kapag may lesson pa sila pero walang naka-book. Ina-update ng mga bagong booking at renewal ang mga signal."
 ],
 "Create a private report for a swimmer, then review it before publishing.": [
  "Crea un informe privado para un nadador y luego revísalo antes de publicarlo.",
  "Gumawa ng pribadong report para sa isang swimmer, pagkatapos ay suriin ito bago i-publish."
 ],
 "Prepare a follow-up, closure notice, or use Create broadcast draft on a completed assistant answer.": [
  "Prepara un seguimiento, un aviso de cierre o usa Crear borrador de difusión en una respuesta completada del asistente.",
  "Maghanda ng follow-up, abiso ng pagsasara, o gamitin ang Gumawa ng broadcast draft sa isang nakumpletong sagot ng assistant."
 ],
 "Needs review": [
  "Necesita revisión",
  "Kailangang suriin"
 ],
 "Remaining includes booked lessons ·": [
  "Lo restante incluye clases reservadas ·",
  "Kasama sa natitira ang mga naka-book na lesson ·"
 ],
 "upcoming dates": [
  "próximas fechas",
  "mga susunod na petsa"
 ],
 "Snoozed until": [
  "Pospuesto hasta",
  "Naka-snooze hanggang"
 ],
 "No approved email recipient yet. Review this family in Students.": [
  "Aún no hay un destinatario de correo electrónico aprobado. Revisa a esta familia en Students.",
  "Wala pang aprubadong tatanggap ng email. Suriin ang pamilyang ito sa Students."
 ],
 "Review draft": [
  "Revisar borrador",
  "Suriin ang draft"
 ],
 "Snooze 7 days": [
  "Posponer 7 días",
  "I-snooze nang 7 araw"
 ],
 "Hide until changes": [
  "Ocultar hasta que haya cambios",
  "Itago hanggang may mga pagbabago"
 ],
 "Pause family": [
  "Pausar familia",
  "I-pause ang pamilya"
 ],
 "Resume review": [
  "Reanudar revisión",
  "Ipagpatuloy ang pagsusuri"
 ],
 "Private edits pending": [
  "Ediciones privadas pendientes",
  "May nakabinbing pribadong edit"
 ],
 "Private draft": [
  "Borrador privado",
  "Pribadong draft"
 ],
 "Next goal:": [
  "Próximo objetivo:",
  "Susunod na goal:"
 ],
 "Edit draft": [
  "Editar borrador",
  "I-edit ang draft"
 ],
 "Preview published print": [
  "Vista previa de la versión impresa publicada",
  "I-preview ang na-publish na print"
 ],
 "Review & publish": [
  "Revisar y publicar",
  "Suriin at i-publish"
 ],
 "Withdraw report": [
  "Retirar informe",
  "Bawiin ang report"
 ],
 "Delete draft": [
  "Eliminar borrador",
  "Tanggalin ang draft"
 ],
 "draft ·": [
  "borrador ·",
  "draft ·"
 ],
 "previously sent": [
  "enviado anteriormente",
  "naipadala na dati"
 ],
 "not sent": [
  "no enviado",
  "hindi naipadala"
 ],
 "Publish this report to the family?": [
  "¿Publicar este informe para la familia?",
  "I-publish ang report na ito para sa pamilya?"
 ],
 "Remove this item?": [
  "¿Eliminar este elemento?",
  "Alisin ang item na ito?"
 ],
 "Only this swimmer’s authorized parent can see the published report. No email or message will be sent.": [
  "Solo el padre o la madre autorizado de este nadador puede ver el informe publicado. No se enviará ningún correo electrónico ni mensaje.",
  "Tanging ang awtorisadong magulang ng swimmer na ito ang makakakita sa na-publish na report. Walang email o mensaheng ipapadala."
 ],
 "This removes the report from the parent portal as well as your active list.": [
  "Esto elimina el informe del portal para padres, así como de tu lista activa.",
  "Aalisin nito ang report mula sa parent portal at sa iyong active list."
 ],
 "This deletes the saved draft. It does not send a message.": [
  "Esto elimina el borrador guardado. No envía ningún mensaje.",
  "Tatanggalin nito ang naka-save na draft. Hindi ito magpapadala ng mensahe."
 ],
 "Publish approved report": [
  "Publicar informe aprobado",
  "I-publish ang aprubadong report"
 ],
 "Confirm removal": [
  "Confirmar eliminación",
  "Kumpirmahin ang pag-aalis"
 ],
 "Invitation re-sent. Expires in 7 days.": [
  "Invitación reenviada. Caduca en 7 días.",
  "Naipadala muli ang imbitasyon. Mag-e-expire sa loob ng 7 araw."
 ],
 "Invitation cancelled.": [
  "Invitación cancelada.",
  "Kinansela ang imbitasyon."
 ],
 "Parent first name is required.": [
  "Se requiere el nombre del padre, madre o tutor.",
  "Kinakailangan ang unang pangalan ng magulang."
 ],
 "Add at least one child.": [
  "Agrega al menos un niño.",
  "Magdagdag ng kahit isang bata."
 ],
 "Some fields had issues — see the result panel below.": [
  "Algunos campos tuvieron problemas — consulta el panel de resultados a continuación.",
  "May mga isyu sa ilang field — tingnan ang panel ng resulta sa ibaba."
 ],
 "Could not read that file — make sure it's a valid CSV.": [
  "No se pudo leer ese archivo — asegúrate de que sea un CSV válido.",
  "Hindi nabasa ang file na iyon — tiyaking valid na CSV ito."
 ],
 "No rows to import. Upload a CSV first.": [
  "No hay filas para importar. Primero sube un CSV.",
  "Walang mga row na mai-import. Mag-upload muna ng CSV."
 ],
 "Import Families": [
  "Importar familias",
  "Mag-import ng mga pamilya"
 ],
 "Add families from other platforms, in-person sign-ups, or offline rosters. Skips the application step — they land on your roster immediately.": [
  "Agrega familias de otras plataformas, inscripciones en persona o listas sin conexión. Omite el paso de solicitud: pasan a tu lista de alumnos de inmediato.",
  "Magdagdag ng mga pamilya mula sa ibang platform, mga in-person na sign-up, o mga offline na roster. Lalaktawan ang application step — mapupunta agad sila sa roster mo."
 ],
 "One family": [
  "Una familia",
  "Isang pamilya"
 ],
 "Add one family": [
  "Agregar una familia",
  "Magdagdag ng isang pamilya"
 ],
 "Bulk CSV": [
  "CSV masivo",
  "Maramihang CSV"
 ],
 "Bulk CSV upload": [
  "Carga masiva de CSV",
  "Maramihang pag-upload ng CSV"
 ],
 "Pending invitations": [
  "Invitaciones pendientes",
  "Mga nakabinbing imbitasyon"
 ],
 "Parent first name *": [
  "Nombre del padre, madre o tutor *",
  "Unang pangalan ng magulang *"
 ],
 "Parent last name": [
  "Apellido del padre, madre o tutor",
  "Apelyido ng magulang"
 ],
 "(optional for offline families)": [
  "(opcional para familias sin conexión)",
  "(opsyonal para sa mga offline na pamilya)"
 ],
 "Mailing address": [
  "Dirección postal",
  "Mailing address"
 ],
 "123 Main St, Phoenix AZ 85001": [
  "123 Main St, Phoenix AZ 85001",
  "123 Main St, Phoenix AZ 85001"
 ],
 "Internal notes (only you see this)": [
  "Notas internas (solo tú puedes ver esto)",
  "Mga internal na tala (ikaw lang ang makakakita nito)"
 ],
 "Pays cash · Tuesdays only · Amish family no email": [
  "Paga en efectivo · Solo los martes · Familia Amish sin correo electrónico",
  "Nagbabayad ng cash · Tuwing Martes lang · Amish na pamilya, walang email"
 ],
 "Children": [
  "Niños",
  "Mga bata"
 ],
 "Add another": [
  "Agregar otro",
  "Magdagdag pa"
 ],
 "First name *": [
  "Nombre *",
  "Unang pangalan *"
 ],
 "DOB": [
  "Fecha de nacimiento",
  "Araw ng kapanganakan"
 ],
 "…or Age": [
  "…o edad",
  "…o Edad"
 ],
 "e.g. 7": [
  "p. ej., 7",
  "hal. 7"
 ],
 "Skill level": [
  "Nivel",
  "Antas ng kasanayan"
 ],
 "Beginner / Intermediate / Advanced": [
  "Principiante / Intermedio / Avanzado",
  "Baguhan / Intermediate / Advanced"
 ],
 "Medical / safety notes": [
  "Notas médicas / de seguridad",
  "Mga tala sa medikal / kaligtasan"
 ],
 "Email this family an invitation to claim their account": [
  "Enviar a esta familia una invitación por correo electrónico para reclamar su cuenta",
  "I-email ang pamilyang ito ng imbitasyon para i-claim ang kanilang account"
 ],
 "(add an email above to enable)": [
  "(agrega un correo electrónico arriba para habilitar)",
  "(magdagdag ng email sa itaas para ma-enable)"
 ],
 "Adding…": [
  "Agregando…",
  "Idinadagdag…"
 ],
 "Add family to my roster": [
  "Agregar familia a mi lista",
  "Idagdag ang pamilya sa roster ko"
 ],
 "Upload a CSV": [
  "Subir un CSV",
  "Mag-upload ng CSV"
 ],
 "Export your client list from your current platform (Jackrabbit, MindBody, Sawyer, or a spreadsheet) and upload it here. Need the column format? Download our template.": [
  "Exporta tu lista de clientes desde tu plataforma actual (Jackrabbit, MindBody, Sawyer o una hoja de cálculo) y súbela aquí. ¿Necesitas el formato de columnas? Descarga nuestra plantilla.",
  "I-export ang listahan ng kliyente mo mula sa kasalukuyan mong platform (Jackrabbit, MindBody, Sawyer, o spreadsheet) at i-upload ito rito. Kailangan ang format ng column? I-download ang aming template."
 ],
 "Invoice sent. (Tip: connect Stripe to auto-generate a Pay-now link.)": [
  "Factura enviada. (Consejo: conecta Stripe para generar automáticamente un enlace de Pagar ahora.)",
  "Naipadala na ang invoice. (Tip: ikonekta ang Stripe para awtomatikong gumawa ng link na Magbayad ngayon.)"
 ],
 "Invoice marked paid.": [
  "Factura marcada como pagada.",
  "Minarkahan ang invoice bilang bayad na."
 ],
 "Send and track invoices — for enrolled families or one-off events.": [
  "Envía y haz seguimiento de facturas: para familias inscritas o eventos puntuales.",
  "Magpadala at mag-track ng mga invoice — para sa mga enrolled na pamilya o mga one-off na event."
 ],
 "Total invoices": [
  "Facturas totales",
  "Kabuuang mga invoice"
 ],
 "Paid this period": [
  "Pagado en este período",
  "Nabayaran sa panahong ito"
 ],
 "No invoices yet. Click \"New invoice\" to bill anyone — perfect for special events and one-off clinics.": [
  "Aún no hay facturas. Haz clic en \"Nueva factura\" para cobrar a cualquier persona: perfecto para eventos especiales y clínicas puntuales.",
  "Wala pang mga invoice. I-click ang \"Bagong invoice\" para singilin ang kahit sino — perpekto para sa mga espesyal na event at one-off na clinic."
 ],
 "No invoices match this filter.": [
  "Ninguna factura coincide con este filtro.",
  "Walang invoice na tumutugma sa filter na ito."
 ],
 "Send your first invoice": [
  "Envía tu primera factura",
  "Ipadala ang una mong invoice"
 ],
 "Mark invoice paid": [
  "Marcar factura como pagada",
  "Markahan ang invoice bilang bayad"
 ],
 "To": [
  "Para",
  "Para kay"
 ],
 "Optional note (e.g. \"Paid via Venmo\")": [
  "Nota opcional (p. ej., \"Pagado por Venmo\")",
  "Opsyonal na note (hal. \"Binayaran via Venmo\")"
 ],
 "Stripe receipt #abc123 — paid via online checkout": [
  "Recibo de Stripe #abc123 — pagado mediante pago en línea",
  "Stripe receipt #abc123 — binayaran sa pamamagitan ng online checkout"
 ],
 "Stored for your audit trail. Not shown to the parent.": [
  "Guardado para tu registro de auditoría. No se muestra al padre o tutor.",
  "Naka-store para sa iyong audit trail. Hindi ito ipapakita sa magulang."
 ],
 "Mark as paid": [
  "Marcar como pagada",
  "Markahan bilang bayad"
 ],
 "Cancel this invoice?": [
  "¿Cancelar esta factura?",
  "Kanselahin ang invoice na ito?"
 ],
 "This will": [
  "Esto",
  "Ito ay"
 ],
 "void the invoice": [
  "anulará la factura",
  "magvo-void ng invoice"
 ],
 "drop the student": [
  "dará de baja al estudiante",
  "aalisin ang estudyante"
 ],
 "from any linked class, and": [
  "de cualquier clase vinculada, y",
  "mula sa anumang naka-link na klase, at"
 ],
 "email the parent": [
  "enviará un correo al padre o tutor",
  "mag-e-email sa magulang"
 ],
 "letting them know. This can't be undone.": [
  "para informarle. Esto no se puede deshacer.",
  "para ipaalam sa kanila. Hindi na ito maaaring ma-undo."
 ],
 "Keep invoice": [
  "Conservar factura",
  "Panatilihin ang invoice"
 ],
 "Yes, cancel invoice": [
  "Sí, cancelar factura",
  "Oo, kanselahin ang invoice"
 ],
 "Send an invoice": [
  "Enviar una factura",
  "Magpadala ng invoice"
 ],
 "Use this to bill anyone for any amount — a lifeguarding class, a CPR clinic at a preschool, a one-off private clinic, etc. The recipient doesn't need a SplashPad account. We'll auto-generate a secure": [
  "Usa esto para cobrar a cualquier persona cualquier cantidad: una clase de salvamento, una clínica de RCP en un preescolar, una clínica privada puntual, etc. El destinatario no necesita una cuenta de SplashPad. Generaremos automáticamente un enlace seguro de",
  "Gamitin ito para singilin ang kahit sino ng anumang halaga — isang lifeguarding class, isang CPR clinic sa isang preschool, isang one-off na private clinic, atbp. Hindi kailangan ng tatanggap ng SplashPad account. Awtomatiko kaming gagawa ng secure na"
 ],
 "Stripe Pay now": [
  "Stripe Pay now",
  "Stripe Pay now"
 ],
 "link routed to your connected account (minus our $0.25 platform fee).": [
  "enlace dirigido a tu cuenta conectada (menos nuestra tarifa de plataforma de $0.25).",
  "link na naka-route sa iyong connected account (bawas ang aming $0.25 na platform fee)."
 ],
 "Recipient name": [
  "Nombre del destinatario",
  "Pangalan ng tatanggap"
 ],
 "e.g. Smith Preschool": [
  "p. ej. Smith Preschool",
  "hal. Smith Preschool"
 ],
 "Recipient email *": [
  "Correo electrónico del destinatario *",
  "Email ng tatanggap *"
 ],
 "billing@smithpreschool.com": [
  "billing@smithpreschool.com",
  "billing@smithpreschool.com"
 ],
 "Subject *": [
  "Asunto *",
  "Subject *"
 ],
 "Invoice for CPR Certification — May 18": [
  "Factura de Certificación en RCP — 18 de mayo",
  "Invoice para sa CPR Certification — Mayo 18"
 ],
 "Message *": [
  "Mensaje *",
  "Mensahe *"
 ],
 "If you add a recipient name above, we'll prepend a friendly \"Hi": [
  "Si agregas un nombre de destinatario arriba, antepondremos un cordial \"Hola\"",
  "Kung magdaragdag ka ng pangalan ng tatanggap sa itaas, maglalagay kami sa unahan ng magiliw na \"Hi\""
 ],
 "name": [
  "nombre",
  "pangalan"
 ],
 ",\" automatically.": [
  ",\" automáticamente.",
  ",\" nang awtomatiko."
 ],
 "Amount (USD) *": [
  "Importe (USD) *",
  "Halaga (USD) *"
 ],
 "Due date": [
  "Fecha de vencimiento",
  "Takdang petsa"
 ],
 "Use a custom payment link instead (Venmo, Zelle, etc.)": [
  "Usa un enlace de pago personalizado en su lugar (Venmo, Zelle, etc.)",
  "Gumamit na lang ng custom na payment link (Venmo, Zelle, atbp.)"
 ],
 "Custom payment link": [
  "Enlace de pago personalizado",
  "Custom na payment link"
 ],
 "Overrides the auto-generated Stripe link. The recipient's \"Pay now\" button will point here instead. Use this for off-Stripe payments — you'll need to come back and click": [
  "Anula el enlace de Stripe generado automáticamente. El botón \"Pagar ahora\" del destinatario apuntará aquí en su lugar. Usa esto para pagos fuera de Stripe; tendrás que volver y hacer clic en",
  "Ina-override nito ang auto-generated na Stripe link. Dito na lang mapupunta ang button na \"Pay now\" ng tatanggap. Gamitin ito para sa mga bayad sa labas ng Stripe — kailangan mong bumalik at i-click ang"
 ],
 "Mark paid": [
  "Marcar como pagado",
  "Mark paid"
 ],
 "manually.": [
  "manualmente.",
  "nang manu-mano."
 ],
 "Send invoice": [
  "Enviar factura",
  "Ipadala ang invoice"
 ],
 "This family said they'll pay you directly — tap Mark paid once the money arrives.": [
  "Esta familia dijo que te pagará directamente; toca Marcar como pagado una vez que llegue el dinero.",
  "Sinabi ng pamilyang ito na direkta ka nilang babayaran — i-tap ang Mark paid kapag natanggap na ang pera."
 ],
 "Pay-now link auto-generated via Stripe Connect": [
  "Enlace de pago inmediato generado automáticamente a través de Stripe Connect",
  "Auto-generated ang pay-now link sa pamamagitan ng Stripe Connect"
 ],
 "Stripe": [
  "Stripe",
  "Stripe"
 ],
 "· Cancelled": [
  "· Cancelada",
  "· Kinansela"
 ],
 "Note:": [
  "Nota:",
  "Tandaan:"
 ],
 "Link": [
  "Enlace",
  "Link"
 ],
 "Failed to load landing page": [
  "No se pudo cargar la página de destino",
  "Hindi ma-load ang landing page"
 ],
 "Link copied! Paste it anywhere.": [
  "¡Enlace copiado! Pégalo donde quieras.",
  "Nakopya na ang link! I-paste ito kahit saan."
 ],
 "Could not copy — long-press the URL to copy manually.": [
  "No se pudo copiar; mantén presionada la URL para copiarla manualmente.",
  "Hindi makopya — i-long press ang URL para manu-manong kopyahin."
 ],
 "Landing page saved!": [
  "¡Página de destino guardada!",
  "Nai-save na ang landing page!"
 ],
 "Your photos are already optimized. You can save now.": [
  "Tus fotos ya están optimizadas. Ya puedes guardar.",
  "Optimized na ang iyong mga litrato. Maaari mo nang i-save ngayon."
 ],
 "Could not optimize photos. Try removing one or re-uploading.": [
  "No se pudieron optimizar las fotos. Intenta quitar una o volver a subirla.",
  "Hindi ma-optimize ang mga litrato. Subukang mag-alis ng isa o mag-upload muli."
 ],
 "Landing Page Builder": [
  "Creador de páginas de destino",
  "Landing Page Builder"
 ],
 "Build a beautiful, customizable landing page that sells lessons before parents even click \"Apply\".": [
  "Crea una página de destino atractiva y personalizable que venda clases antes de que los padres siquiera hagan clic en \"Solicitar\".",
  "Gumawa ng maganda at nako-customize na landing page na nagbebenta ng mga lesson bago pa man i-click ng mga magulang ang \"Apply\"."
 ],
 "Edit Visually": [
  "Editar visualmente",
  "I-edit nang biswal"
 ],
 "beta": [
  "beta",
  "beta"
 ],
 "Pro": [
  "Pro",
  "Pro"
 ],
 "🟢 Published": [
  "🟢 Publicada",
  "🟢 Published"
 ],
 "⚪ Draft": [
  "⚪ Borrador",
  "⚪ Draft"
 ],
 "Your landing page is LIVE 🎉": [
  "Tu página de destino está EN VIVO 🎉",
  "LIVE na ang iyong landing page 🎉"
 ],
 "Share this link with parents — it's your new website.": [
  "Comparte este enlace con los padres; es tu nuevo sitio web.",
  "Ibahagi ang link na ito sa mga magulang — ito na ang bago mong website."
 ],
 "Share": [
  "Compartir",
  "Ibahagi"
 ],
 "Preview as parent": [
  "Vista previa como padre",
  "I-preview bilang magulang"
 ],
 "Preview with unsaved changes": [
  "Vista previa con cambios no guardados",
  "I-preview kasama ang mga hindi nai-save na pagbabago"
 ],
 "Your landing page is currently hidden from parents. Flip the switch above to publish.": [
  "Tu página de destino está oculta para los padres en este momento. Activa el interruptor de arriba para publicarla.",
  "Kasalukuyang nakatago sa mga magulang ang iyong landing page. I-on ang switch sa itaas para i-publish ito."
 ],
 "Optimizing…": [
  "Optimizando…",
  "Ino-optimize…"
 ],
 "Optimize my photos": [
  "Optimizar mis fotos",
  "I-optimize ang mga larawan ko"
 ],
 "— changes go out the moment you Save.": [
  "— los cambios se publican en cuanto haces clic en Guardar.",
  "— lalabas agad ang mga pagbabago sa sandaling i-Save mo."
 ],
 "Draft": [
  "Borrador",
  "Draft"
 ],
 "— flip the publish switch up top once you're ready.": [
  "— activa el interruptor de publicación arriba cuando estés listo.",
  "— i-on ang publish switch sa itaas kapag handa ka na."
 ],
 "Upgrade to Pro to publish your landing page": [
  "Actualiza a Pro para publicar tu página de destino",
  "Mag-upgrade sa Pro para mai-publish ang iyong landing page"
 ],
 "The landing page builder is part of the Pro plan ($79.99/mo). You can upgrade in one click from Billing — your account flips to Pro instantly.": [
  "El creador de páginas de destino forma parte del plan Pro ($79.99/mo). Puedes actualizar con un clic desde Billing — tu cuenta cambia a Pro al instante.",
  "Bahagi ng Pro plan ($79.99/mo) ang landing page builder. Maaari kang mag-upgrade sa isang click mula sa Billing — agad na magiging Pro ang account mo."
 ],
 "Not now": [
  "Ahora no",
  "Huwag muna"
 ],
 "Go to Your Subscription": [
  "Ir a tu suscripción",
  "Pumunta sa Iyong Subscription"
 ],
 "Photo gallery": [
  "Galería de fotos",
  "Photo gallery"
 ],
 "Photos of you teaching, your pool, happy kids. Drag-friendly — reorder with the arrows.": [
  "Fotos tuyas enseñando, de tu piscina, de niños felices. Fácil de arrastrar: reordénalas con las flechas.",
  "Mga larawan mo habang nagtuturo, ng pool mo, ng masasayang bata. Madaling i-drag — ayusin muli gamit ang mga arrow."
 ],
 "You have more than": [
  "Tienes más de",
  "Mayroon kang higit sa"
 ],
 "photos saved from a previous version. Remove a few to get back under the new": [
  "fotos guardadas de una versión anterior. Elimina algunas para volver a estar por debajo del nuevo límite de",
  "larawang naka-save mula sa nakaraang bersyon. Mag-alis ng ilan para makabalik sa ibaba ng bagong limit na"
 ],
 "-photo limit and re-enable the upload button.": [
  "fotos y volver a activar el botón de carga.",
  "-photo na limit at muling paganahin ang upload button."
 ],
 "Add a photo": [
  "Añadir una foto",
  "Magdagdag ng larawan"
 ],
 "Maximum 2 videos.": [
  "Máximo 2 videos.",
  "Maximum na 2 video."
 ],
 "Videos": [
  "Videos",
  "Mga Video"
 ],
 "Paste a YouTube URL. Short videos (1-2 minutes) work best.": [
  "Pega una URL de YouTube. Los videos cortos (1-2 minutos) funcionan mejor.",
  "Mag-paste ng YouTube URL. Pinakamainam ang maiikling video (1-2 minuto)."
 ],
 "Add a video": [
  "Añadir un video",
  "Magdagdag ng video"
 ],
 "Connect your Google Business profile first in Marketing → Google Business.": [
  "Primero conecta tu perfil de Google Business en Marketing → Google Business.",
  "Ikonekta muna ang iyong Google Business profile sa Marketing → Google Business."
 ],
 "Reviews & testimonials": [
  "Reseñas y testimonios",
  "Mga review at testimonial"
 ],
 "Pick where your reviews come from — write them yourself, pull from Google, or show both.": [
  "Elige de dónde provienen tus reseñas: escríbelas tú mismo, tráelas desde Google o muestra ambas.",
  "Piliin kung saan manggagaling ang iyong mga review — isulat mo mismo, kunin mula sa Google, o ipakita ang pareho."
 ],
 "Reviews source": [
  "Origen de las reseñas",
  "Pinagmulan ng mga review"
 ],
 "Manual reviews": [
  "Reseñas manuales",
  "Manu-manong mga review"
 ],
 "Google reviews": [
  "Reseñas de Google",
  "Google reviews"
 ],
 "Want auto-imported Google reviews?": [
  "¿Quieres reseñas de Google importadas automáticamente?",
  "Gusto mo ba ng auto-imported na Google reviews?"
 ],
 "Connect Google Business →": [
  "Conectar Google Business →",
  "Ikonekta ang Google Business →"
 ],
 "Google reviews mode is on.": [
  "El modo de reseñas de Google está activado.",
  "Naka-on ang Google reviews mode."
 ],
 "Your hand-written reviews are saved below but won't show on your landing page until you switch back to": [
  "Tus reseñas escritas a mano están guardadas abajo, pero no se mostrarán en tu página de destino hasta que vuelvas a cambiar a",
  "Ang iyong hand-written na mga review ay naka-save sa ibaba pero hindi lalabas sa iyong landing page hangga't hindi ka bumabalik sa"
 ],
 "Manual": [
  "Manual",
  "Manual"
 ],
 "Parent's name (e.g. Sarah M.)": [
  "Nombre del padre/madre (p. ej., Sarah M.)",
  "Pangalan ng magulang (hal. Sarah M.)"
 ],
 "Location (optional)": [
  "Ubicación (opcional)",
  "Lokasyon (opsyonal)"
 ],
 "What they said about your lessons…": [
  "Lo que dijeron sobre tus clases…",
  "Ano ang sinabi nila tungkol sa iyong mga lesson…"
 ],
 "Add a review": [
  "Añadir una reseña",
  "Magdagdag ng review"
 ],
 "Action buttons": [
  "Botones de acción",
  "Mga action button"
 ],
 "Preview my page": [
  "Vista previa de mi página",
  "I-preview ang aking page"
 ],
 "Theme & style": [
  "Tema y estilo",
  "Tema at estilo"
 ],
 "Pick a color theme and a font family. Changes apply to your live page after you Save.": [
  "Elige un tema de color y una familia tipográfica. Los cambios se aplican a tu página en vivo después de Guardar.",
  "Pumili ng tema ng kulay at pamilya ng font. Maa-apply ang mga pagbabago sa iyong live page pagkatapos mong i-Save."
 ],
 "Color theme": [
  "Tema de color",
  "Tema ng kulay"
 ],
 "CTA": [
  "CTA",
  "CTA"
 ],
 "Pick your custom color": [
  "Elige tu color personalizado",
  "Piliin ang iyong custom na kulay"
 ],
 "Choose any color — we'll derive a beautiful dark gradient from it so your hero text always reads cleanly. Or pick one of the curated presets below.": [
  "Elige cualquier color: derivaremos de él un hermoso degradado oscuro para que el texto principal siempre se lea con claridad. O elige una de las opciones predefinidas a continuación.",
  "Pumili ng anumang kulay — gagawa kami ng magandang dark gradient mula rito para laging malinaw basahin ang iyong hero text. O pumili ng isa sa mga curated preset sa ibaba."
 ],
 "Open color wheel to pick a custom hero color": [
  "Abre la rueda de color para elegir un color personalizado para la sección principal",
  "Buksan ang color wheel para pumili ng custom na kulay para sa hero"
 ],
 "Color wheel": [
  "Rueda de color",
  "Color wheel"
 ],
 "or pick a preset:": [
  "o elige una opción predefinida:",
  "o pumili ng preset:"
 ],
 "CTA button color (optional override)": [
  "Color del botón de CTA (anulación opcional)",
  "Kulay ng CTA button (opsyonal na override)"
 ],
 "Change only the call-to-action button color while keeping the theme background. Leave at the default to use the theme's natural accent.": [
  "Cambia solo el color del botón de llamada a la acción, manteniendo el fondo del tema. Déjalo con el valor predeterminado para usar el acento natural del tema.",
  "Baguhin lang ang kulay ng call-to-action button habang pinananatili ang background ng tema. Iwan ito sa default para gamitin ang natural na accent ng tema."
 ],
 "Pick CTA button accent color": [
  "Elige el color de acento del botón de CTA",
  "Piliin ang accent na kulay ng CTA button"
 ],
 "Accent": [
  "Acento",
  "Accent"
 ],
 "Reset to theme default": [
  "Restablecer al valor predeterminado del tema",
  "I-reset sa default ng tema"
 ],
 "Font": [
  "Fuente",
  "Font"
 ],
 "Confident swimmers": [
  "Nadadores seguros de sí mismos",
  "Mga swimmer na may kumpiyansa"
 ],
 "Live photo": [
  "Foto en vivo",
  "Live na larawan"
 ],
 "Hero section": [
  "Sección principal",
  "Hero section"
 ],
 "The first thing parents see. Big, eye-catching, sells the dream.": [
  "Lo primero que ven los padres. Grande, llamativo, vende el sueño.",
  "Ang unang nakikita ng mga magulang. Malaki, kapansin-pansin, binebenta ang pangarap."
 ],
 "Headline": [
  "Titular",
  "Headline"
 ],
 "Confident swimmers, made here.": [
  "Nadadores seguros de sí mismos, hechos aquí.",
  "Mga swimmer na may kumpiyansa, dito hinuhubog."
 ],
 "Sub-headline": [
  "Subtítulo",
  "Sub-headline"
 ],
 "Personalized swim lessons in your own pool — for kids who are scared of water all the way through competitive swimmers.": [
  "Clases de natación personalizadas en tu propia piscina, desde niños que temen al agua hasta nadadores de competición.",
  "Personalized na swim lessons sa sarili mong pool — para sa mga batang takot sa tubig hanggang sa mga competitive swimmer."
 ],
 "Apply button text": [
  "Texto del botón de solicitud",
  "Text ng Apply button"
 ],
 "Apply for Lessons": [
  "Solicitar clases",
  "Apply for Lessons"
 ],
 "Hero photo (optional)": [
  "Foto principal (opcional)",
  "Hero photo (opsyonal)"
 ],
 "A high-quality landscape photo (ideally 1600x900). If left blank we use your theme's gradient background.": [
  "Una foto horizontal de alta calidad (idealmente 1600x900). Si se deja en blanco, usaremos el fondo degradado de tu tema.",
  "Isang de-kalidad na landscape na larawan (mainam na 1600x900). Kapag iniwang blangko, gagamitin namin ang gradient background ng iyong tema."
 ],
 "About / Bio": [
  "Acerca de / Biografía",
  "Tungkol / Bio"
 ],
 "Your story, philosophy, certifications. 2-3 short paragraphs is perfect.": [
  "Tu historia, filosofía y certificaciones. Lo ideal son 2 o 3 párrafos cortos.",
  "Ang iyong kuwento, pilosopiya, at mga sertipikasyon. Perpekto ang 2-3 maiikling talata."
 ],
 "I've been teaching swim lessons for over 12 years...": [
  "He estado enseñando clases de natación durante más de 12 años...",
  "Mahigit 12 taon na akong nagtuturo ng swim lessons..."
 ],
 "/ 2000 characters": [
  "/ 2000 caracteres",
  "/ 2000 character"
 ],
 "Your photos are larger than ideal (": [
  "Tus fotos son más grandes de lo ideal (",
  "Mas malaki kaysa sa ideal ang iyong mga larawan ("
 ],
 "total).": [
  "en total).",
  "kabuuan)."
 ],
 "On a phone or slower connection, this can cause Save to fail. Tap \"Optimize my photos\" — we'll compress them on-device with no quality loss.": [
  "En un teléfono o con una conexión más lenta, esto puede hacer que Guardar falle. Toca \"Optimize my photos\": las comprimiremos en el dispositivo sin pérdida de calidad.",
  "Sa phone o mas mabagal na koneksyon, puwede nitong maging sanhi ng pagpalya ng Save. I-tap ang \"Optimize my photos\" — iko-compress namin ang mga ito sa device nang walang pagkawala ng kalidad."
 ],
 "Customize what parents see on every button. Add your phone number to the Contact button and it becomes a one-tap call from a phone.": [
  "Personaliza lo que los padres ven en cada botón. Agrega tu número de teléfono al botón de contacto y se convertirá en una llamada con un toque desde un teléfono.",
  "I-customize kung ano ang nakikita ng mga magulang sa bawat button. Idagdag ang iyong numero ng telepono sa Contact button at magiging one-tap call ito mula sa telepono."
 ],
 "Apply / sign up button": [
  "Botón de solicitar / registrarse",
  "Apply / sign up button"
 ],
 "Always shown": [
  "Siempre visible",
  "Palaging ipinapakita"
 ],
 "Book button": [
  "Botón de reservar",
  "Book button"
 ],
 "Visible": [
  "Visible",
  "Nakikita"
 ],
 "Hidden": [
  "Oculto",
  "Nakatago"
 ],
 "Book a Lesson": [
  "Reservar una clase",
  "Mag-book ng Lesson"
 ],
 "Sends parents to your calendar (set in Settings → Booking calendar URL).": [
  "Envía a los padres a tu calendario (configurado en Ajustes → URL del calendario de reservas).",
  "Dinadala ang mga magulang sa iyong calendar (itinatakda sa Settings → Booking calendar URL)."
 ],
 "Contact button": [
  "Botón de contacto",
  "Contact button"
 ],
 "Button text": [
  "Texto del botón",
  "Text ng button"
 ],
 "e.g.": [
  "p. ej.",
  "hal."
 ],
 "Call Coach": [
  "Llamar al instructor",
  "Call Coach"
 ],
 "Text Me": [
  "Envíame un mensaje",
  "I-text ako"
 ],
 "Phone number (optional)": [
  "Número de teléfono (opcional)",
  "Numero ng telepono (opsyonal)"
 ],
 "If filled, the button becomes a": [
  "Si se completa, el botón se convierte en una",
  "Kung may laman, ang button ay magiging"
 ],
 "one-tap call": [
  "llamada con un toque",
  "one-tap call"
 ],
 "from a phone. Leave empty to fall back to email.": [
  "desde un teléfono. Déjalo vacío para usar el correo electrónico.",
  "mula sa telepono. Iwanang walang laman para bumalik sa email."
 ],
 "Live preview:": [
  "Vista previa en vivo:",
  "Live preview:"
 ],
 "Packages section": [
  "Sección de paquetes",
  "Packages section"
 ],
 "Choose whether to display your pricing on the public page. Hiding prices is a powerful \"call for more info\" lead-magnet — replace packages with photos + a custom message instead.": [
  "Elige si quieres mostrar tus precios en la página pública. Ocultar los precios es un potente gancho de \"llama para más información\"; en su lugar, puedes reemplazar los paquetes con fotos + un mensaje personalizado.",
  "Piliin kung ipapakita ang iyong pricing sa public page. Ang pagtatago ng mga presyo ay isang mabisang \"tumawag para sa karagdagang impormasyon\" na lead-magnet — sa halip, palitan ang packages ng mga larawan + custom na mensahe."
 ],
 "Showing packages on your landing page": [
  "Mostrando paquetes en tu página de destino",
  "Ipinapakita ang packages sa iyong landing page"
 ],
 "Packages hidden — lead-magnet section will show": [
  "Paquetes ocultos: se mostrará la sección de captación",
  "Nakatago ang packages — ipapakita ang lead-magnet section"
 ],
 "Parents see your pricing.": [
  "Los padres ven tus precios.",
  "Nakikita ng mga magulang ang iyong pricing."
 ],
 "Parents see a custom block with photos + your message, no prices.": [
  "Los padres ven un bloque personalizado con fotos + tu mensaje, sin precios.",
  "Nakakakita ang mga magulang ng custom na block na may mga larawan + iyong mensahe, walang presyo."
 ],
 "Which packages to show": [
  "Qué paquetes mostrar",
  "Aling packages ang ipapakita"
 ],
 "Show all": [
  "Mostrar todos",
  "Ipakita lahat"
 ],
 "Hide all": [
  "Ocultar todos",
  "Itago lahat"
 ],
 "You haven't created any packages yet.": [
  "Aún no has creado ningún paquete.",
  "Wala ka pang nagagawang packages."
 ],
 "Add some →": [
  "Agregar algunos →",
  "Magdagdag ng ilan →"
 ],
 "Tip: leave all packages selected to show every active package, or pick specific ones to spotlight.": [
  "Consejo: deja todos los paquetes seleccionados para mostrar cada paquete activo, o elige algunos específicos para destacarlos.",
  "Tip: iwanang napili ang lahat ng packages para ipakita ang bawat active na package, o pumili ng mga partikular para i-spotlight."
 ],
 "Lead-magnet block": [
  "Bloque de captación",
  "Lead-magnet block"
 ],
 "Visible to parents instead of your packages. Use it to invite them to apply for details on pricing & availability.": [
  "Visible para los padres en lugar de tus paquetes. Úsalo para invitarlos a solicitar detalles sobre precios y disponibilidad.",
  "Nakikita ng mga magulang kapalit ng iyong packages. Gamitin ito para anyayahan silang mag-apply para sa mga detalye tungkol sa pricing at availability."
 ],
 "Custom packages, tailored to your goals": [
  "Paquetes personalizados, adaptados a tus objetivos",
  "Custom packages, nakaayon sa iyong mga layunin"
 ],
 "Pricing varies depending on your child's skill level and the number of weekly lessons. Apply now and I'll personally reach out within 24 hours with a recommended plan and pricing.": [
  "El precio varía según el nivel de habilidad de tu hijo y la cantidad de clases semanales. Solicita ahora y me pondré en contacto personalmente en un plazo de 24 horas con un plan recomendado y el precio.",
  "Nag-iiba ang pricing depende sa skill level ng iyong anak at sa dami ng lingguhang lessons. Mag-apply ngayon at personal kitang kokontakin sa loob ng 24 oras na may inirerekomendang plano at pricing."
 ],
 "Pro feature": [
  "Función Pro",
  "Pro feature"
 ],
 "Build a beautiful landing page that sells lessons for you.": [
  "Crea una hermosa página de destino que venda clases por ti.",
  "Gumawa ng magandang landing page na magbebenta ng mga lesson para sa iyo."
 ],
 "Replace the default coach page with your own custom landing page — hero photo, your bio, gallery, videos, and parent reviews. Built right here. No code.": [
  "Reemplaza la página predeterminada del instructor con tu propia página de destino personalizada: foto principal, tu biografía, galería, videos y reseñas de padres. Creada aquí mismo. Sin código.",
  "Palitan ang default na page ng coach ng sarili mong custom landing page — hero photo, bio mo, gallery, mga video, at mga review ng magulang. Dito mismo ginawa. Walang code."
 ],
 "Currently on": [
  "Actualmente en",
  "Kasalukuyang nasa"
 ],
 "Self-serve — your plan flips instantly so you can start building right away.": [
  "Autoservicio: tu plan cambia al instante para que puedas empezar a crear de inmediato.",
  "Self-serve — agad na lilipat ang iyong plan para makapagsimula kang bumuo kaagad."
 ],
 "Section removed. Save to confirm.": [
  "Sección eliminada. Guarda para confirmar.",
  "Inalis ang seksyon. I-save para kumpirmahin."
 ],
 "Section duplicated — edit the copy.": [
  "Sección duplicada: edita el texto.",
  "Dinoble ang seksyon — i-edit ang kopya."
 ],
 "Website saved.": [
  "Sitio web guardado.",
  "Na-save ang website."
 ],
 "Reverted to last saved version.": [
  "Se revirtió a la última versión guardada.",
  "Naibalik sa huling naka-save na bersyon."
 ],
 "Loading your website…": [
  "Cargando tu sitio web…",
  "Nilo-load ang iyong website…"
 ],
 "The Website Builder is a Pro feature": [
  "El Creador de Sitios Web es una función Pro",
  "Ang Website Builder ay isang Pro feature"
 ],
 "Upgrade to Pro to get a beautiful multi-page website with premium themes, drag-and-drop sections, and a curated swim photo library.": [
  "Actualiza a Pro para obtener un hermoso sitio web de varias páginas con temas premium, secciones de arrastrar y soltar, y una biblioteca seleccionada de fotos de natación.",
  "Mag-upgrade sa Pro para makakuha ng magandang multi-page website na may mga premium theme, mga drag-and-drop na seksyon, at isang curated na swim photo library."
 ],
 "Website Builder": [
  "Creador de Sitios Web",
  "Website Builder"
 ],
 "● Unsaved changes": [
  "● Cambios no guardados",
  "● Mga hindi naka-save na pagbabago"
 ],
 "Open live": [
  "Abrir sitio publicado",
  "Buksan ang live"
 ],
 "Unsaved · preview only": [
  "No guardado · solo vista previa",
  "Hindi naka-save · preview lang"
 ],
 "Discard": [
  "Descartar",
  "Itapon"
 ],
 "Unpublish": [
  "Anular publicación",
  "I-unpublish"
 ],
 "Publish": [
  "Publicar",
  "I-publish"
 ],
 "Pages": [
  "Páginas",
  "Mga Page"
 ],
 "Sections": [
  "Secciones",
  "Mga Seksyon"
 ],
 "Layout": [
  "Diseño",
  "Layout"
 ],
 "Theme": [
  "Tema",
  "Theme"
 ],
 "Photos": [
  "Fotos",
  "Mga Larawan"
 ],
 "Multi-page website": [
  "Sitio web de varias páginas",
  "Multi-page website"
 ],
 "Home, About, Programs & more — like a real website.": [
  "Inicio, Acerca de, Programas y más, como un sitio web real.",
  "Home, About, Programs, at iba pa — parang totoong website."
 ],
 "Classic single-page layout (legacy).": [
  "Diseño clásico de una sola página (heredado).",
  "Classic single-page layout (legacy)."
 ],
 "/coach/…": [
  "/coach/…",
  "/coach/…"
 ],
 "Home is always visible": [
  "Inicio siempre está visible",
  "Laging nakikita ang Home"
 ],
 "Hide this page": [
  "Ocultar esta página",
  "Itago ang page na ito"
 ],
 "Show this page": [
  "Mostrar esta página",
  "Ipakita ang page na ito"
 ],
 "Auto-hides for visitors until you add locations.": [
  "Se oculta automáticamente para los visitantes hasta que agregues ubicaciones.",
  "Awtomatikong itinatago para sa mga bisita hanggang sa magdagdag ka ng mga lokasyon."
 ],
 "Optional — add team members and it appears in your menu automatically.": [
  "Opcional: agrega miembros del equipo y aparecerá en tu menú automáticamente.",
  "Optional — magdagdag ng mga team member at awtomatiko itong lilitaw sa iyong menu."
 ],
 "Menu labels & footer text": [
  "Etiquetas del menú y texto del pie de página",
  "Mga label ng menu at text ng footer"
 ],
 "Rename pages in the menu, edit footer wording": [
  "Cambia el nombre de las páginas en el menú y edita el texto del pie de página",
  "Palitan ang pangalan ng mga page sa menu, i-edit ang wording ng footer"
 ],
 "Promo pop-up": [
  "Ventana emergente promocional",
  "Promo pop-up"
 ],
 "Deal, special or news — on your site & parent portal": [
  "Oferta, promoción o noticia — en tu sitio y portal para padres",
  "Deal, special o balita — sa iyong site at parent portal"
 ],
 "On": [
  "Activado",
  "Naka-on"
 ],
 "Off": [
  "Desactivado",
  "Naka-off"
 ],
 "Classic mode shows everything on one long page. Flip the switch above to unlock the multi-page website with per-page sections.": [
  "El modo clásico muestra todo en una sola página larga. Activa el interruptor de arriba para habilitar el sitio web de varias páginas con secciones por página.",
  "Ipinapakita ng classic mode ang lahat sa isang mahabang page. I-on ang switch sa itaas para ma-unlock ang multi-page website na may mga section sa bawat page."
 ],
 "page": [
  "página",
  "page"
 ],
 "visible": [
  "visible",
  "nakikita"
 ],
 "Drag to reorder · click to edit · eye to hide. You can also click any section directly in the preview.": [
  "Arrastra para reordenar · haz clic para editar · ojo para ocultar. También puedes hacer clic directamente en cualquier sección en la vista previa.",
  "I-drag para muling ayusin · i-click para i-edit · eye para itago. Maaari mo ring i-click nang direkta ang anumang section sa preview."
 ],
 "Add a section to": [
  "Añadir una sección a",
  "Magdagdag ng section sa"
 ],
 "Classic single-page mode": [
  "Modo clásico de página única",
  "Classic single-page mode"
 ],
 "Section arrangement for the classic layout lives in the": [
  "La disposición de secciones para el diseño clásico está en el",
  "Ang ayos ng mga section para sa classic layout ay nasa"
 ],
 "form editor": [
  "editor de formularios",
  "form editor"
 ],
 ". Switch on the multi-page website (Pages tab) to use drag-and-drop here.": [
  ". Activa el sitio web de varias páginas (pestaña Páginas) para usar aquí arrastrar y soltar.",
  ". I-on ang multi-page website (Pages tab) para magamit dito ang drag-and-drop."
 ],
 "Pick the structure of your site — four proven, high-converting layouts. Your theme (colors & fonts) stays the same.": [
  "Elige la estructura de tu sitio — cuatro diseños probados y de alta conversión. Tu tema (colores y fuentes) se mantiene igual.",
  "Piliin ang structure ng iyong site — apat na subok at high-converting na layout. Mananatiling pareho ang iyong theme (mga kulay at font)."
 ],
 "Compare all 4 layouts live": [
  "Comparar los 4 diseños en vivo",
  "I-compare nang live ang lahat ng 4 na layout"
 ],
 "Home page section order": [
  "Orden de secciones de la página de inicio",
  "Pagkakasunod-sunod ng mga section sa Home page"
 ],
 "Each layout comes with a recommended order for the Home page. Apply it any time — your content and hidden sections are kept, only the order changes.": [
  "Cada diseño incluye un orden recomendado para la página de inicio. Aplícalo en cualquier momento: se conservan tu contenido y las secciones ocultas; solo cambia el orden.",
  "Bawat layout ay may kasamang inirerekomendang pagkakasunod-sunod para sa Home page. Ilapat ito anumang oras — mananatili ang iyong content at mga nakatagong section, pagkakasunod-sunod lang ang magbabago."
 ],
 "Apply": [
  "Aplicar",
  "Ilapat"
 ],
 "order to Home": [
  "orden a Inicio",
  "order sa Home"
 ],
 "One click restyles your whole site — colors, fonts, buttons and hero layout.": [
  "Un clic rediseña todo tu sitio — colores, fuentes, botones y diseño principal.",
  "Sa isang click, mababago ang estilo ng buo mong site — mga kulay, font, button at hero layout."
 ],
 "Hero photo": [
  "Foto principal",
  "Hero photo"
 ],
 "No photo yet — a curated swim photo is used automatically.": [
  "Aún no hay foto — se usa automáticamente una foto de natación seleccionada.",
  "Wala pang photo — awtomatikong gagamit ng isang curated na swim photo."
 ],
 "Choose from library": [
  "Elegir de la biblioteca",
  "Pumili mula sa library"
 ],
 "Or upload your own": [
  "O sube la tuya",
  "O mag-upload ng sarili mo"
 ],
 "Gallery": [
  "Galería",
  "Gallery"
 ],
 "Add from library": [
  "Añadir desde la biblioteca",
  "Magdagdag mula sa library"
 ],
 "Manage gallery": [
  "Gestionar galería",
  "Pamahalaan ang gallery"
 ],
 "Live preview": [
  "Vista previa en vivo",
  "Live preview"
 ],
 "Click any section in the preview to edit it": [
  "Haz clic en cualquier sección de la vista previa para editarla",
  "I-click ang anumang section sa preview para i-edit ito"
 ],
 "Preview viewport": [
  "Ventana de vista previa",
  "Preview viewport"
 ],
 "Desktop": [
  "Escritorio",
  "Desktop"
 ],
 "Mobile": [
  "Móvil",
  "Mobile"
 ],
 "Website live preview": [
  "Vista previa en vivo del sitio web",
  "Live preview ng website"
 ],
 "Live preview of your unsaved changes — parents won't see them until you click Save.": [
  "Vista previa en vivo de tus cambios no guardados — los padres no los verán hasta que hagas clic en Guardar.",
  "Live preview ng iyong mga hindi pa nase-save na pagbabago — hindi ito makikita ng mga magulang hanggang sa i-click mo ang Save."
 ],
 "Menu & footer text": [
  "Texto del menú y del pie de página",
  "Text ng menu at footer"
 ],
 "Add-on": [
  "Complemento",
  "Add-on"
 ],
 "Visible on page": [
  "Visible en la página",
  "Makikita sa pahina"
 ],
 "Hidden from page": [
  "Oculto en la página",
  "Nakatago sa pahina"
 ],
 "Duplicate": [
  "Duplicar",
  "I-duplicate"
 ],
 "Advanced settings": [
  "Configuración avanzada",
  "Advanced settings"
 ],
 "Done": [
  "Listo",
  "Tapos na"
 ],
 "You have unsaved changes.": [
  "Tienes cambios sin guardar.",
  "May mga pagbabago kang hindi pa nase-save."
 ],
 "The preview shows them live — click Save to make them visible to parents.": [
  "La vista previa los muestra en vivo; haz clic en Guardar para hacerlos visibles para los padres.",
  "Ipinapakita sila nang live sa preview — i-click ang Save para makita ng mga magulang."
 ],
 "Upgrade to Pro to save": [
  "Actualiza a Pro para guardar",
  "Mag-upgrade sa Pro para makapag-save"
 ],
 "The Website Builder is a Pro feature. Upgrade in Billing.": [
  "El Creador de Sitios Web es una función Pro. Actualiza en Billing.",
  "Ang Website Builder ay isang Pro feature. Mag-upgrade sa Billing."
 ],
 "Hero photo updated — save to publish.": [
  "Foto principal actualizada; guarda para publicar.",
  "Na-update ang hero photo — mag-save para ma-publish."
 ],
 "Gallery is full (6 photos max).": [
  "La galería está llena (máximo 6 fotos).",
  "Puno na ang gallery (hanggang 6 na larawan lang)."
 ],
 "That photo is already in your gallery.": [
  "Esa foto ya está en tu galería.",
  "Nasa gallery mo na ang larawang iyon."
 ],
 "Photo added to gallery — save to publish.": [
  "Foto agregada a la galería; guarda para publicar.",
  "Naidagdag na ang larawan sa gallery — mag-save para ma-publish."
 ],
 "Drag to reorder": [
  "Arrastra para reordenar",
  "I-drag para ayusin ang pagkakasunod-sunod"
 ],
 "Hide this section": [
  "Ocultar esta sección",
  "Itago ang seksyong ito"
 ],
 "Show this section": [
  "Mostrar esta sección",
  "Ipakita ang seksyong ito"
 ],
 "Duplicate section": [
  "Duplicar sección",
  "I-duplicate ang seksyon"
 ],
 "Remove section": [
  "Eliminar sección",
  "Alisin ang seksyon"
 ],
 "Compare layouts": [
  "Comparar diseños",
  "Ihambing ang mga layout"
 ],
 "Your real content, live, in all four layouts. Pick the one that feels right — you can switch any time.": [
  "Tu contenido real, en vivo, en los cuatro diseños. Elige el que se sienta adecuado: puedes cambiarlo en cualquier momento.",
  "Ang totoong content mo, live, sa lahat ng apat na layout. Piliin ang pinakatama ang dating — puwede kang magpalit anumang oras."
 ],
 "Preview device": [
  "Dispositivo de vista previa",
  "Preview device"
 ],
 "In use": [
  "En uso",
  "Kasalukuyang gamit"
 ],
 "Use this layout": [
  "Usar este diseño",
  "Gamitin ang layout na ito"
 ],
 "Use": [
  "Usar",
  "Gamitin"
 ],
 "Previews use your saved content plus the theme you have selected. Unsaved text edits appear after you Save.": [
  "Las vistas previas usan tu contenido guardado más el tema que has seleccionado. Las ediciones de texto no guardadas aparecerán después de que guardes.",
  "Ginagamit ng mga preview ang na-save mong content kasama ang napili mong theme. Lalabas ang mga hindi pa nase-save na text edit pagkatapos mong mag-Save."
 ],
 "Swim photo library": [
  "Biblioteca de fotos de natación",
  "Swim photo library"
 ],
 "Professionally-shot, license-free photos — pick one for your": [
  "Fotos profesionales y libres de licencia: elige una para tu",
  "Mga propesyonal na kuha, license-free na larawan — pumili ng isa para sa iyong"
 ],
 "hero": [
  "principal",
  "hero"
 ],
 "gallery": [
  "galería",
  "gallery"
 ],
 "Search photos…": [
  "Buscar fotos…",
  "Maghanap ng mga larawan…"
 ],
 "Use this photo": [
  "Usar esta foto",
  "Gamitin ang larawang ito"
 ],
 "No photos match that search.": [
  "Ninguna foto coincide con esa búsqueda.",
  "Walang larawang tumutugma sa paghahanap na iyan."
 ],
 "Location name is required.": [
  "El nombre de la ubicación es obligatorio.",
  "Kinakailangan ang pangalan ng lokasyon."
 ],
 "Address is required.": [
  "La dirección es obligatoria.",
  "Kinakailangan ang address."
 ],
 "Location updated.": [
  "Ubicación actualizada.",
  "Na-update ang lokasyon."
 ],
 "Location added.": [
  "Ubicación agregada.",
  "Nadagdag ang lokasyon."
 ],
 "Location archived.": [
  "Ubicación archivada.",
  "Na-archive ang lokasyon."
 ],
 "Location reactivated.": [
  "Ubicación reactivada.",
  "Na-reactivate ang lokasyon."
 ],
 "Where you teach. Shows up on packages, enrollments, and the parent application.": [
  "Dónde enseñas. Aparece en los paquetes, las inscripciones y la solicitud para padres.",
  "Kung saan ka nagtuturo. Lalabas sa mga package, enrollment, at sa application ng magulang."
 ],
 "Add location": [
  "Agregar ubicación",
  "Magdagdag ng lokasyon"
 ],
 "How do you teach?": [
  "¿Cómo enseñas?",
  "Paano ka nagtuturo?"
 ],
 "Mobile-only? You can skip this. Adding a \"home base\" helps families see your service area.": [
  "¿Solo a domicilio? Puedes omitir esto. Agregar una \"base\" ayuda a las familias a ver tu área de servicio.",
  "Mobile-only? Maaari mo itong laktawan. Ang pagdagdag ng \"home base\" ay nakakatulong sa mga pamilya na makita ang service area mo."
 ],
 "Shown on packages and the parent application.": [
  "Se muestra en los paquetes y en la solicitud para padres.",
  "Ipinapakita sa mga package at sa application ng magulang."
 ],
 "No active locations yet. Add your first to start tagging packages.": [
  "Todavía no hay ubicaciones activas. Agrega la primera para comenzar a etiquetar paquetes.",
  "Wala pang active na lokasyon. Idagdag ang una mo para masimulan ang pag-tag ng mga package."
 ],
 "Archived": [
  "Archivado",
  "Na-archive"
 ],
 "Reactivate": [
  "Reactivar",
  "I-reactivate"
 ],
 "Edit location": [
  "Editar ubicación",
  "I-edit ang lokasyon"
 ],
 "Required: name + address. Notes are visible to parents.": [
  "Obligatorio: nombre + dirección. Las notas son visibles para los padres.",
  "Required: pangalan + address. Nakikita ng mga magulang ang mga note."
 ],
 "(e.g. North Pool)": [
  "(p. ej., Piscina Norte)",
  "(hal. North Pool)"
 ],
 "Street, City, State Zip": [
  "Calle, Ciudad, Estado, Código postal",
  "Street, City, State Zip"
 ],
 "Zip": [
  "Código postal",
  "Zip"
 ],
 "Notes for parents": [
  "Notas para los padres",
  "Mga note para sa mga magulang"
 ],
 "e.g. Park behind the rec centre. Heated pool.": [
  "p. ej., Parque detrás del centro recreativo. Piscina climatizada.",
  "hal. Mag-park sa likod ng rec centre. Heated pool."
 ],
 "Archive location?": [
  "¿Archivar ubicación?",
  "I-archive ang lokasyon?"
 ],
 "Archiving": [
  "Archivando",
  "Ina-archive"
 ],
 "hides it from the package picker and the parent application form. You can optionally move every active package and enrollment to a different location in one click.": [
  "la oculta del selector de paquetes y del formulario de solicitud para padres. Opcionalmente, puedes mover todos los paquetes e inscripciones activos a una ubicación diferente con un solo clic.",
  "itatago ito sa package picker at sa parent application form. Maaari mong ilipat ang bawat active na package at enrollment sa ibang lokasyon sa isang click."
 ],
 "Move active packages + enrollments to…": [
  "Mover paquetes e inscripciones activos a…",
  "Ilipat ang mga active na package at enrollment sa…"
 ],
 "Keep them tagged with this location": [
  "Mantenerlos etiquetados con esta ubicación",
  "Panatilihing naka-tag sa lokasyong ito"
 ],
 "Don't move — keep tagged with this location": [
  "No mover — mantener etiquetados con esta ubicación",
  "Huwag ilipat — panatilihing naka-tag sa lokasyong ito"
 ],
 "Archiving…": [
  "Archivando…",
  "Ina-archive…"
 ],
 "Archive location": [
  "Archivar ubicación",
  "I-archive ang lokasyon"
 ],
 "Archive": [
  "Archivar",
  "I-archive"
 ],
 "Could not load marketing data. Refresh to try again.": [
  "No se pudieron cargar los datos de marketing. Actualiza para volver a intentarlo.",
  "Hindi ma-load ang marketing data. I-refresh para subukan ulit."
 ],
 "That URL should start with https:// — try copying it again from your Google Business page.": [
  "Esa URL debe comenzar con https:// — intenta copiarla de nuevo desde tu página de Google Business.",
  "Dapat magsimula sa https:// ang URL na iyon — subukang kopyahin ulit ito mula sa iyong Google Business page."
 ],
 "Marketing your business": [
  "Promociona tu negocio",
  "Marketing ng negosyo mo"
 ],
 "Step-by-step guides": [
  "Guías paso a paso",
  "Step-by-step na mga gabay"
 ],
 "Tap any topic to expand the walkthrough.": [
  "Toca cualquier tema para expandir la guía.",
  "I-tap ang anumang paksa para i-expand ang walkthrough."
 ],
 "Step 1": [
  "Paso 1",
  "Step 1"
 ],
 "Create your Google Business Profile (15 minutes, free)": [
  "Crea tu Perfil de Empresa en Google (15 minutos, gratis)",
  "Gawin ang iyong Google Business Profile (15 minuto, libre)"
 ],
 "Go to": [
  "Ir a",
  "Pumunta sa"
 ],
 "google.com/business": [
  "google.com/business",
  "google.com/business"
 ],
 "and click": [
  "y haz clic",
  "at i-click"
 ],
 "Manage now": [
  "Administrar ahora",
  "Pamahalaan ngayon"
 ],
 "Sign in with the Google account you want to manage the business from (your coaching email is ideal — keeps it separate from personal).": [
  "Inicia sesión con la cuenta de Google desde la que quieres administrar el negocio (tu correo de instructor es ideal; así lo mantienes separado de lo personal).",
  "Mag-sign in gamit ang Google account na gusto mong gamitin sa pag-manage ng negosyo (mainam ang iyong coaching email — para hiwalay ito sa personal)."
 ],
 "Type your business name (e.g.": [
  "Escribe el nombre de tu negocio (p. ej.",
  "I-type ang pangalan ng negosyo mo (hal."
 ],
 "\"Sunset Swim Coaching\"": [
  "\"Sunset Swim Coaching\"",
  "\"Sunset Swim Coaching\""
 ],
 "). If Google suggests a match, claim it — otherwise click": [
  "). Si Google sugiere una coincidencia, reclámala; de lo contrario, haz clic en",
  "). Kung may imungkahing tugma ang Google, i-claim ito — kung wala, i-click ang"
 ],
 "Add your business to Google": [
  "Añade tu negocio a Google",
  "Idagdag ang negosyo mo sa Google"
 ],
 "Pick the category:": [
  "Elige la categoría:",
  "Piliin ang kategorya:"
 ],
 "Swimming Instructor": [
  "Instructor de natación",
  "Swimming coach"
 ],
 "(most accurate) or": [
  "(la más precisa) o",
  "(pinakatumpak) o"
 ],
 "Swim School": [
  "Escuela de natación",
  "Swim School"
 ],
 "For location, choose": [
  "Para la ubicación, elige",
  "Para sa lokasyon, piliin ang"
 ],
 "\"I deliver goods and services to my customers\"": [
  "\"Entrego bienes y servicios a mis clientes\"",
  "\"I deliver goods and services to my customers\""
 ],
 "if you travel to clients, or": [
  "si te desplazas hasta los clientes, o",
  "kung bumibiyahe ka papunta sa mga kliyente, o"
 ],
 "\"I serve customers at a business address\"": [
  "\"Atiendo a los clientes en la dirección de la empresa\"",
  "\"I serve customers at a business address\""
 ],
 "if you have a fixed pool.": [
  "si tienes una piscina fija.",
  "kung may nakapirming pool ka."
 ],
 "Add the cities / zip codes you serve so you show up in their local results.": [
  "Añade las ciudades / códigos postales donde prestas servicio para aparecer en sus resultados locales.",
  "Idagdag ang mga lungsod / zip code na sineserbisyuhan mo para lumabas ka sa kanilang local results."
 ],
 "Enter your contact info: phone number + your SplashPad page URL (": [
  "Introduce tu información de contacto: número de teléfono + la URL de tu página de SplashPad (",
  "Ilagay ang contact info mo: numero ng telepono + URL ng iyong SplashPad page ("
 ],
 "Verify ownership — Google will mail you a postcard or call/text a code. This takes 5–14 days for postcard.": [
  "Verifica la propiedad: Google te enviará una postal o te llamará/enviará por SMS un código. Esto tarda de 5 a 14 días en el caso de la postal.",
  "I-verify ang pagmamay-ari — padadalhan ka ng Google ng postcard o tatawag/magte-text ng code. Tumatagal ito ng 5–14 araw para sa postcard."
 ],
 "Once verified, come back here and paste your profile URL above": [
  "Una vez verificado, vuelve aquí y pega la URL de tu perfil arriba",
  "Kapag verified na, bumalik dito at i-paste ang profile URL mo sa itaas"
 ],
 "— after upgrading to Pro": [
  "— después de actualizar a Pro",
  "— pagkatapos mag-upgrade sa Pro"
 ],
 "Step 2": [
  "Paso 2",
  "Hakbang 2"
 ],
 "Attach your SplashPad landing page as your \"Website\"": [
  "Adjunta tu página de destino de SplashPad como tu \"Sitio web\"",
  "Idagdag ang iyong SplashPad landing page bilang iyong \"Website\""
 ],
 "Open your Google Business profile dashboard.": [
  "Abre el panel de tu perfil de Google Business.",
  "Buksan ang dashboard ng iyong Google Business profile."
 ],
 "Edit profile": [
  "Editar perfil",
  "I-edit ang profile"
 ],
 "Paste your SplashPad page URL:": [
  "Pega la URL de tu página de SplashPad:",
  "I-paste ang URL ng iyong SplashPad page:"
 ],
 "Save. Within a few hours every parent who finds you on Google can click": [
  "Guarda. En unas horas, todos los padres que te encuentren en Google podrán hacer clic",
  "I-save. Sa loob ng ilang oras, bawat magulang na makakakita sa iyo sa Google ay makaka-click"
 ],
 "to jump straight to your SplashPad page and apply.": [
  "para ir directamente a tu página de SplashPad y solicitar.",
  "para dumiretso sa iyong SplashPad page at mag-apply."
 ],
 "Pro tip:": [
  "Consejo profesional:",
  "Pro tip:"
 ],
 "In your Google profile, also paste your SplashPad URL as the": [
  "En tu perfil de Google, pega también tu URL de SplashPad como el",
  "Sa iyong Google profile, i-paste rin ang iyong SplashPad URL bilang"
 ],
 "Appointment link": [
  "Enlace de cita",
  "Appointment link"
 ],
 ". That adds a dedicated": [
  ". Eso añade un botón dedicado de",
  ". Magdadagdag iyon ng nakalaang"
 ],
 "Book": [
  "Reservar",
  "Book"
 ],
 "button to your Google listing.": [
  "botón a tu ficha de Google.",
  "button sa iyong Google listing."
 ],
 "Local Facebook groups": [
  "Grupos locales de Facebook",
  "Mga lokal na Facebook group"
 ],
 "— many neighborhoods have \"Moms of [City]\" groups. Drop the link when someone asks for recommendations.": [
  "— muchos vecindarios tienen grupos de \"Mamás de [City]\". Comparte el enlace cuando alguien pida recomendaciones.",
  "— maraming kapitbahayan ang may mga group na \"Moms of [City]\". I-drop ang link kapag may humihingi ng rekomendasyon."
 ],
 "Physical signage": [
  "Señalización física",
  "Pisikal na signage"
 ],
 "— pool deck signs, business cards with a QR code linking to your page.": [
  "— letreros en la zona de la piscina, tarjetas de presentación con un código QR que enlace a tu página.",
  "— mga sign sa pool deck, mga business card na may QR code na naka-link sa page mo."
 ],
 "Make sure your page is ready first": [
  "Asegúrate primero de que tu página esté lista",
  "Siguraduhing handa muna ang page mo"
 ],
 "Before you drive traffic, double-check these in SplashPad:": [
  "Antes de dirigir tráfico, verifica esto en SplashPad:",
  "Bago ka magpadala ng traffic, i-double-check ang mga ito sa SplashPad:"
 ],
 "Customize your landing page": [
  "Personaliza tu página de destino",
  "I-customize ang landing page mo"
 ],
 "Add 2–3 clear packages": [
  "Agrega 2–3 paquetes claros",
  "Magdagdag ng 2–3 malinaw na package"
 ],
 "Set your service area in Settings": [
  "Configura tu área de servicio en Configuración",
  "Itakda ang service area mo sa Settings"
 ],
 "Add at least 2 reviews": [
  "Agrega al menos 2 reseñas",
  "Magdagdag ng hindi bababa sa 2 review"
 ],
 "Google Business Profile": [
  "Perfil de Negocio de Google",
  "Google Business Profile"
 ],
 "Connected": [
  "Conectado",
  "Connected"
 ],
 "Not yet connected": [
  "Aún no conectado",
  "Hindi pa connected"
 ],
 "A free Google Business Profile is the single highest-leverage marketing move you can make. When parents search": [
  "Un Perfil de Negocio de Google gratuito es la acción de marketing de mayor impacto que puedes hacer. Cuando los padres buscan",
  "Ang libreng Google Business Profile ang pinakaepektibong marketing move na puwede mong gawin. Kapag naghahanap ang mga magulang ng"
 ],
 "\"swim lessons near me\"": [
  "\"clases de natación cerca de mí\"",
  "\"swim lessons near me\""
 ],
 ", Google shows the local map results": [
  ", Google muestra primero los resultados del mapa local",
  ", unang ipinapakita ng Google ang mga lokal na resulta sa mapa"
 ],
 "first": [
  "primero",
  "muna"
 ],
 "— and businesses with profiles appear there. Connect yours below and we'll": [
  "— y los negocios con perfiles aparecen allí. Conecta el tuyo abajo y",
  "— at doon lumalabas ang mga negosyong may profile. Ikonekta ang sa iyo sa ibaba at"
 ],
 "automatically show your Google reviews on your SplashPad landing page": [
  "mostraremos automáticamente tus reseñas de Google en tu página de destino de SplashPad",
  "awtomatiko naming ipapakita ang mga Google review mo sa iyong SplashPad landing page"
 ],
 "Your Google Business profile URL": [
  "La URL de tu Perfil de Negocio de Google",
  "URL ng iyong Google Business Profile"
 ],
 "Open my Google profile": [
  "Abrir mi perfil de Google",
  "Buksan ang Google profile ko"
 ],
 "Reviews now live on your landing page": [
  "Las reseñas ya están publicadas en tu página de destino",
  "Live na ngayon ang mga review sa landing page mo"
 ],
 "Find your URL: open your Google Business page → click": [
  "Encuentra tu URL: abre tu página de Google Business → haz clic en",
  "Hanapin ang URL mo: buksan ang Google Business page mo → i-click ang"
 ],
 "→ copy the short link.": [
  "→ copia el enlace corto.",
  "→ kopyahin ang short link."
 ],
 "Google Business + Auto-Reviews": [
  "Google Business + Reseñas automáticas",
  "Google Business + Auto-Reviews"
 ],
 "Pro only": [
  "Solo Pro",
  "Pro lang"
 ],
 "Connect your Google Business profile and we'll": [
  "Conecta tu Perfil de Negocio de Google y",
  "Ikonekta ang Google Business Profile mo at"
 ],
 "automatically pull your 5-star reviews onto your SplashPad landing page": [
  "importaremos automáticamente tus reseñas de 5 estrellas a tu página de destino de SplashPad",
  "awtomatiko naming kukunin ang iyong mga 5-star review papunta sa iyong SplashPad landing page"
 ],
 "— no manual entry, no copy-pasting. Plus you get our full local-SEO playbook so parents searching": [
  "— sin ingreso manual ni copiar y pegar. Además, obtienes nuestra guía completa de SEO local para que los padres que buscan",
  "— walang manual entry, walang copy-paste. Dagdag pa, makukuha mo ang buo naming local-SEO playbook para ang mga magulang na naghahanap ay"
 ],
 "find": [
  "encuentren",
  "mahanap"
 ],
 "you": [
  "a ti",
  "ka"
 ],
 "first.": [
  "primero.",
  "muna."
 ],
 "One-click Google Business connector": [
  "Conector de Google Business con un clic",
  "One-click Google Business connector"
 ],
 "Live Google reviews on your landing page": [
  "Reseñas de Google en vivo en tu página de destino",
  "Live na Google reviews sa landing page mo"
 ],
 "Local-SEO playbook + Google review request templates": [
  "Guía de SEO local + plantillas de solicitud de reseñas de Google",
  "Local-SEO playbook + mga template ng paghingi ng Google review"
 ],
 "Branded landing page + custom domain support": [
  "Página de destino con marca + compatibilidad con dominio personalizado",
  "Branded na landing page + support sa custom domain"
 ],
 "Upgrade to Pro — $79.99/mo": [
  "Actualizar a Pro — $79.99/mes",
  "Mag-upgrade sa Pro — $79.99/mo"
 ],
 "Cancel anytime. 7-day taste of Pro included.": [
  "Cancela en cualquier momento. Incluye una prueba de Pro de 7 días.",
  "Kanselahin anumang oras. May kasamang 7-araw na taste ng Pro."
 ],
 "5.0 · 24 Google reviews": [
  "5.0 · 24 reseñas de Google",
  "5.0 · 24 Google reviews"
 ],
 "Sarah P.": [
  "Sarah P.",
  "Sarah P."
 ],
 "— \"Best swim coach in the area. My son went from terrified to swimming laps in 6 lessons!\"": [
  "— \"El mejor instructor de natación del área. ¡Mi hijo pasó de estar aterrorizado a nadar largos en 6 lecciones!\"",
  "— \"Best swim coach sa area. Mula takot na takot ang anak ko hanggang nakakalangoy na ng laps sa 6 lessons!\""
 ],
 "Mike R.": [
  "Mike R.",
  "Mike R."
 ],
 "— \"Patient, professional, and great with kids. Highly recommend.\"": [
  "— \"Paciente, profesional y excelente con los niños. Lo recomiendo mucho.\"",
  "— \"Pasensiyoso, propesyonal, at mahusay sa mga bata. Highly recommend.\""
 ],
 "↑ Auto-imported on your landing page (Pro)": [
  "↑ Importado automáticamente en tu página de destino (Pro)",
  "↑ Auto-imported sa landing page mo (Pro)"
 ],
 "Coach community · 7-day free trial": [
  "Comunidad de instructores · prueba gratis de 7 días",
  "Coach community · 7-day free trial"
 ],
 "Connect with hundreds of swim business experts.": [
  "Conéctate con cientos de expertos en negocios de natación.",
  "Makipag-ugnayan sa daan-daang eksperto sa swim business."
 ],
 "Inside": [
  "Dentro de",
  "Sa loob ng"
 ],
 "Superhero Swim University": [
  "Superhero Swim University",
  "Superhero Swim University"
 ],
 "on SKOOL, you'll connect with elite swim coaches from around the world. Pricing, marketing, retention, scheduling — they share what's working in real time. Start with a": [
  "en SKOOL, te conectarás con instructores de natación de élite de todo el mundo. Precios, marketing, retención, programación — comparten lo que funciona en tiempo real. Empieza con una",
  "sa SKOOL, makakakonekta ka sa mga elite swim coach mula sa buong mundo. Pricing, marketing, retention, scheduling — ibinabahagi nila kung ano ang gumagana nang real time. Magsimula sa isang"
 ],
 "free 7-day trial": [
  "prueba gratis de 7 días",
  "libreng 7-day trial"
 ],
 ", then continue at the SKOOL community rate.": [
  ", luego continúa con la tarifa de la comunidad de SKOOL.",
  ", pagkatapos ay magpatuloy sa SKOOL community rate."
 ],
 "Hundreds of experts in one community": [
  "Cientos de expertos en una sola comunidad",
  "Daan-daang eksperto sa iisang komunidad"
 ],
 "Weekly group calls + recorded archive": [
  "Llamadas grupales semanales + archivo de grabaciones",
  "Lingguhang group calls + recorded archive"
 ],
 "Templates: contracts, marketing, intake forms": [
  "Plantillas: contratos, marketing, formularios de admisión",
  "Templates: contracts, marketing, intake forms"
 ],
 "Start 7-day free trial": [
  "Iniciar prueba gratis de 7 días",
  "Simulan ang libreng 7-day trial"
 ],
 "Google": [
  "Google",
  "Google"
 ],
 "swim lessons near me": [
  "clases de natación cerca de mí",
  "swim lessons near me"
 ],
 "5.0 · 24 reviews": [
  "5.0 · 24 reseñas",
  "5.0 · 24 reviews"
 ],
 "Swimming Instructor · Open today": [
  "Instructor de natación · Abierto hoy",
  "Swimming Instructor · Bukas ngayon"
 ],
 "Website → splashpad.pro": [
  "Sitio web → splashpad.pro",
  "Website → splashpad.pro"
 ],
 "↑ Example of how you'll appear on Google": [
  "↑ Ejemplo de cómo aparecerás en Google",
  "↑ Halimbawa ng magiging itsura mo sa Google"
 ],
 "Display name is required": [
  "El nombre para mostrar es obligatorio",
  "Kinakailangan ang display name"
 ],
 "Please pick your timezone before continuing.": [
  "Elige tu zona horaria antes de continuar.",
  "Pakipili ang iyong timezone bago magpatuloy."
 ],
 "Slug is required": [
  "El slug es obligatorio",
  "Kinakailangan ang slug"
 ],
 "Step": [
  "Paso",
  "Hakbang"
 ],
 "Feeling overwhelmed? Let SplashPad set itself up": [
  "¿Te sientes abrumado? Deja que SplashPad se configure solo",
  "Nao-overwhelm ka ba? Hayaan ang SplashPad na mag-set up ng sarili nito"
 ],
 "Answer ~15 quick questions and we'll fill in your profile, configure your settings, and build your first classes for you. Takes about 3 minutes and you can edit everything after.": [
  "Responde ~15 preguntas rápidas y completaremos tu perfil, configuraremos tus ajustes y crearemos tus primeras clases por ti. Toma unos 3 minutos y luego puedes editarlo todo.",
  "Sagutin ang ~15 maiikling tanong at pupunan namin ang profile mo, iko-configure ang settings mo, at bubuuin ang mga una mong klase para sa iyo. Aabutin ng mga 3 minuto at maaari mong i-edit ang lahat pagkatapos."
 ],
 "Start wizard →": [
  "Iniciar asistente →",
  "Simulan ang wizard →"
 ],
 "Tell us about you": [
  "Cuéntanos sobre ti",
  "Sabihin sa amin ang tungkol sa iyo"
 ],
 "Parents will see this on your registration page.": [
  "Los padres verán esto en tu página de registro.",
  "Makikita ito ng mga magulang sa registration page mo."
 ],
 "Why this matters:": [
  "Por qué esto importa:",
  "Bakit ito mahalaga:"
 ],
 "Most parents searching \"swim lessons near me\" never visit your social pages — they click the website link straight from Google's local map. Sending them to your SplashPad page (which already has Apply / Book buttons) converts them into paying clients without leaving Google.": [
  "La mayoría de los padres que buscan \"clases de natación cerca de mí\" nunca visitan tus páginas sociales: hacen clic en el enlace del sitio web directamente desde el mapa local de Google. Enviarlos a tu página de SplashPad (que ya tiene botones de Apply / Book) los convierte en clientes de pago sin salir de Google.",
  "Karamihan sa mga magulang na naghahanap ng \"swim lessons near me\" ay hindi na bumibisita sa iyong mga social page — dina-click nila agad ang website link mula sa local map ng Google. Ang pagdadala sa kanila sa iyong SplashPad page (na may Apply / Book buttons na) ay nagko-convert sa kanila bilang nagbabayad na kliyente nang hindi umaalis sa Google."
 ],
 "Step 3": [
  "Paso 3",
  "Hakbang 3"
 ],
 "Get your first 10 Google reviews (this is the game-changer)": [
  "Consigue tus primeras 10 reseñas en Google (esto cambia el juego)",
  "Kunin ang iyong unang 10 Google review (ito ang game-changer)"
 ],
 "Coaches with 10+ five-star reviews rank dramatically higher in local Google results — usually within the top 3, which is where 75% of clicks go.": [
  "Los instructores con más de 10 reseñas de cinco estrellas aparecen mucho más arriba en los resultados locales de Google, por lo general entre los 3 primeros, que es donde se concentra el 75% de los clics.",
  "Ang mga coach na may 10+ five-star review ay mas mataas ang ranggo sa mga lokal na resulta ng Google — karaniwan ay nasa top 3, kung saan napupunta ang 75% ng mga click."
 ],
 "Bonus: reviews will appear automatically on your SplashPad landing page once your Google profile is connected.": [
  "Extra: las reseñas aparecerán automáticamente en tu página de destino de SplashPad una vez que tu perfil de Google esté conectado.",
  "Bonus: awtomatikong lalabas ang mga review sa iyong SplashPad landing page kapag nakakonekta na ang iyong Google profile."
 ],
 "Inside your Google Business dashboard, click": [
  "Dentro del panel de Google Business, haz clic en",
  "Sa loob ng iyong Google Business dashboard, i-click ang"
 ],
 "Get more reviews": [
  "Obtener más reseñas",
  "Kumuha ng mas maraming review"
 ],
 "Share review form": [
  "Compartir formulario de reseña",
  "Ibahagi ang review form"
 ],
 "and copy that link.": [
  "y copia ese enlace.",
  "at kopyahin ang link na iyon."
 ],
 "After each lesson when a parent says something nice, send them the link the same day with a short message:": [
  "Después de cada clase, cuando un padre diga algo positivo, envíale el enlace ese mismo día con un mensaje breve:",
  "Pagkatapos ng bawat lesson, kapag may magulang na nagsabi ng maganda, ipadala sa kanila ang link sa mismong araw na iyon kasama ang maikling mensahe:"
 ],
 "\"Loved hearing that today! Mind sharing on Google? Takes 30 seconds: [link]\"": [
  "\"¡Me encantó escuchar eso hoy! ¿Te importaría compartirlo en Google? Toma 30 segundos: [link]\"",
  "\"Loved hearing that today! Mind sharing on Google? Takes 30 seconds: [link]\""
 ],
 "Send the link in your monthly client emails too — your warmest fans are your easiest 5-star reviews.": [
  "Envía también el enlace en tus correos mensuales a clientes: tus seguidores más fieles son tus reseñas de 5 estrellas más fáciles de conseguir.",
  "Isama rin ang link sa iyong buwanang client emails — ang pinakamainit mong supporters ang pinakamadaling pagmulan ng 5-star reviews."
 ],
 "Never": [
  "Nunca",
  "Huwag kailanman"
 ],
 "offer discounts or freebies for reviews — Google detects this and can remove your listing.": [
  "ofrezcas descuentos ni regalos a cambio de reseñas: Google detecta esto y puede eliminar tu ficha.",
  "mag-alok ng discount o freebies kapalit ng reviews — nade-detect ito ng Google at maaari nitong alisin ang iyong listing."
 ],
 "Reply to every review (especially negative ones — calmly, professionally). Active replies also boost SEO.": [
  "Responde a cada reseña (especialmente a las negativas, con calma y profesionalismo). Las respuestas activas también mejoran el SEO.",
  "Sagutin ang bawat review (lalo na ang mga negatibo — nang mahinahon at propesyonal). Nakakatulong din ang aktibong mga reply sa SEO."
 ],
 "Bonus": [
  "Extra",
  "Bonus"
 ],
 "Local SEO basics: keywords, photos, posts": [
  "Conceptos básicos de SEO local: palabras clave, fotos, publicaciones",
  "Mga basic ng local SEO: keywords, photos, posts"
 ],
 "Add 10+ photos": [
  "Añade más de 10 fotos",
  "Magdagdag ng 10+ larawan"
 ],
 "to your Google profile — pool shots, kids learning (with parent permission), you teaching. Profiles with photos get 42% more direction requests.": [
  "a tu perfil de Google: fotos de la piscina, niños aprendiendo (con permiso de los padres), tú enseñando. Los perfiles con fotos reciben un 42% más de solicitudes de indicaciones.",
  "sa iyong Google profile — mga kuha ng pool, mga batang natututo (na may pahintulot ng magulang), ikaw habang nagtuturo. Ang mga profile na may mga larawan ay nakakakuha ng 42% na mas maraming direction requests."
 ],
 "Use the right keywords": [
  "Usa las palabras clave correctas",
  "Gamitin ang tamang keywords"
 ],
 "in your business description: \"private swim lessons\", \"[your city] swim coach\", \"learn to swim\", \"competitive swim coaching\", \"infant water safety\".": [
  "en la descripción de tu negocio: \"clases privadas de natación\", \"instructor de natación en [your city]\", \"aprender a nadar\", \"entrenamiento competitivo de natación\", \"seguridad acuática para bebés\".",
  "sa iyong business description: \"private swim lessons\", \"[your city] swim coach\", \"learn to swim\", \"competitive swim coaching\", \"infant water safety\"."
 ],
 "Post weekly updates": [
  "Publica actualizaciones semanales",
  "Mag-post ng lingguhang updates"
 ],
 "— \"Welcoming a new summer cohort!\", \"Open spots for Saturday lessons\", etc. Recent activity is a major ranking factor.": [
  "— \"¡Damos la bienvenida a un nuevo grupo de verano!\", \"Lugares disponibles para las clases del sábado\", etc. La actividad reciente es un factor importante de posicionamiento.",
  "— \"Welcoming a new summer cohort!\", \"Open spots for Saturday lessons\", atbp. Ang kamakailang aktibidad ay isang mahalagang ranking factor."
 ],
 "Fill out every field": [
  "Completa todos los campos",
  "Punan ang bawat field"
 ],
 "— hours, attributes, services. Google rewards completeness.": [
  "— horario, atributos, servicios. Google recompensa la información completa.",
  "— oras, attributes, services. Ginagantimpalaan ng Google ang pagiging kumpleto."
 ],
 "Encourage Q&A": [
  "Fomenta las preguntas y respuestas",
  "Hikayatin ang Q&A"
 ],
 "— pre-seed answers to questions like \"What ages do you teach?\" so they appear publicly.": [
  "— deja preparadas respuestas a preguntas como \"¿Qué edades enseñas?\" para que aparezcan públicamente.",
  "— maghanda na ng mga sagot sa mga tanong tulad ng \"What ages do you teach?\" para lumabas ang mga ito sa publiko."
 ],
 "Where else to put your SplashPad link": [
  "Dónde más poner tu enlace de SplashPad",
  "Saan pa ilalagay ang iyong SplashPad link"
 ],
 "Instagram bio": [
  "Biografía de Instagram",
  "Instagram bio"
 ],
 "— every coach should have this in their bio link. Use a free Linktree if you have multiple links.": [
  "— cada instructor debería tener esto en el enlace de su biografía. Usa un Linktree gratis si tienes varios enlaces.",
  "— dapat ilagay ito ng bawat coach sa kanilang bio link. Gumamit ng libreng Linktree kung marami kang links."
 ],
 "Facebook page \"About\"": [
  "Sección \"Información\" de la página de Facebook",
  "Facebook page \"About\""
 ],
 "— paste your URL as your website.": [
  "— pega tu URL como sitio web.",
  "— i-paste ang iyong URL bilang iyong website."
 ],
 "Email signature": [
  "Firma de correo electrónico",
  "Email signature"
 ],
 "— Gmail / Apple Mail signatures linking to your SplashPad page.": [
  "— firmas de Gmail / Apple Mail con enlace a tu página de SplashPad.",
  "— Gmail / Apple Mail signatures na naka-link sa iyong SplashPad page."
 ],
 "Marina’s Swim School": [
  "Marina’s Swim School",
  "Marina’s Swim School"
 ],
 "Years of experience": [
  "Años de experiencia",
  "Mga taon ng karanasan"
 ],
 "e.g. 5": [
  "p. ej., 5",
  "hal. 5"
 ],
 "Profile photo (optional)": [
  "Foto de perfil (opcional)",
  "Larawan sa profile (opsyonal)"
 ],
 "Short bio": [
  "Biografía breve",
  "Maikling bio"
 ],
 "Certifications": [
  "Certificaciones",
  "Mga sertipikasyon"
 ],
 "e.g. WSI, CPR": [
  "p. ej., WSI, CPR",
  "hal. WSI, CPR"
 ],
 "Where do you teach?": [
  "¿Dónde enseñas?",
  "Saan ka nagtuturo?"
 ],
 "Primary pool / facility": [
  "Piscina / instalación principal",
  "Pangunahing pool / pasilidad"
 ],
 "Travel to clients’ homes": [
  "Desplazamiento a los hogares de los clientes",
  "Pumupunta sa mga bahay ng kliyente"
 ],
 "Toggle on if you teach at clients’ pools.": [
  "Actívalo si enseñas en las piscinas de tus clientes.",
  "I-on ito kung nagtuturo ka sa mga pool ng mga kliyente."
 ],
 "Service area": [
  "Área de servicio",
  "Saklaw na lugar"
 ],
 "e.g. Bay Area, CA": [
  "p. ej., Bay Area, CA",
  "hal. Bay Area, CA"
 ],
 "Confirm your timezone": [
  "Confirma tu zona horaria",
  "Kumpirmahin ang iyong time zone"
 ],
 "Parents see your class times in this timezone. Setting it right here prevents the “my class shows the wrong hour” bug.": [
  "Los padres ven los horarios de tus clases en esta zona horaria. Configurarla correctamente aquí evita el error de “mi clase aparece a una hora incorrecta”.",
  "Nakikita ng mga magulang ang oras ng iyong mga klase sa time zone na ito. Ang tamang pag-set nito rito ay nakakaiwas sa bug na “maling oras ang ipinapakita sa klase ko”."
 ],
 "Detected from your browser": [
  "Detectada desde tu navegador",
  "Na-detect mula sa iyong browser"
 ],
 "Your saved timezone": [
  "Tu zona horaria guardada",
  "Iyong naka-save na time zone"
 ],
 "We couldn't detect your timezone from your browser.": [
  "No pudimos detectar tu zona horaria desde tu navegador.",
  "Hindi namin ma-detect ang iyong time zone mula sa iyong browser."
 ],
 "Please pick your local timezone below so parents see your class times correctly.": [
  "Elige tu zona horaria local a continuación para que los padres vean correctamente los horarios de tus clases.",
  "Piliin ang iyong lokal na time zone sa ibaba para makita nang tama ng mga magulang ang oras ng iyong mga klase."
 ],
 "Pick your timezone…": [
  "Elige tu zona horaria…",
  "Piliin ang iyong time zone…"
 ],
 "Done picking": [
  "Listo",
  "Tapos na pumili"
 ],
 "Brand your page": [
  "Personaliza tu página",
  "I-brand ang iyong page"
 ],
 "Logo (optional)": [
  "Logo (opcional)",
  "Logo (opsyonal)"
 ],
 "Primary brand color": [
  "Color principal de la marca",
  "Pangunahing kulay ng brand"
 ],
 "Page URL slug": [
  "Slug de URL de la página",
  "URL slug ng page"
 ],
 "/coach/": [
  "/instructor/",
  "/coach/"
 ],
 "yourname": [
  "tunombre",
  "pangalanmo"
 ],
 "Pick your plan": [
  "Elige tu plan",
  "Piliin ang iyong plan"
 ],
 "Free for the first 30 days. Cancel anytime.": [
  "Gratis durante los primeros 30 días. Cancela cuando quieras.",
  "Libre sa unang 30 araw. Kanselahin anumang oras."
 ],
 "⭐ POPULAR": [
  "⭐ POPULAR",
  "⭐ POPULAR"
 ],
 "Get paid by parents": [
  "Recibe pagos de los padres",
  "Mabayaran ng mga magulang"
 ],
 "Connect your bank account through Stripe so parents can pay you with a card directly inside SplashPad. Takes about 5 minutes — you'll need your business info and bank routing/account numbers.": [
  "Conecta tu cuenta bancaria a través de Stripe para que los padres puedan pagarte con tarjeta directamente dentro de SplashPad. Toma unos 5 minutos; necesitarás la información de tu negocio y los números de ruta y de cuenta bancaria.",
  "Ikonekta ang iyong bank account sa pamamagitan ng Stripe para makapagbayad sa iyo ang mga magulang gamit ang card direkta sa loob ng SplashPad. Aabutin ito ng humigit-kumulang 5 minuto — kakailanganin mo ang impormasyon ng iyong negosyo at ang iyong bank routing/account numbers."
 ],
 "You can skip this for now and use SplashPad as a CRM if you prefer Venmo/Zelle — but you won't be able to activate packages with online payment until Stripe is connected.": [
  "Puedes omitir esto por ahora y usar SplashPad como CRM si prefieres Venmo/Zelle, pero no podrás activar paquetes con pago en línea hasta que conectes Stripe.",
  "Maaari mo muna itong laktawan at gamitin ang SplashPad bilang CRM kung mas gusto mo ang Venmo/Zelle — pero hindi mo maa-activate ang mga package na may online payment hangga't hindi nakakonekta ang Stripe."
 ],
 "You're live!": [
  "¡Ya estás en vivo!",
  "Live ka na!"
 ],
 "One last thing — set up payment so you can keep using SplashPad after your free trial.": [
  "Una última cosa: configura los pagos para que puedas seguir usando SplashPad después de tu prueba gratuita.",
  "Isang huling bagay — i-set up ang payment para patuloy mong magamit ang SplashPad pagkatapos ng iyong libreng trial."
 ],
 "Set up payment —": [
  "Configurar pagos —",
  "I-set up ang bayad —"
 ],
 "Add your card on Stripe to keep your account after your free trial. You won't be charged until the trial ends — cancel anytime from Billing.": [
  "Agrega tu tarjeta en Stripe para mantener tu cuenta después de la prueba gratis. No se te cobrará hasta que termine la prueba; cancela en cualquier momento desde Facturación.",
  "Idagdag ang iyong card sa Stripe para mapanatili ang iyong account pagkatapos ng libreng trial. Hindi ka sisingilin hanggang matapos ang trial — puwede kang magkansela anumang oras mula sa Billing."
 ],
 "Go to Your Subscription to add card": [
  "Ve a Tu suscripción para agregar una tarjeta",
  "Pumunta sa Iyong Subscription para magdagdag ng card"
 ],
 "Your registration page": [
  "Tu página de registro",
  "Ang iyong registration page"
 ],
 "Embed code:": [
  "Código de inserción:",
  "Embed code:"
 ],
 "Finish setup": [
  "Finalizar configuración",
  "Tapusin ang setup"
 ],
 "Skip for now": [
  "Omitir por ahora",
  "Laktawan muna"
 ],
 "Book your SplashPad Pro onboarding call": [
  "Reserva tu llamada de incorporación de SplashPad Pro",
  "I-book ang iyong SplashPad Pro onboarding call"
 ],
 "Pro perk": [
  "Beneficio Pro",
  "Pro perk"
 ],
 "The onboarding call is a Pro-only benefit": [
  "La llamada de incorporación es un beneficio exclusivo de Pro",
  "Ang onboarding call ay benepisyo lang ng Pro"
 ],
 "Upgrade to SplashPad Pro and you'll unlock a free 30-minute one-on-one onboarding session with Jake — plus the Pro landing-page editor, Google Reviews connector, advanced theming, and everything else in the Pro tier.": [
  "Actualiza a SplashPad Pro y desbloquearás una sesión gratuita de incorporación individual de 30 minutos con Jake, además del editor de páginas de destino Pro, el conector de Google Reviews, la personalización avanzada de temas y todo lo demás del nivel Pro.",
  "Mag-upgrade sa SplashPad Pro at maa-unlock mo ang libreng 30 minutong 1-on-1 onboarding session kasama si Jake — dagdag pa ang Pro landing-page editor, Google Reviews connector, advanced theming, at lahat ng iba pa sa Pro tier."
 ],
 "Onboarding calls are temporarily paused": [
  "Las llamadas de incorporación están en pausa temporalmente",
  "Pansamantalang naka-pause ang onboarding calls"
 ],
 "We've hit capacity on free onboarding sessions while we onboard our current Pro members. Join our": [
  "Hemos alcanzado la capacidad de sesiones gratuitas de incorporación mientras incorporamos a nuestros miembros actuales de Pro. Únete a nuestro",
  "Naabot na namin ang capacity para sa mga libreng onboarding session habang ino-onboard namin ang kasalukuyan naming mga Pro member. Sumali sa aming"
 ],
 "beta WhatsApp support group": [
  "grupo beta de soporte por WhatsApp",
  "beta WhatsApp support group"
 ],
 "and we'll help you as soon as a slot opens up. In the meantime, the in-app guides on each page will walk you through setup.": [
  "y te ayudaremos en cuanto se abra un lugar. Mientras tanto, las guías de la app en cada página te orientarán durante la configuración.",
  "at tutulungan ka namin sa sandaling may mabukas na slot. Samantala, gagabayan ka ng mga in-app guide sa bawat page sa setup."
 ],
 "Nice — we'll mark your onboarding call as scheduled on your dashboard.": [
  "Perfecto: marcaremos tu llamada de incorporación como programada en tu panel.",
  "Ayos — mamarkahan namin ang iyong onboarding call bilang naka-schedule sa iyong dashboard."
 ],
 "Could not save. Please try again.": [
  "No se pudo guardar. Inténtalo de nuevo.",
  "Hindi na-save. Pakisubukan ulit."
 ],
 "Pro perk · included": [
  "Beneficio Pro · incluido",
  "Pro perk · included"
 ],
 "Your free 30-minute onboarding call": [
  "Tu llamada de incorporación gratuita de 30 minutos",
  "Ang iyong libreng 30 minutong onboarding call"
 ],
 "Welcome to SplashPad Pro! Grab a spot on Jake's calendar below for a quick 1-on-1 walkthrough — he'll help you finish setting up your page, packages, and waiver so you can start accepting families this week.": [
  "¡Bienvenido a SplashPad Pro! Reserva un espacio en el calendario de Jake abajo para una guía rápida individual: te ayudará a terminar de configurar tu página, paquetes y exención para que puedas empezar a aceptar familias esta semana.",
  "Welcome sa SplashPad Pro! Pumili ng slot sa kalendaryo ni Jake sa ibaba para sa mabilis na 1-on-1 walkthrough — tutulungan ka niyang tapusin ang setup ng iyong page, packages, at waiver para makapagsimulang tumanggap ng families ngayong linggo."
 ],
 "30 min": [
  "30 min",
  "30 min"
 ],
 "Free · 1-on-1": [
  "Gratis · individual",
  "Libre · 1-on-1"
 ],
 "Booked your slot?": [
  "¿Reservaste tu horario?",
  "Na-book mo na ba ang iyong slot?"
 ],
 "Tap below to mark the call as scheduled — it'll clear the Quick Start reminder on your dashboard. You can still come back here to reschedule.": [
  "Toca abajo para marcar la llamada como programada; así se quitará el recordatorio de Inicio rápido de tu panel. Aún puedes volver aquí para reprogramarla.",
  "I-tap sa ibaba para markahan ang call bilang naka-schedule — aalisin nito ang Quick Start reminder sa iyong dashboard. Puwede ka pa ring bumalik dito para mag-reschedule."
 ],
 "I've scheduled my call": [
  "He programado mi llamada",
  "Na-schedule ko na ang aking call"
 ],
 "Calendar not loading?": [
  "¿No carga el calendario?",
  "Hindi naglo-load ang kalendaryo?"
 ],
 "Open the booking page directly": [
  "Abrir la página de reserva directamente",
  "Buksan nang direkta ang booking page"
 ],
 "You bill families directly": [
  "Cobras a las familias directamente",
  "Direkta kang naniningil sa mga pamilya"
 ],
 "Ready for payments": [
  "Listo para pagos",
  "Handa na para sa payments"
 ],
 "Tap to finish hooking this up to payments so parents can pay online": [
  "Toca para terminar de conectar esto a los pagos para que los padres puedan pagar en línea",
  "I-tap para tapusin ang pagkonekta nito sa payments para makapagbayad online ang mga magulang"
 ],
 "Stripe sync retried.": [
  "Sincronización de Stripe reintentada.",
  "Ni-retry ang Stripe sync."
 ],
 "Give your package a name.": [
  "Dale un nombre a tu paquete.",
  "Bigyan ng pangalan ang iyong package."
 ],
 "Price must be 0 or more.": [
  "El precio debe ser 0 o más.",
  "Ang presyo ay dapat 0 o higit pa."
 ],
 "Connect your Stripe account before activating packages.": [
  "Conecta tu cuenta de Stripe antes de activar paquetes.",
  "Ikonekta ang iyong Stripe account bago i-activate ang mga package."
 ],
 "Pick which location this package runs at.": [
  "Elige en qué ubicación se ofrece este paquete.",
  "Piliin kung saang lokasyon ginaganap ang package na ito."
 ],
 "Days": [
  "Días",
  "Mga araw"
 ],
 "Age": [
  "Edad",
  "Edad"
 ],
 "All ages": [
  "Todas las edades",
  "Lahat ng edad"
 ],
 "Teen": [
  "Adolescente",
  "Teen"
 ],
 "Adult": [
  "Adulto",
  "Adult"
 ],
 "Marked \"All\"": [
  "Marcado como \"Todos\"",
  "Minarkahan bilang \"All\""
 ],
 "All statuses": [
  "Todos los estados",
  "Lahat ng status"
 ],
 "Group the list": [
  "Agrupar la lista",
  "I-group ang listahan"
 ],
 "No classes yet": [
  "Aún no hay clases",
  "Wala pang mga klase"
 ],
 "No camps yet": [
  "Aún no hay campamentos",
  "Wala pang mga camp"
 ],
 "No packages yet": [
  "Aún no hay paquetes",
  "Wala pang mga package"
 ],
 "Build your first Class — a recurring weekly program with auto-billing. Add a start + end date to run it seasonally.": [
  "Crea tu primera clase: un programa semanal recurrente con cobro automático. Agrega una fecha de inicio y una de fin para ofrecerla por temporada.",
  "Buuin ang una mong Class — isang umuulit na lingguhang programa na may auto-billing. Magdagdag ng start at end date para patakbuhin ito nang pana-panahon."
 ],
 "Build your first Camp — pick the dates, the days of the week and a time, and we generate every session. Parents pay once.": [
  "Crea tu primer campamento: elige las fechas, los días de la semana y una hora, y generaremos cada sesión. Los padres pagan una sola vez.",
  "Buuin ang una mong Camp — piliin ang mga petsa, mga araw ng linggo, at oras, at gagawin namin ang bawat session. Isang beses lang magbabayad ang mga magulang."
 ],
 "Build your first Package — a fixed bundle of lessons or a single one-off lesson. Parents pay once.": [
  "Crea tu primer paquete: un conjunto fijo de clases o una sola clase puntual. Los padres pagan una sola vez.",
  "Buuin ang una mong Package — isang nakapirming bundle ng mga lesson o isang one-off na lesson. Isang beses lang magbabayad ang mga magulang."
 ],
 "Add Camp": [
  "Agregar campamento",
  "Magdagdag ng Camp"
 ],
 "No matches": [
  "Sin coincidencias",
  "Walang tugma"
 ],
 "Nothing in this tab matches your search / filters.": [
  "Nada en esta pestaña coincide con tu búsqueda o filtros.",
  "Walang tumutugma sa iyong paghahanap / filters sa tab na ito."
 ],
 "Clear filters": [
  "Borrar filtros",
  "I-clear ang filters"
 ],
 "Move up": [
  "Mover arriba",
  "Ilipat pataas"
 ],
 "Move down": [
  "Mover abajo",
  "Ilipat pababa"
 ],
 "Reorder": [
  "Reordenar",
  "Ayusin muli"
 ],
 "Parents book from your Open Schedule": [
  "Los padres reservan desde tu horario abierto",
  "Nagbu-book ang mga magulang mula sa iyong Open Schedule"
 ],
 "You schedule each family after purchase": [
  "Programas a cada familia después de la compra",
  "Isi-schedule mo ang bawat pamilya pagkatapos ng purchase"
 ],
 "enrolled": [
  "inscrito",
  "naka-enroll"
 ],
 "min": [
  "min",
  "min"
 ],
 "Private (link-only)": [
  "Privado (solo con enlace)",
  "Private (link-only)"
 ],
 "⭐ Popular": [
  "⭐ Popular",
  "⭐ Popular"
 ],
 "Parents pay before they can enroll. Click to change.": [
  "Los padres pagan antes de poder inscribirse. Haz clic para cambiarlo.",
  "Magbabayad muna ang mga magulang bago sila makapag-enroll. I-click para baguhin."
 ],
 "Pay-first": [
  "Pago primero",
  "Pay-first"
 ],
 "Parents can enroll without paying (you'll invoice them later). Click to change.": [
  "Los padres pueden inscribirse sin pagar (les enviarás la factura después). Haz clic para cambiarlo.",
  "Maaaring mag-enroll ang mga magulang nang hindi muna nagbabayad (i-i-invoice mo sila mamaya). I-click para baguhin."
 ],
 "Pay-later OK": [
  "Se permite pagar después",
  "Pay-later OK"
 ],
 "More": [
  "Más",
  "Higit pa"
 ],
 "Print roster": [
  "Imprimir lista",
  "I-print ang roster"
 ],
 "Share private link": [
  "Compartir enlace privado",
  "Ibahagi ang private link"
 ],
 "Restore from archive": [
  "Restaurar desde archivo",
  "Ibalik mula sa archive"
 ],
 "How many swimmers can book the same class time? Enter at least 1 (1 = private lessons).": [
  "¿Cuántos nadadores pueden reservar la misma hora de clase? Ingresa al menos 1 (1 = clases privadas).",
  "Ilang swimmers ang puwedeng mag-book sa parehong oras ng klase? Maglagay ng kahit 1 (1 = private lessons)."
 ],
 "Add at least one class time with a day selected. Classes need a recurring weekly schedule.": [
  "Agrega al menos un horario de clase con un día seleccionado. Las clases necesitan un horario semanal recurrente.",
  "Magdagdag ng kahit isang oras ng klase na may napiling araw. Kailangan ng mga klase ng umuulit na lingguhang schedule."
 ],
 "How many lessons are in this package? Enter 1 or more.": [
  "¿Cuántas lecciones hay en este paquete? Ingresa 1 o más.",
  "Ilang lessons ang nasa package na ito? Maglagay ng 1 o higit pa."
 ],
 "Pick the day(s) and time this package meets each week.": [
  "Elige el/los día(s) y la hora en que este paquete se realiza cada semana.",
  "Piliin ang (mga) araw at oras kung kailan nagaganap ang package na ito bawat linggo."
 ],
 "A camp needs both a start date and an end date.": [
  "Un campamento necesita una fecha de inicio y una fecha de fin.",
  "Kailangan ng camp ng petsa ng pagsisimula at petsa ng pagtatapos."
 ],
 "A camp's end date can't be before its start date.": [
  "La fecha de fin de un campamento no puede ser anterior a su fecha de inicio.",
  "Hindi puwedeng mas maaga ang petsa ng pagtatapos ng camp kaysa sa petsa ng pagsisimula nito."
 ],
 "This camp has zero sessions — check the dates and weekdays.": [
  "Este campamento tiene cero sesiones; revisa las fechas y los días de la semana.",
  "Walang session ang camp na ito — suriin ang mga petsa at araw ng linggo."
 ],
 "Program": [
  "Programa",
  "Program"
 ],
 "groups your classes & packages by age (like “Preschool Aquatics”) so approved parents get a guided, age-first signup in their Parent Portal.": [
  "agrupa tus clases y paquetes por edad (como “Preschool Aquatics”) para que los padres aprobados tengan una inscripción guiada, priorizando la edad, en su Portal para Padres.",
  "pinagsasama ang iyong mga klase at package ayon sa edad (tulad ng “Preschool Aquatics”) para magkaroon ang mga aprubadong magulang ng may gabay, age-first na pag-sign up sa kanilang Parent Portal."
 ],
 "Build these first": [
  "Crea esto primero",
  "Gawin muna ang mga ito"
 ],
 ", then drop your classes in.": [
  ", luego agrega tus clases.",
  "pagkatapos, ilagay ang iyong mga klase."
 ],
 "Class": [
  "Clase",
  "Class"
 ],
 "recurs weekly with auto-billing. Add a start + end date to make it seasonal (great for spring/summer/fall sessions).": [
  "se repite semanalmente con cobro automático. Agrega una fecha de inicio y fin para hacerlo de temporada (ideal para sesiones de primavera/verano/otoño).",
  "inuulit bawat linggo na may auto-billing. Magdagdag ng petsa ng simula at pagtatapos para gawin itong seasonal (mainam para sa spring/summer/fall sessions)."
 ],
 "Package": [
  "Paquete",
  "Package"
 ],
 "is a one-time purchase — a single lesson or a fixed bundle of lessons. Parents pay once, then use it.": [
  "es una compra única: una sola lección o un paquete fijo de lecciones. Los padres pagan una vez y luego lo usan.",
  "ay isang one-time na pagbili — isang lesson o isang nakapirming bundle ng lessons. Isang beses magbabayad ang mga magulang, pagkatapos ay gagamitin nila ito."
 ],
 "runs on set dates — e.g. Mon–Thu, Aug 24–27 — and parents pay once. Every camp has a start and end date.": [
  "se realiza en fechas fijas; p. ej., lun.–jue., 24–27 de ago.; y los padres pagan una sola vez. Todo campamento tiene una fecha de inicio y una de fin.",
  "tumatakbo sa mga takdang petsa — hal. Lun–Huw, Ago 24–27 — at isang beses lang nagbabayad ang mga magulang. Bawat camp ay may petsa ng simula at pagtatapos."
 ],
 "Let parents pick their own weekly time from your availability. Perfect for one-on-one instruction where every family is on a different schedule.": [
  "Permite que los padres elijan su propio horario semanal según tu disponibilidad. Perfecto para instrucción individual donde cada familia tiene un horario distinto.",
  "Hayaan ang mga magulang na pumili ng sarili nilang lingguhang oras mula sa iyong availability. Perpekto para sa one-on-one na pagtuturo kung saan iba-iba ang schedule ng bawat pamilya."
 ],
 "Everything you sell — programs, classes, packages, camps and open times.": [
  "Todo lo que vendes: programas, clases, paquetes, campamentos y horarios abiertos.",
  "Lahat ng ibinebenta mo — programs, classes, packages, camps, at open times."
 ],
 "Classes": [
  "Clases",
  "Classes"
 ],
 "Packages": [
  "Paquetes",
  "Packages"
 ],
 "Open schedule": [
  "Horario abierto",
  "Open schedule"
 ],
 "What’s": [
  "Qué es",
  "Ano ang"
 ],
 "Connect Stripe to start selling classes & packages": [
  "Conecta Stripe para empezar a vender clases y paquetes",
  "Ikonekta ang Stripe para makapagsimulang magbenta ng classes at packages"
 ],
 "You can draft items right now, but you can't activate them (let parents enroll) until your Stripe account is connected.": [
  "Puedes crear borradores ahora mismo, pero no puedes activarlos (permitir que los padres se inscriban) hasta que tu cuenta de Stripe esté conectada.",
  "Puwede kang gumawa ng mga draft ngayon, pero hindi mo ito maa-activate (mapapayagan ang mga magulang na mag-enroll) hangga't hindi nakakonekta ang iyong Stripe account."
 ],
 "Set it up in Settings": [
  "Configúralo en Configuración",
  "I-set up ito sa Settings"
 ],
 "Set your timezone before publishing classes": [
  "Configura tu zona horaria antes de publicar clases",
  "Itakda ang iyong timezone bago mag-publish ng classes"
 ],
 "We couldn't detect your timezone from your browser. Parents may see wrong class times if you don't set it.": [
  "No pudimos detectar tu zona horaria desde tu navegador. Los padres podrían ver horarios de clase incorrectos si no la configuras.",
  "Hindi namin matukoy ang iyong timezone mula sa browser mo. Maaaring maling oras ng klase ang makita ng mga magulang kung hindi mo ito itatakda."
 ],
 "Set your timezone in Settings": [
  "Configura tu zona horaria en Configuración",
  "Itakda ang iyong timezone sa Settings"
 ],
 "Search classes by name…": [
  "Buscar clases por nombre…",
  "Maghanap ng classes ayon sa pangalan…"
 ],
 "Search camps by name…": [
  "Buscar campamentos por nombre…",
  "Maghanap ng camps ayon sa pangalan…"
 ],
 "Search packages by name…": [
  "Buscar paquetes por nombre…",
  "Maghanap ng packages ayon sa pangalan…"
 ],
 "Clear search": [
  "Borrar búsqueda",
  "I-clear ang paghahanap"
 ],
 "Filters": [
  "Filtros",
  "Mga filter"
 ],
 "Clear": [
  "Borrar",
  "I-clear"
 ],
 "Filter by day of week": [
  "Filtrar por día de la semana",
  "I-filter ayon sa araw ng linggo"
 ],
 "Charge day each month": [
  "Día de cobro cada mes",
  "Araw ng singil bawat buwan"
 ],
 "Day": [
  "Día",
  "Araw"
 ],
 "of each month": [
  "de cada mes",
  "ng bawat buwan"
 ],
 "Stripe handles month-end rollover automatically.": [
  "Stripe gestiona automáticamente el ajuste de fin de mes.",
  "Awtomatikong pinamamahalaan ng Stripe ang paglipat sa katapusan ng buwan."
 ],
 "Auto-stops on": [
  "Se detiene automáticamente el",
  "Awtomatikong humihinto sa"
 ],
 "Because this": [
  "Porque este",
  "Dahil ang"
 ],
 "class ends on a date": [
  "la clase termina en una fecha",
  "klase ay nagtatapos sa isang petsa"
 ],
 "package has an end date": [
  "el paquete tiene una fecha de finalización",
  "package ay may petsa ng pagtatapos"
 ],
 ", we'll cancel the family's subscription automatically after the last billing cycle in that month. No manual cleanup needed.": [
  ", cancelaremos automáticamente la suscripción de la familia después del último ciclo de facturación de ese mes. No se necesita limpieza manual.",
  ", awtomatiko naming kakanselahin ang subscription ng pamilya pagkatapos ng huling billing cycle sa buwang iyon. Walang kailangang manu-manong ayusin."
 ],
 "Ongoing membership.": [
  "Membresía continua.",
  "Patuloy na membership."
 ],
 "No end date — families are billed monthly until they (or you) cancel. First month is prorated automatically.": [
  "Sin fecha de finalización: a las familias se les factura mensualmente hasta que ellos (o usted) cancelen. El primer mes se prorratea automáticamente.",
  "Walang petsa ng pagtatapos — buwan-buwan sinisingil ang mga pamilya hanggang sila (o ikaw) ay magkansela. Awtomatikong prorated ang unang buwan."
 ],
 "Where & who sees it": [
  "Dónde y quién lo ve",
  "Saan at sino ang nakakakita nito"
 ],
 "Location, landing-page visibility, and highlights.": [
  "Ubicación, visibilidad en la página de destino y destacados.",
  "Lokasyon, visibility sa landing page, at mga highlight."
 ],
 "No program — classic list only": [
  "Sin programa: solo lista clásica",
  "Walang program — classic list lang"
 ],
 "Programs power the guided Class Finder on your public page — parents pick an age, then only see the classes that fit.": [
  "Los programas impulsan el Buscador de Clases guiado en tu página pública: los padres eligen una edad y luego solo ven las clases que encajan.",
  "Pinapagana ng mga program ang guided Class Finder sa iyong public page — pipili ang mga magulang ng edad, at pagkatapos ay ang mga klaseng akma lang ang makikita nila."
 ],
 "Age mismatch?": [
  "¿No coinciden las edades?",
  "Hindi tugma ang edad?"
 ],
 "This": [
  "Este",
  "Ang"
 ],
 "package": [
  "paquete",
  "package"
 ],
 "mentions ages": [
  "menciona edades",
  "ay may binabanggit na mga edad"
 ],
 ", but": [
  ", pero",
  ", pero"
 ],
 "covers ages": [
  "cubre las edades",
  "sumasaklaw sa mga edad na"
 ],
 ". Parents filter by age in the Class Finder, so it may not show where you expect.": [
  ". Los padres filtran por edad en el Buscador de Clases, así que puede que no aparezca donde espera.",
  ". Nagfi-filter ang mga magulang ayon sa edad sa Class Finder, kaya maaaring hindi ito lumabas kung saan mo inaasahan."
 ],
 "Did you mean": [
  "¿Quiso decir",
  "Ang ibig mo bang sabihin"
 ],
 "No programs yet. Create them in the": [
  "Aún no hay programas. Créelos en la",
  "Wala pang mga program. Gumawa nito sa"
 ],
 "Programs tab": [
  "pestaña Programas",
  "Programs tab"
 ],
 "to give parents an age-guided signup, then pick one here.": [
  "para ofrecer a los padres una inscripción guiada por edad, y luego elija uno aquí.",
  "para bigyan ang mga magulang ng age-guided signup, pagkatapos ay pumili ng isa rito."
 ],
 "Delivery mode": [
  "Modalidad de prestación",
  "Paraan ng paghatid"
 ],
 "Fixed location": [
  "Ubicación fija",
  "Nakapirming lokasyon"
 ],
 "Family comes to one of my pools/sites.": [
  "La familia viene a una de mis piscinas/sedes.",
  "Pumupunta ang pamilya sa isa sa aking mga pool/site."
 ],
 "I travel to the family.": [
  "Yo me desplazo hasta la familia.",
  "Pumupunta ako sa pamilya."
 ],
 "You don't have any active locations yet. Add one in": [
  "Aún no tienes ninguna ubicación activa. Agrega una en",
  "Wala ka pang anumang aktibong lokasyon. Magdagdag ng isa sa"
 ],
 "Pick a location…": [
  "Elige una ubicación…",
  "Pumili ng lokasyon…"
 ],
 "Parents see this location when they apply or enroll.": [
  "Los padres ven esta ubicación cuando solicitan o se inscriben.",
  "Nakikita ng mga magulang ang lokasyong ito kapag nag-a-apply o nag-e-enroll."
 ],
 "Visibility": [
  "Visibilidad",
  "Visibility"
 ],
 "Mark as Popular": [
  "Marcar como Popular",
  "Markahan bilang Popular"
 ],
 "Adds a ⭐ Popular ribbon on your landing page.": [
  "Agrega una cinta de ⭐ Popular en tu página de inicio.",
  "Nagdadagdag ng ⭐ Popular na ribbon sa iyong landing page."
 ],
 "Coach who teaches this class": [
  "Instructor que imparte esta clase",
  "Coach na nagtuturo ng klaseng ito"
 ],
 "Owner (me)": [
  "Propietario (yo)",
  "May-ari (ako)"
 ],
 "Whoever you pick will see this package's schedule, students, and attendance in their staff portal.": [
  "La persona que elijas verá el horario, los alumnos y la asistencia de este paquete en su portal del personal.",
  "Sinuman ang piliin mo ay makikita ang iskedyul, mga estudyante, at attendance ng package na ito sa kanilang staff portal."
 ],
 "How will the lessons in this package get scheduled?": [
  "¿Cómo se programarán las lecciones de este paquete?",
  "Paano iiiskedyul ang mga lesson sa package na ito?"
 ],
 "The time slots parents pick from when they enroll.": [
  "Los horarios entre los que los padres eligen al inscribirse.",
  "Ang mga time slot na pagpipilian ng mga magulang kapag nag-enroll sila."
 ],
 "Times are in": [
  "Las horas están en",
  "Ang mga oras ay nasa"
 ],
 "We're guessing from your device. Set your real time zone in Settings so class times never shift.": [
  "Lo estamos deduciendo de tu dispositivo. Configura tu zona horaria real en Configuración para que los horarios de las clases nunca cambien.",
  "Hinuhulaan namin ito mula sa iyong device. Itakda ang tunay mong time zone sa Settings para hindi kailanman magbago ang oras ng mga klase."
 ],
 "Using device time zone (": [
  "Usando la zona horaria del dispositivo (",
  "Ginagamit ang time zone ng device ("
 ],
 ") — set yours in Settings": [
  ") — configúrala en Configuración",
  ") — itakda ang sa iyo sa Settings"
 ],
 "How will lessons be scheduled?": [
  "¿Cómo se programarán las lecciones?",
  "Paano iiiskedyul ang mga lesson?"
 ],
 "How this works": [
  "Cómo funciona",
  "Paano ito gumagana"
 ],
 "Parents buy this package — one simple checkout, no time-picking step.": [
  "Los padres compran este paquete: un proceso de pago sencillo, sin paso de selección de horario.",
  "Binibili ng mga magulang ang package na ito — isang simpleng checkout, walang hakbang ng pagpili ng oras."
 ],
 "In their portal they open your": [
  "En su portal abren tu",
  "Sa kanilang portal, bubuksan nila ang iyong"
 ],
 "Open Schedule": [
  "Horario abierto",
  "Open Schedule"
 ],
 "and tap any open time. Each booking uses one lesson from their package — no extra charge.": [
  "y tocan cualquier horario disponible. Cada reserva usa una lección de su paquete, sin cargo adicional.",
  "at ita-tap ang anumang bakanteng oras. Bawat booking ay gumagamit ng isang lesson mula sa kanilang package — walang dagdag na bayad."
 ],
 "They can tick": [
  "Pueden marcar",
  "Maaari nilang lagyan ng check ang"
 ],
 "\"Same time every week\"": [
  "\"La misma hora cada semana\"",
  "\"Same time every week\""
 ],
 "to fill all": [
  "para completar las",
  "para punan ang lahat ng"
 ],
 "lessons in one go.": [
  "lecciones de una vez.",
  "lesson nang isang bagsakan."
 ],
 "You can still book for them from": [
  "Aún puedes reservar por ellos desde",
  "Maaari ka pa ring mag-book para sa kanila mula sa"
 ],
 "Students → Add to schedule": [
  "Alumnos → Añadir al horario",
  "Students → Add to schedule"
 ],
 "Open Schedule:": [
  "Horario abierto:",
  "Open Schedule:"
 ],
 "ON — families can book from the open times you’ve published.": [
  "ACTIVADO — las familias pueden reservar entre los horarios disponibles que hayas publicado.",
  "ON — maaaring mag-book ang mga pamilya mula sa mga bukas na oras na inilathala mo."
 ],
 "OFF — turn on Open Schedule and set your available hours before selling this.": [
  "DESACTIVADO — activa Horario abierto y establece tu disponibilidad antes de vender esto.",
  "OFF — i-on ang Open Schedule at itakda ang iyong mga available na oras bago ito ibenta."
 ],
 "Open Schedule is on, but \"Parents can book\" is switched off.": [
  "Horario abierto está activado, pero \"Los padres pueden reservar\" está desactivado.",
  "Naka-on ang Open Schedule, pero naka-off ang \"Parents can book\"."
 ],
 "Set up Open Schedule": [
  "Configurar Horario abierto",
  "I-set up ang Open Schedule"
 ],
 "Parents buy this package with no time-picking step — one simple checkout.": [
  "Los padres compran este paquete sin paso de selección de horario: un proceso de pago sencillo.",
  "Binibili ng mga magulang ang package na ito nang walang hakbang ng pagpili ng oras — isang simpleng checkout."
 ],
 "They appear on": [
  "Aparecen en",
  "Lalabas sila sa"
 ],
 "flagged": [
  "marcado como",
  "na naka-flag bilang"
 ],
 "\"Needs scheduling\"": [
  "\"Necesita programación\"",
  "\"Needs scheduling\""
 ],
 "→ tap": [
  "→ toca",
  "→ i-tap ang"
 ],
 "Add to schedule": [
  "Añadir al horario",
  "Add to schedule"
 ],
 "and pick the days that work.": [
  "y elige los días que funcionen.",
  "at piliin ang mga araw na uubra."
 ],
 "Parents can't self-book this package from the Open Schedule — you stay in control of the calendar.": [
  "Los padres no pueden reservar este paquete por su cuenta desde el Horario abierto; tú mantienes el control del calendario.",
  "Hindi puwedeng i-self-book ng mga magulang ang package na ito mula sa Open Schedule — ikaw ang may kontrol sa kalendaryo."
 ],
 "Archive (hide, reversible)": [
  "Archivar (ocultar, reversible)",
  "I-archive (itago, puwedeng ibalik)"
 ],
 "Delete permanently": [
  "Eliminar permanentemente",
  "Permanenteng tanggalin"
 ],
 "A recurring weekly class. Add a start + end date to make it seasonal.": [
  "Una clase semanal recurrente. Agrega una fecha de inicio y una de fin para hacerla de temporada.",
  "Isang umuulit na lingguhang klase. Magdagdag ng petsa ng simula at pagtatapos para gawin itong pana-panahon."
 ],
 "Runs on set dates — parents pay once. A camp always has a start and an end date.": [
  "Se imparte en fechas establecidas; los padres pagan una sola vez. Un campamento siempre tiene una fecha de inicio y una de fin.",
  "Ginaganap sa mga takdang petsa — isang beses lang magbabayad ang mga magulang. Ang camp ay laging may petsa ng simula at pagtatapos."
 ],
 "A one-time purchase — a single lesson or a fixed bundle of lessons.": [
  "Una compra única: una sola lección o un paquete fijo de lecciones.",
  "Isang minsanang pagbili — iisang lesson o isang nakapirming bundle ng lessons."
 ],
 "Basics": [
  "Conceptos básicos",
  "Mga pangunahing detalye"
 ],
 "What it's called and how billing works.": [
  "Cómo se llama y cómo funciona la facturación.",
  "Ano ang tawag dito at paano gumagana ang billing."
 ],
 "Package name": [
  "Nombre del paquete",
  "Pangalan ng package"
 ],
 "Description (shown to parents)": [
  "Descripción (se muestra a los padres)",
  "Description (ipinapakita sa mga magulang)"
 ],
 "e.g. 4-day camp Aug 24-27, Mon-Thu. Pick 5:00 or 5:40 PM. Level 3 skills — freestyle and backstroke drills. Bring goggles and a towel.": [
  "p. ej. Campamento de 4 días del 24 al 27 de agosto, lun-jue. Elige 5:00 o 5:40 p. m. Habilidades de nivel 3: ejercicios de crol y espalda. Trae gafas de natación y una toalla.",
  "hal. 4-day camp Aug 24-27, Mon-Thu. Pumili ng 5:00 o 5:40 PM. Level 3 skills — freestyle at backstroke drills. Magdala ng goggles at tuwalya."
 ],
 "e.g. Every Monday at 5:00 PM starting Sept 8. Ongoing class — cancel anytime with 30 days notice.": [
  "p. ej. Todos los lunes a las 5:00 p. m. a partir del 8 de septiembre. Clase continua: cancela en cualquier momento con 30 días de aviso.",
  "hal. Tuwing Lunes ng 5:00 PM simula Sept 8. Ongoing na klase — puwedeng magkansela anumang oras na may 30 araw na abiso."
 ],
 "e.g. What the lesson covers, what to bring, and anything else parents should know.": [
  "p. ej. Qué cubre la lección, qué traer y cualquier otra cosa que los padres deban saber.",
  "hal. Ano ang saklaw ng lesson, ano ang dapat dalhin, at anumang iba pang dapat malaman ng mga magulang."
 ],
 "This is the only description parents see. If you leave it blank, no description shows on their end.": [
  "Esta es la única descripción que ven los padres. Si la dejas en blanco, no se mostrará ninguna descripción de su lado.",
  "Ito lang ang description na makikita ng mga magulang. Kung iiwan mo itong blangko, walang description na ipapakita sa panig nila."
 ],
 "Pricing & capacity": [
  "Precios y cupos",
  "Pagpepresyo at kapasidad"
 ],
 "What parents pay and how many spots you have.": [
  "Lo que pagan los padres y cuántos cupos tienes.",
  "Magkano ang babayaran ng mga magulang at ilan ang slots mo."
 ],
 "Per-lesson rate": [
  "Tarifa por lección",
  "Rate kada lesson"
 ],
 "Monthly price": [
  "Precio mensual",
  "Buwanang presyo"
 ],
 "Total package price": [
  "Precio total del paquete",
  "Kabuuang presyo ng package"
 ],
 "Number of lessons": [
  "Número de lecciones",
  "Bilang ng lessons"
 ],
 "sessions — from your camp dates & days below": [
  "sesiones: según las fechas y los días de tu campamento a continuación",
  "sessions — mula sa mga petsa at araw ng camp mo sa ibaba"
 ],
 "We list this many lesson dates in the Schedule step below.": [
  "Mostramos esta cantidad de fechas de lección en el paso Horario de abajo.",
  "Ililista namin ang ganitong karaming petsa ng lesson sa hakbang na Schedule sa ibaba."
 ],
 "How many lessons the family gets to book.": [
  "Cuántas lecciones puede reservar la familia.",
  "Ilang lessons ang puwedeng i-book ng pamilya."
 ],
 "Lesson duration (min)": [
  "Duración de la lección (min)",
  "Tagal ng lesson (min)"
 ],
 "Swimmers per class time": [
  "Nadadores por horario de clase",
  "Mga swimmer bawat oras ng klase"
 ],
 "Private lessons — each time shows \"Full\" after one swimmer books it.": [
  "Lecciones privadas: cada horario muestra \"Completo\" después de que un nadador lo reserve.",
  "Private lessons — bawat oras ay magpapakita ng \"Full\" pagkatapos itong ma-book ng isang swimmer."
 ],
 "Blank or 0 = unlimited — a time will never show \"Full\". Enter 1 for private lessons.": [
  "En blanco o 0 = ilimitado; un horario nunca mostrará \"Completo\". Ingresa 1 para lecciones privadas.",
  "Blanko o 0 = walang limitasyon — ang isang oras ay hindi kailanman magpapakita ng \"Full\". Ilagay ang 1 para sa private lessons."
 ],
 "Waitlist when full": [
  "Lista de espera cuando esté lleno",
  "Waitlist kapag puno na"
 ],
 "Parents can tap \"Join waitlist\" on a full time. You’ll see every family on Students → Waitlist and choose when to email them about an opening.": [
  "Los padres pueden tocar \"Unirse a la lista de espera\" en un horario lleno. Verás a cada familia en Estudiantes → Lista de espera y decidirás cuándo enviarles un correo sobre una vacante.",
  "Puwedeng i-tap ng mga magulang ang \"Join waitlist\" sa isang punong oras. Makikita mo ang bawat pamilya sa Students → Waitlist at ikaw ang magpapasya kung kailan sila ie-email tungkol sa isang bakante."
 ],
 "Off — full times just show \"Full\". Turn on to capture families who want a time that’s taken.": [
  "Desactivado: los horarios llenos solo muestran \"Completo\". Actívalo para captar familias que quieren un horario que ya está ocupado.",
  "Off — ang mga punong oras ay magpapakita lang ng \"Full\". I-on ito para makuha ang mga pamilyang gusto ang isang oras na nakuha na."
 ],
 "How should parent self-enrollments be handled?": [
  "¿Cómo deben gestionarse las autoinscripciones de los padres?",
  "Paano dapat pangasiwaan ang self-enrollments ng magulang?"
 ],
 "Enroll immediately, collect payment later": [
  "Inscribir de inmediato, cobrar después",
  "I-enroll agad, kolektahin ang bayad mamaya"
 ],
 "The parent's spot is reserved as soon as they sign up. A Stripe payment link is sent to them and an invoice appears on your roster, even if they haven't paid yet.": [
  "El cupo del padre queda reservado en cuanto se inscribe. Se le envía un enlace de pago de Stripe y aparece una factura en tu lista, aunque todavía no haya pagado.",
  "Makareserba agad ang slot ng magulang sa sandaling mag-sign up siya. Padadalhan siya ng Stripe payment link at may lalabas na invoice sa roster mo, kahit hindi pa siya nakakapagbayad."
 ],
 "Only enroll after payment is received": [
  "Inscribir solo después de recibir el pago",
  "I-enroll lang pagkatapos matanggap ang bayad"
 ],
 "The parent is sent straight to Stripe to pay. They're only added to your roster after the payment succeeds. If they bail out without paying, nothing is recorded.": [
  "Se envía al padre directamente a Stripe para pagar. Solo se agrega a tu lista después de que el pago se complete con éxito. Si abandona sin pagar, no se registra nada.",
  "Diretsong ipinapadala ang magulang sa Stripe para magbayad. Idinadagdag lang sila sa roster mo pagkatapos magtagumpay ang bayad. Kung umatras sila nang hindi nagbabayad, walang mare-record."
 ],
 "Note: this only applies when parents enroll themselves from their portal. You can still manually enroll a child and send the invoice afterwards.": [
  "Nota: esto solo aplica cuando los padres se inscriben ellos mismos desde su portal. Aun así, puedes inscribir manualmente a un niño y enviar la factura después.",
  "Tandaan: nalalapat lang ito kapag ang mga magulang mismo ang nag-e-enroll mula sa portal nila. Maaari ka pa ring manu-manong mag-enroll ng bata at ipadala ang invoice pagkatapos."
 ],
 "Schedule somewhere else (like Google Calendar)? Just dismiss the flag.": [
  "¿Lo programas en otro lugar (como Google Calendar)? Solo descarta el indicador.",
  "Naka-schedule ba ito sa ibang lugar (gaya ng Google Calendar)? I-dismiss lang ang flag."
 ],
 "Parents still see their remaining-lesson count tick down as lessons are booked and attended.": [
  "Los padres siguen viendo cómo disminuye su cantidad de clases restantes a medida que se reservan y se asisten las clases.",
  "Makikita pa rin ng mga magulang na nababawasan ang bilang ng natitira nilang lessons habang bina-book at dinadaluhan ang mga lesson."
 ],
 "Camp start date": [
  "Fecha de inicio del campamento",
  "Petsa ng simula ng camp"
 ],
 "required": [
  "obligatorio",
  "kinakailangan"
 ],
 "Camp end date": [
  "Fecha de fin del campamento",
  "Petsa ng pagtatapos ng camp"
 ],
 "between these dates on the days you pick below": [
  "entre estas fechas en los días que elijas abajo",
  "sa pagitan ng mga petsang ito sa mga araw na pipiliin mo sa ibaba"
 ],
 "— per family; each time slot is an option they choose": [
  "— por familia; cada franja horaria es una opción que eligen",
  "— bawat pamilya; bawat time slot ay isang opsyong pipiliin nila"
 ],
 "First lesson date": [
  "Fecha de la primera clase",
  "Petsa ng unang lesson"
 ],
 "If this isn't one of the days you pick below, we start on the next one that is.": [
  "Si esta no es uno de los días que eliges abajo, comenzamos en el siguiente que sí lo sea.",
  "Kung hindi ito isa sa mga araw na pipiliin mo sa ibaba, magsisimula kami sa susunod na araw na kasama."
 ],
 "Last lesson": [
  "Última clase",
  "Huling lesson"
 ],
 "— lesson": [
  "— clase",
  "— lesson"
 ],
 "Enter the number of lessons above.": [
  "Introduce el número de clases arriba.",
  "Ilagay ang bilang ng lessons sa itaas."
 ],
 "Pick a day and time below.": [
  "Elige un día y una hora abajo.",
  "Pumili ng araw at oras sa ibaba."
 ],
 "Pick the first lesson date.": [
  "Elige la fecha de la primera clase.",
  "Piliin ang petsa ng unang lesson."
 ],
 "Calculating…": [
  "Calculando…",
  "Kinakalkula…"
 ],
 "Worked out from your": [
  "Calculado a partir de tus",
  "Kinalkula mula sa iyong"
 ],
 "lessons — nothing to type.": [
  "clases — no hay nada que escribir.",
  "lessons — wala kang kailangang ilagay."
 ],
 "Each family comes": [
  "Cada familia viene",
  "Bawat pamilya ay pumupunta"
 ],
 "×/week": [
  "×/semana",
  "×/linggo"
 ],
 "lessons ≈": [
  "clases ≈",
  "lessons ≈"
 ],
 "week": [
  "semana",
  "linggo"
 ],
 "Your": [
  "Tus",
  "Iyong"
 ],
 "time slots are options — a family picks one, so they don't add up.": [
  "franjas horarias son opciones — una familia elige una, así que no se suman.",
  "mga time slot ay mga opsyon — isang pamilya ang pipili ng isa, kaya hindi sila pinagsasama."
 ],
 "Cancel & reschedule rules": [
  "Reglas de cancelación y reprogramación",
  "Mga patakaran sa pagkansela at pag-reschedule"
 ],
 "Custom for this": [
  "Personalizado para este",
  "Naka-custom para dito"
 ],
 "Using your default:": [
  "Usando tu opción predeterminada:",
  "Gamit ang default mo:"
 ],
 "Use my default instead": [
  "Usar mi opción predeterminada en su lugar",
  "Gamitin na lang ang default ko"
 ],
 "Customize for this": [
  "Personalizar para este",
  "I-custom para dito"
 ],
 "Change the default for everything under": [
  "Cambiar la opción predeterminada para todo lo que está en",
  "Baguhin ang default para sa lahat ng nasa ilalim ng"
 ],
 "Packages & Classes settings": [
  "Configuración de Paquetes y Clases",
  "Mga setting ng Packages & Classes"
 ],
 "Save package": [
  "Guardar paquete",
  "I-save ang package"
 ],
 "Heads up — active subscribers on this package": [
  "Aviso: suscriptores activos de este paquete",
  "Paalala — mga aktibong subscriber sa package na ito"
 ],
 "Yes, save anyway": [
  "Sí, guardar de todos modos",
  "Oo, i-save pa rin"
 ],
 "permanently?": [
  "¿permanentemente?",
  "nang permanente?"
 ],
 "Existing subscribers keep their plan and will still be billed. New parents can't buy or enroll into this item once it's deleted. You can't undo this action.": [
  "Los suscriptores existentes conservan su plan y se les seguirá cobrando. Los nuevos padres no podrán comprar ni inscribirse en este elemento una vez eliminado. No puedes deshacer esta acción.",
  "Pananatilihin ng mga kasalukuyang subscriber ang kanilang plan at patuloy pa rin silang sisingilin. Hindi na makakabili o makakapag-enroll ang mga bagong magulang sa item na ito kapag na-delete na ito. Hindi mo na maa-undo ang aksyong ito."
 ],
 "Reconnect Stripe": [
  "Volver a conectar Stripe",
  "I-reconnect ang Stripe"
 ],
 "Contact support": [
  "Contactar soporte",
  "Makipag-ugnayan sa support"
 ],
 "Manual charge": [
  "Cobro manual",
  "Manual na charge"
 ],
 "refunded": [
  "reembolsado",
  "na-refund"
 ],
 "Refund": [
  "Reembolso",
  "Refund"
 ],
 "Preparing roster…": [
  "Preparando lista…",
  "Inihahanda ang roster…"
 ],
 "Couldn't load this roster.": [
  "No se pudo cargar esta lista.",
  "Hindi ma-load ang roster na ito."
 ],
 "Go back": [
  "Volver",
  "Bumalik"
 ],
 "Print preview ·": [
  "Vista previa de impresión ·",
  "Print preview ·"
 ],
 "enrolled ·": [
  "inscritos ·",
  "enrolled ·"
 ],
 "Print / Save as PDF": [
  "Imprimir / Guardar como PDF",
  "I-print / I-save bilang PDF"
 ],
 "Class Roster": [
  "Lista de clase",
  "Class Roster"
 ],
 "Generated": [
  "Generado",
  "Generated"
 ],
 "No one is enrolled in this": [
  "Nadie está inscrito en este",
  "Walang enrolled dito sa"
 ],
 "time slot": [
  "horario",
  "time slot"
 ],
 "yet.": [
  "todavía.",
  "pa."
 ],
 "Unpaid": [
  "No pagado",
  "Hindi bayad"
 ],
 "Powered by SplashPad": [
  "Con tecnología de SplashPad",
  "Powered by SplashPad"
 ],
 "Daily route": [
  "Ruta diaria",
  "Daily route"
 ],
 "Your lessons as a drive, in order. Tap": [
  "Tus clases como un recorrido, en orden. Toca",
  "Ang lessons mo bilang biyahe, sunod-sunod. I-tap ang"
 ],
 "Directions": [
  "Indicaciones",
  "Directions"
 ],
 "between stops, or open the whole day at once.": [
  "entre paradas, o abre todo el día de una vez.",
  "sa pagitan ng mga stop, o buksan ang buong araw nang sabay-sabay."
 ],
 "(you)": [
  "(tú)",
  "(ikaw)"
 ],
 "Previous day": [
  "Día anterior",
  "Nakaraang araw"
 ],
 "Next day": [
  "Día siguiente",
  "Susunod na araw"
 ],
 "Pick a date": [
  "Elegir una fecha",
  "Pumili ng petsa"
 ],
 "Stops": [
  "Paradas",
  "Mga stop"
 ],
 "Approx. driving": [
  "Aprox. de conducción",
  "Tinatayang biyahe"
 ],
 "Open whole day in Google Maps": [
  "Abrir todo el día en Google Maps",
  "Buksan ang buong araw sa Google Maps"
 ],
 "Add lessons to build a route.": [
  "Agrega clases para crear una ruta.",
  "Magdagdag ng lessons para makabuo ng route."
 ],
 "Turn on": [
  "Activar",
  "I-on ang"
 ],
 "Travel Smart": [
  "Viaje Inteligente",
  "Travel Smart"
 ],
 "to let families book only the times on this route — and see their requests on the map.": [
  "para permitir que las familias reserven solo los horarios de esta ruta y ver sus solicitudes en el mapa.",
  "para hayaan ang mga pamilya na mag-book lang ng mga oras sa rutang ito — at makita ang mga request nila sa mapa."
 ],
 "Travel Smart settings": [
  "Configuración de Viaje Inteligente",
  "Mga setting ng Travel Smart"
 ],
 "Nothing on the road": [
  "Nada en camino",
  "Walang nasa daan"
 ],
 "today": [
  "hoy",
  "ngayon"
 ],
 "this day": [
  "este día",
  "araw na ito"
 ],
 "Lessons you schedule show up here as stops, in order, with directions between them.": [
  "Las clases que programes aparecen aquí como paradas, en orden, con indicaciones entre ellas.",
  "Ang mga lesson na i-schedule mo ay lalabas dito bilang mga stop, sunod-sunod, na may directions sa pagitan nila."
 ],
 "pending home-lesson": [
  "clase a domicilio pendiente",
  "pending home-lesson"
 ],
 "requests": [
  "solicitudes",
  "mga request"
 ],
 "could go on this day — see the map.": [
  "podría ir en este día — consulta el mapa.",
  "puwedeng ilagay sa araw na ito — tingnan ang mapa."
 ],
 "Start:": [
  "Inicio:",
  "Simula:"
 ],
 "mi": [
  "mi",
  "mi"
 ],
 "between": [
  "entre",
  "sa pagitan ng"
 ],
 "Pool": [
  "Piscina",
  "Pool"
 ],
 "No address on file": [
  "No hay una dirección registrada",
  "Walang address na naka-file"
 ],
 "Back home:": [
  "De regreso a casa:",
  "Pauwi:"
 ],
 "Distances are straight-line estimates. Directions open in": [
  "Las distancias son estimaciones en línea recta. Las indicaciones se abren en",
  "Ang mga distansya ay mga tantiyang tuwid na linya. Bubukas ang directions sa"
 ],
 "Where a new request would fit": [
  "Dónde cabría una nueva solicitud",
  "Kung saan magkakasya ang isang bagong request"
 ],
 "Open Leads": [
  "Clientes potenciales abiertos",
  "Open Leads"
 ],
 "· times offered": [
  "· horarios ofrecidos",
  "· mga oras na inalok"
 ],
 "first stop": [
  "primera parada",
  "unang stop"
 ],
 "only stop": [
  "única parada",
  "nag-iisang stop"
 ],
 "extra mi": [
  "mi adicionales",
  "dagdag na mi"
 ],
 "Google Maps": [
  "Google Maps",
  "Google Maps"
 ],
 "Apple Maps": [
  "Apple Maps",
  "Apple Maps"
 ],
 "Could not load lesson details.": [
  "No se pudieron cargar los detalles de la clase.",
  "Hindi ma-load ang mga detalye ng lesson."
 ],
 "Lesson cancelled": [
  "Clase cancelada",
  "Nakansela ang lesson"
 ],
 "Print this day's classes": [
  "Imprimir las clases de este día",
  "I-print ang mga klase sa araw na ito"
 ],
 "Every class on the selected day, with a full roster and attendance boxes.": [
  "Todas las clases del día seleccionado, con lista completa y casillas de asistencia.",
  "Lahat ng klase sa napiling araw, na may buong roster at mga kahon para sa attendance."
 ],
 "Open print preview": [
  "Abrir vista previa de impresión",
  "Buksan ang print preview"
 ],
 "Print a whole week": [
  "Imprimir una semana completa",
  "I-print ang buong linggo"
 ],
 "Seven days on a clipboard-ready packet, one page per day. Empty days are skipped.": [
  "Siete días en un paquete listo para portapapeles, una página por día. Se omiten los días vacíos.",
  "Pitong araw sa isang clipboard-ready na packet, isang pahina bawat araw. Nilalaktawan ang mga bakanteng araw."
 ],
 "Week starts on": [
  "La semana comienza el",
  "Nagsisimula ang linggo sa"
 ],
 "Print an entire month": [
  "Imprimir un mes completo",
  "I-print ang buong buwan"
 ],
 "Every scheduled day of the month in one packet, one page per day. Empty days are skipped.": [
  "Todos los días programados del mes en un solo paquete, una página por día. Se omiten los días vacíos.",
  "Lahat ng naka-schedule na araw ng buwan sa isang packet, isang pahina bawat araw. Nilalaktawan ang mga bakanteng araw."
 ],
 "Review a day’s booked-lesson changes": [
  "Revisar los cambios de clases reservadas de un día",
  "Suriin ang mga pagbabago sa mga naka-book na lesson sa isang araw"
 ],
 "Your lessons and scheduled classes. Times shown in": [
  "Tus clases y clases programadas. Horarios mostrados en",
  "Ang iyong mga lesson at naka-schedule na klase. Ipinapakita ang mga oras sa"
 ],
 "Custom time": [
  "Hora personalizada",
  "Custom na oras"
 ],
 "Book at a custom time": [
  "Reservar a una hora personalizada",
  "Mag-book sa custom na oras"
 ],
 "Just want to hide it for now?": [
  "¿Solo quieres ocultarlo por ahora?",
  "Gusto mo lang ba itong itago muna?"
 ],
 "Close this and use the Archive button instead — it's reversible.": [
  "Cierra esto y usa el botón Archivar en su lugar; es reversible.",
  "Isara ito at gamitin na lang ang button na Archive — maaari itong ibalik."
 ],
 "Keep it": [
  "Conservarlo",
  "Panatilihin ito"
 ],
 "Deleting…": [
  "Eliminando…",
  "Dinedelete…"
 ],
 "It'll disappear from your Live/Draft views and from your public page. Anyone already enrolled keeps their spot and keeps getting billed as usual — nothing changes for them.": [
  "Desaparecerá de tus vistas En vivo/Borrador y de tu página pública. Cualquier persona que ya esté inscrita conserva su lugar y se le seguirá cobrando como de costumbre; nada cambia para ella.",
  "Mawawala ito sa iyong mga Live/Draft view at sa iyong pampublikong page. Ang sinumang naka-enroll na ay mananatili ang puwesto at patuloy na sisingilin gaya ng dati — walang magbabago para sa kanila."
 ],
 "You can bring it back anytime with the": [
  "Puedes recuperarlo en cualquier momento con el",
  "Maaari mo itong ibalik anumang oras gamit ang"
 ],
 "filter.": [
  "filtro.",
  "filter."
 ],
 "No payments found on Stripe in the last 90 days. If you just paid, give Stripe a minute to process.": [
  "No se encontraron pagos en Stripe en los últimos 90 días. Si acabas de pagar, dale un minuto a Stripe para procesarlo.",
  "Walang nakitang bayad sa Stripe sa nakalipas na 90 araw. Kung kakabayad mo lang, bigyan ang Stripe ng isang minuto para ma-process ito."
 ],
 "Refund amount must be greater than zero.": [
  "El importe del reembolso debe ser mayor que cero.",
  "Ang halaga ng refund ay dapat mas malaki sa zero."
 ],
 "Split credit portion must be greater than $0 and less than the total refund.": [
  "La parte del crédito dividido debe ser mayor que $0 y menor que el reembolso total.",
  "Ang bahagi ng hinating credit ay dapat mas malaki sa $0 at mas mababa sa kabuuang refund."
 ],
 "Every charge you've run through SplashPad. Refund full or partial — your family gets 100% back (including the platform fee).": [
  "Todos los cobros que has procesado con SplashPad. Reembolsa total o parcialmente: tu familia recibe el 100% de vuelta (incluida la comisión de la plataforma).",
  "Lahat ng singil na pinadaan mo sa SplashPad. Mag-refund nang buo o bahagya — makukuha ng pamilya ang 100% pabalik (kasama ang platform fee)."
 ],
 "Refunded": [
  "Reembolsado",
  "Na-refund na"
 ],
 "After refunds": [
  "Después de los reembolsos",
  "Pagkatapos ng mga refund"
 ],
 "Totals cover up to the latest 1,000 loaded payments, before processing/platform fees. Search filters the list, not these totals. Credits and bank payouts are tracked separately.": [
  "Los totales cubren hasta los 1,000 pagos cargados más recientes, antes de las comisiones de procesamiento/plataforma. La búsqueda filtra la lista, no estos totales. Los créditos y los depósitos bancarios se registran por separado.",
  "Saklaw ng mga total ang hanggang sa pinakahuling 1,000 na na-load na bayad, bago ang processing/platform fees. Ang paghahanap ay nagfi-filter sa listahan, hindi sa mga total na ito. Ang credits at bank payouts ay sinusubaybayan nang hiwalay."
 ],
 "No payments match this view yet.": [
  "Todavía no hay pagos que coincidan con esta vista.",
  "Wala pang mga bayad na tugma sa view na ito."
 ],
 "Refund payment": [
  "Reembolsar pago",
  "I-refund ang bayad"
 ],
 "Choose where the refund goes. To card returns money to the family via Stripe. To account credit adds an internal balance the family can use for a future charge — no Stripe fees, no wait.": [
  "Elige adónde va el reembolso. A la tarjeta devuelve el dinero a la familia a través de Stripe. Al crédito de la cuenta añade un saldo interno que la familia puede usar para un cargo futuro, sin comisiones de Stripe ni espera.",
  "Piliin kung saan mapupunta ang refund. Ang To card ay nagbabalik ng pera sa pamilya sa pamamagitan ng Stripe. Ang To account credit ay nagdadagdag ng internal na balanse na magagamit ng pamilya para sa susunod na singil — walang Stripe fees, walang paghihintay."
 ],
 "Charged": [
  "Cobrado",
  "Siningil"
 ],
 "on": [
  "el",
  "noong"
 ],
 "Already refunded:": [
  "Ya reembolsado:",
  "Na-refund na:"
 ],
 "Refund destination": [
  "Destino del reembolso",
  "Refund destination"
 ],
 "This payment was made using account credit, so it can only be refunded back to credit.": [
  "Este pago se realizó usando crédito de la cuenta, por lo que solo se puede reembolsar de nuevo como crédito.",
  "Ginawa ang bayad na ito gamit ang account credit, kaya puwede lamang itong i-refund pabalik sa credit."
 ],
 "Refund amount (USD)": [
  "Importe del reembolso (USD)",
  "Halaga ng refund (USD)"
 ],
 "Credit portion (USD) — remainder goes to the card": [
  "Parte del crédito (USD): el resto va a la tarjeta",
  "Bahagi ng credit (USD) — ang natitira ay mapupunta sa card"
 ],
 "To card (Stripe)": [
  "A la tarjeta (Stripe)",
  "Sa card (Stripe)"
 ],
 "To account credit": [
  "Al crédito de la cuenta",
  "Sa account credit"
 ],
 "(internal note, optional)": [
  "(nota interna, opcional)",
  "(internal note, optional)"
 ],
 "e.g. Lesson cancelled by coach": [
  "p. ej., clase cancelada por el instructor",
  "hal. Kinansela ang lesson ng coach"
 ],
 "Refunding…": [
  "Reembolsando…",
  "Nagre-refund…"
 ],
 "Add to credit": [
  "Agregar a crédito",
  "Idagdag sa credit"
 ],
 "Refund split": [
  "Dividir reembolso",
  "Hatiin ang refund"
 ],
 "Confirm refund": [
  "Confirmar reembolso",
  "Kumpirmahin ang refund"
 ],
 "What this usually means:": [
  "Lo que esto suele significar:",
  "Ang karaniwang ibig sabihin nito:"
 ],
 "Stripe asked you to re-confirm your platform connection (sometimes after they update their terms or detect unusual activity). Reconnecting takes about 30 seconds.": [
  "Stripe te pidió que vuelvas a confirmar tu conexión con la plataforma (a veces después de que actualizan sus términos o detectan actividad inusual). Volver a conectar toma unos 30 segundos.",
  "Hiniling ng Stripe na muli mong kumpirmahin ang iyong platform connection (minsan pagkatapos nilang i-update ang kanilang mga tuntunin o makakita ng hindi pangkaraniwang aktibidad). Mga 30 segundo lang ang muling pagkonekta."
 ],
 "Your previous Stripe account is no longer reachable (it may have been deleted in Stripe directly). Reconnect to set up a fresh link — your historical payments stay on file with Stripe regardless.": [
  "Ya no se puede acceder a tu cuenta anterior de Stripe (puede que se haya eliminado directamente en Stripe). Vuelve a conectarla para configurar un enlace nuevo; tus pagos históricos permanecen registrados en Stripe de cualquier manera.",
  "Hindi na ma-access ang dati mong Stripe account (maaaring na-delete ito mismo sa Stripe). Mag-reconnect para makapag-set up ng panibagong link — mananatiling naka-file sa Stripe ang iyong mga dating bayad anuman ang mangyari."
 ],
 "more": [
  "más",
  "higit pa"
 ],
 "· Open": [
  "· Abierto",
  "· Bukas"
 ],
 "open slots": [
  "plazas disponibles",
  "mga bakanteng slot"
 ],
 "Lesson details": [
  "Detalles de la clase",
  "Mga detalye ng lesson"
 ],
 "level:": [
  "nivel:",
  "antas:"
 ],
 "Lesson at the family's home": [
  "Clase en la casa de la familia",
  "Lesson sa bahay ng pamilya"
 ],
 "Lesson location": [
  "Ubicación de la clase",
  "Lokasyon ng lesson"
 ],
 "Mark attendance": [
  "Marcar asistencia",
  "Markahan ang attendance"
 ],
 "Move lesson": [
  "Mover clase",
  "Ilipat ang lesson"
 ],
 "Cancel lesson": [
  "Cancelar clase",
  "Kanselahin ang lesson"
 ],
 "Marks this single lesson as cancelled. Future recurring lessons stay on the schedule.": [
  "Marca esta única clase como cancelada. Las futuras clases recurrentes permanecen en el horario.",
  "Mamarkahan nito ang iisang lesson na ito bilang kinansela. Mananatili sa iskedyul ang mga susunod na umuulit na lesson."
 ],
 "Yes, cancel": [
  "Sí, cancelar",
  "Oo, kanselahin"
 ],
 "Closed — click to manage blackout": [
  "Cerrado — haz clic para administrar el bloqueo",
  "Sarado — i-click para i-manage ang blackout"
 ],
 "awaiting payment": [
  "pendiente de pago",
  "naghihintay ng bayad"
 ],
 "Enrolled — first lesson is on a later date": [
  "Inscrito — la primera clase es en una fecha posterior",
  "Enrolled — ang unang lesson ay sa mas huling petsa"
 ],
 "reserved · starts later": [
  "reservado · empieza más tarde",
  "nakareserba · magsisimula mamaya"
 ],
 "Overlaps": [
  "Superposiciones",
  "Magkakapatong"
 ],
 "one-off": [
  "única",
  "isang beses"
 ],
 "No enrollment to drop.": [
  "No hay ninguna inscripción para dar de baja.",
  "Walang enrollment na aalisin."
 ],
 "Pick a drop date — or check \"Drop now\".": [
  "Elige una fecha de baja, o marca \"Dar de baja ahora\".",
  "Pumili ng petsa ng pag-drop — o i-check ang \"I-drop na ngayon\"."
 ],
 "Scheduled drop cleared — they stay enrolled.": [
  "Se eliminó la baja programada; sigue inscrito.",
  "Na-clear ang naka-iskedyul na pag-drop — mananatili silang enrolled."
 ],
 "Drop-in removed — the package credit is back.": [
  "Se eliminó la clase suelta; el crédito del paquete ha sido devuelto.",
  "Inalis ang drop-in — naibalik ang package credit."
 ],
 "No session date — refresh and try again.": [
  "No hay fecha de sesión; actualiza e inténtalo de nuevo.",
  "Walang petsa ng session — i-refresh at subukan ulit."
 ],
 "This enrollment doesn't have a student attached — can't mark attendance.": [
  "Esta inscripción no tiene un estudiante asociado; no se puede marcar la asistencia.",
  "Walang naka-attach na estudyante sa enrollment na ito — hindi ma-markahan ang attendance."
 ],
 "Request denied. Parent has been notified.": [
  "Solicitud denegada. Se ha notificado al padre, madre o tutor.",
  "Tinanggihan ang request. Naabisuhan na ang magulang."
 ],
 "Weekly": [
  "Semanal",
  "Lingguhan"
 ],
 "One-off": [
  "Única",
  "Isang beses"
 ],
 "Extra week · rolled lessons": [
  "Semana extra · clases trasladadas",
  "Dagdag na linggo · mga ni-roll na lesson"
 ],
 "Move this one-off": [
  "Mover esta clase única",
  "Ilipat ang one-off na ito"
 ],
 "Cancel this class": [
  "Cancelar esta clase",
  "Kanselahin ang class na ito"
 ],
 "Pending class requests": [
  "Solicitudes de clase pendientes",
  "Mga nakabinbing request sa class"
 ],
 "Parents asked to join this exact class. Approve to send them a one-click Stripe payment link.": [
  "Los padres solicitaron unirse a esta clase exacta. Aprueba para enviarles un enlace de pago de Stripe con un clic.",
  "Humiling ang mga magulang na sumali sa mismong class na ito. I-approve para padalhan sila ng one-click na Stripe payment link."
 ],
 ". Move that lesson before approving.": [
  ". Mueve esa clase antes de aprobar.",
  ". Ilipat muna ang lesson na iyon bago i-approve."
 ],
 "Move that lesson": [
  "Mover esa clase",
  "Ilipat ang lesson na iyon"
 ],
 "Enrolled families": [
  "Familias inscritas",
  "Mga enrolled na pamilya"
 ],
 "Print schedule": [
  "Imprimir horario",
  "I-print ang iskedyul"
 ],
 "Print packet": [
  "Imprimir paquete",
  "I-print ang packet"
 ],
 "A single day": [
  "Un solo día",
  "Isang araw"
 ],
 "A whole week": [
  "Una semana completa",
  "Isang buong linggo"
 ],
 "An entire month": [
  "Un mes entero",
  "Isang buong buwan"
 ],
 "Print range": [
  "Intervalo de impresión",
  "Saklaw ng pag-print"
 ],
 "Pick a range above to choose the date.": [
  "Elige arriba un intervalo para seleccionar la fecha.",
  "Pumili ng saklaw sa itaas para piliin ang petsa."
 ],
 "1-on-1 lesson": [
  "Lección individual",
  "1-on-1 na lesson"
 ],
 "Class block (X / Y enrolled)": [
  "Bloque de clase (X / Y inscritos)",
  "Class block (X / Y enrolled)"
 ],
 "Open slot — click to enroll": [
  "Cupo disponible — haz clic para inscribirte",
  "Bukas na slot — i-click para mag-enroll"
 ],
 "Closed day": [
  "Día cerrado",
  "Saradong araw"
 ],
 "Open slots for": [
  "Cupos disponibles para",
  "Bukas na mga slot para sa"
 ],
 "You": [
  "Tú",
  "Ikaw"
 ],
 "Want green open-slot boxes on your schedule?": [
  "¿Quieres cuadros verdes de cupos disponibles en tu horario?",
  "Gusto mo ba ng mga berdeng kahon ng bukas na slot sa iskedyul mo?"
 ],
 "in Packages & Classes. Once you have set your weekly hours and lesson lengths, clickable green slots will appear here — tap one to drop a family in.": [
  "en Paquetes y clases. Una vez que hayas establecido tu horario semanal y la duración de las lecciones, aquí aparecerán cupos verdes en los que se puede hacer clic: toca uno para asignar una familia.",
  "sa Packages & Classes. Kapag naitakda mo na ang lingguhang oras mo at mga haba ng lesson, lilitaw dito ang mga naki-click na berdeng slot — i-tap ang isa para maglagay ng pamilya roon."
 ],
 "Set it up": [
  "Configúralo",
  "I-set up ito"
 ],
 "Almost there — finish your Open Schedule setup": [
  "Ya casi está: termina de configurar tu Horario abierto",
  "Malapit na — tapusin ang setup ng iyong Open Schedule"
 ],
 "Open Schedule is ON, but green slots will not show until you": [
  "El Horario abierto está ACTIVADO, pero los cupos verdes no se mostrarán hasta que",
  "Naka-ON ang Open Schedule, pero hindi lalabas ang mga berdeng slot hangga't hindi mo"
 ],
 "set weekly hours": [
  "establezcas el horario semanal",
  "itakda ang lingguhang oras"
 ],
 "pick lesson lengths": [
  "elijas la duración de las lecciones",
  "piliin ang mga haba ng lesson"
 ],
 "add a price per lesson length": [
  "agregues un precio por cada duración de lección",
  "magdagdag ng presyo kada haba ng lesson"
 ],
 "Open Schedule is on — but no open slots fall in this view. Either every slot is already booked, or your weekly hours do not cover these dates. Flip the week/month or tweak your availability in": [
  "El Horario abierto está activado, pero no hay cupos disponibles en esta vista. O bien todos los cupos ya están reservados, o tu horario semanal no cubre estas fechas. Cambia la semana o el mes, o ajusta tu disponibilidad en",
  "Naka-on ang Open Schedule, pero walang bukas na slot sa view na ito. Maaaring booked na ang bawat slot, o hindi sakop ng lingguhang oras mo ang mga petsang ito. Lipat ng linggo/buwan o ayusin ang availability mo sa"
 ],
 "Loading schedule": [
  "Cargando horario",
  "Naglo-load ng iskedyul"
 ],
 "Weekly schedule": [
  "Horario semanal",
  "Lingguhang iskedyul"
 ],
 "Tap a day to see its full agenda.": [
  "Toca un día para ver su agenda completa.",
  "I-tap ang isang araw para makita ang buong agenda nito."
 ],
 "Swipe sideways to browse all seven days.": [
  "Desliza hacia los lados para ver los siete días.",
  "Mag-swipe pahilis para makita ang lahat ng pitong araw."
 ],
 "Weekly schedule columns": [
  "Columnas del horario semanal",
  "Mga column ng lingguhang iskedyul"
 ],
 "Close this day": [
  "Cerrar este día",
  "Isara ang araw na ito"
 ],
 "Manage closure": [
  "Gestionar cierre",
  "Pamahalaan ang pagsasara"
 ],
 "scheduled": [
  "programado",
  "naka-iskedyul"
 ],
 "· Closed": [
  "· Cerrado",
  "· Sarado"
 ],
 "Closed — tap to view": [
  "Cerrado — toca para ver",
  "Sarado — i-tap para tingnan"
 ],
 "No lessons or classes": [
  "No hay lecciones ni clases",
  "Walang lesson o class"
 ],
 "Open ·": [
  "Abierto ·",
  "Bukas ·"
 ],
 "View day": [
  "Ver día",
  "Tingnan ang araw"
 ],
 "Print": [
  "Imprimir",
  "I-print"
 ],
 "Drop-in": [
  "Clase suelta",
  "Drop-in"
 ],
 "Drop-in · this date only": [
  "Clase suelta · solo en esta fecha",
  "Drop-in · sa petsang ito lang"
 ],
 "Drops": [
  "Bajas",
  "Mga drop"
 ],
 "Lesson": [
  "Lección",
  "Aralin"
 ],
 "· last lesson": [
  "· última lección",
  "· huling aralin"
 ],
 "rolled": [
  "prorrateado",
  "na-roll"
 ],
 "Marked present": [
  "Marcado como presente",
  "Minarkahang present"
 ],
 "Marked absent": [
  "Marcado como ausente",
  "Minarkahang absent"
 ],
 "Move to another slot": [
  "Mover a otro horario",
  "Ilipat sa ibang slot"
 ],
 "Edit scheduled drop…": [
  "Editar baja programada…",
  "I-edit ang naka-iskedyul na drop…"
 ],
 "Drop enrollment…": [
  "Dar de baja la inscripción…",
  "I-drop ang enrollment…"
 ],
 "Present": [
  "Presente",
  "Present"
 ],
 "Absent": [
  "Ausente",
  "Absent"
 ],
 "No phone on file": [
  "No hay ningún teléfono registrado",
  "Walang phone na naka-file"
 ],
 "No phone on file — Call/Text disabled.": [
  "No hay ningún teléfono registrado — Llamar/Enviar mensaje desactivado.",
  "Walang phone na naka-file — Naka-disable ang Call/Text."
 ],
 "Zero enrollments yet. This slot will show capacity here as parents enroll.": [
  "Aún no hay inscripciones. Este horario mostrará la capacidad aquí a medida que los padres inscriban a sus hijos.",
  "Wala pang enrollments. Ipapakita rito ng slot na ito ang capacity habang nag-e-enroll ang mga magulang."
 ],
 "When is their first lesson?": [
  "¿Cuándo es su primera lección?",
  "Kailan ang una nilang aralin?"
 ],
 "gets": [
  "recibe",
  "makakakuha ng"
 ],
 "starting on the date below (we snap to the class weekday if needed). Their last lesson is worked out automatically.": [
  "a partir de la fecha de abajo (la ajustamos al día de la semana de la clase si hace falta). Su última lección se calcula automáticamente.",
  "simula sa petsa sa ibaba (iaayon namin sa weekday ng klase kung kailangan). Awtomatikong kakalkulahin ang huli nilang aralin."
 ],
 "First lesson": [
  "Primera lección",
  "Unang aralin"
 ],
 "Suggested: next class on": [
  "Sugerido: próxima clase el",
  "Mungkahi: susunod na klase sa"
 ],
 "Deny request?": [
  "¿Denegar solicitud?",
  "I-deny ang request?"
 ],
 "We will email": [
  "Enviaremos un correo electrónico a",
  "Mag-e-email kami kay"
 ],
 "that this class is not available. Add a short note if you would like to suggest an alternative.": [
  "informando que esta clase no está disponible. Agrega una nota breve si quieres sugerir una alternativa.",
  "na hindi available ang class na ito. Magdagdag ng maikling note kung gusto mong magmungkahi ng alternatibo."
 ],
 "Optional — e.g., 'This time is full but I have a Wednesday opening.'": [
  "Opcional — p. ej., 'Este horario está lleno, pero tengo un cupo el miércoles.'",
  "Opsyonal — hal., 'Puno ang oras na ito pero may opening ako sa Miyerkules.'"
 ],
 "Deny & notify": [
  "Denegar y notificar",
  "I-deny at i-notify"
 ],
 "Drop": [
  "Dar de baja",
  "I-drop"
 ],
 "Removes": [
  "Elimina a",
  "Inaalis si"
 ],
 "from": [
  "de",
  "mula sa"
 ],
 ". Any subscription is cancelled with proration and the parent gets an email — same as dropping from the Students page.": [
  ". Cualquier suscripción se cancela con prorrateo y el padre recibe un correo electrónico, igual que al dar de baja desde la página de Estudiantes.",
  ". Anumang subscription ay kinakansela nang may proration at makakatanggap ng email ang magulang — katulad ng pag-drop mula sa page na Students."
 ],
 "Last day (they stay enrolled through this date)": [
  "Último día (seguirá inscrito hasta esta fecha)",
  "Huling araw (mananatili silang enrolled hanggang sa petsang ito)"
 ],
 "Drop now": [
  "Dar de baja ahora",
  "I-drop na ngayon"
 ],
 "Ends the enrollment immediately instead of on a future date.": [
  "Termina la inscripción de inmediato en lugar de hacerlo en una fecha futura.",
  "Tinatapos kaagad ang enrollment sa halip na sa hinaharap na petsa."
 ],
 "A drop is already scheduled for": [
  "Ya hay una baja programada para",
  "May naka-iskedyul nang drop para sa"
 ],
 ". Saving replaces it; or clear it to keep them enrolled.": [
  ". Guardar lo reemplaza; o bórralo para mantenerlos inscritos.",
  ". Ang pag-save ay papalit dito; o i-clear ito para manatili silang naka-enroll."
 ],
 "Clear scheduled drop": [
  "Borrar baja programada",
  "I-clear ang naka-iskedyul na pag-drop"
 ],
 "Schedule drop": [
  "Programar baja",
  "Mag-iskedyul ng pag-drop"
 ],
 "Preparing today's schedule…": [
  "Preparando el horario de hoy…",
  "Inihahanda ang iskedyul ngayon…"
 ],
 "Couldn't load this day.": [
  "No se pudo cargar este día.",
  "Hindi ma-load ang araw na ito."
 ],
 "es": [
  "es",
  "es"
 ],
 "famil": [
  "famil",
  "famil"
 ],
 "ies": [
  "ias",
  "ies"
 ],
 "Daily Schedule": [
  "Horario diario",
  "Araw-araw na iskedyul"
 ],
 "Printed": [
  "Impreso",
  "Na-print"
 ],
 "enrolled famil": [
  "familias inscritas",
  "mga pamilyang naka-enroll"
 ],
 "No classes scheduled": [
  "No hay clases programadas",
  "Walang naka-iskedyul na klase"
 ],
 "Nothing on the books for this day. Enjoy the breather!": [
  "No hay nada programado para este día. ¡Disfruta el respiro!",
  "Walang nakatakda para sa araw na ito. Sulitin ang pahinga!"
 ],
 "No one enrolled yet.": [
  "Aún no hay nadie inscrito.",
  "Wala pang naka-enroll."
 ],
 "Building your packet…": [
  "Preparando tu paquete…",
  "Binubuo ang packet mo…"
 ],
 "Couldn't build this packet.": [
  "No se pudo crear este paquete.",
  "Hindi mabuo ang packet na ito."
 ],
 "Nothing scheduled": [
  "Nada programado",
  "Walang naka-iskedyul"
 ],
 "No classes on the books for": [
  "No hay clases programadas para",
  "Walang naka-iskedyul na klase para sa"
 ],
 ". There's nothing to print — enjoy the breather!": [
  ". No hay nada que imprimir; ¡disfruta el respiro!",
  ". Walang mai-print — sulitin ang pahinga!"
 ],
 "Back to Schedule": [
  "Volver al horario",
  "Bumalik sa Iskedyul"
 ],
 "Week": [
  "Semana",
  "Linggo"
 ],
 "packet": [
  "paquete",
  "packet"
 ],
 "day": [
  "día",
  "araw"
 ],
 "Page": [
  "Página",
  "Pahina"
 ],
 "Everything is grouped by what it controls. Pick a section to jump straight to it.": [
  "Todo está agrupado según lo que controla. Elige una sección para ir directamente a ella.",
  "Nakapangkat ang lahat ayon sa kung ano ang kinokontrol nito. Pumili ng seksyon para direktang pumunta roon."
 ],
 "123 Main St, Springfield, IL 62701": [
  "123 Main St, Springfield, IL 62701",
  "123 Main St, Springfield, IL 62701"
 ],
 "Instagram": [
  "Instagram",
  "Instagram"
 ],
 "TikTok": [
  "TikTok",
  "TikTok"
 ],
 "YouTube": [
  "YouTube",
  "YouTube"
 ],
 "Facebook": [
  "Facebook",
  "Facebook"
 ],
 "/parent/coach": [
  "/parent/coach",
  "/parent/coach"
 ],
 "you@newaddress.com": [
  "you@newaddress.com",
  "you@newaddress.com"
 ],
 "SplashPad": [
  "SplashPad",
  "SplashPad"
 ],
 "Pick a staff member.": [
  "Elige un miembro del personal.",
  "Pumili ng staff member."
 ],
 "Pick a location.": [
  "Elige una ubicación.",
  "Pumili ng lokasyon."
 ],
 "Pick a pay type.": [
  "Elige un tipo de pago.",
  "Pumili ng uri ng bayad."
 ],
 "Pick a date.": [
  "Elige una fecha.",
  "Pumili ng petsa."
 ],
 "Shift created.": [
  "Turno creado.",
  "Nagawa ang shift."
 ],
 "Shift updated.": [
  "Turno actualizado.",
  "Na-update ang shift."
 ],
 "Shift deleted.": [
  "Turno eliminado.",
  "Na-delete ang shift."
 ],
 "Shifts": [
  "Turnos",
  "Mga shift"
 ],
 "Schedule when your staff are working and at which location. Staff see their shifts in the staff portal.": [
  "Programa cuándo trabaja tu personal y en qué ubicación. El personal ve sus turnos en el portal del personal.",
  "I-iskedyul kung kailan nagtatrabaho ang iyong staff at saang lokasyon. Makikita ng staff ang kanilang mga shift sa staff portal."
 ],
 "Add shift": [
  "Agregar turno",
  "Magdagdag ng shift"
 ],
 "Invite staff coaches first from": [
  "Invita primero a los instructores del personal desde",
  "Imbitahan muna ang mga staff coach mula sa"
 ],
 "Staff": [
  "Personal",
  "Staff"
 ],
 "before scheduling shifts.": [
  "antes de programar turnos.",
  "bago mag-iskedyul ng mga shift."
 ],
 "Add at least one": [
  "Agrega al menos una",
  "Magdagdag ng kahit isang"
 ],
 "location": [
  "ubicación",
  "lokasyon"
 ],
 "Upcoming occurrences (next 60 days)": [
  "Próximas ocurrencias (próximos 60 días)",
  "Mga susunod na occurrence (susunod na 60 araw)"
 ],
 "No upcoming shifts in this window.": [
  "No hay próximos turnos en este período.",
  "Walang paparating na shift sa panahong ito."
 ],
 "All shifts": [
  "Todos los turnos",
  "Lahat ng shift"
 ],
 "No shifts created yet.": [
  "Aún no se han creado turnos.",
  "Wala pang nagagawang shift."
 ],
 "Every": [
  "Cada",
  "Bawat"
 ],
 "Delete this shift?": [
  "¿Eliminar este turno?",
  "I-delete ang shift na ito?"
 ],
 "This removes the shift for the staff coach. Past time-clock entries are kept for payroll.": [
  "Esto elimina el turno para el instructor del personal. Se conservan los registros anteriores del reloj de tiempo para la nómina.",
  "Aalisin nito ang shift para sa staff coach. Pananatiliin ang mga nakaraang time-clock entry para sa payroll."
 ],
 "Add a shift": [
  "Agregar un turno",
  "Magdagdag ng shift"
 ],
 "Edit shift": [
  "Editar turno",
  "I-edit ang shift"
 ],
 "Pick the staff coach, location, time, and pay type.": [
  "Elige el instructor del personal, la ubicación, el horario y el tipo de pago.",
  "Piliin ang staff coach, lokasyon, oras, at uri ng bayad."
 ],
 "Staff coach *": [
  "Instructor del personal *",
  "Staff coach *"
 ],
 "Pick coach": [
  "Elegir instructor",
  "Pumili ng coach"
 ],
 "Location *": [
  "Ubicación *",
  "Lokasyon *"
 ],
 "Pick location": [
  "Elegir ubicación",
  "Pumili ng lokasyon"
 ],
 "Day of week": [
  "Día de la semana",
  "Araw ng linggo"
 ],
 "(opt)": [
  "(opcional)",
  "(opsyonal)"
 ],
 "Date *": [
  "Fecha *",
  "Petsa *"
 ],
 "Start time *": [
  "Hora de inicio *",
  "Oras ng simula *"
 ],
 "Displays as": [
  "Se muestra como",
  "Ipinapakita bilang"
 ],
 "End time *": [
  "Hora de finalización *",
  "Oras ng pagtatapos *"
 ],
 "Pay type *": [
  "Tipo de pago *",
  "Uri ng bayad *"
 ],
 "e.g. Replace Sarah on Tuesdays": [
  "p. ej. Reemplazar a Sarah los martes",
  "hal. Palitan si Sarah tuwing Martes"
 ],
 "Your staff team": [
  "Tu equipo de personal",
  "Ang iyong team ng staff"
 ],
 "Add the coaches who work for you. Each staff coach gets a personal login that shows only the schedule, students, and attendance for the packages you assign to them.": [
  "Agrega a los instructores que trabajan para ti. Cada instructor del personal recibe un acceso personal que muestra solo el horario, los estudiantes y la asistencia de los paquetes que le asignes.",
  "Idagdag ang mga coach na nagtatrabaho para sa iyo. Bawat staff coach ay may personal na login na nagpapakita lang ng schedule, mga estudyante, at attendance para sa mga package na itatalaga mo sa kanila."
 ],
 "Seats used:": [
  "Asientos usados:",
  "Mga seat na ginagamit:"
 ],
 "Team": [
  "Equipo",
  "Team"
 ],
 "Time clock": [
  "Reloj de tiempo",
  "Time clock"
 ],
 "Payroll": [
  "Nómina",
  "Payroll"
 ],
 "Multi coach management tools are available exclusively for Pro members.": [
  "Las herramientas de gestión para múltiples instructores están disponibles exclusivamente para miembros Pro.",
  "Ang mga tool sa pamamahala ng maraming coach ay eksklusibong available para sa mga Pro member."
 ],
 "Upgrade to": [
  "Actualizar a",
  "Mag-upgrade sa"
 ],
 "($79.99/mo) to unlock multi coach staff portal, shifts, timeclock, and pay rates.": [
  "($79.99/mo) para desbloquear el portal de personal para múltiples instructores, turnos, reloj de tiempo y tarifas de pago.",
  "($79.99/mo) para ma-unlock ang multi coach staff portal, shifts, time clock, at pay rates."
 ],
 "You're at your staff seat limit.": [
  "Has alcanzado el límite de asientos de personal.",
  "Naabot mo na ang limitasyon ng staff seats mo."
 ],
 "Remove or disable an existing staff member, or contact support to add the": [
  "Elimina o desactiva a un miembro actual del personal, o contacta con soporte para agregar la mejora",
  "Alisin o i-disable ang kasalukuyang staff member, o makipag-ugnayan sa support para idagdag ang"
 ],
 "Staff Boost": [
  "Staff Boost",
  "Staff Boost"
 ],
 "upgrade for up to 50 seats.": [
  "para hasta 50 asientos.",
  "upgrade para sa hanggang 50 seats."
 ],
 "Loading staff…": [
  "Cargando personal…",
  "Nilo-load ang staff…"
 ],
 "You haven't added any staff yet.": [
  "Todavía no has agregado personal.",
  "Wala ka pang naidadagdag na staff."
 ],
 "Invite your first coach": [
  "Invita a tu primer instructor",
  "Imbitahan ang una mong coach"
 ],
 "Workforce": [
  "Personal",
  "Workforce"
 ],
 "Activation link": [
  "Enlace de activación",
  "Activation link"
 ],
 "We'll email this directly to your staff coach. If the email doesn't arrive, copy this link and share it manually (SMS, text, etc.).": [
  "Enviaremos esto directamente por correo electrónico a tu instructor del personal. Si el correo no llega, copia este enlace y compártelo manualmente (SMS, text, etc.).",
  "Direkta namin itong ie-email sa iyong staff coach. Kung hindi dumating ang email, kopyahin ang link na ito at i-share ito nang manu-mano (SMS, text, etc.)."
 ],
 "Link copied!": [
  "¡Enlace copiado!",
  "Nakopya ang link!"
 ],
 "Copy failed — long-press the link to copy.": [
  "Error al copiar: mantén presionado el enlace para copiarlo.",
  "Hindi nakopya — i-long press ang link para makopya."
 ],
 "Workforce settings updated.": [
  "Configuración de personal actualizada.",
  "Na-update ang mga setting ng workforce."
 ],
 "Workforce features": [
  "Funciones del personal",
  "Mga feature ng workforce"
 ],
 "Turn off the features you don't use. Disabled features won't appear in your sidebar or your staff coaches' portals.": [
  "Desactiva las funciones que no uses. Las funciones desactivadas no aparecerán en tu barra lateral ni en los portales de tus instructores del personal.",
  "I-off ang mga feature na hindi mo ginagamit. Hindi lalabas ang mga naka-disable na feature sa iyong sidebar o sa mga portal ng iyong mga staff coach."
 ],
 "Master switch": [
  "Interruptor maestro",
  "Master switch"
 ],
 "Master switch is OFF. All workforce features (time clock, shifts, pay rates) are hidden for you and your staff.": [
  "El interruptor maestro está DESACTIVADO. Todas las funciones del personal (reloj de tiempo, turnos, tarifas de pago) están ocultas para ti y tu personal.",
  "Naka-OFF ang master switch. Lahat ng workforce feature (time clock, shifts, pay rates) ay nakatago para sa iyo at sa iyong staff."
 ],
 "Reset": [
  "Restablecer",
  "I-reset"
 ],
 "Save settings": [
  "Guardar configuración",
  "I-save ang settings"
 ],
 "Per-coach workforce overrides updated.": [
  "Se actualizaron las anulaciones de personal por instructor.",
  "Na-update ang per-coach workforce overrides."
 ],
 "Workforce overrides —": [
  "Anulaciones de personal —",
  "Workforce overrides —"
 ],
 "By default each coach inherits your business-wide settings. Pick \"Force ON\" or \"Force OFF\" to override on a per-coach basis.": [
  "De forma predeterminada, cada instructor hereda la configuración general de tu negocio. Elige \"Force ON\" o \"Force OFF\" para anularla por instructor.",
  "Bilang default, minamana ng bawat coach ang business-wide settings mo. Piliin ang \"Force ON\" o \"Force OFF\" para mag-override bawat coach."
 ],
 "Business default:": [
  "Predeterminado del negocio:",
  "Business default:"
 ],
 "ON": [
  "ACTIVADO",
  "ON"
 ],
 "OFF": [
  "DESACTIVADO",
  "OFF"
 ],
 "Inherit (": [
  "Heredar (",
  "Inherit ("
 ],
 "Text selected (": [
  "Texto seleccionado (",
  "Napiling teksto ("
 ],
 "family has": [
  "la familia tiene",
  "ang pamilya ay may"
 ],
 "families have": [
  "las familias tienen",
  "ang mga pamilya ay may"
 ],
 "multiple enrollments.": [
  "múltiples inscripciones.",
  "maramihang enrollment."
 ],
 "Each family shows once in this list — click": [
  "Cada familia aparece una sola vez en esta lista; haz clic en",
  "Bawat pamilya ay isang beses lang ipinapakita sa listahang ito — i-click ang"
 ],
 "Dive In": [
  "Dive In",
  "Dive In"
 ],
 "to see every student, every enrollment, attendance, and payments in one panel.": [
  "para ver a cada estudiante, cada inscripción, la asistencia y los pagos en un solo panel.",
  "para makita ang bawat estudyante, bawat enrollment, attendance, at bayad sa iisang panel."
 ],
 "Select all visible families": [
  "Seleccionar todas las familias visibles",
  "Piliin ang lahat ng nakikitang pamilya"
 ],
 "Student(s)": [
  "Estudiante(s)",
  "(Mga) Estudyante"
 ],
 "Last activity": [
  "Última actividad",
  "Huling aktibidad"
 ],
 "No students yet.": [
  "Aún no hay estudiantes.",
  "Wala pang mga estudyante."
 ],
 "— no students yet —": [
  "— aún no hay estudiantes —",
  "— wala pang mga estudyante —"
 ],
 "Age unknown": [
  "Edad desconocida",
  "Hindi alam ang edad"
 ],
 "— not enrolled yet —": [
  "— aún no está inscrito —",
  "— hindi pa enrolled —"
 ],
 "enrollments": [
  "inscripciones",
  "mga enrollment"
 ],
 "This family paid for a package with no set times yet. Click for options.": [
  "Esta familia pagó un paquete sin horarios establecidos todavía. Haz clic para ver opciones.",
  "Nagbayad ang pamilyang ito para sa isang package na wala pang nakatakdang oras. I-click para sa mga opsyon."
 ],
 "Needs scheduling": [
  "Necesita programación",
  "Kailangang i-schedule"
 ],
 "lessons — add them all at once": [
  "lecciones — agrégalas todas de una vez",
  "mga lesson — idagdag silang lahat nang sabay-sabay"
 ],
 "Dismiss (I schedule elsewhere)": [
  "Descartar (programo en otro lugar)",
  "I-dismiss (sa iba ako nagsa-schedule)"
 ],
 "This family used up their lesson pack. Click to renew in one tap.": [
  "Esta familia agotó su paquete de clases. Haz clic para renovar con un toque.",
  "Naubos na ng pamilyang ito ang kanilang lesson pack. I-click para mag-renew sa isang tap."
 ],
 "Pack used up — renew?": [
  "Paquete agotado — ¿renovar?",
  "Naubos na ang pack — mag-renew?"
 ],
 "Renew — charge card on file": [
  "Renovar — cobrar a la tarjeta guardada",
  "Mag-renew — i-charge ang naka-file na card"
 ],
 "Dismiss (not renewing)": [
  "Descartar (no renovar)",
  "I-dismiss (hindi magre-renew)"
 ],
 "outstanding": [
  "pendiente",
  "natitira pang bayaran"
 ],
 "All waivers signed.": [
  "Todas las exenciones están firmadas.",
  "Lahat ng waiver ay pirmado."
 ],
 "All signed": [
  "Todo firmado",
  "Lahat pirmado"
 ],
 "Dive in": [
  "Dive in",
  "Dive in"
 ],
 "Pending signup actions": [
  "Acciones de registro pendientes",
  "Mga nakabinbing aksyon sa signup"
 ],
 "Pending signup": [
  "Registro pendiente",
  "Nakabinbing signup"
 ],
 "Resend payment link": [
  "Reenviar enlace de pago",
  "Ipadala muli ang payment link"
 ],
 "Dismiss (remove from list)": [
  "Descartar (quitar de la lista)",
  "I-dismiss (alisin sa listahan)"
 ],
 "Enrollment details": [
  "Detalles de la inscripción",
  "Mga detalye ng enrollment"
 ],
 "Emergency:": [
  "Emergencia:",
  "Emergency:"
 ],
 "· Age": [
  "· Edad",
  "· Edad"
 ],
 "· Level": [
  "· Nivel",
  "· Antas"
 ],
 "Force ON": [
  "Forzar ACTIVADO",
  "Piliting BUKAS"
 ],
 "Force OFF": [
  "Forzar DESACTIVADO",
  "Piliting PATAY"
 ],
 "Save overrides": [
  "Guardar anulaciones",
  "I-save ang mga override"
 ],
 "Pay rates updated.": [
  "Tarifas de pago actualizadas.",
  "Na-update ang mga rate ng bayad."
 ],
 "Set pay rates for": [
  "Establecer tarifas de pago para",
  "Itakda ang mga rate ng bayad para sa"
 ],
 "Three separate hourly rates: training (setup / non-teaching), group lessons, and private lessons. Used by the time clock to calculate gross pay.": [
  "Tres tarifas por hora separadas: capacitación (preparación / no enseñanza), clases grupales y clases privadas. Las usa el reloj de tiempo para calcular el pago bruto.",
  "Tatlong magkakahiwalay na hourly rate: training (setup / non-teaching), group lessons, at private lessons. Ginagamit ng time clock para kalkulahin ang gross pay."
 ],
 "Save rates": [
  "Guardar tarifas",
  "I-save ang mga rate"
 ],
 "Invitation re-sent.": [
  "Invitación reenviada.",
  "Naipadala muli ang imbitasyon."
 ],
 "Staff coach removed.": [
  "Instructor del personal eliminado.",
  "Inalis ang staff coach."
 ],
 "Change photo": [
  "Cambiar foto",
  "Palitan ang litrato"
 ],
 "Add photo so parents recognize them": [
  "Agregar foto para que los padres lo reconozcan",
  "Magdagdag ng litrato para makilala siya ng mga magulang"
 ],
 "Last login": [
  "Último inicio de sesión",
  "Huling pag-login"
 ],
 "Invited": [
  "Invitado",
  "Naimbitahan"
 ],
 "Disabled": [
  "Deshabilitado",
  "Naka-disable"
 ],
 "All off": [
  "Todo desactivado",
  "Lahat naka-off"
 ],
 "Pay rates": [
  "Tarifas de pago",
  "Mga rate ng bayad"
 ],
 "Edit profile & photo": [
  "Editar perfil y foto",
  "I-edit ang profile at litrato"
 ],
 "Set pay rates": [
  "Establecer tarifas de pago",
  "Itakda ang mga rate ng bayad"
 ],
 "Workforce overrides": [
  "Anulaciones de personal",
  "Mga override ng workforce"
 ],
 "Resend invite": [
  "Reenviar invitación",
  "Ipadala muli ang imbitasyon"
 ],
 "Disable": [
  "Deshabilitar",
  "I-disable"
 ],
 "Re-enable": [
  "Volver a habilitar",
  "I-enable muli"
 ],
 "They'll lose access to their staff portal immediately. Any packages they were assigned to will be reset to \"Owner (me).\" This action can be reversed by re-inviting them.": [
  "Perderán acceso a su portal del personal de inmediato. Cualquier paquete que se les haya asignado se restablecerá a \"Owner (me)\". Esta acción se puede revertir volviéndolos a invitar.",
  "Mawawala agad ang access nila sa kanilang staff portal. Anumang package na naka-assign sa kanila ay mare-reset sa \"Owner (me).\" Maaaring baligtarin ang aksyong ito sa pamamagitan ng pag-imbita sa kanila muli."
 ],
 "Yes, remove": [
  "Sí, eliminar",
  "Oo, alisin"
 ],
 "Display name is required.": [
  "El nombre para mostrar es obligatorio.",
  "Kailangan ang display name."
 ],
 "Temporary password must be at least 8 characters.": [
  "La contraseña temporal debe tener al menos 8 caracteres.",
  "Ang pansamantalang password ay dapat may hindi bababa sa 8 character."
 ],
 "Invite a staff coach": [
  "Invitar a un instructor del personal",
  "Mag-imbita ng staff coach"
 ],
 "They'll get their own login that shows the schedule, students, and attendance for the packages you assign to them.": [
  "Recibirán su propio inicio de sesión que muestra el horario, los estudiantes y la asistencia de los paquetes que les asignes.",
  "Magkakaroon sila ng sarili nilang login na nagpapakita ng schedule, mga estudyante, at attendance para sa mga package na ia-assign mo sa kanila."
 ],
 "Email invite link": [
  "Enviar enlace de invitación por correo electrónico",
  "I-email ang invite link"
 ],
 "Set temporary password": [
  "Establecer contraseña temporal",
  "Magtakda ng pansamantalang password"
 ],
 "Recommended. They'll get an email with a one-time activation link (good for 7 days) and choose their own password.": [
  "Recomendado. Recibirán un correo electrónico con un enlace de activación de un solo uso (válido por 7 días) y elegirán su propia contraseña.",
  "Inirerekomenda. Makakatanggap sila ng email na may one-time activation link (valid sa loob ng 7 araw) at pipili ng sarili nilang password."
 ],
 "Set the starting password yourself. Useful when you're sitting next to them and want to onboard on the spot. They should change it from settings right away.": [
  "Establece tú mismo la contraseña inicial. Útil cuando estás sentado junto a ellos y quieres incorporarlos en el momento. Deben cambiarla de inmediato desde configuración.",
  "Ikaw mismo ang magtakda ng panimulang password. Kapaki-pakinabang kapag katabi mo sila at gusto mo silang i-onboard agad. Dapat nila itong palitan kaagad mula sa settings."
 ],
 "Display name *": [
  "Nombre para mostrar *",
  "Display name *"
 ],
 "e.g. Sarah Johnson": [
  "p. ej. Sarah Johnson",
  "hal. Sarah Johnson"
 ],
 "Email *": [
  "Correo electrónico *",
  "Email *"
 ],
 "sarah@example.com": [
  "sarah@example.com",
  "sarah@example.com"
 ],
 "Temporary password *": [
  "Contraseña temporal *",
  "Pansamantalang password *"
 ],
 "They'll be able to log in immediately with this password.": [
  "Podrán iniciar sesión de inmediato con esta contraseña.",
  "Makakapag-log in sila agad gamit ang password na ito."
 ],
 "Send invite": [
  "Enviar invitación",
  "Ipadala ang imbitasyon"
 ],
 "Add staff coach": [
  "Agregar instructor del personal",
  "Magdagdag ng staff coach"
 ],
 "Couldn't locate the pending signup for this family.": [
  "No se pudo localizar el registro pendiente de esta familia.",
  "Hindi mahanap ang nakabinbing signup para sa pamilyang ito."
 ],
 "This family doesn't have an approved application yet — approve them under Applications first.": [
  "Esta familia todavía no tiene una solicitud aprobada; apruébela primero en Solicitudes.",
  "Wala pang aprubadong application ang pamilyang ito — aprubahan muna sila sa Applications."
 ],
 "Already marked paid — no changes needed.": [
  "Ya marcado como pagado; no se necesitan cambios.",
  "Nakamarkahan na bilang bayad — walang kailangang baguhin."
 ],
 "Marked as paid — sessions activated": [
  "Marcado como pagado; sesiones activadas",
  "Namarkahan bilang bayad — na-activate ang mga session"
 ],
 "Removed the pending signup from your Students list.": [
  "Se eliminó el registro pendiente de tu lista de Estudiantes.",
  "Inalis ang nakabinbing signup sa iyong listahan ng mga Estudyante."
 ],
 "Family is missing an email.": [
  "A esta familia le falta un correo electrónico.",
  "Walang email ang pamilyang ito."
 ],
 "Pick a date and time.": [
  "Elige una fecha y hora.",
  "Pumili ng petsa at oras."
 ],
 "Review and confirm the updated date preview before saving.": [
  "Revisa y confirma la vista previa de la fecha actualizada antes de guardar.",
  "Suriin at kumpirmahin ang preview ng na-update na petsa bago i-save."
 ],
 "Pick a Class or Package first.": [
  "Elige primero una Clase o un Paquete.",
  "Pumili muna ng Klase o Package."
 ],
 "No approved application found for this family — ask them to re-apply, then enroll from the approval card.": [
  "No se encontró ninguna solicitud aprobada para esta familia; pídeles que vuelvan a solicitarla y luego inscríbelos desde la tarjeta de aprobación.",
  "Walang nahanap na aprubadong application para sa pamilyang ito — hilingin sa kanilang mag-apply muli, saka i-enroll mula sa approval card."
 ],
 "Subscription started — card on file was charged for the first cycle.": [
  "Suscripción iniciada; se cobró a la tarjeta registrada el primer ciclo.",
  "Nagsimula ang subscription — siningil ang naka-save na card para sa unang cycle."
 ],
 "Payment captured. Family is enrolled.": [
  "Pago capturado. La familia está inscrita.",
  "Nakuha ang bayad. Naka-enroll na ang pamilya."
 ],
 "Invite emailed — they'll review and pay inline.": [
  "Invitación enviada por correo electrónico; revisarán y pagarán en línea.",
  "Na-email na ang imbitasyon — rerepasuhin nila at magbabayad sila roon din."
 ],
 "Card on file was declined. We've emailed them a pay-link instead.": [
  "La tarjeta registrada fue rechazada. Les enviamos por correo electrónico un enlace de pago en su lugar.",
  "Na-decline ang naka-save na card. Nag-email na lang kami sa kanila ng pay-link."
 ],
 "Enrolled. Charge per-lesson from Payments when ready.": [
  "Inscrita. Cobra por lección desde Pagos cuando estés listo.",
  "Naka-enroll na. Singilin kada leksyon mula sa Payments kapag handa na."
 ],
 "Enrolled.": [
  "Inscrita.",
  "Naka-enroll na."
 ],
 "Scheduled drop cleared.": [
  "Baja programada eliminada.",
  "Na-clear ang nakaiskedyul na drop."
 ],
 "Missing enrollment reference.": [
  "Falta la referencia de inscripción.",
  "Nawawala ang reference ng enrollment."
 ],
 "Pick at least one family first.": [
  "Elige al menos una familia primero.",
  "Pumili muna ng kahit isang pamilya."
 ],
 "None of the selected families have a phone on file.": [
  "Ninguna de las familias seleccionadas tiene un teléfono registrado.",
  "Wala sa mga napiling pamilya ang may phone na naka-file."
 ],
 "Could not build an SMS link — please check the phone numbers.": [
  "No se pudo crear un enlace SMS; revisa los números de teléfono.",
  "Hindi makagawa ng SMS link — pakisuri ang mga numero ng telepono."
 ],
 "Waiver filter": [
  "Filtro de exención",
  "Waiver filter"
 ],
 "All waivers": [
  "Todas las exenciones",
  "Lahat ng waiver"
 ],
 "Signed": [
  "Firmado",
  "Napirmahan"
 ],
 "Students & enrollments": [
  "Estudiantes e inscripciones",
  "Mga estudyante at enrollment"
 ],
 "Leads": [
  "Prospectos",
  "Mga lead"
 ],
 "Waitlist": [
  "Lista de espera",
  "Waitlist"
 ],
 "family": [
  "familia",
  "pamilya"
 ],
 "selected": [
  "seleccionada",
  "napili"
 ],
 "missing a phone)": [
  "falta un teléfono)",
  "walang phone)"
 ],
 "Notes:": [
  "Notas:",
  "Mga tala:"
 ],
 "Ongoing ·": [
  "En curso ·",
  "Kasalukuyan ·"
 ],
 "completed": [
  "completado",
  "nakumpleto"
 ],
 "sessions remaining": [
  "sesiones restantes",
  "natitirang session"
 ],
 "Download waiver PDF": [
  "Descargar exención en PDF",
  "I-download ang waiver PDF"
 ],
 "We'll open your phone's Messages app with these numbers and your typed note pre-filled. Tap": [
  "Abriremos la app Mensajes de tu teléfono con estos números y tu nota escrita previamente completada. Toca",
  "Bubuksan namin ang Messages app ng phone mo kasama ang mga numerong ito at ang note na na-type mo na naka-prefill. I-tap ang"
 ],
 "in Messages to actually send — nothing is sent until then.": [
  "en Mensajes para enviarlo de verdad; no se envía nada hasta entonces.",
  "sa Messages para talagang maipadala — walang ipapadala hanggang doon."
 ],
 "Recipients": [
  "Destinatarios",
  "Mga tatanggap"
 ],
 "Type the message you'd like to send…": [
  "Escribe el mensaje que te gustaría enviar…",
  "I-type ang mensaheng gusto mong ipadala…"
 ],
 "Tip: iPhone will group up to ~10 recipients into one MMS thread. For larger lists, split into batches or use": [
  "Consejo: iPhone agrupará hasta ~10 destinatarios en un hilo MMS. Para listas más grandes, divídelas en lotes o usa",
  "Tip: Ipapangkat ng iPhone ang hanggang ~10 tatanggap sa isang MMS thread. Para sa mas mahahabang listahan, hatiin sa mga batch o gamitin ang"
 ],
 "Email all families": [
  "Enviar correo a todas las familias",
  "I-email ang lahat ng pamilya"
 ],
 "Open Messages": [
  "Abrir Mensajes",
  "Buksan ang Messages"
 ],
 "Email an invoice to": [
  "Enviar una factura por correo electrónico a",
  "Mag-email ng invoice sa"
 ],
 ". We'll send a clean \"Pay now\" button that opens an inline payment form — no Stripe links to copy, no external redirects.": [
  ". Enviaremos un botón limpio de \"Pagar ahora\" que abre un formulario de pago integrado; no hay enlaces de Stripe para copiar ni redirecciones externas.",
  ". Magpapadala kami ng malinis na \"Pay now\" button na magbubukas ng inline na payment form — walang Stripe links na kokopyahin, walang external redirects."
 ],
 "Amount (optional)": [
  "Importe (opcional)",
  "Halaga (opsyonal)"
 ],
 "Shown on the parent's Payments tab.": [
  "Se muestra en la pestaña Pagos del padre.",
  "Ipapakita sa tab na Payments ng magulang."
 ],
 "Due date (optional)": [
  "Fecha de vencimiento (opcional)",
  "Due date (opsyonal)"
 ],
 "Flags the invoice as overdue if missed.": [
  "Marca la factura como vencida si no se paga a tiempo.",
  "Mamarkahan ang invoice bilang overdue kapag nalagpasan ito."
 ],
 "left": [
  "restantes",
  "natitira"
 ],
 "in": [
  "en",
  "sa"
 ],
 "Time": [
  "Hora",
  "Oras"
 ],
 "Duration (minutes)": [
  "Duración (minutos)",
  "Tagal (minuto)"
 ],
 "Same time every week": [
  "La misma hora cada semana",
  "Parehong oras bawat linggo"
 ],
 "Include past lessons already taught": [
  "Incluir clases pasadas ya impartidas",
  "Isama ang mga nakaraang lesson na naituro na"
 ],
 "I confirm the past dates below were already taught. Uses this package; no extra charge. Mark attendance separately for each child.": [
  "Confirmo que las fechas pasadas a continuación ya fueron impartidas. Usa este paquete; sin cargo adicional. Marca la asistencia por separado para cada niño.",
  "Kinukumpirma ko na ang mga nakaraang petsa sa ibaba ay naituro na. Gagamitin nito ang package na ito; walang dagdag na bayad. Markahan nang hiwalay ang attendance para sa bawat bata."
 ],
 "date": [
  "fecha",
  "petsa"
 ],
 "dates": [
  "fechas",
  "mga petsa"
 ],
 "Updating date preview": [
  "Actualizando vista previa de fechas",
  "Ina-update ang preview ng petsa"
 ],
 "Updating date preview…": [
  "Actualizando vista previa de fechas…",
  "Ina-update ang preview ng petsa…"
 ],
 "Retry preview": [
  "Reintentar vista previa",
  "Subukang muli ang preview"
 ],
 "Past lesson included": [
  "Clase pasada incluida",
  "Kasama ang nakaraang lesson"
 ],
 "Included": [
  "Incluido",
  "Kasama"
 ],
 "will be added": [
  "se agregarán",
  "idaragdag"
 ],
 "Refresh preview": [
  "Actualizar vista previa",
  "I-refresh ang preview"
 ],
 "Review the updated preview before saving.": [
  "Revisa la vista previa actualizada antes de guardar.",
  "Suriin ang na-update na preview bago i-save."
 ],
 "to confirm": [
  "para confirmar",
  "para kumpirmahin"
 ],
 "Doesn't match — check spelling and spacing.": [
  "No coincide: revisa la ortografía y los espacios.",
  "Hindi tugma — suriin ang baybay at mga espasyo."
 ],
 "Deleting": [
  "Eliminando",
  "Tinatanggal"
 ],
 "Dismiss pending signup?": [
  "¿Descartar inscripción pendiente?",
  "I-dismiss ang nakabinbing signup?"
 ],
 "This removes the family from your Students list. We": [
  "Esto elimina a la familia de tu lista de Estudiantes. No",
  "Aalisin nito ang pamilya mula sa iyong listahan ng mga Estudyante. Hindi namin"
 ],
 "won't email them": [
  "les enviaremos correos electrónicos",
  "sila ie-email"
 ],
 "— the record is kept for your records but hidden from view. You can always re-invite them from the coach public page.": [
  "— el registro se conserva para tus archivos, pero se oculta de la vista. Siempre puedes volver a invitarlos desde la página pública del instructor.",
  "— mananatili ang record para sa iyong files pero nakatago sa view. Maaari mo silang imbitahan muli anumang oras mula sa pampublikong page ng coach."
 ],
 "Keep them": [
  "Mantenerlos",
  "Panatilihin sila"
 ],
 "Dismissing": [
  "Descartando",
  "Dini-dismiss"
 ],
 "Schedule a drop date for this enrollment only": [
  "Programar una fecha de baja solo para esta inscripción",
  "Magtakda ng drop date para sa enrollment na ito lang"
 ],
 "Set drop-from-class date": [
  "Establecer fecha de baja de la clase",
  "Itakda ang drop-from-class date"
 ],
 "(this class only)": [
  "(solo esta clase)",
  "(ang class na ito lang)"
 ],
 "edit": [
  "editar",
  "i-edit"
 ],
 "clear": [
  "borrar",
  "i-clear"
 ],
 "Drop from this class on": [
  "Dar de baja de esta clase el",
  "I-drop mula sa class na ito sa"
 ],
 "Drops only from": [
  "Dar de baja solo de",
  "Mag-drop lang mula sa"
 ],
 "this class": [
  "esta clase",
  "class na ito"
 ],
 "— the student stays in your program. Stripe billing auto-prorates so the parent gets credited for unused time.": [
  "— el estudiante permanece en tu programa. La facturación de Stripe se prorratea automáticamente para que el padre, madre o tutor reciba un crédito por el tiempo no usado.",
  "— mananatili ang estudyante sa iyong programa. Awtomatikong pini-prorate ng Stripe billing para mabigyan ng credit ang magulang para sa hindi nagamit na oras."
 ],
 "No class time": [
  "Sin horario de clase",
  "Walang oras ng class"
 ],
 "— no class time —": [
  "— sin horario de clase —",
  "— walang oras ng class —"
 ],
 "Payroll CSV downloaded.": [
  "CSV de nómina descargado.",
  "Na-download ang payroll CSV."
 ],
 "Timesheet": [
  "Hoja de horas",
  "Timesheet"
 ],
 "Hours worked, broken down by pay type. Download a payroll CSV any time.": [
  "Horas trabajadas, desglosadas por tipo de pago. Descarga un CSV de nómina en cualquier momento.",
  "Mga oras na nagtrabaho, naka-breakdown ayon sa uri ng bayad. Mag-download ng payroll CSV anumang oras."
 ],
 "Export CSV": [
  "Exportar CSV",
  "I-export ang CSV"
 ],
 "Total hours": [
  "Horas totales",
  "Kabuuang oras"
 ],
 "Gross pay": [
  "Pago bruto",
  "Kabuuang bayad"
 ],
 "Training hrs": [
  "Horas de capacitación",
  "Training hrs"
 ],
 "Lesson hrs": [
  "Horas de lecciones",
  "Lesson hrs"
 ],
 "No timecards in this period.": [
  "No hay tarjetas de tiempo en este período.",
  "Walang timecards sa panahong ito."
 ],
 "Out": [
  "Salida",
  "Out"
 ],
 "Hours": [
  "Horas",
  "Oras"
 ],
 "Rate": [
  "Tarifa",
  "Rate"
 ],
 "/hr": [
  "/h",
  "/hr"
 ],
 "Could not download any waivers. Please refresh and try again.": [
  "No se pudo descargar ningún formulario de exención de responsabilidad. Actualiza la página e inténtalo de nuevo.",
  "Hindi na-download ang anumang waiver. Paki-refresh at subukan muli."
 ],
 "Every signed liability waiver you've collected, plus any pending signatures. Download individually or grab them all at once.": [
  "Todos los formularios de exención de responsabilidad firmados que has recopilado, además de cualquier firma pendiente. Descárgalos individualmente o descárgalos todos a la vez.",
  "Lahat ng nalagdaang liability waiver na nakolekta mo, kasama ang anumang nakabinbing pirma. I-download nang paisa-isa o kunin silang lahat nang sabay-sabay."
 ],
 "Resolve the preview issue before saving.": [
  "Resuelve el problema de vista previa antes de guardar.",
  "Ayusin ang isyu sa preview bago i-save."
 ],
 "Confirm the past lessons were already taught, or choose a future start date.": [
  "Confirma que las clases pasadas ya se impartieron o elige una fecha de inicio futura.",
  "Kumpirmahin na naituro na ang mga nakaraang lesson, o pumili ng petsa ng pagsisimula sa hinaharap."
 ],
 "No lessons can be added for these dates.": [
  "No se pueden agregar clases para estas fechas.",
  "Walang maidagdag na lesson para sa mga petsang ito."
 ],
 "Add lesson": [
  "Agregar clase",
  "Magdagdag ng lesson"
 ],
 "Enroll in another Class or Package": [
  "Inscribirse en otra clase o paquete",
  "Mag-enroll sa isa pang Class o Package"
 ],
 "Enroll in Class or Package": [
  "Inscribirse en una clase o paquete",
  "Mag-enroll sa Class o Package"
 ],
 "another": [
  "otra",
  "isa pang"
 ],
 "class or package on top of their current enrollment": [
  "clase o paquete además de su inscripción actual",
  "class o package bukod sa kasalukuyan nilang enrollment"
 ],
 ". If they have a card on file we'll charge it immediately (or start the subscription) — otherwise we'll email them a secure pay-link.": [
  ". Si tienen una tarjeta registrada, la cobraremos de inmediato (o iniciaremos la suscripción); de lo contrario, les enviaremos por correo electrónico un enlace de pago seguro.",
  ". Kung may card sila na naka-file, agad namin itong sisingilin (o sisimulan ang subscription) — kung wala, padadalhan namin sila ng secure na pay-link sa email."
 ],
 "Pick what to enroll": [
  "Elige en qué inscribir",
  "Piliin kung saan ie-enroll"
 ],
 "in. If they have a card on file we'll charge it immediately (or start the subscription) — otherwise we'll email them a secure pay-link.": [
  "en. Si tienen una tarjeta registrada, la cobraremos de inmediato (o iniciaremos la suscripción); de lo contrario, les enviaremos por correo electrónico un enlace de pago seguro.",
  "sa. Kung may card sila na naka-file, agad namin itong sisingilin (o sisimulan ang subscription) — kung wala, padadalhan namin sila ng secure na pay-link sa email."
 ],
 "Class or Package": [
  "Clase o paquete",
  "Class o Package"
 ],
 "You don't have any active Classes or Packages yet. Create one on the Classes & Packages page first.": [
  "Aún no tienes clases o paquetes activos. Crea uno primero en la página Clases y paquetes.",
  "Wala ka pang active na Classes o Packages. Gumawa muna ng isa sa page na Classes & Packages."
 ],
 "This family is already enrolled in your only active Class/Package. Create another one to enroll them in a second class.": [
  "Esta familia ya está inscrita en tu única clase/paquete activo. Crea otro para inscribirla en una segunda clase.",
  "Ang pamilyang ito ay naka-enroll na sa tanging active mong Class/Package. Gumawa ng isa pa para ma-enroll sila sa pangalawang class."
 ],
 "Choose a Class or Package": [
  "Elige una clase o paquete",
  "Pumili ng Class o Package"
 ],
 "Classes (recurring)": [
  "Clases (recurrentes)",
  "Classes (recurring)"
 ],
 "/mo ·": [
  "/mes ·",
  "/buwan ·"
 ],
 "Packages (one-time / per-lesson)": [
  "Paquetes (pago único / por clase)",
  "Packages (one-time / per-lesson)"
 ],
 "/lesson": [
  "/clase",
  "/lesson"
 ],
 "We'll attempt to charge the family's card on file. No card? They'll get a branded email with a secure pay-link to complete the enrollment.": [
  "Intentaremos cobrar a la tarjeta registrada de la familia. ¿No hay tarjeta? Recibirán un correo electrónico de marca con un enlace de pago seguro para completar la inscripción.",
  "Susubukan naming singilin ang card ng pamilya na naka-file. Walang card? Makakatanggap sila ng branded na email na may secure na pay-link para kumpletuhin ang enrollment."
 ],
 "Class — recurring subscription.": [
  "Clase: suscripción recurrente.",
  "Class — recurring subscription."
 ],
 "Card on file = auto-bills today + every month. No card = email pay-link, subscription starts when they pay.": [
  "Tarjeta registrada = cobros automáticos hoy y cada mes. Sin tarjeta = enlace de pago por correo electrónico; la suscripción comienza cuando pagan.",
  "Card on file = auto-bills today + every month. No card = email pay-link, magsisimula ang subscription kapag nagbayad sila."
 ],
 "Per-lesson package.": [
  "Paquete por clase.",
  "Per-lesson package."
 ],
 "No auto-charge — we just create the enrollment. Charge the family from": [
  "Sin cobro automático: solo creamos la inscripción. Cobra a la familia desde",
  "Walang auto-charge — gagawin lang namin ang enrollment. Singilin ang pamilya mula sa"
 ],
 "as you run each lesson.": [
  "mientras impartes cada clase.",
  "habang isinasagawa mo ang bawat lesson."
 ],
 "Package — one-time payment.": [
  "Paquete: pago único.",
  "Package — one-time payment."
 ],
 "Card on file = charge $": [
  "Tarjeta registrada = cobrar $",
  "Card on file = charge $"
 ],
 "immediately. No card = email pay-link, enrollment activates after they pay.": [
  "de inmediato. Sin tarjeta = enlace de pago por correo electrónico; la inscripción se activa después de que paguen.",
  "agad. No card = email pay-link, magiging active ang enrollment pagkatapos nilang magbayad."
 ],
 "Class block (optional)": [
  "Bloque de clases (opcional)",
  "Class block (optional)"
 ],
 "Any block — pick later": [
  "Cualquier bloque: elegir después",
  "Anumang block — pumili mamaya"
 ],
 "No specific block (any)": [
  "Sin bloque específico (cualquiera)",
  "Walang partikular na block (kahit alin)"
 ],
 "Pin them to a recurring weekly slot so they appear on its roster.": [
  "Asígnalos a un horario semanal recurrente para que aparezcan en su lista.",
  "I-pin sila sa isang recurring na lingguhang slot para lumabas sila sa roster nito."
 ],
 "When their enrollment begins. Defaults to today.": [
  "Cuándo comienza su inscripción. De forma predeterminada, hoy.",
  "Kailan magsisimula ang enrollment nila. Default ay ngayon."
 ],
 "Enrolling": [
  "Inscribiendo",
  "Ini-enroll"
 ],
 "Drop from class": [
  "Dar de baja de la clase",
  "I-drop mula sa class"
 ],
 "Signed (": [
  "Firmado (",
  "Nilagdaan ("
 ],
 "Pending (": [
  "Pendiente (",
  "Nakabinbin ("
 ],
 "No signed waivers yet.": [
  "Aún no hay exenciones firmadas.",
  "Wala pang mga pirmadong waiver."
 ],
 "PDF": [
  "PDF",
  "PDF"
 ],
 "Signed at": [
  "Firmado el",
  "Nilagdaan noong"
 ],
 "Downloading": [
  "Descargando",
  "Dinada-download"
 ],
 "No pending waivers.": [
  "No hay exenciones pendientes.",
  "Walang nakabinbing waiver."
 ],
 "Unknown template type.": [
  "Tipo de plantilla desconocido.",
  "Hindi kilalang uri ng template."
 ],
 "Assembled from your profile": [
  "Generado a partir de tu perfil",
  "Binuo mula sa iyong profile"
 ],
 "Powered by your Locations": [
  "Impulsado por tus Ubicaciones",
  "Pinapagana ng iyong Mga Lokasyon"
 ],
 "Powered by Travel Smart (Pro)": [
  "Impulsado por Travel Smart (Pro)",
  "Pinapagana ng Travel Smart (Pro)"
 ],
 "Page intro banner": [
  "Banner de introducción de la página",
  "Banner ng pambungad sa pahina"
 ],
 "Unknown section.": [
  "Sección desconocida.",
  "Hindi kilalang seksyon."
 ],
 "Use our wording": [
  "Usa nuestro texto",
  "Gamitin ang aming teksto"
 ],
 "Leave a field blank to keep the text we wrote for you.": [
  "Deja un campo en blanco para mantener el texto que escribimos para ti.",
  "Iwanang blangko ang isang field para panatilihin ang tekstong isinulat namin para sa iyo."
 ],
 "Benefit cards": [
  "Tarjetas de beneficios",
  "Mga benefit card"
 ],
 "(auto-written)": [
  "(escrito automáticamente)",
  "(awtomatikong isinulat)"
 ],
 "Back to auto-written": [
  "Volver al texto automático",
  "Bumalik sa awtomatikong isinulat"
 ],
 "These cards are written for you from your profile and packages. Customize them to change the wording, icons or order.": [
  "Estas tarjetas se escriben para ti a partir de tu perfil y paquetes. Personalízalas para cambiar el texto, los íconos o el orden.",
  "Ang mga card na ito ay isinulat para sa iyo mula sa iyong profile at mga package. I-customize ang mga ito para baguhin ang teksto, mga icon, o pagkakasunod-sunod."
 ],
 "Customize these cards": [
  "Personaliza estas tarjetas",
  "I-customize ang mga card na ito"
 ],
 "Card title": [
  "Título de la tarjeta",
  "Pamagat ng card"
 ],
 "One or two sentences…": [
  "Una o dos frases…",
  "Isa o dalawang pangungusap…"
 ],
 "Card": [
  "Tarjeta",
  "Card"
 ],
 "Add a card": [
  "Agregar una tarjeta",
  "Magdagdag ng card"
 ],
 "Change icon": [
  "Cambiar ícono",
  "Palitan ang icon"
 ],
 "You are already on the team page.": [
  "Ya estás en la página del equipo.",
  "Nasa page ng team ka na."
 ],
 "Added you to the team page — edit your role or bio below.": [
  "Te agregamos a la página del equipo: edita tu función o biografía abajo.",
  "Idinagdag ka na sa page ng team — i-edit ang iyong role o bio sa ibaba."
 ],
 "No staff coaches found in Team Management yet.": [
  "Aún no se encontraron instructores del personal en Team Management.",
  "Wala pang nahanap na mga staff coach sa Team Management."
 ],
 "Everyone from Team Management is already on the page.": [
  "Todas las personas de Team Management ya están en la página.",
  "Lahat mula sa Team Management ay nasa page na."
 ],
 "Section text": [
  "Texto de la sección",
  "Teksto ng seksyon"
 ],
 "Add people": [
  "Agregar personas",
  "Magdagdag ng mga tao"
 ],
 "Add yourself": [
  "Agregarte",
  "Idagdag ang sarili mo"
 ],
 "Import from Team Management": [
  "Importar desde Team Management",
  "I-import mula sa Team Management"
 ],
 "Add by hand": [
  "Agregar manualmente",
  "Idagdag nang mano-mano"
 ],
 "The Meet the Team page appears in your menu automatically once at least one member is visible. You can also force it on or off from the Pages tab.": [
  "La página Conoce al equipo aparece en tu menú automáticamente una vez que al menos un miembro sea visible. También puedes activarla o desactivarla desde la pestaña Páginas.",
  "Awtomatikong lalabas sa iyong menu ang page na Meet the Team kapag may kahit isang miyembrong nakikita na. Maaari mo rin itong piliting i-on o i-off mula sa tab na Pages."
 ],
 ". Stripe billing is auto-adjusted with proration — the parent gets credited for unused time.": [
  ". La facturación de Stripe se ajusta automáticamente con prorrateo; el padre recibe un crédito por el tiempo no utilizado.",
  ". Ang pagsingil sa Stripe ay awtomatikong ina-adjust nang may proration — makakatanggap ang magulang ng credit para sa hindi nagamit na oras."
 ],
 "Drop effective date": [
  "Fecha efectiva de baja",
  "Petsa ng bisa ng pag-drop"
 ],
 "Family stays enrolled + can attend through this date. Stripe will pro-rate any unused portion of the current month.": [
  "La familia sigue inscrita y puede asistir hasta esta fecha. Stripe prorrateará cualquier parte no utilizada del mes actual.",
  "Mananatiling naka-enroll ang pamilya at maaaring dumalo hanggang sa petsang ito. Ipo-pro-rate ng Stripe ang anumang hindi nagamit na bahagi ng kasalukuyang buwan."
 ],
 "Drop now (immediate)": [
  "Dar de baja ahora (inmediato)",
  "I-drop na ngayon (agad)"
 ],
 "Removes them from the roster today. Stripe subscription cancelled instantly with prorated refund for the rest of this month.": [
  "Los elimina de la lista hoy. La suscripción de Stripe se cancela al instante con reembolso prorrateado por el resto de este mes.",
  "Aalisin sila sa roster ngayon. Kakanselahin agad ang subscription sa Stripe na may prorated refund para sa natitirang bahagi ng buwang ito."
 ],
 "Cancel scheduled drop": [
  "Cancelar baja programada",
  "Kanselahin ang naka-iskedyul na pag-drop"
 ],
 "Danger zone — remove this family entirely": [
  "Zona de peligro: eliminar esta familia por completo",
  "Danger zone — alisin nang buo ang pamilyang ito"
 ],
 "Heads up:": [
  "Atención:",
  "Paalala:"
 ],
 "this family has": [
  "esta familia tiene",
  "ang pamilyang ito ay may"
 ],
 "on your roster (they signed up for multiple classes). Deleting will remove": [
  "en su lista (se inscribieron en varias clases). Al eliminar, se quitará",
  "sa iyong roster (nag-sign up sila para sa maraming klase). Kapag dinelete, aalisin ang"
 ],
 "all": [
  "todo",
  "lahat"
 ],
 "at once — not just this one row.": [
  "de una vez; no solo esta fila.",
  "nang sabay-sabay — hindi lang ang row na ito."
 ],
 "Only for abandoned or duplicate registrations you want off your roster.": [
  "Solo para inscripciones abandonadas o duplicadas que quiera quitar de su lista.",
  "Para lang sa mga inabandona o duplicate na registration na gusto mong alisin sa iyong roster."
 ],
 "Paid invoices and Stripe payment records are preserved (anonymized)": [
  "Las facturas pagadas y los registros de pago de Stripe se conservan (anonimizados)",
  "Ang mga bayad nang invoice at mga tala ng bayad sa Stripe ay pinananatili (anonymized)"
 ],
 "so your revenue totals and tax records stay accurate.": [
  "para que sus totales de ingresos y registros fiscales sigan siendo precisos.",
  "para manatiling tama ang iyong mga total ng kita at mga talaan sa buwis."
 ],
 "Delete student and family in full…": [
  "Eliminar por completo al estudiante y la familia…",
  "Burahin nang buo ang estudyante at pamilya…"
 ],
 "Working": [
  "Procesando",
  "Gumagana"
 ],
 "Delete student and family": [
  "Eliminar estudiante y familia",
  "Burahin ang estudyante at pamilya"
 ],
 "You're about to permanently remove": [
  "Está a punto de eliminar permanentemente a",
  "Permanente mong aalisin ang"
 ],
 "and their student(s) from your roster.": [
  "y a sus estudiante(s) de su lista.",
  "at ang kanilang (mga) estudyante mula sa iyong roster."
 ],
 "This family has": [
  "Esta familia tiene",
  "Ang pamilyang ito ay may"
 ],
 "They're not duplicates — they legitimately signed up for": [
  "No son duplicados; realmente se inscribieron en",
  "Hindi sila duplicate — lehitimo silang nag-sign up para sa"
 ],
 "different classes. Continuing will delete": [
  "clases diferentes. Si continúa, se eliminarán",
  "magkakaibang klase. Kapag nagpatuloy ka, mabubura ang"
 ],
 "enrollments at once. Only continue if you truly want to remove the entire family from your roster.": [
  "inscripciones de una vez. Continúe solo si de verdad desea eliminar a toda la familia de su lista.",
  "mga enrollment nang sabay-sabay. Magpatuloy lamang kung talagang gusto mong alisin ang buong pamilya sa iyong roster."
 ],
 "What gets removed": [
  "Qué se elimina",
  "Ano ang aalisin"
 ],
 "Student profile(s), guardians, and family contact details": [
  "Perfiles de estudiantes, tutores y datos de contacto de la familia",
  "Mga profile ng estudyante, guardian, at mga detalye ng contact ng pamilya"
 ],
 "All enrollments, applications, waivers, and forms": [
  "Todas las inscripciones, solicitudes, exenciones de responsabilidad y formularios",
  "Lahat ng enrollment, application, waiver, at form"
 ],
 "Lessons, attendance records, and notes/tags": [
  "Lecciones, registros de asistencia y notas/etiquetas",
  "Mga lesson, attendance record, at note/tag"
 ],
 "Draft, sent, and unpaid invoices": [
  "Facturas en borrador, enviadas y no pagadas",
  "Mga draft, naipadalang, at hindi pa bayad na invoice"
 ],
 "What we always keep": [
  "Lo que siempre conservamos",
  "Ano ang palagi naming pinananatili"
 ],
 "All paid invoices": [
  "Todas las facturas pagadas",
  "Lahat ng bayad nang invoice"
 ],
 "— preserved (anonymized) for your tax records": [
  "— conservadas (anonimizadas) para sus registros fiscales",
  "— pinananatili (anonymized) para sa iyong mga talaan sa buwis"
 ],
 "All Stripe payment records": [
  "Todos los registros de pago de Stripe",
  "Lahat ng tala ng bayad sa Stripe"
 ],
 "— revenue totals stay accurate": [
  "— los totales de ingresos siguen siendo precisos",
  "— nananatiling tama ang mga total ng kita"
 ],
 "Other coaches' relationships with this family are untouched": [
  "Las relaciones de otros instructores con esta familia no se ven afectadas",
  "Hindi maaapektuhan ang mga ugnayan ng ibang coach sa pamilyang ito"
 ],
 "Team members (": [
  "Miembros del equipo (",
  "Mga miyembro ng team ("
 ],
 "No one yet — use the buttons above to add yourself, import your staff, or add a coach by hand.": [
  "Todavía no hay nadie — usa los botones de arriba para agregarte, importar tu personal o agregar un instructor manualmente.",
  "Wala pang tao — gamitin ang mga button sa itaas para idagdag ang sarili mo, i-import ang staff mo, o magdagdag ng coach nang mano-mano."
 ],
 "Full name": [
  "Nombre completo",
  "Buong pangalan"
 ],
 "Show on website": [
  "Mostrar en el sitio web",
  "Ipakita sa website"
 ],
 "Hide from website": [
  "Ocultar del sitio web",
  "Itago sa website"
 ],
 "Show member": [
  "Mostrar miembro",
  "Ipakita ang miyembro"
 ],
 "Hide member": [
  "Ocultar miembro",
  "Itago ang miyembro"
 ],
 "Role (e.g. Lead Instructor)": [
  "Rol (p. ej. Instructor principal)",
  "Role (hal. Lead Coach)"
 ],
 "Photo": [
  "Foto",
  "Larawan"
 ],
 "Short bio — what parents should know (1–3 sentences)": [
  "Biografía breve — lo que los padres deben saber (1–3 oraciones)",
  "Maikling bio — ano ang dapat malaman ng mga magulang (1–3 pangungusap)"
 ],
 "Certifications, comma separated (WSI, CPR, Lifeguard)": [
  "Certificaciones, separadas por comas (WSI, CPR, Lifeguard)",
  "Mga certification, paghiwa-hiwalayin ng kuwit (WSI, CPR, Lifeguard)"
 ],
 "Hidden from website": [
  "Oculto del sitio web",
  "Nakatago sa website"
 ],
 "The promo pop-up is a": [
  "La ventana emergente promocional es una",
  "Ang promo pop-up ay isang"
 ],
 "feature. You can set it up now — it goes live on your website and parent portal as soon as you upgrade.": [
  "función. Puedes configurarla ahora — se activará en tu sitio web y portal para padres en cuanto actualices.",
  "feature. Maaari mo itong i-set up ngayon — magiging live ito sa website mo at parent portal sa sandaling mag-upgrade ka."
 ],
 "Show pop-up": [
  "Mostrar ventana emergente",
  "Ipakita ang pop-up"
 ],
 "Live — visitors see it once per visit.": [
  "Activo — los visitantes la ven una vez por visita.",
  "Live — makikita ito ng mga bisita nang isang beses kada pagbisita."
 ],
 "Off — nothing shows until you turn this on.": [
  "Desactivado — no se muestra nada hasta que actives esto.",
  "Off — walang lalabas hanggang i-on mo ito."
 ],
 "Summer Splash Special — 20% off": [
  "Especial Summer Splash — 20% de descuento",
  "Summer Splash Special — 20% off"
 ],
 "Tell families what's going on — a deal, a new class, a holiday schedule…": [
  "Cuéntales a las familias qué está pasando — una oferta, una clase nueva, un horario de festivos…",
  "Sabihin sa mga pamilya kung ano ang nangyayari — isang deal, bagong class, holiday schedule…"
 ],
 "Photo (optional)": [
  "Foto (opcional)",
  "Larawan (opsyonal)"
 ],
 "Upload photo": [
  "Subir foto",
  "Mag-upload ng larawan"
 ],
 "Remove photo": [
  "Eliminar foto",
  "Alisin ang larawan"
 ],
 "Action button": [
  "Botón de acción",
  "Action button"
 ],
 "Choose an action": [
  "Elige una acción",
  "Pumili ng action"
 ],
 "Which class or package? (optional)": [
  "¿Qué clase o paquete? (opcional)",
  "Aling class o package? (opsyonal)"
 ],
 "Let them choose (general sign-up)": [
  "Permitirles elegir (inscripción general)",
  "Hayaan silang pumili (pangkalahatang sign-up)"
 ],
 "New families go to your application form; approved parents jump straight to enrollment": [
  "Las familias nuevas van a tu formulario de solicitud; los padres aprobados pasan directamente a la inscripción",
  "Mapupunta ang mga bagong pamilya sa application form mo; ang mga approved na magulang ay didiretso sa enrollment"
 ],
 "for this class": [
  "para esta clase",
  "para sa class na ito"
 ],
 "Dials": [
  "Marca",
  "Tumatawag"
 ],
 "— add a phone number in Settings first": [
  "— primero agrega un número de teléfono en Configuración",
  "— magdagdag muna ng phone number sa Settings"
 ],
 "Link URL": [
  "URL del enlace",
  "Link URL"
 ],
 "Where it shows": [
  "Dónde se muestra",
  "Kung saan ito ipinapakita"
 ],
 "Public website": [
  "Sitio web público",
  "Pampublikong website"
 ],
 "Parent portal (approved families)": [
  "Portal para padres (familias aprobadas)",
  "Parent portal (mga approved na pamilya)"
 ],
 "Auto-hide after (optional)": [
  "Ocultar automáticamente después de (opcional)",
  "Awtomatikong itago pagkatapos ng (opsyonal)"
 ],
 "What they said…": [
  "Lo que dijeron…",
  "Ang sinabi nila…"
 ],
 "When a phone number is set, this becomes a one-tap call on mobile.": [
  "Cuando se establece un número de teléfono, esto se convierte en una llamada con un toque en móvil.",
  "Kapag may nakatakdang phone number, magiging one-tap call ito sa mobile."
 ],
 "Apply CTA text": [
  "Aplicar texto de CTA",
  "Ilapat ang CTA text"
 ],
 "Shows on both the hero and the bottom CTA strip.": [
  "Se muestra tanto en el hero como en la franja de CTA inferior.",
  "Ipinapakita sa hero at sa CTA strip sa ibaba."
 ],
 "Service area lives on your instructor profile.": [
  "El área de servicio está en tu perfil de instructor.",
  "Ang service area ay nasa iyong profile ng coach."
 ],
 "Pool name, travel radius and city are set in your Profile / Settings page so they stay consistent across booking flows. Use the visibility toggle here to hide the section from your landing page.": [
  "El nombre de la piscina, el radio de desplazamiento y la ciudad se configuran en tu página de Perfil / Ajustes para que se mantengan consistentes en todos los flujos de reserva. Usa aquí el selector de visibilidad para ocultar la sección de tu página de destino.",
  "Ang pangalan ng pool, travel radius, at lungsod ay itinatakda sa iyong pahina ng Profile / Settings para manatiling pare-pareho sa lahat ng booking flow. Gamitin ang visibility toggle dito para itago ang seksyon sa iyong landing page."
 ],
 "Open Settings": [
  "Abrir Ajustes",
  "Buksan ang Settings"
 ],
 "Add a section": [
  "Agregar una sección",
  "Magdagdag ng seksyon"
 ],
 "Pick a template to add to your landing page. You can edit, reorder, and remove it after adding.": [
  "Elige una plantilla para agregar a tu página de destino. Puedes editarla, reordenarla y eliminarla después de agregarla.",
  "Pumili ng template na idaragdag sa iyong landing page. Maaari mo itong i-edit, ayusin ang pagkakasunod-sunod, at alisin pagkatapos idagdag."
 ],
 "Single use": [
  "De un solo uso",
  "Isahang gamit"
 ],
 "Multi": [
  "Múltiple",
  "Maramihan"
 ],
 "Already added": [
  "Ya agregado",
  "Naidagdag na"
 ],
 "Background style": [
  "Estilo de fondo",
  "Estilo ng background"
 ],
 "Override the theme background for this section. Pick a color, drop in an image, or both (image takes priority).": [
  "Anula el fondo del tema para esta sección. Elige un color, agrega una imagen o ambos (la imagen tiene prioridad).",
  "I-override ang theme background para sa seksyong ito. Pumili ng kulay, maglagay ng larawan, o pareho (uunahing gamitin ang larawan)."
 ],
 "Background color": [
  "Color de fondo",
  "Kulay ng background"
 ],
 "Pick background color": [
  "Elegir color de fondo",
  "Pumili ng kulay ng background"
 ],
 "Text color": [
  "Color del texto",
  "Kulay ng text"
 ],
 "Dark text": [
  "Texto oscuro",
  "Madilim na text"
 ],
 "Light text": [
  "Texto claro",
  "Maliwanag na text"
 ],
 "Background image (optional)": [
  "Imagen de fondo (opcional)",
  "Larawan sa background (opsyonal)"
 ],
 "A subtle photo or pattern. We auto-darken so text stays readable.": [
  "Una foto o patrón sutil. Lo oscurecemos automáticamente para que el texto siga siendo legible.",
  "Isang banayad na larawan o pattern. Awtomatiko namin itong pinapadilim para manatiling madaling basahin ang text."
 ],
 "Max 12 awards.": [
  "Máx. 12 premios.",
  "Max 12 awards."
 ],
 "Show year on each award": [
  "Mostrar el año en cada premio",
  "Ipakita ang taon sa bawat award"
 ],
 "Awards (": [
  "Premios (",
  "Awards ("
 ],
 "Award name": [
  "Nombre del premio",
  "Pangalan ng award"
 ],
 "Issued by": [
  "Otorgado por",
  "Ibinigay ng"
 ],
 "Logo URL (optional)": [
  "URL del logo (opcional)",
  "Logo URL (opsyonal)"
 ],
 "Add award": [
  "Agregar premio",
  "Magdagdag ng award"
 ],
 "Max 20 questions.": [
  "Máx. 20 preguntas.",
  "Max 20 tanong."
 ],
 "Still have questions? Contact me": [
  "¿Aún tienes preguntas? Contáctame",
  "May mga tanong ka pa rin? Makipag-ugnayan sa akin"
 ],
 "link at the bottom": [
  "enlace en la parte inferior",
  "link sa ibaba"
 ],
 "Questions (": [
  "Preguntas (",
  "Questions ("
 ],
 "Question": [
  "Pregunta",
  "Tanong"
 ],
 "Answer": [
  "Respuesta",
  "Sagot"
 ],
 "Add question": [
  "Agregar pregunta",
  "Magdagdag ng tanong"
 ],
 "Max 12 team members.": [
  "Máximo 12 miembros del equipo.",
  "Max 12 miyembro ng team."
 ],
 "Show certifications under each member's bio": [
  "Mostrar certificaciones debajo de la biografía de cada miembro",
  "Ipakita ang mga sertipikasyon sa ilalim ng bio ng bawat miyembro"
 ],
 "Short bio (1-2 sentences)": [
  "Biografía breve (1-2 oraciones)",
  "Maikling bio (1-2 pangungusap)"
 ],
 "Certifications (WSI, CPR, etc.)": [
  "Certificaciones (WSI, CPR, etc.)",
  "Mga sertipikasyon (WSI, CPR, atbp.)"
 ],
 "Add member": [
  "Agregar miembro",
  "Magdagdag ng miyembro"
 ],
 "Summer enrollment is open": [
  "La inscripción de verano está abierta",
  "Bukas na ang pagpapatala para sa tag-init"
 ],
 "Spots fill quickly — apply this week to lock in your time slot.": [
  "Los cupos se llenan rápidamente — postúlate esta semana para asegurar tu horario.",
  "Mabilis mapuno ang mga slot — mag-apply ngayong linggo para masigurado ang iyong time slot."
 ],
 "Apply now": [
  "Postularme ahora",
  "Mag-apply ngayon"
 ],
 "Link (optional)": [
  "Enlace (opcional)",
  "Link (opsyonal)"
 ],
 "Leave blank to open your Apply flow.": [
  "Déjalo en blanco para abrir tu flujo de solicitud.",
  "Iwanang blangko para buksan ang iyong Apply flow."
 ],
 "Button style": [
  "Estilo del botón",
  "Estilo ng button"
 ],
 "Show megaphone icon": [
  "Mostrar icono de megáfono",
  "Ipakita ang icon ng megaphone"
 ],
 "Apply now — I review every application personally.": [
  "Postúlate ahora — reviso personalmente cada solicitud.",
  "Mag-apply ngayon — personal kong nire-review ang bawat application."
 ],
 "Primary button text": [
  "Texto del botón principal",
  "Text ng pangunahing button"
 ],
 "Links to your standard Apply flow.": [
  "Enlaza a tu flujo de solicitud estándar.",
  "Naka-link sa iyong karaniwang Apply flow."
 ],
 "Secondary button (optional)": [
  "Botón secundario (opcional)",
  "Pangalawang button (opsyonal)"
 ],
 "Call me": [
  "Llámame",
  "Tawagan ako"
 ],
 "Secondary link": [
  "Enlace secundario",
  "Pangalawang link"
 ],
 "tel:+1… or https://…": [
  "tel:+1… o https://…",
  "tel:+1… o https://…"
 ],
 "Alignment": [
  "Alineación",
  "Pagkaka-align"
 ],
 "Section heading": [
  "Encabezado de sección",
  "Pamagat ng seksyon"
 ],
 "Intro paragraph (optional)": [
  "Párrafo introductorio (opcional)",
  "Panimulang talata (opsyonal)"
 ],
 "A short sentence to set context for the section.": [
  "Una oración breve para dar contexto a la sección.",
  "Isang maikling pangungusap para magbigay ng konteksto sa seksyon."
 ],
 "Tap a map button for directions in your map of choice.": [
  "Toca un botón de mapa para obtener indicaciones en el mapa que prefieras.",
  "I-tap ang map button para sa direksyon sa napili mong mapa."
 ],
 "Sophia": [
  "Sophia",
  "Sophia"
 ],
 "Siegel": [
  "Siegel",
  "Siegel"
 ],
 "you@example.com": [
  "you@example.com",
  "you@example.com"
 ],
 "Back to reports": [
  "Volver a los informes",
  "Bumalik sa mga ulat"
 ],
 "Published version only. Private notes are not included. In the print dialog, choose Save as PDF and turn off headers and footers for a school-only handout.": [
  "Solo la versión publicada. No se incluyen las notas privadas. En el cuadro de diálogo de impresión, elige Guardar como PDF y desactiva los encabezados y pies de página para obtener un folleto solo para la escuela.",
  "Na-publish na bersyon lang. Hindi kasama ang mga pribadong tala. Sa print dialog, piliin ang Save as PDF at i-off ang headers at footers para sa handout na pang-eskwela lang."
 ],
 "The school logo could not load. The school name will still print.": [
  "No se pudo cargar el logotipo de la escuela. El nombre de la escuela se imprimirá de todos modos.",
  "Hindi ma-load ang logo ng paaralan. Mapi-print pa rin ang pangalan ng paaralan."
 ],
 "Retry logo": [
  "Reintentar logo",
  "Subukang muli ang logo"
 ],
 "Report unavailable": [
  "Informe no disponible",
  "Hindi available ang ulat"
 ],
 "Program:": [
  "Programa:",
  "Programa:"
 ],
 "Instructor:": [
  "Instructor:",
  "Coach:"
 ],
 "Coach-observed skills": [
  "Habilidades observadas por el instructor",
  "Mga skill na naobserbahan ng coach"
 ],
 "Visitors who close it won't see it again until they come back or log in again. Any edit you save shows it to everyone once more.": [
  "Los visitantes que lo cierren no volverán a verlo hasta que regresen o vuelvan a iniciar sesión. Cualquier edición que guardes lo volverá a mostrar a todos.",
  "Ang mga bisitang magsasara nito ay hindi na ito muling makikita hanggang sa bumalik sila o mag-log in muli. Anumang edit na i-save mo ay ipapakita itong muli sa lahat."
 ],
 "Preview pop-up": [
  "Vista previa de la ventana emergente",
  "Preview ng pop-up"
 ],
 "Preview only — visitors would be taken there.": [
  "Solo vista previa: los visitantes irían allí.",
  "Preview lang — dadalhin doon ang mga bisita."
 ],
 "Preview only — visitors would go to sign-up / enrollment.": [
  "Solo vista previa: los visitantes irían a registro / inscripción.",
  "Preview lang — mapupunta ang mga bisita sa sign-up / enrollment."
 ],
 "Preview only — visitors would see your programs.": [
  "Solo vista previa: los visitantes verían tus programas.",
  "Preview lang — makikita ng mga bisita ang iyong mga programa."
 ],
 "Menu labels apply to the top navigation, the mobile menu and the footer. Hidden pages never show regardless of label.": [
  "Las etiquetas del menú se aplican a la navegación superior, al menú móvil y al pie de página. Las páginas ocultas nunca se muestran, independientemente de la etiqueta.",
  "Ang mga label ng menu ay nalalapat sa top navigation, mobile menu, at footer. Ang mga nakatagong page ay hindi kailanman ipinapakita anuman ang label."
 ],
 "Write both a question and an answer first.": [
  "Primero escribe una pregunta y una respuesta.",
  "Isulat muna ang parehong tanong at sagot."
 ],
 "FAQ added — it is live on your site immediately.": [
  "FAQ agregada: ya está publicada en tu sitio de inmediato.",
  "Naidagdag ang FAQ — live na ito agad sa iyong site."
 ],
 "FAQ removed.": [
  "FAQ eliminada.",
  "Inalis ang FAQ."
 ],
 "Add a question": [
  "Agregar una pregunta",
  "Magdagdag ng tanong"
 ],
 "What age can my child start lessons?": [
  "¿A qué edad puede mi hijo empezar las clases?",
  "Sa anong edad puwedeng magsimulang mag-lesson ang anak ko?"
 ],
 "We start as young as 6 months — there's always time to learn!": [
  "Empezamos desde los 6 meses; ¡siempre hay tiempo para aprender!",
  "Nagsisimula kami sa edad na 6 na buwan — laging may oras para matuto!"
 ],
 "Add FAQ": [
  "Agregar FAQ",
  "Magdagdag ng FAQ"
 ],
 "FAQs save instantly — no page save needed.": [
  "Las FAQ se guardan al instante; no es necesario guardar la página.",
  "Agad nase-save ang mga FAQ — hindi na kailangang i-save ang page."
 ],
 "Your FAQs": [
  "Tus FAQ",
  "Iyong mga FAQ"
 ],
 "No FAQs yet — the section stays hidden on your site until you add one.": [
  "Aún no hay FAQ: la sección permanecerá oculta en tu sitio hasta que agregues una.",
  "Wala pang mga FAQ — mananatiling nakatago ang seksyon sa iyong site hanggang sa magdagdag ka ng isa."
 ],
 "Personalized swim lessons in your own pool — from beginners to competitive swimmers.": [
  "Clases de natación personalizadas en tu propia piscina, desde principiantes hasta nadadores de competición.",
  "Personalized na swim lessons sa sarili mong pool — mula baguhan hanggang competitive swimmers."
 ],
 "Landscape photo, ideally 1600x900. Leave blank to use your theme gradient.": [
  "Foto horizontal, idealmente de 1600x900. Déjalo en blanco para usar el degradado de tu tema.",
  "Landscape na larawan, pinakamainam ang 1600x900. Iwanang blangko para gamitin ang theme gradient mo."
 ],
 "Your bio / story": [
  "Tu biografía / historia",
  "Iyong bio / kuwento"
 ],
 "Two or three short paragraphs work best. Mention certifications, years of experience, and your teaching philosophy.": [
  "Lo ideal son dos o tres párrafos cortos. Menciona certificaciones, años de experiencia y tu filosofía de enseñanza.",
  "Pinakamainam ang dalawa o tatlong maiikling talata. Banggitin ang mga certification, taon ng karanasan, at ang iyong pilosopiya sa pagtuturo."
 ],
 "I've been teaching swim lessons for over 12 years…": [
  "He dado clases de natación durante más de 12 años…",
  "Nagtuturo na ako ng swim lessons nang mahigit 12 taon…"
 ],
 "Show packages": [
  "Mostrar paquetes",
  "Ipakita ang mga package"
 ],
 "When off, the lead-magnet block (from form editor) is shown instead.": [
  "Cuando está desactivado, se muestra en su lugar el bloque de lead magnet (del editor de formularios).",
  "Kapag naka-off, ang lead-magnet block (mula sa form editor) ang ipapakita sa halip."
 ],
 "Which packages?": [
  "¿Qué paquetes?",
  "Aling mga package?"
 ],
 "No selection — all active packages will show.": [
  "Sin selección: se mostrarán todos los paquetes activos.",
  "Walang pinili — lahat ng aktibong package ay ipapakita."
 ],
 "You haven't built any packages yet.": [
  "Aún no has creado ningún paquete.",
  "Wala ka pang nagagawang mga package."
 ],
 "Create a package": [
  "Crear un paquete",
  "Gumawa ng package"
 ],
 "Show off your pool, lessons, happy kids. Reorder with arrows.": [
  "Muestra tu piscina, tus clases y niños felices. Reordena con las flechas.",
  "Ipakita ang iyong pool, lessons, at masasayang bata. Ayusin muli gamit ang mga arrow."
 ],
 "Move left": [
  "Mover a la izquierda",
  "Ilipat pakaliwa"
 ],
 "Move right": [
  "Mover a la derecha",
  "Ilipat pakanan"
 ],
 "Video links": [
  "Enlaces de video",
  "Mga link ng video"
 ],
 "Paste a YouTube or Vimeo URL. Short videos (1-2 min) convert best.": [
  "Pega una URL de YouTube o Vimeo. Los videos cortos (1-2 min) convierten mejor.",
  "Mag-paste ng URL ng YouTube o Vimeo. Pinakamahusay mag-convert ang maiikling video (1-2 min)."
 ],
 "For Google reviews, switch to advanced settings — you'll need to connect your Google Business profile first.": [
  "Para las reseñas de Google, cambia a la configuración avanzada: primero tendrás que conectar tu perfil de Google Business.",
  "Para sa Google reviews, lumipat sa advanced settings — kailangan mo munang ikonekta ang iyong Google Business profile."
 ],
 "Current source:": [
  "Fuente actual:",
  "Kasalukuyang source:"
 ],
 "Parent's name": [
  "Nombre del padre/madre",
  "Pangalan ng magulang"
 ],
 "Also forget “remembered” browsers so two-factor is required again everywhere.": [
  "También olvida los navegadores “recordados” para que se vuelva a requerir la autenticación en dos pasos en todas partes.",
  "Kalimutan din ang mga “remembered” na browser para muling kailanganin ang two-factor sa lahat ng lugar."
 ],
 "Sign out other devices": [
  "Cerrar sesión en otros dispositivos",
  "Mag-sign out sa ibang device"
 ],
 "Save a card on file": [
  "Guardar una tarjeta registrada",
  "Mag-save ng card on file"
 ],
 "For payments to": [
  "Para pagos a",
  "Para sa mga bayad sa"
 ],
 "Your card details are stored securely by Stripe.": [
  "Los datos de tu tarjeta se almacenan de forma segura en Stripe.",
  "Ang mga detalye ng iyong card ay ligtas na iniimbak ng Stripe."
 ],
 "Preparing secure form…": [
  "Preparando formulario seguro…",
  "Inihahanda ang secure form…"
 ],
 "Card saved.": [
  "Tarjeta guardada.",
  "Na-save ang card."
 ],
 "Save my card securely for future payments by my coach.": [
  "Guardar mi tarjeta de forma segura para futuros pagos por parte de mi instructor.",
  "I-save nang secure ang card ko para sa mga susunod na bayad ng coach ko."
 ],
 "My coach can charge this card for lessons, packages, and other agreed services. You can remove this card from your Payments page at any time.": [
  "Mi instructor puede cobrar esta tarjeta por clases, paquetes y otros servicios acordados. Puedes eliminar esta tarjeta de tu página de Pagos en cualquier momento.",
  "Maaaring i-charge ng coach ko ang card na ito para sa mga lesson, package, at iba pang napagkasunduang serbisyo. Maaari mong alisin ang card na ito sa iyong Payments page anumang oras."
 ],
 "Save card": [
  "Guardar tarjeta",
  "I-save ang card"
 ],
 "Add account credit": [
  "Agregar crédito a la cuenta",
  "Magdagdag ng account credit"
 ],
 "Give": [
  "Dar",
  "Magbigay ng"
 ],
 "a courtesy credit. It applies to future charges — no Stripe fees, no delay.": [
  "un crédito de cortesía. Se aplica a cargos futuros — sin comisiones de Stripe ni demoras.",
  "isang courtesy credit. Nalalapat ito sa mga susunod na charge — walang Stripe fees, walang delay."
 ],
 "Current balance": [
  "Saldo actual",
  "Kasalukuyang balanse"
 ],
 "After this credit": [
  "Después de este crédito",
  "Pagkatapos ng credit na ito"
 ],
 "Amount (USD)": [
  "Importe (USD)",
  "Halaga (USD)"
 ],
 "Reason (internal only)": [
  "Motivo (solo interno)",
  "Dahilan (internal only)"
 ],
 "Goodwill": [
  "Cortesía",
  "Goodwill"
 ],
 "Overpayment refund": [
  "Reembolso por sobrepago",
  "Refund sa sobrang bayad"
 ],
 "Referral credit": [
  "Crédito por referencia",
  "Referral credit"
 ],
 "Promotional credit": [
  "Crédito promocional",
  "Promotional credit"
 ],
 "Missed / makeup lesson": [
  "Clase perdida / de recuperación",
  "Na-miss / makeup na lesson"
 ],
 "Other…": [
  "Otro…",
  "Iba pa…"
 ],
 "Custom reason": [
  "Motivo personalizado",
  "Custom reason"
 ],
 "Describe the reason…": [
  "Describe el motivo…",
  "Ilarawan ang dahilan…"
 ],
 "Note": [
  "Nota",
  "Note"
 ],
 "(optional, internal)": [
  "(opcional, interno)",
  "(optional, internal)"
 ],
 "e.g. Waived last lesson because pool was closed": [
  "p. ej. Se eximió la última clase porque la piscina estaba cerrada",
  "hal. Inalis ang bayad sa huling lesson dahil sarado ang pool"
 ],
 "Credit amount cannot exceed $10,000 in one entry.": [
  "El importe del crédito no puede superar los $10,000 en una sola entrada.",
  "Hindi maaaring lumampas sa $10,000 ang credit amount sa isang entry."
 ],
 "credit": [
  "crédito",
  "credit"
 ],
 "Pick a family first.": [
  "Primero selecciona una familia.",
  "Pumili muna ng pamilya."
 ],
 "Pick at least one swimmer.": [
  "Selecciona al menos un nadador.",
  "Pumili ng kahit isang swimmer."
 ],
 "Drop-in for this date only": [
  "Clase suelta solo para esta fecha",
  "Drop-in para sa petsang ito lang"
 ],
 "Books a swimmer into": [
  "Reserva a un nadador en",
  "Ini-book ang isang swimmer sa"
 ],
 "only — it uses": [
  "solamente — usa",
  "lang — ginagamit nito"
 ],
 "Progress note": [
  "Nota de progreso",
  "Tala ng progreso"
 ],
 "These observations are not a guarantee of water safety or readiness to swim without supervision.": [
  "Estas observaciones no garantizan la seguridad en el agua ni la preparación para nadar sin supervisión.",
  "Ang mga obserbasyong ito ay hindi garantiya ng kaligtasan sa tubig o kahandaan na lumangoy nang walang superbisyon."
 ],
 "Could not copy. Long-press the text to copy manually.": [
  "No se pudo copiar. Mantén presionado el texto para copiarlo manualmente.",
  "Hindi makopya. Pindutin nang matagal ang text para manu-manong kopyahin."
 ],
 "Marked as resolved.": [
  "Marcado como resuelto.",
  "Minarkahan bilang nalutas."
 ],
 "Could not mark resolved. Try again.": [
  "No se pudo marcar como resuelto. Inténtalo de nuevo.",
  "Hindi mamarkahan bilang nalutas. Subukan muli."
 ],
 "Abandoned checkouts": [
  "Pagos abandonados",
  "Mga inabandunang checkout"
 ],
 "Didn't finish checkout": [
  "No completó el pago",
  "Hindi tinapos ang checkout"
 ],
 "Parents who started enrollment but didn't pay. Reach out to recover the booking.": [
  "Padres que comenzaron la inscripción pero no pagaron. Contáctalos para recuperar la reserva.",
  "Mga magulang na nagsimula ng enrollment pero hindi nagbayad. Makipag-ugnayan para mabawi ang booking."
 ],
 "Nothing here — everyone who started checkout has either paid or you've already resolved them.": [
  "No hay nada aquí: todos los que comenzaron el pago ya pagaron o ya los resolviste.",
  "Walang laman dito — lahat ng nagsimula ng checkout ay nakapagbayad na o naresolba mo na sila."
 ],
 "No email on file": [
  "No hay un correo electrónico registrado",
  "Walang email na naka-file"
 ],
 "Open payment link": [
  "Abrir enlace de pago",
  "Buksan ang payment link"
 ],
 "Resolve": [
  "Resolver",
  "Lutasin"
 ],
 "New password must be at least 10 characters.": [
  "La nueva contraseña debe tener al menos 10 caracteres.",
  "Ang bagong password ay dapat may hindi bababa sa 10 character."
 ],
 "New passwords don't match.": [
  "Las nuevas contraseñas no coinciden.",
  "Hindi magkapareho ang mga bagong password."
 ],
 "Password updated. Every other device was signed out.": [
  "Contraseña actualizada. Se cerró la sesión en todos los demás dispositivos.",
  "Na-update ang password. Naka-sign out ang lahat ng iba pang device."
 ],
 "Enter your password to confirm.": [
  "Ingresa tu contraseña para confirmar.",
  "Ilagay ang iyong password para kumpirmahin."
 ],
 "Account security": [
  "Seguridad de la cuenta",
  "Seguridad ng account"
 ],
 "Password & sessions": [
  "Contraseña y sesiones",
  "Password at mga session"
 ],
 "Change your password or sign out of every other device. Either action ends all other sessions instantly — you stay signed in here.": [
  "Cambia tu contraseña o cierra sesión en todos los demás dispositivos. Cualquiera de las dos acciones finaliza instantáneamente todas las demás sesiones; tú seguirás con la sesión iniciada aquí.",
  "Palitan ang iyong password o mag-sign out sa lahat ng iba pang device. Alinman sa dalawang aksyon ay agad na magtatapos sa lahat ng iba pang session — mananatili kang naka-sign in dito."
 ],
 "Change password": [
  "Cambiar contraseña",
  "Palitan ang password"
 ],
 "Log out everywhere": [
  "Cerrar sesión en todos lados",
  "Mag-log out saanman"
 ],
 "Password last changed": [
  "Último cambio de contraseña",
  "Huling pagpapalit ng password"
 ],
 "Recent sign-ins": [
  "Inicios de sesión recientes",
  "Mga kamakailang sign-in"
 ],
 "No sign-ins recorded yet.": [
  "Aún no hay inicios de sesión registrados.",
  "Wala pang naitalang sign-in."
 ],
 "New device": [
  "Nuevo dispositivo",
  "Bagong device"
 ],
 "Browsers that have signed in": [
  "Navegadores que han iniciado sesión",
  "Mga browser na naka-sign in"
 ],
 "We'll list browsers here after your next sign-in.": [
  "Mostraremos los navegadores aquí después de tu próximo inicio de sesión.",
  "Ililista namin dito ang mga browser pagkatapos ng susunod mong sign-in."
 ],
 "last": [
  "último",
  "huli"
 ],
 "We email you the first time a new browser signs in to your account.": [
  "Te enviamos un correo electrónico la primera vez que un nuevo navegador inicia sesión en tu cuenta.",
  "Mag-e-email kami sa iyo sa unang beses na mag-sign in sa iyong account ang isang bagong browser."
 ],
 "Use at least 10 characters with a letter and a number. We also check it against known data breaches.": [
  "Usa al menos 10 caracteres con una letra y un número. También la verificamos con filtraciones de datos conocidas.",
  "Gumamit ng hindi bababa sa 10 character na may isang letra at isang numero. Sinusuri rin namin ito laban sa mga kilalang data breach."
 ],
 "New password": [
  "Nueva contraseña",
  "Bagong password"
 ],
 "Confirm new password": [
  "Confirmar nueva contraseña",
  "Kumpirmahin ang bagong password"
 ],
 "Update password": [
  "Actualizar contraseña",
  "I-update ang password"
 ],
 "Ends every other signed-in session (phones, tablets, other computers). This browser stays signed in.": [
  "Finaliza todas las demás sesiones con sesión iniciada (teléfonos, tabletas y otras computadoras). Este navegador seguirá con la sesión iniciada.",
  "Tatapusin ang lahat ng iba pang naka-sign-in na session (mga telepono, tablet, at iba pang computer). Mananatiling naka-sign in ang browser na ito."
 ],
 "Confirm your password": [
  "Confirma tu contraseña",
  "Kumpirmahin ang iyong password"
 ],
 "1 credit": [
  "1 crédito",
  "1 credit"
 ],
 "from their prepaid package. They will": [
  "de su paquete prepago. Se",
  "mula sa kanilang prepaid package. Sila ay"
 ],
 "not": [
  "no",
  "hindi"
 ],
 "be added to other dates.": [
  "agregados a otras fechas.",
  "maidadagdag sa ibang mga petsa."
 ],
 "Families with package credits": [
  "Familias con créditos de paquete",
  "Mga pamilyang may package credits"
 ],
 "Search by family or kid's name": [
  "Buscar por apellido de la familia o nombre del niño",
  "Maghanap ayon sa apelyido ng pamilya o pangalan ng bata"
 ],
 "Loading families…": [
  "Cargando familias…",
  "Nilo-load ang mga pamilya…"
 ],
 "No families have a flexible package (no set days/times) with this coach yet.": [
  "Ninguna familia tiene todavía un paquete flexible (sin días/horarios fijos) con este instructor.",
  "Wala pang pamilyang may flexible package (walang takdang araw/oras) sa coach na ito."
 ],
 "No families match that search.": [
  "Ninguna familia coincide con esa búsqueda.",
  "Walang pamilyang tumutugma sa paghahanap na iyon."
 ],
 "Already in this class": [
  "Ya está en esta clase",
  "Nasa klaseng ito na"
 ],
 "Only flexible packages (no set days or times) appear here. Fixed-schedule packages and Classes keep their normal enrollment flow.": [
  "Aquí solo aparecen los paquetes flexibles (sin días ni horarios fijos). Los paquetes con horario fijo y las clases mantienen su flujo normal de inscripción.",
  "Flexible packages lang (walang takdang araw o oras) ang lumalabas dito. Ang fixed-schedule packages at Classes ay gumagamit ng kanilang normal na enrollment flow."
 ],
 "Which kids are coming?": [
  "¿Qué niños vendrán?",
  "Aling mga bata ang darating?"
 ],
 "One credit covers the visit no matter how many siblings attend.": [
  "Un crédito cubre la visita sin importar cuántos hermanos asistan.",
  "Isang credit ang sasaklaw sa pagbisita gaano man karaming magkakapatid ang dadalo."
 ],
 "Book this date · 1 credit": [
  "Reservar esta fecha · 1 crédito",
  "I-book ang petsang ito · 1 credit"
 ],
 "Couldn't load your approved families. Try again.": [
  "No se pudieron cargar tus familias aprobadas. Inténtalo de nuevo.",
  "Hindi ma-load ang iyong mga aprubadong pamilya. Subukan ulit."
 ],
 "Class block context missing — close and re-open the dialog.": [
  "Falta el contexto del bloque de clase: cierra y vuelve a abrir el cuadro de diálogo.",
  "Nawawala ang class block context — isara at buksan muli ang dialog."
 ],
 "Select at least one student to add to this class.": [
  "Selecciona al menos un estudiante para agregar a esta clase.",
  "Pumili ng kahit isang estudyante na idaragdag sa klaseng ito."
 ],
 "Add student to this class": [
  "Agregar estudiante a esta clase",
  "Magdagdag ng estudyante sa klaseng ito"
 ],
 "Adding to": [
  "Agregando a",
  "Idinadagdag sa"
 ],
 ". Pick a family, then choose how they're paying.": [
  ". Elige una familia y luego cómo pagarán.",
  ". Pumili ng pamilya, pagkatapos ay piliin kung paano sila magbabayad."
 ],
 "Pick a family": [
  "Elige una familia",
  "Pumili ng pamilya"
 ],
 "Search by name, email, or kid's name": [
  "Buscar por nombre, correo electrónico o nombre del niño",
  "Maghanap ayon sa pangalan, email, o pangalan ng bata"
 ],
 "No approved families yet — approve an application first.": [
  "Todavía no hay familias aprobadas: primero aprueba una solicitud.",
  "Wala pang mga aprubadong pamilya — mag-apruba muna ng isang application."
 ],
 "kid": [
  "niño",
  "bata"
 ],
 "kids": [
  "niños",
  "mga bata"
 ],
 "Already enrolled": [
  "Ya inscrito",
  "Naka-enroll na"
 ],
 "Payment pending": [
  "Pago pendiente",
  "Nakabinbin ang bayad"
 ],
 "Which kids?": [
  "¿Qué niños?",
  "Aling mga bata?"
 ],
 "This family's application has no kids on file.": [
  "La solicitud de esta familia no tiene niños registrados.",
  "Walang nakalistang mga bata sa application ng pamilyang ito."
 ],
 "This family has a prepaid package with": [
  "Esta familia tiene un paquete prepago con",
  "Ang pamilyang ito ay may prepaid package na may"
 ],
 "left (": [
  "restantes (",
  "natitira ("
 ],
 "\"Add student\" enrolls them in": [
  "\"Agregar estudiante\" los inscribe en",
  "Ang \"Add student\" ay ie-enroll sila sa"
 ],
 "every": [
  "cada",
  "bawat"
 ],
 "upcoming date of this class and bills them again. To book": [
  "próxima fecha de esta clase y les volverá a cobrar. Para reservar",
  "darating na petsa ng klaseng ito at sisingilin silang muli. Para i-book"
 ],
 "just this date": [
  "solo esta fecha",
  "ang petsang ito lang"
 ],
 "using one of their prepaid lessons, use Drop-in instead.": [
  "si usa una de sus clases prepagadas, usa Clase suelta en su lugar.",
  "kung gumagamit ng isa sa kanilang mga prepaid lesson, gamitin na lang ang Drop-in."
 ],
 "Switch to Drop-in (uses 1 credit)": [
  "Cambiar a Clase suelta (usa 1 crédito)",
  "Lumipat sa Drop-in (gagamit ng 1 credit)"
 ],
 "How are they paying?": [
  "¿Cómo pagan?",
  "Paano sila magbabayad?"
 ],
 "Payment note (optional)": [
  "Nota de pago (opcional)",
  "Tala ng bayad (opsyonal)"
 ],
 "e.g., 'Paid $80 cash on 6/9'": [
  "p. ej., 'Paid $80 cash on 6/9'",
  "hal., 'Paid $80 cash on 6/9'"
 ],
 "Add to roster": [
  "Agregar a la lista",
  "Idagdag sa roster"
 ],
 "Send invoice & enroll": [
  "Enviar factura e inscribir",
  "Ipadala ang invoice at i-enroll"
 ],
 "Announcement": [
  "Anuncio",
  "Anunsyo"
 ],
 "Special announcement from your coach": [
  "Anuncio especial de tu instructor",
  "Espesyal na anunsyo mula sa iyong coach"
 ],
 "No thanks": [
  "No, gracias",
  "Hindi, salamat"
 ],
 "Appearance and account menu": [
  "Menú de apariencia y cuenta",
  "Menu ng hitsura at account"
 ],
 "Dark on": [
  "Oscuro activado",
  "Naka-on ang dark"
 ],
 "Light on": [
  "Claro activado",
  "Naka-on ang light"
 ],
 "Theme mode": [
  "Modo de tema",
  "Theme mode"
 ],
 "Accent color": [
  "Color de acento",
  "Accent color"
 ],
 "Changes how": [
  "Cambia cómo se ve el",
  "Binabago kung paano ang"
 ],
 "dashboard looks. Families still see your brand color.": [
  "panel. Las familias seguirán viendo el color de tu marca.",
  "dashboard. Makikita pa rin ng mga pamilya ang kulay ng iyong brand."
 ],
 "Account settings": [
  "Configuración de la cuenta",
  "Mga setting ng account"
 ],
 "Fee amount must be at least $1.00": [
  "El monto de la tarifa debe ser de al menos $1.00",
  "Ang halaga ng fee ay dapat hindi bababa sa $1.00"
 ],
 "Could not save — try again": [
  "No se pudo guardar — inténtalo de nuevo",
  "Hindi na-save — subukan ulit"
 ],
 "Application fee": [
  "Tarifa de solicitud",
  "Application fee"
 ],
 "Charge families a registration fee or an assessment when they apply. Their card is saved at application and only charged when you approve — declined applications are never charged. The saved card also unlocks one-tap charges for packages later.": [
  "Cobra a las familias una tarifa de inscripción o una evaluación cuando soliciten. Su tarjeta se guarda al enviar la solicitud y solo se cobra cuando la apruebas; las solicitudes rechazadas nunca se cobran. La tarjeta guardada también habilita cargos con un toque para paquetes más adelante.",
  "Maningil sa mga pamilya ng registration fee o assessment kapag nag-apply sila. Naka-save ang kanilang card sa pag-apply at sisingilin lang kapag inaprubahan mo — ang mga declined application ay hindi kailanman sinisingil. Ang naka-save na card ay nagpapagana rin ng one-tap charges para sa mga package sa susunod."
 ],
 "Connect your Stripe payouts above to start collecting this fee. Until then, parents can still apply — they just won't be asked to pay.": [
  "Conecta arriba tus pagos de Stripe para empezar a cobrar esta tarifa. Hasta entonces, los padres aún pueden solicitar — simplemente no se les pedirá pagar.",
  "Ikonekta ang iyong Stripe payouts sa itaas para makapagsimulang maningil ng fee na ito. Hanggang sa gawin mo iyon, puwede pa ring mag-apply ang mga magulang — hindi lang sila hihingan ng bayad."
 ],
 "Fee type": [
  "Tipo de tarifa",
  "Uri ng fee"
 ],
 "A one-time signup fee for joining your program.": [
  "Una tarifa única de inscripción por unirse a tu programa.",
  "Isang one-time signup fee para sumali sa iyong programa."
 ],
 "Assessment": [
  "Evaluación",
  "Assessment"
 ],
 "A paid evaluation lesson — you arrange the time with the family.": [
  "Una clase de evaluación pagada — tú coordinas el horario con la familia.",
  "Isang bayad na evaluation lesson — aayusin mo ang oras kasama ang pamilya."
 ],
 "One fee type at a time — switching changes what parents see at signup.": [
  "Solo un tipo de tarifa a la vez — al cambiarlo, cambias lo que ven los padres al inscribirse.",
  "Isang fee type lang sa bawat pagkakataon — kapag pinalitan, mababago ang nakikita ng mga magulang sa signup."
 ],
 "Shown to parents as": [
  "Se muestra a los padres como",
  "Ipinapakita sa mga magulang bilang"
 ],
 "Charged per": [
  "Se cobra por",
  "Sisingilin bawat"
 ],
 "Family — one fee per application": [
  "Familia — una tarifa por solicitud",
  "Pamilya — isang fee bawat application"
 ],
 "Child — fee × number of kids": [
  "Niño — tarifa × cantidad de niños",
  "Bata — fee × bilang ng mga bata"
 ],
 "First application only — returning families skip it": [
  "Solo la primera solicitud — las familias que regresan la omiten",
  "Unang application lang — nilalaktawan ito ng mga pamilyang bumabalik"
 ],
 "Every application": [
  "Cada solicitud",
  "Bawat application"
 ],
 "Charged the moment you approve an application": [
  "Se cobra en el momento en que apruebas una solicitud",
  "Sisingilin sa mismong sandaling aprubahan mo ang isang application"
 ],
 "(instantly if Instant Signup is on).": [
  "(al instante si Instant Signup está activado).",
  "(kaagad kung naka-on ang Instant Signup)."
 ],
 "Save fee": [
  "Guardar cuota",
  "I-save ang bayad"
 ],
 "Checking fee details…": [
  "Comprobando detalles de la cuota…",
  "Sinusuri ang mga detalye ng bayad…"
 ],
 "Couldn't load this step": [
  "No se pudo cargar este paso",
  "Hindi ma-load ang hakbang na ito"
 ],
 "This step isn't available right now. Please try again later.": [
  "Este paso no está disponible en este momento. Inténtalo de nuevo más tarde.",
  "Hindi available ang hakbang na ito ngayon. Pakisubukang muli mamaya."
 ],
 "applied — you save": [
  "aplicado — ahorras",
  "na-apply — makakatipid ka"
 ],
 "Have a code from your coach?": [
  "¿Tienes un código de tu instructor?",
  "May code ka ba mula sa coach mo?"
 ],
 "e.g. FAMILY2026": [
  "p. ej. FAMILY2026",
  "hal. FAMILY2026"
 ],
 "Your coach will arrange the assessment time with you.": [
  "Tu instructor coordinará contigo la hora de la evaluación.",
  "Aayusin ng coach mo ang oras ng assessment kasama ka."
 ],
 "One-time fee for joining this program.": [
  "Cuota única por unirte a este programa.",
  "Isang beses na bayad para sumali sa programang ito."
 ],
 "Charged on approval": [
  "Se cobra al aprobarse",
  "Sisingilin kapag naaprubahan"
 ],
 "You won't be charged today.": [
  "No se te cobrará hoy.",
  "Hindi ka sisingilin ngayon."
 ],
 "Your card is saved securely now, and the": [
  "Tu tarjeta se guarda de forma segura ahora, y la",
  "Ligtas nang naka-save ngayon ang card mo, at ang"
 ],
 "is charged only when": [
  "se cobra solo cuando",
  "ay sisingilin lang kapag"
 ],
 "approves your application. You also authorize": [
  "aprueba tu solicitud. También autorizas a",
  "inaaprubahan ang application mo. Pinapahintulutan mo rin ang"
 ],
 "to charge this card for future lessons or packages — manage saved cards anytime from your parent portal.": [
  "a cobrar esta tarjeta para futuras clases o paquetes; administra las tarjetas guardadas en cualquier momento desde tu portal para padres.",
  "na singilin ang card na ito para sa mga susunod na lesson o package — puwede mong i-manage ang mga naka-save na card anumang oras mula sa iyong parent portal."
 ],
 "Saving card…": [
  "Guardando tarjeta…",
  "Sine-save ang card…"
 ],
 "Save card & continue": [
  "Guardar tarjeta y continuar",
  "I-save ang card at magpatuloy"
 ],
 "Secured by Stripe. Nothing is charged until your application is approved.": [
  "Protegido por Stripe. No se realizará ningún cargo hasta que se apruebe tu solicitud.",
  "Secured by Stripe. Walang sisingilin hanggang hindi naaaprubahan ang application mo."
 ],
 "Pick a date first.": [
  "Primero elige una fecha.",
  "Pumili muna ng petsa."
 ],
 "Removed": [
  "Eliminado",
  "Inalis"
 ],
 "Attendance": [
  "Asistencia",
  "Attendance"
 ],
 "This enrollment has no students attached yet.": [
  "Esta inscripción aún no tiene estudiantes vinculados.",
  "Wala pang nakatalagang estudyante sa enrollment na ito."
 ],
 "No sessions recorded yet": [
  "Aún no hay sesiones registradas",
  "Wala pang naka-record na session"
 ],
 "Log a session": [
  "Registrar una sesión",
  "Mag-log ng session"
 ],
 "Optional notes (e.g. left early, great progress!)": [
  "Notas opcionales (p. ej. se fue temprano, ¡gran progreso!)",
  "Opsyonal na mga note (hal. umalis nang maaga, malaking progreso!)"
 ],
 "Saving the same date again will": [
  "Guardar la misma fecha otra vez",
  "Ang muling pag-save ng parehong petsa ay"
 ],
 "update": [
  "actualizará",
  "mag-a-update sa"
 ],
 "the existing record (no duplicates).": [
  "el registro existente (sin duplicados).",
  "kasalukuyang record (walang duplicate)."
 ],
 "No sessions logged yet for": [
  "Aún no hay sesiones registradas para",
  "Wala pang naka-log na session para kay"
 ],
 "Child": [
  "Niño",
  "Bata"
 ],
 "Attended": [
  "Asistió",
  "Dumalo"
 ],
 "No session": [
  "Sin sesión",
  "Walang session"
 ],
 "Oldest on the left, newest on the right. Tap any mark for the class and notes.": [
  "Lo más antiguo a la izquierda y lo más reciente a la derecha. Toca cualquier marca para ver la clase y las notas.",
  "Pinakaluma sa kaliwa, pinakabago sa kanan. I-tap ang anumang marka para sa klase at mga note."
 ],
 "Payment confirmed — your account is fully restored.": [
  "Pago confirmado — tu cuenta está completamente restablecida.",
  "Nakumpirma ang bayad — ganap nang naibalik ang account mo."
 ],
 "Subscribe": [
  "Suscribirse",
  "Mag-subscribe"
 ],
 ", then": [
  ", luego",
  ", pagkatapos"
 ],
 ". Keep": [
  ". Mantén",
  ". Panatilihing"
 ],
 "Alerts": [
  "Alertas",
  "Mga alerto"
 ],
 "Attachments": [
  "Archivos adjuntos",
  "Mga attachment"
 ],
 "on if you want reminders.": [
  "activadas si quieres recordatorios.",
  "naka-on kung gusto mo ng mga paalala."
 ],
 "Open the Calendar app →": [
  "Abre la app Calendario →",
  "Buksan ang Calendar app →"
 ],
 "appear under": [
  "aparecen en",
  "lumalabas sa ilalim ng"
 ],
 "“SplashPad”": [
  "“SplashPad”",
  "“SplashPad”"
 ],
 "Manual route: Settings → Calendar → Accounts → Add Account → Other →": [
  "Ruta manual: Ajustes → Calendario → Cuentas → Añadir cuenta → Otra →",
  "Manual na paraan: Settings → Calendar → Accounts → Add Account → Other →"
 ],
 "Add Subscribed Calendar": [
  "Añadir calendario suscrito",
  "Add Subscribed Calendar"
 ],
 "→ paste the link.": [
  "→ pega el enlace.",
  "→ i-paste ang link."
 ],
 "The Google Calendar": [
  "El Google Calendar",
  "Ang Google Calendar"
 ],
 "phone app": [
  "app del teléfono",
  "phone app"
 ],
 "can’t add a calendar by link — you do it once on the web and it then shows up on your phone.": [
  "no puede añadir un calendario por enlace; hazlo una vez en la web y luego aparecerá en tu teléfono.",
  "hindi makakapagdagdag ng calendar gamit ang link — gawin mo ito isang beses sa web at pagkatapos ay lalabas ito sa phone mo."
 ],
 "Add to Google Calendar": [
  "Añadir a Google Calendar",
  "Idagdag sa Google Calendar"
 ],
 "above (it opens calendar.google.com). If asked, request the": [
  "de arriba (abre calendar.google.com). Si te lo pide, solicita la",
  "sa itaas (bubuksan nito ang calendar.google.com). Kung hihingin, piliin ang"
 ],
 "desktop site": [
  "sitio de escritorio",
  "desktop site"
 ],
 "in your browser menu.": [
  "en el menú de tu navegador.",
  "sa menu ng browser mo."
 ],
 "Confirm": [
  "Confirmar",
  "Kumpirmahin"
 ],
 "Add calendar": [
  "Añadir calendario",
  "Magdagdag ng calendar"
 ],
 ". Then in the Google Calendar app go to ☰ → Settings → the": [
  ". Luego, en la app Google Calendar, ve a ☰ → Ajustes → el",
  ". Pagkatapos sa Google Calendar app, pumunta sa ☰ → Settings → ang"
 ],
 "calendar → turn": [
  "calendario → activa",
  "calendar → i-on ang"
 ],
 "on.": [
  "activado.",
  "naka-on."
 ],
 "Manual route: on a computer open calendar.google.com → “Other calendars”": [
  "Ruta manual: en una computadora, abre calendar.google.com → “Otros calendarios”",
  "Manual na paraan: sa computer, buksan ang calendar.google.com → “Other calendars”"
 ],
 "From URL": [
  "Desde URL",
  "From URL"
 ],
 "above — the Calendar app opens with the link filled in.": [
  "de arriba: la app Calendario se abre con el enlace completado.",
  "sa itaas — magbubukas ang Calendar app na nakalagay na ang link."
 ],
 ". Set": [
  ". Configura",
  ". Itakda ang"
 ],
 "Auto-refresh": [
  "Actualización automática",
  "Auto-refresh"
 ],
 "Every hour": [
  "Cada hora",
  "Bawat oras"
 ],
 "so changes show up quickly.": [
  "para que los cambios aparezcan rápidamente.",
  "para mabilis lumabas ang mga pagbabago."
 ],
 "OK": [
  "Aceptar",
  "OK"
 ],
 ". Your SplashPad calendar appears in the sidebar.": [
  ". Tu calendario de SplashPad aparece en la barra lateral.",
  ". Lalabas ang iyong SplashPad calendar sa sidebar."
 ],
 "Manual route: Calendar app → File →": [
  "Ruta manual: app Calendario → Archivo →",
  "Manual na paraan: Calendar app → File →"
 ],
 "New Calendar Subscription…": [
  "Nueva suscripción al calendario…",
  "New Calendar Subscription…"
 ],
 "This is a simulated lock (QA). An admin can clear it from the Dunning page.": [
  "Este es un bloqueo simulado (QA). Un administrador puede quitarlo desde la página de Cobros.",
  "Ito ay isang simulated na lock (QA). Maaaring alisin ito ng admin mula sa page ng Dunning."
 ],
 "Stripe still shows a problem with your subscription. Make sure the new card saved, then try again.": [
  "Stripe sigue mostrando un problema con tu suscripción. Asegúrate de que la nueva tarjeta se haya guardado y luego inténtalo de nuevo.",
  "May problema pa ring ipinapakita ang Stripe sa iyong subscription. Tiyaking na-save ang bagong card, pagkatapos ay subukan muli."
 ],
 "Account locked for non-payment": [
  "Cuenta bloqueada por falta de pago",
  "Naka-lock ang account dahil sa hindi pagbabayad"
 ],
 "Booking page paused — dashboard read-only": [
  "Página de reservas en pausa — panel en modo solo lectura",
  "Naka-pause ang booking page — read-only ang dashboard"
 ],
 "Payment method needs attention": [
  "El método de pago necesita atención",
  "Kailangang asikasuhin ang payment method"
 ],
 "Because": [
  "Porque",
  "Dahil"
 ],
 "Only the Your Subscription page is available until a payment method is on file. Your data is safe.": [
  "Solo la página Tu suscripción está disponible hasta que haya un método de pago registrado. Tus datos están seguros.",
  "Ang page na Your Subscription lang ang available hanggang sa may naka-file na payment method. Ligtas ang iyong data."
 ],
 "Add or update your card below (or fix the declined card with your bank).": [
  "Agrega o actualiza tu tarjeta abajo (o soluciona con tu banco el rechazo de la tarjeta).",
  "Idagdag o i-update ang iyong card sa ibaba (o ayusin ang na-decline na card sa iyong bangko)."
 ],
 "Re-check now": [
  "Volver a comprobar ahora",
  "Suriin muli ngayon"
 ],
 ". Once Stripe confirms the payment, everything switches back on.": [
  ". Una vez que Stripe confirme el pago, todo volverá a activarse.",
  " Kapag nakumpirma na ng Stripe ang bayad, babalik sa normal ang lahat."
 ],
 "I've updated my card — re-check now": [
  "Ya actualicé mi tarjeta — volver a comprobar ahora",
  "Na-update ko na ang aking card — suriin muli ngayon"
 ],
 "Need help? Email support": [
  "¿Necesitas ayuda? Envía un correo a soporte",
  "Kailangan ng tulong? Mag-email sa support"
 ],
 "Start date must be on or before end date.": [
  "La fecha de inicio debe ser igual o anterior a la fecha de fin.",
  "Ang petsa ng simula ay dapat kapareho o mas maaga kaysa petsa ng pagtatapos."
 ],
 "End time must be after start time.": [
  "La hora de fin debe ser posterior a la hora de inicio.",
  "Ang oras ng pagtatapos ay dapat mas huli kaysa oras ng simula."
 ],
 "This day is currently closed. Parents can't book or request classes on it.": [
  "Este día está cerrado actualmente. Los padres no pueden reservar ni solicitar clases en él.",
  "Kasalukuyang sarado ang araw na ito. Hindi makakapag-book o makakahiling ng mga klase ang mga magulang dito."
 ],
 "Pick a date (or range) and we'll close those days on your schedule. Any enrolled families will be auto-emailed a cancellation notice with your reason.": [
  "Elige una fecha (o un rango) y cerraremos esos días en tu horario. A cualquier familia inscrita se le enviará automáticamente por correo electrónico un aviso de cancelación con tu motivo.",
  "Pumili ng petsa (o range) at isasara namin ang mga araw na iyon sa iyong schedule. Ang anumang naka-enroll na pamilya ay awtomatikong ema-email ng abiso ng pagkansela kasama ang iyong dahilan."
 ],
 "Date range": [
  "Rango de fechas",
  "Date range"
 ],
 "Multi-day": [
  "Varios días",
  "Maramihang araw"
 ],
 "Start": [
  "Inicio",
  "Simula"
 ],
 "End": [
  "Fin",
  "Wakas"
 ],
 "Duration": [
  "Duración",
  "Tagal"
 ],
 "Specific hours": [
  "Horas específicas",
  "Partikular na oras"
 ],
 "Closing": [
  "Cierre",
  "Pagsasara"
 ],
 "the whole day": [
  "todo el día",
  "buong araw"
 ],
 ". Flip the switch above to close only certain hours (like an afternoon).": [
  ". Activa el interruptor de arriba para cerrar solo ciertas horas (como una tarde).",
  ". I-on ang switch sa itaas para ilang partikular na oras lang ang isara (gaya ng isang hapon)."
 ],
 "Times shown in": [
  "Horas mostradas en",
  "Mga oras na ipinapakita sa"
 ],
 "— same time range applies to each day in the selected range.": [
  "— el mismo rango horario se aplica a cada día del rango seleccionado.",
  "— ang parehong time range ay ilalapat sa bawat araw sa napiling range."
 ],
 "(optional — shown to families in the email)": [
  "(opcional — se muestra a las familias en el correo electrónico)",
  "(opsyonal — ipapakita sa mga pamilya sa email)"
 ],
 "e.g., Family emergency. I'll reach out about make-up sessions.": [
  "p. ej., Emergencia familiar. Me pondré en contacto sobre las clases de recuperación.",
  "hal., Family emergency. Makikipag-ugnayan ako tungkol sa make-up sessions."
 ],
 "You already have a closed day in this window.": [
  "Ya tienes un día cerrado en este periodo.",
  "May nakasara ka nang araw sa window na ito."
 ],
 "Creating overlapping blackouts is fine — but consider deleting the old one first to avoid duplicate emails.": [
  "Crear cierres superpuestos está bien, pero considera eliminar primero el anterior para evitar correos duplicados.",
  "Ayos lang gumawa ng magkakapatong na blackout, pero pag-isipang burahin muna ang luma para maiwasan ang duplicate na email."
 ],
 "Who's affected?": [
  "¿A quiénes afecta?",
  "Sino ang apektado?"
 ],
 "Checking…": [
  "Comprobando…",
  "Sinusuri…"
 ],
 "No one's scheduled on": [
  "No hay nadie programado en",
  "Walang naka-schedule sa"
 ],
 "these days": [
  "estos días",
  "mga araw na ito"
 ],
 "You can close it without sending any emails.": [
  "Puedes cerrarlo sin enviar ningún correo electrónico.",
  "Maaari mo itong isara nang hindi nagpapadala ng anumang email."
 ],
 "(no email on file)": [
  "(no hay correo electrónico registrado)",
  "(walang email na naka-file)"
 ],
 "will get an automated email with your reason (if you added one).": [
  "recibirá un correo electrónico automático con tu motivo (si agregaste uno).",
  "makakatanggap ng awtomatikong email na may dahilan mo (kung nagdagdag ka nito)."
 ],
 "Reopen this day": [
  "Reabrir este día",
  "Buksan muli ang araw na ito"
 ],
 "Closing…": [
  "Cerrando…",
  "Isinasara…"
 ],
 "Close day": [
  "Cerrar día",
  "Isara ang araw"
 ],
 "Close & notify": [
  "Cerrar y notificar",
  "Isara at abisuhan"
 ],
 "Reopen this day?": [
  "¿Reabrir este día?",
  "Buksan muli ang araw na ito?"
 ],
 "Every family that received a cancellation email for this blackout will get a follow-up email letting them know the class is back on. Make-up credits and refund flags issued by the blackout will also be reverted.": [
  "Cada familia que recibió un correo electrónico de cancelación por este bloqueo recibirá un correo de seguimiento informándoles que la clase vuelve a estar activa. Los créditos de recuperación y las marcas de reembolso emitidos por el bloqueo también se revertirán.",
  "Bawat pamilyang nakatanggap ng cancellation email para sa blackout na ito ay makakatanggap ng follow-up email na nagpapaalam na tuloy na muli ang klase. Ang mga make-up credit at refund flag na ibinigay dahil sa blackout ay mababawi rin."
 ],
 "Yes, reopen": [
  "Sí, reabrir",
  "Oo, buksan muli"
 ],
 "Splash Pad": [
  "Splash Pad",
  "Splash Pad"
 ],
 "More than a booking calendar": [
  "Más que un calendario de reservas",
  "Higit pa sa booking calendar"
 ],
 "Support for the business behind your lessons.": [
  "Apoyo para el negocio detrás de tus clases.",
  "Suporta para sa negosyo sa likod ng iyong mga lesson."
 ],
 "Assistant": [
  "Asistente",
  "Assistant"
 ],
 "Travel smart": [
  "Viaja con inteligencia",
  "Bumiyahe nang matalino"
 ],
 "Good to know:": [
  "Bueno saberlo:",
  "Mabuting malaman:"
 ],
 "How to use it": [
  "Cómo usarlo",
  "Paano ito gamitin"
 ],
 "Requires a coach account.": [
  "Requiere una cuenta de instructor.",
  "Nangangailangan ng coach account."
 ],
 "Pro access is required.": [
  "Se requiere acceso Pro.",
  "Kailangan ang Pro access."
 ],
 "Assistant usage limits apply.": [
  "Se aplican límites de uso del Asistente.",
  "May mga limitasyon sa paggamit ng Assistant."
 ],
 "This walkthrough does not change your account.": [
  "Este recorrido no cambia tu cuenta.",
  "Hindi binabago ng walkthrough na ito ang account mo."
 ],
 "Open in my coach account": [
  "Abrir en mi cuenta de instructor",
  "Buksan sa aking coach account"
 ],
 "One tap adds a private": [
  "Con un toque se agrega un calendario privado",
  "Sa isang tap, magdaragdag ng private na calendar"
 ],
 "calendar to Apple, Google or Outlook. Every booked lesson and class time stays up to date automatically.": [
  "al calendario de Apple, Google o Outlook. Cada lección reservada y horario de clase se mantiene actualizado automáticamente.",
  "sa Apple, Google, o Outlook. Bawat naka-book na lesson at oras ng klase ay kusang nananatiling updated."
 ],
 "Booked 1-on-1 lessons and every class time with at least one enrolled swimmer, from 30 days ago to 12 months ahead. Empty class slots are left out so your calendar stays clean.": [
  "Las lecciones individuales reservadas y cada horario de clase con al menos un nadador inscrito, desde hace 30 días hasta 12 meses adelante. Los cupos vacíos de clases se omiten para que tu calendario se mantenga limpio.",
  "Mga naka-book na 1-on-1 lesson at bawat oras ng klase na may kahit isang naka-enroll na swimmer, mula 30 araw ang nakalipas hanggang 12 buwan sa hinaharap. Hindi isinasama ang mga bakanteng class slot para manatiling malinis ang calendar mo."
 ],
 "Nothing is scheduled in the next 30 days yet": [
  "Aún no hay nada programado en los próximos 30 días",
  "Wala pang naka-iskedyul sa susunod na 30 araw"
 ],
 ", so the calendar will look empty until a swimmer is enrolled.": [
  ", así que el calendario se verá vacío hasta que se inscriba un nadador.",
  ", kaya magmumukhang walang laman ang calendar hanggang may ma-enroll na swimmer."
 ],
 "calendar to Apple, Google or Outlook.": [
  "al calendario de Apple, Google o Outlook.",
  "sa Apple, Google, o Outlook na calendar."
 ],
 "’s lessons": [
  "lecciones de ",
  "mga lesson ni "
 ],
 "Your swimmer’s lessons": [
  "Las lecciones de tu nadador",
  "Mga lesson ng swimmer mo"
 ],
 "stay up to date on their own — if your coach moves or cancels a lesson, your calendar changes too.": [
  "se mantienen actualizadas por sí solas; si tu instructor cambia o cancela una lección, tu calendario también cambia.",
  "kusang nananatiling updated — kung ililipat o kakanselahin ng coach mo ang isang lesson, magbabago rin ang calendar mo."
 ],
 "Every upcoming lesson and class time for your swimmers, from 30 days ago to 12 months ahead, with the coach, location and who’s swimming. Cancelled lessons drop off automatically and new bookings appear on their own.": [
  "Cada próxima lección y horario de clase de tus nadadores, desde hace 30 días hasta 12 meses adelante, con el instructor, la ubicación y quién va a nadar. Las lecciones canceladas desaparecen automáticamente y las nuevas reservas aparecen por sí solas.",
  "Bawat paparating na lesson at oras ng klase para sa mga swimmer mo, mula 30 araw ang nakalipas hanggang 12 buwan sa hinaharap, kasama ang coach, lokasyon, at kung sino ang lalangoy. Kusang nawawala ang mga kinanselang lesson at kusang lumalabas ang mga bagong booking."
 ],
 ", so the calendar will look empty until your coach books a lesson.": [
  ", así que el calendario se verá vacío hasta que tu instructor reserve una lección.",
  ", kaya magmumukhang walang laman ang calendar hanggang mag-book ang coach mo ng lesson."
 ],
 "Add to Apple Calendar": [
  "Agregar a Apple Calendar",
  "Idagdag sa Apple Calendar"
 ],
 "above. Your phone opens a “Subscribe to calendar” sheet.": [
  "arriba. Tu teléfono abrirá una ventana de “Suscribirse al calendario”.",
  "sa itaas. Magbubukas ang phone mo ng sheet na “Subscribe to calendar”."
 ],
 "above. Google opens an “Add calendar” box with the link filled in.": [
  "arriba. Google abre un cuadro de “Añadir calendario” con el enlace ya completado.",
  "sa itaas. Magbubukas ang Google ng kahong “Add calendar” na may nakalagay nang link."
 ],
 "Find": [
  "Buscar",
  "Hanapin"
 ],
 "under “Other calendars” on the left and make sure its checkbox is on.": [
  "en “Otros calendarios” a la izquierda y asegúrate de que su casilla esté marcada.",
  "sa ilalim ng “Other calendars” sa kaliwa at tiyaking naka-on ang checkbox nito."
 ],
 "Manual route: calendar.google.com → “Other calendars”": [
  "Ruta manual: calendar.google.com → “Otros calendarios”",
  "Manual na paraan: calendar.google.com → “Other calendars”"
 ],
 "Add to Outlook": [
  "Añadir a Outlook",
  "Idagdag sa Outlook"
 ],
 "above (Outlook.com) — or use the Microsoft 365 link if your calendar is a work/school account.": [
  "arriba (Outlook.com), o usa el enlace de Microsoft 365 si tu calendario es de una cuenta del trabajo o de la escuela.",
  "sa itaas (Outlook.com) — o gamitin ang link ng Microsoft 365 kung ang iyong kalendaryo ay para sa account sa trabaho/eskuwela."
 ],
 "Confirm the calendar name and click": [
  "Confirma el nombre del calendario y haz clic en",
  "Kumpirmahin ang pangalan ng kalendaryo at i-click ang"
 ],
 "Your SplashPad calendar appears under “Other calendars”.": [
  "Tu calendario de SplashPad aparece en “Otros calendarios”.",
  "Lalabas ang iyong SplashPad calendar sa ilalim ng “Other calendars”."
 ],
 "Manual route: Outlook → Add calendar →": [
  "Ruta manual: Outlook → Añadir calendario →",
  "Manual na paraan: Outlook → Add calendar →"
 ],
 "Subscribe from web": [
  "Suscribirse desde la web",
  "Mag-subscribe mula sa web"
 ],
 "Calendar link copied": [
  "Enlace del calendario copiado",
  "Nakopya ang link ng kalendaryo"
 ],
 "Copy blocked by your browser": [
  "Tu navegador bloqueó la copia",
  "Hinarang ng browser mo ang pagkopya"
 ],
 "New calendar link created": [
  "Se creó un nuevo enlace de calendario",
  "Nagawa ang bagong link ng kalendaryo"
 ],
 "Loading your calendar link…": [
  "Cargando tu enlace de calendario…",
  "Ikinakarga ang link ng iyong kalendaryo…"
 ],
 "last pulled": [
  "última actualización",
  "huling nakuha"
 ],
 "Not connected yet": [
  "Aún no conectado",
  "Hindi pa nakakonekta"
 ],
 "No calendar app has pulled": [
  "Ninguna app de calendario lo ha sincronizado",
  "Wala pang calendar app na kumuha nito"
 ],
 "yet. Pick your calendar below — this box turns green once it syncs.": [
  "todavía. Elige tu calendario abajo: este recuadro se pondrá verde cuando se sincronice.",
  "pa. Piliin ang iyong kalendaryo sa ibaba — magiging berde ang kahong ito kapag naka-sync na."
 ],
 "Work / school Microsoft 365 calendar instead?": [
  "¿Tu calendario es de Microsoft 365 del trabajo o de la escuela?",
  "Microsoft 365 calendar ba ito ng trabaho / eskuwela?"
 ],
 "Or copy your private link": [
  "O copia tu enlace privado",
  "O kopyahin ang iyong pribadong link"
 ],
 "Copied": [
  "Copiado",
  "Nakopya"
 ],
 "Calendar feed link": [
  "Enlace del calendario",
  "Link ng calendar feed"
 ],
 "Step-by-step for your device": [
  "Paso a paso para tu dispositivo",
  "Step-by-step para sa iyong device"
 ],
 "Timing:": [
  "Horario:",
  "Timing:"
 ],
 "in the next 30 days": [
  "en los próximos 30 días",
  "sa susunod na 30 araw"
 ],
 "Nothing showing up? Troubleshooting": [
  "¿No aparece nada? Solución de problemas",
  "Walang lumalabas? Troubleshooting"
 ],
 "Give Google time.": [
  "Dale tiempo a Google.",
  "Bigyan ng oras ang Google."
 ],
 "Google Calendar can take up to 24 hours to show a newly added calendar and refreshes every 12–24 hours. Apple and Outlook are faster (about an hour).": [
  "Google Calendar puede tardar hasta 24 horas en mostrar un calendario recién añadido y se actualiza cada 12–24 horas. Apple y Outlook son más rápidos (aproximadamente una hora).",
  "Maaaring umabot nang hanggang 24 oras ang Google Calendar bago ipakita ang bagong idinagdag na kalendaryo at nagre-refresh ito kada 12–24 oras. Mas mabilis ang Apple at Outlook (mga isang oras)."
 ],
 "Is the calendar turned on?": [
  "¿Está activado el calendario?",
  "Naka-on ba ang kalendaryo?"
 ],
 "In your calendar app, look for “SplashPad” in the calendar list and make sure its checkbox is ticked (Google: under “Other calendars”).": [
  "En tu app de calendario, busca “SplashPad” en la lista de calendarios y asegúrate de que su casilla esté marcada (Google: en “Otros calendarios”).",
  "Sa iyong calendar app, hanapin ang “SplashPad” sa listahan ng mga kalendaryo at tiyaking naka-check ang checkbox nito (Google: sa ilalim ng “Other calendars”)."
 ],
 "Android phone?": [
  "¿Teléfono Android?",
  "Android phone?"
 ],
 "Add it on the web first (see the Android tab), then turn Sync on for that calendar in the Google Calendar app.": [
  "Primero añádelo en la web (consulta la pestaña de Android) y luego activa la sincronización para ese calendario en la app Google Calendar.",
  "Idagdag muna ito sa web (tingnan ang Android tab), pagkatapos ay i-on ang Sync para sa kalendaryong iyon sa Google Calendar app."
 ],
 "Still empty?": [
  "¿Sigue vacío?",
  "Wala pa rin laman?"
 ],
 "Shared the link by mistake? Reset it — the old one stops working.": [
  "¿Compartiste el enlace por error? Restablécelo: el anterior dejará de funcionar.",
  "Naibahagi mo ba ang link nang hindi sinasadya? I-reset ito — hihinto sa paggana ang luma."
 ],
 "Reset link": [
  "Restablecer enlace",
  "I-reset ang link"
 ],
 "Reset your calendar link?": [
  "¿Restablecer tu enlace del calendario?",
  "I-reset ang link ng kalendaryo mo?"
 ],
 "Your current link stops working immediately. Any phone or computer already subscribed will stop updating until you add the new link there.": [
  "Tu enlace actual deja de funcionar de inmediato. Cualquier teléfono o computadora que ya esté suscrito dejará de actualizarse hasta que agregues allí el enlace nuevo.",
  "Hihinto agad sa paggana ang kasalukuyan mong link. Anumang telepono o computer na naka-subscribe na ay hihinto sa pag-update hanggang maidagdag mo roon ang bagong link."
 ],
 "Keep current link": [
  "Mantener enlace actual",
  "Panatilihin ang kasalukuyang link"
 ],
 "Parents can cancel or reschedule from their portal": [
  "Los padres pueden cancelar o reprogramar desde su portal",
  "Maaaring magkansela o mag-reschedule ang mga magulang mula sa kanilang portal"
 ],
 "Off = every change goes through you (text or call).": [
  "Desactivado = cada cambio pasa por ti (mensaje de texto o llamada).",
  "Off = bawat pagbabago ay dadaan sa iyo (text o tawag)."
 ],
 "How many cancels are allowed": [
  "Cuántas cancelaciones se permiten",
  "Ilang pagkansela ang pinapayagan"
 ],
 "Unlimited": [
  "Ilimitadas",
  "Walang limitasyon"
 ],
 "Custom number of cancels": [
  "Número personalizado de cancelaciones",
  "Custom na bilang ng mga pagkansela"
 ],
 "Resets": [
  "Se restablece",
  "Nagre-reset"
 ],
 "every month": [
  "cada mes",
  "bawat buwan"
 ],
 "never — total per package": [
  "nunca — total por paquete",
  "hindi kailanman — kabuuan bawat package"
 ],
 "0 means parents can only": [
  "0 significa que los padres solo pueden",
  "Ang 0 ay nangangahulugang maaari lamang ang mga magulang na"
 ],
 "reschedule": [
  "reprogramar",
  "mag-reschedule"
 ],
 "(if you allow it below) — never cancel outright.": [
  "(si lo permites abajo) — nunca cancelar por completo.",
  "(kung papayagan mo sa ibaba) — hindi kailanman direktang magkansela."
 ],
 "Notice required": [
  "Aviso requerido",
  "Kinakailangang abiso"
 ],
 "None": [
  "Ninguno",
  "Wala"
 ],
 "Custom notice hours": [
  "Horas de aviso personalizadas",
  "Custom na oras ng abiso"
 ],
 "hours before the lesson": [
  "horas antes de la clase",
  "oras bago ang lesson"
 ],
 "If it's too late to cancel": [
  "Si ya es demasiado tarde para cancelar",
  "Kung huli na para magkansela"
 ],
 "A reschedule uses one of the allowed changes": [
  "Una reprogramación usa uno de los cambios permitidos",
  "Ang isang reschedule ay gumagamit ng isa sa mga pinapayagang pagbabago"
 ],
 "Off = moving a lesson to another open time is always free (still needs the notice above).": [
  "Desactivado = mover una clase a otro horario disponible siempre es gratis (igual requiere el aviso anterior).",
  "Off = ang paglipat ng lesson sa ibang bakanteng oras ay laging libre (kailangan pa rin ang abiso sa itaas)."
 ],
 "Parents will see:": [
  "Los padres verán:",
  "Makikita ng mga magulang:"
 ],
 "failed charge": [
  "cargo fallido",
  "nabigong charge"
 ],
 "in the last 30 days": [
  "en los últimos 30 días",
  "sa nakaraang 30 araw"
 ],
 "Active enrollment but no card on file — pay-first packages will fail.": [
  "Inscripción activa pero sin tarjeta registrada — los paquetes de pago por adelantado fallarán.",
  "Aktibo ang enrollment pero walang card na naka-file — mabibigo ang mga pay-first package."
 ],
 "Open the Family Hub once to scan this card.": [
  "Abre el Family Hub una vez para escanear esta tarjeta.",
  "Buksan ang Family Hub nang isang beses para i-scan ang card na ito."
 ],
 "Email this family a secure link to update their card": [
  "Enviar por correo electrónico a esta familia un enlace seguro para actualizar su tarjeta",
  "I-email sa pamilyang ito ang isang secure na link para i-update ang kanilang card"
 ],
 "This family has no email on file": [
  "Esta familia no tiene un correo electrónico registrado",
  "Walang email na naka-file para sa pamilyang ito"
 ],
 "Send update link": [
  "Enviar enlace de actualización",
  "Ipadala ang update link"
 ],
 "Card health": [
  "Estado de las tarjetas",
  "Kalagayan ng mga card"
 ],
 "Couldn't load card-health right now.": [
  "No se pudo cargar el estado de las tarjetas en este momento.",
  "Hindi ma-load ang kalagayan ng mga card ngayon."
 ],
 "Connect Stripe to monitor which families have expired or failing cards on file.": [
  "Conecta Stripe para monitorear qué familias tienen tarjetas vencidas o con fallas registradas.",
  "Ikonekta ang Stripe para masubaybayan kung aling mga pamilya ang may expired o pumapalpak na mga card na naka-file."
 ],
 "Connect Stripe": [
  "Conectar Stripe",
  "Ikonekta ang Stripe"
 ],
 "All good": [
  "Todo bien",
  "Maayos ang lahat"
 ],
 "Every family's card on file looks healthy. We'll flag any expiring or failing cards here.": [
  "La tarjeta registrada de cada familia parece estar en buen estado. Marcaremos aquí cualquier tarjeta próxima a vencer o con fallas.",
  "Mukhang maayos ang card na naka-file ng bawat pamilya. Ipa-flag namin dito ang anumang card na malapit nang mag-expire o pumapalpak."
 ],
 "need": [
  "requieren",
  "kailangan ng"
 ],
 "attention": [
  "atención",
  "atensyon"
 ],
 "Monitoring": [
  "Supervisión",
  "Pagmomonitor"
 ],
 "recent failure": [
  "fallo reciente",
  "kamakailang pagkabigo"
 ],
 "expired": [
  "vencida",
  "expired"
 ],
 "expiring": [
  "por vencer",
  "mage-expire"
 ],
 "no card": [
  "sin tarjeta",
  "walang card"
 ],
 "unscanned": [
  "sin revisar",
  "hindi na-scan"
 ],
 "healthy": [
  "correcta",
  "maayos"
 ],
 "See all card-health issues": [
  "Ver todos los problemas del estado de las tarjetas",
  "Tingnan ang lahat ng isyu sa kalagayan ng card"
 ],
 "No urgent card issues —": [
  "No hay problemas urgentes con las tarjetas —",
  "Walang agarang isyu sa mga card —"
 ],
 "all clear!": [
  "¡todo en orden!",
  "ayos ang lahat!"
 ],
 "Statuses update as you open each family's card panel. Send an update-card link to have parents refresh their own card on file.": [
  "Los estados se actualizan a medida que abres el panel de tarjeta de cada familia. Envía un enlace de actualización de tarjeta para que los padres actualicen su propia tarjeta registrada.",
  "Nag-a-update ang mga status habang binubuksan mo ang card panel ng bawat pamilya. Magpadala ng update-card link para ma-refresh ng mga magulang ang sarili nilang card na naka-file."
 ],
 "All card-health issues": [
  "Todos los problemas del estado de las tarjetas",
  "Lahat ng isyu sa kalagayan ng card"
 ],
 "Families whose card on file is expiring, expired, or has recently failed.": [
  "Familias cuya tarjeta registrada está por vencer, vencida o ha fallado recientemente.",
  "Mga pamilyang may card na naka-file na mage-expire, expired, o kamakailan lang ay nabigo."
 ],
 "Switch down to": [
  "Cambiar a un plan inferior a",
  "Mag-downgrade sa"
 ],
 "New": [
  "Nuevo",
  "Bago"
 ],
 "Discount applied": [
  "Descuento aplicado",
  "Na-apply ang diskwento"
 ],
 "Community pricing": [
  "Precio comunitario",
  "Presyong pangkomunidad"
 ],
 "/mo forever": [
  "/mes para siempre",
  "/buwan magpakailanman"
 ],
 ". No code to type — we'll add it for you.": [
  ". No hay ningún código que escribir — lo agregaremos por ti.",
  ". Walang code na kailangang ilagay — kami na ang maglalagay nito para sa iyo."
 ],
 "Use a different code instead": [
  "Usar otro código en su lugar",
  "Gumamit na lang ng ibang code"
 ],
 "Your community 50% Pro discount is temporarily unavailable": [
  "Tu descuento comunitario del 50% en Pro no está disponible temporalmente",
  "Pansamantalang hindi available ang iyong 50% community discount sa Pro"
 ],
 "(the code has hit its limit). We've alerted the SplashPad team — please contact support before upgrading so you aren't billed full price.": [
  "(el código ha alcanzado su límite). Ya alertamos al equipo de SplashPad — ponte en contacto con soporte antes de actualizar para que no se te cobre el precio completo.",
  "(naabot na ng code ang limit nito). Naabisuhan na namin ang SplashPad team — mangyaring makipag-ugnayan sa support bago mag-upgrade para hindi ka masingil ng buong presyo."
 ],
 "Change takes effect immediately. Your card on file is charged the prorated difference for the rest of this billing period on your next billing date, then": [
  "El cambio entra en vigor de inmediato. Se carga a tu tarjeta registrada la diferencia prorrateada por el resto de este período de facturación en tu próxima fecha de facturación, y luego",
  "Magkakabisa agad ang pagbabago. Ang prorated na diperensya para sa natitirang bahagi ng billing period na ito ay icha-charge sa iyong card na naka-file sa susunod mong billing date, pagkatapos ay"
 ],
 "going forward. Cancel anytime.": [
  "en adelante. Cancela en cualquier momento.",
  "sa susunod na panahon. Maaari kang magkansela anumang oras."
 ],
 "Switching…": [
  "Cambiando…",
  "Naglilipat…"
 ],
 "Switch to": [
  "Cambiar a",
  "Lumipat sa"
 ],
 "applied": [
  "aplicado",
  "na-apply"
 ],
 "Have a promo code?": [
  "¿Tienes un código promocional?",
  "May promo code ka ba?"
 ],
 "Renew pack": [
  "Renovar paquete",
  "I-renew ang pack"
 ],
 "Charge card on file": [
  "Cobrar a la tarjeta registrada",
  "I-charge ang card na naka-file"
 ],
 "Charge": [
  "Cobrar",
  "I-charge"
 ],
 "'s saved card and restart their lesson pack in one step. They'll get a Stripe receipt — no login needed on their end.": [
  "la tarjeta guardada de . Reinicia también su paquete de clases en un solo paso. Recibirá un recibo de Stripe — no necesita iniciar sesión de su lado.",
  "naka-save na card ni . at i-restart ang lesson pack nila sa isang hakbang. Makakatanggap sila ng resibo mula sa Stripe — hindi nila kailangang mag-login."
 ],
 "'s saved card. They'll receive an emailed receipt from Stripe immediately.": [
  "la tarjeta guardada de . Recibirá un recibo por correo electrónico de Stripe de inmediato.",
  "naka-save na card ni . Makakatanggap sila agad ng resibo sa email mula sa Stripe."
 ],
 "Loading saved card…": [
  "Cargando tarjeta guardada…",
  "Nilo-load ang naka-save na card…"
 ],
 "This family doesn't have a card on file. Send them a payment link or ask them to add a card from the Payments tab in their parent dashboard.": [
  "Esta familia no tiene una tarjeta registrada. Envíales un enlace de pago o pídeles que añadan una tarjeta desde la pestaña Pagos en su panel para padres.",
  "Walang naka-file na card ang pamilyang ito. Padalhan sila ng payment link o hilinging magdagdag sila ng card mula sa tab na Payments sa kanilang parent dashboard."
 ],
 "On file": [
  "Registrada",
  "Naka-file"
 ],
 "No card on file — but this family has": [
  "No hay una tarjeta registrada, pero esta familia tiene",
  "Walang naka-file na card — pero ang pamilyang ito ay may"
 ],
 "in account credit. You can still charge them if the credit fully covers the amount.": [
  "de crédito en la cuenta. Aún puedes cobrarles si el crédito cubre el importe completo.",
  "na account credit. Maaari mo pa rin silang singilin kung ganap na sasaklawin ng credit ang halaga."
 ],
 "(optional — auto-fills amount)": [
  "(opcional; completa automáticamente el importe)",
  "(opsyonal — awtomatikong nilalagay ang halaga)"
 ],
 "Custom amount": [
  "Importe personalizado",
  "Custom na halaga"
 ],
 "account credit available": [
  "crédito en la cuenta disponible",
  "available na account credit"
 ],
 "Apply credit": [
  "Aplicar crédito",
  "I-apply ang credit"
 ],
 "Apply the maximum credit available": [
  "Aplicar el crédito máximo disponible",
  "I-apply ang maximum na available na credit"
 ],
 "Max": [
  "Máx.",
  "Max"
 ],
 "Don't apply": [
  "No aplicar",
  "Huwag i-apply"
 ],
 "Amount of credit to apply (max": [
  "Importe de crédito a aplicar (máx.",
  "Halaga ng credit na ia-apply (max"
 ],
 "Total charge": [
  "Cargo total",
  "Kabuuang singil"
 ],
 "− Credit applied": [
  "− Crédito aplicado",
  "− Na-apply na credit"
 ],
 "Charged to card": [
  "Cobrado a la tarjeta",
  "Siningil sa card"
 ],
 "Credit fully covers this charge — Stripe is not called and no card is charged.": [
  "El crédito cubre por completo este cargo; no se llama a Stripe ni se cobra ninguna tarjeta.",
  "Ganap na sinasaklaw ng credit ang singil na ito — hindi tatawagin ang Stripe at walang card na sisingilin."
 ],
 "Checking account credit…": [
  "Comprobando crédito en la cuenta…",
  "Tinitingnan ang account credit…"
 ],
 "What is this for?": [
  "¿Para qué es esto?",
  "Para saan ito?"
 ],
 "(shows on the receipt)": [
  "(se muestra en el recibo)",
  "(ipinapakita sa resibo)"
 ],
 "e.g. Summer 4-lesson package": [
  "p. ej., paquete de verano de 4 lecciones",
  "hal. Summer 4-lesson package"
 ],
 "Heads up — this is over $999.": [
  "Atención: esto supera los $999.",
  "Paalala — lampas ito sa $999."
 ],
 "Make sure you've confirmed the amount with the family. Check this box to authorise.": [
  "Asegúrate de haber confirmado el importe con la familia. Marca esta casilla para autorizarlo.",
  "Tiyaking nakumpirma mo ang halaga sa pamilya. Lagyan ng check ang kahong ito para pahintulutan ito."
 ],
 "Amount cannot exceed $10,000 per charge.": [
  "El importe no puede superar $10,000 por cargo.",
  "Hindi maaaring lumampas sa $10,000 bawat singil ang halaga."
 ],
 "Credit fully covers this charge. No Stripe charge is made. The family will see this on their payment history.": [
  "El crédito cubre por completo este cargo. No se realiza ningún cargo de Stripe. La familia lo verá en su historial de pagos.",
  "Ganap na sinasaklaw ng credit ang singil na ito. Walang Stripe charge na gagawin. Makikita ito ng pamilya sa kanilang payment history."
 ],
 "This charge runs off-session against the family’s saved card. If the card requires verification it will fail immediately — no funds are held. Stripe emails the family a hosted receipt on success.": [
  "Este cargo se procesa fuera de sesión contra la tarjeta guardada de la familia. Si la tarjeta requiere verificación, fallará de inmediato; no se retendrán fondos. Stripe envía por correo electrónico a la familia un recibo alojado si el cobro se realiza correctamente.",
  "Ang singil na ito ay pinoproseso off-session gamit ang naka-save na card ng pamilya. Kung mangangailangan ng beripikasyon ang card, agad itong magfa-fail — walang pondong iho-hold. Mag-e-email ang Stripe sa pamilya ng hosted receipt kapag matagumpay."
 ],
 "Charging…": [
  "Cobrando…",
  "Sinisingil…"
 ],
 "Day & time": [
  "Día y hora",
  "Araw at oras"
 ],
 "Class times": [
  "Horarios de clase",
  "Mga oras ng klase"
 ],
 "Tap the weekday(s) and set the time. Add a second time only if parents should choose between two options.": [
  "Toca los días de la semana y establece la hora. Añade una segunda hora solo si los padres deben elegir entre dos opciones.",
  "I-tap ang (mga) araw ng linggo at itakda ang oras. Magdagdag lang ng pangalawang oras kung dapat pumili ang mga magulang sa dalawang opsyon."
 ],
 "Each class time shows on your Schedule with the max enrollment you set above (e.g., 0 / 6 enrolled) — even before anyone joins. Parents pick a time when they enroll.": [
  "Cada horario de clase se muestra en tu Horario con la capacidad máxima que estableciste arriba (p. ej., 0 / 6 inscritos), incluso antes de que alguien se una. Los padres eligen un horario cuando se inscriben.",
  "Bawat oras ng klase ay lumalabas sa iyong Schedule kasama ang maximum enrollment na itinakda mo sa itaas (hal., 0 / 6 enrolled) — kahit bago pa may sumali. Pumipili ang mga magulang ng oras kapag nag-enroll sila."
 ],
 "Add day & time": [
  "Añadir día y hora",
  "Magdagdag ng araw at oras"
 ],
 "No day picked yet — tap \"Add day & time\" to choose when this package meets.": [
  "Aún no se ha elegido ningún día; toca \"Añadir día y hora\" para elegir cuándo se imparte este paquete.",
  "Wala pang napipiling araw — i-tap ang \"Add day & time\" para piliin kung kailan ginaganap ang package na ito."
 ],
 "No class times yet — parents will enroll without picking a time. Add weekly or one-off slots to turn this into a scheduled class.": [
  "Aún no hay horarios de clase; los padres se inscribirán sin elegir un horario. Añade franjas semanales o únicas para convertir esto en una clase programada.",
  "Wala pang class times — mag-e-enroll ang mga magulang nang hindi pumipili ng oras. Magdagdag ng lingguhan o one-off na slots para gawin itong scheduled class."
 ],
 "Repeat": [
  "Repetir",
  "Ulitin"
 ],
 "How many days a week?": [
  "¿Cuántos días a la semana?",
  "Ilang araw bawat linggo?"
 ],
 "Days per week": [
  "Días por semana",
  "Mga araw bawat linggo"
 ],
 "Once a week": [
  "Una vez por semana",
  "Isang beses bawat linggo"
 ],
 "Parents see": [
  "Los padres ven",
  "Nakikita ng mga magulang"
 ],
 "+ Add a": [
  "+ Agregar un",
  "+ Magdagdag ng"
 ],
 "th day": [
  "día",
  "ika-na araw"
 ],
 "Same time every day — change Day 1 and the others follow. Change any other day to give it its own time.": [
  "La misma hora todos los días: cambia el Día 1 y los demás seguirán. Cambia cualquier otro día para darle su propio horario.",
  "Parehong oras araw-araw — baguhin ang Araw 1 at susunod ang iba. Baguhin ang alinmang ibang araw para bigyan ito ng sarili nitong oras."
 ],
 "Each day has its own time. Families enroll in all of these days together.": [
  "Cada día tiene su propio horario. Las familias se inscriben en todos estos días juntos.",
  "Bawat araw ay may sarili nitong oras. Nag-e-enroll ang mga pamilya sa lahat ng araw na ito nang magkakasama."
 ],
 "Pick the day and time this class meets each week.": [
  "Elige el día y la hora en que esta clase se reúne cada semana.",
  "Piliin ang araw at oras kung kailan nagkikita ang klaseng ito bawat linggo."
 ],
 "Parents see:": [
  "Los padres ven:",
  "Nakikita ng mga magulang:"
 ],
 "Duration (min)": [
  "Duración (min)",
  "Tagal (min)"
 ],
 "Capacity": [
  "Capacidad",
  "Kapasidad"
 ],
 "(0 = use package default": [
  "(0 = usar el valor predeterminado del paquete",
  "(0 = gamitin ang default ng package"
 ],
 "· unlimited": [
  "· ilimitado",
  "· walang limitasyon"
 ],
 "Member portal signup": [
  "Inscripción en el portal de miembros",
  "Pag-sign up sa member portal"
 ],
 "Requires approval": [
  "Requiere aprobación",
  "Nangangailangan ng pag-apruba"
 ],
 "You confirm before enrolling.": [
  "Usted confirma antes de inscribir.",
  "Ikaw ang magkukumpirma bago i-enroll."
 ],
 "Approved parents self-enroll instantly.": [
  "Los padres aprobados se inscriben al instante.",
  "Ang mga aprubadong magulang ay makakapag-self-enroll agad."
 ],
 "How long does this class run?": [
  "¿Cuánto dura esta clase?",
  "Gaano katagal ang klaseng ito?"
 ],
 "Ongoing — no end date": [
  "Continua — sin fecha de finalización",
  "Patuloy — walang petsa ng pagtatapos"
 ],
 "Runs (and bills) until a family cancels.": [
  "Se imparte (y se factura) hasta que una familia cancele.",
  "Tumatakbo (at sinisingil) hanggang magkansela ang isang pamilya."
 ],
 "Seasonal — ends on a date": [
  "De temporada — termina en una fecha",
  "Pana-panahon — nagtatapos sa isang petsa"
 ],
 "Billing auto-stops after the last cycle.": [
  "La facturación se detiene automáticamente después del último ciclo.",
  "Awtomatikong humihinto ang billing pagkatapos ng huling cycle."
 ],
 "Start date (optional)": [
  "Fecha de inicio (opcional)",
  "Petsa ng pagsisimula (opsyonal)"
 ],
 "Clear start date": [
  "Borrar fecha de inicio",
  "I-clear ang petsa ng pagsisimula"
 ],
 "Blank = starts as soon as a family enrolls.": [
  "En blanco = comienza en cuanto una familia se inscribe.",
  "Blangko = magsisimula sa sandaling mag-enroll ang isang pamilya."
 ],
 "Clear end date (makes the class ongoing)": [
  "Borrar fecha de finalización (hace que la clase sea continua)",
  "I-clear ang petsa ng pagtatapos (ginagawang tuloy-tuloy ang klase)"
 ],
 "Add another time option": [
  "Agregar otra opción de horario",
  "Magdagdag ng isa pang opsyon sa oras"
 ],
 "Add weekly slot": [
  "Agregar horario semanal",
  "Magdagdag ng lingguhang slot"
 ],
 "Add one-off slot": [
  "Agregar horario único",
  "Magdagdag ng isang beses na slot"
 ],
 "Couldn't update your class times. Try again.": [
  "No se pudieron actualizar los horarios de tu clase. Inténtalo de nuevo.",
  "Hindi ma-update ang mga oras ng klase mo. Subukan ulit."
 ],
 "Class time signup": [
  "Inscripción al horario de clase",
  "Pag-sign up sa oras ng klase"
 ],
 "Instant signup approves the": [
  "La inscripción instantánea aprueba la",
  "Inaaprubahan ng instant signup ang"
 ],
 ". Each": [
  ". Cada",
  ". Bawat isa"
 ],
 "also has its own setting —": [
  "también tiene su propia configuración —",
  "ay mayroon ding sarili nitong setting —"
 ],
 "Ask in the Coach WhatsApp group": [
  "Pregunta en el grupo de WhatsApp de instructores",
  "Magtanong sa Coach WhatsApp group"
 ],
 "Keep going with Pro": [
  "Sigue con Pro",
  "Magpatuloy sa Pro"
 ],
 "Pro coaches get": [
  "Los instructores Pro obtienen",
  "Ang mga Pro coach ay nakakakuha ng"
 ],
 "× the Splash allowance": [
  "× la asignación de Splash",
  "× na Splash allowance"
 ],
 "— plus Splash can take actions for you, not just answer.": [
  "— además, Splash puede realizar acciones por ti, no solo responder.",
  "— dagdag pa, puwedeng gumawa ng mga aksyon ang Splash para sa iyo, hindi lang sumagot."
 ],
 "Takes about a minute · no page change": [
  "Toma alrededor de un minuto · sin cambiar de página",
  "Mga isang minuto lang · walang page change"
 ],
 "Chat with Splash, your superhero sidekick": [
  "Chatea con Splash, tu compañero superhéroe",
  "Makipag-chat kay Splash, ang superhero sidekick mo"
 ],
 "Splash": [
  "Splash",
  "Splash"
 ],
 "Listening — you’re in control": [
  "Escuchando — tú tienes el control",
  "Nakikinig — ikaw ang may kontrol"
 ],
 "On it…": [
  "En ello…",
  "Inaayos na…"
 ],
 "Your SI agent · tell me what to do": [
  "Tu agente de SI · dime qué hacer",
  "Ang SI agent mo · sabihin mo sa akin kung ano ang gagawin"
 ],
 "Your superhero sidekick · SI": [
  "Tu compañero superhéroe · SI",
  "Ang superhero sidekick mo · SI"
 ],
 "Start a new chat": [
  "Iniciar un chat nuevo",
  "Magsimula ng bagong chat"
 ],
 "Close assistant": [
  "Cerrar asistente",
  "Isara ang assistant"
 ],
 "Hi, I’m Splash!": [
  "¡Hola, soy Splash!",
  "Hi, ako si Splash!"
 ],
 "I’m an AI assistant built for swim instructors. Ask me about your account, setting up lessons, or growing your swim business. What would you like help with?": [
  "Soy un asistente de IA creado para instructores de natación. Pregúntame sobre tu cuenta, cómo configurar clases o cómo hacer crecer tu negocio de natación. ¿Con qué te gustaría recibir ayuda?",
  "Isa akong AI assistant na ginawa para sa mga swim instructor. Magtanong ka sa akin tungkol sa account mo, pag-set up ng mga lesson, o pagpapalago ng swim business mo. Ano ang gusto mong ipatulong?"
 ],
 "Back to chat": [
  "Volver al chat",
  "Bumalik sa chat"
 ],
 "You’re the superhero. I’m your sidekick.": [
  "Tú eres el superhéroe. Yo soy tu compañero.",
  "Ikaw ang superhero. Ako ang sidekick mo."
 ],
 "Hey": [
  "Hola",
  "Hey"
 ],
 ", Coach": [
  ", Instructor",
  ", Coach"
 ],
 "Let’s make your coach day a little lighter. What are we tackling?": [
  "Hagamos tu día como instructor un poco más ligero. ¿Qué vamos a resolver?",
  "Gawing mas magaan nang kaunti ang araw mo bilang coach. Ano ang aasikasuhin natin?"
 ],
 "Just tell me what to do": [
  "Solo dime qué hacer",
  "Sabihin mo lang sa akin kung ano ang gagawin"
 ],
 "Ask me anything about your account": [
  "Pregúntame lo que sea sobre tu cuenta",
  "Tanungin mo ako ng kahit ano tungkol sa account mo"
 ],
 "I preview every change — nothing happens until you say": [
  "Te muestro una vista previa de cada cambio: no pasa nada hasta que digas",
  "Pini-preview ko ang bawat pagbabago — walang mangyayari hangga't hindi mo sinasabi"
 ],
 "yes": [
  "sí",
  "oo"
 ],
 "free Splash actions left this month": [
  "acciones gratis de Splash restantes este mes",
  "libreng Splash actions na natitira ngayong buwan"
 ],
 "Free Splash actions used this month — I can still look things up for you.": [
  "Acciones gratis de Splash usadas este mes — aún puedo buscar información por ti.",
  "Nagamit na ang mga libreng Splash action ngayong buwan — puwede pa rin akong maghanap para sa iyo."
 ],
 "Get a human answer now": [
  "Obtén una respuesta humana ahora",
  "Kumuha ng sagot mula sa tao ngayon"
 ],
 "A few ways I can help": [
  "Algunas formas en que puedo ayudar",
  "Ilang paraan kung paano ako makakatulong"
 ],
 "Out of questions for now": [
  "Sin más preguntas por ahora",
  "Wala nang tanong sa ngayon"
 ],
 "Preview ·": [
  "Vista previa ·",
  "Preview ·"
 ],
 "Type or say": [
  "Escribe o di",
  "Mag-type o magsalita"
 ],
 "to do it ·": [
  "para hacerlo ·",
  "para gawin ito ·"
 ],
 "no": [
  "no",
  "hindi"
 ],
 "to cancel · or tell me what to change.": [
  "para cancelar · o dime qué cambiar.",
  "para kanselahin · o sabihin mo sa akin kung ano ang babaguhin."
 ],
 ". Both need to be open for parents to enroll without waiting on you.": [
  ". Ambos deben estar abiertos para que los padres puedan inscribirse sin esperarte.",
  ". Parehong kailangang bukas para makapag-enroll ang mga magulang nang hindi ka hinihintay."
 ],
 "Couldn't load your class times.": [
  "No se pudieron cargar los horarios de tus clases.",
  "Hindi ma-load ang mga oras ng klase mo."
 ],
 "No class times yet. When you add classes under": [
  "Aún no hay horarios de clases. Cuando agregues clases en",
  "Wala pang mga oras ng klase. Kapag nagdagdag ka ng mga klase sa ilalim ng"
 ],
 ", new times will default to": [
  ", los nuevos horarios tendrán por defecto",
  ", ang mga bagong oras ay magiging default sa"
 ],
 "to match your instant-signup setting.": [
  "para coincidir con tu configuración de inscripción instantánea.",
  "para tumugma sa setting mo ng instant signup."
 ],
 "still require your approval. Parents who sign up instantly will be told to “submit a request” when they pick one of these times.": [
  "todavía requieren tu aprobación. A los padres que se inscriban al instante se les indicará “enviar una solicitud” cuando elijan uno de estos horarios.",
  "nangangailangan pa rin ng pag-apruba mo. Sasabihan ang mga magulang na nag-sign up agad na “submit a request” kapag pinili nila ang isa sa mga oras na ito."
 ],
 "are open enrollment — approved parents can enroll instantly.": [
  "tienen inscripción abierta: los padres aprobados pueden inscribirse al instante.",
  "ay open enrollment — ang mga aprubadong magulang ay maaaring mag-enroll agad."
 ],
 "require approval ·": [
  "requieren aprobación ·",
  "nangangailangan ng pag-apruba ·"
 ],
 "open enrollment.": [
  "inscripción abierta.",
  "open enrollment."
 ],
 "approval": [
  "aprobación",
  "pag-apruba"
 ],
 "Switch all class times to open enrollment": [
  "Cambiar todos los horarios de clases a inscripción abierta",
  "Gawing open enrollment ang lahat ng oras ng klase"
 ],
 "Require approval for all": [
  "Requerir aprobación para todos",
  "Mangailangan ng pag-apruba para sa lahat"
 ],
 "Want to review some classes but not others? Set it per class time under": [
  "¿Quieres revisar algunas clases pero no otras? Configúralo por horario de clase en",
  "Gusto mong suriin ang ilang klase pero hindi ang iba? Itakda ito sa bawat oras ng klase sa ilalim ng"
 ],
 "Classes & Pricing → Edit → Schedule": [
  "Clases y precios → Editar → Horario",
  "Classes & Pricing → Edit → Schedule"
 ],
 "Want more help? Join the Coach Beta WhatsApp group.": [
  "¿Quieres más ayuda? Únete al grupo de WhatsApp Beta para Instructores.",
  "Gusto mo pa ng tulong? Sumali sa Coach Beta WhatsApp group."
 ],
 "That's the fastest way to get a real answer — you'll hear directly from the SplashPad team and other coaches inside minutes.": [
  "Esa es la forma más rápida de obtener una respuesta real: recibirás ayuda directamente del equipo de SplashPad y de otros instructores en cuestión de minutos.",
  "Iyan ang pinakamabilis na paraan para makakuha ng totoong sagot — direkta kang makakarinig mula sa SplashPad team at iba pang coach sa loob lang ng ilang minuto."
 ],
 "Join WhatsApp Group": [
  "Unirse al grupo de WhatsApp",
  "Sumali sa WhatsApp Group"
 ],
 "Glad that helped — noted 👍": [
  "Me alegra que eso ayudara — tomado en cuenta 👍",
  "Buti nakatulong iyon — noted 👍"
 ],
 "Thanks — we’ll improve this one.": [
  "Gracias — mejoraremos esto.",
  "Salamat — pagagandahin pa namin ito."
 ],
 "Did this help?": [
  "¿Esto ayudó?",
  "Nakatulong ba ito?"
 ],
 "Yes, this answer helped": [
  "Sí, esta respuesta ayudó",
  "Oo, nakatulong ang sagot na ito"
 ],
 "Yes": [
  "Sí",
  "Oo"
 ],
 "No, this answer didn't help": [
  "No, esta respuesta no ayudó",
  "Hindi, hindi nakatulong ang sagot na ito"
 ],
 "Not really": [
  "No mucho",
  "Hindi masyado"
 ],
 "Coach Assistant": [
  "Asistente del Instructor",
  "Coach Assistant"
 ],
 "Answers pulled locally from the SplashPad Coach Handbook — no data leaves your browser.": [
  "Respuestas obtenidas localmente del Manual del Instructor de SplashPad — ningún dato sale de tu navegador.",
  "Mga sagot na lokal na kinuha mula sa SplashPad Coach Handbook — walang data na lumalabas sa browser mo."
 ],
 "New chat": [
  "Nuevo chat",
  "Bagong chat"
 ],
 "Quick steps": [
  "Pasos rápidos",
  "Mabilis na mga hakbang"
 ],
 "Read the full article": [
  "Leer el artículo completo",
  "Basahin ang buong artikulo"
 ],
 "Related": [
  "Relacionado",
  "Kaugnay"
 ],
 "Ask a question… (e.g. “Why does my class show 8 sessions?”)": [
  "Haz una pregunta… (p. ej. “¿Por qué mi clase muestra 8 sesiones?”)",
  "Magtanong… (hal. “Bakit 8 sessions ang ipinapakita ng klase ko?”)"
 ],
 "Enter to send · Shift+Enter for newline": [
  "Enter para enviar · Shift+Enter para salto de línea",
  "Enter para magpadala · Shift+Enter para sa bagong linya"
 ],
 "Ask": [
  "Preguntar",
  "Magtanong"
 ],
 "Try one of these": [
  "Prueba una de estas",
  "Subukan ang isa sa mga ito"
 ],
 "Let’s work this out": [
  "Resolvámoslo",
  "Ayusin natin ito"
 ],
 "Take me there": [
  "Llévame allí",
  "Dalhin mo ako roon"
 ],
 "Guide:": [
  "Guía:",
  "Gabay:"
 ],
 "Helpful": [
  "Útil",
  "Kapaki-pakinabang"
 ],
 "Not helpful": [
  "No fue útil",
  "Hindi kapaki-pakinabang"
 ],
 "Sorry about that — what was missing?": [
  "Lo sentimos por eso — ¿qué faltó?",
  "Pasensya na tungkol doon — ano ang kulang?"
 ],
 "Optional. It goes straight to the SplashPad team so we can improve the guides.": [
  "Opcional. Va directamente al equipo de SplashPad para que podamos mejorar las guías.",
  "Opsyonal. Diretso ito sa SplashPad team para mapaganda namin ang mga gabay."
 ],
 "e.g. I needed the steps for a staff coach": [
  "p. ej. Necesitaba los pasos para un instructor del personal",
  "hal. Kailangan ko ang mga hakbang para sa isang staff coach"
 ],
 "What was missing from this answer": [
  "Qué faltó en esta respuesta",
  "Ano ang kulang sa sagot na ito"
 ],
 "Skip": [
  "Omitir",
  "Laktawan"
 ],
 "Thanks — your note went to the SplashPad team.": [
  "Gracias — tu nota se envió al equipo de SplashPad.",
  "Salamat — naipadala ang note mo sa SplashPad team."
 ],
 "Paused for now": [
  "Pausado por ahora",
  "Naka-pause muna"
 ],
 "What’s the plan, Coach?": [
  "¿Cuál es el plan, Instructor?",
  "Ano ang plano, Coach?"
 ],
 "Message Splash": [
  "Enviar mensaje a Splash",
  "I-message ang Splash"
 ],
 "Please shorten your message to": [
  "Acorta tu mensaje a",
  "Pakiikli ang mensahe mo sa"
 ],
 "characters before sending.": [
  "caracteres antes de enviarlo.",
  "mga character bago ipadala."
 ],
 "Human backup: Coach WhatsApp": [
  "Respaldo humano: WhatsApp del coach",
  "Human backup: Coach WhatsApp"
 ],
 "Get": [
  "Obtén",
  "Kumuha ng"
 ],
 "× with Pro": [
  "× con Pro",
  "× sa Pro"
 ],
 "Enter to send": [
  "Enter para enviar",
  "Enter para magpadala"
 ],
 "Owner · Head coach": [
  "Propietario · Instructor principal",
  "Owner · Head coach"
 ],
 "Team coach": [
  "Instructor de equipo",
  "Team coach"
 ],
 "Your swim coach": [
  "Tu instructor de natación",
  "Iyong swim coach"
 ],
 "Register with": [
  "Regístrate con",
  "Magparehistro sa"
 ],
 "by filling out the info below — it only takes a couple of minutes.": [
  "completando la información a continuación — solo toma un par de minutos.",
  "sa pagsagot ng impormasyon sa ibaba — ilang minuto lang ito."
 ],
 "Registering with": [
  "Registro con",
  "Nagrerehistro sa"
 ],
 "SplashPad coaches": [
  "instructores de SplashPad",
  "mga SplashPad coach"
 ],
 "Find a SplashPad coach near you": [
  "Encuentra un instructor de SplashPad cerca de ti",
  "Maghanap ng SplashPad coach na malapit sa iyo"
 ],
 "Loading coaches…": [
  "Cargando instructores…",
  "Naglo-load ng mga coach…"
 ],
 "verified instructor": [
  "instructor verificado",
  "verified instructor"
 ],
 "on the platform.": [
  "en la plataforma.",
  "sa platform."
 ],
 "within ~50 miles of your search.": [
  "a ~50 millas de tu búsqueda.",
  "sa loob ng ~50 milya mula sa hinanap mo."
 ],
 "Atlanta, GA": [
  "Atlanta, GA",
  "Atlanta, GA"
 ],
 "Search a city, town, or zip code": [
  "Busca una ciudad, pueblo o código postal",
  "Maghanap ng lungsod, bayan, o zip code"
 ],
 "Reset map view": [
  "Restablecer vista del mapa",
  "I-reset ang view ng mapa"
 ],
 "No coaches on the map yet": [
  "Aún no hay instructores en el mapa",
  "Wala pang mga coach sa mapa"
 ],
 "Be the first swim instructor in your area to join SplashPad — your city will show up here so families nearby can find you.": [
  "Sé el primer instructor de natación de tu zona en unirte a SplashPad; tu ciudad aparecerá aquí para que las familias cercanas puedan encontrarte.",
  "Maging unang swim instructor sa inyong lugar na sumali sa SplashPad — lalabas dito ang lungsod mo para mahanap ka ng mga pamilyang malapit sa iyo."
 ],
 "Become a SplashPad coach": [
  "Conviértete en instructor de SplashPad",
  "Maging SplashPad coach"
 ],
 "SplashPad coach": [
  "Instructor de SplashPad",
  "SplashPad coach"
 ],
 "Visit": [
  "Visitar",
  "Bisitahin"
 ],
 "Email copied to clipboard": [
  "Correo copiado al portapapeles",
  "Nakopya na sa clipboard ang email"
 ],
 "Could not copy — select the email text manually.": [
  "No se pudo copiar; selecciona el texto del correo manualmente.",
  "Hindi makopya — piliin nang mano-mano ang text ng email."
 ],
 "Get in touch with": [
  "Ponte en contacto con",
  "Makipag-ugnayan kay"
 ],
 "Pick the channel that works for you.": [
  "Elige el canal que mejor te funcione.",
  "Piliin ang channel na pinakaangkop sa iyo."
 ],
 "usually responds within a day.": [
  "suele responder en un día.",
  "karaniwang sumasagot sa loob ng isang araw."
 ],
 "Opens your messaging app": [
  "Abre tu app de mensajería",
  "Binubuksan ang messaging app mo"
 ],
 "Open email app": [
  "Abrir app de correo",
  "Buksan ang email app"
 ],
 "\"Open email app\" only works if you have one configured. Otherwise, tap": [
  "\"Abrir app de correo\" solo funciona si tienes una configurada. Si no, toca",
  "Gagana lang ang \"Buksan ang email app\" kung may naka-configure ka na. Kung wala, i-tap ang"
 ],
 "and paste it into your inbox.": [
  "y pégalo en tu bandeja de entrada.",
  "at i-paste ito sa inbox mo."
 ],
 "This coach hasn't published a way to reach them yet. Tap": [
  "Este instructor aún no ha publicado una forma de contacto. Toca",
  "Wala pang inilalathalang paraan ng pakikipag-ugnayan ang coach na ito. I-tap ang"
 ],
 "on the main page to start the application — they'll be in touch.": [
  "en la página principal para iniciar la solicitud; se pondrá en contacto contigo.",
  "sa main page para simulan ang application — makikipag-ugnayan sila sa iyo."
 ],
 "Update payment method": [
  "Actualizar método de pago",
  "I-update ang paraan ng pagbabayad"
 ],
 "Thanks": [
  "Gracias",
  "Salamat"
 ],
 "— your payment method is all set": [
  "— tu método de pago ya está listo",
  "— ayos na ang paraan ng pagbabayad mo"
 ],
 "Your card went through on": [
  "Tu tarjeta se procesó el",
  "Pumasok ang bayad sa card mo noong"
 ],
 "and the reminder on your account is cleared. Nothing changed for your families — no further action needed.": [
  "y el recordatorio de tu cuenta se eliminó. No cambió nada para tus familias; no hace falta hacer nada más.",
  "at naalis na ang paalala sa account mo. Walang nabago para sa mga pamilya mo — wala nang kailangan gawin."
 ],
 "Dismiss welcome back card": [
  "Descartar tarjeta de bienvenida de regreso",
  "I-dismiss ang welcome back card"
 ],
 "Payment received on": [
  "Pago recibido el",
  "Natanggap ang bayad noong"
 ],
 ". Your booking page is live again, your dashboard is unlocked, and your card is on file — nothing else to do on billing.": [
  ". Tu página de reservas ya está activa otra vez, tu panel está desbloqueado y tu tarjeta está registrada; no tienes que hacer nada más con la facturación.",
  ". Live na ulit ang booking page mo, naka-unlock na ang dashboard mo, at naka-file na ang card mo — wala ka nang kailangang gawin sa billing."
 ],
 "View your page": [
  "Ver tu página",
  "Tingnan ang page mo"
 ],
 "Catch up on what's waiting for you": [
  "Ponte al día con lo que te espera",
  "Tingnan ang mga naghihintay para sa iyo"
 ],
 "Nothing piled up while you were away — you're all caught up. Dismiss this card whenever you like.": [
  "No se acumuló nada mientras no estabas; ya estás al día. Descarta esta tarjeta cuando quieras.",
  "Walang naipon habang wala ka — updated ka na sa lahat. I-dismiss ang card na ito kahit kailan mo gusto."
 ],
 "Email sign-off saved": [
  "Despedida de correo guardada",
  "Na-save ang email sign-off"
 ],
 "Branded emails": [
  "Correos con tu marca",
  "Branded emails"
 ],
 "Every email your families receive — confirmations, approvals, reminders, invoices, broadcasts — carries your logo, school name and brand color instead of SplashPad’s.": [
  "Todos los correos que reciben tus familias —confirmaciones, aprobaciones, recordatorios, facturas y comunicados— llevan tu logotipo, el nombre de tu escuela y el color de tu marca en lugar de los de SplashPad.",
  "Bawat email na natatanggap ng mga pamilya mo — confirmations, approvals, reminders, invoices, broadcasts — ay may logo mo, pangalan ng school mo, at brand color mo sa halip na sa SplashPad."
 ],
 "On Pro, every email your families receive — confirmations, approvals, reminders, invoices, broadcasts — carries your logo, school name and brand color instead of SplashPad’s.": [
  "En Pro, todos los correos que reciben tus familias —confirmaciones, aprobaciones, recordatorios, facturas y comunicados— llevan tu logotipo, el nombre de tu escuela y el color de tu marca en lugar de los de SplashPad.",
  "Sa Pro, bawat email na natatanggap ng mga pamilya mo — confirmations, approvals, reminders, invoices, broadcasts — ay may logo mo, pangalan ng school mo, at brand color mo sa halip na sa SplashPad."
 ],
 "SP": [
  "SP",
  "SP"
 ],
 "Swim lessons": [
  "Clases de natación",
  "Swim lessons"
 ],
 "by SSU": [
  "por SSU",
  "ng SSU"
 ],
 "This is how the top of every parent email looks right now.": [
  "Así es como se ve ahora la parte superior de cada correo para padres.",
  "Ganito ang hitsura ngayon ng itaas ng bawat email para sa magulang."
 ],
 "Starter emails keep the SplashPad header. Upgrade to make them yours.": [
  "Los correos del plan Starter mantienen el encabezado de SplashPad. Actualiza tu plan para personalizarlos.",
  "Sa Starter, nananatili ang SplashPad header sa mga email. Mag-upgrade para maging sa iyo ang mga ito."
 ],
 "Overview": [
  "Resumen",
  "Pangkalahatang-ideya"
 ],
 "Parent name": [
  "Nombre del padre/madre",
  "Pangalan ng magulang"
 ],
 "Emergency contact": [
  "Contacto de emergencia",
  "Pang-emergency na kontak"
 ],
 "Medical notes on file": [
  "Notas médicas archivadas",
  "Nakatala ang mga medikal na tala"
 ],
 "Enroll in a class": [
  "Inscribirse en una clase",
  "Mag-enroll sa isang klase"
 ],
 "Delete family": [
  "Eliminar familia",
  "Tanggalin ang pamilya"
 ],
 "Med auth": [
  "Autorización médica",
  "Med auth"
 ],
 "Pick a class & time for": [
  "Elige una clase y horario para",
  "Pumili ng klase at oras para kay"
 ],
 "Monthly": [
  "Mensual",
  "Buwanan"
 ],
 "Enrolling…": [
  "Inscribiendo…",
  "Nag-e-enroll…"
 ],
 "Starts today, auto-renews monthly. Need a different start or drop date? Use": [
  "Empieza hoy y se renueva automáticamente cada mes. ¿Necesitas una fecha de inicio o baja diferente? Usa",
  "Magsisimula ngayon, auto-renews buwan-buwan. Kailangan ng ibang petsa ng pagsisimula o paghinto? Gamitin ang"
 ],
 "at the top of the Enrollments tab.": [
  "en la parte superior de la pestaña Inscripciones.",
  "sa itaas ng tab na Enrollments."
 ],
 "Edit note": [
  "Editar nota",
  "I-edit ang note"
 ],
 "Add a note": [
  "Agregar una nota",
  "Magdagdag ng note"
 ],
 "notes": [
  "notas",
  "mga note"
 ],
 "Note priority level": [
  "Nivel de prioridad de la nota",
  "Antas ng priyoridad ng note"
 ],
 "e.g. Do NOT auto-charge card — call first.": [
  "p. ej., NO cobrar automáticamente a la tarjeta — llamar primero.",
  "hal. HUWAG i-auto-charge ang card — tumawag muna."
 ],
 "e.g. Prefers text messages over calls.": [
  "p. ej., Prefiere mensajes de texto en lugar de llamadas.",
  "hal. Mas gusto ang text message kaysa tawag."
 ],
 "e.g. Kids love the noodle games!": [
  "p. ej., ¡A los niños les encantan los juegos con flotadores!",
  "hal. Gustong-gusto ng mga bata ang noodle games!"
 ],
 "/500 characters": [
  "/500 caracteres",
  "/500 character"
 ],
 "— delete an old note first.": [
  "— primero elimina una nota antigua.",
  "— mag-delete muna ng lumang note."
 ],
 "Add note": [
  "Agregar nota",
  "Magdagdag ng note"
 ],
 "No notes yet": [
  "Aún no hay notas",
  "Wala pang mga note"
 ],
 "Delete note": [
  "Eliminar nota",
  "I-delete ang note"
 ],
 "Add another enrollment": [
  "Agregar otra inscripción",
  "Magdagdag ng isa pang enrollment"
 ],
 "'s": [
  "de",
  "'s"
 ],
 "No enrollments yet": [
  "Aún no hay inscripciones",
  "Wala pang enrollments"
 ],
 "Waiver signed": [
  "Exención firmada",
  "Napirmahan na ang waiver"
 ],
 "Meets": [
  "Se reúne",
  "Nagkikita"
 ],
 "Price": [
  "Precio",
  "Presyo"
 ],
 "/ mo": [
  "/ mes",
  "/ buwan"
 ],
 "/ lesson": [
  "/ lección",
  "/ lesson"
 ],
 "Booked": [
  "Reservado",
  "Naka-book"
 ],
 "Ends": [
  "Termina",
  "Nagtatapos"
 ],
 "Lessons": [
  "Lecciones",
  "Mga lesson"
 ],
 "Personal touch": [
  "Toque personal",
  "Personal na dating"
 ],
 "Sign-off line": [
  "Línea de despedida",
  "Linyang pamamaalam"
 ],
 "Appears under the message in every branded email, like you signed it.": [
  "Aparece debajo del mensaje en cada correo con tu marca, como si lo hubieras firmado.",
  "Lumalabas ito sa ilalim ng mensahe sa bawat branded na email, na parang ikaw ang lumagda rito."
 ],
 "Reply-to address": [
  "Dirección de respuesta",
  "Reply-to address"
 ],
 "coach@yourschool.com": [
  "coach@yourschool.com",
  "coach@yourschool.com"
 ],
 "When a parent hits Reply, it goes here instead of SplashPad support. Also shown in the footer as \"Questions? write to …\".": [
  "Cuando un padre pulsa Responder, va aquí en lugar de al soporte de SplashPad. También se muestra en el pie de página como \"¿Preguntas? escribe a …\".",
  "Kapag pinindot ng magulang ang Reply, dito ito mapupunta imbes na sa SplashPad support. Ipinapakita rin ito sa footer bilang \"May tanong? sumulat sa …\"."
 ],
 "Save sign-off": [
  "Guardar despedida",
  "I-save ang pamamaalam"
 ],
 "Send me a test email": [
  "Enviarme un correo de prueba",
  "Padalhan ako ng test email"
 ],
 "— check your inbox.": [
  "— revisa tu bandeja de entrada.",
  "— tingnan ang iyong inbox."
 ],
 "Email delivery log": [
  "Registro de entrega de correos",
  "Log ng paghahatid ng email"
 ],
 "Last 50 emails SplashPad has tried to send": [
  "Últimos 50 correos que SplashPad ha intentado enviar",
  "Huling 50 email na sinubukang ipadala ng SplashPad"
 ],
 "to you": [
  "a ti",
  "sa iyo"
 ],
 ". If something here says": [
  ". Si algo aquí dice",
  ". Kung may nakalagay dito na"
 ],
 ", that's your provider rejecting it (suppression list, bounce, typo). If the list is": [
  ", es tu proveedor quien lo está rechazando (lista de supresión, rebote, error tipográfico). Si la lista está",
  " , ang provider mo ang tumatanggi rito (suppression list, bounce, typo). Kung ang listahan ay"
 ],
 "empty": [
  "vacía",
  "walang laman"
 ],
 ", the email trigger never fired — let support know.": [
  ", el activador del correo nunca se activó — avisa al soporte.",
  " , hindi kailanman nag-trigger ang email trigger — ipaalam sa support."
 ],
 "sent": [
  "enviado",
  "naipadala"
 ],
 "failed": [
  "fallido",
  "nabigo"
 ],
 "older (pre-tracking)": [
  "antiguo (antes del seguimiento)",
  "mas luma (bago ang tracking)"
 ],
 "No emails have been addressed to your account yet. If you're expecting notifications (new applications, payments, etc.), the trigger that should send them isn't firing — please contact support.": [
  "Todavía no se ha dirigido ningún correo a tu cuenta. Si esperas notificaciones (nuevas solicitudes, pagos, etc.), el activador que debería enviarlas no se está activando — ponte en contacto con soporte.",
  "Wala pang mga email na na-address sa iyong account. Kung may inaasahan kang mga notification (mga bagong application, bayad, atbp.), hindi nagti-trigger ang trigger na dapat magpadala ng mga iyon — mangyaring makipag-ugnayan sa support."
 ],
 "· via": [
  "· vía",
  "· sa pamamagitan ng"
 ],
 "· id": [
  "· id",
  "· id"
 ],
 "Provider error:": [
  "Error del proveedor:",
  "Error ng provider:"
 ],
 "Couldn't mark all as read. Try again.": [
  "No se pudieron marcar todas como leídas. Inténtalo de nuevo.",
  "Hindi mamarkahan bilang nabasa ang lahat. Subukan ulit."
 ],
 "Applications and class requests": [
  "Solicitudes y solicitudes de clase",
  "Mga application at class request"
 ],
 "Applications & requests": [
  "Solicitudes y peticiones",
  "Mga application at request"
 ],
 "You're all caught up.": [
  "Ya estás al día.",
  "Ayos ka na sa lahat."
 ],
 "Mark all read": [
  "Marcar todo como leído",
  "Markahan ang lahat bilang nabasa"
 ],
 "Nothing new.": [
  "Nada nuevo.",
  "Walang bago."
 ],
 "New applications & requests": [
  "Nuevas solicitudes y peticiones",
  "Mga bagong application at request"
 ],
 "Class requests": [
  "Solicitudes de clase",
  "Mga class request"
 ],
 "wants to join": [
  "quiere unirse",
  "gustong sumali"
 ],
 "Save card on file": [
  "Guardar tarjeta registrada",
  "I-save ang card on file"
 ],
 "Enter": [
  "Ingresa los datos de la tarjeta de",
  "Ilagay ang mga detalye ng card ni"
 ],
 "'s card details.": [
  "'s card details.",
  "'s card details."
 ],
 "Stripe processes this data directly — SplashPad never sees the number.": [
  "Stripe procesa estos datos directamente; SplashPad nunca ve el número.",
  "Direktang pinoproseso ng Stripe ang datos na ito — hindi kailanman nakikita ng SplashPad ang numero."
 ],
 "Card saved to file.": [
  "Tarjeta guardada en el archivo.",
  "Naka-save na ang card sa file."
 ],
 "Read consent to the parent before submitting.": [
  "Lea el consentimiento al padre o tutor antes de enviarlo.",
  "Basahin ang pahintulot sa magulang bago isumite."
 ],
 "\"I authorize you to save this card on file and to charge it for lessons and services we've agreed to. I can review each charge in my Payments tab.\"": [
  "\"Le autorizo a guardar esta tarjeta en el archivo y a cobrarla por las clases y servicios que hayamos acordado. Puedo revisar cada cargo en mi pestaña de Pagos.\"",
  "\"Pinapahintulutan ko kayong i-save ang card na ito sa file at i-charge ito para sa mga lesson at serbisyong napagkasunduan namin. Maaari kong suriin ang bawat charge sa aking tab na Payments.\""
 ],
 "Refunding": [
  "Reembolsando",
  "Nagre-refund"
 ],
 "Enter the amount to refund and choose a destination.": [
  "Ingrese el monto a reembolsar y elija un destino.",
  "Ilagay ang halagang ire-refund at pumili ng destinasyon."
 ],
 "Amount to refund": [
  "Monto a reembolsar",
  "Halagang ire-refund"
 ],
 "Max refundable: $": [
  "Máximo reembolsable: $",
  "Pinakamataas na mare-refund: $"
 ],
 "Back to card (Stripe refund)": [
  "Volver a la tarjeta (reembolso de Stripe)",
  "Ibalik sa card (Stripe refund)"
 ],
 "Give as Coach Credit": [
  "Dar como crédito de instructor",
  "Ibigay bilang Coach Credit"
 ],
 "Reason (optional)": [
  "Motivo (opcional)",
  "Dahilan (opsyonal)"
 ],
 "e.g. Family missed the class, cancelled subscription…": [
  "p. ej., La familia faltó a la clase, canceló la suscripción…",
  "hal. Hindi nakadalo ang pamilya sa klase, kinansela ang subscription…"
 ],
 "Refund $": [
  "Reembolsar $",
  "I-refund ang $"
 ],
 "Invoice sent.": [
  "Factura enviada.",
  "Naipadala na ang invoice."
 ],
 "Emailing": [
  "Enviando correo",
  "Nag-e-email"
 ],
 "e.g. Invoice for June lessons": [
  "p. ej., Factura de las clases de junio",
  "hal. Invoice para sa mga lesson sa Hunyo"
 ],
 "Leave blank to send a memo (no pay-now button).": [
  "Déjelo en blanco para enviar una nota (sin botón de pagar ahora).",
  "Iwanang blangko para magpadala ng memo (walang pay-now button)."
 ],
 "Add anything you want the parent to see in the email…": [
  "Agregue cualquier cosa que quiera que el padre o tutor vea en el correo electrónico…",
  "Magdagdag ng anumang gusto mong makita ng magulang sa email…"
 ],
 "Not on file": [
  "No está en el archivo",
  "Wala sa file"
 ],
 "Marked as paid.": [
  "Marcado como pagado.",
  "Minarkahan bilang bayad."
 ],
 "Missing application record — open 'Enroll in a class' to fix.": [
  "Falta el registro de la solicitud; abra 'Inscribirse en una clase' para solucionarlo.",
  "Nawawala ang application record — buksan ang 'Enroll in a class' para ayusin."
 ],
 "Credit voided.": [
  "Crédito anulado.",
  "Na-void ang credit."
 ],
 "Enrollment dropped. Parent notified.": [
  "Inscripción cancelada. Se notificó al padre o tutor.",
  "Inalis ang enrollment. Naabisuhan ang magulang."
 ],
 "Enrollment deleted.": [
  "Inscripción eliminada.",
  "Na-delete ang enrollment."
 ],
 "Student removed.": [
  "Estudiante eliminado.",
  "Inalis ang estudyante."
 ],
 "Note cannot be empty.": [
  "La nota no puede estar vacía.",
  "Hindi maaaring walang laman ang note."
 ],
 "Note updated.": [
  "Nota actualizada.",
  "Na-update ang note."
 ],
 "Note added.": [
  "Nota agregada.",
  "Naidagdag ang note."
 ],
 "Note deleted.": [
  "Nota eliminada.",
  "Na-delete ang note."
 ],
 "lifetime": [
  "de por vida",
  "lifetime"
 ],
 "Lifetime value per family is included with SplashPad Pro": [
  "El valor de por vida por familia está incluido con SplashPad Pro",
  "Kasama sa SplashPad Pro ang lifetime value bawat pamilya"
 ],
 "Lifetime value · Pro": [
  "Valor de por vida · Pro",
  "Lifetime value · Pro"
 ],
 "Everything you need to service this family in one place — contact info, students, class history, and payments.": [
  "Todo lo que necesita para atender a esta familia en un solo lugar: información de contacto, estudiantes, historial de clases y pagos.",
  "Lahat ng kailangan mo para asikasuhin ang pamilyang ito sa isang lugar — contact info, mga estudyante, class history, at payments."
 ],
 "Loading family details…": [
  "Cargando detalles de la familia…",
  "Nilo-load ang mga detalye ng pamilya…"
 ],
 "Couldn't load this family.": [
  "No se pudieron cargar los datos de esta familia.",
  "Hindi ma-load ang pamilyang ito."
 ],
 "Signed by": [
  "Firmado por",
  "Nilagdaan ni"
 ],
 "Invoice": [
  "Factura",
  "Invoice"
 ],
 "Dropping…": [
  "Dando de baja…",
  "Dina-drop…"
 ],
 "Delete enrollment": [
  "Eliminar inscripción",
  "Tanggalin ang enrollment"
 ],
 "No attendance yet": [
  "Aún no hay asistencia",
  "Wala pang attendance"
 ],
 "Connect Stripe in Billing to save + charge cards.": [
  "Conecta Stripe en Facturación para guardar y cobrar tarjetas.",
  "Ikonekta ang Stripe sa Billing para makapag-save at makasingil ng cards."
 ],
 "No card on file.": [
  "No hay ninguna tarjeta registrada.",
  "Walang card na naka-file."
 ],
 "Save one to charge": [
  "Guarda una para cobrar",
  "Mag-save ng isa para masingil"
 ],
 "without waiting on an invoice.": [
  "sin esperar una factura.",
  "nang hindi naghihintay ng invoice."
 ],
 "Enter now (over the phone)": [
  "Ingresar ahora (por teléfono)",
  "Ilagay ngayon (sa telepono)"
 ],
 "Send secure link": [
  "Enviar enlace seguro",
  "Magpadala ng secure na link"
 ],
 "Charge this card": [
  "Cobrar esta tarjeta",
  "Singilin ang card na ito"
 ],
 "Send invoice instead": [
  "Enviar factura en su lugar",
  "Invoice na lang ang ipadala"
 ],
 "Coach credit balance": [
  "Saldo de crédito del instructor",
  "Balanse ng coach credit"
 ],
 "Grant credit": [
  "Otorgar crédito",
  "Magbigay ng credit"
 ],
 "Credit history": [
  "Historial de crédito",
  "Kasaysayan ng credit"
 ],
 "Void": [
  "Anular",
  "I-void"
 ],
 "Voided": [
  "Anulada",
  "Na-void"
 ],
 "No invoices": [
  "No hay facturas",
  "Walang invoices"
 ],
 "Payments received": [
  "Pagos recibidos",
  "Mga natanggap na bayad"
 ],
 "· not attached to an enrollment": [
  "· no adjunto a una inscripción",
  "· hindi naka-attach sa isang enrollment"
 ],
 "Attach to enrollment": [
  "Adjuntar a la inscripción",
  "I-attach sa enrollment"
 ],
 "Attach this payment to": [
  "Adjuntar este pago a",
  "I-attach ang bayad na ito sa"
 ],
 "Choose an enrollment…": [
  "Elige una inscripción…",
  "Pumili ng enrollment…"
 ],
 "The enrollment will be marked as paid.": [
  "La inscripción se marcará como pagada.",
  "Mamarkahan ang enrollment bilang bayad."
 ],
 "This permanently removes the family from": [
  "Esto elimina permanentemente a la familia de",
  "Permanente nitong inaalis ang pamilya sa"
 ],
 "SplashPad:": [
  "SplashPad:",
  "SplashPad:"
 ],
 "Their application, enrollments, lessons, waivers, notes and credits with you are deleted.": [
  "Se eliminan su solicitud, inscripciones, clases, exenciones, notas y créditos contigo.",
  "Mabubura ang kanilang application, enrollments, lessons, waivers, notes, at credits sa iyo."
 ],
 "They lose access to your Parent Portal and booking page immediately.": [
  "Pierden acceso a tu Portal para Padres y página de reservas de inmediato.",
  "Mawawalan sila agad ng access sa iyong Parent Portal at booking page."
 ],
 "Paid invoices and payments are kept, anonymized, for your accounting.": [
  "Las facturas pagadas y los pagos se conservan, anonimizados, para tu contabilidad.",
  "Ang mga bayad na invoice at payments ay pananatilihin, naka-anonymize, para sa iyong accounting."
 ],
 "This can't be undone. Prefer dropping an enrollment if you just want them out of one class.": [
  "Esto no se puede deshacer. Es mejor dar de baja una inscripción si solo quieres sacarlos de una clase.",
  "Hindi na ito maa-undo. Mas mabuting i-drop ang isang enrollment kung gusto mo lang silang alisin sa isang klase."
 ],
 "DELETE": [
  "ELIMINAR",
  "DELETE"
 ],
 "Void this credit?": [
  "¿Anular este crédito?",
  "I-void ang credit na ito?"
 ],
 "Voiding the": [
  "Anular el",
  "Ang pag-void sa"
 ],
 "will drop": [
  "dará de baja",
  "ay magda-drop"
 ],
 "Account scan ·": [
  "Escaneo de cuenta ·",
  "Pag-scan ng account ·"
 ],
 "thing": [
  "elemento",
  "bagay"
 ],
 "to check": [
  "para revisar",
  "susuriin"
 ],
 "Updated": [
  "Actualizado",
  "Na-update"
 ],
 "Setting updated": [
  "Configuración actualizada",
  "Na-update ang setting"
 ],
 "Coach Knowledge Base downloaded": [
  "Base de conocimientos para instructores descargada",
  "Na-download ang Coach Knowledge Base"
 ],
 "Couldn't download the knowledge base. Try again?": [
  "No se pudo descargar la base de conocimientos. ¿Intentar de nuevo?",
  "Hindi ma-download ang knowledge base. Subukan ulit?"
 ],
 "Help Center": [
  "Centro de ayuda",
  "Help Center"
 ],
 "Last updated:": [
  "Última actualización:",
  "Huling na-update:"
 ],
 "Back to all categories": [
  "Volver a todas las categorías",
  "Bumalik sa lahat ng category"
 ],
 "No articles found for": [
  "No se encontraron artículos para",
  "Walang nahanap na article para sa"
 ],
 "article": [
  "artículo",
  "article"
 ],
 "Try different keywords, or browse by category below.": [
  "Prueba con otras palabras clave o explora por categoría a continuación.",
  "Subukan ang ibang keyword, o mag-browse ayon sa category sa ibaba."
 ],
 "Browse by topic": [
  "Explorar por tema",
  "Mag-browse ayon sa paksa"
 ],
 "Popular articles": [
  "Artículos populares",
  "Mga sikat na article"
 ],
 "Take the Coach Knowledge Base with you": [
  "Lleva contigo la base de conocimientos para instructores",
  "Dalhin ang Coach Knowledge Base saan ka man magpunta"
 ],
 "Download the full coach handbook as a single Markdown file. Drop it into Claude Projects, a Custom GPT, or any other AI tool as reference material and it'll answer every question this Help Center answers.": [
  "Descarga el manual completo para instructores como un solo archivo Markdown. Súbelo a Claude Projects, un GPT personalizado o cualquier otra herramienta de IA como material de referencia, y responderá cualquier pregunta que responda este Centro de ayuda.",
  "I-download ang buong coach handbook bilang isang Markdown file. Ilagay ito sa Claude Projects, isang Custom GPT, o anumang iba pang AI tool bilang reference material at sasagutin nito ang bawat tanong na sinasagot ng Help Center na ito."
 ],
 "Download .md": [
  "Descargar .md",
  "I-download ang .md"
 ],
 "Search — try “stripe”, “sessions doubled”, “can’t pay”…": [
  "Buscar — prueba con “stripe”, “sessions doubled”, “can’t pay”…",
  "Maghanap — subukan ang “stripe”, “sessions doubled”, “can’t pay”…"
 ],
 "Close help": [
  "Cerrar ayuda",
  "Isara ang help"
 ],
 "What can we help you with?": [
  "¿En qué podemos ayudarte?",
  "Paano ka namin matutulungan?"
 ],
 "Search the coach handbook…": [
  "Busca en el manual para instructores…",
  "Hanapin sa coach handbook…"
 ],
 "Try asking": [
  "Prueba preguntando",
  "Subukang itanong"
 ],
 "Type a question above and we'll pull up the article that answers it.": [
  "Escribe una pregunta arriba y mostraremos el artículo que la responde.",
  "Mag-type ng tanong sa itaas at ilalabas namin ang article na sasagot dito."
 ],
 "No articles matched": [
  "No hubo artículos coincidentes",
  "Walang tumugmang article"
 ],
 "Try different keywords — or use the button below to get a live reply.": [
  "Prueba con otras palabras clave o usa el botón de abajo para obtener una respuesta en vivo.",
  "Subukan ang ibang keyword — o gamitin ang button sa ibaba para makakuha ng live na sagot."
 ],
 "match": [
  "coincidencia",
  "tugma"
 ],
 "Pause video": [
  "Pausar video",
  "I-pause ang video"
 ],
 "Play video": [
  "Reproducir video",
  "I-play ang video"
 ],
 "Unmute video": [
  "Activar sonido del video",
  "I-unmute ang video"
 ],
 "Mute video": [
  "Silenciar video",
  "I-mute ang video"
 ],
 "Tap for sound": [
  "Toca para activar el sonido",
  "I-tap para sa tunog"
 ],
 "Sound on": [
  "Sonido activado",
  "Naka-on ang tunog"
 ],
 "Could not read the crop region — try moving it slightly.": [
  "No se pudo leer el área de recorte; intenta moverla un poco.",
  "Hindi mabasa ang crop region — subukang galawin ito nang kaunti."
 ],
 "Could not save your crop. Try a smaller image or a different photo.": [
  "No se pudo guardar el recorte. Prueba con una imagen más pequeña o con otra foto.",
  "Hindi ma-save ang iyong crop. Subukan ang mas maliit na image o ibang photo."
 ],
 "Zoom": [
  "Zoom",
  "Zoom"
 ],
 "Rotate": [
  "Girar",
  "I-rotate"
 ],
 "Lock to": [
  "Bloquear a",
  "I-lock sa"
 ],
 "Currently free-cropping any rectangle.": [
  "Actualmente puedes recortar libremente cualquier rectángulo.",
  "Kasalukuyang puwedeng mag-free-crop ng anumang parihaba."
 ],
 "Apply crop": [
  "Aplicar recorte",
  "I-apply ang crop"
 ],
 "Uploaded!": [
  "¡Subido!",
  "Na-upload na!"
 ],
 "Uploading…": [
  "Subiendo…",
  "Ina-upload…"
 ],
 "Camera": [
  "Cámara",
  "Camera"
 ],
 "Crop": [
  "Recortar",
  "Crop"
 ],
 "PNG, JPG, WebP or GIF, up to": [
  "PNG, JPG, WebP o GIF, hasta",
  "PNG, JPG, WebP o GIF, hanggang"
 ],
 "MB.": [
  "MB.",
  "MB."
 ],
 "Recommended:": [
  "Recomendado:",
  "Inirerekomenda:"
 ],
 "px.": [
  "px.",
  "px."
 ],
 "SplashPad is installed on this device.": [
  "SplashPad está instalado en este dispositivo.",
  "Naka-install ang SplashPad sa device na ito."
 ],
 "Open it from your home screen or app list. You’re using the same account.": [
  "Ábrelo desde tu pantalla de inicio o lista de aplicaciones. Estás usando la misma cuenta.",
  "Buksan ito mula sa iyong home screen o listahan ng app. Pareho ang account na ginagamit mo."
 ],
 "Install on this device": [
  "Instalar en este dispositivo",
  "I-install sa device na ito"
 ],
 "Your browser accepted the request. Follow its prompts to finish installation.": [
  "Tu navegador aceptó la solicitud. Sigue sus indicaciones para completar la instalación.",
  "Tinanggap ng browser mo ang kahilingan. Sundin ang mga prompt nito para matapos ang pag-install."
 ],
 "Not installed—you dismissed the prompt. You can install later or keep using the browser.": [
  "No está instalado: descartaste el aviso. Puedes instalarlo más tarde o seguir usando el navegador.",
  "Hindi naka-install—na-dismiss mo ang prompt. Maaari mo itong i-install mamaya o ipagpatuloy ang paggamit ng browser."
 ],
 "Automatic installation isn’t available right now. Use the steps below, or continue in your browser.": [
  "La instalación automática no está disponible en este momento. Usa los pasos a continuación o sigue en tu navegador.",
  "Hindi available ang awtomatikong pag-install sa ngayon. Gamitin ang mga hakbang sa ibaba, o magpatuloy sa iyong browser."
 ],
 "Installation instructions by device": [
  "Instrucciones de instalación por dispositivo",
  "Mga tagubilin sa pag-install ayon sa device"
 ],
 "iPhone / iPad": [
  "iPhone / iPad",
  "iPhone / iPad"
 ],
 "Android": [
  "Android",
  "Android"
 ],
 "Computer": [
  "Computadora",
  "Computer"
 ],
 "Installing is optional—you can do it later from your dashboard.": [
  "La instalación es opcional; puedes hacerlo más tarde desde tu panel.",
  "Opsyonal ang pag-install—magagawa mo ito mamaya mula sa iyong dashboard."
 ],
 "Your browser accepted the install request. Follow its prompts to finish.": [
  "Tu navegador aceptó la solicitud de instalación. Sigue sus indicaciones para completarla.",
  "Tinanggap ng browser mo ang kahilingan sa pag-install. Sundin ang mga prompt nito para matapos."
 ],
 "Look for Install app in Chrome or Edge, or File → Add to Dock in Safari on Mac. You can also keep using SplashPad in your browser.": [
  "Busca Instalar aplicación en Chrome o Edge, o Archivo → Añadir al Dock en Safari en Mac. También puedes seguir usando SplashPad en tu navegador.",
  "Hanapin ang Install app sa Chrome o Edge, o File → Add to Dock sa Safari sa Mac. Maaari mo ring ipagpatuloy ang paggamit ng SplashPad sa browser mo."
 ],
 "Install app": [
  "Instalar aplicación",
  "I-install ang app"
 ],
 "NEW": [
  "NUEVO",
  "BAGO"
 ],
 "Dismiss install prompt": [
  "Descartar aviso de instalación",
  "I-dismiss ang install prompt"
 ],
 "Install SplashPad on your phone": [
  "Instala SplashPad en tu teléfono",
  "I-install ang SplashPad sa iyong phone"
 ],
 "Add SplashPad to your home screen for a full-screen, native app feel — with your business logo as the icon, faster loads, and offline access to today's schedule.": [
  "Añade SplashPad a tu pantalla de inicio para disfrutar de una experiencia de aplicación nativa a pantalla completa, con el logotipo de tu negocio como icono, cargas más rápidas y acceso sin conexión al horario de hoy.",
  "Idagdag ang SplashPad sa iyong home screen para sa full-screen, native app na pakiramdam — kasama ang logo ng negosyo mo bilang icon, mas mabilis na pag-load, at offline access sa iskedyul ngayong araw."
 ],
 "How to install": [
  "Cómo instalar",
  "Paano mag-install"
 ],
 "Add SplashPad to your iPhone": [
  "Añade SplashPad a tu iPhone",
  "Idagdag ang SplashPad sa iyong iPhone"
 ],
 "Apple doesn't allow one-tap install on iPhone/iPad. Follow these two steps in Safari and you'll get a full-screen SplashPad icon on your home screen.": [
  "Apple no permite la instalación con un solo toque en iPhone/iPad. Sigue estos dos pasos en Safari y tendrás un icono de SplashPad a pantalla completa en tu pantalla de inicio.",
  "Hindi pinapayagan ng Apple ang one-tap install sa iPhone/iPad. Sundin ang dalawang hakbang na ito sa Safari at magkakaroon ka ng full-screen na SplashPad icon sa iyong home screen."
 ],
 "Tap the": [
  "Toca el",
  "I-tap ang"
 ],
 "Payment received — thanks!": [
  "Pago recibido — ¡gracias!",
  "Natanggap ang bayad — salamat!"
 ],
 "This invoice is already paid": [
  "Esta factura ya está pagada",
  "Bayad na ang invoice na ito"
 ],
 "Couldn't nudge anyone — check that these families have an email or phone on file.": [
  "No se pudo recordar a nadie — verifica que estas familias tengan un correo electrónico o teléfono registrado.",
  "Walang ma-follow up na kahit sino — tingnan kung may email o phone na naka-file ang mga pamilyang ito."
 ],
 "Restored — the lead is active again and back in your follow-up queue.": [
  "Restaurado — el prospecto está activo de nuevo y volvió a tu cola de seguimiento.",
  "Naibalik — aktibo ulit ang lead at bumalik sa iyong follow-up queue."
 ],
 "This lead is already active.": [
  "Este prospecto ya está activo.",
  "Aktibo na ang lead na ito."
 ],
 "Nothing to restore — you have no abandoned leads.": [
  "Nada que restaurar — no tienes prospectos abandonados.",
  "Walang maibabalik — wala kang abandoned leads."
 ],
 "Could not restore any leads. Try again.": [
  "No se pudo restaurar ningún prospecto. Inténtalo de nuevo.",
  "Walang lead na naibalik. Subukan ulit."
 ],
 "Removed from your leads inbox.": [
  "Eliminado de tu bandeja de entrada de prospectos.",
  "Inalis sa iyong leads inbox."
 ],
 "Follow-up inbox": [
  "Bandeja de seguimiento",
  "Follow-up inbox"
 ],
 "Everyone who started signing up but hasn't finished — plus anyone the auto-sweep already tidied up.": [
  "Todos los que empezaron a registrarse pero no terminaron, además de quienes la limpieza automática ya ordenó.",
  "Lahat ng nagsimulang mag-sign up pero hindi nagtapos — pati ang sinumang nalinis na ng auto-sweep."
 ],
 "Restore all": [
  "Restaurar todo",
  "Ibalik lahat"
 ],
 "lead": [
  "prospecto",
  "lead"
 ],
 "leads": [
  "prospectos",
  "leads"
 ],
 "Nudge": [
  "Recordar",
  "Follow up"
 ],
 "Search parent, kid, email…": [
  "Buscar padre, niño, correo electrónico…",
  "Maghanap ng magulang, bata, email…"
 ],
 "active ·": [
  "activo ·",
  "aktibo ·"
 ],
 "swept": [
  "depurado",
  "na-sweep"
 ],
 "Loading your leads…": [
  "Cargando tus prospectos…",
  "Nilo-load ang iyong leads…"
 ],
 "No leads match those filters.": [
  "Ningún prospecto coincide con esos filtros.",
  "Walang leads na tumutugma sa mga filter na iyon."
 ],
 "When a parent starts a signup but doesn’t finish, they’ll show up here so you can nudge or clear them.": [
  "Cuando un padre comienza un registro pero no lo termina, aparecerá aquí para que puedas recordarle o descartarlo.",
  "Kapag nagsimula ang magulang ng signup pero hindi ito natapos, lalabas sila rito para ma-follow up mo o ma-clear."
 ],
 "Try clearing the search or picking a different status.": [
  "Intenta borrar la búsqueda o elegir un estado diferente.",
  "Subukang i-clear ang search o pumili ng ibang status."
 ],
 "Select all visible leads": [
  "Seleccionar todos los prospectos visibles",
  "Piliin lahat ng nakikitang leads"
 ],
 "Started": [
  "Empezó",
  "Nagsimula"
 ],
 "Started Stripe checkout at least once": [
  "Inició el pago de Stripe al menos una vez",
  "Nagsimula ng Stripe checkout kahit isang beses"
 ],
 "Started Stripe": [
  "Empezó Stripe",
  "Nagsimula ng Stripe"
 ],
 "Cart left behind ·": [
  "Carrito abandonado ·",
  "Iniwang cart ·"
 ],
 "item": [
  "artículo",
  "item"
 ],
 "due today": [
  "vence hoy",
  "due today"
 ],
 "More lead actions": [
  "Más acciones del prospecto",
  "Higit pang lead actions"
 ],
 "Lead actions": [
  "Acciones del prospecto",
  "Lead actions"
 ],
 "Restore to active": [
  "Restaurar a activo",
  "Ibalik sa active"
 ],
 "Dismiss this lead?": [
  "¿Descartar este prospecto?",
  "I-dismiss ang lead na ito?"
 ],
 "from your leads inbox.": [
  "de tu bandeja de entrada de prospectos.",
  "mula sa iyong leads inbox."
 ],
 "We": [
  "Nosotros",
  "Kami"
 ],
 ". The record stays in your history but is hidden from view. You can always restore them later.": [
  ". El registro permanece en tu historial, pero queda oculto de la vista. Siempre puedes restaurarlo más tarde.",
  ". Mananatili ang record sa iyong history pero nakatago sa view. Maaari mo silang ibalik anumang oras sa ibang pagkakataon."
 ],
 "Share icon": [
  "Icono para compartir",
  "Share icon"
 ],
 "It's the little box with an arrow, at the bottom of Safari on iPhone or at the top-right on iPad.": [
  "Es el cuadrito con una flecha, en la parte inferior de Safari en iPhone o en la esquina superior derecha en iPad.",
  "Ito ang maliit na kahon na may arrow, sa ibaba ng Safari sa iPhone o sa kanang itaas sa iPad."
 ],
 "Choose": [
  "Elige",
  "Piliin"
 ],
 "“Add to Home Screen”": [
  "“Agregar a pantalla de inicio”",
  "“Add to Home Screen”"
 ],
 "You may need to scroll down in the share sheet. Then tap": [
  "Puede que tengas que desplazarte hacia abajo en la hoja para compartir. Luego toca",
  "Maaaring kailanganin mong mag-scroll pababa sa share sheet. Pagkatapos, i-tap ang"
 ],
 "in the top-right and SplashPad will land on your home screen.": [
  "en la esquina superior derecha y SplashPad aparecerá en tu pantalla de inicio.",
  "sa kanang itaas at lalabas ang SplashPad sa iyong home screen."
 ],
 "Tip:": [
  "Consejo:",
  "Tip:"
 ],
 "Open SplashPad from your home-screen icon after installing — that's the “full-screen” native experience with your logo as the icon and no Safari address bar.": [
  "Abre SplashPad desde el icono de tu pantalla de inicio después de instalarlo; esa es la experiencia nativa de “pantalla completa”, con tu logotipo como icono y sin la barra de direcciones de Safari.",
  "Buksan ang SplashPad mula sa icon sa iyong home screen pagkatapos i-install — iyon ang “full-screen” na native na karanasan na ang logo mo ang icon at walang address bar ng Safari."
 ],
 "Changed your logo later?": [
  "¿Cambiaste tu logotipo después?",
  "Pinalitan mo ba ang logo mo pagkatapos?"
 ],
 "iPhone/iPad keep the icon from the day you installed. Remove the app from your home screen and add it again to pick up the new one.": [
  "iPhone/iPad conserva el icono del día en que lo instalaste. Elimina la app de tu pantalla de inicio y agrégala de nuevo para que aparezca la nueva.",
  "Pinapanatili ng iPhone/iPad ang icon mula sa araw na in-install mo ito. Alisin ang app sa iyong home screen at idagdag itong muli para lumabas ang bago."
 ],
 "Got it": [
  "Entendido",
  "Nakuha ko"
 ],
 "Meet Splash, your superhero sidekick": [
  "Conoce a Splash, tu compañero superhéroe",
  "Kilalanin si Splash, ang superhero mong sidekick"
 ],
 "Dismiss onboarding tip": [
  "Descartar consejo de introducción",
  "I-dismiss ang onboarding tip"
 ],
 "Meet your sidekick": [
  "Conoce a tu compañero",
  "Kilalanin ang sidekick mo"
 ],
 "You coach the swimmers. I’ll help with the how-tos, ideas, and private notes. Tap": [
  "Tú instruyes a los nadadores. Yo te ayudaré con instrucciones, ideas y notas privadas. Toca",
  "Ikaw ang nagko-coach sa mga swimmer. Tutulungan kita sa mga how-to, ideya, at pribadong note. I-tap ang"
 ],
 "Ask Splash": [
  "Preguntar a Splash",
  "Ask Splash"
 ],
 "whenever you need a hand.": [
  "siempre que necesites ayuda.",
  "kapag kailangan mo ng tulong."
 ],
 "Say hi to Splash": [
  "Saluda a Splash",
  "Batiin si Splash"
 ],
 "Ask Splash, your superhero sidekick": [
  "Pregúntale a Splash, tu compañero superhéroe",
  "Tanungin si Splash, ang superhero mong sidekick"
 ],
 "Your coach sidekick": [
  "Tu compañero instructor",
  "Ang coach mong sidekick"
 ],
 "Payment isn't available right now. Reach out to your coach so they can resend the invoice.": [
  "El pago no está disponible en este momento. Ponte en contacto con tu instructor para que pueda reenviarte la factura.",
  "Hindi available ang pagbabayad ngayon. Makipag-ugnayan sa coach mo para maipadala niyang muli ang invoice."
 ],
 "Invoice from your coach": [
  "Factura de tu instructor",
  "Invoice mula sa coach mo"
 ],
 "— you saved": [
  "— ahorraste",
  "— nakatipid ka ng"
 ],
 "Due": [
  "Vence",
  "Due"
 ],
 "in your parent portal.": [
  "en tu portal para padres.",
  "sa iyong parent portal."
 ],
 "Payment received — don't pay again": [
  "Pago recibido — no vuelvas a pagar",
  "Natanggap na ang bayad — huwag nang magbayad ulit"
 ],
 "You're paying another way": [
  "Vas a pagar de otra forma",
  "Magbabayad ka sa ibang paraan"
 ],
 "Send your payment to": [
  "Envía tu pago a",
  "Ipadala ang bayad mo sa"
 ],
 "using the details below. They'll confirm once it arrives — until then this stays pending.": [
  "usando los datos a continuación. Te confirmarán cuando llegue; hasta entonces, esto seguirá pendiente.",
  "gamit ang mga detalye sa ibaba. Kukumpirmahin nila kapag natanggap na ito — hanggang noon, mananatili itong pending."
 ],
 "Changed your mind? You can still pay by card above.": [
  "¿Cambiaste de opinión? Todavía puedes pagar con tarjeta arriba.",
  "Nagbago ang isip mo? Maaari ka pa ring magbayad gamit ang card sa itaas."
 ],
 "off applied": [
  "de descuento aplicado",
  "na diskwento ang nailapat"
 ],
 "Have a discount code?": [
  "¿Tienes un código de descuento?",
  "May discount code ka ba?"
 ],
 "ENTER CODE": [
  "INTRODUCIR CÓDIGO",
  "ILAGAY ANG CODE"
 ],
 "Card payment isn't available right now": [
  "El pago con tarjeta no está disponible en este momento",
  "Hindi available ang bayad gamit ang card ngayon"
 ],
 "Your coach hasn't finished connecting their payment account yet. If they sent you a discount code that covers this invoice in full, you can still apply it below.": [
  "Tu instructor aún no ha terminado de conectar su cuenta de pago. Si te envió un código de descuento que cubre esta factura por completo, aún puedes aplicarlo abajo.",
  "Hindi pa tapos ang coach mo sa pag-connect ng kanilang payment account. Kung nagpadala sila sa iyo ng discount code na sasagot nang buo sa invoice na ito, maaari mo pa rin itong i-apply sa ibaba."
 ],
 "Restore every abandoned lead?": [
  "¿Restaurar todos los prospectos abandonados?",
  "Ibalik ang lahat ng na-abandonang lead?"
 ],
 "This moves": [
  "Esto mueve",
  "Ililipat nito"
 ],
 "— everyone currently marked": [
  "— a todos los que actualmente están marcados como",
  "— ang lahat ng kasalukuyang naka-mark na"
 ],
 "“didn’t finish checkout”": [
  "“no completaron el proceso de pago”",
  "“hindi natapos ang checkout”"
 ],
 "dismissed": [
  "descartados",
  "na-dismiss"
 ],
 "— back to your active follow-up queue. Parents will be able to sign up for classes again. We": [
  "— de vuelta a tu cola activa de seguimiento. Los padres podrán volver a inscribirse en clases. No",
  "— pabalik sa iyong aktibong follow-up queue. Makakapag-sign up muli ang mga magulang para sa mga klase. Hindi kami"
 ],
 "won’t": [
  "no",
  "hindi"
 ],
 "email them automatically, and no one gets charged.": [
  "les enviaremos correos automáticamente y no se le cobrará a nadie.",
  "mag-e-email sa kanila nang awtomatiko, at walang sisingilin kaninuman."
 ],
 "Restoring": [
  "Restaurando",
  "Ibinabalik"
 ],
 "Restore": [
  "Restaurar",
  "Ibalik"
 ],
 "Thanks! You’re all set.": [
  "¡Gracias! Todo está listo.",
  "Salamat! Handa ka na."
 ],
 "One quick thing before you dive in": [
  "Una cosa rápida antes de empezar",
  "Isang mabilis na bagay bago ka magsimula"
 ],
 "Quick housekeeping": [
  "Asunto administrativo rápido",
  "Mabilis na paalala"
 ],
 "Please accept our Terms of Service and Privacy Policy to continue.": [
  "Acepta nuestros Términos de servicio y la Política de privacidad para continuar.",
  "Pakitanggap ang aming Mga Tuntunin ng Serbisyo at Patakaran sa Privacy upang magpatuloy."
 ],
 "We’ve updated our Terms of Service and Privacy Policy. Please accept them to continue.": [
  "Hemos actualizado nuestros Términos de servicio y la Política de privacidad. Acéptalos para continuar.",
  "Na-update namin ang aming Mga Tuntunin ng Serbisyo at Patakaran sa Privacy. Pakitanggap ang mga ito upang magpatuloy."
 ],
 "I agree to SplashPad’s": [
  "Acepto los",
  "Sumasang-ayon ako sa"
 ],
 "(including the arbitration agreement)": [
  "(incluido el acuerdo de arbitraje)",
  "(kabilang ang kasunduan sa arbitrasyon)"
 ],
 "Agree and continue": [
  "Aceptar y continuar",
  "Sumang-ayon at magpatuloy"
 ],
 "SSA MEDIA LLC": [
  "SSA MEDIA LLC",
  "SSA MEDIA LLC"
 ],
 "Don’t agree? Sign out": [
  "¿No estás de acuerdo? Cerrar sesión",
  "Hindi sang-ayon? Mag-sign out"
 ],
 "Document version": [
  "Versión del documento",
  "Bersyon ng dokumento"
 ],
 "· effective": [
  "· en vigor",
  "· epektibo simula"
 ],
 "Accessibility": [
  "Accesibilidad",
  "Accessibility"
 ],
 "Your Privacy Choices": [
  "Tus opciones de privacidad",
  "Iyong Mga Pagpipilian sa Privacy"
 ],
 "· SplashPad is a product of SSA MEDIA LLC.": [
  "· SplashPad es un producto de SSA MEDIA LLC.",
  "· Ang SplashPad ay produkto ng SSA MEDIA LLC."
 ],
 "Blog": [
  "Blog",
  "Blog"
 ],
 "Security": [
  "Seguridad",
  "Security"
 ],
 "Couldn't check this lesson. Try again.": [
  "No se pudo confirmar esta clase. Inténtalo de nuevo.",
  "Hindi ma-check ang lesson na ito. Subukan ulit."
 ],
 "Change this lesson": [
  "Cambiar esta clase",
  "Baguhin ang lesson na ito"
 ],
 "Checking your coach's policy…": [
  "Comprobando la política de tu instructor…",
  "Tinitingnan ang patakaran ng coach mo…"
 ],
 "Your coach allows unlimited changes with": [
  "Tu instructor permite cambios ilimitados con",
  "Pinapayagan ng coach mo ang walang limitasyong pagbabago na may"
 ],
 "h notice.": [
  "h de antelación.",
  "na oras na abiso."
 ],
 "change": [
  "cambio",
  "pagbabago"
 ],
 "h notice": [
  "h de antelación",
  "na oras na abiso"
 ],
 "· moving a lesson also counts": [
  "· mover una clase también cuenta",
  "· ang paglipat ng lesson ay binibilang din"
 ],
 "'s available balance by that amount. History is kept — the row will just be marked as voided and struck through. You can't undo this from the app; to reissue, grant a fresh credit.": [
  "del saldo disponible en esa cantidad. Se conservará el historial; la fila solo se marcará como anulada y tachada. No puedes deshacer esto desde la app; para volver a emitirlo, otorga un crédito nuevo.",
  "sa available balance ng halagang iyon. Mananatili ang history — mamarkahan lang ang row bilang voided at may strikethrough. Hindi mo ito maa-undo mula sa app; para mag-isyu ulit, magbigay ng panibagong credit."
 ],
 "Voiding…": [
  "Anulando…",
  "Vino-void…"
 ],
 "Void credit": [
  "Anular crédito",
  "I-void ang credit"
 ],
 "Drop from class?": [
  "¿Dar de baja de la clase?",
  "I-drop sa class?"
 ],
 "'s enrollment in": [
  "la inscripción de",
  "ang enrollment sa"
 ],
 "will be marked as dropped today. Their Stripe subscription (if any) will be cancelled with proration so they only pay for time used, and a drop notification email will be sent to the parent. History for this enrollment is kept.": [
  "se marcará como baja hoy. Su suscripción de Stripe (si existe) se cancelará con prorrateo para que solo pague por el tiempo usado, y se enviará un correo de notificación de baja al padre o tutor. Se conserva el historial de esta inscripción.",
  "mamarkahan bilang dropped ngayong araw. Ang kanilang Stripe subscription (kung mayroon) ay ika-cancel nang may proration para oras lang na nagamit ang babayaran nila, at magpapadala ng drop notification email sa magulang. Mananatili ang history ng enrollment na ito."
 ],
 "Drop enrollment": [
  "Dar de baja la inscripción",
  "I-drop ang enrollment"
 ],
 "Delete this enrollment?": [
  "¿Eliminar esta inscripción?",
  "I-delete ang enrollment na ito?"
 ],
 "permanently remove": [
  "eliminar permanentemente",
  "permanenteng alisin"
 ],
 "the enrollment in": [
  "la inscripción en",
  "ang enrollment sa"
 ],
 "for": [
  "de",
  "para kay"
 ],
 ", along with any attendance records and waivers tied to it. Payment history is preserved for tax purposes but will no longer be linked to this enrollment.": [
  ", junto con cualquier registro de asistencia y exenciones de responsabilidad vinculados a ella. El historial de pagos se conserva por motivos fiscales, pero ya no estará vinculado a esta inscripción.",
  ", kasama ang anumang attendance records at waivers na nakaugnay dito. Ang payment history ay pananatilihin para sa tax purposes pero hindi na iuugnay sa enrollment na ito."
 ],
 "This cannot be undone.": [
  "Esto no se puede deshacer.",
  "Hindi na ito maa-undo."
 ],
 "Only do this to clean up test data or duplicate rows — for a real drop, use": [
  "Haz esto solo para limpiar datos de prueba o filas duplicadas; para una baja real, usa",
  "Gawin lang ito para maglinis ng test data o duplicate rows — para sa totoong drop, gamitin ang"
 ],
 "permanently delete": [
  "eliminar permanentemente",
  "permanenteng i-delete"
 ],
 "from the family roster, along with any attendance records the coach has logged for them. They will be removed from every enrollment they were part of.": [
  "del registro familiar, junto con cualquier registro de asistencia que el instructor haya registrado para él/ella. Se eliminará de todas las inscripciones de las que formaba parte.",
  "mula sa family roster, kasama ang anumang attendance records na na-log ng coach para sa kanila. Aalisin sila sa bawat enrollment na kinabibilangan nila."
 ],
 "Remove student": [
  "Eliminar estudiante",
  "Alisin ang estudyante"
 ],
 "Delete this note?": [
  "¿Eliminar esta nota?",
  "I-delete ang note na ito?"
 ],
 "This is a critical note.": [
  "Esta es una nota crítica.",
  "Isa itong critical na note."
 ],
 "This is a medium-priority note.": [
  "Esta es una nota de prioridad media.",
  "Isa itong medium-priority na note."
 ],
 "Once deleted, you can't undo it.": [
  "Una vez eliminada, no podrás deshacerlo.",
  "Kapag na-delete na, hindi mo na ito maa-undo."
 ],
 "Owner peek — this browser only": [
  "Vista rápida del propietario — solo en este navegador",
  "Owner peek — browser na ito lang"
 ],
 "Total:": [
  "Total:",
  "Kabuuan:"
 ],
 "Clear all": [
  "Borrar todo",
  "I-clear lahat"
 ],
 "No feedback in this browser yet. Ask the Assistant a few questions and hit 👍 or 👎 to see them appear here.": [
  "Todavía no hay comentarios en este navegador. Hazle algunas preguntas al Asistente y pulsa 👍 o 👎 para verlos aparecer aquí.",
  "Wala pang feedback sa browser na ito. Magtanong sa Assistant ng ilang tanong at pindutin ang 👍 o 👎 para makita silang lumabas dito."
 ],
 "No answer": [
  "Sin respuesta",
  "Walang sagot"
 ],
 "Matched article:": [
  "Artículo coincidente:",
  "Tumutugmang article:"
 ],
 "— (no article)": [
  "— (sin artículo)",
  "— (walang article)"
 ],
 "Open article": [
  "Abrir artículo",
  "Buksan ang article"
 ],
 "All feedback lives in this browser's localStorage. It never leaves the device. Turn this panel off with": [
  "Todos los comentarios se guardan en el localStorage de este navegador. Nunca salen del dispositivo. Desactiva este panel con",
  "Lahat ng feedback ay nasa localStorage ng browser na ito. Hindi ito umaalis sa device. I-off ang panel na ito gamit ang"
 ],
 "?feedbackpeek=off": [
  "?feedbackpeek=off",
  "?feedbackpeek=off"
 ],
 "Learn more": [
  "Más información",
  "Matuto pa"
 ],
 "Couldn't run the account scan right now.": [
  "No se pudo ejecutar el análisis de la cuenta en este momento.",
  "Hindi mapatakbo ang account scan sa ngayon."
 ],
 "Your account looks healthy": [
  "Tu cuenta se ve en buen estado",
  "Mukhang maayos ang account mo"
 ],
 "checks passed. Nice.": [
  "verificaciones aprobadas. Bien hecho.",
  "mga check ang pumasa. Ayos."
 ],
 "· moving a lesson is free": [
  "· mover una clase es gratis",
  "· libre ang paglipat ng lesson"
 ],
 "Heads up — this lesson would be lost": [
  "Atención: esta clase se perdería",
  "Paalala — mawawala ang lesson na ito"
 ],
 "I understand I won't get this lesson back": [
  "Entiendo que no recuperaré esta clase",
  "Nauunawaan ko na hindi ko na mababawi ang lesson na ito"
 ],
 "Move to another open time": [
  "Mover a otro horario disponible",
  "Ilipat sa ibang available na oras"
 ],
 "Cancel anyway (lose this lesson)": [
  "Cancelar de todos modos (perder esta clase)",
  "I-cancel pa rin (mawawala ang lesson na ito)"
 ],
 "Cancel — put the lesson back in my account": [
  "Cancelar: devolver la clase a mi cuenta",
  "I-cancel — ibalik ang lesson sa account ko"
 ],
 "Cancelling returns the lesson to your account so you can book a new time later.": [
  "Al cancelar, la clase vuelve a tu cuenta para que puedas reservar otro horario más tarde.",
  "Kapag nag-cancel, ibabalik ang lesson sa account mo para makapag-book ka ng bagong oras mamaya."
 ],
 "Counts describe lessons, not payment or refund status.": [
  "Los conteos describen clases, no el estado de pago o reembolso.",
  "Ang mga bilang ay tumutukoy sa mga lesson, hindi sa status ng bayad o refund."
 ],
 "Counts need review. Check bookings and attendance with your coach before adding lessons.": [
  "Los conteos necesitan revisión. Revisa las reservas y la asistencia con tu instructor antes de agregar clases.",
  "Kailangang suriin ang mga bilang. Suriin ang mga booking at attendance kasama ang coach mo bago magdagdag ng mga lesson."
 ],
 "Time to be confirmed": [
  "Horario por confirmar",
  "Oras na kokumpirmahin pa"
 ],
 "tap to call": [
  "toca para llamar",
  "i-tap para tumawag"
 ],
 "At your home": [
  "En tu casa",
  "Sa bahay mo"
 ],
 "No home address on file yet.": [
  "Aún no hay una dirección de domicilio registrada.",
  "Wala pang home address na naka-file."
 ],
 "travels to you.": [
  "va hasta ti.",
  "pupunta sa iyo."
 ],
 "Wrong address? Update it in your profile": [
  "¿Dirección incorrecta? Actualízala en tu perfil",
  "Maling address? I-update ito sa profile mo"
 ],
 "Location to be confirmed": [
  "Ubicación por confirmar",
  "Lokasyon na kokumpirmahin pa"
 ],
 "Ask your coach where this lesson takes place": [
  "Pregúntale a tu instructor dónde se realiza esta clase",
  "Tanungin ang coach mo kung saan gaganapin ang lesson na ito"
 ],
 "— their number is above": [
  "— su número está arriba",
  "— nasa itaas ang numero niya"
 ],
 "Cancellation reason:": [
  "Motivo de la cancelación:",
  "Dahilan ng pagkansela:"
 ],
 "Times shown in your device's time zone.": [
  "Los horarios se muestran en la zona horaria de tu dispositivo.",
  "Ipinapakita ang mga oras sa time zone ng device mo."
 ],
 "MRR re-pulled from Stripe.": [
  "MRR vuelto a obtener de Stripe.",
  "Muling nakuha ang MRR mula sa Stripe."
 ],
 "Forecast: expected next month": [
  "Pronóstico: esperado el próximo mes",
  "Forecast: inaasahan sa susunod na buwan"
 ],
 "Live from Stripe": [
  "En vivo desde Stripe",
  "Live mula sa Stripe"
 ],
 "A projection from Stripe subscriptions: what should bill next month if every card clears. Net of coupons; trials, free codes, paused and failing-card subs count as $0. Use “Revenue collected” above for real money.": [
  "Una proyección de las suscripciones de Stripe: lo que debería cobrarse el próximo mes si todas las tarjetas se aprueban. Neto de cupones; las pruebas, los códigos gratis, las suscripciones pausadas y las suscripciones con tarjetas fallidas cuentan como $0. Usa “Revenue collected” arriba para dinero real.",
  "Isang projection mula sa mga subscription sa Stripe: kung ano ang dapat ma-bill sa susunod na buwan kung papasok ang lahat ng card. Net ng mga coupon; ang mga trial, free code, naka-pause na subscription, at mga subscription na may failed na card ay binibilang bilang $0. Gamitin ang “Revenue collected” sa itaas para sa totoong pera."
 ],
 "As of": [
  "A fecha de",
  "Noong"
 ],
 "Refreshing": [
  "Actualizando",
  "Nagre-refresh"
 ],
 "Refresh from Stripe": [
  "Actualizar desde Stripe",
  "I-refresh mula sa Stripe"
 ],
 "Expected MRR": [
  "MRR esperado",
  "Inaasahang MRR"
 ],
 "Annual run rate": [
  "Tasa anual de ejecución",
  "Annual run rate"
 ],
 "Discount loss / mo": [
  "Pérdida por descuentos / mes",
  "Nawawala sa discount / buwan"
 ],
 "Paying": [
  "De pago",
  "Nagbabayad"
 ],
 "On trial": [
  "En prueba",
  "Nasa trial"
 ],
 "Free codes": [
  "Códigos gratis",
  "Mga free code"
 ],
 "Not billing": [
  "Sin facturación",
  "Hindi bina-bill"
 ],
 "MRR by plan": [
  "MRR por plan",
  "MRR ayon sa plan"
 ],
 "Active discount codes": [
  "Códigos de descuento activos",
  "Mga aktibong discount code"
 ],
 "coach(es)": [
  "instructor(es)",
  "coach(es)"
 ],
 "MRR over time": [
  "MRR a lo largo del tiempo",
  "MRR sa paglipas ng panahon"
 ],
 "Snapshots accumulate one per day. Come back tomorrow to see your first trend point — the chart fills in over time.": [
  "Las instantáneas se acumulan una por día. Vuelve mañana para ver tu primer punto de tendencia; el gráfico se irá completando con el tiempo.",
  "Nadadagdagan ang mga snapshot ng isa bawat araw. Bumalik bukas para makita ang una mong trend point — mapupunan ang chart sa paglipas ng panahon."
 ],
 "Daily motivation": [
  "Motivación diaria",
  "Araw-araw na motibasyon"
 ],
 "Daily verse": [
  "Versículo diario",
  "Araw-araw na talata"
 ],
 "Dismiss daily motivation": [
  "Descartar motivación diaria",
  "I-dismiss ang araw-araw na motibasyon"
 ],
 "Pick a date and a time.": [
  "Elige una fecha y una hora.",
  "Pumili ng petsa at oras."
 ],
 "Move just this lesson": [
  "Mover solo esta clase",
  "Ilipat lang ang lesson na ito"
 ],
 "Now": [
  "Ahora",
  "Ngayon"
 ],
 "· with": [
  "· con",
  "· kasama si"
 ],
 "Pick a new time — only free times are shown.": [
  "Elige una nueva hora; solo se muestran las horas libres.",
  "Pumili ng bagong oras — mga libreng oras lang ang ipinapakita."
 ],
 "Same day": [
  "El mismo día",
  "Parehong araw"
 ],
 "No other free time that day.": [
  "No hay otra hora libre ese día.",
  "Wala nang ibang libreng oras sa araw na iyon."
 ],
 "Nearby days": [
  "Días cercanos",
  "Mga kalapit na araw"
 ],
 "Nothing free within 3 days.": [
  "No hay nada libre dentro de 3 días.",
  "Walang libreng slot sa loob ng 3 araw."
 ],
 "This coach has no Open Schedule hours set — pick a custom time below.": [
  "Este instructor no tiene horas de Horario abierto configuradas; elige una hora personalizada abajo.",
  "Walang naka-set na Open Schedule hours ang coach na ito — pumili ng custom na oras sa ibaba."
 ],
 "Pick a custom time instead": [
  "Elegir una hora personalizada",
  "Pumili na lang ng custom na oras"
 ],
 "Review time": [
  "Revisar hora",
  "Suriin ang oras"
 ],
 "Any time works here, even outside your open hours — but never on top of another lesson or class.": [
  "Aquí funciona cualquier hora, incluso fuera de tus horas abiertas, pero nunca encima de otra lección o clase.",
  "Puwede rito ang anumang oras, kahit labas sa open hours mo — pero hindi kailanman kasabay ng ibang lesson o class."
 ],
 "All times:": [
  "Todas las horas:",
  "Lahat ng oras:"
 ],
 "Only this lesson moves. Other weekly lessons, attendance, package credits and billing stay unchanged. No charge or refund is created.": [
  "Solo se mueve esta clase. Las otras clases semanales, la asistencia, los créditos del paquete y la facturación no cambian. No se crea ningún cargo ni reembolso.",
  "Lesson na ito lang ang ililipat. Mananatiling walang pagbabago ang iba pang lingguhang lesson, attendance, package credits, at billing. Walang gagawing charge o refund."
 ],
 "A parent email will be queued after confirmation, when an email address is available.": [
  "Se pondrá en cola un correo electrónico para el padre o la madre después de la confirmación, cuando haya una dirección de correo disponible.",
  "Mai-queue ang email sa magulang pagkatapos ng kumpirmasyon, kapag may available na email address."
 ],
 "No parent email will be sent. Let the family know yourself.": [
  "No se enviará ningún correo electrónico al padre o la madre. Avísale tú mismo a la familia.",
  "Walang email na ipapadala sa magulang. Ikaw na ang magsabi sa pamilya."
 ],
 "From:": [
  "De:",
  "Mula:"
 ],
 "To:": [
  "A:",
  "Para kay:"
 ],
 "Availability is checked again when you confirm.": [
  "La disponibilidad se volverá a comprobar cuando confirmes.",
  "Susuriing muli ang availability kapag nag-confirm ka."
 ],
 "Email the parent the new time": [
  "Enviar por correo electrónico al padre o la madre la nueva hora",
  "I-email sa magulang ang bagong oras"
 ],
 "Confirm move": [
  "Confirmar cambio",
  "Kumpirmahin ang paglipat"
 ],
 "Give your camp a name so parents recognize it.": [
  "Dale un nombre a tu campamento para que los padres lo reconozcan.",
  "Pangalanan ang camp mo para makilala ito ng mga magulang."
 ],
 "Pick a start and end date for the camp.": [
  "Elige una fecha de inicio y una de finalización para el campamento.",
  "Pumili ng petsa ng simula at pagtatapos para sa camp."
 ],
 "End date must be after start date.": [
  "La fecha de finalización debe ser posterior a la fecha de inicio.",
  "Dapat mas huli ang petsa ng pagtatapos kaysa petsa ng simula."
 ],
 "Pick at least one day of the week for the camp.": [
  "Elige al menos un día de la semana para el campamento.",
  "Pumili ng kahit isang araw ng linggo para sa camp."
 ],
 "This camp has zero sessions — check your dates and weekdays.": [
  "Este campamento tiene cero sesiones; revisa las fechas y los días de la semana.",
  "Ang camp na ito ay may zero sessions — tingnan ang mga petsa at araw ng linggo."
 ],
 "Pick which location this camp runs at.": [
  "Elige en qué ubicación se realiza este campamento.",
  "Pumili kung saang lokasyon gaganapin ang camp na ito."
 ],
 "Here’s when your coach is available over the next 2 weeks. Pick a package below to lock in your spot — your lessons will be auto-scheduled at the times that match.": [
  "Aquí es cuando tu instructor está disponible durante las próximas 2 semanas. Elige un paquete abajo para asegurar tu lugar; tus clases se programarán automáticamente en los horarios que coincidan.",
  "Narito kung kailan available ang coach mo sa susunod na 2 linggo. Pumili ng package sa ibaba para maseguro ang puwesto mo — awtomatikong isi-schedule ang mga lesson mo sa mga oras na tugma."
 ],
 "Moving your lesson": [
  "Cambiar tu clase",
  "Ilipat ang lesson mo"
 ],
 "Tap the new time you want. Same length, same package": [
  "Toca la nueva hora que quieras. Misma duración, mismo paquete",
  "I-tap ang bagong oras na gusto mo. Parehong haba, parehong package"
 ],
 "— this move uses one of your allowed changes": [
  "— este cambio usa uno de tus cambios permitidos",
  "— gagamit ito ng isa sa mga pinapayagang pagbabago mo"
 ],
 "— moving is free": [
  "— cambiar es gratis",
  "— libre ang paglipat"
 ],
 "in your": [
  "en tus",
  "sa iyong"
 ],
 "packages": [
  "paquetes",
  "mga package"
 ],
 "· one lesson per day": [
  "· una clase por día",
  "· isang lesson bawat araw"
 ],
 "Times shown in your coach's local time zone. Greyed-out slots are already booked by other families.": [
  "Los horarios se muestran en la zona horaria local de tu instructor. Los horarios en gris ya están reservados por otras familias.",
  "Ipinapakita ang mga oras sa lokal na time zone ng coach mo. Ang mga naka-gray na slot ay naka-book na ng ibang mga pamilya."
 ],
 "Package lessons book instantly.": [
  "Las clases del paquete se reservan al instante.",
  "Ang mga lesson sa package ay agad na nabu-book."
 ],
 "Your spot is held while you pay.": [
  "Tu lugar se mantiene mientras pagas.",
  "Nakahawak ang puwesto mo habang nagbabayad ka."
 ],
 "None of these times work for your family?": [
  "¿Ninguno de estos horarios le funciona a tu familia?",
  "Wala bang angkop sa pamilya mo sa mga oras na ito?"
 ],
 "Move your lesson?": [
  "¿Cambiar tu clase?",
  "Ilipat ang lesson mo?"
 ],
 "This uses one of your allowed changes.": [
  "Esto usa uno de tus cambios permitidos.",
  "Gagamit ito ng isa sa mga pinapayagang pagbabago mo."
 ],
 "Keep original": [
  "Mantener original",
  "Panatilihin ang orihinal"
 ],
 "Moving…": [
  "Cambiando…",
  "Inililipat…"
 ],
 "Address saved — showing times on your coach’s route.": [
  "Dirección guardada — mostrando horarios en la ruta de tu instructor.",
  "Na-save ang address — ipinapakita ang mga oras sa ruta ng coach mo."
 ],
 "Lessons at your home": [
  "Clases en tu casa",
  "Mga lesson sa bahay mo"
 ],
 "Showing times when": [
  "Mostrando horarios cuando",
  "Ipinapakita ang mga oras kapag"
 ],
 "is already near": [
  "ya está cerca de",
  "malapit na sa"
 ],
 "time is": [
  "la hora está",
  "ang oras ay"
 ],
 "times are": [
  "los horarios están",
  "ang mga oras ay"
 ],
 "hidden because": [
  "ocultos porque",
  "nakatago dahil"
 ],
 "will be more than": [
  "estará a más de",
  "ay higit sa"
 ],
 "miles away then.": [
  "millas de distancia entonces.",
  "milya ang layo sa oras na iyon."
 ],
 "Heads up: you're about": [
  "Aviso: estás a aproximadamente",
  "Paalala: humigit-kumulang"
 ],
 "miles from": [
  "millas de",
  "milya ka mula sa"
 ],
 "'s home base, outside their usual": [
  "la base de operaciones de , fuera de su zona habitual de",
  "home base ni , lampas sa karaniwan niyang"
 ],
 "-mile area — but you can still ask.": [
  " millas, pero igual puedes preguntar.",
  "-milyang area — pero puwede ka pa ring magtanong."
 ],
 "Enter your address and we'll only show times that fit": [
  "Ingresa tu dirección y solo mostraremos horarios que encajen con",
  "Ilagay ang address mo at mga oras lang na akma sa"
 ],
 "'s driving route that day.": [
  "la ruta en auto de ese día de .",
  "ruta sa pagmamaneho ni  sa araw na iyon."
 ],
 "Change address": [
  "Cambiar dirección",
  "Palitan ang address"
 ],
 "ST": [
  "ST",
  "ST"
 ],
 "Show my times": [
  "Mostrar mis horarios",
  "Ipakita ang mga oras ko"
 ],
 "You can offer up to three times.": [
  "Puedes ofrecer hasta tres horarios.",
  "Maaari kang mag-alok ng hanggang tatlong oras."
 ],
 "Multi-day camp": [
  "Campamento de varios días",
  "Multi-day camp"
 ],
 "Skip the setup checklist — pick your date range, days, and time, and we'll generate the full session plan for you.": [
  "Omite la lista de configuración: elige tu rango de fechas, días y hora, y generaremos el plan completo de sesiones por ti.",
  "Laktawan ang setup checklist — piliin ang iyong date range, mga araw, at oras, at bubuuin namin ang buong session plan para sa iyo."
 ],
 "Camp name": [
  "Nombre del campamento",
  "Pangalan ng camp"
 ],
 "e.g. Level 3 Summer Camp — Aug 24-27": [
  "p. ej. Campamento de verano Nivel 3 — 24-27 de ago.",
  "hal. Level 3 Summer Camp — Aug 24-27"
 ],
 "Description shown to parents": [
  "Descripción visible para los padres",
  "Deskripsyong makikita ng mga magulang"
 ],
 "e.g. 4-day summer camp for Level 3 kids. Freestyle and backstroke drills, endurance work. Bring goggles, a towel, and a labeled water bottle.": [
  "p. ej. campamento de verano de 4 días para niños de Nivel 3. Ejercicios de crol y espalda, trabajo de resistencia. Traigan goggles, una toalla y una botella de agua con nombre.",
  "hal. 4-day summer camp para sa Level 3 na mga bata. Freestyle at backstroke drills, endurance work. Magdala ng goggles, tuwalya, at may-label na bote ng tubig."
 ],
 "This is the only description parents will see. Leave blank if you'd rather not have one.": [
  "Esta es la única descripción que verán los padres. Déjala en blanco si prefieres no poner una.",
  "Ito lang ang deskripsyong makikita ng mga magulang. Iwanang blangko kung mas gusto mong wala nito."
 ],
 "Total price ($)": [
  "Precio total ($)",
  "Kabuuang presyo ($)"
 ],
 "Parents pay this once, up-front, for the full camp.": [
  "Los padres pagan esto una sola vez, por adelantado, para todo el campamento.",
  "Ito ay babayaran ng mga magulang nang isang beses, upfront, para sa buong camp."
 ],
 "Duration per session (min)": [
  "Duración por sesión (min)",
  "Tagal bawat session (min)"
 ],
 "Max seats": [
  "Cupos máximos",
  "Max na slots"
 ],
 "How many kids can enroll total.": [
  "Cuántos niños pueden inscribirse en total.",
  "Ilang bata ang puwedeng mag-enroll sa kabuuan."
 ],
 "Days of the week": [
  "Días de la semana",
  "Mga araw ng linggo"
 ],
 "Pick dates and days to see the plan": [
  "Elige fechas y días para ver el plan",
  "Pumili ng mga petsa at araw para makita ang plano"
 ],
 "…and": [
  "…y",
  "…at"
 ],
 "more.": [
  "más.",
  "pa."
 ],
 "Create camp (": [
  "Crear campamento (",
  "Gumawa ng camp ("
 ],
 "Couldn't load the lesson you're moving.": [
  "No se pudo cargar la clase que estás moviendo.",
  "Hindi ma-load ang lesson na inililipat mo."
 ],
 "That time was just taken — pick another open time below.": [
  "Ese horario acaba de ocuparse; elige otro horario disponible abajo.",
  "Kaka-book lang sa oras na iyon — pumili ng ibang bakanteng oras sa ibaba."
 ],
 "Loading your coach's availability…": [
  "Cargando la disponibilidad de tu instructor…",
  "Nilo-load ang availability ng iyong coach…"
 ],
 "Availability unavailable right now": [
  "La disponibilidad no está disponible en este momento",
  "Hindi available ang availability ngayon"
 ],
 "Once you purchase a package below, your coach will reach out directly.": [
  "Una vez que compres un paquete abajo, tu instructor se pondrá en contacto contigo directamente.",
  "Kapag bumili ka ng package sa ibaba, direktang makikipag-ugnayan sa iyo ang iyong coach."
 ],
 "Choose a coach": [
  "Elige un instructor",
  "Pumili ng coach"
 ],
 "Any available coach": [
  "Cualquier instructor disponible",
  "Sinumang available na coach"
 ],
 "No open times on your coach’s route yet": [
  "Aún no hay horarios disponibles en la ruta de tu instructor",
  "Wala pang bukas na oras sa route ng iyong coach"
 ],
 "No open times in the next 2 weeks": [
  "No hay horarios disponibles en las próximas 2 semanas",
  "Walang bukas na oras sa susunod na 2 linggo"
 ],
 "Try another coach tab, or reach out below — they may have other times that work.": [
  "Prueba otra pestaña de instructor o comunícate abajo; puede que tengan otros horarios que funcionen.",
  "Subukan ang ibang tab ng coach, o makipag-ugnayan sa ibaba — baka may iba pa silang oras na puwede sa iyo."
 ],
 "Your coach hasn’t published any open slots for this window yet. Reach out below — they may have other times that work.": [
  "Tu instructor aún no ha publicado horarios disponibles para este período. Comunícate abajo; puede que tenga otros horarios que funcionen.",
  "Hindi pa nagpa-publish ang iyong coach ng anumang bukas na slot para sa window na ito. Makipag-ugnayan sa ibaba — baka may iba pa silang oras na puwede sa iyo."
 ],
 "Request lessons at my home": [
  "Solicitar clases en mi casa",
  "Humiling ng lessons sa bahay ko"
 ],
 "Open lesson times": [
  "Horarios de clases disponibles",
  "Mga bukas na oras ng lesson"
 ],
 "min slots": [
  "slots de min",
  "min slots"
 ],
 "Pick a coach (or any available coach), then tap a time — it uses one lesson from your package, no payment needed.": [
  "Elige un instructor (o cualquier instructor disponible) y luego toca un horario: usará una clase de tu paquete, sin necesidad de pago.",
  "Pumili ng coach (o anumang available na coach), pagkatapos ay i-tap ang oras — gagamit ito ng isang lesson mula sa iyong package, walang kailangang bayad."
 ],
 "Tap any open time to book it with one lesson from your package — no payment needed.": [
  "Toca cualquier horario disponible para reservarlo con una clase de tu paquete; sin necesidad de pago.",
  "I-tap ang anumang bukas na oras para i-book ito gamit ang isang lesson mula sa iyong package — walang kailangang bayad."
 ],
 "Pick a coach (or any available coach), then tap a time to book and pay in a couple of taps.": [
  "Elige un instructor (o cualquier instructor disponible) y luego toca un horario para reservar y pagar en un par de toques.",
  "Pumili ng coach (o anumang available na coach), pagkatapos ay i-tap ang oras para mag-book at magbayad sa ilang tap lang."
 ],
 "Tap any open time to book a lesson and pay in a couple of taps.": [
  "Toca cualquier horario disponible para reservar una clase y pagar en un par de toques.",
  "I-tap ang anumang bukas na oras para mag-book ng lesson at magbayad sa ilang tap lang."
 ],
 "Pick at least one time.": [
  "Elige al menos un horario.",
  "Pumili ng hindi bababa sa isang oras."
 ],
 "Offer times to": [
  "Ofrecer horarios a",
  "Mag-alok ng mga oras sa"
 ],
 "Pick up to three open times. They get an email with one-tap accept; the first family to accept a time gets it.": [
  "Elige hasta tres horarios disponibles. Recibirán un correo con aceptación en un solo toque; la primera familia que acepte un horario se lo queda.",
  "Pumili ng hanggang tatlong bukas na oras. Makakatanggap sila ng email na may one-tap na pagtanggap; ang unang pamilyang tatanggap ng oras ang makakakuha nito."
 ],
 "Lesson address:": [
  "Dirección de la clase:",
  "Address ng lesson:"
 ],
 "route-friendly": [
  "apto para la ruta",
  "route-friendly"
 ],
 "time": [
  "horario",
  "oras"
 ],
 "times": [
  "horarios",
  "mga oras"
 ],
 "(within": [
  "(a menos de",
  "(sa loob ng"
 ],
 "mi of your other lessons)": [
  "mi de tus otras clases)",
  "mi ng iba mo pang lesson)"
 ],
 "We couldn't place this address on the map, so all open times are shown.": [
  "No pudimos ubicar esta dirección en el mapa, así que se muestran todos los horarios disponibles.",
  "Hindi namin mailagay ang address na ito sa mapa, kaya lahat ng bukas na oras ay ipinapakita."
 ],
 "Route-friendly only": [
  "Solo aptos para la ruta",
  "Route-friendly lang"
 ],
 "Show all open times (": [
  "Mostrar todos los horarios disponibles (",
  "Ipakita ang lahat ng bukas na oras ("
 ],
 "No": [
  "No",
  "Wala"
 ],
 "times in the next two weeks.": [
  "horarios en las próximas dos semanas.",
  "oras sa susunod na dalawang linggo."
 ],
 "Try \"Show all open times\".": [
  "Prueba \"Mostrar todos los horarios disponibles\".",
  "Subukan ang \"Ipakita ang lahat ng bukas na oras\"."
 ],
 "Lesson length": [
  "Duración de la clase",
  "Haba ng lesson"
 ],
 "Note to the family": [
  "Nota para la familia",
  "Note para sa pamilya"
 ],
 "e.g. I'm in your neighborhood Thursdays — happy to bring kickboards!": [
  "p. ej., Estoy por su zona los jueves; ¡con gusto llevo tablas de natación!",
  "hal., Nasa neighborhood ninyo ako tuwing Huwebes — masaya akong magdala ng mga kickboard!"
 ],
 "of 3 picked": [
  "de 3 elegidos",
  "sa 3 na napili"
 ],
 "Tap times to pick them": [
  "Toca los horarios para elegirlos",
  "I-tap ang mga oras para piliin ang mga ito"
 ],
 "Send offer": [
  "Enviar oferta",
  "Ipadala ang alok"
 ],
 "New & improved tour — take 3 minutes to see what's new.": [
  "Recorrido nuevo y mejorado: tómate 3 minutos para ver las novedades.",
  "Bago at pinahusay na tour — maglaan ng 3 minuto para makita ang mga bago."
 ],
 "We just expanded the walkthrough — every sidebar section, the dashboard, Stripe setup, and a \"first 4 moves\" checklist are now covered. Skippable anytime; replay from Settings.": [
  "Acabamos de ampliar la guía: ahora cubre cada sección de la barra lateral, el panel, la configuración de Stripe y una lista de verificación de \"primeros 4 pasos\". Puedes omitirla en cualquier momento; vuelve a verla desde Configuración.",
  "Kaka-expand lang namin ng walkthrough — sakop na ngayon ang bawat seksyon ng sidebar, ang dashboard, Stripe setup, at isang checklist ng \"unang 4 na hakbang\". Puwedeng laktawan anumang oras; i-replay mula sa Settings."
 ],
 "Take the tour": [
  "Hacer el recorrido",
  "Simulan ang tour"
 ],
 "Maybe later": [
  "Quizás más tarde",
  "Siguro mamaya"
 ],
 "Pick a lesson length.": [
  "Elige la duración de la clase.",
  "Pumili ng haba ng lesson."
 ],
 "Pick at least one child.": [
  "Elige al menos un niño.",
  "Pumili ng hindi bababa sa isang bata."
 ],
 "Please sign your coach’s waiver on your dashboard first, then come back to book.": [
  "Primero firma la exención de responsabilidad de tu instructor en tu panel y luego vuelve para reservar.",
  "Pakipirma muna ang waiver ng coach mo sa iyong dashboard, tapos bumalik para mag-book."
 ],
 "we'll assign one": [
  "asignaremos uno",
  "magtatalaga kami ng isa"
 ],
 "Head coach": [
  "Instructor principal",
  "Head coach"
 ],
 "How you're booking": [
  "Cómo estás reservando",
  "Paano ka nagbu-book"
 ],
 "Use my": [
  "Usar mi",
  "Gamitin ang aking"
 ],
 "left ·": [
  "restan ·",
  "natitira ·"
 ],
 "min · no charge": [
  "min · sin cargo",
  "min · walang bayad"
 ],
 "Pay for a single lesson": [
  "Pagar una sola clase",
  "Magbayad para sa isang lesson"
 ],
 "Keep your package lessons for later.": [
  "Guarda las clases de tu paquete para más tarde.",
  "Itabi ang mga lesson sa package mo para sa ibang araw."
 ],
 "Fill all": [
  "Llenar todas",
  "Punan lahat"
 ],
 "remaining lessons at this day & time. Weeks that aren't available are skipped.": [
  "clases restantes en este día y hora. Se omiten las semanas que no están disponibles.",
  "natitirang lesson sa araw at oras na ito. Lalaktawan ang mga linggong hindi available."
 ],
 "Checking each week…": [
  "Comprobando cada semana…",
  "Sinusuri ang bawat linggo…"
 ],
 "skip": [
  "omitir",
  "laktawan"
 ],
 "lessons will be booked": [
  "se reservarán clases",
  "mabubook ang mga lesson"
 ],
 "skipped": [
  "omitidas",
  "nilaktawan"
 ],
 "· your coach hasn't published hours past": [
  "· tu instructor no ha publicado horarios después de",
  "· hindi pa naglalabas ng oras ang coach mo lampas"
 ],
 "then": [
  "entonces",
  "pagkatapos"
 ],
 "yet — the other": [
  "todavía — las otras",
  "pa — ang iba"
 ],
 "stay in your pack": [
  "permanecen en tu paquete",
  "mananatili sa package mo"
 ],
 "Who's swimming?": [
  "¿Quién va a nadar?",
  "Sino ang lalangoy?"
 ],
 "Uses": [
  "Usos",
  "Gamit"
 ],
 "Booking…": [
  "Reservando…",
  "Nagbu-book…"
 ],
 "Holding your spot…": [
  "Guardando tu lugar…",
  "Hinahawakan ang slot mo…"
 ],
 "Book this time": [
  "Reservar este horario",
  "I-book ang oras na ito"
 ],
 "Could not load families.": [
  "No se pudieron cargar las familias.",
  "Hindi ma-load ang mga pamilya."
 ],
 "Pick a family.": [
  "Elige una familia.",
  "Pumili ng pamilya."
 ],
 "Pick at least one child to enroll.": [
  "Elige al menos un niño para inscribir.",
  "Pumili ng kahit isang bata na ie-enroll."
 ],
 "Connect Stripe before sending invoices.": [
  "Conecta Stripe antes de enviar facturas.",
  "Ikonekta ang Stripe bago magpadala ng mga invoice."
 ],
 "Connect Stripe before charging cards on file.": [
  "Conecta Stripe antes de cobrar las tarjetas guardadas.",
  "Ikonekta ang Stripe bago singilin ang mga naka-save na card."
 ],
 "Pick a date and start time.": [
  "Elige una fecha y una hora de inicio.",
  "Pumili ng petsa at oras ng simula."
 ],
 "That date/time isn't valid.": [
  "Esa fecha/hora no es válida.",
  "Hindi valid ang petsa/oras na iyon."
 ],
 "Custom price must be a number greater than 0.": [
  "El precio personalizado debe ser un número mayor que 0.",
  "Dapat numerong mas mataas sa 0 ang custom na presyo."
 ],
 "Custom price is not a valid number.": [
  "El precio personalizado no es un número válido.",
  "Hindi valid na numero ang custom na presyo."
 ],
 "Manual override — this bypasses the templated slot grid so you can pick any minute (e.g. 9:45).": [
  "Anulación manual — esto omite la cuadrícula de horarios de la plantilla para que puedas elegir cualquier minuto (p. ej. 9:45).",
  "Manual override — nilalampasan nito ang templated slot grid para makapili ka ng kahit anong minuto (hal. 9:45)."
 ],
 "Length": [
  "Duración",
  "Haba"
 ],
 "Cancel — use the original": [
  "Cancelar — usar el original",
  "Kanselahin — gamitin ang orihinal"
 ],
 "slot": [
  "bloque",
  "slot"
 ],
 "Enroll into": [
  "Inscribir en",
  "I-enroll sa"
 ],
 "Edit the start time or length": [
  "Edita la hora de inicio o la duración",
  "I-edit ang oras ng simula o haba"
 ],
 "Edit time": [
  "Editar hora",
  "I-edit ang oras"
 ],
 "· ends": [
  "· termina",
  "· nagtatapos"
 ],
 "Use \"Edit time\" to book this family with a different coach.": [
  "Usa \"Editar hora\" para reservar a esta familia con un instructor diferente.",
  "Gamitin ang \"I-edit ang oras\" para i-book ang pamilyang ito sa ibang coach."
 ],
 "Pick who teaches this lesson. Times are checked against that coach’s bookings only.": [
  "Elige quién imparte esta clase. Los horarios se verifican solo con las reservas de ese instructor.",
  "Piliin kung sino ang magtuturo ng lesson na ito. Ang mga oras ay sinusuri laban lang sa mga booking ng coach na iyon."
 ],
 "(invited)": [
  "(invitado)",
  "(imbitado)"
 ],
 "Bookable": [
  "Reservable",
  "Maaaring i-book"
 ],
 "Unsaved changes": [
  "Cambios sin guardar",
  "Mga pagbabagong hindi pa nai-save"
 ],
 "Offers open-schedule lessons": [
  "Ofrece clases con horario abierto",
  "Nag-aalok ng mga lesson na may bukas na iskedyul"
 ],
 "Coach can edit their own hours": [
  "El instructor puede editar su propio horario",
  "Maaaring i-edit ng coach ang sarili niyang oras"
 ],
 "They can update these hours from their staff portal.": [
  "Pueden actualizar este horario desde su portal del personal.",
  "Maaari nilang i-update ang mga oras na ito mula sa kanilang staff portal."
 ],
 "Only you can change these hours.": [
  "Solo tú puedes cambiar este horario.",
  "Ikaw lang ang maaaring magbago ng mga oras na ito."
 ],
 "Hours below are saved but parents won't see": [
  "El horario de abajo está guardado, pero los padres no lo verán",
  "Naka-save ang mga oras sa ibaba pero hindi makikita ng mga magulang"
 ],
 "until you flip on": [
  "hasta que actives",
  "hanggang sa i-on mo ang"
 ],
 "Lesson lengths & prices": [
  "Duración y precios de las clases",
  "Haba at presyo ng mga lesson"
 ],
 "Pick the lengths you offer and price each one. These apply across all schedule periods": [
  "Elige las duraciones que ofreces y el precio de cada una. Esto se aplica a todos los períodos del horario",
  "Piliin ang mga haba na inaalok mo at ang presyo ng bawat isa. Nalalapat ito sa lahat ng schedule period"
 ],
 "and every coach": [
  "y a cada instructor",
  "at sa bawat coach"
 ],
 ". Parents pick a length when they book.": [
  ". Los padres eligen una duración al reservar.",
  ". Pumipili ang mga magulang ng haba kapag nagbu-book."
 ],
 "min lesson": [
  "min por clase",
  "min na lesson"
 ],
 "per lesson": [
  "por clase",
  "bawat lesson"
 ],
 "Changes save to your coach profile": [
  "Los cambios se guardan en tu perfil de instructor",
  "Mase-save ang mga pagbabago sa iyong coach profile"
 ],
 "and each coach you edited": [
  "y en cada instructor que editaste",
  "at sa bawat coach na in-edit mo"
 ],
 ". Parents will see this immediately on your booking page once you save.": [
  ". Los padres verán esto de inmediato en tu página de reservas una vez que guardes.",
  ". Makikita ito agad ng mga magulang sa iyong booking page kapag na-save mo na."
 ],
 "Pick a Start Date and End Date above to see the auto-generated lesson list.": [
  "Elige una Fecha de inicio y una Fecha de finalización arriba para ver la lista de clases generada automáticamente.",
  "Pumili ng Start Date at End Date sa itaas para makita ang auto-generated na listahan ng mga lesson."
 ],
 "Add at least one weekly time above to see the lesson list.": [
  "Agrega al menos un horario semanal arriba para ver la lista de clases.",
  "Magdagdag ng kahit isang lingguhang oras sa itaas para makita ang listahan ng mga lesson."
 ],
 "Lessons preview": [
  "Vista previa de las clases",
  "Preview ng mga lesson"
 ],
 "Auto-generated": [
  "Generado automáticamente",
  "Auto-generated"
 ],
 "No lessons fall on the selected weekdays within this date range.": [
  "No hay clases en los días de la semana seleccionados dentro de este rango de fechas.",
  "Walang mga lesson na pasok sa napiling mga weekday sa loob ng date range na ito."
 ],
 "Change time for this date only": [
  "Cambiar la hora solo para esta fecha",
  "Baguhin ang oras para sa petsang ito lang"
 ],
 "Change time for": [
  "Cambiar la hora de",
  "Baguhin ang oras para sa"
 ],
 "Only this date will move. The default time stays the same for every other day.": [
  "Solo se moverá esta fecha. La hora predeterminada seguirá siendo la misma para todos los demás días.",
  "Ang petsang ito lang ang gagalaw. Mananatiling pareho ang default na oras para sa lahat ng iba pang araw."
 ],
 "Restore this lesson": [
  "Restaurar esta clase",
  "Ibalik ang lesson na ito"
 ],
 "Skip this date": [
  "Omitir esta fecha",
  "Laktawan ang petsang ito"
 ],
 "Time overridden for this date": [
  "Hora modificada para esta fecha",
  "Na-override ang oras para sa petsang ito"
 ],
 "date is": [
  "la fecha es",
  "ang petsa ay"
 ],
 "dates are": [
  "las fechas son",
  "ang mga petsa ay"
 ],
 "skipped and will not be counted as part of this package.": [
  "omitidas y no se contarán como parte de este paquete.",
  "nilaktawan at hindi mabibilang bilang bahagi ng package na ito."
 ],
 "Couldn't load your settings.": [
  "No se pudo cargar tu configuración.",
  "Hindi na-load ang iyong settings."
 ],
 "Cancel & reschedule rules saved — parents see them right away.": [
  "Las reglas de cancelación y reprogramación se guardaron; los padres las verán de inmediato.",
  "Na-save ang mga patakaran sa pagkansela at pag-reschedule — makikita agad ito ng mga magulang."
 ],
 "Cancellation policy text saved.": [
  "Se guardó el texto de la política de cancelación.",
  "Na-save ang teksto ng patakaran sa pagkansela."
 ],
 "This open slot comes from the selected coach’s hours. Tap “Edit time” to book with someone else.": [
  "Este espacio disponible proviene del horario del instructor seleccionado. Toca “Editar hora” para reservar con otra persona.",
  "Ang bakanteng slot na ito ay mula sa oras ng napiling coach. I-tap ang “Edit time” para mag-book sa ibang tao."
 ],
 "Search families…": [
  "Buscar familias…",
  "Maghanap ng mga pamilya…"
 ],
 "No families found.": [
  "No se encontraron familias.",
  "Walang nahanap na mga pamilya."
 ],
 "Which child(ren)?": [
  "¿Qué niño(s)?",
  "Aling mga bata?"
 ],
 "Billing": [
  "Facturación",
  "Pagsingil"
 ],
 "Connect Stripe →": [
  "Conectar Stripe →",
  "Ikonekta ang Stripe →"
 ],
 "need Stripe Connect. Use": [
  "necesita Stripe Connect. Usa",
  "kailangan ng Stripe Connect. Gamitin ang"
 ],
 "Paying offsite": [
  "Pago fuera de la plataforma",
  "Pagbabayad offsite"
 ],
 "Don't charge": [
  "No cobrar",
  "Huwag singilin"
 ],
 "for now, or finish Stripe setup to unlock them.": [
  "por ahora, o completa la configuración de Stripe para desbloquearlos.",
  "sa ngayon, o tapusin ang pag-set up ng Stripe para ma-unlock ang mga iyon."
 ],
 "Connect Stripe to bill via Splash Pad": [
  "Conecta Stripe para cobrar a través de Splash Pad",
  "Ikonekta ang Stripe para maningil sa pamamagitan ng Splash Pad"
 ],
 "Connect your Stripe account before using this option.": [
  "Conecta tu cuenta de Stripe antes de usar esta opción.",
  "Ikonekta ang iyong Stripe account bago gamitin ang opsyong ito."
 ],
 "Custom price (optional)": [
  "Precio personalizado (opcional)",
  "Custom na presyo (opsyonal)"
 ],
 "Bills this exact amount instead of your configured": [
  "Cobra exactamente este importe en lugar de tu",
  "Sisingilin ang eksaktong halagang ito sa halip na ang iyong naka-configure na"
 ],
 "-min price. Leave blank to use the default.": [
  "precio de -min. Déjalo en blanco para usar el valor predeterminado.",
  "presyo para sa -min. Iwanang blangko para gamitin ang default."
 ],
 "e.g. Making up for rain-out on 6/15": [
  "p. ej., Recuperando por cancelación por lluvia el 6/15",
  "hal. Pagpapalit para sa nakanselang lesson dahil sa ulan noong 6/15"
 ],
 "e.g. Paid $40 via Zelle": [
  "p. ej., Pagó $40 por Zelle",
  "hal. Nagbayad ng $40 sa pamamagitan ng Zelle"
 ],
 "Charge card & enroll": [
  "Cobrar tarjeta e inscribir",
  "Singilin ang card at i-enroll"
 ],
 "Enroll (no charge)": [
  "Inscribir (sin cargo)",
  "I-enroll (walang bayad)"
 ],
 "Could not load your open schedule config. Please refresh.": [
  "No se pudo cargar la configuración de tu horario abierto. Actualiza la página.",
  "Hindi ma-load ang iyong config ng open schedule. Paki-refresh."
 ],
 "Pick at least one lesson length before enabling Open Schedule.": [
  "Elige al menos una duración de clase antes de habilitar Horario abierto.",
  "Pumili ng hindi bababa sa isang haba ng lesson bago i-enable ang Open Schedule."
 ],
 "Set a price for every lesson length you offer (or remove the length).": [
  "Establece un precio para cada duración de clase que ofreces (o elimina esa duración).",
  "Magtakda ng presyo para sa bawat haba ng lesson na inaalok mo (o alisin ang habang iyon)."
 ],
 "Loading open schedule…": [
  "Cargando horario abierto…",
  "Nilo-load ang open schedule…"
 ],
 "Skip structured packages. Just set the days/hours you're available, pick the lesson lengths you offer, and parents (or you) can drop students into any open time.": [
  "Omite los paquetes estructurados. Solo establece los días/horas en que estás disponible, elige las duraciones de clase que ofreces y los padres (o tú) podrán asignar estudiantes a cualquier horario disponible.",
  "Laktawan ang mga structured package. Itakda lang ang mga araw/oras na available ka, piliin ang mga haba ng lesson na inaalok mo, at ang mga magulang (o ikaw) ay maaaring maglagay ng mga estudyante sa anumang bakanteng oras."
 ],
 "Enable Open Schedule": [
  "Habilitar horario abierto",
  "I-enable ang Open Schedule"
 ],
 "Turn the feature on for your": [
  "Activa la función para tu",
  "I-on ang feature para sa iyong"
 ],
 "studio": [
  "estudio",
  "studio"
 ],
 "account": [
  "cuenta",
  "account"
 ],
 "Parents can self-book": [
  "Los padres pueden reservar por su cuenta",
  "Maaaring mag-self-book ang mga magulang"
 ],
 "Parents pick any open slot themselves. Families with a lesson package book with their remaining lessons (no charge); everyone else pays per lesson online.": [
  "Los padres eligen por sí mismos cualquier espacio disponible. Las familias con un paquete de clases reservan con sus clases restantes (sin cargo); todos los demás pagan cada clase en línea.",
  "Pumipili mismo ang mga magulang ng anumang bakanteng slot. Ang mga pamilyang may lesson package ay nagbu-book gamit ang kanilang natitirang lessons (walang bayad); lahat ng iba pa ay nagbabayad kada lesson online."
 ],
 "You manually drop kids into open slots. Turn on to let families with a \"sell now, schedule later\" package book their own lesson times.": [
  "Tú asignas manualmente a los niños a los espacios disponibles. Actívalo para permitir que las familias con un paquete de \"comprar ahora, programar después\" reserven sus propios horarios de clase.",
  "Manu-mano mong inilalagay ang mga bata sa mga bakanteng slot. I-on ito para payagan ang mga pamilyang may package na \"sell now, schedule later\" na mag-book ng sarili nilang oras ng lesson."
 ],
 "Whose hours are you editing?": [
  "¿De quién estás editando el horario?",
  "Kaninong oras ang ine-edit mo?"
 ],
 "Every coach has their own open-schedule hours. Parents see a tab per coach (plus “Any available coach”) and book the one they want.": [
  "Cada instructor tiene su propio horario de horario abierto. Los padres ven una pestaña por instructor (más “Cualquier instructor disponible”) y reservan con el que quieran.",
  "Bawat coach ay may sarili niyang open-schedule hours. Nakakakita ang mga magulang ng isang tab bawat coach (kasama ang “Any available coach”) at nagbu-book sila sa coach na gusto nila."
 ],
 "bookable coach": [
  "instructor reservable",
  "maaaring i-book na coach"
 ],
 "Has hours": [
  "Tiene horario",
  "May oras"
 ],
 "Rules that apply to every package, class and lesson booking. Anything here can be overridden on a single package from its builder.": [
  "Reglas que se aplican a todos los paquetes, clases y reservas de lecciones. Todo lo que aparezca aquí se puede reemplazar en un paquete individual desde su creador.",
  "Mga patakaran na naaangkop sa bawat package, class, at booking ng lesson. Anumang narito ay puwedeng i-override sa isang package mula sa builder nito."
 ],
 "This is the default for all packages, classes and open-schedule bookings. When a parent has changes left and gives enough notice, they cancel or move a lesson themselves — otherwise the portal tells them to text or call you.": [
  "Esta es la configuración predeterminada para todos los paquetes, clases y reservas de horario abierto. Cuando un padre todavía tiene cambios disponibles y avisa con suficiente anticipación, cancela o cambia una lección por su cuenta; de lo contrario, el portal le indica que te envíe un texto o te llame.",
  "Ito ang default para sa lahat ng package, class, at open-schedule booking. Kapag may natitira pang changes ang magulang at nakapagbigay ng sapat na abiso, sila mismo ang nagkakansela o naglilipat ng lesson — kung hindi, sasabihin ng portal na mag-text o tumawag sila sa iyo."
 ],
 "Save rules": [
  "Guardar reglas",
  "I-save ang mga patakaran"
 ],
 "Cancellation policy wording": [
  "Texto de la política de cancelación",
  "Salita ng patakaran sa pagkansela"
 ],
 "The three sections parents agree to when they register.": [
  "Las tres secciones que los padres aceptan cuando se registran.",
  "Ang tatlong seksyon na sinasang-ayunan ng mga magulang kapag nagparehistro sila."
 ],
 "Past signers keep the wording they agreed to": [
  "Quienes firmaron anteriormente conservan el texto que aceptaron",
  "Ang mga dating lumagda ay mananatili sa salitang sinang-ayunan nila"
 ],
 "— edits only affect new families. Tip: make the rules above and this text say the same thing.": [
  "— las ediciones solo afectan a las familias nuevas. Consejo: haz que las reglas anteriores y este texto digan lo mismo.",
  "— ang mga edit ay makakaapekto lang sa mga bagong pamilya. Tip: tiyaking pareho ang sinasabi ng mga patakaran sa itaas at ng tekstong ito."
 ],
 "chars": [
  "caracteres",
  "mga character"
 ],
 "Save wording": [
  "Guardar texto",
  "I-save ang teksto"
 ],
 "Whether approved parents can join a class time instantly or must request it.": [
  "Si los padres aprobados pueden unirse a un horario de clase al instante o si deben solicitarlo.",
  "Kung ang mga aprubadong magulang ay puwedeng sumali agad sa oras ng class o kailangan muna nila itong i-request."
 ],
 "Open help and support": [
  "Abrir ayuda y soporte",
  "Buksan ang help at support"
 ],
 "How can we help?": [
  "¿Cómo podemos ayudar?",
  "Paano kami makakatulong?"
 ],
 "Search our help center": [
  "Buscar en nuestro centro de ayuda",
  "Maghanap sa aming help center"
 ],
 "Hide password": [
  "Ocultar contraseña",
  "Itago ang password"
 ],
 "Show password": [
  "Mostrar contraseña",
  "Ipakita ang password"
 ],
 "How to pay": [
  "Cómo pagar",
  "Paano magbayad"
 ],
 "will share payment details with you directly.": [
  "compartirá los detalles de pago contigo directamente.",
  "ay direktang magbabahagi sa iyo ng mga detalye ng bayad."
 ],
 "until": [
  "hasta",
  "hanggang"
 ],
 "confirms your payment was received — you'll get a confirmation as soon as they do.": [
  "confirma que se recibió tu pago — recibirás una confirmación en cuanto lo haga.",
  "kinukumpirma na natanggap ang bayad mo — makakatanggap ka ng kumpirmasyon sa sandaling magawa nila ito."
 ],
 "Never mind, I'll pay by card": [
  "No importa, pagaré con tarjeta",
  "Hindi na lang, card na lang ang ibabayad ko"
 ],
 "What to do:": [
  "Qué hacer:",
  "Ano ang gagawin:"
 ],
 "Nothing was charged. Your coach has been told the payment didn’t go through.": [
  "No se realizó ningún cargo. Se le informó a tu instructor que el pago no se procesó.",
  "Walang na-charge. Sinabihan na ang coach mo na hindi natuloy ang bayad."
 ],
 "Try another card": [
  "Probar otra tarjeta",
  "Subukan ang ibang card"
 ],
 "Try this card again": [
  "Probar esta tarjeta de nuevo",
  "Subukan ulit ang card na ito"
 ],
 "Prefer to keep this card? Call the number on the back and ask them to approve the charge, then try again.": [
  "¿Prefieres mantener esta tarjeta? Llama al número que está al reverso y pídeles que aprueben el cargo; luego vuelve a intentarlo.",
  "Mas gusto mong gamitin pa rin ang card na ito? Tawagan ang numerong nasa likod at hilinging aprubahan nila ang charge, pagkatapos ay subukan ulit."
 ],
 "Payments & renewals": [
  "Pagos y renovaciones",
  "Mga bayad at renewal"
 ],
 "You'll see payments here as clients settle their invoices.": [
  "Verás los pagos aquí a medida que los clientes liquiden sus facturas.",
  "Makikita mo rito ang mga bayad habang binabayaran ng mga kliyente ang kanilang mga invoice."
 ],
 "Open Payments": [
  "Abrir Pagos",
  "Buksan ang Payments"
 ],
 "No email on file — text them instead.": [
  "No hay un correo electrónico registrado — envíales un texto en su lugar.",
  "Walang naka-file na email — i-text mo na lang sila."
 ],
 "No phone number on file for this family.": [
  "No hay un número de teléfono registrado para esta familia.",
  "Walang naka-file na numero ng telepono para sa pamilyang ito."
 ],
 "Click to send a payment reminder": [
  "Haz clic para enviar un recordatorio de pago",
  "I-click para magpadala ng paalala sa bayad"
 ],
 "Nudge this family": [
  "Recordarle a esta familia",
  "I-remind ang pamilyang ito"
 ],
 "Pick how to remind them about the outstanding payment.": [
  "Elige cómo recordarles el pago pendiente.",
  "Piliin kung paano sila reremind-an tungkol sa hindi pa nababayarang bayad."
 ],
 "Email sent ✓": [
  "Correo enviado ✓",
  "Naipadala ang email ✓"
 ],
 "Send email reminder": [
  "Enviar recordatorio por correo electrónico",
  "Magpadala ng paalala sa email"
 ],
 "Text the family": [
  "Enviar un mensaje de texto a la familia",
  "I-text ang pamilya"
 ],
 "View all open invoices": [
  "Ver todas las facturas pendientes",
  "Tingnan ang lahat ng bukas na invoice"
 ],
 "Track payment status across families": [
  "Seguimiento del estado de pago entre familias",
  "Subaybayan ang status ng bayad sa mga pamilya"
 ],
 "Setting up checkout…": [
  "Configurando el pago…",
  "Sine-set up ang checkout…"
 ],
 "Couldn't start checkout": [
  "No se pudo iniciar el pago",
  "Hindi masimulan ang checkout"
 ],
 "Payment is not available right now. Please try again later.": [
  "El pago no está disponible en este momento. Inténtalo de nuevo más tarde.",
  "Hindi available ang bayad sa ngayon. Pakisubukan ulit mamaya."
 ],
 "Card on file only": [
  "Solo tarjeta guardada",
  "Naka-file na card lang"
 ],
 "Per month": [
  "Por mes",
  "Bawat buwan"
 ],
 "to save this card and charge it for future lessons or packages. You can manage your saved cards anytime from": [
  "para guardar esta tarjeta y cobrarla por futuras clases o paquetes. Puedes administrar tus tarjetas guardadas en cualquier momento desde",
  "para i-save ang card na ito at i-charge ito para sa mga susunod na lesson o package. Maaari mong i-manage ang iyong mga naka-save na card anumang oras mula sa"
 ],
 "Pay \\$": [
  "Pagar \\$",
  "Magbayad ng \\$"
 ],
 "Payments are temporarily paused on your account": [
  "Los pagos están en pausa temporalmente en tu cuenta",
  "Pansamantalang naka-pause ang mga bayad sa iyong account"
 ],
 "As part of routine payment-safety checks, new charges, card saves and subscriptions are on hold while SplashPad takes a quick look. Everything else — your schedule, students and messages — works as normal. Most reviews clear within one business day.": [
  "Como parte de las revisiones rutinarias de seguridad de pagos, los nuevos cobros, el guardado de tarjetas y las suscripciones están en pausa mientras SplashPad hace una revisión rápida. Todo lo demás — tu horario, estudiantes y mensajes — funciona con normalidad. La mayoría de las revisiones se resuelven en un día hábil.",
  "Bilang bahagi ng mga regular na safety check sa bayad, naka-hold muna ang mga bagong charge, pag-save ng card, at mga subscription habang mabilis itong tinitingnan ng SplashPad. Lahat ng iba pa — ang iyong schedule, mga estudyante, at mga mensahe — ay gumagana nang normal. Karamihan sa mga review ay natatapos sa loob ng isang business day."
 ],
 "Your invoice is ready — pay it right here in SplashPad.": [
  "Tu factura está lista — págala aquí mismo en SplashPad.",
  "Handa na ang iyong invoice — bayaran ito dito mismo sa SplashPad."
 ],
 "Reopening your secure payment page…": [
  "Reabriendo tu página de pago segura…",
  "Muling binubuksan ang iyong secure na payment page…"
 ],
 "No saved payment found for this registration. Use \"Pick a different class\" to start fresh — it only takes a minute.": [
  "No se encontró un método de pago guardado para esta inscripción. Usa \"Elegir una clase diferente\" para empezar de nuevo — solo toma un minuto.",
  "Walang nahanap na naka-save na bayad para sa registration na ito. Gamitin ang \"Pumili ng ibang klase\" para magsimula muli — isang minuto lang ito."
 ],
 "Registration cancelled — pick any class you like.": [
  "Inscripción cancelada — elige cualquier clase que quieras.",
  "Nakansela ang registration — pumili ng kahit anong klaseng gusto mo."
 ],
 "Payment needed to lock this in": [
  "Se necesita el pago para asegurar esto",
  "Kailangan ang bayad para ma-secure ito"
 ],
 "Finish your payment to hold this spot — or cancel this registration and pick a different class with": [
  "Completa tu pago para reservar este lugar — o cancela esta inscripción y elige una clase diferente con",
  "Tapusin ang iyong bayad para ma-reserve ang slot na ito — o kanselahin ang registration na ito at pumili ng ibang klase gamit ang"
 ],
 ". Your spot isn't held until payment goes through.": [
  ". Tu lugar no queda reservado hasta que se procese el pago.",
  ". Hindi nakareserba ang iyong slot hangga't hindi pumapasok ang bayad."
 ],
 "Pick a different class": [
  "Elegir una clase diferente",
  "Pumili ng ibang klase"
 ],
 "Cancel this registration?": [
  "¿Cancelar esta inscripción?",
  "Kanselahin ang registration na ito?"
 ],
 "This releases the pending spot so you can pick any other class. Nothing has been charged — you can always sign up for this class again later if it still has room.": [
  "Esto libera el lugar pendiente para que puedas elegir cualquier otra clase. No se ha hecho ningún cargo — siempre puedes inscribirte en esta clase de nuevo más adelante si todavía hay cupo.",
  "Ire-release nito ang nakabinbing slot para makapili ka ng ibang klase. Walang na-charge — maaari kang mag-sign up ulit sa klaseng ito mamaya kung may bakante pa."
 ],
 "Yes, cancel & pick another": [
  "Sí, cancelar y elegir otra",
  "Oo, kanselahin at pumili ng iba"
 ],
 "Powered by": [
  "Desarrollado por",
  "Powered by"
 ],
 "Price in {currency}": [
  "Precio en {currency}",
  "Presyo sa {currency}"
 ],
 "of 2": [
  "de 2",
  "ng 2"
 ],
 "Ready to make the move to Pro?": [
  "¿Listo para pasarte a Pro?",
  "Handa ka na bang lumipat sa Pro?"
 ],
 "Are you an SSU member?": [
  "¿Eres miembro de SSU?",
  "Miyembro ka ba ng SSU?"
 ],
 "Quick check before we switch you over — here’s exactly what changes.": [
  "Verificación rápida antes de cambiarte — aquí tienes exactamente lo que cambia.",
  "Mabilisang check bago ka namin ilipat — heto mismo ang magbabago."
 ],
 "Superhero Swim University members get 50% off Pro. Enter your code and we’ll show your new price before anything is charged.": [
  "Los miembros de Superhero Swim University obtienen un 50% de descuento en Pro. Ingresa tu código y te mostraremos tu nuevo precio antes de que se haga cualquier cargo.",
  "Ang mga miyembro ng Superhero Swim University ay may 50% diskuwento sa Pro. Ilagay ang iyong code at ipapakita namin ang bago mong presyo bago singilin ang anuman."
 ],
 "SSU members: 50% off on the next step": [
  "Miembros de SSU: 50% de descuento en el siguiente paso",
  "Mga miyembro ng SSU: 50% off sa susunod na hakbang"
 ],
 "Your SSU 50% off code": [
  "Tu código de 50% de descuento de SSU",
  "Iyong SSU 50% off code"
 ],
 "e.g. SSU50": [
  "p. ej. SSU50",
  "hal. SSU50"
 ],
 "Your new price": [
  "Tu nuevo precio",
  "Ang bago mong presyo"
 ],
 "You save": [
  "Ahorras",
  "Matitipid mo"
 ],
 "every month compared to the list price.": [
  "cada mes en comparación con el precio de lista.",
  "bawat buwan kumpara sa list price."
 ],
 "No code? No problem — you can continue at the list price and add a code later from Billing.": [
  "¿Sin código? No hay problema: puedes continuar al precio de lista y agregar un código más tarde desde Facturación.",
  "Walang code? Walang problema — puwede kang magpatuloy sa list price at magdagdag ng code mamaya mula sa Billing."
 ],
 "Switches immediately. Your": [
  "Cambia de inmediato. Tu",
  "Agad na lilipat. Ang iyong"
 ],
 "card ending in ••••": [
  "tarjeta terminada en ••••",
  "card na nagtatapos sa ••••"
 ],
 "is charged the prorated difference today, then": [
  "se carga hoy con la diferencia prorrateada y luego",
  "ay sisingilin ngayon ng prorated na diperensya, at pagkatapos"
 ],
 "/mo, renewing automatically each month until you cancel": [
  "/mes, con renovación automática cada mes hasta que canceles",
  "/buwan, awtomatikong nagre-renew bawat buwan hanggang magkansela ka"
 ],
 ". Cancel anytime under Your Subscription.": [
  ". Cancela en cualquier momento en Tu suscripción.",
  ". Kanselahin anumang oras sa Iyong Subscription."
 ],
 "Next you’ll add a card for Pro. Nothing is charged until you finish that step, and your code carries over automatically.": [
  "A continuación agregarás una tarjeta para Pro. No se cobrará nada hasta que completes ese paso, y tu código se transferirá automáticamente.",
  "Susunod, magdadagdag ka ng card para sa Pro. Walang sisingilin hanggang matapos mo ang hakbang na iyon, at awtomatikong madadala ang iyong code."
 ],
 "Yes, I’m sure — continue": [
  "Sí, estoy seguro — continuar",
  "Oo, sigurado ako — magpatuloy"
 ],
 "Confirm upgrade —": [
  "Confirmar mejora —",
  "Kumpirmahin ang upgrade —"
 ],
 "Continue to payment —": [
  "Continuar al pago —",
  "Magpatuloy sa bayad —"
 ],
 "· Unlimited students, your own website, team portal and more. Cancel anytime.": [
  "· Estudiantes ilimitados, tu propio sitio web, portal del equipo y más. Cancela en cualquier momento.",
  "· Walang limitasyong estudyante, sarili mong website, team portal, at iba pa. Kanselahin anumang oras."
 ],
 "That’s everything — your Pro account is fully set up.": [
  "Eso es todo: tu cuenta Pro está completamente configurada.",
  "Iyon na ang lahat — ganap nang naka-set up ang iyong Pro account."
 ],
 "You’re in": [
  "Ya tienes",
  "Kasali ka na sa"
 ],
 "Welcome to Pro!": [
  "¡Te damos la bienvenida a Pro!",
  "Welcome sa Pro!"
 ],
 "Four quick wins to get the most out of your upgrade. Knock them out now while you’re here.": [
  "Cuatro logros rápidos para aprovechar al máximo tu mejora. Complétalos ahora mientras estás aquí.",
  "Apat na mabilisang panalo para masulit ang iyong upgrade. Tapusin na ang mga ito ngayon habang nandito ka."
 ],
 "done": [
  "hecho",
  "tapos na"
 ],
 "Already done": [
  "Ya está hecho",
  "Tapos na ito"
 ],
 "detected": [
  "detectado",
  "na-detect"
 ],
 "Close this and it won’t pop up again.": [
  "Ciérralo y no volverá a aparecer.",
  "Isara ito at hindi na ito muling lalabas."
 ],
 "Don’t show again": [
  "No mostrar de nuevo",
  "Huwag nang ipakita muli"
 ],
 "Recently deleted": [
  "Eliminados recientemente",
  "Kamakailang tinanggal"
 ],
 "Deleted enrollments can be restored for 30 days.": [
  "Las inscripciones eliminadas se pueden restaurar durante 30 días.",
  "Maaaring maibalik ang mga tinanggal na enrollment sa loob ng 30 araw."
 ],
 "package no longer exists": [
  "el paquete ya no existe",
  "wala na ang package"
 ],
 "· deleted": [
  "· eliminado",
  "· tinanggal"
 ],
 "Re-pulled from Stripe.": [
  "Se volvió a obtener de Stripe.",
  "Muling nakuha mula sa Stripe."
 ],
 "Revenue collected": [
  "Ingresos cobrados",
  "Nakolektang kita"
 ],
 "Stripe ledger": [
  "Libro mayor de Stripe",
  "Stripe ledger"
 ],
 "Stripe unavailable": [
  "Stripe no disponible",
  "Hindi available ang Stripe"
 ],
 "Money that actually hit our Stripe balance — coach subscriptions plus the $0.25 lesson fees. This is the number that matches Stripe.": [
  "Dinero que realmente llegó a nuestro saldo de Stripe: suscripciones de instructores más las tarifas de clase de $0.25. Este es el número que coincide con Stripe.",
  "Pera na talagang pumasok sa aming Stripe balance — mga subscription ng coach kasama ang $0.25 na lesson fees. Ito ang numerong tugma sa Stripe."
 ],
 "gross collected": [
  "ingresos brutos cobrados",
  "gross na nakolekta"
 ],
 "Net to bank": [
  "Neto al banco",
  "Net papunta sa bangko"
 ],
 "after refunds & Stripe fees": [
  "después de reembolsos y comisiones de Stripe",
  "pagkatapos ng refunds at Stripe fees"
 ],
 "Run-rate for full month": [
  "Proyección para el mes completo",
  "Run-rate para sa buong buwan"
 ],
 "run-rate vs.": [
  "proyección vs.",
  "run-rate vs."
 ],
 "Subscriptions": [
  "Suscripciones",
  "Mga subscription"
 ],
 "Lesson fees ($0.25)": [
  "Tarifas de clases ($0.25)",
  "Mga bayad sa lesson ($0.25)"
 ],
 "Stripe fees": [
  "Comisiones de Stripe",
  "Mga bayarin sa Stripe"
 ],
 "Collected by month": [
  "Cobrado por mes",
  "Nakolekta kada buwan"
 ],
 "Could not load the trend.": [
  "No se pudo cargar la tendencia.",
  "Hindi ma-load ang trend."
 ],
 "No collected revenue in this period yet.": [
  "Todavía no hay ingresos cobrados en este período.",
  "Wala pang nakolektang kita sa panahong ito."
 ],
 "Bars = money collected (subscriptions + $0.25 lesson fees). Solid line = net to bank. Dashed = what the forecast predicted for that month.": [
  "Barras = dinero cobrado (suscripciones + tarifas de clases de $0.25). Línea continua = neto al banco. Línea discontinua = lo que el pronóstico predijo para ese mes.",
  "Mga bar = nakolektang pera (mga subscription + $0.25 na bayad sa lesson). Solid na linya = netong mapupunta sa bangko. Dashed = kung ano ang hinula ng forecast para sa buwang iyon."
 ],
 "(cached ≤5 min)": [
  "(en caché ≤5 min)",
  "(naka-cache ≤5 min)"
 ],
 "Why forecast ≠ collected": [
  "Por qué pronóstico ≠ cobrado",
  "Bakit forecast ≠ nakolekta"
 ],
 "Forecast vs. collected — per subscription": [
  "Pronóstico vs. cobrado — por suscripción",
  "Forecast vs. nakolekta — bawat subscription"
 ],
 "Each Stripe subscription, what the forecast counts it at, and what its most recent invoice actually did. Rows marked": [
  "Cada suscripción de Stripe, cómo la cuenta el pronóstico y qué hizo realmente su factura más reciente. Las filas marcadas",
  "Bawat Stripe subscription, kung paano ito binibilang ng forecast, at kung ano talaga ang ginawa ng pinakabagong invoice nito. Ang mga row na may markang"
 ],
 "not collected": [
  "no cobrada",
  "hindi nakolekta"
 ],
 "are the gap.": [
  "son la diferencia.",
  "ang agwat."
 ],
 "No subscriptions found in Stripe.": [
  "No se encontraron suscripciones en Stripe.",
  "Walang nahanap na subscription sa Stripe."
 ],
 "Plan": [
  "Plan",
  "Plan"
 ],
 "Forecast /mo": [
  "Pronóstico /mes",
  "Forecast /buwan"
 ],
 "Last invoice": [
  "Última factura",
  "Huling invoice"
 ],
 "Verdict": [
  "Veredicto",
  "Hatol"
 ],
 "payments": [
  "pagos",
  "mga bayad"
 ],
 "Subscription payments —": [
  "Pagos de suscripciones —",
  "Mga bayad sa subscription —"
 ],
 "Every coach subscription charge and refund on the Stripe ledger for this window.": [
  "Cada cargo y reembolso de suscripción de instructor en el registro de Stripe para esta ventana.",
  "Bawat singil at refund ng subscription ng coach sa Stripe ledger para sa window na ito."
 ],
 "refund": [
  "reembolso",
  "refund"
 ],
 "Home base": [
  "Sede principal",
  "Home base"
 ],
 "Request ·": [
  "Solicitud ·",
  "Request ·"
 ],
 "Fits": [
  "Encaja",
  "Pasok"
 ],
 "Schedule periods": [
  "Períodos del horario",
  "Mga period ng schedule"
 ],
 "Each period runs during its own date range with its own weekly hours. Add one for each season, pool, or location change. Leave both dates blank for a period that runs indefinitely.": [
  "Cada período transcurre dentro de su propio rango de fechas y con sus propias horas semanales. Agrega uno para cada temporada, piscina o cambio de ubicación. Deja ambas fechas en blanco para un período que dure indefinidamente.",
  "Ang bawat period ay tumatakbo sa sarili nitong date range na may sarili nitong lingguhang oras. Magdagdag ng isa para sa bawat season, pool, o pagbabago ng lokasyon. Iwanang blangko ang parehong petsa para sa period na tatakbo nang walang takda."
 ],
 "period": [
  "período",
  "period"
 ],
 "periods": [
  "períodos",
  "mga period"
 ],
 "e.g. September Outdoor Pool": [
  "p. ej., Piscina exterior de septiembre",
  "hal. September Outdoor Pool"
 ],
 "End date (optional)": [
  "Fecha de finalización (opcional)",
  "Petsa ng pagtatapos (opsyonal)"
 ],
 "No location": [
  "Sin ubicación",
  "Walang lokasyon"
 ],
 "Weekly hours": [
  "Horas semanales",
  "Lingguhang oras"
 ],
 "Not available": [
  "No disponible",
  "Hindi available"
 ],
 "Add hours": [
  "Agregar horas",
  "Magdagdag ng oras"
 ],
 "7-day free trial": [
  "Prueba gratis de 7 días",
  "7-araw na libreng trial"
 ],
 "Replay SplashPad logo splash": [
  "Reproducir de nuevo la pantalla de inicio con el logo de SplashPad",
  "I-play muli ang splash screen ng logo ng SplashPad"
 ],
 "Make a": [
  "Crear una",
  "Gumawa ng isang"
 ],
 "Replay splash animation": [
  "Reproducir de nuevo la animación de inicio",
  "I-play muli ang splash animation"
 ],
 "Pad": [
  "Pad",
  "Pad"
 ],
 "My coach profile": [
  "Mi perfil de instructor",
  "Aking profile ng coach"
 ],
 "Parents see this photo and name on every class, package and lesson": [
  "Los padres ven esta foto y nombre en cada clase, paquete y lección",
  "Makikita ng mga magulang ang larawang ito at pangalan sa bawat klase, package, at lesson"
 ],
 "you teach": [
  "que impartes",
  "na itinuturo mo"
 ],
 "this coach teaches": [
  "este coach enseña",
  "ang coach na ito ay nagtuturo ng"
 ],
 "— on the website and inside the parent portal.": [
  "— en el sitio web y dentro del portal para padres.",
  "— sa website at sa loob ng parent portal."
 ],
 "Display name": [
  "Nombre para mostrar",
  "Display name"
 ],
 "e.g. Coach Sarah": [
  "p. ej., Instructora Sarah",
  "hal. Coach Sarah"
 ],
 "(optional, shows on the website team page)": [
  "(opcional, se muestra en la página del equipo del sitio web)",
  "(opsyonal, ipinapakita sa team page ng website)"
 ],
 "e.g. Former college swimmer, WSI certified, loves helping nervous beginners fall in love with the water.": [
  "p. ej., Exnadadora universitaria, certificada por WSI, le encanta ayudar a principiantes nerviosos a enamorarse del agua.",
  "hal. Dating college swimmer, certified sa WSI, gustong tumulong sa mga kabadong baguhan na mahalin ang tubig."
 ],
 "Welcome back! Refreshing your Stripe status…": [
  "¡Bienvenido de nuevo! Actualizando tu estado de Stripe…",
  "Welcome back! Nire-refresh ang iyong Stripe status…"
 ],
 "Could not start Stripe onboarding. Please try again.": [
  "No se pudo iniciar la configuración de Stripe. Inténtalo de nuevo.",
  "Hindi masimulan ang Stripe onboarding. Pakisubukan muli."
 ],
 "Stripe status refreshed.": [
  "Estado de Stripe actualizado.",
  "Na-refresh na ang Stripe status."
 ],
 "Stripe connection cleared. You can start fresh now.": [
  "Se borró la conexión con Stripe. Ahora puedes empezar de nuevo.",
  "Na-clear na ang Stripe connection. Maaari ka nang magsimulang muli ngayon."
 ],
 "Stripe returned no dashboard link. Try Force refresh from Stripe and then click Stripe dashboard again.": [
  "Stripe no devolvió ningún enlace del panel. Prueba Forzar actualización desde Stripe y luego haz clic de nuevo en Panel de Stripe.",
  "Walang ibinalik na dashboard link ang Stripe. Subukang gamitin ang Force refresh from Stripe at pagkatapos ay i-click muli ang Stripe dashboard."
 ],
 "Your browser blocked the new tab. Use \"Continue to Stripe\" or copy the link instead.": [
  "Tu navegador bloqueó la nueva pestaña. Usa \"Continue to Stripe\" o copia el enlace.",
  "Na-block ng browser mo ang bagong tab. Gamitin ang \"Continue to Stripe\" o kopyahin na lang ang link."
 ],
 "Stripe dashboard link copied": [
  "Enlace al panel de Stripe copiado",
  "Nakopya na ang link ng Stripe dashboard"
 ],
 "Could not copy automatically. Long-press the link to copy it.": [
  "No se pudo copiar automáticamente. Mantén presionado el enlace para copiarlo.",
  "Hindi ito awtomatikong nakopya. Long-press ang link para makopya ito."
 ],
 "Loading Stripe status…": [
  "Cargando estado de Stripe…",
  "Nilo-load ang Stripe status…"
 ],
 "Bank account": [
  "Cuenta bancaria",
  "Bank account"
 ],
 "Accept card payments with Stripe": [
  "Acepta pagos con tarjeta con Stripe",
  "Tanggap ng bayad gamit ang card sa pamamagitan ng Stripe"
 ],
 "Resume onboarding": [
  "Reanudar configuración",
  "Ipagpatuloy ang onboarding"
 ],
 "Opens Stripe.com in a new tab — view payouts, update your bank account, see disputes, etc.": [
  "Abre Stripe.com en una nueva pestaña — consulta pagos, actualiza tu cuenta bancaria, revisa disputas, etc.",
  "Binubuksan ang Stripe.com sa bagong tab — tingnan ang payouts, i-update ang iyong bank account, tingnan ang disputes, atbp."
 ],
 "Stripe dashboard": [
  "Panel de Stripe",
  "Stripe dashboard"
 ],
 "Checking with Stripe…": [
  "Consultando con Stripe…",
  "Nakikipag-check sa Stripe…"
 ],
 "Force refresh from Stripe": [
  "Forzar actualización desde Stripe",
  "Force refresh from Stripe"
 ],
 "Something not working? →": [
  "¿Algo no funciona? →",
  "May hindi gumagana? →"
 ],
 "Stripe needs:": [
  "Stripe necesita:",
  "Kailangan ng Stripe:"
 ],
 "Wrong country? Start over": [
  "¿País incorrecto? Empezar de nuevo",
  "Maling bansa? Magsimula ulit"
 ],
 "Where do you teach swim lessons?": [
  "¿Dónde impartes clases de natación?",
  "Saan ka nagtuturo ng swim lessons?"
 ],
 "Stripe sets up your account for one country — it controls the tax forms, ID verification, and banking flow you'll see next.": [
  "Stripe configura tu cuenta para un solo país — eso controla los formularios fiscales, la verificación de identidad y el proceso bancario que verás a continuación.",
  "Sine-set up ng Stripe ang account mo para sa iisang bansa — ito ang kumokontrol sa mga tax form, ID verification, at banking flow na makikita mo sa susunod."
 ],
 "— that fixes it most of the time.": [
  "— eso lo soluciona la mayoría de las veces.",
  "— naaayos niyan ang problema kadalasan."
 ],
 "Still stuck?": [
  "¿Sigues atascado?",
  "Hindi pa rin maayos?"
 ],
 "Screenshot this card": [
  "Haz una captura de esta tarjeta",
  "I-screenshot ang card na ito"
 ],
 "(including the box below) and send it to us in the support chat — the Report ID lets us find the exact problem instantly.": [
  "(incluido el recuadro de abajo) y envíanosla en el chat de soporte — el ID del informe nos permite encontrar el problema exacto al instante.",
  "(kasama ang kahon sa ibaba) at ipadala ito sa amin sa support chat — tinutulungan kami ng Report ID na mahanap agad ang eksaktong problema."
 ],
 "Reload page": [
  "Recargar página",
  "I-reload ang page"
 ],
 "Could not load share link.": [
  "No se pudo cargar el enlace para compartir.",
  "Hindi ma-load ang share link."
 ],
 "Link copied to clipboard": [
  "Enlace copiado al portapapeles",
  "Nakopya ang link sa clipboard"
 ],
 "Could not copy — select the text manually.": [
  "No se pudo copiar — selecciona el texto manualmente.",
  "Hindi makopya — piliin ang text nang mano-mano."
 ],
 "Link emailed to family.": [
  "Enlace enviado por correo a la familia.",
  "Na-email ang link sa pamilya."
 ],
 "This package is private — it isn't shown on your public landing page. Send a family the direct link so they can review and sign up.": [
  "Este paquete es privado — no se muestra en tu página pública de destino. Envía a una familia el enlace directo para que pueda revisarlo e inscribirse.",
  "Pribado ang package na ito — hindi ito ipinapakita sa iyong pampublikong landing page. Ipadala sa isang pamilya ang direktang link para marepaso nila ito at makapag-sign up."
 ],
 "Loading link…": [
  "Cargando enlace…",
  "Nilo-load ang link…"
 ],
 "Share link": [
  "Enlace para compartir",
  "Share link"
 ],
 "Private": [
  "Privado",
  "Pribado"
 ],
 "Paste this into iMessage, WhatsApp, or anywhere else. Anyone with the link can sign up.": [
  "Pega esto en iMessage, WhatsApp o cualquier otro lugar. Cualquiera que tenga el enlace puede inscribirse.",
  "I-paste ito sa iMessage, WhatsApp, o kahit saan pa. Kahit sino na may link ay puwedeng mag-sign up."
 ],
 "Or email it to a family": [
  "O envíalo por correo a una familia",
  "O i-email ito sa isang pamilya"
 ],
 "Search your families…": [
  "Busca tus familias…",
  "Hanapin ang iyong mga pamilya…"
 ],
 "No families on your roster yet.": [
  "Aún no hay familias en tu lista.",
  "Wala ka pang mga pamilya sa roster mo."
 ],
 "Personal note (optional)": [
  "Nota personal (opcional)",
  "Personal na note (opsyonal)"
 ],
 "e.g. Here's that VIP package we talked about — locked in your special price.": [
  "p. ej. Aquí está ese paquete VIP del que hablamos — con tu precio especial asegurado.",
  "hal. Narito ang VIP package na napag-usapan natin — naka-lock in na ang espesyal mong presyo."
 ],
 "We'll send the email through Splash Pad on your behalf.": [
  "Enviaremos el correo a través de Splash Pad en tu nombre.",
  "Ipapadala namin ang email sa pamamagitan ng Splash Pad para sa iyo."
 ],
 "Email link": [
  "Enviar enlace por correo",
  "I-email ang link"
 ],
 "Emailed to": [
  "Enviado por correo a",
  "Na-email sa"
 ],
 ". If it gets caught in spam, copy the link above and send it manually.": [
  ". Si termina en spam, copia el enlace de arriba y envíalo manualmente.",
  ". Kung mapunta ito sa spam, kopyahin ang link sa itaas at ipadala ito nang mano-mano."
 ],
 "Anyone with this link can sign up for this package, so only share it with families you trust. Set the package to \"Draft\" or delete it to revoke the link.": [
  "Cualquiera que tenga este enlace puede inscribirse en este paquete, así que compártelo solo con familias de confianza. Cambia el paquete a \"Borrador\" o elimínalo para revocar el enlace.",
  "Kahit sino na may link na ito ay puwedeng mag-sign up sa package na ito, kaya ibahagi lang ito sa mga pamilyang pinagkakatiwalaan mo. Itakda ang package sa \"Draft\" o tanggalin ito para mabawi ang link."
 ],
 "Join the community": [
  "Únete a la comunidad",
  "Sumali sa komunidad"
 ],
 "Connect with fellow coaches": [
  "Conecta con otros instructores",
  "Makipag-ugnayan sa kapwa coach"
 ],
 "Coach community": [
  "Comunidad de instructores",
  "Komunidad ng mga coach"
 ],
 "Grow faster with other swim coaches.": [
  "Crece más rápido con otros instructores de natación.",
  "Mas mabilis na umunlad kasama ang ibang swim coach."
 ],
 "Superhero Swim University on Skool is where elite swim instructors share what's working — pricing, marketing, retention, scheduling, the lot. Members swap referrals, ask each other questions, and graduate the playbook together.": [
  "Superhero Swim University en Skool es donde los instructores de natación de élite comparten lo que funciona: precios, marketing, retención, programación y todo lo demás. Los miembros intercambian referencias, se hacen preguntas y desarrollan juntos el manual de estrategias.",
  "Ang Superhero Swim University sa Skool ay kung saan nagbabahaginan ang mga elite swim instructor ng mga epektibong paraan — pricing, marketing, retention, scheduling, at iba pa. Nagpapalitan ng referrals ang mga miyembro, nagtatanungan, at sama-samang binubuo ang playbook."
 ],
 "Honest peer feedback on your business": [
  "Comentarios sinceros de colegas sobre tu negocio",
  "Tapat na feedback ng kapwa mo sa negosyo mo"
 ],
 "Join Superhero Swim University": [
  "Únete a Superhero Swim University",
  "Sumali sa Superhero Swim University"
 ],
 "Get access to hundreds of swim business experts": [
  "Obtén acceso a cientos de expertos en negocios de natación",
  "Magkaroon ng access sa daan-daang eksperto sa swim business"
 ],
 "Community": [
  "Comunidad",
  "Komunidad"
 ],
 "Join": [
  "Únete",
  "Sumali"
 ],
 "on Skool — connect with elite coaches from around the world. Weekly calls, templates, and peer feedback. Start with a": [
  "en Skool — conecta con instructores de élite de todo el mundo. Llamadas semanales, plantillas y comentarios de colegas. Comienza con una",
  "sa Skool — makipag-ugnayan sa mga elite coach mula sa buong mundo. Lingguhang calls, templates, at feedback ng kapwa coach. Magsimula sa isang"
 ],
 "Add another schedule period": [
  "Agregar otro período de horario",
  "Magdagdag ng isa pang panahon ng iskedyul"
 ],
 "Plan up to a year out. When a booking date isn't covered by any period, parents see “Coach not available on this date” instead of a wrong-hour slot. Two periods can share the same dates (e.g. mornings at one pool, evenings at another) as long as their hours don't overlap.": [
  "Planifica con hasta un año de anticipación. Cuando una fecha de reserva no está cubierta por ningún período, los padres verán “Instructor no disponible en esta fecha” en lugar de un horario incorrecto. Dos períodos pueden compartir las mismas fechas (p. ej., mañanas en una piscina y tardes en otra) siempre que sus horarios no se superpongan.",
  "Magplano nang hanggang isang taon. Kapag ang petsa ng booking ay hindi sakop ng anumang panahon, makikita ng mga magulang ang “Hindi available ang coach sa petsang ito” sa halip na slot na may maling oras. Maaaring magkapareho ang mga petsa ng dalawang panahon (hal., umaga sa isang pool, gabi sa iba) basta’t hindi nagsasapawan ang kanilang mga oras."
 ],
 "Couldn't load your schedule settings.": [
  "No se pudieron cargar los ajustes de tu horario.",
  "Hindi ma-load ang iyong mga setting ng iskedyul."
 ],
 "Scheduling note saved.": [
  "Nota de programación guardada.",
  "Na-save ang tala sa pag-iskedyul."
 ],
 "Schedule settings": [
  "Ajustes de horario",
  "Mga setting ng iskedyul"
 ],
 "Who books lesson times, which reminders go out, and quick links to your hours and closed dates.": [
  "Quién reserva los horarios de las lecciones, qué recordatorios se envían y enlaces rápidos a tus horas y fechas cerradas.",
  "Sino ang nagbu-book ng mga oras ng lesson, aling mga paalala ang ipinapadala, at mga mabilisang link sa iyong mga oras at saradong petsa."
 ],
 "Who picks lesson times": [
  "Quién elige los horarios de las lecciones",
  "Sino ang pumipili ng mga oras ng lesson"
 ],
 "You arrange times after families buy.": [
  "Tú coordinas los horarios después de que las familias compran.",
  "Ikaw ang nag-aayos ng mga oras pagkatapos bumili ang mga pamilya."
 ],
 "Parents pick from your open times.": [
  "Los padres eligen entre tus horarios disponibles.",
  "Pumipili ang mga magulang mula sa iyong mga available na oras."
 ],
 "Scheduling / lesson booking": [
  "Programación / reserva de lecciones",
  "Pag-iskedyul / pag-book ng lesson"
 ],
 "Parent self-scheduling on booking page": [
  "Autoprogramación de padres en la página de reserva",
  "Pag-iskedyul ng magulang sa booking page"
 ],
 "Booking-page scheduling note": [
  "Nota de programación en la página de reserva",
  "Tala sa pag-iskedyul sa booking page"
 ],
 "With Open Schedule off: if your classes/packages have set days & times, families see \"You pick your class day & time\" and choose one at checkout (your note shows underneath). If nothing has set times, they see \"Scheduling handled directly with your coach\". Hide the note or use your own words.": [
  "Con Horario abierto desactivado: si tus clases/paquetes tienen días y horarios fijos, las familias verán \"Tú eliges el día y la hora de tu clase\" y escogerán uno al finalizar la compra (tu nota aparece debajo). Si nada tiene horarios fijos, verán \"La programación se gestiona directamente con tu instructor\". Oculta la nota o usa tus propias palabras.",
  "Kapag naka-off ang Open Schedule: kung may nakatakdang araw at oras ang iyong mga klase/package, makikita ng mga pamilya ang \"Ikaw ang pipili ng araw at oras ng iyong klase\" at pipili sila ng isa sa checkout (lalabas ang iyong tala sa ibaba). Kung walang may nakatakdang oras, makikita nila ang \"Direktang inaayos ang pag-iskedyul sa iyong coach\". Itago ang tala o gamitin ang sarili mong mga salita."
 ],
 "Show the scheduling note on my booking page": [
  "Mostrar la nota de programación en mi página de reserva",
  "Ipakita ang tala sa pag-iskedyul sa aking booking page"
 ],
 "Note text (blank = default)": [
  "Texto de la nota (en blanco = predeterminado)",
  "Teksto ng tala (walang laman = default)"
 ],
 "Purchase a package below and your coach will reach out to arrange lesson times that work for your family.": [
  "Compra un paquete abajo y tu instructor se pondrá en contacto para coordinar horarios de lecciones que funcionen para tu familia.",
  "Bumili ng package sa ibaba at makikipag-ugnayan ang iyong coach para ayusin ang mga oras ng lesson na babagay sa iyong pamilya."
 ],
 "Save note": [
  "Guardar nota",
  "I-save ang tala"
 ],
 "Lesson reminders": [
  "Recordatorios de lecciones",
  "Mga paalala sa lesson"
 ],
 "Email only — SplashPad doesn't send texts.": [
  "Solo correo electrónico — SplashPad no envía mensajes de texto.",
  "Email lang — hindi nagpapadala ang SplashPad ng mga text."
 ],
 "Email me 24 hours before each lesson": [
  "Enviarme un correo 24 horas antes de cada lección",
  "I-email ako 24 oras bago ang bawat lesson"
 ],
 "Auto-email parents a lesson reminder": [
  "Enviar automáticamente a los padres un recordatorio de lección por correo electrónico",
  "Awtomatikong mag-email ng paalala sa lesson sa mga magulang"
 ],
 "Hours, closed dates & class times": [
  "Horas, fechas cerradas y horarios de clases",
  "Mga oras, saradong petsa at oras ng klase"
 ],
 "Where the rest of your schedule is shaped.": [
  "Donde se define el resto de tu horario.",
  "Dito hinuhubog ang natitirang bahagi ng iyong iskedyul."
 ],
 "Available hours": [
  "Horas disponibles",
  "Mga available na oras"
 ],
 "Your weekly open-schedule hours, lesson lengths and prices.": [
  "Tus horas semanales de horario abierto, duraciones de lecciones y precios.",
  "Ang iyong lingguhang open-schedule na oras, haba ng lesson, at mga presyo."
 ],
 "Close dates & times": [
  "Cerrar fechas y horas",
  "Isara ang mga petsa at oras"
 ],
 "Holidays, pool closures, or a few hours off.": [
  "Días festivos, cierres de piscina o unas horas libres.",
  "Mga holiday, pagsasara ng pool, o ilang oras na pahinga."
 ],
 "Fixed weekly class slots live on each package.": [
  "Los horarios semanales fijos de clase están en cada paquete.",
  "Ang mga nakapirming lingguhang slot ng klase ay nasa bawat package."
 ],
 "Your coach hasn't shared a scheduling link yet.": [
  "Tu instructor aún no ha compartido un enlace de programación.",
  "Hindi pa nagbabahagi ang iyong coach ng link sa pag-iskedyul."
 ],
 "Once a lesson is booked, this calendar will appear here.": [
  "Una vez reservada una lección, este calendario aparecerá aquí.",
  "Kapag na-book na ang isang lesson, lalabas dito ang kalendaryong ito."
 ],
 "Your coach uses an external scheduler. Tap below to pick a time — your slot will sync back to them automatically.": [
  "Tu instructor usa un programador externo. Toca abajo para elegir un horario; tu reserva se sincronizará automáticamente con él.",
  "Gumagamit ang iyong coach ng external scheduler. I-tap sa ibaba para pumili ng oras — awtomatikong magsi-sync pabalik sa kanila ang iyong slot."
 ],
 "Open scheduler": [
  "Abrir programador",
  "Buksan ang scheduler"
 ],
 "Open full size": [
  "Abrir a tamaño completo",
  "Buksan sa buong laki"
 ],
 "Something went wrong": [
  "Algo salió mal",
  "May nangyaring mali"
 ],
 "This page hit an unexpected error — it wasn't caused by anything you did, and our team has been notified automatically.": [
  "Esta página encontró un error inesperado; no fue causado por nada que hiciste y nuestro equipo ha sido notificado automáticamente.",
  "Nagkaroon ng hindi inaasahang error ang page na ito — hindi ito dahil sa anumang ginawa mo, at awtomatikong naabisuhan ang aming team."
 ],
 "This can't be changed later": [
  "Esto no se puede cambiar después",
  "Hindi na ito mababago sa huli"
 ],
 ", so pick the country where you actually live and bank.": [
  ", así que elige el país donde realmente vives y tienes tu cuenta bancaria.",
  ", kaya piliin ang bansang talagang tinitirhan mo at kung saan ka nagba-bank."
 ],
 "Country": [
  "País",
  "Bansa"
 ],
 "Select your country": [
  "Selecciona tu país",
  "Piliin ang iyong bansa"
 ],
 "Don't see your country? It means Stripe doesn't yet support coach payouts there — email support@splashpad.pro and we'll look into alternatives.": [
  "¿No ves tu país? Significa que Stripe todavía no admite pagos a instructores allí; envía un correo a support@splashpad.pro y veremos alternativas.",
  "Hindi makita ang bansa mo? Ibig sabihin, hindi pa sinusuportahan ng Stripe ang payouts para sa mga coach doon — mag-email sa support@splashpad.pro at titingnan namin ang mga alternatibo."
 ],
 "Continue to Stripe": [
  "Continuar a Stripe",
  "Magpatuloy sa Stripe"
 ],
 "Start Stripe setup over?": [
  "¿Empezar de nuevo la configuración de Stripe?",
  "Simulan muli ang pag-set up ng Stripe?"
 ],
 "This clears the Stripe account you partially set up so you can pick a different country.": [
  "Esto borra la cuenta de Stripe que configuraste parcialmente para que puedas elegir otro país.",
  "Buburahin nito ang Stripe account na bahagya mong na-set up para makapili ka ng ibang bansa."
 ],
 "Safe to do": [
  "Seguro hacerlo",
  "Ligtas gawin"
 ],
 "because your Stripe account hasn't started accepting payouts yet — no parent transactions are tied to it. Your SplashPad account, students, packages, and schedule are": [
  "porque tu cuenta de Stripe aún no ha comenzado a aceptar pagos — no hay transacciones de padres vinculadas a ella. Tu cuenta de SplashPad, estudiantes, paquetes y horario no se verán",
  "dahil hindi pa nagsisimulang tumanggap ng payouts ang iyong Stripe account — wala pang parent transactions na naka-link dito. Ang iyong SplashPad account, mga estudyante, package, at iskedyul ay"
 ],
 "unaffected": [
  "afectados",
  "hindi maaapektuhan"
 ],
 "After you confirm, tap": [
  "Después de confirmar, toca",
  "Pagkatapos mong kumpirmahin, i-tap ang"
 ],
 "to pick the right country and restart onboarding.": [
  "para elegir el país correcto y reiniciar la incorporación.",
  "para piliin ang tamang bansa at simulan muli ang onboarding."
 ],
 "Resetting…": [
  "Restableciendo…",
  "Nire-reset…"
 ],
 "Yes, start over": [
  "Sí, empezar de nuevo",
  "Oo, magsimula muli"
 ],
 "Status changed:": [
  "Estado cambiado:",
  "Nagbago ang status:"
 ],
 "(was different a moment ago — your Settings card is now up to date)": [
  "(era distinto hace un momento; tu tarjeta de Configuración ahora está actualizada)",
  "(iba ito kanina lang — updated na ngayon ang iyong Settings card)"
 ],
 "Open Stripe dashboard": [
  "Abrir panel de Stripe",
  "Buksan ang Stripe dashboard"
 ],
 "Stripe troubleshooting": [
  "Solución de problemas de Stripe",
  "Pag-troubleshoot sa Stripe"
 ],
 "Try these in order — most coaches get sorted by step 3 without needing support.": [
  "Prueba estos pasos en orden: la mayoría de los instructores lo resuelven en el paso 3 sin necesitar soporte.",
  "Subukan ang mga ito nang sunod-sunod — karamihan sa mga coach ay naaayos ito pagsapit ng step 3 nang hindi na kailangan ng support."
 ],
 "on the card above. We'll re-check your real status with Stripe and tell you exactly what's wrong.": [
  "en la tarjeta de arriba. Volveremos a verificar tu estado real con Stripe y te diremos exactamente qué está mal.",
  "sa card sa itaas. Muli naming iche-check ang iyong tunay na status sa Stripe at sasabihin namin sa iyo kung ano mismo ang mali."
 ],
 "If the diagnostic says": [
  "Si el diagnóstico dice",
  "Kung sinasabi ng diagnostic na"
 ],
 ", tap that button. You'll log into your existing Stripe account and re-authorize Splash Pad (about 30 seconds). Your money, bank info, and history all stay in place.": [
  ", toca ese botón. Iniciarás sesión en tu cuenta de Stripe existente y volverás a autorizar a Splash Pad (unos 30 segundos). Tu dinero, datos bancarios e historial permanecerán intactos.",
  ", i-tap ang button na iyon. Magla-log in ka sa iyong kasalukuyang Stripe account at muling ia-authorize ang Splash Pad (mga 30 segundo). Mananatili sa lugar ang iyong pera, bank info, at history."
 ],
 "If it says": [
  "Si dice",
  "Kung sinasabi nito na"
 ],
 ", do that and finish whatever Stripe is asking for (usually updated documents or ID verification). Then come back and tap Force refresh.": [
  ", hazlo y completa lo que Stripe te pida (normalmente documentos actualizados o verificación de identidad). Luego vuelve y toca Forzar actualización.",
  ", gawin iyon at tapusin kung ano man ang hinihingi ng Stripe (karaniwan ay updated na mga dokumento o ID verification). Pagkatapos, bumalik at i-tap ang Force refresh."
 ],
 "onboarding isn't finished": [
  "la incorporación no está terminada",
  "hindi pa tapos ang onboarding"
 ],
 ", tap": [
  ", toca",
  ", i-tap ang"
 ],
 "and complete the remaining steps. Most coaches wrap up in 2–3 minutes.": [
  "y completa los pasos restantes. La mayoría de los instructores terminan en 2–3 minutos.",
  "at kumpletuhin ang mga natitirang hakbang. Karamihan sa mga coach ay natatapos sa loob ng 2–3 minuto."
 ],
 "Still stuck? Email": [
  "¿Sigues atascado? Envía un correo a",
  "Na-stuck ka pa rin? Mag-email sa"
 ],
 "with a screenshot of the diagnostic dialog. We respond within a few hours during business hours.": [
  "con una captura de pantalla del diálogo de diagnóstico. Respondemos en unas horas durante el horario laboral.",
  "na may screenshot ng diagnostic dialog. Sumasagot kami sa loob ng ilang oras kapag business hours."
 ],
 "Reassurance:": [
  "Tranquilidad:",
  "Pampalubag-loob:"
 ],
 "Disconnects don't affect your money or your bank account on Stripe's side. They're almost always just an authorization that needs to be renewed.": [
  "Las desconexiones no afectan tu dinero ni tu cuenta bancaria del lado de Stripe. Casi siempre son solo una autorización que necesita renovarse.",
  "Ang mga pagkakadiskonekta ay hindi nakakaapekto sa iyong pera o sa iyong bank account sa panig ng Stripe. Halos palagi, authorization lang ito na kailangang i-renew."
 ],
 "Email support": [
  "Enviar correo a soporte",
  "Mag-email sa support"
 ],
 "Open your Stripe dashboard": [
  "Abre tu panel de Stripe",
  "Buksan ang iyong Stripe dashboard"
 ],
 "to view payouts, update your bank account, and review payments. You can return to Splash Pad with your browser's back button.": [
  "para ver pagos, actualizar tu cuenta bancaria y revisar cobros. Puedes volver a Splash Pad con el botón de atrás de tu navegador.",
  "para tingnan ang payouts, i-update ang iyong bank account, at suriin ang mga bayad. Maaari kang bumalik sa Splash Pad gamit ang back button ng iyong browser."
 ],
 "Open in a new tab": [
  "Abrir en una nueva pestaña",
  "Buksan sa bagong tab"
 ],
 "Or copy the link": [
  "O copia el enlace",
  "O kopyahin ang link"
 ],
 "The link is single-use and expires in a few minutes. If it doesn't work, close this dialog and tap": [
  "El enlace es de un solo uso y vence en unos minutos. Si no funciona, cierra este cuadro de diálogo y toca",
  "Ang link ay pang-isahang gamit at mag-e-expire sa loob ng ilang minuto. Kung hindi ito gumana, isara ang dialog na ito at i-tap"
 ],
 "again.": [
  "de nuevo.",
  "muli."
 ],
 "Your card was declined. Please try a different card.": [
  "Tu tarjeta fue rechazada. Prueba con otra tarjeta.",
  "Na-decline ang iyong card. Pakisubukan ang ibang card."
 ],
 "Card details are tokenised by Stripe — never stored on SplashPad servers.": [
  "Los datos de la tarjeta son tokenizados por Stripe; nunca se almacenan en los servidores de SplashPad.",
  "Ang mga detalye ng card ay tine-tokenize ng Stripe — hindi kailanman iniimbak sa mga server ng SplashPad."
 ],
 "Your plan": [
  "Tu plan",
  "Ang iyong plan"
 ],
 "renews automatically each month at $": [
  "se renueva automáticamente cada mes por $",
  "ay awtomatikong nagre-renew bawat buwan sa halagang $"
 ],
 "until you cancel": [
  "hasta que canceles",
  "hanggang sa kanselahin mo"
 ],
 ". Cancel anytime under Your Subscription — access continues through the period you’ve paid for.": [
  ". Cancela cuando quieras en Tu Suscripción: el acceso continúa durante el período que ya pagaste.",
  ". Kanselahin anumang oras sa Iyong Subscription — magpapatuloy ang access hanggang sa katapusan ng panahong nabayaran mo na."
 ],
 "Save new card": [
  "Guardar nueva tarjeta",
  "I-save ang bagong card"
 ],
 "Update your payment card": [
  "Actualizar tu tarjeta de pago",
  "I-update ang iyong payment card"
 ],
 "Your plan and next billing date stay the same — this only replaces the card we charge. Your old card stays on file until the new one is saved.": [
  "Tu plan y la próxima fecha de facturación siguen siendo los mismos; esto solo reemplaza la tarjeta que cobramos. Tu tarjeta anterior permanece registrada hasta que se guarde la nueva.",
  "Mananatiling pareho ang iyong plan at susunod na petsa ng pagsingil — papalitan lang nito ang card na sinisingil namin. Mananatili sa file ang dati mong card hanggang sa ma-save ang bago."
 ],
 "Loading secure card form…": [
  "Cargando formulario seguro de tarjeta…",
  "Nilo-load ang secure na form ng card…"
 ],
 "Starter limit reached": [
  "Límite Starter alcanzado",
  "Naabot na ang Starter limit"
 ],
 "You’re growing": [
  "Estás creciendo",
  "Lumalaki ka"
 ],
 "New enrollments and approvals are paused until you upgrade — Pro removes the limit entirely.": [
  "Las nuevas inscripciones y aprobaciones están en pausa hasta que actualices tu plan; Pro elimina el límite por completo.",
  "Naka-pause ang mga bagong enrollment at approval hanggang mag-upgrade ka — inaalis ng Pro ang limit nang buo."
 ],
 "Everything you unlock with Pro": [
  "Todo lo que desbloqueas con Pro",
  "Lahat ng maa-unlock mo sa Pro"
 ],
 "Beautiful, organized, structured — and built right into the account you already use.": [
  "Atractivo, organizado y estructurado, y ya integrado en la cuenta que ya usas.",
  "Maganda, organisado, maayos ang pagkakabuo — at built in na mismo sa account na ginagamit mo na."
 ],
 "Pro ·": [
  "Pro ·",
  "Pro ·"
 ],
 "· cancel anytime": [
  "· cancela cuando quieras",
  "· kanselahin anumang oras"
 ],
 "Remind me in": [
  "Recuérdamelo en",
  "Ipaalala sa akin sa loob ng"
 ],
 "One package has no swimmer limit": [
  "Un paquete no tiene límite de nadadores",
  "May isang package na walang limit sa swimmer"
 ],
 "Their class times can never show": [
  "Los horarios de sus clases nunca pueden mostrar",
  "Hindi kailanman maipapakita ang oras ng kanilang class bilang"
 ],
 "\"Full\"": [
  "\"Lleno\"",
  "\"Full\""
 ],
 ", so a second family could book a time you've already filled. Tap": [
  ", así que una segunda familia podría reservar un horario que ya has llenado. Toca",
  ", kaya maaaring makapag-book ang pangalawang pamilya ng oras na napuno mo na. I-tap ang"
 ],
 "Set to 1": [
  "Establecer en 1",
  "Itakda sa 1"
 ],
 "for private lessons — or edit the package if you teach groups.": [
  "para clases privadas, o edita el paquete si enseñas a grupos.",
  "para sa private lessons — o i-edit ang package kung nagtuturo ka ng grupo."
 ],
 "· currently unlimited": [
  "· actualmente ilimitado",
  "· kasalukuyang walang limit"
 ],
 "Set all to 1": [
  "Establecer todo en 1",
  "Itakda lahat sa 1"
 ],
 "You’re live on splashpad.pro!": [
  "¡Ya estás en vivo en splashpad.pro!",
  "Live ka na sa splashpad.pro!"
 ],
 "Thank you for the honest feedback!": [
  "¡Gracias por tus comentarios sinceros!",
  "Salamat sa tapat mong feedback!"
 ],
 "Your review now appears on the SplashPad homepage — thank you for helping other coaches find us.": [
  "Tu reseña ahora aparece en la página principal de SplashPad. Gracias por ayudar a otros instructores a encontrarnos.",
  "Lumalabas na ngayon ang iyong review sa homepage ng SplashPad — salamat sa pagtulong sa ibang coach na mahanap kami."
 ],
 "We read every answer and use it to make SplashPad better for your business.": [
  "Leemos cada respuesta y la usamos para hacer que SplashPad sea mejor para tu negocio.",
  "Binabasa namin ang bawat sagot at ginagamit ito para pagandahin ang SplashPad para sa iyong negosyo."
 ],
 "See it live": [
  "Verlo en vivo",
  "Tingnan ito nang live"
 ],
 "How’s SplashPad working for you?": [
  "¿Cómo te está funcionando SplashPad?",
  "Kumusta ang paggamit mo ng SplashPad?"
 ],
 "2 minutes, straight from the founder — your honest review helps other swim coaches find us.": [
  "2 minutos, directamente del fundador: tu reseña sincera ayuda a otros instructores de natación a encontrarnos.",
  "2 minuto lang, direkta mula sa founder — ang tapat mong review ay tumutulong sa ibang swim coach na mahanap kami."
 ],
 "How many stars would you give SplashPad?": [
  "¿Cuántas estrellas le darías a SplashPad?",
  "Ilang bituin ang ibibigay mo sa SplashPad?"
 ],
 "In your own words — how has SplashPad benefited your business?": [
  "En tus propias palabras, ¿cómo ha beneficiado SplashPad a tu negocio?",
  "Sa sarili mong mga salita — paano nakatulong ang SplashPad sa negosyo mo?"
 ],
 "e.g. I replaced my spreadsheet, paper waivers, and payment chasing with one link…": [
  "p. ej., reemplacé mi hoja de cálculo, las exenciones en papel y el seguimiento de pagos con un solo enlace…",
  "hal. pinalitan ko ang spreadsheet ko, mga paper waiver, at pangungulit sa bayad ng iisang link…"
 ],
 "Your name": [
  "Tu nombre",
  "Pangalan mo"
 ],
 "Swim school name": [
  "Nombre de la escuela de natación",
  "Pangalan ng swim school"
 ],
 "Location (city, state)": [
  "Ubicación (ciudad, estado)",
  "Lokasyon (lungsod, estado)"
 ],
 "Miami, FL": [
  "Miami, FL",
  "Miami, FL"
 ],
 "You may feature my review, name, swim school, and photo on splashpad.pro.": [
  "Pueden mostrar mi reseña, nombre, escuela de natación y foto en splashpad.pro.",
  "Maaari ninyong itampok ang review, pangalan, swim school, at larawan ko sa splashpad.pro."
 ],
 "Submit my review": [
  "Enviar mi reseña",
  "Isumite ang review ko"
 ],
 "Verified coach": [
  "Instructor verificado",
  "Verified coach"
 ],
 "average": [
  "promedio",
  "average"
 ],
 "verified": [
  "verificado",
  "verified"
 ],
 "coach": [
  "instructor",
  "coach"
 ],
 "coaches": [
  "instructores",
  "mga coach"
 ],
 "% say it’s helping their business a lot": [
  "% dice que está ayudando mucho a su negocio",
  "% ang nagsasabing malaki ang naitutulong nito sa kanilang negosyo"
 ],
 "Please enter your name.": [
  "Por favor, ingresa tu nombre.",
  "Pakilagay ang pangalan mo."
 ],
 "Please enter a valid email.": [
  "Por favor, ingresa un correo electrónico válido.",
  "Pakilagay ang wastong email."
 ],
 "Please enter your street address so the coach can plan the drive.": [
  "Por favor, ingresa tu dirección para que el coach pueda planificar el trayecto.",
  "Pakilagay ang street address mo para maplano ng coach ang biyahe."
 ],
 "Request lessons at your home": [
  "Solicitar clases en tu casa",
  "Humiling ng lessons sa bahay mo"
 ],
 "Sent! Your request is in the coach’s inbox.": [
  "¡Enviado! Tu solicitud está en la bandeja de entrada del instructor.",
  "Naipadala na! Nasa inbox na ng coach ang request mo."
 ],
 "Request sent": [
  "Solicitud enviada",
  "Naipadala na ang request"
 ],
 "got a notification with your address and preferred times. Most coaches reply within a day.": [
  "recibió una notificación con tu dirección y los horarios que prefieres. La mayoría de los instructores responden dentro de un día.",
  "nakatanggap ng notification kasama ang address mo at mga gusto mong oras. Karamihan sa mga coach ay sumasagot sa loob ng isang araw."
 ],
 "Jordan Rivera": [
  "Jordan Rivera",
  "Jordan Rivera"
 ],
 "Swimmers": [
  "Nadadores",
  "Mga swimmer"
 ],
 "(names & ages)": [
  "(nombres y edades)",
  "(mga pangalan at edad)"
 ],
 "Ava (4), Max (6)": [
  "Ava (4), Max (6)",
  "Ava (4), Max (6)"
 ],
 "Lesson address": [
  "Dirección de la clase",
  "Address ng lesson"
 ],
 "123 Main St, City, ST 12345": [
  "123 Main St, City, ST 12345",
  "123 Main St, City, ST 12345"
 ],
 "Days that work": [
  "Días disponibles",
  "Mga araw na puwede"
 ],
 "Preferred days": [
  "Días preferidos",
  "Mga gustong araw"
 ],
 "Times that work": [
  "Horarios disponibles",
  "Mga oras na puwede"
 ],
 "e.g. weekdays after 4pm, Saturday mornings": [
  "p. ej., entre semana después de las 4 p. m., sábados por la mañana",
  "hal. weekdays pagkatapos ng 4pm, Sabado ng umaga"
 ],
 "Anything else?": [
  "¿Algo más?",
  "May iba pa?"
 ],
 "Pool details, gate code, kids' experience level…": [
  "Detalles de la piscina, código de la puerta, nivel de experiencia de los niños…",
  "Mga detalye ng pool, gate code, antas ng karanasan ng mga bata…"
 ],
 "Note saved.": [
  "Nota guardada.",
  "Na-save ang note."
 ],
 "Home lesson requests": [
  "Solicitudes de clases a domicilio",
  "Mga request para sa home lesson"
 ],
 "new": [
  "nuevo",
  "bago"
 ],
 "Families who couldn't find a time on your route (Travel Smart). Shuffle a lesson or two and reach out.": [
  "Familias que no pudieron encontrar un horario en tu ruta (Travel Smart). Reorganiza una o dos clases y contáctalas.",
  "Mga pamilyang hindi makahanap ng oras sa ruta mo (Travel Smart). Ilipat-lipat ang isa o dalawang lesson at makipag-ugnayan."
 ],
 "Hide closed": [
  "Ocultar cerradas",
  "Itago ang mga sarado"
 ],
 "No open requests. When a family can't find a time on your route, their request lands here (and in your bell).": [
  "No hay solicitudes abiertas. Cuando una familia no puede encontrar un horario en tu ruta, su solicitud aparece aquí (y en tu campana).",
  "Walang bukas na request. Kapag hindi makahanap ng oras ang isang pamilya sa ruta mo, dito lalabas ang request nila (at sa bell mo)."
 ],
 "From your website": [
  "Desde tu sitio web",
  "Mula sa website mo"
 ],
 "From the parent portal": [
  "Desde el portal para padres",
  "Mula sa parent portal"
 ],
 "Accepted:": [
  "Aceptado:",
  "Tinanggap:"
 ],
 "offered": [
  "ofrecido",
  "naialok"
 ],
 "mi from base": [
  "mi desde la base",
  "mi mula sa base"
 ],
 "Any day": [
  "Cualquier día",
  "Anumang araw"
 ],
 "Preferred times": [
  "Horarios preferidos",
  "Mga gustong oras"
 ],
 "They were sent to book + pay for that time in their portal.": [
  "Se les indicó que reservaran y pagaran ese horario en su portal.",
  "Pinadalhan sila para mag-book + magbayad para sa oras na iyon sa portal nila."
 ],
 "They were sent to your apply flow with that time noted — schedule it once you approve them.": [
  "Se les envió a tu flujo de solicitud con ese horario indicado; prográmalo una vez que los apruebes.",
  "Pinadala sila sa apply flow mo na may nakatalang oras na iyon — i-schedule ito kapag na-approve mo na sila."
 ],
 "Times offered · waiting on the family": [
  "Horarios ofrecidos · esperando a la familia",
  "Mga inialok na oras · naghihintay sa pamilya"
 ],
 "min)": [
  "min)",
  "min)"
 ],
 "Offer new times": [
  "Ofrecer nuevos horarios",
  "Mag-alok ng mga bagong oras"
 ],
 "Offer times": [
  "Ofrecer horarios",
  "Mag-alok ng mga oras"
 ],
 "See on route map": [
  "Ver en el mapa de ruta",
  "Tingnan sa route map"
 ],
 "Your notes": [
  "Tus notas",
  "Mga note mo"
 ],
 "e.g. Could swap Thursday 4pm with the Millers…": [
  "p. ej. Podría cambiar el jueves a las 4 p. m. con los Miller…",
  "hal. Puwedeng ipagpalit ang Huwebes 4pm sa mga Miller…"
 ],
 "Live for parents": [
  "Visible para los padres",
  "Live para sa mga magulang"
 ],
 "Families type their address and only see lesson times that fit your driving route that day — no more 40-minute detours between back-to-back lessons.": [
  "Las familias escriben su dirección y solo ven horarios de clase que encajan con tu ruta de manejo ese día; ya no más desvíos de 40 minutos entre clases consecutivas.",
  "Ita-type ng mga pamilya ang address nila at lesson times lang ang makikita nila na pasok sa driving route mo sa araw na iyon — wala nang 40-minute na detour sa pagitan ng magkasunod na lesson."
 ],
 "Turn Travel Smart on or off": [
  "Activar o desactivar Travel Smart",
  "I-on o i-off ang Travel Smart"
 ],
 "Turned on, but not showing to parents yet.": [
  "Activado, pero aún no se muestra a los padres.",
  "Naka-on, pero hindi pa ipinapakita sa mga magulang."
 ],
 "Set": [
  "Establecer",
  "Itakda"
 ],
 "above to": [
  "arriba a",
  "sa itaas sa"
 ],
 "You travel to families": [
  "Tú viajas a las familias",
  "Ikaw ang bumibiyahe papunta sa mga pamilya"
 ],
 "Home base on the map": [
  "Base en el mapa",
  "Home base sa mapa"
 ],
 "Parents can see your open times": [
  "Los padres pueden ver tus horarios disponibles",
  "Makikita ng mga magulang ang mga bakante mong oras"
 ],
 "Max detour between lessons": [
  "Desvío máximo entre clases",
  "Pinakamalaking detour sa pagitan ng mga lesson"
 ],
 "Max detour miles": [
  "Millas máximas de desvío",
  "Pinakamalaking detour miles"
 ],
 "A time slot shows for a family only if their home is within this distance of the lesson right before or after it. Smaller = tighter routes, fewer options.": [
  "Una franja horaria se muestra a una familia solo si su hogar está dentro de esta distancia de la clase inmediatamente anterior o posterior. Menor = rutas más ajustadas, menos opciones.",
  "Magpapakita lang ang isang time slot para sa isang pamilya kung ang bahay nila ay nasa loob ng distansyang ito mula sa lesson kaagad bago o pagkatapos nito. Mas maliit = mas masisikip na ruta, mas kaunting pagpipilian."
 ],
 "How far you'll travel from home base": [
  "Qué tan lejos viajarás desde tu base",
  "Gaano kalayo ang bibiyahehin mo mula sa home base"
 ],
 "Service radius miles": [
  "Radio de servicio en millas",
  "Service radius sa miles"
 ],
 "On days with nothing booked yet, any family inside this radius sees all your open times — the route can start anywhere.": [
  "En los días en que todavía no haya nada reservado, cualquier familia dentro de este radio verá todos tus horarios disponibles; la ruta puede comenzar en cualquier lugar.",
  "Sa mga araw na wala pang naka-book, makikita ng anumang pamilyang nasa loob ng radius na ito ang lahat ng bukas mong oras — puwedeng magsimula ang ruta kahit saan."
 ],
 "How parents experience it": [
  "Cómo lo viven los padres",
  "Paano ito nararanasan ng mga magulang"
 ],
 "1. They type their address": [
  "1. Escriben su dirección",
  "1. Tina-type nila ang address nila"
 ],
 "On your website (“Do we come to you?”) or in their parent portal.": [
  "En tu sitio web (“¿Vamos a su domicilio?”) o en su portal para padres.",
  "Sa website mo (“Pumupunta ba kami sa inyo?”) o sa parent portal nila."
 ],
 "2. We check your route": [
  "2. Revisamos tu ruta",
  "2. Chine-check namin ang ruta mo"
 ],
 "Only the open times near your other lessons that day stay visible.": [
  "Solo seguirán visibles los horarios disponibles cercanos a tus otras clases de ese día.",
  "Ang mananatiling visible lang ay ang mga bukas na oras na malapit sa iba mong lessons sa araw na iyon."
 ],
 "3. Nothing fits? They ask": [
  "3. ¿Nada encaja? Ellos preguntan",
  "3. Walang bagay? Magre-request sila"
 ],
 "A “Request a home visit” lands in your bell + Leads so you can shuffle things around.": [
  "Una “Solicitud de clase a domicilio” llega a tu campana + Leads para que puedas reorganizar las cosas.",
  "May “Request a home visit” na papasok sa bell mo + Leads para maipagpalit-palit mo ang mga bagay."
 ],
 "new home-lesson": [
  "nueva clase a domicilio",
  "bagong home-lesson"
 ],
 "waiting": [
  "en espera",
  "naghihintay"
 ],
 "Open in Leads": [
  "Abrir en Leads",
  "Buksan sa Leads"
 ],
 "Your browser does not support embedded videos.": [
  "Tu navegador no admite videos incrustados.",
  "Hindi sinusuportahan ng browser mo ang embedded videos."
 ],
 "Everything SplashPad does for your business — in 3 minutes.": [
  "Todo lo que SplashPad hace por tu negocio, en 3 minutos.",
  "Lahat ng ginagawa ng SplashPad para sa negosyo mo — sa loob ng 3 minuto."
 ],
 "See everything SplashPad can do": [
  "Ver todo lo que SplashPad puede hacer",
  "Tingnan ang lahat ng kayang gawin ng SplashPad"
 ],
 "One video, every feature — watch Splash walk through the whole platform, then pick the plan that fits below.": [
  "Un video, todas las funciones: mira a Splash recorrer toda la plataforma y luego elige el plan que mejor se adapte abajo.",
  "Isang video, lahat ng feature — panoorin si Splash na ilibot ang buong platform, tapos piliin ang plan na akma sa ibaba."
 ],
 "Play the SplashPad tutorial video — every feature in 3 minutes": [
  "Reproducir el video tutorial de SplashPad: todas las funciones en 3 minutos",
  "I-play ang tutorial video ng SplashPad — lahat ng feature sa loob ng 3 minuto"
 ],
 "SplashPad in 3 minutes": [
  "SplashPad en 3 minutos",
  "SplashPad sa loob ng 3 minuto"
 ],
 "Every feature, shown for real — click to play": [
  "Todas las funciones, mostradas de verdad: haz clic para reproducir",
  "Lahat ng feature, totoong ipinapakita — i-click para i-play"
 ],
 "Add a second factor to lock down your account.": [
  "Agrega un segundo factor para proteger tu cuenta.",
  "Magdagdag ng second factor para maseguro ang account mo."
 ],
 "Your account holds your families' contact info, waivers, and payment history. A one-tap code from your phone makes it dramatically harder for anyone to steal it — even if your password ever leaked in an unrelated breach. Takes about 90 seconds.": [
  "Tu cuenta contiene la información de contacto de tus familias, exenciones de responsabilidad y el historial de pagos. Un código de un toque desde tu teléfono hace que sea muchísimo más difícil que alguien lo robe, incluso si tu contraseña alguna vez se filtró en una vulneración no relacionada. Toma unos 90 segundos.",
  "Nasa account mo ang contact info ng mga pamilya mo, mga waiver, at payment history. Ang one-tap code mula sa phone mo ay nagpapahirap nang husto para nakawin ito ng kahit sino — kahit na na-leak man ang password mo sa isang hiwalay na breach. Mga 90 segundo lang ito."
 ],
 "Set up 2FA": [
  "Configurar 2FA",
  "I-set up ang 2FA"
 ],
 "Copy failed": [
  "Error al copiar",
  "Hindi nakopya"
 ],
 "Loading security settings…": [
  "Cargando la configuración de seguridad…",
  "Nilo-load ang security settings…"
 ],
 "Authenticator app connected.": [
  "Aplicación de autenticación conectada.",
  "Nakakonekta na ang authenticator app."
 ],
 "Email could not be sent — check that the SplashPad email backend is configured.": [
  "No se pudo enviar el correo electrónico; verifica que el backend de correo electrónico de SplashPad esté configurado.",
  "Hindi naipadala ang email — tiyaking naka-configure ang SplashPad email backend."
 ],
 "Email codes enabled.": [
  "Códigos por correo electrónico habilitados.",
  "Naka-enable ang email codes."
 ],
 "New backup codes generated. Save them now.": [
  "Se generaron nuevos códigos de respaldo. Guárdalos ahora.",
  "Nakabuo ng mga bagong backup code. I-save mo na sila ngayon."
 ],
 "Two-factor authentication disabled.": [
  "Autenticación de dos factores desactivada.",
  "Na-disable ang two-factor authentication."
 ],
 "Device revoked. They'll need a code on next login.": [
  "Dispositivo revocado. Necesitarán un código en el próximo inicio de sesión.",
  "Na-revoke ang device. Kakailanganin nila ng code sa susunod na login."
 ],
 "Two-factor authentication": [
  "Autenticación de dos factores",
  "Two-factor authentication"
 ],
 "Add a second step to logins. Even if your password is stolen, nobody can sign in without your phone or backup code.": [
  "Agrega un segundo paso a los inicios de sesión. Incluso si te roban la contraseña, nadie podrá iniciar sesión sin tu teléfono o código de respaldo.",
  "Magdagdag ng pangalawang hakbang sa mga login. Kahit manakaw ang password mo, walang makaka-sign in nang wala ang phone mo o backup code."
 ],
 "Authenticator app": [
  "Aplicación de autenticación",
  "Authenticator app"
 ],
 "Use Google Authenticator, 1Password, or Authy.": [
  "Usa Google Authenticator, 1Password o Authy.",
  "Gumamit ng Google Authenticator, 1Password, o Authy."
 ],
 "Re-configure": [
  "Volver a configurar",
  "I-configure muli"
 ],
 "Set up": [
  "Configurar",
  "I-set up"
 ],
 "Email code": [
  "Código por correo electrónico",
  "Code sa email"
 ],
 "Receive a 6-digit code at your account email.": [
  "Recibe un código de 6 dígitos en el correo electrónico de tu cuenta.",
  "Makatanggap ng 6-digit na code sa email ng iyong account."
 ],
 "Resend code": [
  "Reenviar código",
  "Ipadala muli ang code"
 ],
 "Backup codes": [
  "Códigos de respaldo",
  "Mga backup code"
 ],
 "of 8 remaining": [
  "de 8 restantes",
  "sa 8 na natitira"
 ],
 "Regenerate": [
  "Regenerar",
  "Bumuo muli"
 ],
 "Only": [
  "Solo",
  "Na lang"
 ],
 "backup code": [
  "código de respaldo",
  "backup code"
 ],
 "left.": [
  "restante.",
  "ang natitira."
 ],
 "Generate a fresh set now so you don't get locked out if you lose access to your authenticator app.": [
  "Genera ahora un nuevo conjunto para no quedarte sin acceso si pierdes acceso a tu aplicación de autenticación.",
  "Gumawa ng bagong set ngayon para hindi ka ma-lock out kung mawalan ka ng access sa iyong authenticator app."
 ],
 "Last verified": [
  "Última verificación",
  "Huling na-verify"
 ],
 "Turn off 2FA": [
  "Desactivar 2FA",
  "I-off ang 2FA"
 ],
 "Trusted devices": [
  "Dispositivos de confianza",
  "Mga pinagkakatiwalaang device"
 ],
 "Browsers you marked as trusted skip the 2FA step at login for 30 days. Revoke any you no longer recognize.": [
  "Los navegadores que marcaste como de confianza omiten el paso de 2FA al iniciar sesión durante 30 días. Revoca cualquiera que ya no reconozcas.",
  "Ang mga browser na minarkahan mong pinagkakatiwalaan ay lalaktawan ang 2FA step sa pag-login sa loob ng 30 araw. I-revoke ang alinman na hindi mo na nakikilala."
 ],
 "No trusted devices yet.": [
  "Aún no hay dispositivos de confianza.",
  "Wala pang pinagkakatiwalaang device."
 ],
 "Added": [
  "Agregado",
  "Idinagdag"
 ],
 "· expires": [
  "· vence",
  "· mag-e-expire"
 ],
 "· IP": [
  "· IP",
  "· IP"
 ],
 "Revoke": [
  "Revocar",
  "I-revoke"
 ],
 "Connect authenticator app": [
  "Conectar aplicación de autenticación",
  "Ikonekta ang authenticator app"
 ],
 "Scan this QR with Google Authenticator, 1Password, Authy, or any TOTP app — then enter the 6-digit code it shows.": [
  "Escanea este código QR con Google Authenticator, 1Password, Authy o cualquier aplicación TOTP; luego ingresa el código de 6 dígitos que muestre.",
  "I-scan ang QR na ito gamit ang Google Authenticator, 1Password, Authy, o anumang TOTP app — pagkatapos ilagay ang 6-digit na code na ipinapakita nito."
 ],
 "Can't scan?": [
  "¿No puedes escanearlo?",
  "Hindi ma-scan?"
 ],
 "Enter 6-digit code": [
  "Ingresa el código de 6 dígitos",
  "Ilagay ang 6-digit na code"
 ],
 "Activate": [
  "Activar",
  "I-activate"
 ],
 "Verify your email": [
  "Verifica tu correo electrónico",
  "I-verify ang iyong email"
 ],
 "We sent a 6-digit code to": [
  "Enviamos un código de 6 dígitos a",
  "Nagpadala kami ng 6-digit na code sa"
 ],
 ". Enter it below.": [
  ". Introdúcelo abajo.",
  ". Ilagay ito sa ibaba."
 ],
 "Sending a code to your account email…": [
  "Enviando un código al correo electrónico de tu cuenta…",
  "Nagpapadala ng code sa email ng iyong account…"
 ],
 "6-digit code": [
  "Código de 6 dígitos",
  "6-digit na code"
 ],
 "Regenerate backup codes": [
  "Regenerar códigos de respaldo",
  "Bumuo muli ng mga backup code"
 ],
 "Save your backup codes": [
  "Guarda tus códigos de respaldo",
  "I-save ang iyong mga backup code"
 ],
 "Generating fresh codes will invalidate all existing ones. Re-enter your password to continue.": [
  "Generar códigos nuevos invalidará todos los existentes. Vuelve a ingresar tu contraseña para continuar.",
  "Ang pagbuo ng mga bagong code ay magpapawalang-bisa sa lahat ng kasalukuyan. Ipasok muli ang iyong password para magpatuloy."
 ],
 "Save these codes somewhere safe (password manager, printed copy). Each one only works once and replaces your previous set.": [
  "Guarda estos códigos en un lugar seguro (administrador de contraseñas, copia impresa). Cada uno solo funciona una vez y reemplaza tu conjunto anterior.",
  "I-save ang mga code na ito sa ligtas na lugar (password manager, naka-print na kopya). Bawat isa ay isang beses lang gagana at papalitan ang dati mong set."
 ],
 "Download .txt": [
  "Descargar .txt",
  "I-download ang .txt"
 ],
 "Account password": [
  "Contraseña de la cuenta",
  "Password ng account"
 ],
 "I've saved them": [
  "Los he guardado",
  "Na-save ko na ang mga ito"
 ],
 "Generate new codes": [
  "Generar códigos nuevos",
  "Bumuo ng mga bagong code"
 ],
 "Turn off two-factor authentication?": [
  "¿Desactivar la autenticación de dos factores?",
  "I-off ang two-factor authentication?"
 ],
 "This removes the second step from every future login. We strongly recommend keeping 2FA on.": [
  "Esto elimina el segundo paso de todos los inicios de sesión futuros. Recomendamos encarecidamente mantener la autenticación de dos factores activada.",
  "Aalisin nito ang ikalawang hakbang sa lahat ng susunod na pag-login. Mahigpit naming inirerekomendang panatilihing naka-on ang 2FA."
 ],
 "Current 2FA code (any method)": [
  "Código actual de autenticación de dos factores (cualquier método)",
  "Kasalukuyang 2FA code (anumang paraan)"
 ],
 "6-digit code or backup code": [
  "Código de 6 dígitos o código de respaldo",
  "6-digit na code o backup code"
 ],
 "Pick a class, package, or single lesson first.": [
  "Primero elige una clase, un paquete o una clase individual.",
  "Pumili muna ng class, package, o single lesson."
 ],
 "Single Lessons need a drop date — set when the lesson is.": [
  "Las clases individuales necesitan una fecha de baja; indica cuándo es la clase.",
  "Kailangan ng drop date ang Single Lessons — itakda kung kailan ang lesson."
 ],
 "Pick at least one student to enroll.": [
  "Elige al menos un alumno para inscribir.",
  "Pumili ng kahit isang estudyante na ie-enroll."
 ],
 "Missing application context — refresh the page and try again.": [
  "Falta el contexto de la aplicación; actualiza la página e inténtalo de nuevo.",
  "Nawawala ang application context — i-refresh ang page at subukan ulit."
 ],
 "Pick what to enroll them in. If they have a card on file we'll charge it immediately (or start the subscription) — otherwise we'll email a secure pay-link.": [
  "Elige en qué inscribirlos. Si tienen una tarjeta guardada, la cobraremos de inmediato (o iniciaremos la suscripción); de lo contrario, les enviaremos por correo electrónico un enlace de pago seguro.",
  "Piliin kung saan sila ie-enroll. Kung may card silang naka-file, agad namin itong sisingilin (o sisimulan ang subscription) — kung wala, mag-e-email kami ng secure na pay-link."
 ],
 "Which student": [
  "Qué alumno",
  "Aling estudyante"
 ],
 "Born": [
  "Nacimiento",
  "Ipinanganak"
 ],
 "Tap a student to enroll them.": [
  "Toca a un alumno para inscribirlo.",
  "I-tap ang estudyante para i-enroll siya."
 ],
 "Lesson type": [
  "Tipo de clase",
  "Uri ng lesson"
 ],
 "Single Lesson": [
  "Clase individual",
  "Single Lesson"
 ],
 "You don't have any active": [
  "No tienes ningún",
  "Wala kang anumang aktibong"
 ],
 "Single Lessons": [
  "Clases individuales",
  "Single Lessons"
 ],
 "yet. Add one from": [
  "todavía. Agrega una desde",
  "pa. Magdagdag ng isa mula sa"
 ],
 "Class block": [
  "Bloque de clase",
  "Class block"
 ],
 "Pick which day + time": [
  "Elige qué día y hora",
  "Piliin kung aling araw + oras"
 ],
 "Pin to a specific slot (optional)": [
  "Fijar en un horario específico (opcional)",
  "I-pin sa isang partikular na slot (opsyonal)"
 ],
 "This class meets on multiple days — pick one so the family lands on the right block.": [
  "Esta clase se imparte en varios días; elige uno para que la familia quede en el bloque correcto.",
  "Nagaganap ang class na ito sa maraming araw — pumili ng isa para mapunta ang pamilya sa tamang block."
 ],
 "Assigned coach": [
  "Instructor asignado",
  "Naka-assign na coach"
 ],
 "You (owner)": [
  "Tú (propietario)",
  "Ikaw (owner)"
 ],
 "The family will see this coach's name on their portal.": [
  "La familia verá el nombre de este instructor en su portal.",
  "Makikita ng pamilya ang pangalan ng coach na ito sa kanilang portal."
 ],
 "Drop date": [
  "Fecha de baja",
  "Drop date"
 ],
 "Required": [
  "Obligatorio",
  "Required"
 ],
 "When this single lesson takes place.": [
  "Cuándo tiene lugar esta clase individual.",
  "Kung kailan magaganap ang single lesson na ito."
 ],
 "Leave empty for auto-renew. Set this to schedule an end date now.": [
  "Déjalo vacío para renovación automática. Configúralo para programar ahora una fecha de finalización.",
  "Iwanang walang laman para sa auto-renew. Itakda ito para mag-schedule ng end date ngayon."
 ],
 "Marked as enrolled — cleared from the waitlist.": [
  "Marcado como inscrito; eliminado de la lista de espera.",
  "Minarkahang enrolled — inalis sa waitlist."
 ],
 "Families who want a class time that’s full. Reach out from your own phone or email — every contact detail is right here.": [
  "Familias que quieren un horario de clase que está lleno. Comunícate desde tu propio teléfono o correo electrónico; todos los datos de contacto están aquí mismo.",
  "Mga pamilyang gusto ng class time na puno na. Makipag-ugnayan gamit ang sarili mong phone o email — nasa rito mismo ang lahat ng contact detail."
 ],
 "Auto-email families when a seat opens": [
  "Enviar correo automático a las familias cuando se abra un lugar",
  "Awtomatikong mag-email sa mga pamilya kapag may nabuksang slot"
 ],
 "On — the moment a seat opens,": [
  "Activado — en cuanto se abre un cupo,",
  "Naka-on — sa oras na may magbukas na slot,"
 ],
 "everyone": [
  "todos",
  "lahat"
 ],
 "waiting for that time is emailed. Nothing is held; first family to book gets it.": [
  "quienes esperan ese horario reciben un correo. No se reserva nada; la primera familia que reserve se lo queda.",
  "ang naghihintay para sa oras na iyon ay mae-email. Walang nakahold; ang unang pamilyang mag-book ang makakakuha nito."
 ],
 "Off — when a seat opens you get a bell alert and nobody is emailed yet. Offer it to your current families first, then press": [
  "Desactivado — cuando se abre un cupo, recibes una alerta de campana y todavía no se envía correo a nadie. Ofréceselo primero a tus familias actuales y luego pulsa",
  "Naka-off — kapag may nagbukas na slot, makakatanggap ka ng bell alert at wala pang mae-email. I-offer mo muna ito sa mga kasalukuyan mong pamilya, tapos pindutin ang"
 ],
 "Email all waiting": [
  "Enviar correo a todos los que esperan",
  "I-email ang lahat ng naghihintay"
 ],
 "when you’re ready.": [
  "cuando estés listo.",
  "kapag handa ka na."
 ],
 "Parents only see “Join waitlist” on classes where you turned": [
  "Los padres solo ven “Unirse a la lista de espera” en las clases donde lo activaste",
  "Makikita lang ng mga magulang ang “Join waitlist” sa mga klase kung saan in-on mo ito"
 ],
 "on in the builder. Families stay listed until they enroll or you remove them.": [
  "en el creador. Las familias siguen en la lista hasta que se inscriban o las elimines.",
  "sa builder. Mananatiling nakalista ang mga pamilya hanggang sa mag-enroll sila o alisin mo sila."
 ],
 "Search parent, swimmer, email, phone, class…": [
  "Buscar padre, alumno, correo, teléfono, clase…",
  "Maghanap ng magulang, manlalangoy, email, telepono, klase…"
 ],
 "Search waitlist": [
  "Buscar en la lista de espera",
  "Hanapin sa waitlist"
 ],
 "No one is waiting right now.": [
  "Ahora mismo no hay nadie esperando.",
  "Walang naghihintay ngayon."
 ],
 "Turn on \"Waitlist when full\" in a class, package, or camp builder. When a time is full, parents can tap \"Join waitlist\" and they’ll show up here.": [
  "Activa \"Lista de espera cuando esté lleno\" en el creador de clases, paquetes o campamentos. Cuando un horario esté lleno, los padres pueden tocar \"Unirse a la lista de espera\" y aparecerán aquí.",
  "I-on ang \"Waitlist when full\" sa class, package, o camp builder. Kapag puno ang isang oras, puwedeng i-tap ng mga magulang ang \"Join waitlist\" at lalabas sila rito."
 ],
 "Try a different name, email, or class.": [
  "Prueba con otro nombre, correo o clase.",
  "Subukan ang ibang pangalan, email, o klase."
 ],
 "New parents can't join; existing families stay listed.": [
  "Los padres nuevos no pueden unirse; las familias existentes siguen en la lista.",
  "Hindi makakasali ang mga bagong magulang; mananatiling nakalista ang mga kasalukuyang pamilya."
 ],
 "Waitlist off": [
  "Lista de espera desactivada",
  "Naka-off ang waitlist"
 ],
 "Joined": [
  "Se unió",
  "Sumali"
 ],
 "Emailed": [
  "Correo enviado",
  "Na-email"
 ],
 "Text (opens your Messages app)": [
  "Texto (abre tu app de Mensajes)",
  "Text (bubuksan ang iyong Messages app)"
 ],
 "Mark as enrolled": [
  "Marcar como inscrito",
  "Markahan bilang enrolled"
 ],
 "Remove from waitlist": [
  "Eliminar de la lista de espera",
  "Alisin sa waitlist"
 ],
 "Remove from the waitlist?": [
  "¿Eliminar de la lista de espera?",
  "Alisin sa waitlist?"
 ],
 "will no longer be emailed when a seat opens in": [
  "ya no recibirá correos cuando se abra un cupo en",
  "hindi na mae-email kapag may nagbukas na slot sa"
 ],
 ". They can rejoin from their portal any time.": [
  ". Puede volver a unirse desde su portal en cualquier momento.",
  ". Puwede silang sumali ulit mula sa kanilang portal anumang oras."
 ],
 "Your coach hasn't added this document yet — ask them directly for the specifics.": [
  "Tu instructor aún no ha añadido este documento — pídele los detalles directamente.",
  "Hindi pa naidaragdag ng coach mo ang dokumentong ito — direktang hingin sa kanila ang mga detalye."
 ],
 "Tap to read": [
  "Toca para leer",
  "I-tap para basahin"
 ],
 "I agree to": [
  "Acepto",
  "Sumasang-ayon ako sa"
 ],
 "Liability Waiver": [
  "Exención de responsabilidad",
  "Liability Waiver"
 ],
 "Cancellation Policy": [
  "Política de cancelación",
  "Cancellation Policy"
 ],
 "Liability waiver": [
  "Exención de responsabilidad",
  "Liability waiver"
 ],
 "You won't be able to enroll in classes until your waiver is on file. Click here to sign now — takes 30 seconds.": [
  "No podrás inscribirte en clases hasta que tu exención de responsabilidad esté archivada. Haz clic aquí para firmarla ahora — tarda 30 segundos.",
  "Hindi ka makakapag-enroll sa mga klase hangga't wala pa sa file ang iyong waiver. I-click dito para pumirma ngayon — aabutin ng 30 segundo."
 ],
 "Sign now": [
  "Firmar ahora",
  "Pumirma ngayon"
 ],
 "Sign your waiver with": [
  "Firma tu exención con",
  "Pirmahan ang waiver mo sa"
 ],
 "Your coach needs your digital waiver on file before you can be enrolled in any classes.": [
  "Tu instructor necesita tener tu exención digital archivada antes de que puedas inscribirte en cualquier clase.",
  "Kailangan ng coach mo na nasa file ang iyong digital waiver bago ka ma-enroll sa anumang klase."
 ],
 "Waiver & release": [
  "Exención y liberación de responsabilidad",
  "Waiver & release"
 ],
 "The standard participation waiver you'd sign at any swim school — between you and": [
  "La exención estándar de participación que firmarías en cualquier escuela de natación — entre tú y",
  "Ang karaniwang participation waiver na pipirmahan mo sa anumang swim school — sa pagitan mo at"
 ],
 ". You'll get a PDF copy.": [
  ". Recibirás una copia en PDF.",
  ". Makakatanggap ka ng kopyang PDF."
 ],
 "I have read and agree to the waiver and release above.": [
  "He leído y acepto la exención de responsabilidad y liberación anteriores.",
  "Nabasa ko na at sumasang-ayon ako sa waiver at release sa itaas."
 ],
 "Cancellation policies": [
  "Políticas de cancelación",
  "Mga patakaran sa pagkansela"
 ],
 "I have read and agree to the cancellation policies above.": [
  "He leído y acepto las políticas de cancelación anteriores.",
  "Nabasa ko na at sumasang-ayon ako sa mga patakaran sa pagkansela sa itaas."
 ],
 "e.g. Jane Smith": [
  "p. ej., Jane Smith",
  "hal. Jane Smith"
 ],
 "By typing your name above and clicking \"Sign waiver\", you confirm this is your electronic signature with the same legal force as a handwritten signature.": [
  "Al escribir tu nombre arriba y hacer clic en \"Firmar exención\", confirmas que esta es tu firma electrónica con la misma validez legal que una firma manuscrita.",
  "Sa pag-type ng pangalan mo sa itaas at pag-click sa \"Pirmahan ang waiver\", kinukumpirma mong ito ang iyong electronic signature na may kaparehong legal na bisa ng sulat-kamay na lagda."
 ],
 "Signing…": [
  "Firmando…",
  "Pinipirmahan…"
 ],
 "Sign waiver": [
  "Firmar exención",
  "Pirmahan ang waiver"
 ],
 "Later": [
  "Más tarde",
  "Mamaya"
 ],
 "min read": [
  "min de lectura",
  "min basahin"
 ],
 "Dismiss guide tip": [
  "Descartar consejo de guía",
  "I-dismiss ang tip ng gabay"
 ],
 "That time is full — pick another.": [
  "Ese horario está lleno — elige otro.",
  "Puno na ang oras na iyon — pumili ng iba."
 ],
 "Your coach needs to confirm this time — use \"Request this time\" instead.": [
  "Tu instructor debe confirmar este horario — usa \"Solicitar este horario\" en su lugar.",
  "Kailangang kumpirmahin ng coach mo ang oras na ito — gamitin na lang ang \"I-request ang oras na ito\"."
 ],
 "Enter the swimmer's first name.": [
  "Ingresa el nombre del nadador.",
  "Ilagay ang unang pangalan ng manlalangoy."
 ],
 "Enter the swimmer's birthdate so we can match ages.": [
  "Ingresa la fecha de nacimiento del nadador para que podamos asignarlo por edad.",
  "Ilagay ang kaarawan ng manlalangoy para maitugma namin ang mga edad."
 ],
 "Pick a class first.": [
  "Elige primero una clase.",
  "Pumili muna ng klase."
 ],
 "Pick a date & time for the lesson.": [
  "Elige una fecha y hora para la lección.",
  "Pumili ng petsa at oras para sa lesson."
 ],
 "Add at least one swimmer.": [
  "Agrega al menos un nadador.",
  "Magdagdag ng kahit isang manlalangoy."
 ],
 "Your cart is empty — add a class first.": [
  "Tu carrito está vacío — agrega primero una clase.",
  "Walang laman ang cart mo — magdagdag muna ng klase."
 ],
 "Preview mode — checkout is disabled here. This is exactly where parents pay.": [
  "Modo de vista previa — el pago está deshabilitado aquí. Aquí es exactamente donde los padres pagan.",
  "Preview mode — hindi available ang checkout dito. Dito mismo nagbabayad ang mga magulang."
 ],
 "Find the perfect class": [
  "Encuentra la clase perfecta",
  "Hanapin ang perpektong klase"
 ],
 "Answer one question and we'll only show classes that fit your child.": [
  "Responde una pregunta y solo te mostraremos clases que se adapten a tu hijo.",
  "Sagutin ang isang tanong at mga klaseng bagay lang sa anak mo ang ipapakita namin."
 ],
 "Step 1 — How old is your swimmer?": [
  "Paso 1 — ¿Qué edad tiene tu nadador?",
  "Hakbang 1 — Ilang taon na ang manlalangoy mo?"
 ],
 "We'll hide everything that doesn't fit.": [
  "Ocultaremos todo lo que no encaje.",
  "Itatago namin ang lahat ng hindi akma."
 ],
 "Step 2 — Pick a program": [
  "Paso 2 — Elige un programa",
  "Hakbang 2 — Pumili ng programa"
 ],
 "fit": [
  "adecuado",
  "akma"
 ],
 "Set up by": [
  "Configurado por",
  "Inihanda ni"
 ],
 "— each groups its sessions & times.": [
  "— cada uno agrupa sus sesiones y horarios.",
  "— bawat isa ay pinapangkat ang mga session at oras nito."
 ],
 "Step 3 —": [
  "Paso 3 —",
  "Hakbang 3 —"
 ],
 "· pick your class": [
  "· elige tu clase",
  "· piliin ang klase mo"
 ],
 "Choose an option, then your dates & times.": [
  "Elige una opción y luego tus fechas y horarios.",
  "Pumili ng opsyon, pagkatapos ng mga petsa at oras mo."
 ],
 "No classes in this program right now — check back soon or contact the coach.": [
  "No hay clases en este programa ahora mismo — vuelve pronto o contacta al instructor.",
  "Walang mga klase sa programang ito sa ngayon — bumalik kaagad o makipag-ugnayan sa coach."
 ],
 "No classes in this program at that location.": [
  "No hay clases en este programa en esa ubicación.",
  "Walang mga klase sa programang ito sa lokasyong iyon."
 ],
 "Show all locations": [
  "Mostrar todas las ubicaciones",
  "Ipakita ang lahat ng lokasyon"
 ],
 "Monthly membership": [
  "Membresía mensual",
  "Buwanang membership"
 ],
 "Pay per lesson": [
  "Pago por clase",
  "Bayad kada lesson"
 ],
 "x / week": [
  "x / semana",
  "x / linggo"
 ],
 "Flexible — coach schedules with you": [
  "Flexible — el instructor coordina contigo",
  "Flexible — ang coach ang makikipag-iskedyul sa iyo"
 ],
 "one-time": [
  "único",
  "isang beses"
 ],
 "Pick your time:": [
  "Elige tu horario:",
  "Piliin ang oras mo:"
 ],
 "Preview only — approved parents request this time here.": [
  "Solo vista previa — los padres aprobados solicitan este horario aquí.",
  "Preview lang — dito hinihiling ng mga aprubadong magulang ang oras na ito."
 ],
 "Sign in to your parent account to request this time — your coach will confirm it with you.": [
  "Inicia sesión en tu cuenta de padre para solicitar este horario — tu instructor lo confirmará contigo.",
  "Mag-sign in sa parent account mo para hilingin ang oras na ito — iko-confirm ito ng coach mo sa iyo."
 ],
 "Coach must confirm · Request this time": [
  "El instructor debe confirmar · Solicitar este horario",
  "Dapat i-confirm ng coach · Hilingin ang oras na ito"
 ],
 "Full · Join waitlist": [
  "Completo · Unirse a la lista de espera",
  "Puno na · Sumali sa waitlist"
 ],
 "Flexible schedule —": [
  "Horario flexible —",
  "Flexible na schedule —"
 ],
 "will set lesson times with you after checkout.": [
  "establecerá los horarios de las clases contigo después del pago.",
  "itatalaga ang mga oras ng lesson kasama ka pagkatapos ng checkout."
 ],
 "Recurring:": [
  "Recurrente:",
  "Paulit-ulit:"
 ],
 "/month billed on day": [
  "/mes cobrado el día",
  "/buwan, sisingilin sa araw na"
 ],
 "of each month until you cancel. Your first month is": [
  "de cada mes hasta que canceles. Tu primer mes está",
  "ng bawat buwan hanggang magkansela ka. Ang unang buwan mo ay"
 ],
 "prorated": [
  "prorrateado",
  "prorated"
 ],
 "— today you only pay for the days left before your first billing day.": [
  "— hoy solo pagas por los días restantes antes de tu primer día de facturación.",
  "— ngayon, babayaran mo lang ang mga natitirang araw bago ang una mong araw ng pagsingil."
 ],
 "Step 4 — Who's swimming?": [
  "Paso 4 — ¿Quién nada?",
  "Hakbang 4 — Sino ang lalangoy?"
 ],
 "Pick one or more kids — siblings welcome.": [
  "Elige uno o más niños — los hermanos son bienvenidos.",
  "Pumili ng isa o higit pang bata — welcome ang magkakapatid."
 ],
 "Add swimmer": [
  "Agregar nadador",
  "Magdagdag ng swimmer"
 ],
 "e.g. Emmie": [
  "p. ej., Emmie",
  "hal. Emmie"
 ],
 "Add to cart": [
  "Agregar al carrito",
  "Idagdag sa cart"
 ],
 "Your classes": [
  "Tus clases",
  "Mga klase mo"
 ],
 "Nothing here yet — pick an age above to get started.": [
  "Aún no hay nada aquí — elige una edad arriba para comenzar.",
  "Wala pang laman dito — pumili ng edad sa itaas para magsimula."
 ],
 "Checkout once": [
  "Pagar una sola vez",
  "Isang checkout lang"
 ],
 "One card entry · every swimmer enrolled": [
  "Un solo ingreso de tarjeta · todos los nadadores inscritos",
  "Isang card entry · lahat ng swimmer ay enrolled"
 ],
 "Exit preview": [
  "Salir de la vista previa",
  "Lumabas sa preview"
 ],
 "Parent preview (phone)": [
  "Vista previa para padres (teléfono)",
  "Parent preview (phone)"
 ],
 "Parent preview (desktop)": [
  "Vista previa para padres (escritorio)",
  "Parent preview (desktop)"
 ],
 "Stop dictation": [
  "Detener dictado",
  "Ihinto ang dictation"
 ],
 "Start dictation": [
  "Iniciar dictado",
  "Simulan ang dictation"
 ],
 "Your browser may process speech online. SplashPad does not store audio.": [
  "Es posible que tu navegador procese la voz en línea. SplashPad no almacena audio.",
  "Maaaring i-process ng browser mo ang speech online. Hindi nag-iimbak ang SplashPad ng audio."
 ],
 "Handle a day’s booked lessons": [
  "Gestionar las clases reservadas de un día",
  "Pamahalaan ang mga naka-book na lesson sa isang araw"
 ],
 "One location, one day. This tool releases listed flexible-package reservations. Standing classes, makeup lessons and other billing types stay in your existing Schedule tools.": [
  "Una ubicación, un día. Esta herramienta libera las reservas listadas de paquetes flexibles. Las clases fijas, las clases de recuperación y otros tipos de facturación permanecen en tus herramientas de Programación existentes.",
  "Isang location, isang araw. Inilalabas ng tool na ito ang mga nakalistang reservation ng flexible-package. Ang mga regular na klase, makeup lesson, at iba pang billing type ay mananatili sa iyong kasalukuyang mga tool sa Schedule."
 ],
 "Local date": [
  "Fecha local",
  "Lokal na petsa"
 ],
 "Choose location": [
  "Elegir ubicación",
  "Pumili ng location"
 ],
 "Reason (included in a notice draft only if you create one)": [
  "Motivo (incluido en un borrador de aviso solo si crea uno)",
  "Dahilan (isasama lang sa draft ng abiso kung gagawa ka nito)"
 ],
 "e.g. Pool maintenance": [
  "p. ej. Mantenimiento de la piscina",
  "hal. Pagmamantini ng pool"
 ],
 "Preview affected lessons": [
  "Vista previa de las clases afectadas",
  "I-preview ang mga apektadong lesson"
 ],
 "Reload": [
  "Recargar",
  "I-reload"
 ],
 "Schedule / blackout tools": [
  "Herramientas de programación / bloqueo",
  "Mga tool sa schedule / blackout"
 ],
 "Add a location in Locations before using this workflow.": [
  "Agregue una ubicación en Ubicaciones antes de usar este flujo de trabajo.",
  "Magdagdag ng location sa Locations bago gamitin ang workflow na ito."
 ],
 "Excluded": [
  "Excluido",
  "Hindi isinama"
 ],
 "No booked lessons at this location on this date.": [
  "No hay clases reservadas en esta ubicación en esta fecha.",
  "Walang naka-book na lesson sa location na ito sa petsang ito."
 ],
 "I reviewed the included lessons and exclusions. No emails, charges or refunds will be sent.": [
  "Revisé las clases incluidas y las exclusiones. No se enviarán correos electrónicos ni se aplicarán cargos o reembolsos.",
  "Na-review ko ang mga kasamang lesson at mga hindi isinama. Walang ipapadalang email, sisingilin, o ire-refund."
 ],
 "Applying…": [
  "Aplicando…",
  "Ina-apply…"
 ],
 "Some items need attention": [
  "Algunos elementos requieren atención",
  "May ilang item na nangangailangan ng pansin"
 ],
 "Operation completed": [
  "Operación completada",
  "Nakumpleto ang operasyon"
 ],
 "No notice has been sent. Review the audience and text in a separate draft.": [
  "No se ha enviado ningún aviso. Revise la audiencia y el texto en un borrador aparte.",
  "Walang naipadalang abiso. I-review ang audience at text sa hiwalay na draft."
 ],
 "Retry remaining items": [
  "Reintentar los elementos restantes",
  "Subukang muli ang mga natitirang item"
 ],
 "Review notice draft": [
  "Revisar borrador de aviso",
  "I-review ang draft ng abiso"
 ],
 "Recent operations": [
  "Operaciones recientes",
  "Mga kamakailang operasyon"
 ],
 "View results": [
  "Ver resultados",
  "Tingnan ang mga resulta"
 ],
 "Open filters": [
  "Abrir filtros",
  "Buksan ang mga filter"
 ],
 "Filter by status": [
  "Filtrar por estado",
  "I-filter ayon sa status"
 ],
 "Close dialog": [
  "Cerrar cuadro de diálogo",
  "Isara ang dialog"
 ],
 "Dismiss savings estimate": [
  "Descartar estimación de ahorro",
  "Isara ang tantiya ng matitipid"
 ],
 "Approximate savings switching to SplashPad": [
  "Ahorro aproximado al cambiarse a SplashPad",
  "Tinatayang matitipid sa paglipat sa SplashPad"
 ],
 "/year": [
  "/año",
  "/taon"
 ],
 "No verified estimate for this platform.": [
  "No hay una estimación verificada para esta plataforma.",
  "Walang beripikadong tantiya para sa platform na ito."
 ],
 "Estimates only—never a guaranteed bill reduction.": [
  "Solo estimaciones; nunca una reducción garantizada de la factura.",
  "Mga tantiya lamang—hindi kailanman garantisadong bawas sa bill."
 ],
 "Estimate details": [
  "Detalles de la estimación",
  "Mga detalye ng tantiya"
 ],
 "Published subscription ranges and SSU assumptions. This is not another quiz question.": [
  "Rangos de suscripción publicados y supuestos de SSU. Esta no es otra pregunta del cuestionario.",
  "Mga naka-publish na hanay ng subscription at mga palagay ng SSU. Hindi ito isa pang tanong sa quiz."
 ],
 "Back to quiz": [
  "Volver al cuestionario",
  "Bumalik sa quiz"
 ],
 "SSU rate detected on your account": [
  "Tarifa de SSU detectada en su cuenta",
  "Nadetect ang SSU rate sa account mo"
 ],
 "Use SSU member rates for this estimate": [
  "Usar las tarifas para miembros de SSU para esta estimación",
  "Gamitin ang mga rate para sa SSU member para sa tantiyang ito"
 ],
 "Approx. annual subscription difference": [
  "Diferencia aproximada de suscripción anual",
  "Tinatayang diperensya sa taunang subscription"
 ],
 "/yr": [
  "/año",
  "/taon"
 ],
 "We don’t have verified pricing for your platform, so we won’t guess a savings figure. You can still move your families.": [
  "No tenemos precios verificados para su plataforma, así que no vamos a adivinar una cifra de ahorro. Aun así, puede trasladar a sus familias.",
  "Wala kaming beripikadong pricing para sa platform mo, kaya hindi kami manghuhula ng halaga ng matitipid. Maaari mo pa ring ilipat ang mga pamilya mo."
 ],
 "SSU members: Starter free, Pro 50% off. Eligibility is checked separately.": [
  "Miembros de SSU: Starter gratis, Pro con 50% de descuento. La elegibilidad se verifica por separado.",
  "Mga SSU member: libre ang Starter, 50% off ang Pro. Hiwalay na vine-verify ang eligibility."
 ],
 "Prices, assumptions & sources": [
  "Precios, supuestos y fuentes",
  "Mga presyo, palagay at source"
 ],
 "Program / enrollment": [
  "Programa / inscripción",
  "Programa / enrollment"
 ],
 "Loading programs…": [
  "Cargando programas…",
  "Nilo-load ang mga programa…"
 ],
 "Choose the program for this report": [
  "Elige el programa para este informe",
  "Piliin ang programa para sa ulat na ito"
 ],
 "Choose a program to include the correct instructor and school on the published printout.": [
  "Elige un programa para incluir al instructor y la escuela correctos en la impresión publicada.",
  "Pumili ng programa para maisama ang tamang coach at paaralan sa na-publish na printout."
 ],
 "Report title": [
  "Título del informe",
  "Pamagat ng ulat"
 ],
 "Name a skill you observed": [
  "Nombra una habilidad que observaste",
  "Pangalanan ang isang kasanayang napansin mo"
 ],
 "Add skill": [
  "Agregar habilidad",
  "Magdagdag ng kasanayan"
 ],
 "These observations are not a guarantee of water safety or independent swimming readiness.": [
  "Estas observaciones no garantizan la seguridad en el agua ni la preparación para nadar de forma independiente.",
  "Ang mga obserbasyong ito ay hindi garantiya ng kaligtasan sa tubig o kahandaan sa malayang paglangoy."
 ],
 "Save private draft": [
  "Guardar borrador privado",
  "I-save ang pribadong draft"
 ],
 "Day at a glance": [
  "Resumen del día",
  "Buod ng araw"
 ],
 ". Tap an item to open its details.": [
  ". Toca un elemento para abrir sus detalles.",
  ". I-tap ang isang item para buksan ang mga detalye nito."
 ],
 "Close day agenda": [
  "Cerrar agenda del día",
  "Isara ang agenda ng araw"
 ],
 "Closure on this day": [
  "Cierre en este día",
  "Pagsasara sa araw na ito"
 ],
 "No scheduled items on this closed day": [
  "No hay elementos programados en este día cerrado",
  "Walang naka-iskedyul na item sa saradong araw na ito"
 ],
 "A clear day on your calendar": [
  "Un día despejado en tu calendario",
  "Maluwag na araw sa iyong kalendaryo"
 ],
 "No classes, packages, camps or lessons are scheduled for this date.": [
  "No hay clases, paquetes, campamentos ni lecciones programados para esta fecha.",
  "Walang naka-iskedyul na klase, package, camp, o lesson para sa petsang ito."
 ],
 "View classes & packages": [
  "Ver clases y paquetes",
  "Tingnan ang mga klase at package"
 ],
 "Overlaps a booked lesson — review details": [
  "Se superpone con una lección reservada — revisa los detalles",
  "May overlap sa naka-book na lesson — suriin ang mga detalye"
 ],
 "min ·": [
  "min ·",
  "min ·"
 ],
 "Read this Splash reply aloud": [
  "Leer en voz alta esta respuesta de Splash",
  "Basahin nang malakas ang tugon na ito ng Splash"
 ],
 "Cancel audio preparation": [
  "Cancelar preparación de audio",
  "Kanselahin ang paghahanda ng audio"
 ],
 "Stop audio": [
  "Detener audio",
  "Ihinto ang audio"
 ],
 "Replay audio from the beginning": [
  "Reproducir el audio desde el principio",
  "I-play muli ang audio mula sa simula"
 ],
 "Listen sends this reply to ElevenLabs for AI-generated speech.": [
  "Escuchar envía esta respuesta a ElevenLabs para generar voz con IA.",
  "Ipinapadala ng Listen ang tugon na ito sa ElevenLabs para sa speech na binuo ng AI."
 ],
 "Draft saved. Nothing was sent.": [
  "Borrador guardado. No se envió nada.",
  "Na-save ang draft. Walang naipadala."
 ],
 "Review your message draft": [
  "Revisa el borrador de tu mensaje",
  "Suriin ang draft ng iyong mensahe"
 ],
 "Choose the audience and edit the message. Saving or opening the composer never sends an email.": [
  "Elige la audiencia y edita el mensaje. Guardar o abrir el editor nunca envía un correo electrónico.",
  "Piliin ang audience at i-edit ang mensahe. Ang pag-save o pagbubukas ng composer ay hindi kailanman nagpapadala ng email."
 ],
 "Reload draft": [
  "Recargar borrador",
  "I-reload ang draft"
 ],
 "Approved families": [
  "Familias aprobadas",
  "Mga aprubadong pamilya"
 ],
 "Search name or email": [
  "Buscar nombre o correo electrónico",
  "Maghanap ng pangalan o email"
 ],
 "recipients are no longer available.": [
  "los destinatarios ya no están disponibles.",
  "ang mga recipient ay hindi na available."
 ],
 "Remove unavailable recipients": [
  "Eliminar destinatarios no disponibles",
  "Alisin ang mga unavailable na recipient"
 ],
 "No approved email recipients yet. You can still save a draft.": [
  "Aún no hay destinatarios de correo electrónico aprobados. Aun así, puedes guardar un borrador.",
  "Wala pang aprubadong email recipient. Maaari ka pa ring mag-save ng draft."
 ],
 "selected:": [
  "seleccionados:",
  "napili:"
 ],
 "Save draft": [
  "Guardar borrador",
  "I-save ang draft"
 ],
 "How this estimate works": [
  "Cómo funciona esta estimación",
  "Paano gumagana ang pagtatayang ito"
 ],
 "A published subscription comparison, not a prediction of your bill.": [
  "Una comparación de suscripciones publicada, no una predicción de su factura.",
  "Isang inilathalang paghahambing ng subscription, hindi hula ng iyong bill."
 ],
 "SSU rates apply to SplashPad only: Starter is free; Pro is 50% off its standard subscription, rounded to the billed cent. Checking the estimate box does not apply or verify a discount.": [
  "Las tarifas SSU se aplican solo a SplashPad: Starter es gratis; Pro tiene 50% de descuento sobre su suscripción estándar, redondeado al centavo facturado. Marcar la casilla de estimación no aplica ni verifica un descuento.",
  "Ang mga SSU rate ay para sa SplashPad lamang: libre ang Starter; 50% diskuwento ang Pro mula sa karaniwang subscription nito, na ni-round sa sinisingil na sentimo. Ang pag-check sa estimate box ay hindi nag-a-apply o nagpapatunay ng diskuwento."
 ],
 ". USD prices checked": [
  ". Precios en USD verificados",
  ". Mga presyong USD na-check"
 ],
 ". The range uses the lowest and highest listed plan, for one subscription/location.": [
  ". El rango usa el plan publicado más bajo y el más alto, para una suscripción/ubicación.",
  ". Ginagamit ng range ang pinakamababa at pinakamataas na nakalistang plan, para sa isang subscription/lokasyon."
 ],
 "View published": [
  "Ver publicados",
  "Tingnan ang inilathala"
 ],
 "pricing": [
  "precios",
  "pagpepresyo"
 ],
 "Make these policies yours": [
  "Haga suyas estas políticas",
  "Gawing iyo ang mga patakarang ito"
 ],
 "Review each section for your business before inviting parents.": [
  "Revise cada sección para su negocio antes de invitar a los padres.",
  "Suriin ang bawat seksyon para sa iyong negosyo bago mag-imbita ng mga magulang."
 ],
 "Save & upload families": [
  "Guardar y cargar familias",
  "I-save at i-upload ang mga pamilya"
 ],
 "Templates are a starting point, not legal advice. Existing signed waiver records are kept unchanged. New signatures capture your saved policies.": [
  "Las plantillas son un punto de partida, no asesoría legal. Los registros existentes de exenciones firmadas se conservan sin cambios. Las nuevas firmas capturan sus políticas guardadas.",
  "Panimula lamang ang mga template, hindi legal na payo. Ang mga umiiral na record ng mga nilagdaang waiver ay mananatiling hindi binago. Kukuhanin ng mga bagong pirma ang iyong mga naka-save na patakaran."
 ],
 "Your families are safely imported": [
  "Sus familias se importaron de forma segura",
  "Ligtas na na-import ang iyong mga pamilya"
 ],
 "Upload your families": [
  "Cargue sus familias",
  "I-upload ang iyong mga pamilya"
 ],
 "One row per swimmer. Siblings stay with their family. Importing never sends invitations.": [
  "Una fila por nadador. Los hermanos permanecen con su familia. Importar nunca envía invitaciones.",
  "Isang row bawat swimmer. Mananatili ang magkakapatid sa kanilang pamilya. Ang pag-import ay hindi kailanman nagpapadala ng mga imbitasyon."
 ],
 "Continue my setup": [
  "Continuar con la configuración",
  "Ipagpatuloy ang aking setup"
 ],
 "Save & return to quiz": [
  "Guardar y volver al cuestionario",
  "I-save at bumalik sa quiz"
 ],
 "Discard preview": [
  "Descartar vista previa",
  "I-discard ang preview"
 ],
 "families quietly": [
  "familias en silencio",
  "mga pamilyang tahimik na na-import"
 ],
 "families linked ·": [
  "familias vinculadas ·",
  "mga pamilyang naka-link ·"
 ],
 "swimmers added": [
  "nadadores agregados",
  "mga swimmer na naidagdag"
 ],
 "existing swimmers kept unchanged. No invitations, enrollments, or charges were created.": [
  "los nadadores existentes se mantuvieron sin cambios. No se crearon invitaciones, inscripciones ni cargos.",
  "ang mga umiiral na swimmer ay nanatiling hindi binago. Walang nalikhang mga imbitasyon, enrollment, o charge."
 ],
 "Continue setting up your school. At the end, you can preview your welcome email and choose who to invite. Parents will create a password or sign in, then sign your policies.": [
  "Continúe configurando su escuela. Al final, puede obtener una vista previa de su correo electrónico de bienvenida y elegir a quién invitar. Los padres crearán una contraseña o iniciarán sesión, y luego firmarán sus políticas.",
  "Ipagpatuloy ang pag-set up ng iyong paaralan. Sa dulo, maaari mong i-preview ang iyong welcome email at piliin kung sino ang iimbitahan. Gagawa ang mga magulang ng password o magsa-sign in, pagkatapos ay pipirma sa iyong mga patakaran."
 ],
 "Upload another CSV": [
  "Cargar otro CSV",
  "Mag-upload ng isa pang CSV"
 ],
 "Correct this import": [
  "Corregir esta importación",
  "Ayusin ang import na ito"
 ],
 "Undo is only available for entirely new, unused families before any invitation. Existing families, signed waivers and activity are protected.": [
  "Deshacer solo está disponible para familias completamente nuevas y sin uso antes de cualquier invitación. Las familias existentes, las exenciones firmadas y la actividad están protegidas.",
  "Available lang ang pag-undo para sa ganap na bago at hindi pa nagagamit na mga pamilya bago ang anumang imbitasyon. Protektado ang mga umiiral na pamilya, nilagdaang waiver, at aktibidad."
 ],
 "Confirm undo of this unused import": [
  "Confirmar deshacer de esta importación sin usar",
  "Kumpirmahin ang pag-undo sa hindi pa nagagamit na import na ito"
 ],
 "Example CSV": [
  "CSV de ejemplo",
  "Halimbawang CSV"
 ],
 "Help prepare my file": [
  "Ayúdeme a preparar mi archivo",
  "Tulungan akong ihanda ang aking file"
 ],
 "Export your families and swimmers from your previous software as CSV. Exact iClassPro/Swum export formats are not yet verified; use this template or match your column headers below.": [
  "Exporte sus familias y nadadores de su software anterior como CSV. Los formatos exactos de exportación de iClassPro/Swum aún no están verificados; use esta plantilla o haga coincidir los encabezados de sus columnas a continuación.",
  "I-export ang iyong mga pamilya at swimmer mula sa dati mong software bilang CSV. Ang eksaktong iClassPro/Swum export formats ay hindi pa nabe-verify; gamitin ang template na ito o itugma ang iyong mga column header sa ibaba."
 ],
 "Use one row per swimmer. Repeat the same guardian email for siblings.": [
  "Use una fila por nadador. Repita el mismo correo electrónico del tutor para los hermanos.",
  "Gumamit ng isang row bawat swimmer. Ulitin ang parehong email ng guardian para sa magkakapatid."
 ],
 "Include parent first name, email (or phone + last name), and swimmer first name.": [
  "Incluya el nombre del padre o madre, el correo electrónico (o teléfono + apellido) y el nombre del nadador.",
  "Isama ang unang pangalan ng magulang, email (o telepono + apelyido), at unang pangalan ng swimmer."
 ],
 "Birth dates are optional; if included, use YYYY-MM-DD.": [
  "Las fechas de nacimiento son opcionales; si se incluyen, use YYYY-MM-DD.",
  "Opsyonal ang mga petsa ng kapanganakan; kung isasama, gamitin ang YYYY-MM-DD."
 ],
 "Do not include card details, passwords, medical records, or old signed-waiver files.": [
  "No incluya datos de tarjetas, contraseñas, historiales médicos ni archivos antiguos de exenciones firmadas.",
  "Huwag isama ang mga detalye ng card, password, medical record, o mga lumang file ng nilagdaang waiver."
 ],
 "Up to 500 families / 1,500 swimmer rows per file. This imports contacts, not balances, payment methods, memberships, or lesson bookings.": [
  "Hasta 500 familias / 1,500 filas de nadadores por archivo. Esto importa contactos, no saldos, métodos de pago, membresías ni reservas de clases.",
  "Hanggang 500 pamilya / 1,500 swimmer row bawat file. Nag-i-import ito ng mga contact, hindi ng mga balanse, paraan ng pagbabayad, membership, o booking ng lesson."
 ],
 "Choose a CSV file": [
  "Elija un archivo CSV",
  "Pumili ng CSV file"
 ],
 "Your CSV preview is saved. Upload families to pick up where you left off.": [
  "Se guardó la vista previa de tu CSV. Sube las familias para retomar donde lo dejaste.",
  "Na-save ang preview ng iyong CSV. I-upload ang mga pamilya para magpatuloy kung saan ka huminto."
 ],
 "Review welcome emails & progress": [
  "Revisar correos de bienvenida y progreso",
  "Suriin ang mga welcome email at progreso"
 ],
 "No families imported yet. Continue without inviting anyone, or bring your families over now.": [
  "Aún no se ha importado ninguna familia. Continúa sin invitar a nadie o trae a tus familias ahora.",
  "Wala pang na-import na mga pamilya. Magpatuloy nang walang iniimbitahan, o idagdag ang iyong mga pamilya ngayon."
 ],
 "Upload families": [
  "Subir familias",
  "I-upload ang mga pamilya"
 ],
 "Parents securely sign in or create a password, sign your waivers, then see the offerings you’ve published in their family portal.": [
  "Los padres inician sesión de forma segura o crean una contraseña, firman tus exenciones de responsabilidad y luego ven las ofertas que has publicado en su portal familiar.",
  "Ligtas na nagla-log in ang mga magulang o gumagawa ng password, pinipirmahan ang iyong mga waiver, at pagkatapos ay nakikita ang mga alok na na-publish mo sa kanilang family portal."
 ],
 "Paid since": [
  "Pagado desde",
  "Bayad mula noong"
 ],
 "Still unpaid": [
  "Aún sin pagar",
  "Hindi pa rin bayad"
 ],
 "Stripe decline code": [
  "Código de rechazo de Stripe",
  "Stripe decline code"
 ],
 "Declined card attempts": [
  "Intentos con tarjeta rechazada",
  "Mga tangkang gumamit ng card na na-decline"
 ],
 "still unpaid": [
  "aún sin pagar",
  "hindi pa rin bayad"
 ],
 "All paid since": [
  "Todo pagado desde",
  "Lahat bayad mula noong"
 ],
 "Refresh declined attempts": [
  "Actualizar intentos rechazados",
  "I-refresh ang mga na-decline na pagtatangka"
 ],
 "resolved (family paid afterwards)": [
  "resuelto (la familia pagó después)",
  "naresolba (nagbayad ang pamilya pagkatapos)"
 ],
 "Payment reconciliation": [
  "Conciliación de pagos",
  "Payment reconciliation"
 ],
 "Refresh status": [
  "Actualizar estado",
  "I-refresh ang status"
 ],
 "Retry status": [
  "Reintentar estado",
  "Subukang muli ang status"
 ],
 "Last check:": [
  "Última revisión:",
  "Huling check:"
 ],
 "Not recorded": [
  "No registrado",
  "Hindi naitala"
 ],
 "Last successful check:": [
  "Última revisión exitosa:",
  "Huling matagumpay na check:"
 ],
 "Last processed payment event:": [
  "Último evento de pago procesado:",
  "Huling naprosesong payment event:"
 ],
 "Last check covered the preceding": [
  "La última revisión cubrió los",
  "Sinaklaw ng huling check ang nakaraang"
 ],
 "days. Older payments may need a separate review.": [
  "días anteriores. Los pagos más antiguos pueden requerir una revisión por separado.",
  "na araw. Maaaring mangailangan ng hiwalay na pagsusuri ang mas lumang mga bayad."
 ],
 "Pending payment records:": [
  "Registros de pago pendientes:",
  "Mga nakabinbing payment record:"
 ],
 ". Failed processing events in the last 30 days:": [
  ". Eventos de procesamiento fallidos en los últimos 30 días:",
  ". Mga nabigong processing event sa nakaraang 30 araw:"
 ],
 ". Historical event failures may already have been reconciled.": [
  ". Los fallos históricos de eventos pueden ya haberse conciliado.",
  ". Maaaring na-reconcile na ang mga dating event failure."
 ],
 "A successful charge means the parent paid; a bank payout can still be pending. Resync retrieves existing Stripe records—it does not charge or refund a family. Refresh status only reads saved information.": [
  "Un cargo exitoso significa que el padre pagó; una transferencia bancaria aún puede estar pendiente. La resincronización recupera registros existentes de Stripe; no cobra ni reembolsa a una familia. Actualizar estado solo lee la información guardada.",
  "Ang matagumpay na charge ay nangangahulugang nagbayad ang magulang; maaaring nakabinbin pa rin ang bank payout. Kinukuha ng resync ang mga umiiral na Stripe record—hindi nito sini-singil o nire-refund ang isang pamilya. Ang refresh status ay nagbabasa lamang ng naka-save na impormasyon."
 ],
 "Review Stripe connection": [
  "Revisar conexión de Stripe",
  "Suriin ang koneksyon sa Stripe"
 ],
 "Resync existing records (last 90 days)": [
  "Resincronizar registros existentes (últimos 90 días)",
  "I-resync ang mga umiiral na record (nakaraang 90 araw)"
 ],
 "Private draft saved. Publish separately when ready.": [
  "Borrador privado guardado. Publícalo por separado cuando esté listo.",
  "Na-save ang pribadong draft. I-publish ito nang hiwalay kapag handa na."
 ],
 "Edit private draft": [
  "Editar borrador privado",
  "I-edit ang pribadong draft"
 ],
 "New progress report": [
  "Nuevo informe de progreso",
  "Bagong progress report"
 ],
 "Record observations and the next learning goal. Parents only see the version you explicitly publish.": [
  "Registra observaciones y el siguiente objetivo de aprendizaje. Los padres solo ven la versión que publicas explícitamente.",
  "Itala ang mga obserbasyon at ang susunod na layunin sa pagkatuto. Ang mga magulang ay makakakita lamang ng bersyong tahasan mong ipinublish."
 ],
 "Your previous published version stays visible. These edits remain private until you publish again.": [
  "Tu versión publicada anterior sigue visible. Estas ediciones permanecen privadas hasta que publiques de nuevo.",
  "Mananatiling nakikita ang dati mong na-publish na bersyon. Mananatiling pribado ang mga pagbabagong ito hanggang sa muli kang mag-publish."
 ],
 "Swimmer": [
  "Nadador",
  "Swimmer"
 ],
 "Choose a swimmer": [
  "Elige un nadador",
  "Pumili ng swimmer"
 ],
 "Working safely—please keep this window open.": [
  "Trabajando de forma segura: mantén esta ventana abierta.",
  "Ligtas na gumagana—pakihayaang bukas ang window na ito."
 ],
 "Match or change columns": [
  "Relaciona o cambia columnas",
  "Itugma o baguhin ang mga column"
 ],
 "Match each field to a column in your CSV. We won’t guess ambiguous fields.": [
  "Relaciona cada campo con una columna de tu CSV. No adivinaremos los campos ambiguos.",
  "Itugma ang bawat field sa isang column sa iyong CSV. Hindi kami huhula sa mga hindi malinaw na field."
 ],
 "Not included": [
  "No incluido",
  "Hindi kasama"
 ],
 "Preview these columns": [
  "Vista previa de estas columnas",
  "I-preview ang mga column na ito"
 ],
 "families ·": [
  "familias ·",
  "mga pamilya ·"
 ],
 "swimmer rows ·": [
  "filas de nadadores ·",
  "mga row ng swimmer ·"
 ],
 "matching swimmers kept ·": [
  "nadadores coincidentes conservados ·",
  "mga tumugmang swimmer na pinanatili ·"
 ],
 "families without email": [
  "familias sin correo electrónico",
  "mga pamilyang walang email"
 ],
 "Fix": [
  "Corregir",
  "Ayusin"
 ],
 "issue(s), then upload again.": [
  "problema(s) y luego vuelve a cargar.",
  "na isyu, pagkatapos ay mag-upload muli."
 ],
 "Showing the first 20 families. Summary includes the entire file.": [
  "Mostrando las primeras 20 familias. El resumen incluye todo el archivo.",
  "Ipinapakita ang unang 20 pamilya. Kasama sa buod ang buong file."
 ],
 "I reviewed this preview. These are my families, and I understand that importing will not email or charge anyone.": [
  "Revisé esta vista previa. Estas son mis familias y entiendo que la importación no enviará correos electrónicos ni cobrará a nadie.",
  "Sinuri ko ang preview na ito. Ito ang aking mga pamilya, at nauunawaan ko na ang pag-import ay hindi mag-e-email o maniningil kaninuman."
 ],
 "Review policies": [
  "Revisar políticas",
  "Suriin ang mga patakaran"
 ],
 "Preview your family welcome": [
  "Vista previa de la bienvenida para tu familia",
  "I-preview ang welcome para sa iyong pamilya"
 ],
 "Invitations are individual emails. Parents only access their own family portal.": [
  "Las invitaciones son correos electrónicos individuales. Los padres solo acceden al portal de su propia familia.",
  "Ang mga imbitasyon ay indibidwal na email. Maa-access lamang ng mga magulang ang portal ng sarili nilang pamilya."
 ],
 "Stop after this batch": [
  "Detener después de este lote",
  "Huminto pagkatapos ng batch na ito"
 ],
 "Keep invitations for later": [
  "Guardar las invitaciones para más tarde",
  "Itabi ang mga imbitasyon para sa ibang pagkakataon"
 ],
 "selected families": [
  "familias seleccionadas",
  "mga napiling pamilya"
 ],
 "Confirm your quiz setup before sending invitations.": [
  "Confirma la configuración de tu cuestionario antes de enviar las invitaciones.",
  "Kumpirmahin ang setup ng iyong quiz bago magpadala ng mga imbitasyon."
 ],
 "Your policies changed. Review them before sending invitations.": [
  "Tus políticas cambiaron. Revísalas antes de enviar las invitaciones.",
  "Nagbago ang iyong mga patakaran. Suriin ang mga ito bago magpadala ng mga imbitasyon."
 ],
 "Email delivery needs configuration. Your families are safe; nothing has been sent.": [
  "La entrega de correos electrónicos necesita configuración. Tus familias están seguras; no se ha enviado nada.",
  "Kailangang i-configure ang paghahatid ng email. Ligtas ang iyong mga pamilya; wala pang naipapadala."
 ],
 "Send a test to my coach email": [
  "Enviar una prueba a mi correo electrónico de instructor",
  "Magpadala ng test sa aking coach email"
 ],
 "Select all ready families (": [
  "Seleccionar todas las familias listas (",
  "Piliin ang lahat ng handang pamilya ("
 ],
 "Clear selection": [
  "Borrar selección",
  "I-clear ang selection"
 ],
 "Select": [
  "Seleccionar",
  "Piliin"
 ],
 "Account active": [
  "Cuenta activa",
  "Aktibo ang account"
 ],
 "Not activated": [
  "No activada",
  "Hindi activated"
 ],
 "I reviewed my policies and this email. These are my current families, and I approve inviting the selected families now. I understand draft classes are not visible until published.": [
  "Revisé mis políticas y este correo electrónico. Estas son mis familias actuales y apruebo invitar ahora a las familias seleccionadas. Entiendo que las clases en borrador no son visibles hasta que se publiquen.",
  "Sinuri ko ang aking mga patakaran at ang email na ito. Ito ang aking mga kasalukuyang pamilya, at inaaprubahan ko ang pag-imbita sa mga napiling pamilya ngayon. Nauunawaan ko na ang mga draft na klase ay hindi makikita hangga't hindi nailalathala."
 ],
 "“Email accepted” means the provider accepted it, not guaranteed inbox delivery. Families activate accounts and sign policies in their own time. No payments or bookings are created.": [
  "“Correo electrónico aceptado” significa que el proveedor lo aceptó, no que se garantice la entrega en la bandeja de entrada. Las familias activan cuentas y firman políticas a su debido tiempo. No se crean pagos ni reservas.",
  "Ang “Tinanggap ang email” ay nangangahulugang tinanggap ito ng provider, hindi garantisadong maihahatid sa inbox. Ina-activate ng mga pamilya ang mga account at lumalagda sa mga patakaran sa sarili nilang oras. Walang mabubuong bayad o booking."
 ],
 "1. Make your policies fit your business": [
  "1. Haz que tus políticas se ajusten a tu negocio",
  "1. Iangkop ang iyong mga patakaran sa iyong negosyo"
 ],
 "Waiver, cancellations, weather & illness": [
  "Exención de responsabilidad, cancelaciones, clima y enfermedad",
  "Waiver, mga cancellation, panahon at sakit"
 ],
 "2. Upload families": [
  "2. Carga familias",
  "2. Mag-upload ng mga pamilya"
 ],
 "CSV help, safe preview, then import": [
  "Ayuda con CSV, vista previa segura y luego importar",
  "Tulong sa CSV, ligtas na preview, pagkatapos ay import"
 ],
 "No emails, enrollments or charges on import. You can also use Continue and bring families over later.": [
  "Sin correos electrónicos, inscripciones ni cargos al importar. También puedes usar Continuar y traer familias más tarde.",
  "Walang mga email, enrollment, o singil sa pag-import. Maaari mo ring gamitin ang Continue at dalhin ang mga pamilya sa ibang pagkakataon."
 ],
 "A time that fits your family": [
  "Un horario que se adapte a tu familia",
  "Oras na akma sa pamilya mo"
 ],
 "Tuesday · 4:00 PM": [
  "Martes · 4:00 p. m.",
  "Martes · 4:00 PM"
 ],
 "Saturday · 10:00 AM": [
  "Sábado · 10:00 a. m.",
  "Sabado · 10:00 AM"
 ],
 "Say hello to Coach Splash": [
  "Saluda al instructor Splash",
  "Batiin si Coach Splash"
 ],
 "A friendlier first step into the pool.": [
  "Un primer paso más amigable hacia la piscina.",
  "Mas magiliw na unang hakbang papunta sa pool."
 ],
 "Trial requested (demo)": [
  "Prueba solicitada (demo)",
  "Nakahiling ng trial (demo)"
 ],
 "Book a trial (demo)": [
  "Reservar una prueba (demo)",
  "Mag-book ng trial (demo)"
 ],
 "Explore the example coach website": [
  "Explora el sitio web de ejemplo del instructor",
  "I-explore ang halimbawang website ng coach"
 ],
 "Explore the mini site": [
  "Explora el mini sitio",
  "I-explore ang mini site"
 ],
 "Trial requested in the demo. Nothing was submitted.": [
  "Prueba solicitada en la demo. No se envió nada.",
  "Nakahiling ng trial sa demo. Walang naisumite."
 ],
 "Scroll inside the screen or try the tabs. This is a demo.": [
  "Desplázate dentro de la pantalla o prueba las pestañas. Esto es una demo.",
  "Mag-scroll sa loob ng screen o subukan ang mga tab. Demo ito."
 ],
 "Hi, Rivera family": [
  "Hola, familia Rivera",
  "Hi, pamilyang Rivera"
 ],
 "Your next little victory": [
  "Tu próxima pequeña victoria",
  "Ang susunod mong munting tagumpay"
 ],
 "Beginner swim": [
  "Natación para principiantes",
  "Beginner swim"
 ],
 "Tuesday ·": [
  "Martes ·",
  "Martes ·"
 ],
 "PM": [
  "p. m.",
  "PM"
 ],
 "You’re on the roster!": [
  "¡Ya estás en la lista!",
  "Kasama ka na sa roster!"
 ],
 "One happy swimmer. One easy tap.": [
  "Un nadador feliz. Un toque fácil.",
  "Isang masayang swimmer. Isang madaling tap."
 ],
 "Lesson booked!": [
  "¡Lección reservada!",
  "Naka-book na ang lesson!"
 ],
 "Demo · Tue": [
  "Demo · mar",
  "Demo · Tue"
 ],
 "Choose a demo lesson time": [
  "Elige un horario para la lección de demostración",
  "Pumili ng oras para sa demo lesson"
 ],
 "Booked (demo)": [
  "Reservado (demo)",
  "Naka-book (demo)"
 ],
 "Book lesson (demo)": [
  "Reservar lección (demo)",
  "Mag-book ng lesson (demo)"
 ],
 "Choose a time and watch the checkmark pop out.": [
  "Elige un horario y mira cómo aparece la marca de verificación.",
  "Pumili ng oras at panoorin ang paglitaw ng checkmark."
 ],
 "COACH SPLASH": [
  "INSTRUCTOR SPLASH",
  "COACH SPLASH"
 ],
 "Clocked in · 3:45 PM": [
  "Entrada registrada · 3:45 p. m.",
  "Naka-clock in · 3:45 PM"
 ],
 "Ready for your shift?": [
  "¿Listo para tu turno?",
  "Handa na para sa shift mo?"
 ],
 "Private lesson": [
  "Lección privada",
  "Private lesson"
 ],
 "Stroke skills": [
  "Técnica de nado",
  "Stroke skills"
 ],
 "Your team.": [
  "Tu equipo.",
  "Team mo."
 ],
 "Ready to make waves.": [
  "Listo para causar sensación.",
  "Handang gumawa ng alon."
 ],
 "Clocked in": [
  "Entrada registrada",
  "Naka-clock in"
 ],
 "Clock in (demo)": [
  "Registrar entrada (demo)",
  "Mag-clock in (demo)"
 ],
 "Hide schedule": [
  "Ocultar horario",
  "Itago ang schedule"
 ],
 "Check today’s schedule": [
  "Consultar el horario de hoy",
  "Tingnan ang schedule ngayon"
 ],
 "Pay rates are turned off in Team Management → Settings, so gross pay shows $0. Turn them on and set each coach's rate to see real totals.": [
  "Las tarifas de pago están desactivadas en Gestión del equipo → Configuración, por lo que el pago bruto muestra $0. Actívalas y establece la tarifa de cada instructor para ver los totales reales.",
  "Naka-off ang mga pay rate sa Team Management → Settings, kaya $0 ang ipinapakitang gross pay. I-on ang mga ito at itakda ang rate ng bawat coach para makita ang totoong mga total."
 ],
 "No completed time-clock entries in this period": [
  "No hay registros completados de fichaje en este período",
  "Walang nakumpletong time-clock entry sa panahong ito"
 ],
 "Hours appear here once coaches clock in and out. Try another month, or check the": [
  "Las horas aparecerán aquí cuando los instructores registren entrada y salida. Prueba con otro mes o revisa la pestaña",
  "Lalabas dito ang mga oras kapag nag-clock in at out na ang mga coach. Subukan ang ibang buwan, o tingnan ang"
 ],
 "tab.": [
  "pestaña.",
  "tab."
 ],
 "shift": [
  "turno",
  "shift"
 ],
 "Pay type": [
  "Tipo de pago",
  "Uri ng bayad"
 ],
 "Rate / h": [
  "Tarifa / h",
  "Rate / h"
 ],
 "Totals by location": [
  "Totales por ubicación",
  "Mga total ayon sa lokasyon"
 ],
 "Grand total": [
  "Total general",
  "Kabuuang total"
 ],
 "Gross pay only — taxes and withholdings are not calculated. Pay uses the rate in effect at clock-in.": [
  "Solo pago bruto — no se calculan impuestos ni retenciones. El pago usa la tarifa vigente al registrar la entrada.",
  "Gross pay lang — hindi kinakalkula ang mga buwis at withholding. Ginagamit sa bayad ang rate na umiiral noong pag-clock in."
 ],
 "Business insights": [
  "Información del negocio",
  "Business insights"
 ],
 "Where your revenue comes from and how often families miss lessons.": [
  "De dónde provienen tus ingresos y con qué frecuencia las familias faltan a las clases.",
  "Saan nanggagaling ang iyong revenue at gaano kadalas lumiliban ang mga pamilya sa lessons."
 ],
 "Revenue by type": [
  "Ingresos por tipo",
  "Revenue ayon sa uri"
 ],
 "No paid revenue in this period yet.": [
  "Aún no hay ingresos pagados en este período.",
  "Wala pang paid revenue sa panahong ito."
 ],
 "· succeeded, net of refunds.": [
  "· procesados correctamente, neto de reembolsos.",
  "· succeeded, net of refunds."
 ],
 "No-show rate": [
  "Tasa de inasistencia",
  "No-show rate"
 ],
 "attended ·": [
  "asistió ·",
  "dumalo ·"
 ],
 "absent": [
  "ausente",
  "absent"
 ],
 "No attendance marked in this period yet.": [
  "Aún no se ha marcado asistencia en este período.",
  "Wala pang attendance na namarkahan sa panahong ito."
 ],
 "Weekly no-show trend": [
  "Tendencia semanal de inasistencia",
  "Lingguhang trend ng no-show"
 ],
 "Weekly no-show share,": [
  "Proporción semanal de inasistencia,",
  "Lingguhang bahagi ng no-show,"
 ],
 "Most missed": [
  "Con más faltas",
  "Pinakamaraming na-miss"
 ],
 "Pro members only": [
  "Solo para miembros Pro",
  "Para lang sa mga Pro member"
 ],
 "is included with SplashPad Pro. Upgrade to unlock the real numbers.": [
  "está incluido con SplashPad Pro. Actualiza para desbloquear los números reales.",
  "ay kasama sa SplashPad Pro. Mag-upgrade para ma-unlock ang totoong mga numero."
 ],
 "Pay period month": [
  "Mes del período de pago",
  "Buwan ng pay period"
 ],
 "Custom range": [
  "Rango personalizado",
  "Custom range"
 ],
 "Reset this demo": [
  "Restablecer esta demo",
  "I-reset ang demo na ito"
 ],
 "coach-splash · demo website": [
  "coach-splash · sitio web de demostración",
  "coach-splash · demo website"
 ],
 "Scrollable example coach website": [
  "Sitio web de ejemplo de instructor con desplazamiento",
  "Scrollable example coach website"
 ],
 "SPLASH SWIM ACADEMY": [
  "SPLASH SWIM ACADEMY",
  "SPLASH SWIM ACADEMY"
 ],
 "Little swimmers.": [
  "Pequeños nadadores.",
  "Maliliit na manlalangoy."
 ],
 "Big superpowers.": [
  "Grandes superpoderes.",
  "Malalaking superpower."
 ],
 "Meet your coach, Splash.": [
  "Conoce a tu instructor, Splash.",
  "Kilalanin ang coach mo, si Splash."
 ],
 "Find their superpower": [
  "Encuentra su superpoder",
  "Hanapin ang kanilang superpower"
 ],
 "First splashes": [
  "Primeras salpicaduras",
  "Unang splashes"
 ],
 "Save & open composer": [
  "Guardar y abrir el editor",
  "I-save at buksan ang composer"
 ],
 "Site pages": [
  "Páginas del sitio",
  "Mga pahina ng site"
 ],
 "Open menu": [
  "Abrir menú",
  "Buksan ang menu"
 ],
 "This page isn’t available": [
  "Esta página no está disponible",
  "Hindi available ang pahinang ito"
 ],
 "Back to home": [
  "Volver al inicio",
  "Bumalik sa home"
 ],
 "Footer pages": [
  "Páginas del pie de página",
  "Mga pahina ng footer"
 ],
 "Legal": [
  "Legal",
  "Legal"
 ],
 "Call coach": [
  "Llamar al instructor",
  "Tawagan ang coach"
 ],
 "Most popular": [
  "Más popular",
  "Pinakasikat"
 ],
 "Membership · renews": [
  "Membresía · se renueva",
  "Membership · nagre-renew"
 ],
 "ly": [
  "mente",
  "kada"
 ],
 "Flexible — coach sets times with you": [
  "Flexible — el instructor fija los horarios contigo",
  "Flexible — ang coach ang nagse-set ng oras kasama ka"
 ],
 "No packages published yet — create packages in Classes & Packages to fill this section.": [
  "Aún no hay paquetes publicados — crea paquetes en Classes & Packages para completar esta sección.",
  "Wala pang na-publish na packages — gumawa ng packages sa Classes & Packages para mapunan ang seksyong ito."
 ],
 "Apply for pricing": [
  "Solicitar precios",
  "Magtanong para sa pricing"
 ],
 "Add testimonials (or connect Google reviews) to show social proof here.": [
  "Agrega testimonios (o conecta reseñas de Google) para mostrar prueba social aquí.",
  "Magdagdag ng testimonials (o ikonekta ang Google reviews) para magpakita ng social proof dito."
 ],
 "on Google": [
  "en Google",
  "sa Google"
 ],
 "Add locations from Locations in your portal to show them here with tap-for-directions.": [
  "Agrega ubicaciones desde Locations en tu portal para mostrarlas aquí con toque para obtener indicaciones.",
  "Magdagdag ng locations mula sa Locations sa iyong portal para ipakita ang mga ito rito na may tap-for-directions."
 ],
 "Add FAQs from your portal settings to answer common parent questions here.": [
  "Agrega preguntas frecuentes desde la configuración de tu portal para responder aquí las preguntas comunes de los padres.",
  "Magdagdag ng FAQs mula sa settings ng iyong portal para sagutin dito ang mga karaniwang tanong ng mga magulang."
 ],
 "Write your story in the About section to introduce yourself to families.": [
  "Escribe tu historia en la sección About para presentarte a las familias.",
  "Isulat ang kuwento mo sa seksyong About para maipakilala ang sarili mo sa mga pamilya."
 ],
 "Add certifications and experience in your Profile to build trust here.": [
  "Agrega certificaciones y experiencia en tu Perfil para generar confianza aquí.",
  "Magdagdag ng certifications at experience sa iyong Profile para makabuo ng tiwala rito."
 ],
 "Add up to 6 photos in the Photo Gallery section — or pick from the curated swim library.": [
  "Agrega hasta 6 fotos en la sección Galería de fotos — o elige de la biblioteca de natación seleccionada.",
  "Magdagdag ng hanggang 6 na larawan sa seksyong Photo Gallery — o pumili mula sa curated swim library."
 ],
 "Add YouTube or Vimeo links in the Videos section to show yourself in action.": [
  "Agrega enlaces de YouTube o Vimeo en la sección Videos para mostrarte en acción.",
  "Magdagdag ng mga link ng YouTube o Vimeo sa seksyong Videos para maipakita ka habang nagtuturo."
 ],
 "Contact options": [
  "Opciones de contacto",
  "Mga opsyon sa pakikipag-ugnayan"
 ],
 "No team members yet — click this section to import your staff from Team Management or add coaches by hand.": [
  "Aún no hay miembros del equipo — haz clic en esta sección para importar tu personal desde Team Management o agregar instructores manualmente.",
  "Wala pang team members — i-click ang seksyong ito para i-import ang iyong staff mula sa Team Management o manu-manong magdagdag ng mga coach."
 ],
 "We come to you": [
  "Vamos a tu ubicación",
  "Pumupunta kami sa inyo"
 ],
 "— an address checker for in-home lessons. Turn on": [
  "— un verificador de direcciones para clases a domicilio. Activa",
  "— isang address checker para sa in-home lessons. I-on ang"
 ],
 "from your Locations page and this section appears here automatically.": [
  "desde tu página Locations y esta sección aparecerá aquí automáticamente.",
  "mula sa iyong pahinang Locations at awtomatikong lalabas dito ang seksyong ito."
 ],
 "Your address": [
  "Tu dirección",
  "Iyong address"
 ],
 "Preview — on your live site parents see whether their address is on your route and the times that fit.": [
  "Vista previa — en tu sitio en vivo los padres verán si su dirección está en tu ruta y los horarios que encajan.",
  "Preview — sa live site mo makikita ng mga magulang kung nasa ruta mo ang address nila at ang mga oras na bagay."
 ],
 "Yes — we come to your area!": [
  "Sí — ¡vamos a tu zona!",
  "Oo — pumupunta kami sa inyong area!"
 ],
 "time fits": [
  "horario compatible",
  "akmang oras"
 ],
 "times fit": [
  "horarios compatibles",
  "mga akmang oras"
 ],
 "our route in the next two weeks": [
  "nuestra ruta en las próximas dos semanas",
  "aming ruta sa susunod na dalawang linggo"
 ],
 "None of these work? Send a request": [
  "¿Ninguno de estos funciona? Envía una solicitud",
  "Wala bang gumagana sa mga ito? Magpadala ng request"
 ],
 "Nothing open on our route near you right now": [
  "No hay disponibilidad en nuestra ruta cerca de ti en este momento",
  "Walang bakante sa ruta namin malapit sa iyo sa ngayon"
 ],
 "Routes change every week. Send a quick request with your address and preferred times and we’ll try to fit you in.": [
  "Las rutas cambian cada semana. Envía una solicitud rápida con tu dirección y horarios preferidos y trataremos de acomodarte.",
  "Nagbabago ang mga ruta bawat linggo. Magpadala ng mabilis na request kasama ang iyong address at mga gustong oras at susubukan naming maisingit ka."
 ],
 "We sometimes make exceptions when a few families are close together. Send a request and we’ll let you know.": [
  "A veces hacemos excepciones cuando varias familias están cerca unas de otras. Envía una solicitud y te avisaremos.",
  "Minsan gumagawa kami ng mga exception kapag magkakalapit ang ilang pamilya. Magpadala ng request at ipapaalam namin sa iyo."
 ],
 "Location performance": [
  "Rendimiento por ubicación",
  "Performance ng lokasyon"
 ],
 "Which pool earns the most, who's enrolled where, and how many staff hours each location takes.": [
  "Qué piscina genera más ingresos, quién está inscrito dónde y cuántas horas de personal requiere cada ubicación.",
  "Aling pool ang kumikita nang pinakamarami, sino ang enrolled saan, at ilang staff hours ang kailangan ng bawat lokasyon."
 ],
 "Add a location to see performance by pool": [
  "Agrega una ubicación para ver el rendimiento por piscina",
  "Magdagdag ng lokasyon para makita ang performance ayon sa pool"
 ],
 "Revenue, enrollments and staff hours are grouped by the location on each class or package.": [
  "Los ingresos, las inscripciones y las horas de personal se agrupan según la ubicación de cada clase o paquete.",
  "Ang revenue, enrollments, at staff hours ay pinapangkat ayon sa lokasyon ng bawat class o package."
 ],
 "Total revenue": [
  "Ingresos totales",
  "Kabuuang revenue"
 ],
 "Active enrollments": [
  "Inscripciones activas",
  "Aktibong enrollments"
 ],
 "Staff hours": [
  "Horas del personal",
  "Staff hours"
 ],
 "Top earner": [
  "Mayor generador de ingresos",
  "Pinakamalaking kumikita"
 ],
 "% of revenue": [
  "% de los ingresos",
  "% ng revenue"
 ],
 "New enrollments": [
  "Nuevas inscripciones",
  "Mga bagong enrollment"
 ],
 "Active · students": [
  "Activos · estudiantes",
  "Aktibo · mga estudyante"
 ],
 "Shifts · 14d": [
  "Turnos · 14d",
  "Mga shift · 14d"
 ],
 "Arrows compare with the previous period (": [
  "Las flechas comparan con el período anterior (",
  "Ikinukumpara ng mga arrow sa nakaraang period ("
 ],
 "Revenue is matched to a location through the class or package on each payment. Payments without a location (mobile lessons, invoices) appear under \"No location / mobile\".": [
  "Los ingresos se asignan a una ubicación mediante la clase o el paquete de cada pago. Los pagos sin ubicación (clases móviles, facturas) aparecen en \"Sin ubicación / móvil\".",
  "Itinutugma ang revenue sa isang lokasyon sa pamamagitan ng class o package sa bawat bayad. Ang mga bayad na walang lokasyon (mobile lessons, invoices) ay lumalabas sa \"No location / mobile\"."
 ],
 "Hours and gross pay per coach from completed time-clock entries — split by pay type and location. Hand the PDF or CSV straight to your accountant.": [
  "Horas y pago bruto por instructor a partir de registros completados del reloj de tiempo, divididos por tipo de pago y ubicación. Entrega el PDF o CSV directamente a tu contador.",
  "Mga oras at gross pay bawat coach mula sa mga nakumpletong time-clock entry — hinati ayon sa pay type at lokasyon. Ibigay ang PDF o CSV diretso sa iyong accountant."
 ],
 "Exporting…": [
  "Exportando…",
  "Ini-export…"
 ],
 "Building…": [
  "Generando…",
  "Binubuo…"
 ],
 "Download PDF": [
  "Descargar PDF",
  "I-download ang PDF"
 ],
 "Email to accountant": [
  "Enviar por correo al contador",
  "I-email sa accountant"
 ],
 "End date must be on or after the start date.": [
  "La fecha de finalización debe ser igual o posterior a la fecha de inicio.",
  "Ang end date ay dapat kapareho o mas huli kaysa sa start date."
 ],
 "Email payroll to your accountant": [
  "Enviar nómina por correo a tu contador",
  "I-email ang payroll sa iyong accountant"
 ],
 "h ·": [
  "h ·",
  "h ·"
 ],
 "gross": [
  "bruto",
  "gross"
 ],
 "accountant@firm.com": [
  "accountant@firm.com",
  "accountant@firm.com"
 ],
 "PDF report": [
  "Informe PDF",
  "PDF report"
 ],
 "CSV spreadsheet": [
  "Hoja de cálculo CSV",
  "CSV spreadsheet"
 ],
 "Pick at least one file.": [
  "Elige al menos un archivo.",
  "Pumili ng kahit isang file."
 ],
 "Hi Dana — here's this month's payroll. Two new coaches started mid-month.": [
  "Hola Dana: aquí está la nómina de este mes. Dos nuevos instructores empezaron a mitad de mes.",
  "Hi Dana — narito ang payroll ngayong buwan. Dalawang bagong coach ang nagsimula sa kalagitnaan ng buwan."
 ],
 "Remember this accountant": [
  "Recordar este contador",
  "Tandaan ang accountant na ito"
 ],
 "Pre-fill the address and note next time.": [
  "Completa previamente la dirección y la nota la próxima vez.",
  "I-pre-fill ang address at note sa susunod."
 ],
 "Sent from SplashPad with your school's branding; replies go to your inbox.": [
  "Enviado desde SplashPad con la imagen de marca de tu escuela; las respuestas llegan a tu bandeja de entrada.",
  "Ipinadala mula sa SplashPad gamit ang branding ng iyong paaralan; ang mga reply ay mapupunta sa iyong inbox."
 ],
 "Send payroll": [
  "Enviar nómina",
  "Ipadala ang payroll"
 ],
 "Coaches paid": [
  "Instructores pagados",
  "Mga coach na nabayaran"
 ],
 "Demo shift started. No hours or payroll recorded.": [
  "Turno de demostración iniciado. No se registrarán horas ni nómina.",
  "Nagsimula ang demo shift. Walang oras o payroll na itatala."
 ],
 "Try clocking in, then peek at the day ahead.": [
  "Prueba registrar tu entrada y luego echa un vistazo al día que te espera.",
  "Subukang mag-clock in, pagkatapos silipin ang nakaabang na araw."
 ],
 "MONDAY": [
  "LUNES",
  "LUNES"
 ],
 "WEDNESDAY": [
  "MIÉRCOLES",
  "MIYERKULES"
 ],
 "4 swimmers": [
  "4 nadadores",
  "4 manlalangoy"
 ],
 "1 swimmer": [
  "1 nadador",
  "1 manlalangoy"
 ],
 "Demo schedule day": [
  "Día de horario de demostración",
  "Araw ng demo schedule"
 ],
 "Splash seated at the controls of a cyan and gold seaplane, flying around the globe": [
  "Splash sentado a los mandos de un hidroavión cian y dorado, volando alrededor del mundo",
  "Si Splash ay nakaupo sa controls ng isang cyan at gintong seaplane, lumilipad sa paligid ng mundo"
 ],
 "Loading flight illustration": [
  "Cargando ilustración del vuelo",
  "Nilo-load ang flight illustration"
 ],
 "Let’s get Splash back in the air.": [
  "Hagamos que Splash vuelva a volar.",
  "Ibalik natin si Splash sa ere."
 ],
 "A world of swim coaches": [
  "Un mundo de instructores de natación",
  "Isang mundo ng mga swim coach"
 ],
 "Reload illustration": [
  "Volver a cargar la ilustración",
  "I-reload ang illustration"
 ],
 "Fly with Splash": [
  "Vuela con Splash",
  "Lumipad kasama si Splash"
 ],
 "Illustrated demo, not live locations.": [
  "Demostración ilustrada, no ubicaciones reales.",
  "Illustrated demo, hindi live locations."
 ],
 "Coach Splash": [
  "Instructor Splash",
  "Coach Splash"
 ],
 "Rivera family": [
  "Familia Rivera",
  "Pamilyang Rivera"
 ],
 "A little win from today": [
  "Una pequeña victoria de hoy",
  "Isang munting panalo mula ngayon"
 ],
 "Your swim adventure starts here": [
  "Tu aventura de natación comienza aquí",
  "Dito nagsisimula ang swim adventure mo"
 ],
 "Delivered in the demo": [
  "Entregado en la demostración",
  "Na-deliver sa demo"
 ],
 "Choose an example email": [
  "Elige un correo electrónico de ejemplo",
  "Pumili ng halimbawang email"
 ],
 "Sent (demo)": [
  "Enviado (demostración)",
  "Naipadala (demo)"
 ],
 "Send email (demo)": [
  "Enviar correo electrónico (demostración)",
  "Magpadala ng email (demo)"
 ],
 "Just a demo. No actual email was sent.": [
  "Es solo una demostración. No se envió ningún correo electrónico real.",
  "Demo lang ito. Walang aktuwal na email na ipinadala."
 ],
 "A thoughtful update, without the admin work.": [
  "Una actualización útil, sin el trabajo administrativo.",
  "Isang maingat na update, nang walang admin work."
 ],
 "Splash with three women superheroes and one male teammate, each in a unique pose": [
  "Splash con tres superheroínas y un compañero de equipo, cada uno en una pose única",
  "Si Splash kasama ang tatlong babaeng superhero at isang lalaking teammate, bawat isa ay may natatanging pose"
 ],
 "Splash waving hello in the middle of his crew": [
  "Splash saludando en medio de su equipo",
  "Si Splash na kumakaway ng hello sa gitna ng kanyang crew"
 ],
 "Different superpowers. One swim family.": [
  "Diferentes superpoderes. Una sola familia de natación.",
  "Magkakaibang superpowers. Isang swim family."
 ],
 "Say hello to Splash": [
  "Saluda a Splash",
  "Batiin si Splash"
 ],
 "Splash says hello! Meet our illustrated coaching superhero squad.": [
  "¡Splash te saluda! Conoce a nuestro escuadrón ilustrado de superhéroes instructores.",
  "Hello sabi ni Splash! Kilalanin ang aming illustrated coaching superhero squad."
 ],
 "An illustrated squad of different personalities, all cheering you on.": [
  "Un escuadrón ilustrado de distintas personalidades, todos animándote.",
  "Isang illustrated squad ng iba’t ibang personalidad, lahat ay sumusuporta sa iyo."
 ],
 "Try it · Demo": [
  "Pruébalo · Demostración",
  "Subukan ito · Demo"
 ],
 "splashpad.pro · Superhero Swim Academy · Owner dashboard": [
  "splashpad.pro · Superhero Swim Academy · Panel del propietario",
  "splashpad.pro · Superhero Swim Academy · Owner dashboard"
 ],
 "Revenue · Sept": [
  "Ingresos · sept.",
  "Revenue · Set"
 ],
 "Staff hours · Sept": [
  "Horas del personal · sept.",
  "Staff hours · Set"
 ],
 "Revenue · all locations · 2026": [
  "Ingresos · todas las ubicaciones · 2026",
  "Revenue · lahat ng location · 2026"
 ],
 "Export PDF · CSV": [
  "Exportar PDF · CSV",
  "I-export ang PDF · CSV"
 ],
 "splashpad.pro · Website builder · Published": [
  "splashpad.pro · Creador de sitios web · Publicado",
  "splashpad.pro · Website builder · Nailathala"
 ],
 "Brand": [
  "Marca",
  "Brand"
 ],
 "Coach Maya · Austin, TX": [
  "Instructora Maya · Austin, TX",
  "Coach Maya · Austin, TX"
 ],
 "Confident swimmers, happy parents.": [
  "Nadadores seguros, padres felices.",
  "Kumpiyansang mga manlalangoy, masayang mga magulang."
 ],
 "splashpad.pro/coach/maya": [
  "splashpad.pro/coach/maya",
  "splashpad.pro/coach/maya"
 ],
 "Your SI agent · inside your account": [
  "Tu agente de SI · dentro de tu cuenta",
  "Iyong SI agent · nasa loob ng account mo"
 ],
 "Move Jamie to Thursday 4pm beginners.": [
  "Mueve a Jamie al grupo de principiantes del jueves a las 4 p. m.",
  "Ilipat si Jamie sa Thursday 4pm beginners."
 ],
 "Preview — nothing changed yet": [
  "Vista previa — aún no se ha cambiado nada",
  "Preview — wala pang nababago"
 ],
 "Tue 4:00 · Beginners": [
  "Mar 4:00 · Principiantes",
  "Tue 4:00 · Beginners"
 ],
 "Seat available · 5/6": [
  "Lugar disponible · 5/6",
  "May available na slot · 5/6"
 ],
 "Jamie R. · Nguyen family · 6 lessons left": [
  "Jamie R. · familia Nguyen · quedan 6 clases",
  "Jamie R. · pamilyang Nguyen · 6 lessons pa ang natitira"
 ],
 "Done. Jamie is in Thursday beginners and the family was notified.": [
  "Listo. Jamie está en principiantes del jueves y se notificó a la familia.",
  "Tapos na. Nasa Thursday beginners na si Jamie at naabisuhan ang pamilya."
 ],
 "A look inside": [
  "Un vistazo al interior",
  "Isang sulyap sa loob"
 ],
 "Everything your swim school runs on.": [
  "Todo sobre lo que funciona tu escuela de natación.",
  "Lahat ng pinapatakbo ng swim school mo."
 ],
 "One login for you, your staff and every family.": [
  "Un inicio de sesión para ti, tu personal y cada familia.",
  "Isang login para sa iyo, sa staff mo, at sa bawat pamilya."
 ],
 "Super Intelligence · in every coach account": [
  "Superinteligencia · en cada cuenta de instructor",
  "Super Intelligence · sa bawat coach account"
 ],
 "Meet Splash,": [
  "Conoce a Splash,",
  "Kilalanin si Splash,"
 ],
 "SI agent.": [
  "agente de SI.",
  "SI agent."
 ],
 "Describe a task. Splash previews it. You confirm. Less admin, more coaching — with an AI-powered assistant that lives inside SplashPad.": [
  "Describe una tarea. Splash la muestra en vista previa. Tú confirmas. Menos administración, más enseñanza — con un asistente impulsado por IA que vive dentro de SplashPad.",
  "Ilarawan ang isang gawain. Ipi-preview ito ni Splash. Ikaw ang magkukumpirma. Mas kaunting admin, mas maraming coaching — kasama ang AI-powered na assistant na nasa loob ng SplashPad."
 ],
 "Nothing changes in your account until you confirm.": [
  "Nada cambia en tu cuenta hasta que lo confirmes.",
  "Walang magbabago sa account mo hangga't hindi mo kinukumpirma."
 ],
 "Start free trial": [
  "Iniciar prueba gratis",
  "Simulan ang libreng trial"
 ],
 "See the product": [
  "Ver el producto",
  "Tingnan ang produkto"
 ],
 "Splash the mascot": [
  "Splash, la mascota",
  "Si Splash na mascot"
 ],
 "Open Splash tour": [
  "Abrir recorrido de Splash",
  "Buksan ang Splash tour"
 ],
 "Close Splash tour": [
  "Cerrar recorrido de Splash",
  "Isara ang Splash tour"
 ],
 "Audio unavailable — tour continues with text.": [
  "Audio no disponible — el recorrido continúa con texto.",
  "Hindi available ang audio — magpapatuloy ang tour gamit ang text."
 ],
 "Start Tour": [
  "Iniciar recorrido",
  "Simulan ang Tour"
 ],
 "Unmute Splash": [
  "Activar sonido de Splash",
  "I-unmute si Splash"
 ],
 "Mute Splash": [
  "Silenciar a Splash",
  "I-mute si Splash"
 ],
 "Muted": [
  "Silenciado",
  "Naka-mute"
 ],
 "Voice on": [
  "Voz activada",
  "Bukas ang boses"
 ],
 "Pick your class day & time": [
  "Elige el día y la hora de tu clase",
  "Piliin ang araw at oras ng klase mo"
 ],
 "Class days": [
  "Días de clase",
  "Mga araw ng klase"
 ],
 "On waitlist": [
  "En lista de espera",
  "Nasa waitlist"
 ],
 "year to date": [
  "año hasta la fecha",
  "mula simula ng taon"
 ],
 "+31% vs 2025": [
  "+31% vs 2025",
  "+31% vs 2025"
 ],
 "Lifetime value · top families": [
  "Valor de por vida · familias principales",
  "Lifetime value · nangungunang pamilya"
 ],
 "By location · vs last month": [
  "Por ubicación · vs el mes pasado",
  "Ayon sa lokasyon · vs nakaraang buwan"
 ],
 "September payroll": [
  "Nómina de septiembre",
  "Payroll ng Setyembre"
 ],
 "$4,660 · sent to accountant": [
  "$4,660 · enviado al contador",
  "$4,660 · ipinadala sa accountant"
 ],
 "Meet Splash: a 90-second commercial showing coach requests, previews and confirmed account changes. On-screen captions included.": [
  "Conoce Splash: un comercial de 90 segundos que muestra solicitudes de instructor, vistas previas y cambios de cuenta confirmados. Incluye subtítulos en pantalla.",
  "Kilalanin ang Splash: isang 90-segundong commercial na nagpapakita ng mga request sa coach, previews, at mga nakumpirmang pagbabago sa account. May kasamang on-screen captions."
 ],
 "Play the Splash commercial": [
  "Reproducir el comercial de Splash",
  "I-play ang commercial ng Splash"
 ],
 "Pause Splash commercial": [
  "Pausar el comercial de Splash",
  "I-pause ang commercial ng Splash"
 ],
 "Play Splash commercial": [
  "Reproducir comercial de Splash",
  "I-play ang commercial ng Splash"
 ],
 "Pause": [
  "Pausar",
  "I-pause"
 ],
 "Play": [
  "Reproducir",
  "I-play"
 ],
 "Turn sound on": [
  "Activar sonido",
  "I-on ang tunog"
 ],
 "Mute": [
  "Silenciar",
  "I-mute"
 ],
 "Motion preference respected — press play when ready.": [
  "Se respetó la preferencia de movimiento — presiona reproducir cuando estés listo.",
  "Sinunod ang motion preference — pindutin ang play kapag handa ka na."
 ],
 "Autoplay unavailable — press play.": [
  "La reproducción automática no está disponible — presiona reproducir.",
  "Hindi available ang autoplay — pindutin ang play."
 ],
 "90-second commercial · captions on screen": [
  "Comercial de 90 segundos · subtítulos en pantalla",
  "90-segundong commercial · captions sa screen"
 ],
 "The commercial couldn’t load. You can keep browsing.": [
  "No se pudo cargar el comercial. Puedes seguir navegando.",
  "Hindi ma-load ang commercial. Maaari kang magpatuloy sa pag-browse."
 ],
 "splashpad.pro · Schedule · This week": [
  "splashpad.pro · Horario · Esta semana",
  "splashpad.pro · Schedule · This week"
 ],
 "Week of Sept 15": [
  "Semana del 15 de sept.",
  "Linggo ng Set 15"
 ],
 "48 swimmers · 12 classes": [
  "48 nadadores · 12 clases",
  "48 manlalangoy · 12 klase"
 ],
 "Thu 4:00 · Beginners": [
  "Jue 4:00 · Principiantes",
  "Huw 4:00 · Beginners"
 ],
 "Superhero Swim Academy": [
  "Superhero Swim Academy",
  "Superhero Swim Academy"
 ],
 "Hi, Nguyen family": [
  "Hola, familia Nguyen",
  "Hi, pamilyang Nguyen"
 ],
 "Lessons left": [
  "Lecciones restantes",
  "Mga natitirang lesson"
 ],
 "6 of 8": [
  "6 de 8",
  "6 sa 8"
 ],
 "Thu · 4:00 PM · Beginners": [
  "Jue · 4:00 p. m. · Principiantes",
  "Huw · 4:00 PM · Beginners"
 ],
 "Main pool · Coach Maya": [
  "Piscina principal · Instructora Maya",
  "Main pool · Coach Maya"
 ],
 "2 swimmers": [
  "2 nadadores",
  "2 manlalangoy"
 ],
 "Lily · Max": [
  "Lily · Max",
  "Lily · Max"
 ],
 "Renew package · $240": [
  "Renovar paquete · $240",
  "I-renew ang package · $240"
 ],
 "Reminder sent": [
  "Recordatorio enviado",
  "Naipadala na ang paalala"
 ],
 "Lily’s lesson is tomorrow at 4:00 PM.": [
  "La lección de Lily es mañana a las 4:00 p. m.",
  "Bukas ang lesson ni Lily sa 4:00 PM."
 ],
 "splashpad.pro · Staff · Payroll · September": [
  "splashpad.pro · Personal · Nómina · Septiembre",
  "splashpad.pro · Staff · Payroll · September"
 ],
 "Maya clocked in · 3:58 PM": [
  "Maya registró entrada · 3:58 p. m.",
  "Nag-clock in si Maya · 3:58 PM"
 ],
 "Full · waitlist": [
  "Completo · lista de espera",
  "Puno · waitlist"
 ],
 "is full": [
  "está completo",
  "ay puno na"
 ],
 "You’re": [
  "Estás",
  "Ikaw ay"
 ],
 "on the waitlist for this time. You’ll get an email when a spot opens — the first family to book gets it.": [
  "en la lista de espera para este horario. Recibirás un correo electrónico cuando se abra un lugar; la primera familia que reserve se lo queda.",
  "nasa waitlist para sa oras na ito. Makakatanggap ka ng email kapag may nabuksang slot — mapupunta ito sa unang pamilyang makapag-book."
 ],
 "Join the waitlist and you’ll get an email when a spot opens. Spots go to the first family to book.": [
  "Únete a la lista de espera y recibirás un correo electrónico cuando se abra un lugar. Los lugares son para la primera familia que reserve.",
  "Sumali sa waitlist at makakatanggap ka ng email kapag may nabuksang slot. Mapupunta ang mga slot sa unang pamilyang makapag-book."
 ],
 "Leave waitlist": [
  "Salir de la lista de espera",
  "Umalis sa waitlist"
 ],
 "One-time session": [
  "Sesión única",
  "Isang beses na session"
 ],
 "lessons start on the first": [
  "las clases empiezan el primer",
  "nagsisimula ang mga lesson sa unang"
 ],
 "class day": [
  "día de clase",
  "araw ng klase"
 ],
 "after checkout.": [
  "después del pago.",
  "pagkatapos ng checkout."
 ],
 "This time is full": [
  "Este horario está completo",
  "Puno na ang oras na ito"
 ],
 "Tap a day, then a time — the details show up here before you pay.": [
  "Toca un día y luego una hora: los detalles aparecerán aquí antes de pagar.",
  "I-tap ang isang araw, saka ang oras — lalabas dito ang mga detalye bago ka magbayad."
 ],
 "No payments yet. Your history will appear here after your first lesson payment.": [
  "Aún no hay pagos. Tu historial aparecerá aquí después del pago de tu primera clase.",
  "Wala pang mga bayad. Lalabas dito ang history mo pagkatapos ng una mong bayad sa lesson."
 ],
 "Search by coach, package, amount, or date": [
  "Buscar por instructor, paquete, monto o fecha",
  "Maghanap ayon sa coach, package, halaga, o petsa"
 ],
 "Search payment history": [
  "Buscar historial de pagos",
  "Hanapin ang payment history"
 ],
 "No payments match “": [
  "Ningún pago coincide con “",
  "Walang bayad na tumutugma sa “"
 ],
 "Give your program a name.": [
  "Ponle un nombre a tu programa.",
  "Bigyan ng pangalan ang iyong program."
 ],
 "Max age must be at least the min age.": [
  "La edad máxima debe ser al menos la edad mínima.",
  "Dapat ang max na edad ay hindi bababa sa min na edad."
 ],
 "Program created": [
  "Programa creado",
  "Nagawa ang program"
 ],
 "Program updated": [
  "Programa actualizado",
  "Na-update ang program"
 ],
 "Could not save the new order.": [
  "No se pudo guardar el nuevo orden.",
  "Hindi na-save ang bagong ayos."
 ],
 "What’s a Program?": [
  "¿Qué es un Programa?",
  "Ano ang Program?"
 ],
 "Programs organize everything you sell.": [
  "Los Programas organizan todo lo que vendes.",
  "Inaayos ng mga Program ang lahat ng ibinebenta mo."
 ],
 "is an age-range bucket (like": [
  "es un grupo por rango de edad (como",
  "ay isang pangkat ayon sa age range (tulad ng"
 ],
 "“Preschool Aquatics, ages 3–5”": [
  "“Actividades acuáticas preescolares, edades 3–5”",
  "“Preschool Aquatics, edad 3–5”"
 ],
 ") that holds your classes, packages & camps. When approved parents open": [
  ") que contiene tus clases, paquetes y campamentos. Cuando los padres aprobados abren",
  ") na naglalaman ng iyong mga klase, package, at camp. Kapag binuksan ng mga approved na magulang ang"
 ],
 "in their Parent Portal, they pick their child’s age and only see what’s inside matching Programs — no overwhelming list.": [
  "en su Portal para Padres, eligen la edad de su hijo y solo ven lo que está dentro de los Programas correspondientes, sin una lista abrumadora.",
  "sa kanilang Parent Portal, pipiliin nila ang edad ng anak nila at makikita lang nila ang nasa loob ng mga tumutugmang Program — walang nakaka-overwhelm na listahan."
 ],
 "Create your Programs first, then drop your classes, packages and camps into them.": [
  "Crea primero tus Programas y luego agrega en ellos tus clases, paquetes y campamentos.",
  "Gawin muna ang iyong mga Program, saka ilagay roon ang iyong mga klase, package, at camp."
 ],
 "Use “Preview as parent” above to see exactly what families get.": [
  "Usa “Vista previa como padre” arriba para ver exactamente lo que reciben las familias.",
  "Gamitin ang “Preview as parent” sa itaas para makita mismo kung ano ang makukuha ng mga pamilya."
 ],
 "New Program": [
  "Nuevo Programa",
  "Bagong Program"
 ],
 "No programs yet": [
  "Aún no hay programas",
  "Wala pang mga program"
 ],
 "Create your first program, then drop your classes into it. Approved parents get a guided “find your class” experience in their Parent Portal. Until then, their portal shows the classic list.": [
  "Crea tu primer programa y luego agrega tus clases en él. Los padres aprobados obtienen una experiencia guiada de “encuentra tu clase” en su Portal para Padres. Hasta entonces, su portal muestra la lista clásica.",
  "Gawin ang iyong unang program, saka ilagay dito ang iyong mga klase. Makakakuha ang mga approved na magulang ng guided na “find your class” experience sa kanilang Parent Portal. Hanggang doon, classic na listahan ang makikita sa kanilang portal."
 ],
 "Create your first program": [
  "Crea tu primer programa",
  "Gawin ang iyong unang program"
 ],
 "Edit program": [
  "Editar programa",
  "I-edit ang program"
 ],
 "Delete program": [
  "Eliminar programa",
  "Tanggalin ang program"
 ],
 "Current price": [
  "Precio actual",
  "Kasalukuyang presyo"
 ],
 "New price": [
  "Nuevo precio",
  "Bagong presyo"
 ],
 "Entering zero makes that price free. Existing subscriptions keep their original agreed price and currency.": [
  "Si introduces cero, ese precio será gratuito. Las suscripciones existentes mantienen el precio y la moneda originales acordados.",
  "Ang paglalagay ng zero ay gagawing libre ang presyong iyon. Ang mga umiiral na subscription ay mananatili sa kanilang orihinal na napagkasunduang presyo at currency."
 ],
 "I have reviewed every new price. I understand that past transactions and existing subscriptions will not be converted.": [
  "He revisado cada precio nuevo. Entiendo que las transacciones pasadas y las suscripciones existentes no se convertirán.",
  "Nasuri ko na ang bawat bagong presyo. Nauunawaan ko na ang mga nakaraang transaksyon at umiiral na subscription ay hindi iko-convert."
 ],
 "Keep current currency": [
  "Mantener la moneda actual",
  "Panatilihin ang kasalukuyang currency"
 ],
 "(v": [
  "(v",
  "(v"
 ],
 "STOP": [
  "DETENER",
  "ITIGIL"
 ],
 "123 Main St": [
  "123 Main St",
  "123 Main St"
 ],
 "CA": [
  "CA",
  "CA"
 ],
 "Jane Doe": [
  "Jane Doe",
  "Jane Doe"
 ],
 "Add classes": [
  "Agregar clases",
  "Magdagdag ng mga klase"
 ],
 "Not in a program yet (": [
  "Aún no está en un programa (",
  "Wala pa sa programa ("
 ],
 "These still show in the portal’s classic list. Add them to a program above to include them in the guided signup.": [
  "Estas aún se muestran en la lista clásica del portal. Agrégalas a un programa arriba para incluirlas en la inscripción guiada.",
  "Makikita pa rin ang mga ito sa classic list ng portal. Idagdag ang mga ito sa isang programa sa itaas para maisama sila sa guided signup."
 ],
 "New program": [
  "Nuevo programa",
  "Bagong programa"
 ],
 "Parents will see this as a big friendly card on your signup page.": [
  "Los padres verán esto como una tarjeta grande y amigable en tu página de inscripción.",
  "Makikita ito ng mga magulang bilang isang malaking magiliw na card sa iyong signup page."
 ],
 "Program name": [
  "Nombre del programa",
  "Pangalan ng programa"
 ],
 "e.g. Preschool Aquatics": [
  "p. ej., Acuática preescolar",
  "hal. Preschool Aquatics"
 ],
 "Icon": [
  "Ícono",
  "Icon"
 ],
 "Age range": [
  "Rango de edad",
  "Saklaw ng edad"
 ],
 "Min age": [
  "Edad mínima",
  "Minimum na edad"
 ],
 "Max age": [
  "Edad máxima",
  "Maximum na edad"
 ],
 "No limit": [
  "Sin límite",
  "Walang limitasyon"
 ],
 "No upper age limit": [
  "Sin límite máximo de edad",
  "Walang maximum na limitasyon sa edad"
 ],
 "One line parents see under the program name": [
  "Una línea que los padres ven debajo del nombre del programa",
  "Isang linyang makikita ng mga magulang sa ilalim ng pangalan ng programa"
 ],
 "Create program": [
  "Crear programa",
  "Gumawa ng programa"
 ],
 "Add classes to": [
  "Agregar clases a",
  "Magdagdag ng mga klase sa"
 ],
 "Tick the classes that belong in this program. Classes already in another program will move here.": [
  "Marca las clases que pertenecen a este programa. Las clases que ya estén en otro programa se moverán aquí.",
  "Lagyan ng check ang mga klaseng kabilang sa programang ito. Ang mga klaseng nasa ibang programa na ay ililipat dito."
 ],
 "Every class is already in this program. Create more classes from Classes & Packages.": [
  "Todas las clases ya están en este programa. Crea más clases desde Clases y Paquetes.",
  "Lahat ng klase ay nasa programang ito na. Gumawa pa ng mga klase mula sa Classes & Packages."
 ],
 "Add selected": [
  "Agregar seleccionadas",
  "Idagdag ang mga napili"
 ],
 "Delete “": [
  "Eliminar “",
  "Tanggalin ang “"
 ],
 "Your classes are safe — they’ll just move back to the unassigned pool and keep showing in your page’s classic list.": [
  "Tus clases están seguras: simplemente volverán al grupo sin asignar y seguirán mostrándose en la lista clásica de tu página.",
  "Ligtas ang iyong mga klase — babalik lang ang mga ito sa unassigned pool at patuloy na lalabas sa classic list ng iyong page."
 ],
 "Currency and reviewed prices updated. Historical payments are unchanged.": [
  "La moneda y los precios revisados se actualizaron. Los pagos históricos no cambian.",
  "Na-update ang currency at mga sinuring presyo. Hindi magbabago ang mga dating bayad."
 ],
 "Charging currencies come from your connected payment account, not your country or language.": [
  "Las monedas de cobro provienen de tu cuenta de pagos conectada, no de tu país ni de tu idioma.",
  "Ang mga charging currency ay mula sa iyong nakakonektang payment account, hindi sa iyong bansa o wika."
 ],
 "Charging currency": [
  "Moneda de cobro",
  "Charging currency"
 ],
 "Search currencies…": [
  "Buscar monedas…",
  "Maghanap ng mga currency…"
 ],
 "No matching currency.": [
  "No hay ninguna moneda coincidente.",
  "Walang katugmang currency."
 ],
 "Payment account default": [
  "Predeterminada de la cuenta de pagos",
  "Default ng payment account"
 ],
 "Your charging currency can be different.": [
  "Tu moneda de cobro puede ser diferente.",
  "Maaaring iba ang iyong charging currency."
 ],
 "Check again": [
  "Comprobar de nuevo",
  "Suriin muli"
 ],
 "Payment settings": [
  "Configuración de pagos",
  "Mga setting ng bayad"
 ],
 "Resume currency update": [
  "Reanudar actualización de moneda",
  "Ipagpatuloy ang pag-update ng currency"
 ],
 "Review new prices": [
  "Revisar nuevos precios",
  "Suriin ang mga bagong presyo"
 ],
 "Review every new price": [
  "Revisa cada nuevo precio",
  "Suriin ang bawat bagong presyo"
 ],
 "Nothing changes until you confirm. Enter each new price yourself; we never convert your prices automatically.": [
  "Nada cambia hasta que confirmes. Ingresa tú mismo cada precio nuevo; nunca convertimos tus precios automáticamente.",
  "Walang magbabago hangga't hindi ka nagkukumpirma. Ikaw mismo ang maglagay ng bawat bagong presyo; hindi namin kailanman awtomatikong kino-convert ang iyong mga presyo."
 ],
 "No existing prices to review. New prices will use the selected currency.": [
  "No hay precios existentes para revisar. Los precios nuevos usarán la moneda seleccionada.",
  "Walang kasalukuyang presyo na susuriin. Gagamitin ng mga bagong presyo ang napiling currency."
 ]
});
Object.assign(messages, {
 'Charging currency': ['Moneda de cobro', 'Pera sa pagsingil'],
 'Training hrs': ['Horas de capacitación', 'Oras ng pagsasanay'],
 'Lesson hrs': ['Horas de lecciones', 'Oras ng aralin'],
 'Out': ['Salida', 'Paglabas'],
 'Rate': ['Tarifa', 'Bayad kada oras'],
 'Could not add credit. Try again.': ['No se pudo agregar el crédito. Inténtalo de nuevo.', 'Hindi maidagdag ang credit. Subukan muli.'],
 'Connect and verify your payment account before changing currency.': ['Conecta y verifica tu cuenta de pagos antes de cambiar la moneda.', 'Ikonekta at beripikahin ang iyong payment account bago baguhin ang pera sa pagsingil.'],
 'This family is paying {amount}': ['Esta familia está pagando {amount}', 'Magbabayad ang pamilyang ito ng {amount}'],
 'Card on file = charge {amount}': ['Tarjeta guardada = cobrar {amount}', 'Naka-save na card = singilin ng {amount}'],
 'Refund issued as Coach Credit ({amount}).': ['Reembolso emitido como crédito del entrenador ({amount}).', 'Ibinigay ang refund bilang Coach Credit ({amount}).'],
 'Refund issued to card ({amount}).': ['Reembolso emitido a la tarjeta ({amount}).', 'Ibinigay ang refund sa card ({amount}).'],
 'Max refundable: {amount}': ['Reembolso máximo: {amount}', 'Pinakamataas na refund: {amount}'],
 'Refund {amount}': ['Reembolsar {amount}', 'I-refund ang {amount}'],
 'Amount due: {amount}': ['Monto pendiente: {amount}', 'Halagang dapat bayaran: {amount}'],
 'Enter a valid amount for this currency.': ['Ingresa un monto válido para esta moneda.', 'Maglagay ng wastong halaga para sa currency na ito.'],
 'Send this invoice without an amount? The parent will not see a Pay-now button.': ['¿Enviar esta factura sin monto? El padre no verá el botón de pagar ahora.', 'Ipadala ang invoice na walang halaga? Hindi makikita ng magulang ang button na magbayad ngayon.'],
 'Added {amount} credit to {name}.': ['Se agregó un crédito de {amount} a {name}.', 'Nagdagdag ng {amount} credit para kay {name}.'],
 'the family': ['la familia', 'pamilya'],
 'Could not load credit balance.': ['No se pudo cargar el saldo de crédito.', 'Hindi ma-load ang balanse ng credit.'],
 'Credit amount cannot exceed {amount} in one entry.': ['El crédito no puede superar {amount} en una entrada.', 'Hindi maaaring lumampas sa {amount} ang credit sa isang entry.'],
 'Previous period: {amount}': ['Período anterior: {amount}', 'Nakaraang panahon: {amount}'],
 'SplashPad subscription is billed in USD.': ['La suscripción de SplashPad se cobra en USD.', 'Sinisingil sa USD ang subscription sa SplashPad.'],
 'Switch to {plan}': ['Cambiar a {plan}', 'Lumipat sa {plan}'],
 'Subscribe — {amount}/mo': ['Suscribirse — {amount}/mes', 'Mag-subscribe — {amount}/buwan'],
});
// R44 — currency onboarding, no-payment-account path, dashboard checklist and pending banner.
Object.assign(messages, {
 'Preferred currency': ['Moneda preferida', 'Gustong pera'],
 'Choose the currency families pay in. Existing prices and past payments are never converted automatically.': ['Elige la moneda en la que pagan las familias. Los precios existentes y los pagos anteriores nunca se convierten automáticamente.', 'Piliin ang pera na ipambabayad ng mga pamilya. Hindi kailanman awtomatikong iko-convert ang mga kasalukuyang presyo at nakaraang bayad.'],
 'Families will pay in {currency}. Every price you enter in this guide is in {currency}. You can change it later in Settings.': ['Las familias pagarán en {currency}. Cada precio que ingreses en esta guía está en {currency}. Puedes cambiarlo después en Configuración.', 'Magbabayad ang mga pamilya sa {currency}. Nasa {currency} ang bawat presyong ilalagay mo sa gabay na ito. Maaari mo itong baguhin sa Mga setting.'],
 'To charge in {currency}, review each price in Settings → Language & region after this guide.': ['Para cobrar en {currency}, revisa cada precio en Configuración → Idioma y región después de esta guía.', 'Para maningil sa {currency}, suriin ang bawat presyo sa Mga setting → Wika at rehiyon pagkatapos ng gabay na ito.'],
 'No payment account is connected yet, so you can choose any currency. Once you connect one, it must be able to charge in this currency.': ['Aún no hay una cuenta de pagos conectada, así que puedes elegir cualquier moneda. Cuando conectes una, deberá poder cobrar en esta moneda.', 'Wala pang nakakonektang payment account, kaya maaari kang pumili ng anumang pera. Kapag nagkonekta ka ng isa, dapat itong makasingil sa perang ito.'],
 'Your connected payment account cannot charge in {currency}. Choose a supported currency below, or families will not be able to pay by card.': ['Tu cuenta de pagos conectada no puede cobrar en {currency}. Elige una moneda compatible abajo, o las familias no podrán pagar con tarjeta.', 'Hindi makakasingil sa {currency} ang iyong nakakonektang payment account. Pumili ng suportadong pera sa ibaba, kung hindi ay hindi makakabayad ang mga pamilya gamit ang card.'],
 'Your charging currency will be set to {currency}. Every new price above is in {currency}.': ['Tu moneda de cobro se establecerá en {currency}. Cada precio nuevo de arriba está en {currency}.', 'Itatakda ang iyong pera sa pagsingil sa {currency}. Nasa {currency} ang bawat bagong presyo sa itaas.'],
 'Account created': ['Cuenta creada', 'Nagawa ang account'],
 'Brand your page (name + link)': ['Personaliza tu página (nombre + enlace)', 'I-brand ang iyong pahina (pangalan + link)'],
 'Brand it': ['Personalizar', 'I-brand'],
 'Set your time zone (keeps class times accurate)': ['Configura tu zona horaria (mantiene exactos los horarios)', 'Itakda ang iyong time zone (pinapanatiling tama ang oras ng klase)'],
 'Set it': ['Configurar', 'Itakda'],
 'Connect payouts so parents can pay you (Stripe)': ['Conecta los pagos para que los padres puedan pagarte (Stripe)', 'Ikonekta ang payouts para makabayad sa iyo ang mga magulang (Stripe)'],
 'Connect': ['Conectar', 'Ikonekta'],
 'Lock your account with a phone code (2FA)': ['Protege tu cuenta con un código por teléfono (2FA)', 'I-lock ang iyong account gamit ang code sa telepono (2FA)'],
 'Set up': ['Configurar', 'I-set up'],
 'Create your first class or package': ['Crea tu primera clase o paquete', 'Gumawa ng iyong unang klase o pakete'],
 'Create': ['Crear', 'Gumawa'],
 'Share your signup link with families': ['Comparte tu enlace de registro con las familias', 'Ibahagi ang iyong signup link sa mga pamilya'],
 'Copy link': ['Copiar enlace', 'Kopyahin ang link'],
 'Receive your first application': ['Recibe tu primera solicitud', 'Tumanggap ng iyong unang aplikasyon'],
 'Check inbox': ['Ver bandeja', 'Tingnan ang inbox'],
 'Take the 3-minute tour of SplashPad': ['Haz el recorrido de 3 minutos por SplashPad', 'Sumama sa 3-minutong tour ng SplashPad'],
 'Take the tour': ['Hacer el recorrido', 'Simulan ang tour'],
 'Book your free 30-min Pro onboarding call': ['Reserva tu llamada gratuita de 30 min de bienvenida Pro', 'Mag-book ng libreng 30-minutong Pro onboarding call'],
 'Book it': ['Reservar', 'I-book'],
 'Join our WhatsApp support group (fastest way to get help)': ['Únete a nuestro grupo de soporte en WhatsApp (la forma más rápida de obtener ayuda)', 'Sumali sa aming WhatsApp support group (pinakamabilis na paraan para humingi ng tulong)'],
 'Join': ['Unirse', 'Sumali'],
 '1 family has been waiting over a day': ['1 familia lleva más de un día esperando', '1 pamilya ang naghihintay nang mahigit isang araw'],
 '{count} families have been waiting over a day': ['{count} familias llevan más de un día esperando', '{count} pamilya ang naghihintay nang mahigit isang araw'],
 '1 parent request waiting on you': ['1 solicitud de padres espera tu respuesta', '1 kahilingan ng magulang ang naghihintay sa iyo'],
 '{count} parent requests waiting on you': ['{count} solicitudes de padres esperan tu respuesta', '{count} kahilingan ng magulang ang naghihintay sa iyo'],
 'New family applications': ['Nuevas solicitudes de familias', 'Mga bagong aplikasyon ng pamilya'],
 'Class time requests': ['Solicitudes de horario de clase', 'Mga kahilingan sa oras ng klase'],
 'Home-lesson requests': ['Solicitudes de clases a domicilio', 'Mga kahilingan sa aralin sa bahay'],
 'Review applications': ['Revisar solicitudes', 'Suriin ang mga aplikasyon'],
 'Review class requests': ['Revisar solicitudes de clase', 'Suriin ang mga kahilingan sa klase'],
 'Review requests': ['Revisar solicitudes', 'Suriin ang mga kahilingan'],
 'Contact Coach': ['Contactar al entrenador', 'Makipag-ugnayan sa Coach'],
 'Refund amount': ['Importe del reembolso', 'Halaga ng refund'],
 'Confirm currency and prices': ['Confirmar moneda y precios', 'Kumpirmahin ang pera at mga presyo'],
 'Retry': ['Reintentar', 'Subukan muli'],
 'Could not load currencies from your payment account. Try again.': ['No se pudieron cargar las monedas de tu cuenta de pagos. Inténtalo de nuevo.', 'Hindi ma-load ang mga pera mula sa iyong payment account. Subukan muli.'],
 'Could not start the price review. Try again.': ['No se pudo iniciar la revisión de precios. Inténtalo de nuevo.', 'Hindi masimulan ang pagsusuri ng presyo. Subukan muli.'],
 'Could not finish the currency update. Please try again.': ['No se pudo completar el cambio de moneda. Inténtalo de nuevo.', 'Hindi natapos ang pag-update ng pera. Pakisubukan muli.'],
 'Credit portion ({currency}) — remainder goes to the card': ['Parte del crédito ({currency}): el resto va a la tarjeta', 'Bahagi ng credit ({currency}) — ang natitira ay mapupunta sa card'],
});
export function translate(text, language = 'en', params = {}) {
 if (typeof text !== 'string') return text;
 const idx = language === 'es' ? 0 : language === 'tl' ? 1 : -1;
 const entry = messages[text];
 const translated = idx < 0 ? text : entry?.[idx] || text;
 return translated.replace(/\{(\w+)\}/g, (match, key) => Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
}
